(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (factory((global.keepkey = {})));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function commonjsRequire () {
    	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
    }

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var global$1 = (typeof global !== "undefined" ? global :
                typeof self !== "undefined" ? self :
                typeof window !== "undefined" ? window : {});

    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
    var inited = false;
    function init () {
      inited = true;
      var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      for (var i = 0, len = code.length; i < len; ++i) {
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
      }

      revLookup['-'.charCodeAt(0)] = 62;
      revLookup['_'.charCodeAt(0)] = 63;
    }

    function toByteArray (b64) {
      if (!inited) {
        init();
      }
      var i, j, l, tmp, placeHolders, arr;
      var len = b64.length;

      if (len % 4 > 0) {
        throw new Error('Invalid string. Length must be a multiple of 4')
      }

      // the number of equal signs (place holders)
      // if there are two placeholders, than the two characters before it
      // represent one byte
      // if there is only one, then the three characters before it represent 2 bytes
      // this is just a cheap hack to not do indexOf twice
      placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

      // base64 is 4/3 + up to two characters of the original data
      arr = new Arr(len * 3 / 4 - placeHolders);

      // if there are placeholders, only get up to the last complete 4 chars
      l = placeHolders > 0 ? len - 4 : len;

      var L = 0;

      for (i = 0, j = 0; i < l; i += 4, j += 3) {
        tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = (tmp >> 16) & 0xFF;
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
      }

      if (placeHolders === 2) {
        tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
        arr[L++] = tmp & 0xFF;
      } else if (placeHolders === 1) {
        tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
        arr[L++] = (tmp >> 8) & 0xFF;
        arr[L++] = tmp & 0xFF;
      }

      return arr
    }

    function tripletToBase64 (num) {
      return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
    }

    function encodeChunk (uint8, start, end) {
      var tmp;
      var output = [];
      for (var i = start; i < end; i += 3) {
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
        output.push(tripletToBase64(tmp));
      }
      return output.join('')
    }

    function fromByteArray (uint8) {
      if (!inited) {
        init();
      }
      var tmp;
      var len = uint8.length;
      var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
      var output = '';
      var parts = [];
      var maxChunkLength = 16383; // must be multiple of 3

      // go through the array every three bytes, we'll deal with trailing stuff later
      for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
        parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
      }

      // pad the end with zeros, but make sure to not forget the extra bytes
      if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[(tmp << 4) & 0x3F];
        output += '==';
      } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
        output += lookup[tmp >> 10];
        output += lookup[(tmp >> 4) & 0x3F];
        output += lookup[(tmp << 2) & 0x3F];
        output += '=';
      }

      parts.push(output);

      return parts.join('')
    }

    function read (buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? (nBytes - 1) : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];

      i += d;

      e = s & ((1 << (-nBits)) - 1);
      s >>= (-nBits);
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

      m = e & ((1 << (-nBits)) - 1);
      e >>= (-nBits);
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : ((s ? -1 : 1) * Infinity)
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
    }

    function write (buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
      var i = isLE ? 0 : (nBytes - 1);
      var d = isLE ? 1 : -1;
      var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

      value = Math.abs(value);

      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }

        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }

      for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

      e = (e << mLen) | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

      buffer[offset + i - d] |= s * 128;
    }

    var toString = {}.toString;

    var isArray = Array.isArray || function (arr) {
      return toString.call(arr) == '[object Array]';
    };

    var INSPECT_MAX_BYTES = 50;

    /**
     * If `Buffer.TYPED_ARRAY_SUPPORT`:
     *   === true    Use Uint8Array implementation (fastest)
     *   === false   Use Object implementation (most compatible, even IE6)
     *
     * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
     * Opera 11.6+, iOS 4.2+.
     *
     * Due to various browser bugs, sometimes the Object implementation will be used even
     * when the browser supports typed arrays.
     *
     * Note:
     *
     *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
     *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
     *
     *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
     *
     *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
     *     incorrect length in some situations.

     * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
     * get the Object implementation, which is slower but behaves correctly.
     */
    Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
      ? global$1.TYPED_ARRAY_SUPPORT
      : true;

    function kMaxLength () {
      return Buffer.TYPED_ARRAY_SUPPORT
        ? 0x7fffffff
        : 0x3fffffff
    }

    function createBuffer (that, length) {
      if (kMaxLength() < length) {
        throw new RangeError('Invalid typed array length')
      }
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) {
          that = new Buffer(length);
        }
        that.length = length;
      }

      return that
    }

    /**
     * The Buffer constructor returns instances of `Uint8Array` that have their
     * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
     * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
     * and the `Uint8Array` methods. Square bracket notation works as expected -- it
     * returns a single octet.
     *
     * The `Uint8Array` prototype remains unmodified.
     */

    function Buffer (arg, encodingOrOffset, length) {
      if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
        return new Buffer(arg, encodingOrOffset, length)
      }

      // Common case.
      if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') {
          throw new Error(
            'If encoding is specified then the first argument must be a string'
          )
        }
        return allocUnsafe(this, arg)
      }
      return from(this, arg, encodingOrOffset, length)
    }

    Buffer.poolSize = 8192; // not used by this implementation

    // TODO: Legacy, not needed anymore. Remove in next major version.
    Buffer._augment = function (arr) {
      arr.__proto__ = Buffer.prototype;
      return arr
    };

    function from (that, value, encodingOrOffset, length) {
      if (typeof value === 'number') {
        throw new TypeError('"value" argument must not be a number')
      }

      if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
        return fromArrayBuffer(that, value, encodingOrOffset, length)
      }

      if (typeof value === 'string') {
        return fromString(that, value, encodingOrOffset)
      }

      return fromObject(that, value)
    }

    /**
     * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
     * if value is a number.
     * Buffer.from(str[, encoding])
     * Buffer.from(array)
     * Buffer.from(buffer)
     * Buffer.from(arrayBuffer[, byteOffset[, length]])
     **/
    Buffer.from = function (value, encodingOrOffset, length) {
      return from(null, value, encodingOrOffset, length)
    };

    if (Buffer.TYPED_ARRAY_SUPPORT) {
      Buffer.prototype.__proto__ = Uint8Array.prototype;
      Buffer.__proto__ = Uint8Array;
    }

    function assertSize (size) {
      if (typeof size !== 'number') {
        throw new TypeError('"size" argument must be a number')
      } else if (size < 0) {
        throw new RangeError('"size" argument must not be negative')
      }
    }

    function alloc (that, size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(that, size)
      }
      if (fill !== undefined) {
        // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string'
          ? createBuffer(that, size).fill(fill, encoding)
          : createBuffer(that, size).fill(fill)
      }
      return createBuffer(that, size)
    }

    /**
     * Creates a new filled Buffer instance.
     * alloc(size[, fill[, encoding]])
     **/
    Buffer.alloc = function (size, fill, encoding) {
      return alloc(null, size, fill, encoding)
    };

    function allocUnsafe (that, size) {
      assertSize(size);
      that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
      if (!Buffer.TYPED_ARRAY_SUPPORT) {
        for (var i = 0; i < size; ++i) {
          that[i] = 0;
        }
      }
      return that
    }

    /**
     * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
     * */
    Buffer.allocUnsafe = function (size) {
      return allocUnsafe(null, size)
    };
    /**
     * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
     */
    Buffer.allocUnsafeSlow = function (size) {
      return allocUnsafe(null, size)
    };

    function fromString (that, string, encoding) {
      if (typeof encoding !== 'string' || encoding === '') {
        encoding = 'utf8';
      }

      if (!Buffer.isEncoding(encoding)) {
        throw new TypeError('"encoding" must be a valid string encoding')
      }

      var length = byteLength(string, encoding) | 0;
      that = createBuffer(that, length);

      var actual = that.write(string, encoding);

      if (actual !== length) {
        // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        that = that.slice(0, actual);
      }

      return that
    }

    function fromArrayLike (that, array) {
      var length = array.length < 0 ? 0 : checked(array.length) | 0;
      that = createBuffer(that, length);
      for (var i = 0; i < length; i += 1) {
        that[i] = array[i] & 255;
      }
      return that
    }

    function fromArrayBuffer (that, array, byteOffset, length) {
      array.byteLength; // this throws if `array` is not a valid ArrayBuffer

      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('\'offset\' is out of bounds')
      }

      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('\'length\' is out of bounds')
      }

      if (byteOffset === undefined && length === undefined) {
        array = new Uint8Array(array);
      } else if (length === undefined) {
        array = new Uint8Array(array, byteOffset);
      } else {
        array = new Uint8Array(array, byteOffset, length);
      }

      if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
      } else {
        // Fallback: Return an object instance of the Buffer class
        that = fromArrayLike(that, array);
      }
      return that
    }

    function fromObject (that, obj) {
      if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);

        if (that.length === 0) {
          return that
        }

        obj.copy(that, 0, 0, len);
        return that
      }

      if (obj) {
        if ((typeof ArrayBuffer !== 'undefined' &&
            obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
          if (typeof obj.length !== 'number' || isnan(obj.length)) {
            return createBuffer(that, 0)
          }
          return fromArrayLike(that, obj)
        }

        if (obj.type === 'Buffer' && isArray(obj.data)) {
          return fromArrayLike(that, obj.data)
        }
      }

      throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
    }

    function checked (length) {
      // Note: cannot use `length < kMaxLength()` here because that fails when
      // length is NaN (which is otherwise coerced to zero.)
      if (length >= kMaxLength()) {
        throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                             'size: 0x' + kMaxLength().toString(16) + ' bytes')
      }
      return length | 0
    }
    Buffer.isBuffer = isBuffer;
    function internalIsBuffer (b) {
      return !!(b != null && b._isBuffer)
    }

    Buffer.compare = function compare (a, b) {
      if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
        throw new TypeError('Arguments must be Buffers')
      }

      if (a === b) return 0

      var x = a.length;
      var y = b.length;

      for (var i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break
        }
      }

      if (x < y) return -1
      if (y < x) return 1
      return 0
    };

    Buffer.isEncoding = function isEncoding (encoding) {
      switch (String(encoding).toLowerCase()) {
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return true
        default:
          return false
      }
    };

    Buffer.concat = function concat (list, length) {
      if (!isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }

      if (list.length === 0) {
        return Buffer.alloc(0)
      }

      var i;
      if (length === undefined) {
        length = 0;
        for (i = 0; i < list.length; ++i) {
          length += list[i].length;
        }
      }

      var buffer = Buffer.allocUnsafe(length);
      var pos = 0;
      for (i = 0; i < list.length; ++i) {
        var buf = list[i];
        if (!internalIsBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers')
        }
        buf.copy(buffer, pos);
        pos += buf.length;
      }
      return buffer
    };

    function byteLength (string, encoding) {
      if (internalIsBuffer(string)) {
        return string.length
      }
      if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
          (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
        return string.byteLength
      }
      if (typeof string !== 'string') {
        string = '' + string;
      }

      var len = string.length;
      if (len === 0) return 0

      // Use a for loop to avoid recursion
      var loweredCase = false;
      for (;;) {
        switch (encoding) {
          case 'ascii':
          case 'latin1':
          case 'binary':
            return len
          case 'utf8':
          case 'utf-8':
          case undefined:
            return utf8ToBytes(string).length
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return len * 2
          case 'hex':
            return len >>> 1
          case 'base64':
            return base64ToBytes(string).length
          default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer.byteLength = byteLength;

    function slowToString (encoding, start, end) {
      var loweredCase = false;

      // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
      // property of a typed array.

      // This behaves neither like String nor Uint8Array in that we set start/end
      // to their upper/lower bounds if the value passed is out of range.
      // undefined is handled specially as per ECMA-262 6th Edition,
      // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
      if (start === undefined || start < 0) {
        start = 0;
      }
      // Return early if start > this.length. Done here to prevent potential uint32
      // coercion fail below.
      if (start > this.length) {
        return ''
      }

      if (end === undefined || end > this.length) {
        end = this.length;
      }

      if (end <= 0) {
        return ''
      }

      // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
      end >>>= 0;
      start >>>= 0;

      if (end <= start) {
        return ''
      }

      if (!encoding) encoding = 'utf8';

      while (true) {
        switch (encoding) {
          case 'hex':
            return hexSlice(this, start, end)

          case 'utf8':
          case 'utf-8':
            return utf8Slice(this, start, end)

          case 'ascii':
            return asciiSlice(this, start, end)

          case 'latin1':
          case 'binary':
            return latin1Slice(this, start, end)

          case 'base64':
            return base64Slice(this, start, end)

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return utf16leSlice(this, start, end)

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
        }
      }
    }

    // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
    // Buffer instances.
    Buffer.prototype._isBuffer = true;

    function swap (b, n, m) {
      var i = b[n];
      b[n] = b[m];
      b[m] = i;
    }

    Buffer.prototype.swap16 = function swap16 () {
      var len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 16-bits')
      }
      for (var i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this
    };

    Buffer.prototype.swap32 = function swap32 () {
      var len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 32-bits')
      }
      for (var i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this
    };

    Buffer.prototype.swap64 = function swap64 () {
      var len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError('Buffer size must be a multiple of 64-bits')
      }
      for (var i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this
    };

    Buffer.prototype.toString = function toString () {
      var length = this.length | 0;
      if (length === 0) return ''
      if (arguments.length === 0) return utf8Slice(this, 0, length)
      return slowToString.apply(this, arguments)
    };

    Buffer.prototype.equals = function equals (b) {
      if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
      if (this === b) return true
      return Buffer.compare(this, b) === 0
    };

    Buffer.prototype.inspect = function inspect () {
      var str = '';
      var max = INSPECT_MAX_BYTES;
      if (this.length > 0) {
        str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
        if (this.length > max) str += ' ... ';
      }
      return '<Buffer ' + str + '>'
    };

    Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
      if (!internalIsBuffer(target)) {
        throw new TypeError('Argument must be a Buffer')
      }

      if (start === undefined) {
        start = 0;
      }
      if (end === undefined) {
        end = target ? target.length : 0;
      }
      if (thisStart === undefined) {
        thisStart = 0;
      }
      if (thisEnd === undefined) {
        thisEnd = this.length;
      }

      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError('out of range index')
      }

      if (thisStart >= thisEnd && start >= end) {
        return 0
      }
      if (thisStart >= thisEnd) {
        return -1
      }
      if (start >= end) {
        return 1
      }

      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;

      if (this === target) return 0

      var x = thisEnd - thisStart;
      var y = end - start;
      var len = Math.min(x, y);

      var thisCopy = this.slice(thisStart, thisEnd);
      var targetCopy = target.slice(start, end);

      for (var i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break
        }
      }

      if (x < y) return -1
      if (y < x) return 1
      return 0
    };

    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
      // Empty buffer means no match
      if (buffer.length === 0) return -1

      // Normalize byteOffset
      if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 0x7fffffff) {
        byteOffset = 0x7fffffff;
      } else if (byteOffset < -0x80000000) {
        byteOffset = -0x80000000;
      }
      byteOffset = +byteOffset;  // Coerce to Number.
      if (isNaN(byteOffset)) {
        // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : (buffer.length - 1);
      }

      // Normalize byteOffset: negative offsets start from the end of the buffer
      if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir) return -1
        else byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1
      }

      // Normalize val
      if (typeof val === 'string') {
        val = Buffer.from(val, encoding);
      }

      // Finally, search either indexOf (if dir is true) or lastIndexOf
      if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) {
          return -1
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
      } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer.TYPED_ARRAY_SUPPORT &&
            typeof Uint8Array.prototype.indexOf === 'function') {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
          }
        }
        return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
      }

      throw new TypeError('val must be string, number or Buffer')
    }

    function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
      var indexSize = 1;
      var arrLength = arr.length;
      var valLength = val.length;

      if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' ||
            encoding === 'utf16le' || encoding === 'utf-16le') {
          if (arr.length < 2 || val.length < 2) {
            return -1
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }

      function read$$1 (buf, i) {
        if (indexSize === 1) {
          return buf[i]
        } else {
          return buf.readUInt16BE(i * indexSize)
        }
      }

      var i;
      if (dir) {
        var foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read$$1(arr, i) === read$$1(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          var found = true;
          for (var j = 0; j < valLength; j++) {
            if (read$$1(arr, i + j) !== read$$1(val, j)) {
              found = false;
              break
            }
          }
          if (found) return i
        }
      }

      return -1
    }

    Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1
    };

    Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
    };

    Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
    };

    function hexWrite (buf, string, offset, length) {
      offset = Number(offset) || 0;
      var remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }

      // must be an even number of digits
      var strLen = string.length;
      if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

      if (length > strLen / 2) {
        length = strLen / 2;
      }
      for (var i = 0; i < length; ++i) {
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i
        buf[offset + i] = parsed;
      }
      return i
    }

    function utf8Write (buf, string, offset, length) {
      return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
    }

    function asciiWrite (buf, string, offset, length) {
      return blitBuffer(asciiToBytes(string), buf, offset, length)
    }

    function latin1Write (buf, string, offset, length) {
      return asciiWrite(buf, string, offset, length)
    }

    function base64Write (buf, string, offset, length) {
      return blitBuffer(base64ToBytes(string), buf, offset, length)
    }

    function ucs2Write (buf, string, offset, length) {
      return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
    }

    Buffer.prototype.write = function write$$1 (string, offset, length, encoding) {
      // Buffer#write(string)
      if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
      // Buffer#write(string, encoding)
      } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
      // Buffer#write(string, offset[, length][, encoding])
      } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
          length = length | 0;
          if (encoding === undefined) encoding = 'utf8';
        } else {
          encoding = length;
          length = undefined;
        }
      // legacy write(string, encoding, offset, length) - remove in v0.13
      } else {
        throw new Error(
          'Buffer.write(string, encoding, offset[, length]) is no longer supported'
        )
      }

      var remaining = this.length - offset;
      if (length === undefined || length > remaining) length = remaining;

      if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
        throw new RangeError('Attempt to write outside buffer bounds')
      }

      if (!encoding) encoding = 'utf8';

      var loweredCase = false;
      for (;;) {
        switch (encoding) {
          case 'hex':
            return hexWrite(this, string, offset, length)

          case 'utf8':
          case 'utf-8':
            return utf8Write(this, string, offset, length)

          case 'ascii':
            return asciiWrite(this, string, offset, length)

          case 'latin1':
          case 'binary':
            return latin1Write(this, string, offset, length)

          case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length)

          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return ucs2Write(this, string, offset, length)

          default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };

    Buffer.prototype.toJSON = function toJSON () {
      return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
      }
    };

    function base64Slice (buf, start, end) {
      if (start === 0 && end === buf.length) {
        return fromByteArray(buf)
      } else {
        return fromByteArray(buf.slice(start, end))
      }
    }

    function utf8Slice (buf, start, end) {
      end = Math.min(buf.length, end);
      var res = [];

      var i = start;
      while (i < end) {
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = (firstByte > 0xEF) ? 4
          : (firstByte > 0xDF) ? 3
          : (firstByte > 0xBF) ? 2
          : 1;

        if (i + bytesPerSequence <= end) {
          var secondByte, thirdByte, fourthByte, tempCodePoint;

          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 0x80) {
                codePoint = firstByte;
              }
              break
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
                if (tempCodePoint > 0x7F) {
                  codePoint = tempCodePoint;
                }
              }
              break
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
                if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                  codePoint = tempCodePoint;
                }
              }
              break
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
                if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }

        if (codePoint === null) {
          // we did not generate a valid codePoint so insert a
          // replacement char (U+FFFD) and advance only 1 byte
          codePoint = 0xFFFD;
          bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
          // encode to utf16 (surrogate pair dance)
          codePoint -= 0x10000;
          res.push(codePoint >>> 10 & 0x3FF | 0xD800);
          codePoint = 0xDC00 | codePoint & 0x3FF;
        }

        res.push(codePoint);
        i += bytesPerSequence;
      }

      return decodeCodePointsArray(res)
    }

    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;

    function decodeCodePointsArray (codePoints) {
      var len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
      }

      // Decode in chunks to avoid "call stack size exceeded".
      var res = '';
      var i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res
    }

    function asciiSlice (buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 0x7F);
      }
      return ret
    }

    function latin1Slice (buf, start, end) {
      var ret = '';
      end = Math.min(buf.length, end);

      for (var i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret
    }

    function hexSlice (buf, start, end) {
      var len = buf.length;

      if (!start || start < 0) start = 0;
      if (!end || end < 0 || end > len) end = len;

      var out = '';
      for (var i = start; i < end; ++i) {
        out += toHex(buf[i]);
      }
      return out
    }

    function utf16leSlice (buf, start, end) {
      var bytes = buf.slice(start, end);
      var res = '';
      for (var i = 0; i < bytes.length; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res
    }

    Buffer.prototype.slice = function slice (start, end) {
      var len = this.length;
      start = ~~start;
      end = end === undefined ? len : ~~end;

      if (start < 0) {
        start += len;
        if (start < 0) start = 0;
      } else if (start > len) {
        start = len;
      }

      if (end < 0) {
        end += len;
        if (end < 0) end = 0;
      } else if (end > len) {
        end = len;
      }

      if (end < start) end = start;

      var newBuf;
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
      } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for (var i = 0; i < sliceLen; ++i) {
          newBuf[i] = this[i + start];
        }
      }

      return newBuf
    };

    /*
     * Need to make sure that buffer isn't trying to write out of bounds.
     */
    function checkOffset (offset, ext, length) {
      if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
      if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
    }

    Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);

      var val = this[offset];
      var mul = 1;
      var i = 0;
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }

      return val
    };

    Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        checkOffset(offset, byteLength, this.length);
      }

      var val = this[offset + --byteLength];
      var mul = 1;
      while (byteLength > 0 && (mul *= 0x100)) {
        val += this[offset + --byteLength] * mul;
      }

      return val
    };

    Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      return this[offset]
    };

    Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return this[offset] | (this[offset + 1] << 8)
    };

    Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      return (this[offset] << 8) | this[offset + 1]
    };

    Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return ((this[offset]) |
          (this[offset + 1] << 8) |
          (this[offset + 2] << 16)) +
          (this[offset + 3] * 0x1000000)
    };

    Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return (this[offset] * 0x1000000) +
        ((this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        this[offset + 3])
    };

    Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);

      var val = this[offset];
      var mul = 1;
      var i = 0;
      while (++i < byteLength && (mul *= 0x100)) {
        val += this[offset + i] * mul;
      }
      mul *= 0x80;

      if (val >= mul) val -= Math.pow(2, 8 * byteLength);

      return val
    };

    Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) checkOffset(offset, byteLength, this.length);

      var i = byteLength;
      var mul = 1;
      var val = this[offset + --i];
      while (i > 0 && (mul *= 0x100)) {
        val += this[offset + --i] * mul;
      }
      mul *= 0x80;

      if (val >= mul) val -= Math.pow(2, 8 * byteLength);

      return val
    };

    Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 1, this.length);
      if (!(this[offset] & 0x80)) return (this[offset])
      return ((0xff - this[offset] + 1) * -1)
    };

    Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset] | (this[offset + 1] << 8);
      return (val & 0x8000) ? val | 0xFFFF0000 : val
    };

    Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 2, this.length);
      var val = this[offset + 1] | (this[offset] << 8);
      return (val & 0x8000) ? val | 0xFFFF0000 : val
    };

    Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return (this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16) |
        (this[offset + 3] << 24)
    };

    Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);

      return (this[offset] << 24) |
        (this[offset + 1] << 16) |
        (this[offset + 2] << 8) |
        (this[offset + 3])
    };

    Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return read(this, offset, true, 23, 4)
    };

    Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 4, this.length);
      return read(this, offset, false, 23, 4)
    };

    Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return read(this, offset, true, 52, 8)
    };

    Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
      if (!noAssert) checkOffset(offset, 8, this.length);
      return read(this, offset, false, 52, 8)
    };

    function checkInt (buf, value, offset, ext, max, min) {
      if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
      if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
      if (offset + ext > buf.length) throw new RangeError('Index out of range')
    }

    Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }

      var mul = 1;
      var i = 0;
      this[offset] = value & 0xFF;
      while (++i < byteLength && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF;
      }

      return offset + byteLength
    };

    Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      byteLength = byteLength | 0;
      if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
      }

      var i = byteLength - 1;
      var mul = 1;
      this[offset + i] = value & 0xFF;
      while (--i >= 0 && (mul *= 0x100)) {
        this[offset + i] = (value / mul) & 0xFF;
      }

      return offset + byteLength
    };

    Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
      if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      this[offset] = (value & 0xff);
      return offset + 1
    };

    function objectWriteUInt16 (buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffff + value + 1;
      for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
        buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
          (littleEndian ? i : 1 - i) * 8;
      }
    }

    Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2
    };

    Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 8);
        this[offset + 1] = (value & 0xff);
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2
    };

    function objectWriteUInt32 (buf, value, offset, littleEndian) {
      if (value < 0) value = 0xffffffff + value + 1;
      for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
        buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
      }
    }

    Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = (value >>> 24);
        this[offset + 2] = (value >>> 16);
        this[offset + 1] = (value >>> 8);
        this[offset] = (value & 0xff);
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4
    };

    Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 24);
        this[offset + 1] = (value >>> 16);
        this[offset + 2] = (value >>> 8);
        this[offset + 3] = (value & 0xff);
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4
    };

    Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);

        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }

      var i = 0;
      var mul = 1;
      var sub = 0;
      this[offset] = value & 0xFF;
      while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
      }

      return offset + byteLength
    };

    Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);

        checkInt(this, value, offset, byteLength, limit - 1, -limit);
      }

      var i = byteLength - 1;
      var mul = 1;
      var sub = 0;
      this[offset + i] = value & 0xFF;
      while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
      }

      return offset + byteLength
    };

    Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
      if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
      if (value < 0) value = 0xff + value + 1;
      this[offset] = (value & 0xff);
      return offset + 1
    };

    Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
      } else {
        objectWriteUInt16(this, value, offset, true);
      }
      return offset + 2
    };

    Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 8);
        this[offset + 1] = (value & 0xff);
      } else {
        objectWriteUInt16(this, value, offset, false);
      }
      return offset + 2
    };

    Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value & 0xff);
        this[offset + 1] = (value >>> 8);
        this[offset + 2] = (value >>> 16);
        this[offset + 3] = (value >>> 24);
      } else {
        objectWriteUInt32(this, value, offset, true);
      }
      return offset + 4
    };

    Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
      value = +value;
      offset = offset | 0;
      if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
      if (value < 0) value = 0xffffffff + value + 1;
      if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = (value >>> 24);
        this[offset + 1] = (value >>> 16);
        this[offset + 2] = (value >>> 8);
        this[offset + 3] = (value & 0xff);
      } else {
        objectWriteUInt32(this, value, offset, false);
      }
      return offset + 4
    };

    function checkIEEE754 (buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length) throw new RangeError('Index out of range')
      if (offset < 0) throw new RangeError('Index out of range')
    }

    function writeFloat (buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
      }
      write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4
    }

    Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert)
    };

    Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert)
    };

    function writeDouble (buf, value, offset, littleEndian, noAssert) {
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
      }
      write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8
    }

    Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert)
    };

    Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert)
    };

    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy (target, targetStart, start, end) {
      if (!start) start = 0;
      if (!end && end !== 0) end = this.length;
      if (targetStart >= target.length) targetStart = target.length;
      if (!targetStart) targetStart = 0;
      if (end > 0 && end < start) end = start;

      // Copy 0 bytes; we're done
      if (end === start) return 0
      if (target.length === 0 || this.length === 0) return 0

      // Fatal error conditions
      if (targetStart < 0) {
        throw new RangeError('targetStart out of bounds')
      }
      if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
      if (end < 0) throw new RangeError('sourceEnd out of bounds')

      // Are we oob?
      if (end > this.length) end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }

      var len = end - start;
      var i;

      if (this === target && start < targetStart && targetStart < end) {
        // descending copy from end
        for (i = len - 1; i >= 0; --i) {
          target[i + targetStart] = this[i + start];
        }
      } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
        // ascending copy from start
        for (i = 0; i < len; ++i) {
          target[i + targetStart] = this[i + start];
        }
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, start + len),
          targetStart
        );
      }

      return len
    };

    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill (val, start, end, encoding) {
      // Handle string cases:
      if (typeof val === 'string') {
        if (typeof start === 'string') {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === 'string') {
          encoding = end;
          end = this.length;
        }
        if (val.length === 1) {
          var code = val.charCodeAt(0);
          if (code < 256) {
            val = code;
          }
        }
        if (encoding !== undefined && typeof encoding !== 'string') {
          throw new TypeError('encoding must be a string')
        }
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
          throw new TypeError('Unknown encoding: ' + encoding)
        }
      } else if (typeof val === 'number') {
        val = val & 255;
      }

      // Invalid ranges are not set to a default, so can range check early.
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError('Out of range index')
      }

      if (end <= start) {
        return this
      }

      start = start >>> 0;
      end = end === undefined ? this.length : end >>> 0;

      if (!val) val = 0;

      var i;
      if (typeof val === 'number') {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        var bytes = internalIsBuffer(val)
          ? val
          : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }

      return this
    };

    // HELPER FUNCTIONS
    // ================

    var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

    function base64clean (str) {
      // Node strips out invalid characters like \n and \t from the string, base64-js does not
      str = stringtrim(str).replace(INVALID_BASE64_RE, '');
      // Node converts strings with length < 2 to ''
      if (str.length < 2) return ''
      // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
      while (str.length % 4 !== 0) {
        str = str + '=';
      }
      return str
    }

    function stringtrim (str) {
      if (str.trim) return str.trim()
      return str.replace(/^\s+|\s+$/g, '')
    }

    function toHex (n) {
      if (n < 16) return '0' + n.toString(16)
      return n.toString(16)
    }

    function utf8ToBytes (string, units) {
      units = units || Infinity;
      var codePoint;
      var length = string.length;
      var leadSurrogate = null;
      var bytes = [];

      for (var i = 0; i < length; ++i) {
        codePoint = string.charCodeAt(i);

        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
          // last char was a lead
          if (!leadSurrogate) {
            // no lead yet
            if (codePoint > 0xDBFF) {
              // unexpected trail
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue
            } else if (i + 1 === length) {
              // unpaired lead
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
              continue
            }

            // valid lead
            leadSurrogate = codePoint;

            continue
          }

          // 2 leads in a row
          if (codePoint < 0xDC00) {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            leadSurrogate = codePoint;
            continue
          }

          // valid surrogate pair
          codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) {
          // valid bmp char, but last char was a lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }

        leadSurrogate = null;

        // encode utf8
        if (codePoint < 0x80) {
          if ((units -= 1) < 0) break
          bytes.push(codePoint);
        } else if (codePoint < 0x800) {
          if ((units -= 2) < 0) break
          bytes.push(
            codePoint >> 0x6 | 0xC0,
            codePoint & 0x3F | 0x80
          );
        } else if (codePoint < 0x10000) {
          if ((units -= 3) < 0) break
          bytes.push(
            codePoint >> 0xC | 0xE0,
            codePoint >> 0x6 & 0x3F | 0x80,
            codePoint & 0x3F | 0x80
          );
        } else if (codePoint < 0x110000) {
          if ((units -= 4) < 0) break
          bytes.push(
            codePoint >> 0x12 | 0xF0,
            codePoint >> 0xC & 0x3F | 0x80,
            codePoint >> 0x6 & 0x3F | 0x80,
            codePoint & 0x3F | 0x80
          );
        } else {
          throw new Error('Invalid code point')
        }
      }

      return bytes
    }

    function asciiToBytes (str) {
      var byteArray = [];
      for (var i = 0; i < str.length; ++i) {
        // Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
      }
      return byteArray
    }

    function utf16leToBytes (str, units) {
      var c, hi, lo;
      var byteArray = [];
      for (var i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0) break

        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }

      return byteArray
    }


    function base64ToBytes (str) {
      return toByteArray(base64clean(str))
    }

    function blitBuffer (src, dst, offset, length) {
      for (var i = 0; i < length; ++i) {
        if ((i + offset >= dst.length) || (i >= src.length)) break
        dst[i + offset] = src[i];
      }
      return i
    }

    function isnan (val) {
      return val !== val // eslint-disable-line no-self-compare
    }


    // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
    // The _isBuffer check is for Safari 5-7 support, because it's missing
    // Object.prototype.constructor. Remove this eventually
    function isBuffer(obj) {
      return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
    }

    function isFastBuffer (obj) {
      return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
    }

    // For Node v0.10 support. Remove this eventually.
    function isSlowBuffer (obj) {
      return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
    }

    var $jscomp={scope:{},getGlobal:function(a){return "undefined"!=typeof window&&window===a?a:"undefined"!=typeof commonjsGlobal?commonjsGlobal:a}};$jscomp.global=$jscomp.getGlobal(commonjsGlobal);$jscomp.initSymbol=function(){$jscomp.global.Symbol||($jscomp.global.Symbol=$jscomp.Symbol);$jscomp.initSymbol=function(){};};$jscomp.symbolCounter_=0;$jscomp.Symbol=function(a){return "jscomp_symbol_"+a+$jscomp.symbolCounter_++};
    $jscomp.initSymbolIterator=function(){$jscomp.initSymbol();$jscomp.global.Symbol.iterator||($jscomp.global.Symbol.iterator=$jscomp.global.Symbol("iterator"));$jscomp.initSymbolIterator=function(){};};$jscomp.makeIterator=function(a){$jscomp.initSymbolIterator();$jscomp.initSymbol();$jscomp.initSymbolIterator();var b=a[Symbol.iterator];if(b)return b.call(a);var c=0;return {next:function(){return c<a.length?{done:!1,value:a[c++]}:{done:!0}}}};
    $jscomp.arrayFromIterator=function(a){for(var b,c=[];!(b=a.next()).done;)c.push(b.value);return c};$jscomp.arrayFromIterable=function(a){return a instanceof Array?a:$jscomp.arrayFromIterator($jscomp.makeIterator(a))};$jscomp.inherits=function(a,b){function c(){}c.prototype=b.prototype;a.prototype=new c;a.prototype.constructor=a;for(var d in b)if(Object.defineProperties){var e=Object.getOwnPropertyDescriptor(b,d);e&&Object.defineProperty(a,d,e);}else a[d]=b[d];};$jscomp.array=$jscomp.array||{};
    $jscomp.iteratorFromArray=function(a,b){$jscomp.initSymbolIterator();a instanceof String&&(a+="");var c=0,d={next:function(){if(c<a.length){var e=c++;return {value:b(e,a[e]),done:!1}}d.next=function(){return {done:!0,value:void 0}};return d.next()}};$jscomp.initSymbol();$jscomp.initSymbolIterator();d[Symbol.iterator]=function(){return d};return d};
    $jscomp.findInternal=function(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return {i:e,v:f}}return {i:-1,v:void 0}};
    $jscomp.array.from=function(a,b,c){$jscomp.initSymbolIterator();b=null!=b?b:function(a){return a};var d=[];$jscomp.initSymbol();$jscomp.initSymbolIterator();var e=a[Symbol.iterator];"function"==typeof e&&(a=e.call(a));if("function"==typeof a.next)for(;!(e=a.next()).done;)d.push(b.call(c,e.value));else for(var e=a.length,f=0;f<e;f++)d.push(b.call(c,a[f]));return d};$jscomp.array.of=function(a){return $jscomp.array.from(arguments)};
    $jscomp.array.entries=function(){return $jscomp.iteratorFromArray(this,function(a,b){return [a,b]})};$jscomp.array.installHelper_=function(a,b){!Array.prototype[a]&&Object.defineProperties&&Object.defineProperty&&Object.defineProperty(Array.prototype,a,{configurable:!0,enumerable:!1,writable:!0,value:b});};$jscomp.array.entries$install=function(){$jscomp.array.installHelper_("entries",$jscomp.array.entries);};$jscomp.array.keys=function(){return $jscomp.iteratorFromArray(this,function(a){return a})};
    $jscomp.array.keys$install=function(){$jscomp.array.installHelper_("keys",$jscomp.array.keys);};$jscomp.array.values=function(){return $jscomp.iteratorFromArray(this,function(a,b){return b})};$jscomp.array.values$install=function(){$jscomp.array.installHelper_("values",$jscomp.array.values);};
    $jscomp.array.copyWithin=function(a,b,c){var d=this.length;a=Number(a);b=Number(b);c=Number(null!=c?c:d);if(a<b)for(c=Math.min(c,d);b<c;)b in this?this[a++]=this[b++]:(delete this[a++],b++);else for(c=Math.min(c,d+b-a),a+=c-b;c>b;)--c in this?this[--a]=this[c]:delete this[a];return this};$jscomp.array.copyWithin$install=function(){$jscomp.array.installHelper_("copyWithin",$jscomp.array.copyWithin);};
    $jscomp.array.fill=function(a,b,c){var d=this.length||0;0>b&&(b=Math.max(0,d+b));if(null==c||c>d)c=d;c=Number(c);0>c&&(c=Math.max(0,d+c));for(b=Number(b||0);b<c;b++)this[b]=a;return this};$jscomp.array.fill$install=function(){$jscomp.array.installHelper_("fill",$jscomp.array.fill);};$jscomp.array.find=function(a,b){return $jscomp.findInternal(this,a,b).v};$jscomp.array.find$install=function(){$jscomp.array.installHelper_("find",$jscomp.array.find);};
    $jscomp.array.findIndex=function(a,b){return $jscomp.findInternal(this,a,b).i};$jscomp.array.findIndex$install=function(){$jscomp.array.installHelper_("findIndex",$jscomp.array.findIndex);};$jscomp.ASSUME_NO_NATIVE_MAP=!1;
    $jscomp.Map$isConformant=function(){if($jscomp.ASSUME_NO_NATIVE_MAP)return !1;var a=$jscomp.global.Map;if(!a||!a.prototype.entries||"function"!=typeof Object.seal)return !1;try{var b=Object.seal({x:4}),c=new a($jscomp.makeIterator([[b,"s"]]));if("s"!=c.get(b)||1!=c.size||c.get({x:4})||c.set({x:4},"t")!=c||2!=c.size)return !1;var d=c.entries(),e=d.next();if(e.done||e.value[0]!=b||"s"!=e.value[1])return !1;e=d.next();return e.done||4!=e.value[0].x||"t"!=e.value[1]||!d.next().done?!1:!0}catch(f){return !1}};
    $jscomp.Map=function(a){this.data_={};this.head_=$jscomp.Map.createHead();this.size=0;if(a){a=$jscomp.makeIterator(a);for(var b;!(b=a.next()).done;)b=b.value,this.set(b[0],b[1]);}};
    $jscomp.Map.prototype.set=function(a,b){var c=$jscomp.Map.maybeGetEntry(this,a);c.list||(c.list=this.data_[c.id]=[]);c.entry?c.entry.value=b:(c.entry={next:this.head_,previous:this.head_.previous,head:this.head_,key:a,value:b},c.list.push(c.entry),this.head_.previous.next=c.entry,this.head_.previous=c.entry,this.size++);return this};
    $jscomp.Map.prototype["delete"]=function(a){a=$jscomp.Map.maybeGetEntry(this,a);return a.entry&&a.list?(a.list.splice(a.index,1),a.list.length||delete this.data_[a.id],a.entry.previous.next=a.entry.next,a.entry.next.previous=a.entry.previous,a.entry.head=null,this.size--,!0):!1};$jscomp.Map.prototype.clear=function(){this.data_={};this.head_=this.head_.previous=$jscomp.Map.createHead();this.size=0;};$jscomp.Map.prototype.has=function(a){return !!$jscomp.Map.maybeGetEntry(this,a).entry};
    $jscomp.Map.prototype.get=function(a){return (a=$jscomp.Map.maybeGetEntry(this,a).entry)&&a.value};$jscomp.Map.prototype.entries=function(){return $jscomp.Map.makeIterator_(this,function(a){return [a.key,a.value]})};$jscomp.Map.prototype.keys=function(){return $jscomp.Map.makeIterator_(this,function(a){return a.key})};$jscomp.Map.prototype.values=function(){return $jscomp.Map.makeIterator_(this,function(a){return a.value})};
    $jscomp.Map.prototype.forEach=function(a,b){for(var c=this.entries(),d;!(d=c.next()).done;)d=d.value,a.call(b,d[1],d[0],this);};$jscomp.Map.maybeGetEntry=function(a,b){var c=$jscomp.Map.getId(b),d=a.data_[c];if(d&&Object.prototype.hasOwnProperty.call(a.data_,c))for(var e=0;e<d.length;e++){var f=d[e];if(b!==b&&f.key!==f.key||b===f.key)return {id:c,list:d,index:e,entry:f}}return {id:c,list:d,index:-1,entry:void 0}};
    $jscomp.Map.makeIterator_=function(a,b){var c=a.head_,d={next:function(){if(c){for(;c.head!=a.head_;)c=c.previous;for(;c.next!=c.head;)return c=c.next,{done:!1,value:b(c)};c=null;}return {done:!0,value:void 0}}};$jscomp.initSymbol();$jscomp.initSymbolIterator();d[Symbol.iterator]=function(){return d};return d};$jscomp.Map.mapIndex_=0;$jscomp.Map.createHead=function(){var a={};return a.previous=a.next=a.head=a};
    $jscomp.Map.getId=function(a){if(!(a instanceof Object))return "p_"+a;if(!($jscomp.Map.idKey in a))try{$jscomp.Map.defineProperty(a,$jscomp.Map.idKey,{value:++$jscomp.Map.mapIndex_});}catch(b){}return $jscomp.Map.idKey in a?a[$jscomp.Map.idKey]:"o_ "+a};$jscomp.Map.defineProperty=Object.defineProperty?function(a,b,c){Object.defineProperty(a,b,{value:String(c)});}:function(a,b,c){a[b]=String(c);};$jscomp.Map.Entry=function(){};
    $jscomp.Map$install=function(){$jscomp.initSymbol();$jscomp.initSymbolIterator();$jscomp.Map$isConformant()?$jscomp.Map=$jscomp.global.Map:($jscomp.initSymbol(),$jscomp.initSymbolIterator(),$jscomp.Map.prototype[Symbol.iterator]=$jscomp.Map.prototype.entries,$jscomp.initSymbol(),$jscomp.Map.idKey=Symbol("map-id-key"),$jscomp.Map$install=function(){});};$jscomp.math=$jscomp.math||{};
    $jscomp.math.clz32=function(a){a=Number(a)>>>0;if(0===a)return 32;var b=0;0===(a&4294901760)&&(a<<=16,b+=16);0===(a&4278190080)&&(a<<=8,b+=8);0===(a&4026531840)&&(a<<=4,b+=4);0===(a&3221225472)&&(a<<=2,b+=2);0===(a&2147483648)&&b++;return b};$jscomp.math.imul=function(a,b){a=Number(a);b=Number(b);var c=a&65535,d=b&65535;return c*d+((a>>>16&65535)*d+c*(b>>>16&65535)<<16>>>0)|0};$jscomp.math.sign=function(a){a=Number(a);return 0===a||isNaN(a)?a:0<a?1:-1};
    $jscomp.math.log10=function(a){return Math.log(a)/Math.LN10};$jscomp.math.log2=function(a){return Math.log(a)/Math.LN2};$jscomp.math.log1p=function(a){a=Number(a);if(.25>a&&-.25<a){for(var b=a,c=1,d=a,e=0,f=1;e!=d;)b*=a,f*=-1,d=(e=d)+f*b/++c;return d}return Math.log(1+a)};$jscomp.math.expm1=function(a){a=Number(a);if(.25>a&&-.25<a){for(var b=a,c=1,d=a,e=0;e!=d;)b*=a/++c,d=(e=d)+b;return d}return Math.exp(a)-1};$jscomp.math.cosh=function(a){a=Number(a);return (Math.exp(a)+Math.exp(-a))/2};
    $jscomp.math.sinh=function(a){a=Number(a);return 0===a?a:(Math.exp(a)-Math.exp(-a))/2};$jscomp.math.tanh=function(a){a=Number(a);if(0===a)return a;var b=Math.exp(-2*Math.abs(a)),b=(1-b)/(1+b);return 0>a?-b:b};$jscomp.math.acosh=function(a){a=Number(a);return Math.log(a+Math.sqrt(a*a-1))};$jscomp.math.asinh=function(a){a=Number(a);if(0===a)return a;var b=Math.log(Math.abs(a)+Math.sqrt(a*a+1));return 0>a?-b:b};
    $jscomp.math.atanh=function(a){a=Number(a);return ($jscomp.math.log1p(a)-$jscomp.math.log1p(-a))/2};$jscomp.math.hypot=function(a,b,c){a=Number(a);b=Number(b);var d,e,f,g=Math.max(Math.abs(a),Math.abs(b));for(d=2;d<arguments.length;d++)g=Math.max(g,Math.abs(arguments[d]));if(1E100<g||1E-100>g){a/=g;b/=g;f=a*a+b*b;for(d=2;d<arguments.length;d++)e=Number(arguments[d])/g,f+=e*e;return Math.sqrt(f)*g}f=a*a+b*b;for(d=2;d<arguments.length;d++)e=Number(arguments[d]),f+=e*e;return Math.sqrt(f)};
    $jscomp.math.trunc=function(a){a=Number(a);if(isNaN(a)||Infinity===a||-Infinity===a||0===a)return a;var b=Math.floor(Math.abs(a));return 0>a?-b:b};$jscomp.math.cbrt=function(a){if(0===a)return a;a=Number(a);var b=Math.pow(Math.abs(a),1/3);return 0>a?-b:b};$jscomp.number=$jscomp.number||{};$jscomp.number.isFinite=function(a){return "number"!==typeof a?!1:!isNaN(a)&&Infinity!==a&&-Infinity!==a};$jscomp.number.isInteger=function(a){return $jscomp.number.isFinite(a)?a===Math.floor(a):!1};
    $jscomp.number.isNaN=function(a){return "number"===typeof a&&isNaN(a)};$jscomp.number.isSafeInteger=function(a){return $jscomp.number.isInteger(a)&&Math.abs(a)<=$jscomp.number.MAX_SAFE_INTEGER};$jscomp.number.EPSILON=function(){return Math.pow(2,-52)}();$jscomp.number.MAX_SAFE_INTEGER=function(){return 9007199254740991}();$jscomp.number.MIN_SAFE_INTEGER=function(){return -9007199254740991}();$jscomp.object=$jscomp.object||{};
    $jscomp.object.assign=function(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(d)for(var e in d)Object.prototype.hasOwnProperty.call(d,e)&&(a[e]=d[e]);}return a};$jscomp.object.is=function(a,b){return a===b?0!==a||1/a===1/b:a!==a&&b!==b};$jscomp.ASSUME_NO_NATIVE_SET=!1;
    $jscomp.Set$isConformant=function(){if($jscomp.ASSUME_NO_NATIVE_SET)return !1;var a=$jscomp.global.Set;if(!a||!a.prototype.entries||"function"!=typeof Object.seal)return !1;try{var b=Object.seal({x:4}),c=new a($jscomp.makeIterator([b]));if(!c.has(b)||1!=c.size||c.add(b)!=c||1!=c.size||c.add({x:4})!=c||2!=c.size)return !1;var d=c.entries(),e=d.next();if(e.done||e.value[0]!=b||e.value[1]!=b)return !1;e=d.next();return e.done||e.value[0]==b||4!=e.value[0].x||e.value[1]!=e.value[0]?!1:d.next().done}catch(f){return !1}};
    $jscomp.Set=function(a){this.map_=new $jscomp.Map;if(a){a=$jscomp.makeIterator(a);for(var b;!(b=a.next()).done;)this.add(b.value);}this.size=this.map_.size;};$jscomp.Set.prototype.add=function(a){this.map_.set(a,a);this.size=this.map_.size;return this};$jscomp.Set.prototype["delete"]=function(a){a=this.map_["delete"](a);this.size=this.map_.size;return a};$jscomp.Set.prototype.clear=function(){this.map_.clear();this.size=0;};$jscomp.Set.prototype.has=function(a){return this.map_.has(a)};
    $jscomp.Set.prototype.entries=function(){return this.map_.entries()};$jscomp.Set.prototype.values=function(){return this.map_.values()};$jscomp.Set.prototype.forEach=function(a,b){var c=this;this.map_.forEach(function(d){return a.call(b,d,d,c)});};$jscomp.Set$install=function(){$jscomp.Map$install();$jscomp.Set$isConformant()?$jscomp.Set=$jscomp.global.Set:($jscomp.initSymbol(),$jscomp.initSymbolIterator(),$jscomp.Set.prototype[Symbol.iterator]=$jscomp.Set.prototype.values,$jscomp.Set$install=function(){});};
    $jscomp.string=$jscomp.string||{};$jscomp.checkStringArgs=function(a,b,c){if(null==a)throw new TypeError("The 'this' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""};
    $jscomp.string.fromCodePoint=function(a){for(var b="",c=0;c<arguments.length;c++){var d=Number(arguments[c]);if(0>d||1114111<d||d!==Math.floor(d))throw new RangeError("invalid_code_point "+d);65535>=d?b+=String.fromCharCode(d):(d-=65536,b+=String.fromCharCode(d>>>10&1023|55296),b+=String.fromCharCode(d&1023|56320));}return b};
    $jscomp.string.repeat=function(a){var b=$jscomp.checkStringArgs(this,null,"repeat");if(0>a||1342177279<a)throw new RangeError("Invalid count value");a|=0;for(var c="";a;)if(a&1&&(c+=b),a>>>=1)b+=b;return c};$jscomp.string.repeat$install=function(){String.prototype.repeat||(String.prototype.repeat=$jscomp.string.repeat);};
    $jscomp.string.codePointAt=function(a){var b=$jscomp.checkStringArgs(this,null,"codePointAt"),c=b.length;a=Number(a)||0;if(0<=a&&a<c){a|=0;var d=b.charCodeAt(a);if(55296>d||56319<d||a+1===c)return d;a=b.charCodeAt(a+1);return 56320>a||57343<a?d:1024*(d-55296)+a+9216}};$jscomp.string.codePointAt$install=function(){String.prototype.codePointAt||(String.prototype.codePointAt=$jscomp.string.codePointAt);};
    $jscomp.string.includes=function(a,b){return -1!==$jscomp.checkStringArgs(this,a,"includes").indexOf(a,b||0)};$jscomp.string.includes$install=function(){String.prototype.includes||(String.prototype.includes=$jscomp.string.includes);};$jscomp.string.startsWith=function(a,b){var c=$jscomp.checkStringArgs(this,a,"startsWith");a+="";for(var d=c.length,e=a.length,f=Math.max(0,Math.min(b|0,c.length)),g=0;g<e&&f<d;)if(c[f++]!=a[g++])return !1;return g>=e};
    $jscomp.string.startsWith$install=function(){String.prototype.startsWith||(String.prototype.startsWith=$jscomp.string.startsWith);};$jscomp.string.endsWith=function(a,b){var c=$jscomp.checkStringArgs(this,a,"endsWith");a+="";void 0===b&&(b=c.length);for(var d=Math.max(0,Math.min(b|0,c.length)),e=a.length;0<e&&0<d;)if(c[--d]!=a[--e])return !1;return 0>=e};$jscomp.string.endsWith$install=function(){String.prototype.endsWith||(String.prototype.endsWith=$jscomp.string.endsWith);};
    var COMPILED$1=!0,goog=goog||{};goog.global=commonjsGlobal;goog.isDef=function(a){return void 0!==a};goog.exportPath_=function(a,b,c){a=a.split(".");c=c||goog.global;a[0]in c||!c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)!a.length&&goog.isDef(b)?c[d]=b:c=c[d]?c[d]:c[d]={};};
    goog.define=function(a,b){var c=b;goog.exportPath_(a,c);};goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.STRICT_MODE_COMPATIBLE=!1;goog.DISALLOW_TEST_ONLY_CODE=!goog.DEBUG;
    goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;goog.provide=function(a){goog.constructNamespace_(a);};goog.constructNamespace_=function(a,b){goog.exportPath_(a,b);};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
    goog.module=function(a){if(!goog.isString(a)||!a||-1==a.search(goog.VALID_MODULE_RE_))throw Error("Invalid module identifier");if(!goog.isInModuleLoader_())throw Error("Module "+a+" has been loaded incorrectly.");if(goog.moduleLoaderState_.moduleName)throw Error("goog.module may only be called once per module.");goog.moduleLoaderState_.moduleName=a;};goog.module.get=function(a){return goog.module.getInternal_(a)};
    goog.module.getInternal_=function(a){};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return null!=goog.moduleLoaderState_};
    goog.module.declareLegacyNamespace=function(){goog.moduleLoaderState_.declareLegacyNamespace=!0;};
    goog.setTestOnly=function(a){if(goog.DISALLOW_TEST_ONLY_CODE)throw a=a||"",Error("Importing test-only code into non-debug environment"+(a?": "+a:"."));};goog.forwardDeclare=function(a){};goog.getObjectByName=function(a,b){for(var c=a.split("."),d=b||goog.global,e;e=c.shift();)if(goog.isDefAndNotNull(d[e]))d=d[e];else return null;return d};goog.globalize=function(a,b){var c=b||goog.global,d;for(d in a)c[d]=a[d];};goog.addDependency=function(a,b,c,d){if(goog.DEPENDENCIES_ENABLED){var e;a=a.replace(/\\/g,"/");for(var f=goog.dependencies_,g=0;e=b[g];g++)f.nameToPath[e]=a,f.pathIsModule[a]=!!d;for(d=0;b=c[d];d++)a in f.requires||(f.requires[a]={}),f.requires[a][b]=!0;}};
    goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(a){goog.global.console&&goog.global.console.error(a);};goog.require=function(a){};
    goog.basePath="";goog.nullFunction=function(){};goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(a){a.getInstance=function(){if(a.instance_)return a.instance_;goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=a);return a.instance_=new a};};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!COMPILED$1;
    goog.DEPENDENCIES_ENABLED&&(goog.dependencies_={pathIsModule:{},nameToPath:{},requires:{},visited:{},written:{},deferred:{}},goog.inHtmlDocument_=function(){var a=goog.global.document;return null!=a&&"write"in a},goog.findBasePath_=function(){if(goog.isDef(goog.global.CLOSURE_BASE_PATH))goog.basePath=goog.global.CLOSURE_BASE_PATH;else if(goog.inHtmlDocument_())for(var a=goog.global.document.getElementsByTagName("SCRIPT"),b=a.length-1;0<=b;--b){var c=a[b].src,d=c.lastIndexOf("?"),d=-1==d?c.length:
    d;if("base.js"==c.substr(d-7,7)){goog.basePath=c.substr(0,d-7);break}}},goog.importScript_=function(a,b){(goog.global.CLOSURE_IMPORT_SCRIPT||goog.writeScriptTag_)(a,b)&&(goog.dependencies_.written[a]=!0);},goog.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.importModule_=function(a){goog.importScript_("",'goog.retrieveAndExecModule_("'+a+'");')&&(goog.dependencies_.written[a]=!0);},goog.queuedModules_=[],goog.wrapModule_=function(a,b){return goog.LOAD_MODULE_USING_EVAL&&
    goog.isDef(goog.global.JSON)?"goog.loadModule("+goog.global.JSON.stringify(b+"\n//# sourceURL="+a+"\n")+");":'goog.loadModule(function(exports) {"use strict";'+b+"\n;return exports});\n//# sourceURL="+a+"\n"},goog.loadQueuedModules_=function(){var a=goog.queuedModules_.length;if(0<a){var b=goog.queuedModules_;goog.queuedModules_=[];for(var c=0;c<a;c++)goog.maybeProcessDeferredPath_(b[c]);}},goog.maybeProcessDeferredDep_=function(a){goog.isDeferredModule_(a)&&goog.allDepsAreAvailable_(a)&&(a=goog.getPathFromDeps_(a),
    goog.maybeProcessDeferredPath_(goog.basePath+a));},goog.isDeferredModule_=function(a){return (a=goog.getPathFromDeps_(a))&&goog.dependencies_.pathIsModule[a]?goog.basePath+a in goog.dependencies_.deferred:!1},goog.allDepsAreAvailable_=function(a){if((a=goog.getPathFromDeps_(a))&&a in goog.dependencies_.requires)for(var b in goog.dependencies_.requires[a])if(!goog.isProvided_(b)&&!goog.isDeferredModule_(b))return !1;return !0},goog.maybeProcessDeferredPath_=function(a){if(a in goog.dependencies_.deferred){var b=
    goog.dependencies_.deferred[a];delete goog.dependencies_.deferred[a];goog.globalEval(b);}},goog.loadModuleFromUrl=function(a){goog.retrieveAndExecModule_(a);},goog.loadModule=function(a){var b=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:void 0,declareLegacyNamespace:!1};var c;if(goog.isFunction(a))c=a.call(goog.global,{});else if(goog.isString(a))c=goog.loadModuleFromSource_.call(goog.global,a);else throw Error("Invalid module definition");var d=goog.moduleLoaderState_.moduleName;
    if(!goog.isString(d)||!d)throw Error('Invalid module name "'+d+'"');goog.moduleLoaderState_.declareLegacyNamespace?goog.constructNamespace_(d,c):goog.SEAL_MODULE_EXPORTS&&Object.seal&&Object.seal(c);goog.loadedModules_[d]=c;}finally{goog.moduleLoaderState_=b;}},goog.loadModuleFromSource_=function(a){eval(a);return {}},goog.writeScriptSrcNode_=function(a){goog.global.document.write('<script type="text/javascript" src="'+a+'">\x3c/script>');},goog.appendScriptSrcNode_=function(a){var b=goog.global.document,
    c=b.createElement("script");c.type="text/javascript";c.src=a;c.defer=!1;c.async=!1;b.head.appendChild(c);},goog.writeScriptTag_=function(a,b){if(goog.inHtmlDocument_()){var c=goog.global.document;if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&"complete"==c.readyState){if(/\bdeps.js$/.test(a))return !1;throw Error('Cannot write "'+a+'" after document load');}var d=goog.IS_OLD_IE_;void 0===b?d?(d=" onreadystatechange='goog.onScriptLoad_(this, "+ ++goog.lastNonModuleScriptIndex_+")' ",c.write('<script type="text/javascript" src="'+
    a+'"'+d+">\x3c/script>")):goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING?goog.appendScriptSrcNode_(a):goog.writeScriptSrcNode_(a):c.write('<script type="text/javascript">'+b+"\x3c/script>");return !0}return !1},goog.lastNonModuleScriptIndex_=0,goog.onScriptLoad_=function(a,b){"complete"==a.readyState&&goog.lastNonModuleScriptIndex_==b&&goog.loadQueuedModules_();return !0},goog.writeScripts_=function(a){function b(a){if(!(a in e.written||a in e.visited)){e.visited[a]=!0;if(a in e.requires)for(var f in e.requires[a])if(!goog.isProvided_(f))if(f in
    e.nameToPath)b(e.nameToPath[f]);else throw Error("Undefined nameToPath for "+f);a in d||(d[a]=!0,c.push(a));}}var c=[],d={},e=goog.dependencies_;b(a);for(a=0;a<c.length;a++){var f=c[a];goog.dependencies_.written[f]=!0;}var g=goog.moduleLoaderState_;goog.moduleLoaderState_=null;for(a=0;a<c.length;a++)if(f=c[a])e.pathIsModule[f]?goog.importModule_(goog.basePath+f):goog.importScript_(goog.basePath+f);else throw goog.moduleLoaderState_=g,Error("Undefined script input");goog.moduleLoaderState_=g;},goog.getPathFromDeps_=
    function(a){return a in goog.dependencies_.nameToPath?goog.dependencies_.nameToPath[a]:null},goog.findBasePath_(),goog.global.CLOSURE_NO_DEPS||goog.importScript_(goog.basePath+"deps.js"));goog.normalizePath_=function(a){a=a.split("/");for(var b=0;b<a.length;)"."==a[b]?a.splice(b,1):b&&".."==a[b]&&a[b-1]&&".."!=a[b-1]?a.splice(--b,2):b++;return a.join("/")};
    goog.loadFileSync_=function(a){if(goog.global.CLOSURE_LOAD_FILE_SYNC)return goog.global.CLOSURE_LOAD_FILE_SYNC(a);var b=new goog.global.XMLHttpRequest;b.open("get",a,!1);b.send();return b.responseText};
    goog.retrieveAndExecModule_=function(a){};
    goog.typeOf=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return "array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return "object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return "array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return "function"}else return "null";
    else if("function"==b&&"undefined"==typeof a.call)return "object";return b};goog.isNull=function(a){return null===a};goog.isDefAndNotNull=function(a){return null!=a};goog.isArray=function(a){return "array"==goog.typeOf(a)};goog.isArrayLike=function(a){var b=goog.typeOf(a);return "array"==b||"object"==b&&"number"==typeof a.length};goog.isDateLike=function(a){return goog.isObject(a)&&"function"==typeof a.getFullYear};goog.isString=function(a){return "string"==typeof a};
    goog.isBoolean=function(a){return "boolean"==typeof a};goog.isNumber=function(a){return "number"==typeof a};goog.isFunction=function(a){return "function"==goog.typeOf(a)};goog.isObject=function(a){var b=typeof a;return "object"==b&&null!=a||"function"==b};goog.getUid=function(a){return a[goog.UID_PROPERTY_]||(a[goog.UID_PROPERTY_]=++goog.uidCounter_)};goog.hasUid=function(a){return !!a[goog.UID_PROPERTY_]};
    goog.removeUid=function(a){null!==a&&"removeAttribute"in a&&a.removeAttribute(goog.UID_PROPERTY_);try{delete a[goog.UID_PROPERTY_];}catch(b){}};goog.UID_PROPERTY_="closure_uid_"+(1E9*Math.random()>>>0);goog.uidCounter_=0;goog.getHashCode=goog.getUid;goog.removeHashCode=goog.removeUid;goog.cloneObject=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if(a.clone)return a.clone();var b="array"==b?[]:{},c;for(c in a)b[c]=goog.cloneObject(a[c]);return b}return a};
    goog.bindNative_=function(a,b,c){return a.call.apply(a.bind,arguments)};goog.bindJs_=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}};
    goog.bind=function(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments)};goog.partial=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}};goog.mixin=function(a,b){for(var c in b)a[c]=b[c];};goog.now=goog.TRUSTED_SITE&&Date.now||function(){return +new Date};
    goog.globalEval=function(a){if(goog.global.execScript)goog.global.execScript(a,"JavaScript");else if(goog.global.eval){if(null==goog.evalWorksForGlobals_)if(goog.global.eval("var _evalTest_ = 1;"),"undefined"!=typeof goog.global._evalTest_){try{delete goog.global._evalTest_;}catch(d){}goog.evalWorksForGlobals_=!0;}else goog.evalWorksForGlobals_=!1;if(goog.evalWorksForGlobals_)goog.global.eval(a);else{var b=goog.global.document,c=b.createElement("SCRIPT");c.type="text/javascript";c.defer=!1;c.appendChild(b.createTextNode(a));
    b.body.appendChild(c);b.body.removeChild(c);}}else throw Error("goog.globalEval not available");};goog.evalWorksForGlobals_=null;goog.getCssName=function(a,b){var c=function(a){return goog.cssNameMapping_[a]||a},d=function(a){a=a.split("-");for(var b=[],d=0;d<a.length;d++)b.push(c(a[d]));return b.join("-")},d=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?c:d:function(a){return a};return b?a+"-"+d(b):d(a)};
    goog.setCssNameMapping=function(a,b){goog.cssNameMapping_=a;goog.cssNameMappingStyle_=b;};goog.getMsg=function(a,b){b&&(a=a.replace(/\{\$([^}]+)}/g,function(a,d){return null!=b&&d in b?b[d]:a}));return a};goog.getMsgWithFallback=function(a,b){return a};goog.exportSymbol=function(a,b,c){goog.exportPath_(a,b,c);};goog.exportProperty=function(a,b,c){a[b]=c;};
    goog.inherits=function(a,b){function c(){}c.prototype=b.prototype;a.superClass_=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.base=function(a,c,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[c].apply(a,g)};};
    goog.base=function(a,b,c){var d=arguments.callee.caller;if(goog.STRICT_MODE_COMPATIBLE||goog.DEBUG&&!d)throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");if(d.superClass_){for(var e=Array(arguments.length-1),f=1;f<arguments.length;f++)e[f-1]=arguments[f];return d.superClass_.constructor.apply(a,e)}e=Array(arguments.length-2);for(f=2;f<arguments.length;f++)e[f-2]=arguments[f];for(var f=!1,g=a.constructor;g;g=
    g.superClass_&&g.superClass_.constructor)if(g.prototype[b]===d)f=!0;else if(f)return g.prototype[b].apply(a,e);if(a[b]===d)return a.constructor.prototype[b].apply(a,e);throw Error("goog.base called from a method of one name to a method of a different name");};goog.scope=function(a){a.call(goog.global);};goog.defineClass=function(a,b){var c=b.constructor,d=b.statics;c&&c!=Object.prototype.constructor||(c=function(){throw Error("cannot instantiate an interface (no constructor defined).");});c=goog.defineClass.createSealingConstructor_(c,a);a&&goog.inherits(c,a);delete b.constructor;delete b.statics;goog.defineClass.applyProperties_(c.prototype,b);null!=d&&(d instanceof Function?d(c):goog.defineClass.applyProperties_(c,d));return c};goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;
    goog.defineClass.createSealingConstructor_=function(a,b){if(goog.defineClass.SEAL_CLASS_INSTANCES&&Object.seal instanceof Function){if(b&&b.prototype&&b.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_])return a;var c=function(){var b=a.apply(this,arguments)||this;b[goog.UID_PROPERTY_]=b[goog.UID_PROPERTY_];this.constructor===c&&Object.seal(b);return b};return c}return a};goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    goog.defineClass.applyProperties_=function(a,b){for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c]);for(var d=0;d<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;d++)c=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d],Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c]);};goog.tagUnsealableClass=function(a){};goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_="goog_defineClass_legacy_unsealable";goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.debug={};goog.debug.Error=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,goog.debug.Error);else{var b=Error().stack;b&&(this.stack=b);}a&&(this.message=String(a));this.reportErrorToServer=!0;};goog.inherits(goog.debug.Error,Error);goog.debug.Error.prototype.name="CustomError";goog.string={};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\u00a0"};goog.string.startsWith=function(a,b){return 0==a.lastIndexOf(b,0)};goog.string.endsWith=function(a,b){var c=a.length-b.length;return 0<=c&&a.indexOf(b,c)==c};goog.string.caseInsensitiveStartsWith=function(a,b){return 0==goog.string.caseInsensitiveCompare(b,a.substr(0,b.length))};
    goog.string.caseInsensitiveEndsWith=function(a,b){return 0==goog.string.caseInsensitiveCompare(b,a.substr(a.length-b.length,b.length))};goog.string.caseInsensitiveEquals=function(a,b){return a.toLowerCase()==b.toLowerCase()};goog.string.subs=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};goog.string.collapseWhitespace=function(a){return a.replace(/[\s\xa0]+/g," ").replace(/^\s+|\s+$/g,"")};
    goog.string.isEmptyOrWhitespace=function(a){return /^[\s\xa0]*$/.test(a)};goog.string.isEmptyString=function(a){return 0==a.length};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(a){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a))};goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(a){return !/[^\t\n\r ]/.test(a)};goog.string.isAlpha=function(a){return !/[^a-zA-Z]/.test(a)};
    goog.string.isNumeric=function(a){return !/[^0-9]/.test(a)};goog.string.isAlphaNumeric=function(a){return !/[^a-zA-Z0-9]/.test(a)};goog.string.isSpace=function(a){return " "==a};goog.string.isUnicodeChar=function(a){return 1==a.length&&" "<=a&&"~">=a||"\u0080"<=a&&"\ufffd">=a};goog.string.stripNewlines=function(a){return a.replace(/(\r\n|\r|\n)+/g," ")};goog.string.canonicalizeNewlines=function(a){return a.replace(/(\r\n|\r|\n)/g,"\n")};
    goog.string.normalizeWhitespace=function(a){return a.replace(/\xa0|\s/g," ")};goog.string.normalizeSpaces=function(a){return a.replace(/\xa0|[ \t]+/g," ")};goog.string.collapseBreakingSpaces=function(a){return a.replace(/[\t\r\n ]+/g," ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g,"")};goog.string.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};goog.string.trimLeft=function(a){return a.replace(/^[\s\xa0]+/,"")};
    goog.string.trimRight=function(a){return a.replace(/[\s\xa0]+$/,"")};goog.string.caseInsensitiveCompare=function(a,b){var c=String(a).toLowerCase(),d=String(b).toLowerCase();return c<d?-1:c==d?0:1};
    goog.string.numberAwareCompare_=function(a,b,c){if(a==b)return 0;if(!a)return -1;if(!b)return 1;for(var d=a.toLowerCase().match(c),e=b.toLowerCase().match(c),f=Math.min(d.length,e.length),g=0;g<f;g++){c=d[g];var h=e[g];if(c!=h)return a=parseInt(c,10),!isNaN(a)&&(b=parseInt(h,10),!isNaN(b)&&a-b)?a-b:c<h?-1:1}return d.length!=e.length?d.length-e.length:a<b?-1:1};goog.string.intAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\D+/g)};
    goog.string.floatAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\.\d+|\D+/g)};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(a){return encodeURIComponent(String(a))};goog.string.urlDecode=function(a){return decodeURIComponent(a.replace(/\+/g," "))};goog.string.newLineToBr=function(a,b){return a.replace(/(\r\n|\r|\n)/g,b?"<br />":"<br>")};
    goog.string.htmlEscape=function(a,b){if(b)a=a.replace(goog.string.AMP_RE_,"&amp;").replace(goog.string.LT_RE_,"&lt;").replace(goog.string.GT_RE_,"&gt;").replace(goog.string.QUOT_RE_,"&quot;").replace(goog.string.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.NULL_RE_,"&#0;"),goog.string.DETECT_DOUBLE_ESCAPING&&(a=a.replace(goog.string.E_RE_,"&#101;"));else{if(!goog.string.ALL_RE_.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(goog.string.AMP_RE_,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(goog.string.LT_RE_,
    "&lt;"));-1!=a.indexOf(">")&&(a=a.replace(goog.string.GT_RE_,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(goog.string.QUOT_RE_,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(goog.string.SINGLE_QUOTE_RE_,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(goog.string.NULL_RE_,"&#0;"));goog.string.DETECT_DOUBLE_ESCAPING&&-1!=a.indexOf("e")&&(a=a.replace(goog.string.E_RE_,"&#101;"));}return a};goog.string.AMP_RE_=/&/g;goog.string.LT_RE_=/</g;goog.string.GT_RE_=/>/g;goog.string.QUOT_RE_=/"/g;
    goog.string.SINGLE_QUOTE_RE_=/'/g;goog.string.NULL_RE_=/\x00/g;goog.string.E_RE_=/e/g;goog.string.ALL_RE_=goog.string.DETECT_DOUBLE_ESCAPING?/[\x00&<>"'e]/:/[\x00&<>"']/;goog.string.unescapeEntities=function(a){return goog.string.contains(a,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(a):goog.string.unescapePureXmlEntities_(a):a};
    goog.string.unescapeEntitiesWithDocument=function(a,b){return goog.string.contains(a,"&")?goog.string.unescapeEntitiesUsingDom_(a,b):a};
    goog.string.unescapeEntitiesUsingDom_=function(a,b){var c={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"'},d;d=b?b.createElement("div"):goog.global.document.createElement("div");return a.replace(goog.string.HTML_ENTITY_PATTERN_,function(a,b){var g=c[a];if(g)return g;if("#"==b.charAt(0)){var h=Number("0"+b.substr(1));isNaN(h)||(g=String.fromCharCode(h));}g||(d.innerHTML=a+" ",g=d.firstChild.nodeValue.slice(0,-1));return c[a]=g})};
    goog.string.unescapePureXmlEntities_=function(a){return a.replace(/&([^;]+);/g,function(a,c){switch(c){case "amp":return "&";case "lt":return "<";case "gt":return ">";case "quot":return '"';default:if("#"==c.charAt(0)){var d=Number("0"+c.substr(1));if(!isNaN(d))return String.fromCharCode(d)}return a}})};goog.string.HTML_ENTITY_PATTERN_=/&([^;\s<&]+);?/g;goog.string.whitespaceEscape=function(a,b){return goog.string.newLineToBr(a.replace(/  /g," &#160;"),b)};
    goog.string.preserveSpaces=function(a){return a.replace(/(^|[\n ]) /g,"$1"+goog.string.Unicode.NBSP)};goog.string.stripQuotes=function(a,b){for(var c=b.length,d=0;d<c;d++){var e=1==c?b:b.charAt(d);if(a.charAt(0)==e&&a.charAt(a.length-1)==e)return a.substring(1,a.length-1)}return a};goog.string.truncate=function(a,b,c){c&&(a=goog.string.unescapeEntities(a));a.length>b&&(a=a.substring(0,b-3)+"...");c&&(a=goog.string.htmlEscape(a));return a};
    goog.string.truncateMiddle=function(a,b,c,d){c&&(a=goog.string.unescapeEntities(a));if(d&&a.length>b){d>b&&(d=b);var e=a.length-d;a=a.substring(0,b-d)+"..."+a.substring(e);}else a.length>b&&(d=Math.floor(b/2),e=a.length-d,a=a.substring(0,d+b%2)+"..."+a.substring(e));c&&(a=goog.string.htmlEscape(a));return a};goog.string.specialEscapeChars_={"\x00":"\\0","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\x0B",'"':'\\"',"\\":"\\\\","<":"<"};goog.string.jsEscapeCache_={"'":"\\'"};
    goog.string.quote=function(a){a=String(a);for(var b=['"'],c=0;c<a.length;c++){var d=a.charAt(c),e=d.charCodeAt(0);b[c+1]=goog.string.specialEscapeChars_[d]||(31<e&&127>e?d:goog.string.escapeChar(d));}b.push('"');return b.join("")};goog.string.escapeString=function(a){for(var b=[],c=0;c<a.length;c++)b[c]=goog.string.escapeChar(a.charAt(c));return b.join("")};
    goog.string.escapeChar=function(a){if(a in goog.string.jsEscapeCache_)return goog.string.jsEscapeCache_[a];if(a in goog.string.specialEscapeChars_)return goog.string.jsEscapeCache_[a]=goog.string.specialEscapeChars_[a];var b,c=a.charCodeAt(0);if(31<c&&127>c)b=a;else{if(256>c){if(b="\\x",16>c||256<c)b+="0";}else b="\\u",4096>c&&(b+="0");b+=c.toString(16).toUpperCase();}return goog.string.jsEscapeCache_[a]=b};goog.string.contains=function(a,b){return -1!=a.indexOf(b)};
    goog.string.caseInsensitiveContains=function(a,b){return goog.string.contains(a.toLowerCase(),b.toLowerCase())};goog.string.countOf=function(a,b){return a&&b?a.split(b).length-1:0};goog.string.removeAt=function(a,b,c){var d=a;0<=b&&b<a.length&&0<c&&(d=a.substr(0,b)+a.substr(b+c,a.length-b-c));return d};goog.string.remove=function(a,b){var c=new RegExp(goog.string.regExpEscape(b),"");return a.replace(c,"")};
    goog.string.removeAll=function(a,b){var c=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(c,"")};goog.string.regExpEscape=function(a){return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")};goog.string.repeat=String.prototype.repeat?function(a,b){return a.repeat(b)}:function(a,b){return Array(b+1).join(a)};
    goog.string.padNumber=function(a,b,c){a=goog.isDef(c)?a.toFixed(c):String(a);c=a.indexOf(".");-1==c&&(c=a.length);return goog.string.repeat("0",Math.max(0,b-c))+a};goog.string.makeSafe=function(a){return null==a?"":String(a)};goog.string.buildString=function(a){return Array.prototype.join.call(arguments,"")};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36)};
    goog.string.compareVersions=function(a,b){for(var c=0,d=goog.string.trim(String(a)).split("."),e=goog.string.trim(String(b)).split("."),f=Math.max(d.length,e.length),g=0;0==c&&g<f;g++){var h=d[g]||"",k=e[g]||"",l=RegExp("(\\d*)(\\D*)","g"),p=RegExp("(\\d*)(\\D*)","g");do{var m=l.exec(h)||["","",""],n=p.exec(k)||["","",""];if(0==m[0].length&&0==n[0].length)break;var c=0==m[1].length?0:parseInt(m[1],10),q=0==n[1].length?0:parseInt(n[1],10),c=goog.string.compareElements_(c,q)||goog.string.compareElements_(0==
    m[2].length,0==n[2].length)||goog.string.compareElements_(m[2],n[2]);}while(0==c)}return c};goog.string.compareElements_=function(a,b){return a<b?-1:a>b?1:0};goog.string.hashCode=function(a){for(var b=0,c=0;c<a.length;++c)b=31*b+a.charCodeAt(c)>>>0;return b};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;goog.string.createUniqueString=function(){return "goog_"+goog.string.uniqueStringCounter_++};
    goog.string.toNumber=function(a){var b=Number(a);return 0==b&&goog.string.isEmptyOrWhitespace(a)?NaN:b};goog.string.isLowerCamelCase=function(a){return /^[a-z]+([A-Z][a-z]*)*$/.test(a)};goog.string.isUpperCamelCase=function(a){return /^([A-Z][a-z]*)+$/.test(a)};goog.string.toCamelCase=function(a){return String(a).replace(/\-([a-z])/g,function(a,c){return c.toUpperCase()})};goog.string.toSelectorCase=function(a){return String(a).replace(/([A-Z])/g,"-$1").toLowerCase()};
    goog.string.toTitleCase=function(a,b){var c=goog.isString(b)?goog.string.regExpEscape(b):"\\s";return a.replace(new RegExp("(^"+(c?"|["+c+"]+":"")+")([a-z])","g"),function(a,b,c){return b+c.toUpperCase()})};goog.string.capitalize=function(a){return String(a.charAt(0)).toUpperCase()+String(a.substr(1)).toLowerCase()};goog.string.parseInt=function(a){isFinite(a)&&(a=String(a));return goog.isString(a)?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN};
    goog.string.splitLimit=function(a,b,c){a=a.split(b);for(var d=[];0<c&&a.length;)d.push(a.shift()),c--;a.length&&d.push(a.join(b));return d};goog.string.editDistance=function(a,b){var c=[],d=[];if(a==b)return 0;if(!a.length||!b.length)return Math.max(a.length,b.length);for(var e=0;e<b.length+1;e++)c[e]=e;for(e=0;e<a.length;e++){d[0]=e+1;for(var f=0;f<b.length;f++)d[f+1]=Math.min(d[f]+1,c[f+1]+1,c[f]+Number(a[e]!=b[f]));for(f=0;f<c.length;f++)c[f]=d[f];}return d[b.length]};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(a,b){b.unshift(a);goog.debug.Error.call(this,goog.string.subs.apply(null,b));b.shift();this.messagePattern=a;};goog.inherits(goog.asserts.AssertionError,goog.debug.Error);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(a){throw a;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;
    goog.asserts.doAssertFailure_=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);a=new goog.asserts.AssertionError(""+e,f||[]);goog.asserts.errorHandler_(a);};goog.asserts.setErrorHandler=function(a){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=a);};goog.asserts.assert=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!a&&goog.asserts.doAssertFailure_("",null,b,Array.prototype.slice.call(arguments,2));return a};
    goog.asserts.fail=function(a,b){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1)));};goog.asserts.assertNumber=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isNumber(a)&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
    goog.asserts.assertString=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isString(a)&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertFunction=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isFunction(a)&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
    goog.asserts.assertObject=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(a)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertArray=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isArray(a)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
    goog.asserts.assertBoolean=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isBoolean(a)&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertElement=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||goog.isObject(a)&&a.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
    goog.asserts.assertInstanceof=function(a,b,c,d){!goog.asserts.ENABLE_ASSERTS||a instanceof b||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(b),goog.asserts.getType_(a)],c,Array.prototype.slice.call(arguments,3));return a};goog.asserts.assertObjectPrototypeIsIntact=function(){for(var a in Object.prototype)goog.asserts.fail(a+" should not be enumerable in Object.prototype.");};
    goog.asserts.getType_=function(a){return a instanceof Function?a.displayName||a.name||"unknown type name":a instanceof Object?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):null===a?"null":typeof a};var jspb={Map:function(a,b){this.arr_=a;this.valueCtor_=b;this.map_={};this.arrClean=!0;0<this.arr_.length&&this.loadFromArray_();}};jspb.Map.prototype.loadFromArray_=function(){for(var a=0;a<this.arr_.length;a++){var b=this.arr_[a],c=b[0];this.map_[c.toString()]=new jspb.Map.Entry_(c,b[1]);}this.arrClean=!0;};
    jspb.Map.prototype.toArray=function(){if(this.arrClean){if(this.valueCtor_){var a=this.map_,b;for(b in a)if(Object.prototype.hasOwnProperty.call(a,b)){var c=a[b].valueWrapper;c&&c.toArray();}}}else{this.arr_.length=0;a=this.stringKeys_();a.sort();for(b=0;b<a.length;b++){var d=this.map_[a[b]];(c=d.valueWrapper)&&c.toArray();this.arr_.push([d.key,d.value]);}this.arrClean=!0;}return this.arr_};
    jspb.Map.prototype.toObject=function(a,b){for(var c=this.toArray(),d=[],e=0;e<c.length;e++){var f=this.map_[c[e][0].toString()];this.wrapEntry_(f);var g=f.valueWrapper;g?(goog.asserts.assert(b),d.push([f.key,b(a,g)])):d.push([f.key,f.value]);}return d};jspb.Map.fromObject=function(a,b,c){b=new jspb.Map([],b);for(var d=0;d<a.length;d++){var e=a[d][0],f=c(a[d][1]);b.set(e,f);}return b};jspb.Map.ArrayIteratorIterable_=function(a){this.idx_=0;this.arr_=a;};
    jspb.Map.ArrayIteratorIterable_.prototype.next=function(){return this.idx_<this.arr_.length?{done:!1,value:this.arr_[this.idx_++]}:{done:!0,value:void 0}};$jscomp.initSymbol();"undefined"!=typeof Symbol&&($jscomp.initSymbol(),$jscomp.initSymbolIterator(),jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator]=function(){return this});jspb.Map.prototype.getLength=function(){return this.stringKeys_().length};jspb.Map.prototype.clear=function(){this.map_={};this.arrClean=!1;};
    jspb.Map.prototype.del=function(a){a=a.toString();var b=this.map_.hasOwnProperty(a);delete this.map_[a];this.arrClean=!1;return b};jspb.Map.prototype.getEntryList=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++){var d=this.map_[b[c]];a.push([d.key,d.value]);}return a};jspb.Map.prototype.entries=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++){var d=this.map_[b[c]];a.push([d.key,this.wrapEntry_(d)]);}return new jspb.Map.ArrayIteratorIterable_(a)};
    jspb.Map.prototype.keys=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++)a.push(this.map_[b[c]].key);return new jspb.Map.ArrayIteratorIterable_(a)};jspb.Map.prototype.values=function(){var a=[],b=this.stringKeys_();b.sort();for(var c=0;c<b.length;c++)a.push(this.wrapEntry_(this.map_[b[c]]));return new jspb.Map.ArrayIteratorIterable_(a)};
    jspb.Map.prototype.forEach=function(a,b){var c=this.stringKeys_();c.sort();for(var d=0;d<c.length;d++){var e=this.map_[c[d]];a.call(b,this.wrapEntry_(e),e.key,this);}};jspb.Map.prototype.set=function(a,b){var c=new jspb.Map.Entry_(a);this.valueCtor_?(c.valueWrapper=b,c.value=b.toArray()):c.value=b;this.map_[a.toString()]=c;this.arrClean=!1;return this};jspb.Map.prototype.wrapEntry_=function(a){return this.valueCtor_?(a.valueWrapper||(a.valueWrapper=new this.valueCtor_(a.value)),a.valueWrapper):a.value};
    jspb.Map.prototype.get=function(a){if(a=this.map_[a.toString()])return this.wrapEntry_(a)};jspb.Map.prototype.has=function(a){return a.toString()in this.map_};jspb.Map.prototype.serializeBinary=function(a,b,c,d,e){var f=this.stringKeys_();f.sort();for(var g=0;g<f.length;g++){var h=this.map_[f[g]];b.beginSubMessage(a);c.call(b,1,h.key);this.valueCtor_?d.call(b,2,this.wrapEntry_(h),e):d.call(b,2,h.value);b.endSubMessage();}};
    jspb.Map.deserializeBinary=function(a,b,c,d,e,f){for(var g=void 0;b.nextField()&&!b.isEndGroup();){var h=b.getFieldNumber();1==h?f=c.call(b):2==h&&(a.valueCtor_?(goog.asserts.assert(e),g=new a.valueCtor_,d.call(b,g,e)):g=d.call(b));}goog.asserts.assert(void 0!=f);goog.asserts.assert(void 0!=g);a.set(f,g);};jspb.Map.prototype.stringKeys_=function(){var a=this.map_,b=[],c;for(c in a)Object.prototype.hasOwnProperty.call(a,c)&&b.push(c);return b};
    jspb.Map.Entry_=function(a,b){this.key=a;this.value=b;this.valueWrapper=void 0;};goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;goog.array.ASSUME_NATIVE_FUNCTIONS=!1;goog.array.peek=function(a){return a[a.length-1]};goog.array.last=goog.array.peek;
    goog.array.indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(goog.isString(a))return goog.isString(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return -1};
    goog.array.lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.lastIndexOf.call(a,b,null==c?a.length-1:c)}:function(a,b,c){c=null==c?a.length-1:c;0>c&&(c=Math.max(0,a.length+c));if(goog.isString(a))return goog.isString(b)&&1==b.length?a.lastIndexOf(b,c):-1;for(;0<=c;c--)if(c in a&&a[c]===b)return c;return -1};
    goog.array.forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(a,b,c){goog.asserts.assert(null!=a.length);Array.prototype.forEach.call(a,b,c);}:function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a);};goog.array.forEachRight=function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,d=d-1;0<=d;--d)d in e&&b.call(c,e[d],d,a);};
    goog.array.filter=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g=goog.isString(a)?a.split(""):a,h=0;h<d;h++)if(h in g){var k=g[h];b.call(c,k,h,a)&&(e[f++]=k);}return e};
    goog.array.map=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=goog.isString(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e};
    goog.array.reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(a,b,c,d){goog.asserts.assert(null!=a.length);d&&(b=goog.bind(b,d));return Array.prototype.reduce.call(a,b,c)}:function(a,b,c,d){var e=c;goog.array.forEach(a,function(c,g){e=b.call(d,e,c,g,a);});return e};
    goog.array.reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(a,b,c,d){goog.asserts.assert(null!=a.length);goog.asserts.assert(null!=b);d&&(b=goog.bind(b,d));return Array.prototype.reduceRight.call(a,b,c)}:function(a,b,c,d){var e=c;goog.array.forEachRight(a,function(c,g){e=b.call(d,e,c,g,a);});return e};
    goog.array.some=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return !0;return !1};
    goog.array.every=goog.NATIVE_ARRAY_PROTOTYPES&&(goog.array.ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return !1;return !0};goog.array.count=function(a,b,c){var d=0;goog.array.forEach(a,function(a,f,g){b.call(c,a,f,g)&&++d;},c);return d};
    goog.array.find=function(a,b,c){b=goog.array.findIndex(a,b,c);return 0>b?null:goog.isString(a)?a.charAt(b):a[b]};goog.array.findIndex=function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return -1};goog.array.findRight=function(a,b,c){b=goog.array.findIndexRight(a,b,c);return 0>b?null:goog.isString(a)?a.charAt(b):a[b]};
    goog.array.findIndexRight=function(a,b,c){for(var d=a.length,e=goog.isString(a)?a.split(""):a,d=d-1;0<=d;d--)if(d in e&&b.call(c,e[d],d,a))return d;return -1};goog.array.contains=function(a,b){return 0<=goog.array.indexOf(a,b)};goog.array.isEmpty=function(a){return 0==a.length};goog.array.clear=function(a){if(!goog.isArray(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0;};goog.array.insert=function(a,b){goog.array.contains(a,b)||a.push(b);};
    goog.array.insertAt=function(a,b,c){goog.array.splice(a,c,0,b);};goog.array.insertArrayAt=function(a,b,c){goog.partial(goog.array.splice,a,c,0).apply(null,b);};goog.array.insertBefore=function(a,b,c){var d;2==arguments.length||0>(d=goog.array.indexOf(a,c))?a.push(b):goog.array.insertAt(a,b,d);};goog.array.remove=function(a,b){var c=goog.array.indexOf(a,b),d;(d=0<=c)&&goog.array.removeAt(a,c);return d};
    goog.array.removeAt=function(a,b){goog.asserts.assert(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length};goog.array.removeIf=function(a,b,c){b=goog.array.findIndex(a,b,c);return 0<=b?(goog.array.removeAt(a,b),!0):!1};goog.array.removeAllIf=function(a,b,c){var d=0;goog.array.forEachRight(a,function(e,f){b.call(c,e,f,a)&&goog.array.removeAt(a,f)&&d++;});return d};goog.array.concat=function(a){return Array.prototype.concat.apply(Array.prototype,arguments)};
    goog.array.join=function(a){return Array.prototype.concat.apply(Array.prototype,arguments)};goog.array.toArray=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return []};goog.array.clone=goog.array.toArray;goog.array.extend=function(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(goog.isArrayLike(d)){var e=a.length||0,f=d.length||0;a.length=e+f;for(var g=0;g<f;g++)a[e+g]=d[g];}else a.push(d);}};
    goog.array.splice=function(a,b,c,d){goog.asserts.assert(null!=a.length);return Array.prototype.splice.apply(a,goog.array.slice(arguments,1))};goog.array.slice=function(a,b,c){goog.asserts.assert(null!=a.length);return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)};
    goog.array.removeDuplicates=function(a,b,c){b=b||a;var d=function(a){return goog.isObject(a)?"o"+goog.getUid(a):(typeof a).charAt(0)+a};c=c||d;for(var d={},e=0,f=0;f<a.length;){var g=a[f++],h=c(g);Object.prototype.hasOwnProperty.call(d,h)||(d[h]=!0,b[e++]=g);}b.length=e;};goog.array.binarySearch=function(a,b,c){return goog.array.binarySearch_(a,c||goog.array.defaultCompare,!1,b)};goog.array.binarySelect=function(a,b,c){return goog.array.binarySearch_(a,b,!0,void 0,c)};
    goog.array.binarySearch_=function(a,b,c,d,e){for(var f=0,g=a.length,h;f<g;){var k=f+g>>1,l;l=c?b.call(e,a[k],k,a):b(d,a[k]);0<l?f=k+1:(g=k,h=!l);}return h?f:~f};goog.array.sort=function(a,b){a.sort(b||goog.array.defaultCompare);};goog.array.stableSort=function(a,b){for(var c=0;c<a.length;c++)a[c]={index:c,value:a[c]};var d=b||goog.array.defaultCompare;goog.array.sort(a,function(a,b){return d(a.value,b.value)||a.index-b.index});for(c=0;c<a.length;c++)a[c]=a[c].value;};
    goog.array.sortByKey=function(a,b,c){var d=c||goog.array.defaultCompare;goog.array.sort(a,function(a,c){return d(b(a),b(c))});};goog.array.sortObjectsByKey=function(a,b,c){goog.array.sortByKey(a,function(a){return a[b]},c);};goog.array.isSorted=function(a,b,c){b=b||goog.array.defaultCompare;for(var d=1;d<a.length;d++){var e=b(a[d-1],a[d]);if(0<e||0==e&&c)return !1}return !0};
    goog.array.equals=function(a,b,c){if(!goog.isArrayLike(a)||!goog.isArrayLike(b)||a.length!=b.length)return !1;var d=a.length;c=c||goog.array.defaultCompareEquality;for(var e=0;e<d;e++)if(!c(a[e],b[e]))return !1;return !0};goog.array.compare3=function(a,b,c){c=c||goog.array.defaultCompare;for(var d=Math.min(a.length,b.length),e=0;e<d;e++){var f=c(a[e],b[e]);if(0!=f)return f}return goog.array.defaultCompare(a.length,b.length)};goog.array.defaultCompare=function(a,b){return a>b?1:a<b?-1:0};
    goog.array.inverseDefaultCompare=function(a,b){return -goog.array.defaultCompare(a,b)};goog.array.defaultCompareEquality=function(a,b){return a===b};goog.array.binaryInsert=function(a,b,c){c=goog.array.binarySearch(a,b,c);return 0>c?(goog.array.insertAt(a,b,-(c+1)),!0):!1};goog.array.binaryRemove=function(a,b,c){b=goog.array.binarySearch(a,b,c);return 0<=b?goog.array.removeAt(a,b):!1};
    goog.array.bucket=function(a,b,c){for(var d={},e=0;e<a.length;e++){var f=a[e],g=b.call(c,f,e,a);goog.isDef(g)&&(d[g]||(d[g]=[])).push(f);}return d};goog.array.toObject=function(a,b,c){var d={};goog.array.forEach(a,function(e,f){d[b.call(c,e,f,a)]=e;});return d};goog.array.range=function(a,b,c){var d=[],e=0,f=a;c=c||1;void 0!==b&&(e=a,f=b);if(0>c*(f-e))return [];if(0<c)for(a=e;a<f;a+=c)d.push(a);else for(a=e;a>f;a+=c)d.push(a);return d};
    goog.array.repeat=function(a,b){for(var c=[],d=0;d<b;d++)c[d]=a;return c};goog.array.flatten=function(a){for(var b=[],c=0;c<arguments.length;c++){var d=arguments[c];if(goog.isArray(d))for(var e=0;e<d.length;e+=8192)for(var f=goog.array.slice(d,e,e+8192),f=goog.array.flatten.apply(null,f),g=0;g<f.length;g++)b.push(f[g]);else b.push(d);}return b};
    goog.array.rotate=function(a,b){goog.asserts.assert(null!=a.length);a.length&&(b%=a.length,0<b?Array.prototype.unshift.apply(a,a.splice(-b,b)):0>b&&Array.prototype.push.apply(a,a.splice(0,-b)));return a};goog.array.moveItem=function(a,b,c){goog.asserts.assert(0<=b&&b<a.length);goog.asserts.assert(0<=c&&c<a.length);b=Array.prototype.splice.call(a,b,1);Array.prototype.splice.call(a,c,0,b[0]);};
    goog.array.zip=function(a){if(!arguments.length)return [];for(var b=[],c=arguments[0].length,d=1;d<arguments.length;d++)arguments[d].length<c&&(c=arguments[d].length);for(d=0;d<c;d++){for(var e=[],f=0;f<arguments.length;f++)e.push(arguments[f][d]);b.push(e);}return b};goog.array.shuffle=function(a,b){for(var c=b||Math.random,d=a.length-1;0<d;d--){var e=Math.floor(c()*(d+1)),f=a[d];a[d]=a[e];a[e]=f;}};goog.array.copyByIndex=function(a,b){var c=[];goog.array.forEach(b,function(b){c.push(a[b]);});return c};goog.crypt={};goog.crypt.stringToByteArray=function(a){for(var b=[],c=0,d=0;d<a.length;d++){for(var e=a.charCodeAt(d);255<e;)b[c++]=e&255,e>>=8;b[c++]=e;}return b};goog.crypt.byteArrayToString=function(a){if(8192>=a.length)return String.fromCharCode.apply(null,a);for(var b="",c=0;c<a.length;c+=8192)var d=goog.array.slice(a,c,c+8192),b=b+String.fromCharCode.apply(null,d);return b};goog.crypt.byteArrayToHex=function(a){return goog.array.map(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};
    goog.crypt.hexToByteArray=function(a){goog.asserts.assert(0==a.length%2,"Key string length must be multiple of 2");for(var b=[],c=0;c<a.length;c+=2)b.push(parseInt(a.substring(c,c+2),16));return b};
    goog.crypt.stringToUtf8ByteArray=function(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(55296==(e&64512)&&d+1<a.length&&56320==(a.charCodeAt(d+1)&64512)?(e=65536+((e&1023)<<10)+(a.charCodeAt(++d)&1023),b[c++]=e>>18|240,b[c++]=e>>12&63|128):b[c++]=e>>12|224,b[c++]=e>>6&63|128),b[c++]=e&63|128);}return b};
    goog.crypt.utf8ByteArrayToString=function(a){for(var b=[],c=0,d=0;c<a.length;){var e=a[c++];if(128>e)b[d++]=String.fromCharCode(e);else if(191<e&&224>e){var f=a[c++];b[d++]=String.fromCharCode((e&31)<<6|f&63);}else if(239<e&&365>e){var f=a[c++],g=a[c++],h=a[c++],e=((e&7)<<18|(f&63)<<12|(g&63)<<6|h&63)-65536;b[d++]=String.fromCharCode(55296+(e>>10));b[d++]=String.fromCharCode(56320+(e&1023));}else f=a[c++],g=a[c++],b[d++]=String.fromCharCode((e&15)<<12|(f&63)<<6|g&63);}return b.join("")};
    goog.crypt.xorByteArray=function(a,b){goog.asserts.assert(a.length==b.length,"XOR array lengths must match");for(var c=[],d=0;d<a.length;d++)c.push(a[d]^b[d]);return c};goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var a=goog.labs.userAgent.util.getNavigator_();return a&&(a=a.userAgent)?a:""};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(a){goog.labs.userAgent.util.userAgent_=a||goog.labs.userAgent.util.getNativeUserAgentString_();};
    goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_};goog.labs.userAgent.util.matchUserAgent=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.contains(b,a)};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.caseInsensitiveContains(b,a)};
    goog.labs.userAgent.util.extractVersionTuples=function(a){for(var b=RegExp("(\\w[\\w ]+)/([^\\s]+)\\s*(?:\\((.*?)\\))?","g"),c=[],d;d=b.exec(a);)c.push([d[1],d[2],d[3]||void 0]);return c};goog.labs.userAgent.platform={};goog.labs.userAgent.platform.isAndroid=function(){return goog.labs.userAgent.util.matchUserAgent("Android")};goog.labs.userAgent.platform.isIpod=function(){return goog.labs.userAgent.util.matchUserAgent("iPod")};goog.labs.userAgent.platform.isIphone=function(){return goog.labs.userAgent.util.matchUserAgent("iPhone")&&!goog.labs.userAgent.util.matchUserAgent("iPod")&&!goog.labs.userAgent.util.matchUserAgent("iPad")};goog.labs.userAgent.platform.isIpad=function(){return goog.labs.userAgent.util.matchUserAgent("iPad")};
    goog.labs.userAgent.platform.isIos=function(){return goog.labs.userAgent.platform.isIphone()||goog.labs.userAgent.platform.isIpad()||goog.labs.userAgent.platform.isIpod()};goog.labs.userAgent.platform.isMacintosh=function(){return goog.labs.userAgent.util.matchUserAgent("Macintosh")};goog.labs.userAgent.platform.isLinux=function(){return goog.labs.userAgent.util.matchUserAgent("Linux")};goog.labs.userAgent.platform.isWindows=function(){return goog.labs.userAgent.util.matchUserAgent("Windows")};
    goog.labs.userAgent.platform.isChromeOS=function(){return goog.labs.userAgent.util.matchUserAgent("CrOS")};
    goog.labs.userAgent.platform.getVersion=function(){var a=goog.labs.userAgent.util.getUserAgent(),b="";goog.labs.userAgent.platform.isWindows()?(b=/Windows (?:NT|Phone) ([0-9.]+)/,b=(a=b.exec(a))?a[1]:"0.0"):goog.labs.userAgent.platform.isIos()?(b=/(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/,b=(a=b.exec(a))&&a[1].replace(/_/g,".")):goog.labs.userAgent.platform.isMacintosh()?(b=/Mac OS X ([0-9_.]+)/,b=(a=b.exec(a))?a[1].replace(/_/g,"."):"10"):goog.labs.userAgent.platform.isAndroid()?(b=/Android\s+([^\);]+)(\)|;)/,
    b=(a=b.exec(a))&&a[1]):goog.labs.userAgent.platform.isChromeOS()&&(b=/(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/,b=(a=b.exec(a))&&a[1]);return b||""};goog.labs.userAgent.platform.isVersionOrHigher=function(a){return 0<=goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(),a)};goog.object={};goog.object.forEach=function(a,b,c){for(var d in a)b.call(c,a[d],d,a);};goog.object.filter=function(a,b,c){var d={},e;for(e in a)b.call(c,a[e],e,a)&&(d[e]=a[e]);return d};goog.object.map=function(a,b,c){var d={},e;for(e in a)d[e]=b.call(c,a[e],e,a);return d};goog.object.some=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return !0;return !1};goog.object.every=function(a,b,c){for(var d in a)if(!b.call(c,a[d],d,a))return !1;return !0};
    goog.object.getCount=function(a){var b=0,c;for(c in a)b++;return b};goog.object.getAnyKey=function(a){for(var b in a)return b};goog.object.getAnyValue=function(a){for(var b in a)return a[b]};goog.object.contains=function(a,b){return goog.object.containsValue(a,b)};goog.object.getValues=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b};goog.object.getKeys=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b};
    goog.object.getValueByKeys=function(a,b){for(var c=goog.isArrayLike(b),d=c?b:arguments,c=c?0:1;c<d.length&&(a=a[d[c]],goog.isDef(a));c++);return a};goog.object.containsKey=function(a,b){return null!==a&&b in a};goog.object.containsValue=function(a,b){for(var c in a)if(a[c]==b)return !0;return !1};goog.object.findKey=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d};goog.object.findValue=function(a,b,c){return (b=goog.object.findKey(a,b,c))&&a[b]};
    goog.object.isEmpty=function(a){for(var b in a)return !1;return !0};goog.object.clear=function(a){for(var b in a)delete a[b];};goog.object.remove=function(a,b){var c;(c=b in a)&&delete a[b];return c};goog.object.add=function(a,b,c){if(null!==a&&b in a)throw Error('The object already contains the key "'+b+'"');goog.object.set(a,b,c);};goog.object.get=function(a,b,c){return null!==a&&b in a?a[b]:c};goog.object.set=function(a,b,c){a[b]=c;};
    goog.object.setIfUndefined=function(a,b,c){return b in a?a[b]:a[b]=c};goog.object.setWithReturnValueIfNotSet=function(a,b,c){if(b in a)return a[b];c=c();return a[b]=c};goog.object.equals=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return !1;for(c in b)if(!(c in a))return !1;return !0};goog.object.clone=function(a){var b={},c;for(c in a)b[c]=a[c];return b};
    goog.object.unsafeClone=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if(goog.isFunction(a.clone))return a.clone();var b="array"==b?[]:{},c;for(c in a)b[c]=goog.object.unsafeClone(a[c]);return b}return a};goog.object.transpose=function(a){var b={},c;for(c in a)b[a[c]]=c;return b};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    goog.object.extend=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<goog.object.PROTOTYPE_FIELDS_.length;f++)c=goog.object.PROTOTYPE_FIELDS_[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c]);}};
    goog.object.create=function(a){var b=arguments.length;if(1==b&&goog.isArray(arguments[0]))return goog.object.create.apply(null,arguments[0]);if(b%2)throw Error("Uneven number of arguments");for(var c={},d=0;d<b;d+=2)c[arguments[d]]=arguments[d+1];return c};goog.object.createSet=function(a){var b=arguments.length;if(1==b&&goog.isArray(arguments[0]))return goog.object.createSet.apply(null,arguments[0]);for(var c={},d=0;d<b;d++)c[arguments[d]]=!0;return c};
    goog.object.createImmutableView=function(a){var b=a;Object.isFrozen&&!Object.isFrozen(a)&&(b=Object.create(a),Object.freeze(b));return b};goog.object.isImmutableView=function(a){return !!Object.isFrozen&&Object.isFrozen(a)};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera")||goog.labs.userAgent.util.matchUserAgent("OPR")};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.browser.matchEdge_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox")};
    goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdge_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"))};goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast")};
    goog.labs.userAgent.browser.matchIosWebview_=function(){return (goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit")};
    goog.labs.userAgent.browser.matchChrome_=function(){return (goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchOpera_()&&!goog.labs.userAgent.browser.matchEdge_()};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk())};
    goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdge_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;
    goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk")};
    goog.labs.userAgent.browser.getVersion=function(){function a(a){a=goog.array.find(a,d);return c[a]||""}var b=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE())return goog.labs.userAgent.browser.getIEVersion_(b);var b=goog.labs.userAgent.util.extractVersionTuples(b),c={};goog.array.forEach(b,function(a){c[a[0]]=a[1];});var d=goog.partial(goog.object.containsKey,c);return goog.labs.userAgent.browser.isOpera()?a(["Version","Opera","OPR"]):goog.labs.userAgent.browser.isEdge()?
    a(["Edge"]):goog.labs.userAgent.browser.isChrome()?a(["Chrome","CriOS"]):(b=b[2])&&b[1]||""};goog.labs.userAgent.browser.isVersionOrHigher=function(a){return 0<=goog.string.compareVersions(goog.labs.userAgent.browser.getVersion(),a)};
    goog.labs.userAgent.browser.getIEVersion_=function(a){var b=/rv: *([\d\.]*)/.exec(a);if(b&&b[1])return b[1];var b="",c=/MSIE +([\d\.]+)/.exec(a);if(c&&c[1])if(a=/Trident\/(\d.\d)/.exec(a),"7.0"==c[1])if(a&&a[1])switch(a[1]){case "4.0":b="8.0";break;case "5.0":b="9.0";break;case "6.0":b="10.0";break;case "7.0":b="11.0";}else b="7.0";else b=c[1];return b};goog.labs.userAgent.engine={};goog.labs.userAgent.engine.isPresto=function(){return goog.labs.userAgent.util.matchUserAgent("Presto")};goog.labs.userAgent.engine.isTrident=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.engine.isEdge=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};
    goog.labs.userAgent.engine.isWebKit=function(){return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit")&&!goog.labs.userAgent.engine.isEdge()};goog.labs.userAgent.engine.isGecko=function(){return goog.labs.userAgent.util.matchUserAgent("Gecko")&&!goog.labs.userAgent.engine.isWebKit()&&!goog.labs.userAgent.engine.isTrident()&&!goog.labs.userAgent.engine.isEdge()};
    goog.labs.userAgent.engine.getVersion=function(){var a=goog.labs.userAgent.util.getUserAgent();if(a){var a=goog.labs.userAgent.util.extractVersionTuples(a),b=goog.labs.userAgent.engine.getEngineTuple_(a);if(b)return "Gecko"==b[0]?goog.labs.userAgent.engine.getVersionForKey_(a,"Firefox"):b[1];var a=a[0],c;if(a&&(c=a[2])&&(c=/Trident\/([^\s;]+)/.exec(c)))return c[1]}return ""};
    goog.labs.userAgent.engine.getEngineTuple_=function(a){if(!goog.labs.userAgent.engine.isEdge())return a[1];for(var b=0;b<a.length;b++){var c=a[b];if("Edge"==c[0])return c}};goog.labs.userAgent.engine.isVersionOrHigher=function(a){return 0<=goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(),a)};goog.labs.userAgent.engine.getVersionForKey_=function(a,b){var c=goog.array.find(a,function(a){return b==a[0]});return c&&c[1]||""};goog.userAgent={};goog.userAgent.ASSUME_IE=!1;goog.userAgent.ASSUME_EDGE=!1;goog.userAgent.ASSUME_GECKO=!1;goog.userAgent.ASSUME_WEBKIT=!1;goog.userAgent.ASSUME_MOBILE_WEBKIT=!1;goog.userAgent.ASSUME_OPERA=!1;goog.userAgent.ASSUME_ANY_VERSION=!1;goog.userAgent.BROWSER_KNOWN_=goog.userAgent.ASSUME_IE||goog.userAgent.ASSUME_EDGE||goog.userAgent.ASSUME_GECKO||goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_OPERA;goog.userAgent.getUserAgentString=function(){return goog.labs.userAgent.util.getUserAgent()};
    goog.userAgent.getNavigator=function(){return goog.global.navigator||null};goog.userAgent.OPERA=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_OPERA:goog.labs.userAgent.browser.isOpera();goog.userAgent.IE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_IE:goog.labs.userAgent.browser.isIE();goog.userAgent.EDGE=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_EDGE:goog.labs.userAgent.engine.isEdge();goog.userAgent.EDGE_OR_IE=goog.userAgent.EDGE||goog.userAgent.IE;
    goog.userAgent.GECKO=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_GECKO:goog.labs.userAgent.engine.isGecko();goog.userAgent.WEBKIT=goog.userAgent.BROWSER_KNOWN_?goog.userAgent.ASSUME_WEBKIT||goog.userAgent.ASSUME_MOBILE_WEBKIT:goog.labs.userAgent.engine.isWebKit();goog.userAgent.isMobile_=function(){return goog.userAgent.WEBKIT&&goog.labs.userAgent.util.matchUserAgent("Mobile")};goog.userAgent.MOBILE=goog.userAgent.ASSUME_MOBILE_WEBKIT||goog.userAgent.isMobile_();goog.userAgent.SAFARI=goog.userAgent.WEBKIT;
    goog.userAgent.determinePlatform_=function(){var a=goog.userAgent.getNavigator();return a&&a.platform||""};goog.userAgent.PLATFORM=goog.userAgent.determinePlatform_();goog.userAgent.ASSUME_MAC=!1;goog.userAgent.ASSUME_WINDOWS=!1;goog.userAgent.ASSUME_LINUX=!1;goog.userAgent.ASSUME_X11=!1;goog.userAgent.ASSUME_ANDROID=!1;goog.userAgent.ASSUME_IPHONE=!1;goog.userAgent.ASSUME_IPAD=!1;
    goog.userAgent.PLATFORM_KNOWN_=goog.userAgent.ASSUME_MAC||goog.userAgent.ASSUME_WINDOWS||goog.userAgent.ASSUME_LINUX||goog.userAgent.ASSUME_X11||goog.userAgent.ASSUME_ANDROID||goog.userAgent.ASSUME_IPHONE||goog.userAgent.ASSUME_IPAD;goog.userAgent.MAC=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_MAC:goog.labs.userAgent.platform.isMacintosh();goog.userAgent.WINDOWS=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_WINDOWS:goog.labs.userAgent.platform.isWindows();
    goog.userAgent.isLegacyLinux_=function(){return goog.labs.userAgent.platform.isLinux()||goog.labs.userAgent.platform.isChromeOS()};goog.userAgent.LINUX=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_LINUX:goog.userAgent.isLegacyLinux_();goog.userAgent.isX11_=function(){var a=goog.userAgent.getNavigator();return !!a&&goog.string.contains(a.appVersion||"","X11")};goog.userAgent.X11=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_X11:goog.userAgent.isX11_();
    goog.userAgent.ANDROID=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_ANDROID:goog.labs.userAgent.platform.isAndroid();goog.userAgent.IPHONE=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPHONE:goog.labs.userAgent.platform.isIphone();goog.userAgent.IPAD=goog.userAgent.PLATFORM_KNOWN_?goog.userAgent.ASSUME_IPAD:goog.labs.userAgent.platform.isIpad();goog.userAgent.operaVersion_=function(){var a=goog.global.opera.version;try{return a()}catch(b){return a}};
    goog.userAgent.determineVersion_=function(){if(goog.userAgent.OPERA&&goog.global.opera)return goog.userAgent.operaVersion_();var a="",b=goog.userAgent.getVersionRegexResult_();b&&(a=b?b[1]:"");return goog.userAgent.IE&&(b=goog.userAgent.getDocumentMode_(),b>parseFloat(a))?String(b):a};
    goog.userAgent.getVersionRegexResult_=function(){var a=goog.userAgent.getUserAgentString();if(goog.userAgent.GECKO)return /rv\:([^\);]+)(\)|;)/.exec(a);if(goog.userAgent.EDGE)return /Edge\/([\d\.]+)/.exec(a);if(goog.userAgent.IE)return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(goog.userAgent.WEBKIT)return /WebKit\/(\S+)/.exec(a)};goog.userAgent.getDocumentMode_=function(){var a=goog.global.document;return a?a.documentMode:void 0};goog.userAgent.VERSION=goog.userAgent.determineVersion_();
    goog.userAgent.compare=function(a,b){return goog.string.compareVersions(a,b)};goog.userAgent.isVersionOrHigherCache_={};goog.userAgent.isVersionOrHigher=function(a){return goog.userAgent.ASSUME_ANY_VERSION||goog.userAgent.isVersionOrHigherCache_[a]||(goog.userAgent.isVersionOrHigherCache_[a]=0<=goog.string.compareVersions(goog.userAgent.VERSION,a))};goog.userAgent.isVersion=goog.userAgent.isVersionOrHigher;
    goog.userAgent.isDocumentModeOrHigher=function(a){return Number(goog.userAgent.DOCUMENT_MODE)>=a};goog.userAgent.isDocumentMode=goog.userAgent.isDocumentModeOrHigher;goog.userAgent.DOCUMENT_MODE=function(){var a=goog.global.document,b=goog.userAgent.getDocumentMode_();return a&&goog.userAgent.IE?b||("CSS1Compat"==a.compatMode?parseInt(goog.userAgent.VERSION,10):5):void 0}();goog.userAgent.product={};goog.userAgent.product.ASSUME_FIREFOX=!1;goog.userAgent.product.ASSUME_IPHONE=!1;goog.userAgent.product.ASSUME_IPAD=!1;goog.userAgent.product.ASSUME_ANDROID=!1;goog.userAgent.product.ASSUME_CHROME=!1;goog.userAgent.product.ASSUME_SAFARI=!1;
    goog.userAgent.product.PRODUCT_KNOWN_=goog.userAgent.ASSUME_IE||goog.userAgent.ASSUME_EDGE||goog.userAgent.ASSUME_OPERA||goog.userAgent.product.ASSUME_FIREFOX||goog.userAgent.product.ASSUME_IPHONE||goog.userAgent.product.ASSUME_IPAD||goog.userAgent.product.ASSUME_ANDROID||goog.userAgent.product.ASSUME_CHROME||goog.userAgent.product.ASSUME_SAFARI;goog.userAgent.product.OPERA=goog.userAgent.OPERA;goog.userAgent.product.IE=goog.userAgent.IE;goog.userAgent.product.EDGE=goog.userAgent.EDGE;
    goog.userAgent.product.FIREFOX=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_FIREFOX:goog.labs.userAgent.browser.isFirefox();goog.userAgent.product.isIphoneOrIpod_=function(){return goog.labs.userAgent.platform.isIphone()||goog.labs.userAgent.platform.isIpod()};goog.userAgent.product.IPHONE=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_IPHONE:goog.userAgent.product.isIphoneOrIpod_();
    goog.userAgent.product.IPAD=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_IPAD:goog.labs.userAgent.platform.isIpad();goog.userAgent.product.ANDROID=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_ANDROID:goog.labs.userAgent.browser.isAndroidBrowser();goog.userAgent.product.CHROME=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_CHROME:goog.labs.userAgent.browser.isChrome();
    goog.userAgent.product.isSafariDesktop_=function(){return goog.labs.userAgent.browser.isSafari()&&!goog.labs.userAgent.platform.isIos()};goog.userAgent.product.SAFARI=goog.userAgent.product.PRODUCT_KNOWN_?goog.userAgent.product.ASSUME_SAFARI:goog.userAgent.product.isSafariDesktop_();goog.crypt.base64={};goog.crypt.base64.byteToCharMap_=null;goog.crypt.base64.charToByteMap_=null;goog.crypt.base64.byteToCharMapWebSafe_=null;goog.crypt.base64.ENCODED_VALS_BASE="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";goog.crypt.base64.ENCODED_VALS=goog.crypt.base64.ENCODED_VALS_BASE+"+/=";goog.crypt.base64.ENCODED_VALS_WEBSAFE=goog.crypt.base64.ENCODED_VALS_BASE+"-_.";
    goog.crypt.base64.ASSUME_NATIVE_SUPPORT_=goog.userAgent.GECKO||goog.userAgent.WEBKIT&&!goog.userAgent.product.SAFARI||goog.userAgent.OPERA;goog.crypt.base64.HAS_NATIVE_ENCODE_=goog.crypt.base64.ASSUME_NATIVE_SUPPORT_||"function"==typeof goog.global.btoa;goog.crypt.base64.HAS_NATIVE_DECODE_=goog.crypt.base64.ASSUME_NATIVE_SUPPORT_||!goog.userAgent.product.SAFARI&&!goog.userAgent.IE&&"function"==typeof goog.global.atob;
    goog.crypt.base64.encodeByteArray=function(a,b){goog.asserts.assert(goog.isArrayLike(a),"encodeByteArray takes an array as a parameter");goog.crypt.base64.init_();for(var c=b?goog.crypt.base64.byteToCharMapWebSafe_:goog.crypt.base64.byteToCharMap_,d=[],e=0;e<a.length;e+=3){var f=a[e],g=e+1<a.length,h=g?a[e+1]:0,k=e+2<a.length,l=k?a[e+2]:0,p=f>>2,f=(f&3)<<4|h>>4,h=(h&15)<<2|l>>6,l=l&63;k||(l=64,g||(h=64));d.push(c[p],c[f],c[h],c[l]);}return d.join("")};
    goog.crypt.base64.encodeString=function(a,b){return goog.crypt.base64.HAS_NATIVE_ENCODE_&&!b?goog.global.btoa(a):goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a),b)};goog.crypt.base64.decodeString=function(a,b){if(goog.crypt.base64.HAS_NATIVE_DECODE_&&!b)return goog.global.atob(a);var c="";goog.crypt.base64.decodeStringInternal_(a,function(a){c+=String.fromCharCode(a);});return c};
    goog.crypt.base64.decodeStringToByteArray=function(a,b){var c=[];goog.crypt.base64.decodeStringInternal_(a,function(a){c.push(a);});return c};goog.crypt.base64.decodeStringToUint8Array=function(a){goog.asserts.assert(!goog.userAgent.IE||goog.userAgent.isVersionOrHigher("10"),"Browser does not support typed arrays");var b=new Uint8Array(Math.ceil(3*a.length/4)),c=0;goog.crypt.base64.decodeStringInternal_(a,function(a){b[c++]=a;});return b.subarray(0,c)};
    goog.crypt.base64.decodeStringInternal_=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=goog.crypt.base64.charToByteMap_[c];if(null!=e)return e;if(!goog.string.isEmptyOrWhitespace(c))throw Error("Unknown base64 encoding at char: "+c);}return b}goog.crypt.base64.init_();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h));}};
    goog.crypt.base64.init_=function(){if(!goog.crypt.base64.byteToCharMap_){goog.crypt.base64.byteToCharMap_={};goog.crypt.base64.charToByteMap_={};goog.crypt.base64.byteToCharMapWebSafe_={};for(var a=0;a<goog.crypt.base64.ENCODED_VALS.length;a++)goog.crypt.base64.byteToCharMap_[a]=goog.crypt.base64.ENCODED_VALS.charAt(a),goog.crypt.base64.charToByteMap_[goog.crypt.base64.byteToCharMap_[a]]=a,goog.crypt.base64.byteToCharMapWebSafe_[a]=goog.crypt.base64.ENCODED_VALS_WEBSAFE.charAt(a),a>=goog.crypt.base64.ENCODED_VALS_BASE.length&&
    (goog.crypt.base64.charToByteMap_[goog.crypt.base64.ENCODED_VALS_WEBSAFE.charAt(a)]=a);}};jspb.ExtensionFieldInfo=function(a,b,c,d,e){this.fieldIndex=a;this.fieldName=b;this.ctor=c;this.toObjectFn=d;this.isRepeated=e;};jspb.ExtensionFieldBinaryInfo=function(a,b,c,d,e,f){this.fieldInfo=a;this.binaryReaderFn=b;this.binaryWriterFn=c;this.binaryMessageSerializeFn=d;this.binaryMessageDeserializeFn=e;this.isPacked=f;};jspb.ExtensionFieldInfo.prototype.isMessageType=function(){return !!this.ctor};jspb.Message=function(){};jspb.Message.GENERATE_TO_OBJECT=!0;jspb.Message.GENERATE_FROM_OBJECT=!goog.DISALLOW_TEST_ONLY_CODE;
    jspb.Message.GENERATE_TO_STRING=!0;jspb.Message.ASSUME_LOCAL_ARRAYS=!1;jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS=!0;jspb.Message.SUPPORTS_UINT8ARRAY_="function"==typeof Uint8Array;jspb.Message.prototype.getJsPbMessageId=function(){return this.messageId_};jspb.Message.getIndex_=function(a,b){return b+a.arrayIndexOffset_};jspb.Message.getFieldNumber_=function(a,b){return b-a.arrayIndexOffset_};
    jspb.Message.initialize=function(a,b,c,d,e,f){a.wrappers_=null;b||(b=c?[c]:[]);a.messageId_=c?String(c):void 0;a.arrayIndexOffset_=0===c?-1:0;a.array=b;jspb.Message.initPivotAndExtensionObject_(a,d);a.convertedFloatingPointFields_={};jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS||(a.repeatedFields=e);if(e)for(b=0;b<e.length;b++)c=e[b],c<a.pivot_?(c=jspb.Message.getIndex_(a,c),a.array[c]=a.array[c]||jspb.Message.EMPTY_LIST_SENTINEL_):(jspb.Message.maybeInitEmptyExtensionObject_(a),a.extensionObject_[c]=
    a.extensionObject_[c]||jspb.Message.EMPTY_LIST_SENTINEL_);if(f&&f.length)for(b=0;b<f.length;b++)jspb.Message.computeOneofCase(a,f[b]);};jspb.Message.EMPTY_LIST_SENTINEL_=goog.DEBUG&&Object.freeze?Object.freeze([]):[];jspb.Message.isArray_=function(a){return jspb.Message.ASSUME_LOCAL_ARRAYS?a instanceof Array:goog.isArray(a)};
    jspb.Message.initPivotAndExtensionObject_=function(a,b){if(a.array.length){var c=a.array.length-1,d=a.array[c];if(d&&"object"==typeof d&&!jspb.Message.isArray_(d)&&!(jspb.Message.SUPPORTS_UINT8ARRAY_&&d instanceof Uint8Array)){a.pivot_=jspb.Message.getFieldNumber_(a,c);a.extensionObject_=d;return}}-1<b?(a.pivot_=b,a.extensionObject_=null):a.pivot_=Number.MAX_VALUE;};
    jspb.Message.maybeInitEmptyExtensionObject_=function(a){var b=jspb.Message.getIndex_(a,a.pivot_);a.array[b]||(a.extensionObject_=a.array[b]={});};jspb.Message.toObjectList=function(a,b,c){for(var d=[],e=0;e<a.length;e++)d[e]=b.call(a[e],c,a[e]);return d};
    jspb.Message.toObjectExtension=function(a,b,c,d,e){for(var f in c){var g=c[f],h=d.call(a,g);if(null!=h){for(var k in g.fieldName)if(g.fieldName.hasOwnProperty(k))break;b[k]=g.toObjectFn?g.isRepeated?jspb.Message.toObjectList(h,g.toObjectFn,e):g.toObjectFn(e,h):h;}}};
    jspb.Message.serializeBinaryExtensions=function(a,b,c,d){for(var e in c){var f=c[e],g=f.fieldInfo;if(!f.binaryWriterFn)throw Error("Message extension present that was generated without binary serialization support");var h=d.call(a,g);if(null!=h)if(g.isMessageType())if(f.binaryMessageSerializeFn)f.binaryWriterFn.call(b,g.fieldIndex,h,f.binaryMessageSerializeFn);else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
    else f.binaryWriterFn.call(b,g.fieldIndex,h);}};jspb.Message.readBinaryExtension=function(a,b,c,d,e){var f=c[b.getFieldNumber()];if(f){c=f.fieldInfo;if(!f.binaryReaderFn)throw Error("Deserializing extension whose generated code does not support binary format");var g;c.isMessageType()?(g=new c.ctor,f.binaryReaderFn.call(b,g,f.binaryMessageDeserializeFn)):g=f.binaryReaderFn.call(b);c.isRepeated&&!f.isPacked?(b=d.call(a,c))?b.push(g):e.call(a,c,[g]):e.call(a,c,g);}else b.skipField();};
    jspb.Message.getField=function(a,b){if(b<a.pivot_){var c=jspb.Message.getIndex_(a,b),d=a.array[c];return d===jspb.Message.EMPTY_LIST_SENTINEL_?a.array[c]=[]:d}if(a.extensionObject_)return d=a.extensionObject_[b],d===jspb.Message.EMPTY_LIST_SENTINEL_?a.extensionObject_[b]=[]:d};
    jspb.Message.getRepeatedField=function(a,b){if(b<a.pivot_){var c=jspb.Message.getIndex_(a,b),d=a.array[c];return d===jspb.Message.EMPTY_LIST_SENTINEL_?a.array[c]=[]:d}d=a.extensionObject_[b];return d===jspb.Message.EMPTY_LIST_SENTINEL_?a.extensionObject_[b]=[]:d};jspb.Message.getOptionalFloatingPointField=function(a,b){var c=jspb.Message.getField(a,b);return null==c?c:+c};
    jspb.Message.getRepeatedFloatingPointField=function(a,b){var c=jspb.Message.getRepeatedField(a,b);a.convertedFloatingPointFields_||(a.convertedFloatingPointFields_={});if(!a.convertedFloatingPointFields_[b]){for(var d=0;d<c.length;d++)c[d]=+c[d];a.convertedFloatingPointFields_[b]=!0;}return c};
    jspb.Message.bytesAsB64=function(a){if(null==a||goog.isString(a))return a;if(jspb.Message.SUPPORTS_UINT8ARRAY_&&a instanceof Uint8Array)return goog.crypt.base64.encodeByteArray(a);goog.asserts.fail("Cannot coerce to b64 string: "+goog.typeOf(a));return null};jspb.Message.bytesAsU8=function(a){if(null==a||a instanceof Uint8Array)return a;if(goog.isString(a))return goog.crypt.base64.decodeStringToUint8Array(a);goog.asserts.fail("Cannot coerce to Uint8Array: "+goog.typeOf(a));return null};
    jspb.Message.bytesListAsB64=function(a){jspb.Message.assertConsistentTypes_(a);return !a.length||goog.isString(a[0])?a:goog.array.map(a,jspb.Message.bytesAsB64)};jspb.Message.bytesListAsU8=function(a){jspb.Message.assertConsistentTypes_(a);return !a.length||a[0]instanceof Uint8Array?a:goog.array.map(a,jspb.Message.bytesAsU8)};
    jspb.Message.assertConsistentTypes_=function(a){if(goog.DEBUG&&a&&1<a.length){var b=goog.typeOf(a[0]);goog.array.forEach(a,function(a){goog.typeOf(a)!=b&&goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got "+goog.typeOf(a)+" expected "+b);});}};jspb.Message.getFieldWithDefault=function(a,b,c){a=jspb.Message.getField(a,b);return null==a?c:a};jspb.Message.getFieldProto3=jspb.Message.getFieldWithDefault;
    jspb.Message.getMapField=function(a,b,c,d){a.wrappers_||(a.wrappers_={});if(b in a.wrappers_)return a.wrappers_[b];if(!c)return c=jspb.Message.getField(a,b),c||(c=[],jspb.Message.setField(a,b,c)),a.wrappers_[b]=new jspb.Map(c,d)};jspb.Message.setField=function(a,b,c){b<a.pivot_?a.array[jspb.Message.getIndex_(a,b)]=c:(jspb.Message.maybeInitEmptyExtensionObject_(a),a.extensionObject_[b]=c);};jspb.Message.setProto3IntField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,0);};
    jspb.Message.setProto3StringIntField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,"0");};jspb.Message.setProto3FloatField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,0);};jspb.Message.setProto3BooleanField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,!1);};jspb.Message.setProto3StringField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,"");};jspb.Message.setProto3BytesField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,"");};
    jspb.Message.setProto3EnumField=function(a,b,c){jspb.Message.setFieldIgnoringDefault_(a,b,c,0);};jspb.Message.setFieldIgnoringDefault_=function(a,b,c,d){c!=d?jspb.Message.setField(a,b,c):a.array[jspb.Message.getIndex_(a,b)]=null;};jspb.Message.addToRepeatedField=function(a,b,c,d){a=jspb.Message.getRepeatedField(a,b);void 0!=d?a.splice(d,0,c):a.push(c);};
    jspb.Message.setOneofField=function(a,b,c,d){(c=jspb.Message.computeOneofCase(a,c))&&c!==b&&void 0!==d&&(a.wrappers_&&c in a.wrappers_&&(a.wrappers_[c]=void 0),jspb.Message.setField(a,c,void 0));jspb.Message.setField(a,b,d);};jspb.Message.computeOneofCase=function(a,b){for(var c,d,e=0;e<b.length;e++){var f=b[e],g=jspb.Message.getField(a,f);null!=g&&(c=f,d=g,jspb.Message.setField(a,f,void 0));}return c?(jspb.Message.setField(a,c,d),c):0};
    jspb.Message.getWrapperField=function(a,b,c,d){a.wrappers_||(a.wrappers_={});if(!a.wrappers_[c]){var e=jspb.Message.getField(a,c);if(d||e)a.wrappers_[c]=new b(e);}return a.wrappers_[c]};jspb.Message.getRepeatedWrapperField=function(a,b,c){jspb.Message.wrapRepeatedField_(a,b,c);b=a.wrappers_[c];b==jspb.Message.EMPTY_LIST_SENTINEL_&&(b=a.wrappers_[c]=[]);return b};
    jspb.Message.wrapRepeatedField_=function(a,b,c){a.wrappers_||(a.wrappers_={});if(!a.wrappers_[c]){for(var d=jspb.Message.getRepeatedField(a,c),e=[],f=0;f<d.length;f++)e[f]=new b(d[f]);a.wrappers_[c]=e;}};jspb.Message.setWrapperField=function(a,b,c){a.wrappers_||(a.wrappers_={});var d=c?c.toArray():c;a.wrappers_[b]=c;jspb.Message.setField(a,b,d);};
    jspb.Message.setOneofWrapperField=function(a,b,c,d){a.wrappers_||(a.wrappers_={});var e=d?d.toArray():d;a.wrappers_[b]=d;jspb.Message.setOneofField(a,b,c,e);};jspb.Message.setRepeatedWrapperField=function(a,b,c){a.wrappers_||(a.wrappers_={});c=c||[];for(var d=[],e=0;e<c.length;e++)d[e]=c[e].toArray();a.wrappers_[b]=c;jspb.Message.setField(a,b,d);};
    jspb.Message.addToRepeatedWrapperField=function(a,b,c,d,e){jspb.Message.wrapRepeatedField_(a,d,b);var f=a.wrappers_[b];f||(f=a.wrappers_[b]=[]);c=c?c:new d;a=jspb.Message.getRepeatedField(a,b);void 0!=e?(f.splice(e,0,c),a.splice(e,0,c.toArray())):(f.push(c),a.push(c.toArray()));return c};jspb.Message.toMap=function(a,b,c,d){for(var e={},f=0;f<a.length;f++)e[b.call(a[f])]=c?c.call(a[f],d,a[f]):a[f];return e};
    jspb.Message.prototype.syncMapFields_=function(){if(this.wrappers_)for(var a in this.wrappers_){var b=this.wrappers_[a];if(goog.isArray(b))for(var c=0;c<b.length;c++)b[c]&&b[c].toArray();else b&&b.toArray();}};jspb.Message.prototype.toArray=function(){this.syncMapFields_();return this.array};jspb.Message.GENERATE_TO_STRING&&(jspb.Message.prototype.toString=function(){this.syncMapFields_();return this.array.toString()});
    jspb.Message.prototype.getExtension=function(a){if(this.extensionObject_){this.wrappers_||(this.wrappers_={});var b=a.fieldIndex;if(a.isRepeated){if(a.isMessageType())return this.wrappers_[b]||(this.wrappers_[b]=goog.array.map(this.extensionObject_[b]||[],function(b){return new a.ctor(b)})),this.wrappers_[b]}else if(a.isMessageType())return !this.wrappers_[b]&&this.extensionObject_[b]&&(this.wrappers_[b]=new a.ctor(this.extensionObject_[b])),this.wrappers_[b];return this.extensionObject_[b]}};
    jspb.Message.prototype.setExtension=function(a,b){this.wrappers_||(this.wrappers_={});jspb.Message.maybeInitEmptyExtensionObject_(this);var c=a.fieldIndex;a.isRepeated?(b=b||[],a.isMessageType()?(this.wrappers_[c]=b,this.extensionObject_[c]=goog.array.map(b,function(a){return a.toArray()})):this.extensionObject_[c]=b):a.isMessageType()?(this.wrappers_[c]=b,this.extensionObject_[c]=b?b.toArray():b):this.extensionObject_[c]=b;return this};
    jspb.Message.difference=function(a,b){if(!(a instanceof b.constructor))throw Error("Messages have different types.");var c=a.toArray(),d=b.toArray(),e=[],f=0,g=c.length>d.length?c.length:d.length;a.getJsPbMessageId()&&(e[0]=a.getJsPbMessageId(),f=1);for(;f<g;f++)jspb.Message.compareFields(c[f],d[f])||(e[f]=d[f]);return new a.constructor(e)};jspb.Message.equals=function(a,b){return a==b||!(!a||!b)&&a instanceof b.constructor&&jspb.Message.compareFields(a.toArray(),b.toArray())};
    jspb.Message.compareExtensions=function(a,b){a=a||{};b=b||{};var c={},d;for(d in a)c[d]=0;for(d in b)c[d]=0;for(d in c)if(!jspb.Message.compareFields(a[d],b[d]))return !1;return !0};
    jspb.Message.compareFields=function(a,b){if(a==b)return !0;if(!goog.isObject(a)||!goog.isObject(b))return goog.isNumber(a)&&isNaN(a)||goog.isNumber(b)&&isNaN(b)?String(a)==String(b):!1;if(a.constructor!=b.constructor)return !1;if(jspb.Message.SUPPORTS_UINT8ARRAY_&&a.constructor===Uint8Array){if(a.length!=b.length)return !1;for(var c=0;c<a.length;c++)if(a[c]!=b[c])return !1;return !0}if(a.constructor===Array){for(var d=void 0,e=void 0,f=Math.max(a.length,b.length),c=0;c<f;c++){var g=a[c],h=b[c];g&&g.constructor==
    Object&&(goog.asserts.assert(void 0===d),goog.asserts.assert(c===a.length-1),d=g,g=void 0);h&&h.constructor==Object&&(goog.asserts.assert(void 0===e),goog.asserts.assert(c===b.length-1),e=h,h=void 0);if(!jspb.Message.compareFields(g,h))return !1}return d||e?(d=d||{},e=e||{},jspb.Message.compareExtensions(d,e)):!0}if(a.constructor===Object)return jspb.Message.compareExtensions(a,b);throw Error("Invalid type in JSPB array");};jspb.Message.prototype.cloneMessage=function(){return jspb.Message.cloneMessage(this)};
    jspb.Message.prototype.clone=function(){return jspb.Message.cloneMessage(this)};jspb.Message.clone=function(a){return jspb.Message.cloneMessage(a)};jspb.Message.cloneMessage=function(a){return new a.constructor(jspb.Message.clone_(a.toArray()))};
    jspb.Message.copyInto=function(a,b){goog.asserts.assertInstanceof(a,jspb.Message);goog.asserts.assertInstanceof(b,jspb.Message);goog.asserts.assert(a.constructor==b.constructor,"Copy source and target message should have the same type.");for(var c=jspb.Message.clone(a),d=b.toArray(),e=c.toArray(),f=d.length=0;f<e.length;f++)d[f]=e[f];b.wrappers_=c.wrappers_;b.extensionObject_=c.extensionObject_;};
    jspb.Message.clone_=function(a){var b;if(goog.isArray(a)){for(var c=Array(a.length),d=0;d<a.length;d++)b=a[d],null!=b&&(c[d]="object"==typeof b?jspb.Message.clone_(goog.asserts.assert(b)):b);return c}if(jspb.Message.SUPPORTS_UINT8ARRAY_&&a instanceof Uint8Array)return new Uint8Array(a);c={};for(d in a)b=a[d],null!=b&&(c[d]="object"==typeof b?jspb.Message.clone_(goog.asserts.assert(b)):b);return c};jspb.Message.registerMessageType=function(a,b){jspb.Message.registry_[a]=b;b.messageId=a;};
    jspb.Message.registry_={};jspb.Message.messageSetExtensions={};jspb.Message.messageSetExtensionsBinary={};jspb.arith={};jspb.arith.UInt64=function(a,b){this.lo=a;this.hi=b;};jspb.arith.UInt64.prototype.cmp=function(a){return this.hi<a.hi||this.hi==a.hi&&this.lo<a.lo?-1:this.hi==a.hi&&this.lo==a.lo?0:1};jspb.arith.UInt64.prototype.rightShift=function(){return new jspb.arith.UInt64((this.lo>>>1|(this.hi&1)<<31)>>>0,this.hi>>>1>>>0)};jspb.arith.UInt64.prototype.leftShift=function(){return new jspb.arith.UInt64(this.lo<<1>>>0,(this.hi<<1|this.lo>>>31)>>>0)};
    jspb.arith.UInt64.prototype.msb=function(){return !!(this.hi&2147483648)};jspb.arith.UInt64.prototype.lsb=function(){return !!(this.lo&1)};jspb.arith.UInt64.prototype.zero=function(){return 0==this.lo&&0==this.hi};jspb.arith.UInt64.prototype.add=function(a){return new jspb.arith.UInt64((this.lo+a.lo&4294967295)>>>0>>>0,((this.hi+a.hi&4294967295)>>>0)+(4294967296<=this.lo+a.lo?1:0)>>>0)};
    jspb.arith.UInt64.prototype.sub=function(a){return new jspb.arith.UInt64((this.lo-a.lo&4294967295)>>>0>>>0,((this.hi-a.hi&4294967295)>>>0)-(0>this.lo-a.lo?1:0)>>>0)};jspb.arith.UInt64.mul32x32=function(a,b){for(var c=a&65535,d=a>>>16,e=b&65535,f=b>>>16,g=c*e+65536*(c*f&65535)+65536*(d*e&65535),c=d*f+(c*f>>>16)+(d*e>>>16);4294967296<=g;)g-=4294967296,c+=1;return new jspb.arith.UInt64(g>>>0,c>>>0)};
    jspb.arith.UInt64.prototype.mul=function(a){var b=jspb.arith.UInt64.mul32x32(this.lo,a);a=jspb.arith.UInt64.mul32x32(this.hi,a);a.hi=a.lo;a.lo=0;return b.add(a)};
    jspb.arith.UInt64.prototype.div=function(a){if(0==a)return [];var b=new jspb.arith.UInt64(0,0),c=new jspb.arith.UInt64(this.lo,this.hi);a=new jspb.arith.UInt64(a,0);for(var d=new jspb.arith.UInt64(1,0);!a.msb();)a=a.leftShift(),d=d.leftShift();for(;!d.zero();)0>=a.cmp(c)&&(b=b.add(d),c=c.sub(a)),a=a.rightShift(),d=d.rightShift();return [b,c]};jspb.arith.UInt64.prototype.toString=function(){for(var a="",b=this;!b.zero();)var b=b.div(10),c=b[0],a=b[1].lo+a,b=c;""==a&&(a="0");return a};
    jspb.arith.UInt64.fromString=function(a){for(var b=new jspb.arith.UInt64(0,0),c=new jspb.arith.UInt64(0,0),d=0;d<a.length;d++){if("0">a[d]||"9"<a[d])return null;var e=parseInt(a[d],10);c.lo=e;b=b.mul(10).add(c);}return b};jspb.arith.UInt64.prototype.clone=function(){return new jspb.arith.UInt64(this.lo,this.hi)};jspb.arith.Int64=function(a,b){this.lo=a;this.hi=b;};
    jspb.arith.Int64.prototype.add=function(a){return new jspb.arith.Int64((this.lo+a.lo&4294967295)>>>0>>>0,((this.hi+a.hi&4294967295)>>>0)+(4294967296<=this.lo+a.lo?1:0)>>>0)};jspb.arith.Int64.prototype.sub=function(a){return new jspb.arith.Int64((this.lo-a.lo&4294967295)>>>0>>>0,((this.hi-a.hi&4294967295)>>>0)-(0>this.lo-a.lo?1:0)>>>0)};jspb.arith.Int64.prototype.clone=function(){return new jspb.arith.Int64(this.lo,this.hi)};
    jspb.arith.Int64.prototype.toString=function(){var a=0!=(this.hi&2147483648),b=new jspb.arith.UInt64(this.lo,this.hi);a&&(b=(new jspb.arith.UInt64(0,0)).sub(b));return (a?"-":"")+b.toString()};jspb.arith.Int64.fromString=function(a){var b=0<a.length&&"-"==a[0];b&&(a=a.substring(1));a=jspb.arith.UInt64.fromString(a);if(null===a)return null;b&&(a=(new jspb.arith.UInt64(0,0)).sub(a));return new jspb.arith.Int64(a.lo,a.hi)};jspb.BinaryConstants={};jspb.ConstBinaryMessage=function(){};jspb.BinaryMessage=function(){};jspb.BinaryConstants.FieldType={INVALID:-1,DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18,FHASH64:30,VHASH64:31};jspb.BinaryConstants.WireType={INVALID:-1,VARINT:0,FIXED64:1,DELIMITED:2,START_GROUP:3,END_GROUP:4,FIXED32:5};
    jspb.BinaryConstants.FieldTypeToWireType=function(a){var b=jspb.BinaryConstants.FieldType,c=jspb.BinaryConstants.WireType;switch(a){case b.INT32:case b.INT64:case b.UINT32:case b.UINT64:case b.SINT32:case b.SINT64:case b.BOOL:case b.ENUM:case b.VHASH64:return c.VARINT;case b.DOUBLE:case b.FIXED64:case b.SFIXED64:case b.FHASH64:return c.FIXED64;case b.STRING:case b.MESSAGE:case b.BYTES:return c.DELIMITED;case b.FLOAT:case b.FIXED32:case b.SFIXED32:return c.FIXED32;default:return c.INVALID}};
    jspb.BinaryConstants.INVALID_FIELD_NUMBER=-1;jspb.BinaryConstants.FLOAT32_EPS=1.401298464324817E-45;jspb.BinaryConstants.FLOAT32_MIN=1.1754943508222875E-38;jspb.BinaryConstants.FLOAT32_MAX=3.4028234663852886E38;jspb.BinaryConstants.FLOAT64_EPS=4.9E-324;jspb.BinaryConstants.FLOAT64_MIN=2.2250738585072014E-308;jspb.BinaryConstants.FLOAT64_MAX=1.7976931348623157E308;jspb.BinaryConstants.TWO_TO_20=1048576;jspb.BinaryConstants.TWO_TO_23=8388608;jspb.BinaryConstants.TWO_TO_31=2147483648;
    jspb.BinaryConstants.TWO_TO_32=4294967296;jspb.BinaryConstants.TWO_TO_52=4503599627370496;jspb.BinaryConstants.TWO_TO_63=0x7fffffffffffffff;jspb.BinaryConstants.TWO_TO_64=1.8446744073709552E19;jspb.BinaryConstants.ZERO_HASH="\x00\x00\x00\x00\x00\x00\x00\x00";jspb.utils={};jspb.utils.split64Low=0;jspb.utils.split64High=0;jspb.utils.splitUint64=function(a){var b=a>>>0;a=Math.floor((a-b)/jspb.BinaryConstants.TWO_TO_32)>>>0;jspb.utils.split64Low=b;jspb.utils.split64High=a;};jspb.utils.splitInt64=function(a){var b=0>a;a=Math.abs(a);var c=a>>>0;a=Math.floor((a-c)/jspb.BinaryConstants.TWO_TO_32);a>>>=0;b&&(a=~a>>>0,c=(~c>>>0)+1,4294967295<c&&(c=0,a++,4294967295<a&&(a=0)));jspb.utils.split64Low=c;jspb.utils.split64High=a;};
    jspb.utils.splitZigzag64=function(a){var b=0>a;a=2*Math.abs(a);jspb.utils.splitUint64(a);a=jspb.utils.split64Low;var c=jspb.utils.split64High;b&&(0==a?0==c?c=a=4294967295:(c--,a=4294967295):a--);jspb.utils.split64Low=a;jspb.utils.split64High=c;};
    jspb.utils.splitFloat32=function(a){var b=0>a?1:0;a=b?-a:a;var c;0===a?0<1/a?(jspb.utils.split64High=0,jspb.utils.split64Low=0):(jspb.utils.split64High=0,jspb.utils.split64Low=2147483648):isNaN(a)?(jspb.utils.split64High=0,jspb.utils.split64Low=2147483647):a>jspb.BinaryConstants.FLOAT32_MAX?(jspb.utils.split64High=0,jspb.utils.split64Low=(b<<31|2139095040)>>>0):a<jspb.BinaryConstants.FLOAT32_MIN?(a=Math.round(a/Math.pow(2,-149)),jspb.utils.split64High=0,jspb.utils.split64Low=(b<<31|a)>>>0):(c=Math.floor(Math.log(a)/
    Math.LN2),a*=Math.pow(2,-c),a=Math.round(a*jspb.BinaryConstants.TWO_TO_23)&8388607,jspb.utils.split64High=0,jspb.utils.split64Low=(b<<31|c+127<<23|a)>>>0);};
    jspb.utils.splitFloat64=function(a){var b=0>a?1:0;a=b?-a:a;if(0===a)jspb.utils.split64High=0<1/a?0:2147483648,jspb.utils.split64Low=0;else if(isNaN(a))jspb.utils.split64High=2147483647,jspb.utils.split64Low=4294967295;else if(a>jspb.BinaryConstants.FLOAT64_MAX)jspb.utils.split64High=(b<<31|2146435072)>>>0,jspb.utils.split64Low=0;else if(a<jspb.BinaryConstants.FLOAT64_MIN){var c=a/Math.pow(2,-1074);a=c/jspb.BinaryConstants.TWO_TO_32;jspb.utils.split64High=(b<<31|a)>>>0;jspb.utils.split64Low=c>>>0;}else{var d=
    Math.floor(Math.log(a)/Math.LN2);1024==d&&(d=1023);c=a*Math.pow(2,-d);a=c*jspb.BinaryConstants.TWO_TO_20&1048575;c=c*jspb.BinaryConstants.TWO_TO_52>>>0;jspb.utils.split64High=(b<<31|d+1023<<20|a)>>>0;jspb.utils.split64Low=c;}};
    jspb.utils.splitHash64=function(a){var b=a.charCodeAt(0),c=a.charCodeAt(1),d=a.charCodeAt(2),e=a.charCodeAt(3),f=a.charCodeAt(4),g=a.charCodeAt(5),h=a.charCodeAt(6);a=a.charCodeAt(7);jspb.utils.split64Low=b+(c<<8)+(d<<16)+(e<<24)>>>0;jspb.utils.split64High=f+(g<<8)+(h<<16)+(a<<24)>>>0;};jspb.utils.joinUint64=function(a,b){return b*jspb.BinaryConstants.TWO_TO_32+a};
    jspb.utils.joinInt64=function(a,b){var c=b&2147483648;c&&(a=~a+1>>>0,b=~b>>>0,0==a&&(b=b+1>>>0));var d=jspb.utils.joinUint64(a,b);return c?-d:d};jspb.utils.joinZigzag64=function(a,b){var c=a&1;a=(a>>>1|b<<31)>>>0;b>>>=1;c&&(a=a+1>>>0,0==a&&(b=b+1>>>0));var d=jspb.utils.joinUint64(a,b);return c?-d:d};jspb.utils.joinFloat32=function(a,b){var c=2*(a>>31)+1,d=a>>>23&255,e=a&8388607;return 255==d?e?NaN:Infinity*c:0==d?c*Math.pow(2,-149)*e:c*Math.pow(2,d-150)*(e+Math.pow(2,23))};
    jspb.utils.joinFloat64=function(a,b){var c=2*(b>>31)+1,d=b>>>20&2047,e=jspb.BinaryConstants.TWO_TO_32*(b&1048575)+a;return 2047==d?e?NaN:Infinity*c:0==d?c*Math.pow(2,-1074)*e:c*Math.pow(2,d-1075)*(e+jspb.BinaryConstants.TWO_TO_52)};jspb.utils.joinHash64=function(a,b){return String.fromCharCode(a>>>0&255,a>>>8&255,a>>>16&255,a>>>24&255,b>>>0&255,b>>>8&255,b>>>16&255,b>>>24&255)};jspb.utils.DIGITS="0123456789abcdef".split("");
    jspb.utils.joinUnsignedDecimalString=function(a,b){function c(a){for(var b=1E7,c=0;7>c;c++){var b=b/10,d=a/b%10>>>0;if(0!=d||h)h=!0,k+=g[d];}}if(2097151>=b)return ""+(jspb.BinaryConstants.TWO_TO_32*b+a);var d=(a>>>24|b<<8)>>>0&16777215,e=b>>16&65535,f=(a&16777215)+6777216*d+6710656*e,d=d+8147497*e,e=2*e;1E7<=f&&(d+=Math.floor(f/1E7),f%=1E7);1E7<=d&&(e+=Math.floor(d/1E7),d%=1E7);var g=jspb.utils.DIGITS,h=!1,k="";(e||h)&&c(e);(d||h)&&c(d);(f||h)&&c(f);return k};
    jspb.utils.joinSignedDecimalString=function(a,b){var c=b&2147483648;c&&(a=~a+1>>>0,b=~b+(0==a?1:0)>>>0);var d=jspb.utils.joinUnsignedDecimalString(a,b);return c?"-"+d:d};jspb.utils.hash64ToDecimalString=function(a,b){jspb.utils.splitHash64(a);var c=jspb.utils.split64Low,d=jspb.utils.split64High;return b?jspb.utils.joinSignedDecimalString(c,d):jspb.utils.joinUnsignedDecimalString(c,d)};
    jspb.utils.hash64ArrayToDecimalStrings=function(a,b){for(var c=Array(a.length),d=0;d<a.length;d++)c[d]=jspb.utils.hash64ToDecimalString(a[d],b);return c};
    jspb.utils.decimalStringToHash64=function(a){function b(a,b){for(var c=0;8>c&&(1!==a||0<b);c++){var d=a*e[c]+b;e[c]=d&255;b=d>>>8;}}function c(){for(var a=0;8>a;a++)e[a]=~e[a]&255;}goog.asserts.assert(0<a.length);var d=!1;"-"===a[0]&&(d=!0,a=a.slice(1));for(var e=[0,0,0,0,0,0,0,0],f=0;f<a.length;f++)b(10,jspb.utils.DIGITS.indexOf(a[f]));d&&(c(),b(1,1));return goog.crypt.byteArrayToString(e)};jspb.utils.splitDecimalString=function(a){jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));};
    jspb.utils.hash64ToHexString=function(a){var b=Array(18);b[0]="0";b[1]="x";for(var c=0;8>c;c++){var d=a.charCodeAt(7-c);b[2*c+2]=jspb.utils.DIGITS[d>>4];b[2*c+3]=jspb.utils.DIGITS[d&15];}return b.join("")};jspb.utils.hexStringToHash64=function(a){a=a.toLowerCase();goog.asserts.assert(18==a.length);goog.asserts.assert("0"==a[0]);goog.asserts.assert("x"==a[1]);for(var b="",c=0;8>c;c++)var d=jspb.utils.DIGITS.indexOf(a[2*c+2]),e=jspb.utils.DIGITS.indexOf(a[2*c+3]),b=String.fromCharCode(16*d+e)+b;return b};
    jspb.utils.hash64ToNumber=function(a,b){jspb.utils.splitHash64(a);var c=jspb.utils.split64Low,d=jspb.utils.split64High;return b?jspb.utils.joinInt64(c,d):jspb.utils.joinUint64(c,d)};jspb.utils.numberToHash64=function(a){jspb.utils.splitInt64(a);return jspb.utils.joinHash64(jspb.utils.split64Low,jspb.utils.split64High)};jspb.utils.countVarints=function(a,b,c){for(var d=0,e=b;e<c;e++)d+=a[e]>>7;return c-b-d};
    jspb.utils.countVarintFields=function(a,b,c,d){var e=0;d=8*d+jspb.BinaryConstants.WireType.VARINT;if(128>d)for(;b<c&&a[b++]==d;)for(e++;;){var f=a[b++];if(0==(f&128))break}else for(;b<c;){for(f=d;128<f;){if(a[b]!=(f&127|128))return e;b++;f>>=7;}if(a[b++]!=f)break;for(e++;f=a[b++],0!=(f&128););}return e};jspb.utils.countFixedFields_=function(a,b,c,d,e){var f=0;if(128>d)for(;b<c&&a[b++]==d;)f++,b+=e;else for(;b<c;){for(var g=d;128<g;){if(a[b++]!=(g&127|128))return f;g>>=7;}if(a[b++]!=g)break;f++;b+=e;}return f};
    jspb.utils.countFixed32Fields=function(a,b,c,d){return jspb.utils.countFixedFields_(a,b,c,8*d+jspb.BinaryConstants.WireType.FIXED32,4)};jspb.utils.countFixed64Fields=function(a,b,c,d){return jspb.utils.countFixedFields_(a,b,c,8*d+jspb.BinaryConstants.WireType.FIXED64,8)};
    jspb.utils.countDelimitedFields=function(a,b,c,d){var e=0;for(d=8*d+jspb.BinaryConstants.WireType.DELIMITED;b<c;){for(var f=d;128<f;){if(a[b++]!=(f&127|128))return e;f>>=7;}if(a[b++]!=f)break;e++;for(var g=0,h=1;f=a[b++],g+=(f&127)*h,h*=128,0!=(f&128););b+=g;}return e};jspb.utils.debugBytesToTextFormat=function(a){var b='"';if(a){a=jspb.utils.byteSourceToUint8Array(a);for(var c=0;c<a.length;c++)b+="\\x",16>a[c]&&(b+="0"),b+=a[c].toString(16);}return b+'"'};
    jspb.utils.debugScalarToTextFormat=function(a){return goog.isString(a)?goog.string.quote(a):a.toString()};jspb.utils.stringToByteArray=function(a){for(var b=new Uint8Array(a.length),c=0;c<a.length;c++){var d=a.charCodeAt(c);if(255<d)throw Error("Conversion error: string contains codepoint outside of byte range");b[c]=d;}return b};
    jspb.utils.byteSourceToUint8Array=function(a){if(a.constructor===Uint8Array)return a;if(a.constructor===ArrayBuffer||a.constructor===Buffer||a.constructor===Array)return new Uint8Array(a);if(a.constructor===String)return goog.crypt.base64.decodeStringToUint8Array(a);goog.asserts.fail("Type not convertible to Uint8Array.");return new Uint8Array(0)};jspb.BinaryEncoder=function(){this.buffer_=[];};jspb.BinaryEncoder.prototype.length=function(){return this.buffer_.length};jspb.BinaryEncoder.prototype.end=function(){var a=this.buffer_;this.buffer_=[];return a};
    jspb.BinaryEncoder.prototype.writeSplitVarint64=function(a,b){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(b==Math.floor(b));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);for(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32);0<b||127<a;)this.buffer_.push(a&127|128),a=(a>>>7|b<<25)>>>0,b>>>=7;this.buffer_.push(a);};
    jspb.BinaryEncoder.prototype.writeSplitFixed64=function(a,b){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(b==Math.floor(b));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32);this.writeUint32(a);this.writeUint32(b);};
    jspb.BinaryEncoder.prototype.writeUnsignedVarint32=function(a){goog.asserts.assert(a==Math.floor(a));for(goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);127<a;)this.buffer_.push(a&127|128),a>>>=7;this.buffer_.push(a);};
    jspb.BinaryEncoder.prototype.writeSignedVarint32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);if(0<=a)this.writeUnsignedVarint32(a);else{for(var b=0;9>b;b++)this.buffer_.push(a&127|128),a>>=7;this.buffer_.push(1);}};
    jspb.BinaryEncoder.prototype.writeUnsignedVarint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_64);jspb.utils.splitInt64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeSignedVarint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_63&&a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitInt64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeZigzagVarint32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);this.writeUnsignedVarint32((a<<1^a>>31)>>>0);};jspb.BinaryEncoder.prototype.writeZigzagVarint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_63&&a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitZigzag64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeZigzagVarint64String=function(a){this.writeZigzagVarint64(parseInt(a,10));};jspb.BinaryEncoder.prototype.writeUint8=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&256>a);this.buffer_.push(a>>>0&255);};jspb.BinaryEncoder.prototype.writeUint16=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&65536>a);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255);};
    jspb.BinaryEncoder.prototype.writeUint32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_32);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255);this.buffer_.push(a>>>16&255);this.buffer_.push(a>>>24&255);};jspb.BinaryEncoder.prototype.writeUint64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(0<=a&&a<jspb.BinaryConstants.TWO_TO_64);jspb.utils.splitUint64(a);this.writeUint32(jspb.utils.split64Low);this.writeUint32(jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeInt8=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(-128<=a&&128>a);this.buffer_.push(a>>>0&255);};jspb.BinaryEncoder.prototype.writeInt16=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(-32768<=a&&32768>a);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255);};
    jspb.BinaryEncoder.prototype.writeInt32=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);this.buffer_.push(a>>>0&255);this.buffer_.push(a>>>8&255);this.buffer_.push(a>>>16&255);this.buffer_.push(a>>>24&255);};
    jspb.BinaryEncoder.prototype.writeInt64=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_63&&a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitInt64(a);this.writeSplitFixed64(jspb.utils.split64Low,jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeInt64String=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(+a>=-jspb.BinaryConstants.TWO_TO_63&&+a<jspb.BinaryConstants.TWO_TO_63);jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));this.writeSplitFixed64(jspb.utils.split64Low,jspb.utils.split64High);};jspb.BinaryEncoder.prototype.writeFloat=function(a){goog.asserts.assert(a>=-jspb.BinaryConstants.FLOAT32_MAX&&a<=jspb.BinaryConstants.FLOAT32_MAX);jspb.utils.splitFloat32(a);this.writeUint32(jspb.utils.split64Low);};
    jspb.BinaryEncoder.prototype.writeDouble=function(a){goog.asserts.assert(a>=-jspb.BinaryConstants.FLOAT64_MAX&&a<=jspb.BinaryConstants.FLOAT64_MAX);jspb.utils.splitFloat64(a);this.writeUint32(jspb.utils.split64Low);this.writeUint32(jspb.utils.split64High);};jspb.BinaryEncoder.prototype.writeBool=function(a){goog.asserts.assert(goog.isBoolean(a)||goog.isNumber(a));this.buffer_.push(a?1:0);};
    jspb.BinaryEncoder.prototype.writeEnum=function(a){goog.asserts.assert(a==Math.floor(a));goog.asserts.assert(a>=-jspb.BinaryConstants.TWO_TO_31&&a<jspb.BinaryConstants.TWO_TO_31);this.writeSignedVarint32(a);};jspb.BinaryEncoder.prototype.writeBytes=function(a){this.buffer_.push.apply(this.buffer_,a);};jspb.BinaryEncoder.prototype.writeVarintHash64=function(a){jspb.utils.splitHash64(a);this.writeSplitVarint64(jspb.utils.split64Low,jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeFixedHash64=function(a){jspb.utils.splitHash64(a);this.writeUint32(jspb.utils.split64Low);this.writeUint32(jspb.utils.split64High);};
    jspb.BinaryEncoder.prototype.writeString=function(a){for(var b=this.buffer_.length,c=0;c<a.length;c++){var d=a.charCodeAt(c);if(128>d)this.buffer_.push(d);else if(2048>d)this.buffer_.push(d>>6|192),this.buffer_.push(d&63|128);else if(65536>d)if(55296<=d&&56319>=d&&c+1<a.length){var e=a.charCodeAt(c+1);56320<=e&&57343>=e&&(d=1024*(d-55296)+e-56320+65536,this.buffer_.push(d>>18|240),this.buffer_.push(d>>12&63|128),this.buffer_.push(d>>6&63|128),this.buffer_.push(d&63|128),c++);}else this.buffer_.push(d>>
    12|224),this.buffer_.push(d>>6&63|128),this.buffer_.push(d&63|128);}return this.buffer_.length-b};jspb.BinaryWriter=function(){this.blocks_=[];this.totalLength_=0;this.encoder_=new jspb.BinaryEncoder;this.bookmarks_=[];};jspb.BinaryWriter.prototype.appendUint8Array_=function(a){var b=this.encoder_.end();this.blocks_.push(b);this.blocks_.push(a);this.totalLength_+=b.length+a.length;};
    jspb.BinaryWriter.prototype.beginDelimited_=function(a){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);a=this.encoder_.end();this.blocks_.push(a);this.totalLength_+=a.length;a.push(this.totalLength_);return a};jspb.BinaryWriter.prototype.endDelimited_=function(a){var b=a.pop(),b=this.totalLength_+this.encoder_.length()-b;for(goog.asserts.assert(0<=b);127<b;)a.push(b&127|128),b>>>=7,this.totalLength_++;a.push(b);this.totalLength_++;};
    jspb.BinaryWriter.prototype.writeSerializedMessage=function(a,b,c){this.appendUint8Array_(a.subarray(b,c));};jspb.BinaryWriter.prototype.maybeWriteSerializedMessage=function(a,b,c){null!=a&&null!=b&&null!=c&&this.writeSerializedMessage(a,b,c);};jspb.BinaryWriter.prototype.reset=function(){this.blocks_=[];this.encoder_.end();this.totalLength_=0;this.bookmarks_=[];};
    jspb.BinaryWriter.prototype.getResultBuffer=function(){goog.asserts.assert(0==this.bookmarks_.length);for(var a=new Uint8Array(this.totalLength_+this.encoder_.length()),b=this.blocks_,c=b.length,d=0,e=0;e<c;e++){var f=b[e];a.set(f,d);d+=f.length;}b=this.encoder_.end();a.set(b,d);d+=b.length;goog.asserts.assert(d==a.length);this.blocks_=[a];return a};jspb.BinaryWriter.prototype.getResultBase64String=function(a){return goog.crypt.base64.encodeByteArray(this.getResultBuffer(),a)};
    jspb.BinaryWriter.prototype.beginSubMessage=function(a){this.bookmarks_.push(this.beginDelimited_(a));};jspb.BinaryWriter.prototype.endSubMessage=function(){goog.asserts.assert(0<=this.bookmarks_.length);this.endDelimited_(this.bookmarks_.pop());};jspb.BinaryWriter.prototype.writeFieldHeader_=function(a,b){goog.asserts.assert(1<=a&&a==Math.floor(a));this.encoder_.writeUnsignedVarint32(8*a+b);};
    jspb.BinaryWriter.prototype.writeAny=function(a,b,c){var d=jspb.BinaryConstants.FieldType;switch(a){case d.DOUBLE:this.writeDouble(b,c);break;case d.FLOAT:this.writeFloat(b,c);break;case d.INT64:this.writeInt64(b,c);break;case d.UINT64:this.writeUint64(b,c);break;case d.INT32:this.writeInt32(b,c);break;case d.FIXED64:this.writeFixed64(b,c);break;case d.FIXED32:this.writeFixed32(b,c);break;case d.BOOL:this.writeBool(b,c);break;case d.STRING:this.writeString(b,c);break;case d.GROUP:goog.asserts.fail("Group field type not supported in writeAny()");
    break;case d.MESSAGE:goog.asserts.fail("Message field type not supported in writeAny()");break;case d.BYTES:this.writeBytes(b,c);break;case d.UINT32:this.writeUint32(b,c);break;case d.ENUM:this.writeEnum(b,c);break;case d.SFIXED32:this.writeSfixed32(b,c);break;case d.SFIXED64:this.writeSfixed64(b,c);break;case d.SINT32:this.writeSint32(b,c);break;case d.SINT64:this.writeSint64(b,c);break;case d.FHASH64:this.writeFixedHash64(b,c);break;case d.VHASH64:this.writeVarintHash64(b,c);break;default:goog.asserts.fail("Invalid field type in writeAny()");}};
    jspb.BinaryWriter.prototype.writeUnsignedVarint32_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeUnsignedVarint32(b));};jspb.BinaryWriter.prototype.writeSignedVarint32_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint32(b));};jspb.BinaryWriter.prototype.writeUnsignedVarint64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeUnsignedVarint64(b));};
    jspb.BinaryWriter.prototype.writeSignedVarint64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint64(b));};jspb.BinaryWriter.prototype.writeZigzagVarint32_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarint32(b));};jspb.BinaryWriter.prototype.writeZigzagVarint64_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarint64(b));};
    jspb.BinaryWriter.prototype.writeZigzagVarint64String_=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeZigzagVarint64String(b));};jspb.BinaryWriter.prototype.writeInt32=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeSignedVarint32_(a,b));};
    jspb.BinaryWriter.prototype.writeInt32String=function(a,b){if(null!=b){var c=parseInt(b,10);goog.asserts.assert(c>=-jspb.BinaryConstants.TWO_TO_31&&c<jspb.BinaryConstants.TWO_TO_31);this.writeSignedVarint32_(a,c);}};jspb.BinaryWriter.prototype.writeInt64=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_63&&b<jspb.BinaryConstants.TWO_TO_63),this.writeSignedVarint64_(a,b));};
    jspb.BinaryWriter.prototype.writeInt64String=function(a,b){if(null!=b){var c=jspb.arith.Int64.fromString(b);this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT);this.encoder_.writeSplitVarint64(c.lo,c.hi);}};jspb.BinaryWriter.prototype.writeUint32=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32),this.writeUnsignedVarint32_(a,b));};
    jspb.BinaryWriter.prototype.writeUint32String=function(a,b){if(null!=b){var c=parseInt(b,10);goog.asserts.assert(0<=c&&c<jspb.BinaryConstants.TWO_TO_32);this.writeUnsignedVarint32_(a,c);}};jspb.BinaryWriter.prototype.writeUint64=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_64),this.writeUnsignedVarint64_(a,b));};
    jspb.BinaryWriter.prototype.writeUint64String=function(a,b){if(null!=b){var c=jspb.arith.UInt64.fromString(b);this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT);this.encoder_.writeSplitVarint64(c.lo,c.hi);}};jspb.BinaryWriter.prototype.writeSint32=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeZigzagVarint32_(a,b));};
    jspb.BinaryWriter.prototype.writeSint64=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_63&&b<jspb.BinaryConstants.TWO_TO_63),this.writeZigzagVarint64_(a,b));};jspb.BinaryWriter.prototype.writeSint64String=function(a,b){null!=b&&(goog.asserts.assert(+b>=-jspb.BinaryConstants.TWO_TO_63&&+b<jspb.BinaryConstants.TWO_TO_63),this.writeZigzagVarint64String_(a,b));};
    jspb.BinaryWriter.prototype.writeFixed32=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_32),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED32),this.encoder_.writeUint32(b));};jspb.BinaryWriter.prototype.writeFixed64=function(a,b){null!=b&&(goog.asserts.assert(0<=b&&b<jspb.BinaryConstants.TWO_TO_64),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeUint64(b));};
    jspb.BinaryWriter.prototype.writeFixed64String=function(a,b){if(null!=b){var c=jspb.arith.UInt64.fromString(b);this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64);this.encoder_.writeSplitFixed64(c.lo,c.hi);}};jspb.BinaryWriter.prototype.writeSfixed32=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED32),this.encoder_.writeInt32(b));};
    jspb.BinaryWriter.prototype.writeSfixed64=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_63&&b<jspb.BinaryConstants.TWO_TO_63),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeInt64(b));};jspb.BinaryWriter.prototype.writeSfixed64String=function(a,b){if(null!=b){var c=jspb.arith.Int64.fromString(b);this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64);this.encoder_.writeSplitFixed64(c.lo,c.hi);}};
    jspb.BinaryWriter.prototype.writeFloat=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED32),this.encoder_.writeFloat(b));};jspb.BinaryWriter.prototype.writeDouble=function(a,b){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeDouble(b));};jspb.BinaryWriter.prototype.writeBool=function(a,b){null!=b&&(goog.asserts.assert(goog.isBoolean(b)||goog.isNumber(b)),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeBool(b));};
    jspb.BinaryWriter.prototype.writeEnum=function(a,b){null!=b&&(goog.asserts.assert(b>=-jspb.BinaryConstants.TWO_TO_31&&b<jspb.BinaryConstants.TWO_TO_31),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeSignedVarint32(b));};jspb.BinaryWriter.prototype.writeString=function(a,b){if(null!=b){var c=this.beginDelimited_(a);this.encoder_.writeString(b);this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writeBytes=function(a,b){if(null!=b){var c=jspb.utils.byteSourceToUint8Array(b);this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(c.length);this.appendUint8Array_(c);}};jspb.BinaryWriter.prototype.writeMessage=function(a,b,c){null!=b&&(a=this.beginDelimited_(a),c(b,this),this.endDelimited_(a));};
    jspb.BinaryWriter.prototype.writeGroup=function(a,b,c){null!=b&&(this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.START_GROUP),c(b,this),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.END_GROUP));};jspb.BinaryWriter.prototype.writeFixedHash64=function(a,b){null!=b&&(goog.asserts.assert(8==b.length),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.FIXED64),this.encoder_.writeFixedHash64(b));};
    jspb.BinaryWriter.prototype.writeVarintHash64=function(a,b){null!=b&&(goog.asserts.assert(8==b.length),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.VARINT),this.encoder_.writeVarintHash64(b));};jspb.BinaryWriter.prototype.writeRepeatedInt32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSignedVarint32_(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedInt32String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeInt32String(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedInt64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSignedVarint64_(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedInt64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeInt64String(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedUint32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUnsignedVarint32_(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedUint32String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUint32String(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedUint64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUnsignedVarint64_(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedUint64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeUint64String(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedSint32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarint32_(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedSint64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarint64_(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedSint64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeZigzagVarint64String_(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedFixed32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixed32(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedFixed64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixed64(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedFixed64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixed64String(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedSfixed32=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSfixed32(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedSfixed64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSfixed64(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedSfixed64String=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeSfixed64String(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedFloat=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFloat(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedDouble=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeDouble(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedBool=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeBool(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedEnum=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeEnum(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedString=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeString(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedBytes=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeBytes(a,b[c]);};jspb.BinaryWriter.prototype.writeRepeatedMessage=function(a,b,c){if(null!=b)for(var d=0;d<b.length;d++){var e=this.beginDelimited_(a);c(b[d],this);this.endDelimited_(e);}};
    jspb.BinaryWriter.prototype.writeRepeatedGroup=function(a,b,c){if(null!=b)for(var d=0;d<b.length;d++)this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.START_GROUP),c(b[d],this),this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.END_GROUP);};jspb.BinaryWriter.prototype.writeRepeatedFixedHash64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeFixedHash64(a,b[c]);};
    jspb.BinaryWriter.prototype.writeRepeatedVarintHash64=function(a,b){if(null!=b)for(var c=0;c<b.length;c++)this.writeVarintHash64(a,b[c]);};jspb.BinaryWriter.prototype.writePackedInt32=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeSignedVarint32(b[d]);this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writePackedInt32String=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeSignedVarint32(parseInt(b[d],10));this.endDelimited_(c);}};jspb.BinaryWriter.prototype.writePackedInt64=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeSignedVarint64(b[d]);this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writePackedInt64String=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++){var e=jspb.arith.Int64.fromString(b[d]);this.encoder_.writeSplitVarint64(e.lo,e.hi);}this.endDelimited_(c);}};jspb.BinaryWriter.prototype.writePackedUint32=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeUnsignedVarint32(b[d]);this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writePackedUint32String=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeUnsignedVarint32(parseInt(b[d],10));this.endDelimited_(c);}};jspb.BinaryWriter.prototype.writePackedUint64=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeUnsignedVarint64(b[d]);this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writePackedUint64String=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++){var e=jspb.arith.UInt64.fromString(b[d]);this.encoder_.writeSplitVarint64(e.lo,e.hi);}this.endDelimited_(c);}};jspb.BinaryWriter.prototype.writePackedSint32=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeZigzagVarint32(b[d]);this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writePackedSint64=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeZigzagVarint64(b[d]);this.endDelimited_(c);}};jspb.BinaryWriter.prototype.writePackedSint64String=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeZigzagVarint64(parseInt(b[d],10));this.endDelimited_(c);}};
    jspb.BinaryWriter.prototype.writePackedFixed32=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(4*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeUint32(b[c]);}};jspb.BinaryWriter.prototype.writePackedFixed64=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(8*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeUint64(b[c]);}};
    jspb.BinaryWriter.prototype.writePackedFixed64String=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(8*b.length);for(var c=0;c<b.length;c++){var d=jspb.arith.UInt64.fromString(b[c]);this.encoder_.writeSplitFixed64(d.lo,d.hi);}}};
    jspb.BinaryWriter.prototype.writePackedSfixed32=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(4*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeInt32(b[c]);}};jspb.BinaryWriter.prototype.writePackedSfixed64=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(8*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeInt64(b[c]);}};
    jspb.BinaryWriter.prototype.writePackedSfixed64String=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(8*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeInt64String(b[c]);}};jspb.BinaryWriter.prototype.writePackedFloat=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(4*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeFloat(b[c]);}};
    jspb.BinaryWriter.prototype.writePackedDouble=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(8*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeDouble(b[c]);}};jspb.BinaryWriter.prototype.writePackedBool=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(b.length);for(var c=0;c<b.length;c++)this.encoder_.writeBool(b[c]);}};
    jspb.BinaryWriter.prototype.writePackedEnum=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeEnum(b[d]);this.endDelimited_(c);}};jspb.BinaryWriter.prototype.writePackedFixedHash64=function(a,b){if(null!=b&&b.length){this.writeFieldHeader_(a,jspb.BinaryConstants.WireType.DELIMITED);this.encoder_.writeUnsignedVarint32(8*b.length);for(var c=0;c<b.length;c++)this.encoder_.writeFixedHash64(b[c]);}};
    jspb.BinaryWriter.prototype.writePackedVarintHash64=function(a,b){if(null!=b&&b.length){for(var c=this.beginDelimited_(a),d=0;d<b.length;d++)this.encoder_.writeVarintHash64(b[d]);this.endDelimited_(c);}};jspb.BinaryIterator=function(a,b,c){this.elements_=this.nextMethod_=this.decoder_=null;this.cursor_=0;this.nextValue_=null;this.atEnd_=!0;this.init_(a,b,c);};jspb.BinaryIterator.prototype.init_=function(a,b,c){a&&b&&(this.decoder_=a,this.nextMethod_=b);this.elements_=c||null;this.cursor_=0;this.nextValue_=null;this.atEnd_=!this.decoder_&&!this.elements_;this.next();};jspb.BinaryIterator.instanceCache_=[];
    jspb.BinaryIterator.alloc=function(a,b,c){if(jspb.BinaryIterator.instanceCache_.length){var d=jspb.BinaryIterator.instanceCache_.pop();d.init_(a,b,c);return d}return new jspb.BinaryIterator(a,b,c)};jspb.BinaryIterator.prototype.free=function(){this.clear();100>jspb.BinaryIterator.instanceCache_.length&&jspb.BinaryIterator.instanceCache_.push(this);};
    jspb.BinaryIterator.prototype.clear=function(){this.decoder_&&this.decoder_.free();this.elements_=this.nextMethod_=this.decoder_=null;this.cursor_=0;this.nextValue_=null;this.atEnd_=!0;};jspb.BinaryIterator.prototype.get=function(){return this.nextValue_};jspb.BinaryIterator.prototype.atEnd=function(){return this.atEnd_};
    jspb.BinaryIterator.prototype.next=function(){var a=this.nextValue_;this.decoder_?this.decoder_.atEnd()?(this.nextValue_=null,this.atEnd_=!0):this.nextValue_=this.nextMethod_.call(this.decoder_):this.elements_&&(this.cursor_==this.elements_.length?(this.nextValue_=null,this.atEnd_=!0):this.nextValue_=this.elements_[this.cursor_++]);return a};jspb.BinaryDecoder=function(a,b,c){this.bytes_=null;this.tempHigh_=this.tempLow_=this.cursor_=this.end_=this.start_=0;this.error_=!1;a&&this.setBlock(a,b,c);};
    jspb.BinaryDecoder.instanceCache_=[];jspb.BinaryDecoder.alloc=function(a,b,c){if(jspb.BinaryDecoder.instanceCache_.length){var d=jspb.BinaryDecoder.instanceCache_.pop();a&&d.setBlock(a,b,c);return d}return new jspb.BinaryDecoder(a,b,c)};jspb.BinaryDecoder.prototype.free=function(){this.clear();100>jspb.BinaryDecoder.instanceCache_.length&&jspb.BinaryDecoder.instanceCache_.push(this);};jspb.BinaryDecoder.prototype.clone=function(){return jspb.BinaryDecoder.alloc(this.bytes_,this.start_,this.end_-this.start_)};
    jspb.BinaryDecoder.prototype.clear=function(){this.bytes_=null;this.cursor_=this.end_=this.start_=0;this.error_=!1;};jspb.BinaryDecoder.prototype.getBuffer=function(){return this.bytes_};jspb.BinaryDecoder.prototype.setBlock=function(a,b,c){this.bytes_=jspb.utils.byteSourceToUint8Array(a);this.start_=goog.isDef(b)?b:0;this.end_=goog.isDef(c)?this.start_+c:this.bytes_.length;this.cursor_=this.start_;};jspb.BinaryDecoder.prototype.getEnd=function(){return this.end_};
    jspb.BinaryDecoder.prototype.setEnd=function(a){this.end_=a;};jspb.BinaryDecoder.prototype.reset=function(){this.cursor_=this.start_;};jspb.BinaryDecoder.prototype.getCursor=function(){return this.cursor_};jspb.BinaryDecoder.prototype.setCursor=function(a){this.cursor_=a;};jspb.BinaryDecoder.prototype.advance=function(a){this.cursor_+=a;goog.asserts.assert(this.cursor_<=this.end_);};jspb.BinaryDecoder.prototype.atEnd=function(){return this.cursor_==this.end_};
    jspb.BinaryDecoder.prototype.pastEnd=function(){return this.cursor_>this.end_};jspb.BinaryDecoder.prototype.getError=function(){return this.error_||0>this.cursor_||this.cursor_>this.end_};
    jspb.BinaryDecoder.prototype.readSplitVarint64_=function(){for(var a,b=0,c,d=0;4>d;d++)if(a=this.bytes_[this.cursor_++],b|=(a&127)<<7*d,128>a){this.tempLow_=b>>>0;this.tempHigh_=0;return}a=this.bytes_[this.cursor_++];b|=(a&127)<<28;c=0|(a&127)>>4;if(128>a)this.tempLow_=b>>>0,this.tempHigh_=c>>>0;else{for(d=0;5>d;d++)if(a=this.bytes_[this.cursor_++],c|=(a&127)<<7*d+3,128>a){this.tempLow_=b>>>0;this.tempHigh_=c>>>0;return}goog.asserts.fail("Failed to read varint, encoding is invalid.");this.error_=
    !0;}};jspb.BinaryDecoder.prototype.skipVarint=function(){for(;this.bytes_[this.cursor_]&128;)this.cursor_++;this.cursor_++;};jspb.BinaryDecoder.prototype.unskipVarint=function(a){for(;128<a;)this.cursor_--,a>>>=7;this.cursor_--;};
    jspb.BinaryDecoder.prototype.readUnsignedVarint32=function(){var a,b=this.bytes_;a=b[this.cursor_+0];var c=a&127;if(128>a)return this.cursor_+=1,goog.asserts.assert(this.cursor_<=this.end_),c;a=b[this.cursor_+1];c|=(a&127)<<7;if(128>a)return this.cursor_+=2,goog.asserts.assert(this.cursor_<=this.end_),c;a=b[this.cursor_+2];c|=(a&127)<<14;if(128>a)return this.cursor_+=3,goog.asserts.assert(this.cursor_<=this.end_),c;a=b[this.cursor_+3];c|=(a&127)<<21;if(128>a)return this.cursor_+=4,goog.asserts.assert(this.cursor_<=
    this.end_),c;a=b[this.cursor_+4];c|=(a&15)<<28;if(128>a)return this.cursor_+=5,goog.asserts.assert(this.cursor_<=this.end_),c>>>0;this.cursor_+=5;128<=b[this.cursor_++]&&128<=b[this.cursor_++]&&128<=b[this.cursor_++]&&128<=b[this.cursor_++]&&128<=b[this.cursor_++]&&goog.asserts.assert(!1);goog.asserts.assert(this.cursor_<=this.end_);return c};jspb.BinaryDecoder.prototype.readSignedVarint32=jspb.BinaryDecoder.prototype.readUnsignedVarint32;jspb.BinaryDecoder.prototype.readUnsignedVarint32String=function(){return this.readUnsignedVarint32().toString()};
    jspb.BinaryDecoder.prototype.readSignedVarint32String=function(){return this.readSignedVarint32().toString()};jspb.BinaryDecoder.prototype.readZigzagVarint32=function(){var a=this.readUnsignedVarint32();return a>>>1^-(a&1)};jspb.BinaryDecoder.prototype.readUnsignedVarint64=function(){this.readSplitVarint64_();return jspb.utils.joinUint64(this.tempLow_,this.tempHigh_)};
    jspb.BinaryDecoder.prototype.readUnsignedVarint64String=function(){this.readSplitVarint64_();return jspb.utils.joinUnsignedDecimalString(this.tempLow_,this.tempHigh_)};jspb.BinaryDecoder.prototype.readSignedVarint64=function(){this.readSplitVarint64_();return jspb.utils.joinInt64(this.tempLow_,this.tempHigh_)};jspb.BinaryDecoder.prototype.readSignedVarint64String=function(){this.readSplitVarint64_();return jspb.utils.joinSignedDecimalString(this.tempLow_,this.tempHigh_)};
    jspb.BinaryDecoder.prototype.readZigzagVarint64=function(){this.readSplitVarint64_();return jspb.utils.joinZigzag64(this.tempLow_,this.tempHigh_)};jspb.BinaryDecoder.prototype.readZigzagVarint64String=function(){return this.readZigzagVarint64().toString()};jspb.BinaryDecoder.prototype.readUint8=function(){var a=this.bytes_[this.cursor_+0];this.cursor_+=1;goog.asserts.assert(this.cursor_<=this.end_);return a};
    jspb.BinaryDecoder.prototype.readUint16=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1];this.cursor_+=2;goog.asserts.assert(this.cursor_<=this.end_);return a<<0|b<<8};jspb.BinaryDecoder.prototype.readUint32=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1],c=this.bytes_[this.cursor_+2],d=this.bytes_[this.cursor_+3];this.cursor_+=4;goog.asserts.assert(this.cursor_<=this.end_);return (a<<0|b<<8|c<<16|d<<24)>>>0};
    jspb.BinaryDecoder.prototype.readUint64=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinUint64(a,b)};jspb.BinaryDecoder.prototype.readUint64String=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinUnsignedDecimalString(a,b)};jspb.BinaryDecoder.prototype.readInt8=function(){var a=this.bytes_[this.cursor_+0];this.cursor_+=1;goog.asserts.assert(this.cursor_<=this.end_);return a<<24>>24};
    jspb.BinaryDecoder.prototype.readInt16=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1];this.cursor_+=2;goog.asserts.assert(this.cursor_<=this.end_);return (a<<0|b<<8)<<16>>16};jspb.BinaryDecoder.prototype.readInt32=function(){var a=this.bytes_[this.cursor_+0],b=this.bytes_[this.cursor_+1],c=this.bytes_[this.cursor_+2],d=this.bytes_[this.cursor_+3];this.cursor_+=4;goog.asserts.assert(this.cursor_<=this.end_);return a<<0|b<<8|c<<16|d<<24};
    jspb.BinaryDecoder.prototype.readInt64=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinInt64(a,b)};jspb.BinaryDecoder.prototype.readInt64String=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinSignedDecimalString(a,b)};jspb.BinaryDecoder.prototype.readFloat=function(){var a=this.readUint32();return jspb.utils.joinFloat32(a,0)};
    jspb.BinaryDecoder.prototype.readDouble=function(){var a=this.readUint32(),b=this.readUint32();return jspb.utils.joinFloat64(a,b)};jspb.BinaryDecoder.prototype.readBool=function(){return !!this.bytes_[this.cursor_++]};jspb.BinaryDecoder.prototype.readEnum=function(){return this.readSignedVarint32()};
    jspb.BinaryDecoder.prototype.readString=function(a){var b=this.bytes_,c=this.cursor_;a=c+a;for(var d=[],e="";c<a;){var f=b[c++];if(128>f)d.push(f);else if(192>f)continue;else if(224>f){var g=b[c++];d.push((f&31)<<6|g&63);}else if(240>f){var g=b[c++],h=b[c++];d.push((f&15)<<12|(g&63)<<6|h&63);}else if(248>f){var g=b[c++],h=b[c++],k=b[c++],f=(f&7)<<18|(g&63)<<12|(h&63)<<6|k&63,f=f-65536;d.push((f>>10&1023)+55296,(f&1023)+56320);}8192<=d.length&&(e+=String.fromCharCode.apply(null,d),d.length=0);}e+=goog.crypt.byteArrayToString(d);
    this.cursor_=c;return e};jspb.BinaryDecoder.prototype.readStringWithLength=function(){var a=this.readUnsignedVarint32();return this.readString(a)};jspb.BinaryDecoder.prototype.readBytes=function(a){if(0>a||this.cursor_+a>this.bytes_.length)return this.error_=!0,goog.asserts.fail("Invalid byte length!"),new Uint8Array(0);var b=this.bytes_.subarray(this.cursor_,this.cursor_+a);this.cursor_+=a;goog.asserts.assert(this.cursor_<=this.end_);return b};
    jspb.BinaryDecoder.prototype.readVarintHash64=function(){this.readSplitVarint64_();return jspb.utils.joinHash64(this.tempLow_,this.tempHigh_)};jspb.BinaryDecoder.prototype.readFixedHash64=function(){var a=this.bytes_,b=this.cursor_,c=a[b+0],d=a[b+1],e=a[b+2],f=a[b+3],g=a[b+4],h=a[b+5],k=a[b+6],a=a[b+7];this.cursor_+=8;return String.fromCharCode(c,d,e,f,g,h,k,a)};jspb.BinaryReader=function(a,b,c){this.decoder_=jspb.BinaryDecoder.alloc(a,b,c);this.fieldCursor_=this.decoder_.getCursor();this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID;this.error_=!1;this.readCallbacks_=null;};jspb.BinaryReader.instanceCache_=[];
    jspb.BinaryReader.alloc=function(a,b,c){if(jspb.BinaryReader.instanceCache_.length){var d=jspb.BinaryReader.instanceCache_.pop();a&&d.decoder_.setBlock(a,b,c);return d}return new jspb.BinaryReader(a,b,c)};jspb.BinaryReader.prototype.alloc=jspb.BinaryReader.alloc;
    jspb.BinaryReader.prototype.free=function(){this.decoder_.clear();this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID;this.error_=!1;this.readCallbacks_=null;100>jspb.BinaryReader.instanceCache_.length&&jspb.BinaryReader.instanceCache_.push(this);};jspb.BinaryReader.prototype.getFieldCursor=function(){return this.fieldCursor_};jspb.BinaryReader.prototype.getCursor=function(){return this.decoder_.getCursor()};
    jspb.BinaryReader.prototype.getBuffer=function(){return this.decoder_.getBuffer()};jspb.BinaryReader.prototype.getFieldNumber=function(){return this.nextField_};jspb.BinaryReader.prototype.getWireType=function(){return this.nextWireType_};jspb.BinaryReader.prototype.isEndGroup=function(){return this.nextWireType_==jspb.BinaryConstants.WireType.END_GROUP};jspb.BinaryReader.prototype.getError=function(){return this.error_||this.decoder_.getError()};
    jspb.BinaryReader.prototype.setBlock=function(a,b,c){this.decoder_.setBlock(a,b,c);this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID;};jspb.BinaryReader.prototype.reset=function(){this.decoder_.reset();this.nextField_=jspb.BinaryConstants.INVALID_FIELD_NUMBER;this.nextWireType_=jspb.BinaryConstants.WireType.INVALID;};jspb.BinaryReader.prototype.advance=function(a){this.decoder_.advance(a);};
    jspb.BinaryReader.prototype.nextField=function(){if(this.decoder_.atEnd())return !1;if(this.getError())return goog.asserts.fail("Decoder hit an error"),!1;this.fieldCursor_=this.decoder_.getCursor();var a=this.decoder_.readUnsignedVarint32(),b=a>>>3,a=a&7;if(a!=jspb.BinaryConstants.WireType.VARINT&&a!=jspb.BinaryConstants.WireType.FIXED32&&a!=jspb.BinaryConstants.WireType.FIXED64&&a!=jspb.BinaryConstants.WireType.DELIMITED&&a!=jspb.BinaryConstants.WireType.START_GROUP&&a!=jspb.BinaryConstants.WireType.END_GROUP)return goog.asserts.fail("Invalid wire type"),
    this.error_=!0,!1;this.nextField_=b;this.nextWireType_=a;return !0};jspb.BinaryReader.prototype.unskipHeader=function(){this.decoder_.unskipVarint(this.nextField_<<3|this.nextWireType_);};jspb.BinaryReader.prototype.skipMatchingFields=function(){var a=this.nextField_;for(this.unskipHeader();this.nextField()&&this.getFieldNumber()==a;)this.skipField();this.decoder_.atEnd()||this.unskipHeader();};
    jspb.BinaryReader.prototype.skipVarintField=function(){this.nextWireType_!=jspb.BinaryConstants.WireType.VARINT?(goog.asserts.fail("Invalid wire type for skipVarintField"),this.skipField()):this.decoder_.skipVarint();};jspb.BinaryReader.prototype.skipDelimitedField=function(){if(this.nextWireType_!=jspb.BinaryConstants.WireType.DELIMITED)goog.asserts.fail("Invalid wire type for skipDelimitedField"),this.skipField();else{var a=this.decoder_.readUnsignedVarint32();this.decoder_.advance(a);}};
    jspb.BinaryReader.prototype.skipFixed32Field=function(){this.nextWireType_!=jspb.BinaryConstants.WireType.FIXED32?(goog.asserts.fail("Invalid wire type for skipFixed32Field"),this.skipField()):this.decoder_.advance(4);};jspb.BinaryReader.prototype.skipFixed64Field=function(){this.nextWireType_!=jspb.BinaryConstants.WireType.FIXED64?(goog.asserts.fail("Invalid wire type for skipFixed64Field"),this.skipField()):this.decoder_.advance(8);};
    jspb.BinaryReader.prototype.skipGroup=function(){var a=[this.nextField_];do{if(!this.nextField()){goog.asserts.fail("Unmatched start-group tag: stream EOF");this.error_=!0;break}if(this.nextWireType_==jspb.BinaryConstants.WireType.START_GROUP)a.push(this.nextField_);else if(this.nextWireType_==jspb.BinaryConstants.WireType.END_GROUP&&this.nextField_!=a.pop()){goog.asserts.fail("Unmatched end-group tag");this.error_=!0;break}}while(0<a.length)};
    jspb.BinaryReader.prototype.skipField=function(){switch(this.nextWireType_){case jspb.BinaryConstants.WireType.VARINT:this.skipVarintField();break;case jspb.BinaryConstants.WireType.FIXED64:this.skipFixed64Field();break;case jspb.BinaryConstants.WireType.DELIMITED:this.skipDelimitedField();break;case jspb.BinaryConstants.WireType.FIXED32:this.skipFixed32Field();break;case jspb.BinaryConstants.WireType.START_GROUP:this.skipGroup();break;default:goog.asserts.fail("Invalid wire encoding for field.");}};
    jspb.BinaryReader.prototype.registerReadCallback=function(a,b){goog.isNull(this.readCallbacks_)&&(this.readCallbacks_={});goog.asserts.assert(!this.readCallbacks_[a]);this.readCallbacks_[a]=b;};jspb.BinaryReader.prototype.runReadCallback=function(a){goog.asserts.assert(!goog.isNull(this.readCallbacks_));a=this.readCallbacks_[a];goog.asserts.assert(a);return a(this)};
    jspb.BinaryReader.prototype.readAny=function(a){this.nextWireType_=jspb.BinaryConstants.FieldTypeToWireType(a);var b=jspb.BinaryConstants.FieldType;switch(a){case b.DOUBLE:return this.readDouble();case b.FLOAT:return this.readFloat();case b.INT64:return this.readInt64();case b.UINT64:return this.readUint64();case b.INT32:return this.readInt32();case b.FIXED64:return this.readFixed64();case b.FIXED32:return this.readFixed32();case b.BOOL:return this.readBool();case b.STRING:return this.readString();
    case b.GROUP:goog.asserts.fail("Group field type not supported in readAny()");case b.MESSAGE:goog.asserts.fail("Message field type not supported in readAny()");case b.BYTES:return this.readBytes();case b.UINT32:return this.readUint32();case b.ENUM:return this.readEnum();case b.SFIXED32:return this.readSfixed32();case b.SFIXED64:return this.readSfixed64();case b.SINT32:return this.readSint32();case b.SINT64:return this.readSint64();case b.FHASH64:return this.readFixedHash64();case b.VHASH64:return this.readVarintHash64();
    default:goog.asserts.fail("Invalid field type in readAny()");}return 0};jspb.BinaryReader.prototype.readMessage=function(a,b){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var c=this.decoder_.getEnd(),d=this.decoder_.readUnsignedVarint32(),d=this.decoder_.getCursor()+d;this.decoder_.setEnd(d);b(a,this);this.decoder_.setCursor(d);this.decoder_.setEnd(c);};
    jspb.BinaryReader.prototype.readGroup=function(a,b,c){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.START_GROUP);goog.asserts.assert(this.nextField_==a);c(b,this);this.error_||this.nextWireType_==jspb.BinaryConstants.WireType.END_GROUP||(goog.asserts.fail("Group submessage did not end with an END_GROUP tag"),this.error_=!0);};
    jspb.BinaryReader.prototype.getFieldDecoder=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var a=this.decoder_.readUnsignedVarint32(),b=this.decoder_.getCursor(),c=b+a,a=jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(),b,a);this.decoder_.setCursor(c);return a};jspb.BinaryReader.prototype.readInt32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint32()};
    jspb.BinaryReader.prototype.readInt32String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint32String()};jspb.BinaryReader.prototype.readInt64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint64()};jspb.BinaryReader.prototype.readInt64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint64String()};
    jspb.BinaryReader.prototype.readUint32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint32()};jspb.BinaryReader.prototype.readUint32String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint32String()};jspb.BinaryReader.prototype.readUint64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint64()};
    jspb.BinaryReader.prototype.readUint64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readUnsignedVarint64String()};jspb.BinaryReader.prototype.readSint32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarint32()};jspb.BinaryReader.prototype.readSint64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarint64()};
    jspb.BinaryReader.prototype.readSint64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readZigzagVarint64String()};jspb.BinaryReader.prototype.readFixed32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readUint32()};jspb.BinaryReader.prototype.readFixed64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readUint64()};
    jspb.BinaryReader.prototype.readFixed64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readUint64String()};jspb.BinaryReader.prototype.readSfixed32=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readInt32()};jspb.BinaryReader.prototype.readSfixed32String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readInt32().toString()};
    jspb.BinaryReader.prototype.readSfixed64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readInt64()};jspb.BinaryReader.prototype.readSfixed64String=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readInt64String()};jspb.BinaryReader.prototype.readFloat=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED32);return this.decoder_.readFloat()};
    jspb.BinaryReader.prototype.readDouble=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readDouble()};jspb.BinaryReader.prototype.readBool=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return !!this.decoder_.readUnsignedVarint32()};jspb.BinaryReader.prototype.readEnum=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readSignedVarint64()};
    jspb.BinaryReader.prototype.readString=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var a=this.decoder_.readUnsignedVarint32();return this.decoder_.readString(a)};jspb.BinaryReader.prototype.readBytes=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);var a=this.decoder_.readUnsignedVarint32();return this.decoder_.readBytes(a)};
    jspb.BinaryReader.prototype.readVarintHash64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.VARINT);return this.decoder_.readVarintHash64()};jspb.BinaryReader.prototype.readFixedHash64=function(){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.FIXED64);return this.decoder_.readFixedHash64()};
    jspb.BinaryReader.prototype.readPackedField_=function(a){goog.asserts.assert(this.nextWireType_==jspb.BinaryConstants.WireType.DELIMITED);for(var b=this.decoder_.readUnsignedVarint32(),b=this.decoder_.getCursor()+b,c=[];this.decoder_.getCursor()<b;)c.push(a.call(this.decoder_));return c};jspb.BinaryReader.prototype.readPackedInt32=function(){return this.readPackedField_(this.decoder_.readSignedVarint32)};jspb.BinaryReader.prototype.readPackedInt32String=function(){return this.readPackedField_(this.decoder_.readSignedVarint32String)};
    jspb.BinaryReader.prototype.readPackedInt64=function(){return this.readPackedField_(this.decoder_.readSignedVarint64)};jspb.BinaryReader.prototype.readPackedInt64String=function(){return this.readPackedField_(this.decoder_.readSignedVarint64String)};jspb.BinaryReader.prototype.readPackedUint32=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint32)};jspb.BinaryReader.prototype.readPackedUint32String=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint32String)};
    jspb.BinaryReader.prototype.readPackedUint64=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint64)};jspb.BinaryReader.prototype.readPackedUint64String=function(){return this.readPackedField_(this.decoder_.readUnsignedVarint64String)};jspb.BinaryReader.prototype.readPackedSint32=function(){return this.readPackedField_(this.decoder_.readZigzagVarint32)};jspb.BinaryReader.prototype.readPackedSint64=function(){return this.readPackedField_(this.decoder_.readZigzagVarint64)};
    jspb.BinaryReader.prototype.readPackedSint64String=function(){return this.readPackedField_(this.decoder_.readZigzagVarint64String)};jspb.BinaryReader.prototype.readPackedFixed32=function(){return this.readPackedField_(this.decoder_.readUint32)};jspb.BinaryReader.prototype.readPackedFixed64=function(){return this.readPackedField_(this.decoder_.readUint64)};jspb.BinaryReader.prototype.readPackedFixed64String=function(){return this.readPackedField_(this.decoder_.readUint64String)};
    jspb.BinaryReader.prototype.readPackedSfixed32=function(){return this.readPackedField_(this.decoder_.readInt32)};jspb.BinaryReader.prototype.readPackedSfixed64=function(){return this.readPackedField_(this.decoder_.readInt64)};jspb.BinaryReader.prototype.readPackedSfixed64String=function(){return this.readPackedField_(this.decoder_.readInt64String)};jspb.BinaryReader.prototype.readPackedFloat=function(){return this.readPackedField_(this.decoder_.readFloat)};
    jspb.BinaryReader.prototype.readPackedDouble=function(){return this.readPackedField_(this.decoder_.readDouble)};jspb.BinaryReader.prototype.readPackedBool=function(){return this.readPackedField_(this.decoder_.readBool)};jspb.BinaryReader.prototype.readPackedEnum=function(){return this.readPackedField_(this.decoder_.readEnum)};jspb.BinaryReader.prototype.readPackedVarintHash64=function(){return this.readPackedField_(this.decoder_.readVarintHash64)};
    jspb.BinaryReader.prototype.readPackedFixedHash64=function(){return this.readPackedField_(this.decoder_.readFixedHash64)};jspb.Export={};var Map$1=jspb.Map;var Message=jspb.Message;var BinaryReader=jspb.BinaryReader;var BinaryWriter=jspb.BinaryWriter;var ExtensionFieldInfo=jspb.ExtensionFieldInfo;var ExtensionFieldBinaryInfo=jspb.ExtensionFieldBinaryInfo;var exportSymbol=goog.exportSymbol;var inherits=goog.inherits;var object={extend:goog.object.extend};var typeOf=goog.typeOf;

    var googleProtobuf = {
    	Map: Map$1,
    	Message: Message,
    	BinaryReader: BinaryReader,
    	BinaryWriter: BinaryWriter,
    	ExtensionFieldInfo: ExtensionFieldInfo,
    	ExtensionFieldBinaryInfo: ExtensionFieldBinaryInfo,
    	exportSymbol: exportSymbol,
    	inherits: inherits,
    	object: object,
    	typeOf: typeOf
    };

    var descriptor_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!


    var goog = googleProtobuf;
    var global = Function('return this')();

    goog.exportSymbol('proto.google.protobuf.DescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.DescriptorProto.ExtensionRange', null, global);
    goog.exportSymbol('proto.google.protobuf.DescriptorProto.ReservedRange', null, global);
    goog.exportSymbol('proto.google.protobuf.EnumDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.EnumDescriptorProto.EnumReservedRange', null, global);
    goog.exportSymbol('proto.google.protobuf.EnumOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.EnumValueDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.EnumValueOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.ExtensionRangeOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.FieldDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.FieldDescriptorProto.Label', null, global);
    goog.exportSymbol('proto.google.protobuf.FieldDescriptorProto.Type', null, global);
    goog.exportSymbol('proto.google.protobuf.FieldOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.FieldOptions.CType', null, global);
    goog.exportSymbol('proto.google.protobuf.FieldOptions.JSType', null, global);
    goog.exportSymbol('proto.google.protobuf.FileDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.FileDescriptorSet', null, global);
    goog.exportSymbol('proto.google.protobuf.FileOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.FileOptions.OptimizeMode', null, global);
    goog.exportSymbol('proto.google.protobuf.GeneratedCodeInfo', null, global);
    goog.exportSymbol('proto.google.protobuf.GeneratedCodeInfo.Annotation', null, global);
    goog.exportSymbol('proto.google.protobuf.MessageOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.MethodDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.MethodOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.MethodOptions.IdempotencyLevel', null, global);
    goog.exportSymbol('proto.google.protobuf.OneofDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.OneofOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.ServiceDescriptorProto', null, global);
    goog.exportSymbol('proto.google.protobuf.ServiceOptions', null, global);
    goog.exportSymbol('proto.google.protobuf.SourceCodeInfo', null, global);
    goog.exportSymbol('proto.google.protobuf.SourceCodeInfo.Location', null, global);
    goog.exportSymbol('proto.google.protobuf.UninterpretedOption', null, global);
    goog.exportSymbol('proto.google.protobuf.UninterpretedOption.NamePart', null, global);

    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.FileDescriptorSet = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.FileDescriptorSet.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.FileDescriptorSet, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.FileDescriptorSet.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.FileDescriptorSet.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.FileDescriptorSet.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.FileDescriptorSet} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FileDescriptorSet.toObject = function(includeInstance, msg) {
      var obj = {
        fileList: googleProtobuf.Message.toObjectList(msg.getFileList(),
        proto.google.protobuf.FileDescriptorProto.toObject, includeInstance)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.FileDescriptorSet}
     */
    proto.google.protobuf.FileDescriptorSet.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.FileDescriptorSet;
      return proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.FileDescriptorSet} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.FileDescriptorSet}
     */
    proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.google.protobuf.FileDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader);
          msg.addFile(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.FileDescriptorSet.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.FileDescriptorSet} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getFileList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter
        );
      }
    };


    /**
     * repeated FileDescriptorProto file = 1;
     * @return {!Array<!proto.google.protobuf.FileDescriptorProto>}
     */
    proto.google.protobuf.FileDescriptorSet.prototype.getFileList = function() {
      return /** @type{!Array<!proto.google.protobuf.FileDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.FileDescriptorProto, 1));
    };


    /** @param {!Array<!proto.google.protobuf.FileDescriptorProto>} value */
    proto.google.protobuf.FileDescriptorSet.prototype.setFileList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };


    /**
     * @param {!proto.google.protobuf.FileDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.FileDescriptorProto}
     */
    proto.google.protobuf.FileDescriptorSet.prototype.addFile = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.FileDescriptorProto, opt_index);
    };


    proto.google.protobuf.FileDescriptorSet.prototype.clearFileList = function() {
      this.setFileList([]);
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.FileDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.FileDescriptorProto.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.FileDescriptorProto, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.FileDescriptorProto.repeatedFields_ = [3,10,11,4,5,6,7];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.FileDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.FileDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FileDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        pb_package: googleProtobuf.Message.getField(msg, 2),
        dependencyList: googleProtobuf.Message.getRepeatedField(msg, 3),
        publicDependencyList: googleProtobuf.Message.getRepeatedField(msg, 10),
        weakDependencyList: googleProtobuf.Message.getRepeatedField(msg, 11),
        messageTypeList: googleProtobuf.Message.toObjectList(msg.getMessageTypeList(),
        proto.google.protobuf.DescriptorProto.toObject, includeInstance),
        enumTypeList: googleProtobuf.Message.toObjectList(msg.getEnumTypeList(),
        proto.google.protobuf.EnumDescriptorProto.toObject, includeInstance),
        serviceList: googleProtobuf.Message.toObjectList(msg.getServiceList(),
        proto.google.protobuf.ServiceDescriptorProto.toObject, includeInstance),
        extensionList: googleProtobuf.Message.toObjectList(msg.getExtensionList(),
        proto.google.protobuf.FieldDescriptorProto.toObject, includeInstance),
        options: (f = msg.getOptions()) && proto.google.protobuf.FileOptions.toObject(includeInstance, f),
        sourceCodeInfo: (f = msg.getSourceCodeInfo()) && proto.google.protobuf.SourceCodeInfo.toObject(includeInstance, f),
        syntax: googleProtobuf.Message.getField(msg, 12)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.FileDescriptorProto}
     */
    proto.google.protobuf.FileDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.FileDescriptorProto;
      return proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.FileDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.FileDescriptorProto}
     */
    proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setPackage(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.addDependency(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readInt32());
          msg.addPublicDependency(value);
          break;
        case 11:
          var value = /** @type {number} */ (reader.readInt32());
          msg.addWeakDependency(value);
          break;
        case 4:
          var value = new proto.google.protobuf.DescriptorProto;
          reader.readMessage(value,proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader);
          msg.addMessageType(value);
          break;
        case 5:
          var value = new proto.google.protobuf.EnumDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader);
          msg.addEnumType(value);
          break;
        case 6:
          var value = new proto.google.protobuf.ServiceDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader);
          msg.addService(value);
          break;
        case 7:
          var value = new proto.google.protobuf.FieldDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader);
          msg.addExtension$(value);
          break;
        case 8:
          var value = new proto.google.protobuf.FileOptions;
          reader.readMessage(value,proto.google.protobuf.FileOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        case 9:
          var value = new proto.google.protobuf.SourceCodeInfo;
          reader.readMessage(value,proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader);
          msg.setSourceCodeInfo(value);
          break;
        case 12:
          var value = /** @type {string} */ (reader.readString());
          msg.setSyntax(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.FileDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getDependencyList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          3,
          f
        );
      }
      f = message.getPublicDependencyList();
      if (f.length > 0) {
        writer.writeRepeatedInt32(
          10,
          f
        );
      }
      f = message.getWeakDependencyList();
      if (f.length > 0) {
        writer.writeRepeatedInt32(
          11,
          f
        );
      }
      f = message.getMessageTypeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          4,
          f,
          proto.google.protobuf.DescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getEnumTypeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          5,
          f,
          proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getServiceList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          6,
          f,
          proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getExtensionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          7,
          f,
          proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          proto.google.protobuf.FileOptions.serializeBinaryToWriter
        );
      }
      f = message.getSourceCodeInfo();
      if (f != null) {
        writer.writeMessage(
          9,
          f,
          proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 12));
      if (f != null) {
        writer.writeString(
          12,
          f
        );
      }
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string package = 2;
     * @return {string}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getPackage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setPackage = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearPackage = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.hasPackage = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * repeated string dependency = 3;
     * @return {!Array<string>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getDependencyList = function() {
      return /** @type {!Array<string>} */ (googleProtobuf.Message.getRepeatedField(this, 3));
    };


    /** @param {!Array<string>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setDependencyList = function(value) {
      googleProtobuf.Message.setField(this, 3, value || []);
    };


    /**
     * @param {!string} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addDependency = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 3, value, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearDependencyList = function() {
      this.setDependencyList([]);
    };


    /**
     * repeated int32 public_dependency = 10;
     * @return {!Array<number>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getPublicDependencyList = function() {
      return /** @type {!Array<number>} */ (googleProtobuf.Message.getRepeatedField(this, 10));
    };


    /** @param {!Array<number>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setPublicDependencyList = function(value) {
      googleProtobuf.Message.setField(this, 10, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addPublicDependency = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 10, value, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearPublicDependencyList = function() {
      this.setPublicDependencyList([]);
    };


    /**
     * repeated int32 weak_dependency = 11;
     * @return {!Array<number>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getWeakDependencyList = function() {
      return /** @type {!Array<number>} */ (googleProtobuf.Message.getRepeatedField(this, 11));
    };


    /** @param {!Array<number>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setWeakDependencyList = function(value) {
      googleProtobuf.Message.setField(this, 11, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addWeakDependency = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 11, value, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearWeakDependencyList = function() {
      this.setWeakDependencyList([]);
    };


    /**
     * repeated DescriptorProto message_type = 4;
     * @return {!Array<!proto.google.protobuf.DescriptorProto>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getMessageTypeList = function() {
      return /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 4));
    };


    /** @param {!Array<!proto.google.protobuf.DescriptorProto>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setMessageTypeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 4, value);
    };


    /**
     * @param {!proto.google.protobuf.DescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.DescriptorProto}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addMessageType = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.DescriptorProto, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearMessageTypeList = function() {
      this.setMessageTypeList([]);
    };


    /**
     * repeated EnumDescriptorProto enum_type = 5;
     * @return {!Array<!proto.google.protobuf.EnumDescriptorProto>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getEnumTypeList = function() {
      return /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 5));
    };


    /** @param {!Array<!proto.google.protobuf.EnumDescriptorProto>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setEnumTypeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 5, value);
    };


    /**
     * @param {!proto.google.protobuf.EnumDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.EnumDescriptorProto}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addEnumType = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.google.protobuf.EnumDescriptorProto, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearEnumTypeList = function() {
      this.setEnumTypeList([]);
    };


    /**
     * repeated ServiceDescriptorProto service = 6;
     * @return {!Array<!proto.google.protobuf.ServiceDescriptorProto>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getServiceList = function() {
      return /** @type{!Array<!proto.google.protobuf.ServiceDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.ServiceDescriptorProto, 6));
    };


    /** @param {!Array<!proto.google.protobuf.ServiceDescriptorProto>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setServiceList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 6, value);
    };


    /**
     * @param {!proto.google.protobuf.ServiceDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.ServiceDescriptorProto}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addService = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.google.protobuf.ServiceDescriptorProto, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearServiceList = function() {
      this.setServiceList([]);
    };


    /**
     * repeated FieldDescriptorProto extension = 7;
     * @return {!Array<!proto.google.protobuf.FieldDescriptorProto>}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getExtensionList = function() {
      return /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 7));
    };


    /** @param {!Array<!proto.google.protobuf.FieldDescriptorProto>} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setExtensionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 7, value);
    };


    /**
     * @param {!proto.google.protobuf.FieldDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.FieldDescriptorProto}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.addExtension$ = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.google.protobuf.FieldDescriptorProto, opt_index);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearExtensionList = function() {
      this.setExtensionList([]);
    };


    /**
     * optional FileOptions options = 8;
     * @return {?proto.google.protobuf.FileOptions}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.FileOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.FileOptions, 8));
    };


    /** @param {?proto.google.protobuf.FileOptions|undefined} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 8, value);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional SourceCodeInfo source_code_info = 9;
     * @return {?proto.google.protobuf.SourceCodeInfo}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getSourceCodeInfo = function() {
      return /** @type{?proto.google.protobuf.SourceCodeInfo} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.SourceCodeInfo, 9));
    };


    /** @param {?proto.google.protobuf.SourceCodeInfo|undefined} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setSourceCodeInfo = function(value) {
      googleProtobuf.Message.setWrapperField(this, 9, value);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearSourceCodeInfo = function() {
      this.setSourceCodeInfo(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.hasSourceCodeInfo = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional string syntax = 12;
     * @return {string}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.getSyntax = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 12, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileDescriptorProto.prototype.setSyntax = function(value) {
      googleProtobuf.Message.setField(this, 12, value);
    };


    proto.google.protobuf.FileDescriptorProto.prototype.clearSyntax = function() {
      googleProtobuf.Message.setField(this, 12, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileDescriptorProto.prototype.hasSyntax = function() {
      return googleProtobuf.Message.getField(this, 12) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.DescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.DescriptorProto.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.DescriptorProto, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.DescriptorProto.repeatedFields_ = [2,6,3,4,5,8,9,10];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.DescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.DescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.DescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.DescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        fieldList: googleProtobuf.Message.toObjectList(msg.getFieldList(),
        proto.google.protobuf.FieldDescriptorProto.toObject, includeInstance),
        extensionList: googleProtobuf.Message.toObjectList(msg.getExtensionList(),
        proto.google.protobuf.FieldDescriptorProto.toObject, includeInstance),
        nestedTypeList: googleProtobuf.Message.toObjectList(msg.getNestedTypeList(),
        proto.google.protobuf.DescriptorProto.toObject, includeInstance),
        enumTypeList: googleProtobuf.Message.toObjectList(msg.getEnumTypeList(),
        proto.google.protobuf.EnumDescriptorProto.toObject, includeInstance),
        extensionRangeList: googleProtobuf.Message.toObjectList(msg.getExtensionRangeList(),
        proto.google.protobuf.DescriptorProto.ExtensionRange.toObject, includeInstance),
        oneofDeclList: googleProtobuf.Message.toObjectList(msg.getOneofDeclList(),
        proto.google.protobuf.OneofDescriptorProto.toObject, includeInstance),
        options: (f = msg.getOptions()) && proto.google.protobuf.MessageOptions.toObject(includeInstance, f),
        reservedRangeList: googleProtobuf.Message.toObjectList(msg.getReservedRangeList(),
        proto.google.protobuf.DescriptorProto.ReservedRange.toObject, includeInstance),
        reservedNameList: googleProtobuf.Message.getRepeatedField(msg, 10)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.DescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.DescriptorProto;
      return proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.DescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.DescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = new proto.google.protobuf.FieldDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader);
          msg.addField(value);
          break;
        case 6:
          var value = new proto.google.protobuf.FieldDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader);
          msg.addExtension$(value);
          break;
        case 3:
          var value = new proto.google.protobuf.DescriptorProto;
          reader.readMessage(value,proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader);
          msg.addNestedType(value);
          break;
        case 4:
          var value = new proto.google.protobuf.EnumDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader);
          msg.addEnumType(value);
          break;
        case 5:
          var value = new proto.google.protobuf.DescriptorProto.ExtensionRange;
          reader.readMessage(value,proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader);
          msg.addExtensionRange(value);
          break;
        case 8:
          var value = new proto.google.protobuf.OneofDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader);
          msg.addOneofDecl(value);
          break;
        case 7:
          var value = new proto.google.protobuf.MessageOptions;
          reader.readMessage(value,proto.google.protobuf.MessageOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        case 9:
          var value = new proto.google.protobuf.DescriptorProto.ReservedRange;
          reader.readMessage(value,proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader);
          msg.addReservedRange(value);
          break;
        case 10:
          var value = /** @type {string} */ (reader.readString());
          msg.addReservedName(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.DescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.DescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.DescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.DescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getFieldList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          2,
          f,
          proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getExtensionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          6,
          f,
          proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getNestedTypeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          3,
          f,
          proto.google.protobuf.DescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getEnumTypeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          4,
          f,
          proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getExtensionRangeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          5,
          f,
          proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter
        );
      }
      f = message.getOneofDeclList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          8,
          f,
          proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          proto.google.protobuf.MessageOptions.serializeBinaryToWriter
        );
      }
      f = message.getReservedRangeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          9,
          f,
          proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter
        );
      }
      f = message.getReservedNameList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          10,
          f
        );
      }
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.DescriptorProto.ExtensionRange, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.DescriptorProto.ExtensionRange.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.toObject = function(includeInstance, msg) {
      var f, obj = {
        start: googleProtobuf.Message.getField(msg, 1),
        end: googleProtobuf.Message.getField(msg, 2),
        options: (f = msg.getOptions()) && proto.google.protobuf.ExtensionRangeOptions.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.DescriptorProto.ExtensionRange;
      return proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setStart(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setEnd(value);
          break;
        case 3:
          var value = new proto.google.protobuf.ExtensionRangeOptions;
          reader.readMessage(value,proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional int32 start = 1;
     * @return {number}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getStart = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setStart = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearStart = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasStart = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional int32 end = 2;
     * @return {number}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getEnd = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setEnd = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearEnd = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasEnd = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional ExtensionRangeOptions options = 3;
     * @return {?proto.google.protobuf.ExtensionRangeOptions}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.ExtensionRangeOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.ExtensionRangeOptions, 3));
    };


    /** @param {?proto.google.protobuf.ExtensionRangeOptions|undefined} value */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };


    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.DescriptorProto.ReservedRange = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.DescriptorProto.ReservedRange, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.DescriptorProto.ReservedRange.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.DescriptorProto.ReservedRange} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.toObject = function(includeInstance, msg) {
      var obj = {
        start: googleProtobuf.Message.getField(msg, 1),
        end: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.DescriptorProto.ReservedRange}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.DescriptorProto.ReservedRange;
      return proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.DescriptorProto.ReservedRange} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.DescriptorProto.ReservedRange}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setStart(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setEnd(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.DescriptorProto.ReservedRange} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeInt32(
          2,
          f
        );
      }
    };


    /**
     * optional int32 start = 1;
     * @return {number}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getStart = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setStart = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearStart = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasStart = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional int32 end = 2;
     * @return {number}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getEnd = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setEnd = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearEnd = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasEnd = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.DescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.DescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated FieldDescriptorProto field = 2;
     * @return {!Array<!proto.google.protobuf.FieldDescriptorProto>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getFieldList = function() {
      return /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 2));
    };


    /** @param {!Array<!proto.google.protobuf.FieldDescriptorProto>} value */
    proto.google.protobuf.DescriptorProto.prototype.setFieldList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };


    /**
     * @param {!proto.google.protobuf.FieldDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.FieldDescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.prototype.addField = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.FieldDescriptorProto, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearFieldList = function() {
      this.setFieldList([]);
    };


    /**
     * repeated FieldDescriptorProto extension = 6;
     * @return {!Array<!proto.google.protobuf.FieldDescriptorProto>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getExtensionList = function() {
      return /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 6));
    };


    /** @param {!Array<!proto.google.protobuf.FieldDescriptorProto>} value */
    proto.google.protobuf.DescriptorProto.prototype.setExtensionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 6, value);
    };


    /**
     * @param {!proto.google.protobuf.FieldDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.FieldDescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.prototype.addExtension$ = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.google.protobuf.FieldDescriptorProto, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearExtensionList = function() {
      this.setExtensionList([]);
    };


    /**
     * repeated DescriptorProto nested_type = 3;
     * @return {!Array<!proto.google.protobuf.DescriptorProto>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getNestedTypeList = function() {
      return /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 3));
    };


    /** @param {!Array<!proto.google.protobuf.DescriptorProto>} value */
    proto.google.protobuf.DescriptorProto.prototype.setNestedTypeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 3, value);
    };


    /**
     * @param {!proto.google.protobuf.DescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.DescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.prototype.addNestedType = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.google.protobuf.DescriptorProto, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearNestedTypeList = function() {
      this.setNestedTypeList([]);
    };


    /**
     * repeated EnumDescriptorProto enum_type = 4;
     * @return {!Array<!proto.google.protobuf.EnumDescriptorProto>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getEnumTypeList = function() {
      return /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 4));
    };


    /** @param {!Array<!proto.google.protobuf.EnumDescriptorProto>} value */
    proto.google.protobuf.DescriptorProto.prototype.setEnumTypeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 4, value);
    };


    /**
     * @param {!proto.google.protobuf.EnumDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.EnumDescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.prototype.addEnumType = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.EnumDescriptorProto, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearEnumTypeList = function() {
      this.setEnumTypeList([]);
    };


    /**
     * repeated ExtensionRange extension_range = 5;
     * @return {!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getExtensionRangeList = function() {
      return /** @type{!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ExtensionRange, 5));
    };


    /** @param {!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>} value */
    proto.google.protobuf.DescriptorProto.prototype.setExtensionRangeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 5, value);
    };


    /**
     * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange}
     */
    proto.google.protobuf.DescriptorProto.prototype.addExtensionRange = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.google.protobuf.DescriptorProto.ExtensionRange, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearExtensionRangeList = function() {
      this.setExtensionRangeList([]);
    };


    /**
     * repeated OneofDescriptorProto oneof_decl = 8;
     * @return {!Array<!proto.google.protobuf.OneofDescriptorProto>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getOneofDeclList = function() {
      return /** @type{!Array<!proto.google.protobuf.OneofDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.OneofDescriptorProto, 8));
    };


    /** @param {!Array<!proto.google.protobuf.OneofDescriptorProto>} value */
    proto.google.protobuf.DescriptorProto.prototype.setOneofDeclList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 8, value);
    };


    /**
     * @param {!proto.google.protobuf.OneofDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.OneofDescriptorProto}
     */
    proto.google.protobuf.DescriptorProto.prototype.addOneofDecl = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.google.protobuf.OneofDescriptorProto, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearOneofDeclList = function() {
      this.setOneofDeclList([]);
    };


    /**
     * optional MessageOptions options = 7;
     * @return {?proto.google.protobuf.MessageOptions}
     */
    proto.google.protobuf.DescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.MessageOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.MessageOptions, 7));
    };


    /** @param {?proto.google.protobuf.MessageOptions|undefined} value */
    proto.google.protobuf.DescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 7, value);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.DescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * repeated ReservedRange reserved_range = 9;
     * @return {!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getReservedRangeList = function() {
      return /** @type{!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ReservedRange, 9));
    };


    /** @param {!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>} value */
    proto.google.protobuf.DescriptorProto.prototype.setReservedRangeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 9, value);
    };


    /**
     * @param {!proto.google.protobuf.DescriptorProto.ReservedRange=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.DescriptorProto.ReservedRange}
     */
    proto.google.protobuf.DescriptorProto.prototype.addReservedRange = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.google.protobuf.DescriptorProto.ReservedRange, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearReservedRangeList = function() {
      this.setReservedRangeList([]);
    };


    /**
     * repeated string reserved_name = 10;
     * @return {!Array<string>}
     */
    proto.google.protobuf.DescriptorProto.prototype.getReservedNameList = function() {
      return /** @type {!Array<string>} */ (googleProtobuf.Message.getRepeatedField(this, 10));
    };


    /** @param {!Array<string>} value */
    proto.google.protobuf.DescriptorProto.prototype.setReservedNameList = function(value) {
      googleProtobuf.Message.setField(this, 10, value || []);
    };


    /**
     * @param {!string} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.DescriptorProto.prototype.addReservedName = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 10, value, opt_index);
    };


    proto.google.protobuf.DescriptorProto.prototype.clearReservedNameList = function() {
      this.setReservedNameList([]);
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.ExtensionRangeOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.ExtensionRangeOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.ExtensionRangeOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.ExtensionRangeOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.ExtensionRangeOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.ExtensionRangeOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.ExtensionRangeOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.ExtensionRangeOptions.toObject = function(includeInstance, msg) {
      var obj = {
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.ExtensionRangeOptions.extensions, proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.ExtensionRangeOptions}
     */
    proto.google.protobuf.ExtensionRangeOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.ExtensionRangeOptions;
      return proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.ExtensionRangeOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.ExtensionRangeOptions}
     */
    proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.ExtensionRangeOptions.extensionsBinary,
            proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension,
            proto.google.protobuf.ExtensionRangeOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.ExtensionRangeOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.ExtensionRangeOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.ExtensionRangeOptions.extensionsBinary, proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension);
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.ExtensionRangeOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.ExtensionRangeOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.ExtensionRangeOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.ExtensionRangeOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.ExtensionRangeOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.ExtensionRangeOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.FieldDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.FieldDescriptorProto, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.FieldDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.FieldDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FieldDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        number: googleProtobuf.Message.getField(msg, 3),
        label: googleProtobuf.Message.getField(msg, 4),
        type: googleProtobuf.Message.getField(msg, 5),
        typeName: googleProtobuf.Message.getField(msg, 6),
        extendee: googleProtobuf.Message.getField(msg, 2),
        defaultValue: googleProtobuf.Message.getField(msg, 7),
        oneofIndex: googleProtobuf.Message.getField(msg, 9),
        jsonName: googleProtobuf.Message.getField(msg, 10),
        options: (f = msg.getOptions()) && proto.google.protobuf.FieldOptions.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.FieldDescriptorProto}
     */
    proto.google.protobuf.FieldDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.FieldDescriptorProto;
      return proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.FieldDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.FieldDescriptorProto}
     */
    proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setNumber(value);
          break;
        case 4:
          var value = /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */ (reader.readEnum());
          msg.setLabel(value);
          break;
        case 5:
          var value = /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */ (reader.readEnum());
          msg.setType(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.setTypeName(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setExtendee(value);
          break;
        case 7:
          var value = /** @type {string} */ (reader.readString());
          msg.setDefaultValue(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setOneofIndex(value);
          break;
        case 10:
          var value = /** @type {string} */ (reader.readString());
          msg.setJsonName(value);
          break;
        case 8:
          var value = new proto.google.protobuf.FieldOptions;
          reader.readMessage(value,proto.google.protobuf.FieldOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.FieldDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeInt32(
          3,
          f
        );
      }
      f = /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeEnum(
          5,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeString(
          6,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeString(
          7,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeInt32(
          9,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeString(
          10,
          f
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          proto.google.protobuf.FieldOptions.serializeBinaryToWriter
        );
      }
    };


    /**
     * @enum {number}
     */
    proto.google.protobuf.FieldDescriptorProto.Type = {
      TYPE_DOUBLE: 1,
      TYPE_FLOAT: 2,
      TYPE_INT64: 3,
      TYPE_UINT64: 4,
      TYPE_INT32: 5,
      TYPE_FIXED64: 6,
      TYPE_FIXED32: 7,
      TYPE_BOOL: 8,
      TYPE_STRING: 9,
      TYPE_GROUP: 10,
      TYPE_MESSAGE: 11,
      TYPE_BYTES: 12,
      TYPE_UINT32: 13,
      TYPE_ENUM: 14,
      TYPE_SFIXED32: 15,
      TYPE_SFIXED64: 16,
      TYPE_SINT32: 17,
      TYPE_SINT64: 18
    };

    /**
     * @enum {number}
     */
    proto.google.protobuf.FieldDescriptorProto.Label = {
      LABEL_OPTIONAL: 1,
      LABEL_REQUIRED: 2,
      LABEL_REPEATED: 3
    };

    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional int32 number = 3;
     * @return {number}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getNumber = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setNumber = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearNumber = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasNumber = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional Label label = 4;
     * @return {!proto.google.protobuf.FieldDescriptorProto.Label}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getLabel = function() {
      return /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 1));
    };


    /** @param {!proto.google.protobuf.FieldDescriptorProto.Label} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setLabel = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearLabel = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasLabel = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional Type type = 5;
     * @return {!proto.google.protobuf.FieldDescriptorProto.Type}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getType = function() {
      return /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 1));
    };


    /** @param {!proto.google.protobuf.FieldDescriptorProto.Type} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setType = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearType = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasType = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional string type_name = 6;
     * @return {string}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getTypeName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setTypeName = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearTypeName = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasTypeName = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional string extendee = 2;
     * @return {string}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getExtendee = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setExtendee = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearExtendee = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasExtendee = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string default_value = 7;
     * @return {string}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getDefaultValue = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setDefaultValue = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearDefaultValue = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasDefaultValue = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional int32 oneof_index = 9;
     * @return {number}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getOneofIndex = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setOneofIndex = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearOneofIndex = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasOneofIndex = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional string json_name = 10;
     * @return {string}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getJsonName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setJsonName = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearJsonName = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasJsonName = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * optional FieldOptions options = 8;
     * @return {?proto.google.protobuf.FieldOptions}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.FieldOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.FieldOptions, 8));
    };


    /** @param {?proto.google.protobuf.FieldOptions|undefined} value */
    proto.google.protobuf.FieldDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 8, value);
    };


    proto.google.protobuf.FieldDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.OneofDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.OneofDescriptorProto, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.OneofDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.OneofDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.OneofDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.OneofDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        options: (f = msg.getOptions()) && proto.google.protobuf.OneofOptions.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.OneofDescriptorProto}
     */
    proto.google.protobuf.OneofDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.OneofDescriptorProto;
      return proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.OneofDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.OneofDescriptorProto}
     */
    proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = new proto.google.protobuf.OneofOptions;
          reader.readMessage(value,proto.google.protobuf.OneofOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.OneofDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.OneofDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          proto.google.protobuf.OneofOptions.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.OneofDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.OneofDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.OneofDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.OneofDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional OneofOptions options = 2;
     * @return {?proto.google.protobuf.OneofOptions}
     */
    proto.google.protobuf.OneofDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.OneofOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.OneofOptions, 2));
    };


    /** @param {?proto.google.protobuf.OneofOptions|undefined} value */
    proto.google.protobuf.OneofDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };


    proto.google.protobuf.OneofDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.OneofDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.EnumDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.EnumDescriptorProto.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.EnumDescriptorProto, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.EnumDescriptorProto.repeatedFields_ = [2,4,5];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.EnumDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.EnumDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        valueList: googleProtobuf.Message.toObjectList(msg.getValueList(),
        proto.google.protobuf.EnumValueDescriptorProto.toObject, includeInstance),
        options: (f = msg.getOptions()) && proto.google.protobuf.EnumOptions.toObject(includeInstance, f),
        reservedRangeList: googleProtobuf.Message.toObjectList(msg.getReservedRangeList(),
        proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject, includeInstance),
        reservedNameList: googleProtobuf.Message.getRepeatedField(msg, 5)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.EnumDescriptorProto}
     */
    proto.google.protobuf.EnumDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.EnumDescriptorProto;
      return proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.EnumDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.EnumDescriptorProto}
     */
    proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = new proto.google.protobuf.EnumValueDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader);
          msg.addValue(value);
          break;
        case 3:
          var value = new proto.google.protobuf.EnumOptions;
          reader.readMessage(value,proto.google.protobuf.EnumOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        case 4:
          var value = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange;
          reader.readMessage(value,proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader);
          msg.addReservedRange(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.addReservedName(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.EnumDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getValueList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          2,
          f,
          proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          proto.google.protobuf.EnumOptions.serializeBinaryToWriter
        );
      }
      f = message.getReservedRangeList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          4,
          f,
          proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter
        );
      }
      f = message.getReservedNameList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          5,
          f
        );
      }
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject = function(includeInstance, msg) {
      var obj = {
        start: googleProtobuf.Message.getField(msg, 1),
        end: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange;
      return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setStart(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setEnd(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeInt32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeInt32(
          2,
          f
        );
      }
    };


    /**
     * optional int32 start = 1;
     * @return {number}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getStart = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setStart = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearStart = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasStart = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional int32 end = 2;
     * @return {number}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getEnd = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setEnd = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearEnd = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasEnd = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.EnumDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.EnumDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated EnumValueDescriptorProto value = 2;
     * @return {!Array<!proto.google.protobuf.EnumValueDescriptorProto>}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.getValueList = function() {
      return /** @type{!Array<!proto.google.protobuf.EnumValueDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumValueDescriptorProto, 2));
    };


    /** @param {!Array<!proto.google.protobuf.EnumValueDescriptorProto>} value */
    proto.google.protobuf.EnumDescriptorProto.prototype.setValueList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };


    /**
     * @param {!proto.google.protobuf.EnumValueDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.EnumValueDescriptorProto}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.addValue = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.EnumValueDescriptorProto, opt_index);
    };


    proto.google.protobuf.EnumDescriptorProto.prototype.clearValueList = function() {
      this.setValueList([]);
    };


    /**
     * optional EnumOptions options = 3;
     * @return {?proto.google.protobuf.EnumOptions}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.EnumOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.EnumOptions, 3));
    };


    /** @param {?proto.google.protobuf.EnumOptions|undefined} value */
    proto.google.protobuf.EnumDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };


    proto.google.protobuf.EnumDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * repeated EnumReservedRange reserved_range = 4;
     * @return {!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.getReservedRangeList = function() {
      return /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, 4));
    };


    /** @param {!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>} value */
    proto.google.protobuf.EnumDescriptorProto.prototype.setReservedRangeList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 4, value);
    };


    /**
     * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.addReservedRange = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, opt_index);
    };


    proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedRangeList = function() {
      this.setReservedRangeList([]);
    };


    /**
     * repeated string reserved_name = 5;
     * @return {!Array<string>}
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.getReservedNameList = function() {
      return /** @type {!Array<string>} */ (googleProtobuf.Message.getRepeatedField(this, 5));
    };


    /** @param {!Array<string>} value */
    proto.google.protobuf.EnumDescriptorProto.prototype.setReservedNameList = function(value) {
      googleProtobuf.Message.setField(this, 5, value || []);
    };


    /**
     * @param {!string} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.EnumDescriptorProto.prototype.addReservedName = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 5, value, opt_index);
    };


    proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedNameList = function() {
      this.setReservedNameList([]);
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.EnumValueDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.EnumValueDescriptorProto, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.EnumValueDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.EnumValueDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumValueDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        number: googleProtobuf.Message.getField(msg, 2),
        options: (f = msg.getOptions()) && proto.google.protobuf.EnumValueOptions.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.EnumValueDescriptorProto}
     */
    proto.google.protobuf.EnumValueDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.EnumValueDescriptorProto;
      return proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.EnumValueDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.EnumValueDescriptorProto}
     */
    proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setNumber(value);
          break;
        case 3:
          var value = new proto.google.protobuf.EnumValueOptions;
          reader.readMessage(value,proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.EnumValueDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeInt32(
          2,
          f
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.EnumValueDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional int32 number = 2;
     * @return {number}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.getNumber = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.setNumber = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.EnumValueDescriptorProto.prototype.clearNumber = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.hasNumber = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional EnumValueOptions options = 3;
     * @return {?proto.google.protobuf.EnumValueOptions}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.EnumValueOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.EnumValueOptions, 3));
    };


    /** @param {?proto.google.protobuf.EnumValueOptions|undefined} value */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };


    proto.google.protobuf.EnumValueDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumValueDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.ServiceDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.ServiceDescriptorProto.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.ServiceDescriptorProto, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.ServiceDescriptorProto.repeatedFields_ = [2];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.ServiceDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.ServiceDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.ServiceDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        methodList: googleProtobuf.Message.toObjectList(msg.getMethodList(),
        proto.google.protobuf.MethodDescriptorProto.toObject, includeInstance),
        options: (f = msg.getOptions()) && proto.google.protobuf.ServiceOptions.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.ServiceDescriptorProto}
     */
    proto.google.protobuf.ServiceDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.ServiceDescriptorProto;
      return proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.ServiceDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.ServiceDescriptorProto}
     */
    proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = new proto.google.protobuf.MethodDescriptorProto;
          reader.readMessage(value,proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader);
          msg.addMethod(value);
          break;
        case 3:
          var value = new proto.google.protobuf.ServiceOptions;
          reader.readMessage(value,proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.ServiceDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getMethodList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          2,
          f,
          proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          proto.google.protobuf.ServiceOptions.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.ServiceDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.ServiceDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated MethodDescriptorProto method = 2;
     * @return {!Array<!proto.google.protobuf.MethodDescriptorProto>}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.getMethodList = function() {
      return /** @type{!Array<!proto.google.protobuf.MethodDescriptorProto>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.MethodDescriptorProto, 2));
    };


    /** @param {!Array<!proto.google.protobuf.MethodDescriptorProto>} value */
    proto.google.protobuf.ServiceDescriptorProto.prototype.setMethodList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };


    /**
     * @param {!proto.google.protobuf.MethodDescriptorProto=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.MethodDescriptorProto}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.addMethod = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.MethodDescriptorProto, opt_index);
    };


    proto.google.protobuf.ServiceDescriptorProto.prototype.clearMethodList = function() {
      this.setMethodList([]);
    };


    /**
     * optional ServiceOptions options = 3;
     * @return {?proto.google.protobuf.ServiceOptions}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.ServiceOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.ServiceOptions, 3));
    };


    /** @param {?proto.google.protobuf.ServiceOptions|undefined} value */
    proto.google.protobuf.ServiceDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };


    proto.google.protobuf.ServiceDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.ServiceDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.MethodDescriptorProto = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.MethodDescriptorProto, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.MethodDescriptorProto.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.MethodDescriptorProto} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.MethodDescriptorProto.toObject = function(includeInstance, msg) {
      var f, obj = {
        name: googleProtobuf.Message.getField(msg, 1),
        inputType: googleProtobuf.Message.getField(msg, 2),
        outputType: googleProtobuf.Message.getField(msg, 3),
        options: (f = msg.getOptions()) && proto.google.protobuf.MethodOptions.toObject(includeInstance, f),
        clientStreaming: googleProtobuf.Message.getFieldWithDefault(msg, 5, false),
        serverStreaming: googleProtobuf.Message.getFieldWithDefault(msg, 6, false)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.MethodDescriptorProto}
     */
    proto.google.protobuf.MethodDescriptorProto.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.MethodDescriptorProto;
      return proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.MethodDescriptorProto} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.MethodDescriptorProto}
     */
    proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setName(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setInputType(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setOutputType(value);
          break;
        case 4:
          var value = new proto.google.protobuf.MethodOptions;
          reader.readMessage(value,proto.google.protobuf.MethodOptions.deserializeBinaryFromReader);
          msg.setOptions(value);
          break;
        case 5:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setClientStreaming(value);
          break;
        case 6:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setServerStreaming(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.MethodDescriptorProto} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = message.getOptions();
      if (f != null) {
        writer.writeMessage(
          4,
          f,
          proto.google.protobuf.MethodOptions.serializeBinaryToWriter
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBool(
          5,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBool(
          6,
          f
        );
      }
    };


    /**
     * optional string name = 1;
     * @return {string}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.getName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.MethodDescriptorProto.prototype.setName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.MethodDescriptorProto.prototype.clearName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.hasName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string input_type = 2;
     * @return {string}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.getInputType = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.MethodDescriptorProto.prototype.setInputType = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.MethodDescriptorProto.prototype.clearInputType = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.hasInputType = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string output_type = 3;
     * @return {string}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.getOutputType = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.MethodDescriptorProto.prototype.setOutputType = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.MethodDescriptorProto.prototype.clearOutputType = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.hasOutputType = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional MethodOptions options = 4;
     * @return {?proto.google.protobuf.MethodOptions}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.getOptions = function() {
      return /** @type{?proto.google.protobuf.MethodOptions} */ (
        googleProtobuf.Message.getWrapperField(this, proto.google.protobuf.MethodOptions, 4));
    };


    /** @param {?proto.google.protobuf.MethodOptions|undefined} value */
    proto.google.protobuf.MethodDescriptorProto.prototype.setOptions = function(value) {
      googleProtobuf.Message.setWrapperField(this, 4, value);
    };


    proto.google.protobuf.MethodDescriptorProto.prototype.clearOptions = function() {
      this.setOptions(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.hasOptions = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional bool client_streaming = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.getClientStreaming = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MethodDescriptorProto.prototype.setClientStreaming = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.google.protobuf.MethodDescriptorProto.prototype.clearClientStreaming = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.hasClientStreaming = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bool server_streaming = 6;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.getServerStreaming = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MethodDescriptorProto.prototype.setServerStreaming = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.google.protobuf.MethodDescriptorProto.prototype.clearServerStreaming = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodDescriptorProto.prototype.hasServerStreaming = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.FileOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.FileOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.FileOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.FileOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.FileOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.FileOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.FileOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FileOptions.toObject = function(includeInstance, msg) {
      var obj = {
        javaPackage: googleProtobuf.Message.getField(msg, 1),
        javaOuterClassname: googleProtobuf.Message.getField(msg, 8),
        javaMultipleFiles: googleProtobuf.Message.getFieldWithDefault(msg, 10, false),
        javaGenerateEqualsAndHash: googleProtobuf.Message.getField(msg, 20),
        javaStringCheckUtf8: googleProtobuf.Message.getFieldWithDefault(msg, 27, false),
        optimizeFor: googleProtobuf.Message.getFieldWithDefault(msg, 9, 1),
        goPackage: googleProtobuf.Message.getField(msg, 11),
        ccGenericServices: googleProtobuf.Message.getFieldWithDefault(msg, 16, false),
        javaGenericServices: googleProtobuf.Message.getFieldWithDefault(msg, 17, false),
        pyGenericServices: googleProtobuf.Message.getFieldWithDefault(msg, 18, false),
        phpGenericServices: googleProtobuf.Message.getFieldWithDefault(msg, 42, false),
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 23, false),
        ccEnableArenas: googleProtobuf.Message.getFieldWithDefault(msg, 31, false),
        objcClassPrefix: googleProtobuf.Message.getField(msg, 36),
        csharpNamespace: googleProtobuf.Message.getField(msg, 37),
        swiftPrefix: googleProtobuf.Message.getField(msg, 39),
        phpClassPrefix: googleProtobuf.Message.getField(msg, 40),
        phpNamespace: googleProtobuf.Message.getField(msg, 41),
        phpMetadataNamespace: googleProtobuf.Message.getField(msg, 44),
        rubyPackage: googleProtobuf.Message.getField(msg, 45),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.FileOptions.extensions, proto.google.protobuf.FileOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.FileOptions}
     */
    proto.google.protobuf.FileOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.FileOptions;
      return proto.google.protobuf.FileOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.FileOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.FileOptions}
     */
    proto.google.protobuf.FileOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setJavaPackage(value);
          break;
        case 8:
          var value = /** @type {string} */ (reader.readString());
          msg.setJavaOuterClassname(value);
          break;
        case 10:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setJavaMultipleFiles(value);
          break;
        case 20:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setJavaGenerateEqualsAndHash(value);
          break;
        case 27:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setJavaStringCheckUtf8(value);
          break;
        case 9:
          var value = /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */ (reader.readEnum());
          msg.setOptimizeFor(value);
          break;
        case 11:
          var value = /** @type {string} */ (reader.readString());
          msg.setGoPackage(value);
          break;
        case 16:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setCcGenericServices(value);
          break;
        case 17:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setJavaGenericServices(value);
          break;
        case 18:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPyGenericServices(value);
          break;
        case 42:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPhpGenericServices(value);
          break;
        case 23:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 31:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setCcEnableArenas(value);
          break;
        case 36:
          var value = /** @type {string} */ (reader.readString());
          msg.setObjcClassPrefix(value);
          break;
        case 37:
          var value = /** @type {string} */ (reader.readString());
          msg.setCsharpNamespace(value);
          break;
        case 39:
          var value = /** @type {string} */ (reader.readString());
          msg.setSwiftPrefix(value);
          break;
        case 40:
          var value = /** @type {string} */ (reader.readString());
          msg.setPhpClassPrefix(value);
          break;
        case 41:
          var value = /** @type {string} */ (reader.readString());
          msg.setPhpNamespace(value);
          break;
        case 44:
          var value = /** @type {string} */ (reader.readString());
          msg.setPhpMetadataNamespace(value);
          break;
        case 45:
          var value = /** @type {string} */ (reader.readString());
          msg.setRubyPackage(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.FileOptions.extensionsBinary,
            proto.google.protobuf.FileOptions.prototype.getExtension,
            proto.google.protobuf.FileOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.FileOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.FileOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.FileOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FileOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeString(
          8,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeBool(
          10,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 20));
      if (f != null) {
        writer.writeBool(
          20,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 27));
      if (f != null) {
        writer.writeBool(
          27,
          f
        );
      }
      f = /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeEnum(
          9,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 11));
      if (f != null) {
        writer.writeString(
          11,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 16));
      if (f != null) {
        writer.writeBool(
          16,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 17));
      if (f != null) {
        writer.writeBool(
          17,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 18));
      if (f != null) {
        writer.writeBool(
          18,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 42));
      if (f != null) {
        writer.writeBool(
          42,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 23));
      if (f != null) {
        writer.writeBool(
          23,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 31));
      if (f != null) {
        writer.writeBool(
          31,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 36));
      if (f != null) {
        writer.writeString(
          36,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 37));
      if (f != null) {
        writer.writeString(
          37,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 39));
      if (f != null) {
        writer.writeString(
          39,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 40));
      if (f != null) {
        writer.writeString(
          40,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 41));
      if (f != null) {
        writer.writeString(
          41,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 44));
      if (f != null) {
        writer.writeString(
          44,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 45));
      if (f != null) {
        writer.writeString(
          45,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.FileOptions.extensionsBinary, proto.google.protobuf.FileOptions.prototype.getExtension);
    };


    /**
     * @enum {number}
     */
    proto.google.protobuf.FileOptions.OptimizeMode = {
      SPEED: 1,
      CODE_SIZE: 2,
      LITE_RUNTIME: 3
    };

    /**
     * optional string java_package = 1;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getJavaPackage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setJavaPackage = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearJavaPackage = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasJavaPackage = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string java_outer_classname = 8;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getJavaOuterClassname = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setJavaOuterClassname = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearJavaOuterClassname = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasJavaOuterClassname = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional bool java_multiple_files = 10;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getJavaMultipleFiles = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setJavaMultipleFiles = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearJavaMultipleFiles = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasJavaMultipleFiles = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * optional bool java_generate_equals_and_hash = 20;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getJavaGenerateEqualsAndHash = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 20, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setJavaGenerateEqualsAndHash = function(value) {
      googleProtobuf.Message.setField(this, 20, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearJavaGenerateEqualsAndHash = function() {
      googleProtobuf.Message.setField(this, 20, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasJavaGenerateEqualsAndHash = function() {
      return googleProtobuf.Message.getField(this, 20) != null;
    };


    /**
     * optional bool java_string_check_utf8 = 27;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getJavaStringCheckUtf8 = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 27, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setJavaStringCheckUtf8 = function(value) {
      googleProtobuf.Message.setField(this, 27, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearJavaStringCheckUtf8 = function() {
      googleProtobuf.Message.setField(this, 27, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasJavaStringCheckUtf8 = function() {
      return googleProtobuf.Message.getField(this, 27) != null;
    };


    /**
     * optional OptimizeMode optimize_for = 9;
     * @return {!proto.google.protobuf.FileOptions.OptimizeMode}
     */
    proto.google.protobuf.FileOptions.prototype.getOptimizeFor = function() {
      return /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 1));
    };


    /** @param {!proto.google.protobuf.FileOptions.OptimizeMode} value */
    proto.google.protobuf.FileOptions.prototype.setOptimizeFor = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearOptimizeFor = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasOptimizeFor = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional string go_package = 11;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getGoPackage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 11, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setGoPackage = function(value) {
      googleProtobuf.Message.setField(this, 11, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearGoPackage = function() {
      googleProtobuf.Message.setField(this, 11, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasGoPackage = function() {
      return googleProtobuf.Message.getField(this, 11) != null;
    };


    /**
     * optional bool cc_generic_services = 16;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getCcGenericServices = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 16, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setCcGenericServices = function(value) {
      googleProtobuf.Message.setField(this, 16, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearCcGenericServices = function() {
      googleProtobuf.Message.setField(this, 16, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasCcGenericServices = function() {
      return googleProtobuf.Message.getField(this, 16) != null;
    };


    /**
     * optional bool java_generic_services = 17;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getJavaGenericServices = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 17, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setJavaGenericServices = function(value) {
      googleProtobuf.Message.setField(this, 17, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearJavaGenericServices = function() {
      googleProtobuf.Message.setField(this, 17, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasJavaGenericServices = function() {
      return googleProtobuf.Message.getField(this, 17) != null;
    };


    /**
     * optional bool py_generic_services = 18;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getPyGenericServices = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 18, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setPyGenericServices = function(value) {
      googleProtobuf.Message.setField(this, 18, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearPyGenericServices = function() {
      googleProtobuf.Message.setField(this, 18, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasPyGenericServices = function() {
      return googleProtobuf.Message.getField(this, 18) != null;
    };


    /**
     * optional bool php_generic_services = 42;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getPhpGenericServices = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 42, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setPhpGenericServices = function(value) {
      googleProtobuf.Message.setField(this, 42, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearPhpGenericServices = function() {
      googleProtobuf.Message.setField(this, 42, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasPhpGenericServices = function() {
      return googleProtobuf.Message.getField(this, 42) != null;
    };


    /**
     * optional bool deprecated = 23;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 23, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 23, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 23, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 23) != null;
    };


    /**
     * optional bool cc_enable_arenas = 31;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FileOptions.prototype.getCcEnableArenas = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 31, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FileOptions.prototype.setCcEnableArenas = function(value) {
      googleProtobuf.Message.setField(this, 31, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearCcEnableArenas = function() {
      googleProtobuf.Message.setField(this, 31, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasCcEnableArenas = function() {
      return googleProtobuf.Message.getField(this, 31) != null;
    };


    /**
     * optional string objc_class_prefix = 36;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getObjcClassPrefix = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 36, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setObjcClassPrefix = function(value) {
      googleProtobuf.Message.setField(this, 36, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearObjcClassPrefix = function() {
      googleProtobuf.Message.setField(this, 36, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasObjcClassPrefix = function() {
      return googleProtobuf.Message.getField(this, 36) != null;
    };


    /**
     * optional string csharp_namespace = 37;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getCsharpNamespace = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 37, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setCsharpNamespace = function(value) {
      googleProtobuf.Message.setField(this, 37, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearCsharpNamespace = function() {
      googleProtobuf.Message.setField(this, 37, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasCsharpNamespace = function() {
      return googleProtobuf.Message.getField(this, 37) != null;
    };


    /**
     * optional string swift_prefix = 39;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getSwiftPrefix = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 39, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setSwiftPrefix = function(value) {
      googleProtobuf.Message.setField(this, 39, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearSwiftPrefix = function() {
      googleProtobuf.Message.setField(this, 39, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasSwiftPrefix = function() {
      return googleProtobuf.Message.getField(this, 39) != null;
    };


    /**
     * optional string php_class_prefix = 40;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getPhpClassPrefix = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 40, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setPhpClassPrefix = function(value) {
      googleProtobuf.Message.setField(this, 40, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearPhpClassPrefix = function() {
      googleProtobuf.Message.setField(this, 40, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasPhpClassPrefix = function() {
      return googleProtobuf.Message.getField(this, 40) != null;
    };


    /**
     * optional string php_namespace = 41;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getPhpNamespace = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 41, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setPhpNamespace = function(value) {
      googleProtobuf.Message.setField(this, 41, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearPhpNamespace = function() {
      googleProtobuf.Message.setField(this, 41, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasPhpNamespace = function() {
      return googleProtobuf.Message.getField(this, 41) != null;
    };


    /**
     * optional string php_metadata_namespace = 44;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getPhpMetadataNamespace = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 44, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setPhpMetadataNamespace = function(value) {
      googleProtobuf.Message.setField(this, 44, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearPhpMetadataNamespace = function() {
      googleProtobuf.Message.setField(this, 44, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasPhpMetadataNamespace = function() {
      return googleProtobuf.Message.getField(this, 44) != null;
    };


    /**
     * optional string ruby_package = 45;
     * @return {string}
     */
    proto.google.protobuf.FileOptions.prototype.getRubyPackage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 45, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.FileOptions.prototype.setRubyPackage = function(value) {
      googleProtobuf.Message.setField(this, 45, value);
    };


    proto.google.protobuf.FileOptions.prototype.clearRubyPackage = function() {
      googleProtobuf.Message.setField(this, 45, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FileOptions.prototype.hasRubyPackage = function() {
      return googleProtobuf.Message.getField(this, 45) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.FileOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.FileOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.FileOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.FileOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.FileOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.FileOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.MessageOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.MessageOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.MessageOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.MessageOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.MessageOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.MessageOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.MessageOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.MessageOptions.toObject = function(includeInstance, msg) {
      var obj = {
        messageSetWireFormat: googleProtobuf.Message.getFieldWithDefault(msg, 1, false),
        noStandardDescriptorAccessor: googleProtobuf.Message.getFieldWithDefault(msg, 2, false),
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 3, false),
        mapEntry: googleProtobuf.Message.getField(msg, 7),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.MessageOptions.extensions, proto.google.protobuf.MessageOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.MessageOptions}
     */
    proto.google.protobuf.MessageOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.MessageOptions;
      return proto.google.protobuf.MessageOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.MessageOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.MessageOptions}
     */
    proto.google.protobuf.MessageOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setMessageSetWireFormat(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setNoStandardDescriptorAccessor(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 7:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setMapEntry(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.MessageOptions.extensionsBinary,
            proto.google.protobuf.MessageOptions.prototype.getExtension,
            proto.google.protobuf.MessageOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.MessageOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.MessageOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.MessageOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.MessageOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBool(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBool(
          7,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.MessageOptions.extensionsBinary, proto.google.protobuf.MessageOptions.prototype.getExtension);
    };


    /**
     * optional bool message_set_wire_format = 1;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.getMessageSetWireFormat = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MessageOptions.prototype.setMessageSetWireFormat = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.MessageOptions.prototype.clearMessageSetWireFormat = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.hasMessageSetWireFormat = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bool no_standard_descriptor_accessor = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.getNoStandardDescriptorAccessor = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MessageOptions.prototype.setNoStandardDescriptorAccessor = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.MessageOptions.prototype.clearNoStandardDescriptorAccessor = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.hasNoStandardDescriptorAccessor = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool deprecated = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MessageOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.MessageOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bool map_entry = 7;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.getMapEntry = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MessageOptions.prototype.setMapEntry = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.google.protobuf.MessageOptions.prototype.clearMapEntry = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MessageOptions.prototype.hasMapEntry = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.MessageOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.MessageOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.MessageOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.MessageOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.MessageOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.MessageOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.FieldOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.FieldOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.FieldOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.FieldOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.FieldOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.FieldOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.FieldOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FieldOptions.toObject = function(includeInstance, msg) {
      var obj = {
        ctype: googleProtobuf.Message.getFieldWithDefault(msg, 1, 0),
        packed: googleProtobuf.Message.getField(msg, 2),
        jstype: googleProtobuf.Message.getFieldWithDefault(msg, 6, 0),
        lazy: googleProtobuf.Message.getFieldWithDefault(msg, 5, false),
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 3, false),
        weak: googleProtobuf.Message.getFieldWithDefault(msg, 10, false),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.FieldOptions.extensions, proto.google.protobuf.FieldOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.FieldOptions}
     */
    proto.google.protobuf.FieldOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.FieldOptions;
      return proto.google.protobuf.FieldOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.FieldOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.FieldOptions}
     */
    proto.google.protobuf.FieldOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!proto.google.protobuf.FieldOptions.CType} */ (reader.readEnum());
          msg.setCtype(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPacked(value);
          break;
        case 6:
          var value = /** @type {!proto.google.protobuf.FieldOptions.JSType} */ (reader.readEnum());
          msg.setJstype(value);
          break;
        case 5:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setLazy(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 10:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setWeak(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.FieldOptions.extensionsBinary,
            proto.google.protobuf.FieldOptions.prototype.getExtension,
            proto.google.protobuf.FieldOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.FieldOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.FieldOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.FieldOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.FieldOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!proto.google.protobuf.FieldOptions.CType} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeEnum(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
      f = /** @type {!proto.google.protobuf.FieldOptions.JSType} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeEnum(
          6,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBool(
          5,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeBool(
          10,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.FieldOptions.extensionsBinary, proto.google.protobuf.FieldOptions.prototype.getExtension);
    };


    /**
     * @enum {number}
     */
    proto.google.protobuf.FieldOptions.CType = {
      STRING: 0,
      CORD: 1,
      STRING_PIECE: 2
    };

    /**
     * @enum {number}
     */
    proto.google.protobuf.FieldOptions.JSType = {
      JS_NORMAL: 0,
      JS_STRING: 1,
      JS_NUMBER: 2
    };

    /**
     * optional CType ctype = 1;
     * @return {!proto.google.protobuf.FieldOptions.CType}
     */
    proto.google.protobuf.FieldOptions.prototype.getCtype = function() {
      return /** @type {!proto.google.protobuf.FieldOptions.CType} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {!proto.google.protobuf.FieldOptions.CType} value */
    proto.google.protobuf.FieldOptions.prototype.setCtype = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.FieldOptions.prototype.clearCtype = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.hasCtype = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bool packed = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.getPacked = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FieldOptions.prototype.setPacked = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.FieldOptions.prototype.clearPacked = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.hasPacked = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional JSType jstype = 6;
     * @return {!proto.google.protobuf.FieldOptions.JSType}
     */
    proto.google.protobuf.FieldOptions.prototype.getJstype = function() {
      return /** @type {!proto.google.protobuf.FieldOptions.JSType} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, 0));
    };


    /** @param {!proto.google.protobuf.FieldOptions.JSType} value */
    proto.google.protobuf.FieldOptions.prototype.setJstype = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.google.protobuf.FieldOptions.prototype.clearJstype = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.hasJstype = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bool lazy = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.getLazy = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FieldOptions.prototype.setLazy = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.google.protobuf.FieldOptions.prototype.clearLazy = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.hasLazy = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bool deprecated = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FieldOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.FieldOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bool weak = 10;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.getWeak = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.FieldOptions.prototype.setWeak = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.google.protobuf.FieldOptions.prototype.clearWeak = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.FieldOptions.prototype.hasWeak = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.FieldOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.FieldOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.FieldOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.FieldOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.FieldOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.FieldOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.OneofOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.OneofOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.OneofOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.OneofOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.OneofOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.OneofOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.OneofOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.OneofOptions.toObject = function(includeInstance, msg) {
      var obj = {
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.OneofOptions.extensions, proto.google.protobuf.OneofOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.OneofOptions}
     */
    proto.google.protobuf.OneofOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.OneofOptions;
      return proto.google.protobuf.OneofOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.OneofOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.OneofOptions}
     */
    proto.google.protobuf.OneofOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.OneofOptions.extensionsBinary,
            proto.google.protobuf.OneofOptions.prototype.getExtension,
            proto.google.protobuf.OneofOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.OneofOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.OneofOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.OneofOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.OneofOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.OneofOptions.extensionsBinary, proto.google.protobuf.OneofOptions.prototype.getExtension);
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.OneofOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.OneofOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.OneofOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.OneofOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.OneofOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.OneofOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.EnumOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.EnumOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.EnumOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.EnumOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.EnumOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.EnumOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.EnumOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumOptions.toObject = function(includeInstance, msg) {
      var obj = {
        allowAlias: googleProtobuf.Message.getField(msg, 2),
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 3, false),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.EnumOptions.extensions, proto.google.protobuf.EnumOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.EnumOptions}
     */
    proto.google.protobuf.EnumOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.EnumOptions;
      return proto.google.protobuf.EnumOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.EnumOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.EnumOptions}
     */
    proto.google.protobuf.EnumOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setAllowAlias(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.EnumOptions.extensionsBinary,
            proto.google.protobuf.EnumOptions.prototype.getExtension,
            proto.google.protobuf.EnumOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.EnumOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.EnumOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.EnumOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.EnumOptions.extensionsBinary, proto.google.protobuf.EnumOptions.prototype.getExtension);
    };


    /**
     * optional bool allow_alias = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.EnumOptions.prototype.getAllowAlias = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.EnumOptions.prototype.setAllowAlias = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.EnumOptions.prototype.clearAllowAlias = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumOptions.prototype.hasAllowAlias = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool deprecated = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.EnumOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.EnumOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.EnumOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.EnumOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.EnumOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.EnumOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.EnumOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.EnumOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.EnumOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.EnumValueOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.EnumValueOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.EnumValueOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.EnumValueOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.EnumValueOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.EnumValueOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.EnumValueOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumValueOptions.toObject = function(includeInstance, msg) {
      var obj = {
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 1, false),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.EnumValueOptions.extensions, proto.google.protobuf.EnumValueOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.EnumValueOptions}
     */
    proto.google.protobuf.EnumValueOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.EnumValueOptions;
      return proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.EnumValueOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.EnumValueOptions}
     */
    proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.EnumValueOptions.extensionsBinary,
            proto.google.protobuf.EnumValueOptions.prototype.getExtension,
            proto.google.protobuf.EnumValueOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.EnumValueOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.EnumValueOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBool(
          1,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.EnumValueOptions.extensionsBinary, proto.google.protobuf.EnumValueOptions.prototype.getExtension);
    };


    /**
     * optional bool deprecated = 1;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.EnumValueOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.EnumValueOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.EnumValueOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.EnumValueOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.EnumValueOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.EnumValueOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.EnumValueOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.EnumValueOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.EnumValueOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.EnumValueOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.ServiceOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.ServiceOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.ServiceOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.ServiceOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.ServiceOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.ServiceOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.ServiceOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.ServiceOptions.toObject = function(includeInstance, msg) {
      var obj = {
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 33, false),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.ServiceOptions.extensions, proto.google.protobuf.ServiceOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.ServiceOptions}
     */
    proto.google.protobuf.ServiceOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.ServiceOptions;
      return proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.ServiceOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.ServiceOptions}
     */
    proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 33:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.ServiceOptions.extensionsBinary,
            proto.google.protobuf.ServiceOptions.prototype.getExtension,
            proto.google.protobuf.ServiceOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.ServiceOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.ServiceOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.ServiceOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.ServiceOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 33));
      if (f != null) {
        writer.writeBool(
          33,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.ServiceOptions.extensionsBinary, proto.google.protobuf.ServiceOptions.prototype.getExtension);
    };


    /**
     * optional bool deprecated = 33;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.ServiceOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 33, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.ServiceOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 33, value);
    };


    proto.google.protobuf.ServiceOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 33, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.ServiceOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 33) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.ServiceOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.ServiceOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.ServiceOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.ServiceOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.ServiceOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.ServiceOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.MethodOptions = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.MethodOptions.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.MethodOptions, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.MethodOptions.repeatedFields_ = [999];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.MethodOptions.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.MethodOptions.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.MethodOptions} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.MethodOptions.toObject = function(includeInstance, msg) {
      var obj = {
        deprecated: googleProtobuf.Message.getFieldWithDefault(msg, 33, false),
        idempotencyLevel: googleProtobuf.Message.getFieldWithDefault(msg, 34, 0),
        uninterpretedOptionList: googleProtobuf.Message.toObjectList(msg.getUninterpretedOptionList(),
        proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
      };

      googleProtobuf.Message.toObjectExtension(/** @type {!jspb.Message} */ (msg), obj,
          proto.google.protobuf.MethodOptions.extensions, proto.google.protobuf.MethodOptions.prototype.getExtension,
          includeInstance);
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.MethodOptions}
     */
    proto.google.protobuf.MethodOptions.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.MethodOptions;
      return proto.google.protobuf.MethodOptions.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.MethodOptions} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.MethodOptions}
     */
    proto.google.protobuf.MethodOptions.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 33:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDeprecated(value);
          break;
        case 34:
          var value = /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */ (reader.readEnum());
          msg.setIdempotencyLevel(value);
          break;
        case 999:
          var value = new proto.google.protobuf.UninterpretedOption;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
          msg.addUninterpretedOption(value);
          break;
        default:
          googleProtobuf.Message.readBinaryExtension(msg, reader, proto.google.protobuf.MethodOptions.extensionsBinary,
            proto.google.protobuf.MethodOptions.prototype.getExtension,
            proto.google.protobuf.MethodOptions.prototype.setExtension);
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.MethodOptions.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.MethodOptions.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.MethodOptions} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.MethodOptions.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 33));
      if (f != null) {
        writer.writeBool(
          33,
          f
        );
      }
      f = /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */ (googleProtobuf.Message.getField(message, 34));
      if (f != null) {
        writer.writeEnum(
          34,
          f
        );
      }
      f = message.getUninterpretedOptionList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          999,
          f,
          proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter
        );
      }
      googleProtobuf.Message.serializeBinaryExtensions(message, writer,
        proto.google.protobuf.MethodOptions.extensionsBinary, proto.google.protobuf.MethodOptions.prototype.getExtension);
    };


    /**
     * @enum {number}
     */
    proto.google.protobuf.MethodOptions.IdempotencyLevel = {
      IDEMPOTENCY_UNKNOWN: 0,
      NO_SIDE_EFFECTS: 1,
      IDEMPOTENT: 2
    };

    /**
     * optional bool deprecated = 33;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.MethodOptions.prototype.getDeprecated = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 33, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.MethodOptions.prototype.setDeprecated = function(value) {
      googleProtobuf.Message.setField(this, 33, value);
    };


    proto.google.protobuf.MethodOptions.prototype.clearDeprecated = function() {
      googleProtobuf.Message.setField(this, 33, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodOptions.prototype.hasDeprecated = function() {
      return googleProtobuf.Message.getField(this, 33) != null;
    };


    /**
     * optional IdempotencyLevel idempotency_level = 34;
     * @return {!proto.google.protobuf.MethodOptions.IdempotencyLevel}
     */
    proto.google.protobuf.MethodOptions.prototype.getIdempotencyLevel = function() {
      return /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */ (googleProtobuf.Message.getFieldWithDefault(this, 34, 0));
    };


    /** @param {!proto.google.protobuf.MethodOptions.IdempotencyLevel} value */
    proto.google.protobuf.MethodOptions.prototype.setIdempotencyLevel = function(value) {
      googleProtobuf.Message.setField(this, 34, value);
    };


    proto.google.protobuf.MethodOptions.prototype.clearIdempotencyLevel = function() {
      googleProtobuf.Message.setField(this, 34, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.MethodOptions.prototype.hasIdempotencyLevel = function() {
      return googleProtobuf.Message.getField(this, 34) != null;
    };


    /**
     * repeated UninterpretedOption uninterpreted_option = 999;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
     */
    proto.google.protobuf.MethodOptions.prototype.getUninterpretedOptionList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption>} value */
    proto.google.protobuf.MethodOptions.prototype.setUninterpretedOptionList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 999, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.MethodOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
    };


    proto.google.protobuf.MethodOptions.prototype.clearUninterpretedOptionList = function() {
      this.setUninterpretedOptionList([]);
    };



    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldInfo>}
     */
    proto.google.protobuf.MethodOptions.extensions = {};


    /**
     * The extensions registered with this message class. This is a map of
     * extension field number to fieldInfo object.
     *
     * For example:
     *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
     *
     * fieldName contains the JsCompiler renamed field name property so that it
     * works in OPTIMIZED mode.
     *
     * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
     */
    proto.google.protobuf.MethodOptions.extensionsBinary = {};


    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.UninterpretedOption = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.UninterpretedOption.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.UninterpretedOption, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.UninterpretedOption.repeatedFields_ = [2];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.UninterpretedOption.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.UninterpretedOption.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.UninterpretedOption} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.UninterpretedOption.toObject = function(includeInstance, msg) {
      var obj = {
        nameList: googleProtobuf.Message.toObjectList(msg.getNameList(),
        proto.google.protobuf.UninterpretedOption.NamePart.toObject, includeInstance),
        identifierValue: googleProtobuf.Message.getField(msg, 3),
        positiveIntValue: googleProtobuf.Message.getField(msg, 4),
        negativeIntValue: googleProtobuf.Message.getField(msg, 5),
        doubleValue: googleProtobuf.Message.getOptionalFloatingPointField(msg, 6),
        stringValue: msg.getStringValue_asB64(),
        aggregateValue: googleProtobuf.Message.getField(msg, 8)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.UninterpretedOption.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.UninterpretedOption;
      return proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.UninterpretedOption} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.UninterpretedOption}
     */
    proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 2:
          var value = new proto.google.protobuf.UninterpretedOption.NamePart;
          reader.readMessage(value,proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader);
          msg.addName(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setIdentifierValue(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setPositiveIntValue(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readInt64());
          msg.setNegativeIntValue(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readDouble());
          msg.setDoubleValue(value);
          break;
        case 7:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setStringValue(value);
          break;
        case 8:
          var value = /** @type {string} */ (reader.readString());
          msg.setAggregateValue(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.UninterpretedOption.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.UninterpretedOption} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getNameList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          2,
          f,
          proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint64(
          4,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeInt64(
          5,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeDouble(
          6,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBytes(
          7,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeString(
          8,
          f
        );
      }
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.UninterpretedOption.NamePart = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.google.protobuf.UninterpretedOption.NamePart, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.UninterpretedOption.NamePart.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.UninterpretedOption.NamePart} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.UninterpretedOption.NamePart.toObject = function(includeInstance, msg) {
      var obj = {
        namePart: googleProtobuf.Message.getField(msg, 1),
        isExtension: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.UninterpretedOption.NamePart}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.UninterpretedOption.NamePart;
      return proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.UninterpretedOption.NamePart} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.UninterpretedOption.NamePart}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setNamePart(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setIsExtension(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.UninterpretedOption.NamePart} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
    };


    /**
     * required string name_part = 1;
     * @return {string}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.getNamePart = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.setNamePart = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearNamePart = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasNamePart = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required bool is_extension = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.getIsExtension = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.setIsExtension = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearIsExtension = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasIsExtension = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * repeated NamePart name = 2;
     * @return {!Array<!proto.google.protobuf.UninterpretedOption.NamePart>}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getNameList = function() {
      return /** @type{!Array<!proto.google.protobuf.UninterpretedOption.NamePart>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption.NamePart, 2));
    };


    /** @param {!Array<!proto.google.protobuf.UninterpretedOption.NamePart>} value */
    proto.google.protobuf.UninterpretedOption.prototype.setNameList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };


    /**
     * @param {!proto.google.protobuf.UninterpretedOption.NamePart=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.UninterpretedOption.NamePart}
     */
    proto.google.protobuf.UninterpretedOption.prototype.addName = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.UninterpretedOption.NamePart, opt_index);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearNameList = function() {
      this.setNameList([]);
    };


    /**
     * optional string identifier_value = 3;
     * @return {string}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getIdentifierValue = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.UninterpretedOption.prototype.setIdentifierValue = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearIdentifierValue = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.prototype.hasIdentifierValue = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint64 positive_int_value = 4;
     * @return {number}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getPositiveIntValue = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.UninterpretedOption.prototype.setPositiveIntValue = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearPositiveIntValue = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.prototype.hasPositiveIntValue = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional int64 negative_int_value = 5;
     * @return {number}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getNegativeIntValue = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.UninterpretedOption.prototype.setNegativeIntValue = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearNegativeIntValue = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.prototype.hasNegativeIntValue = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional double double_value = 6;
     * @return {number}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getDoubleValue = function() {
      return /** @type {number} */ (+googleProtobuf.Message.getFieldWithDefault(this, 6, 0.0));
    };


    /** @param {number} value */
    proto.google.protobuf.UninterpretedOption.prototype.setDoubleValue = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearDoubleValue = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.prototype.hasDoubleValue = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bytes string_value = 7;
     * @return {!(string|Uint8Array)}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getStringValue = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, ""));
    };


    /**
     * optional bytes string_value = 7;
     * This is a type-conversion wrapper around `getStringValue()`
     * @return {string}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getStringValue()));
    };


    /**
     * optional bytes string_value = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getStringValue()`
     * @return {!Uint8Array}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getStringValue()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.google.protobuf.UninterpretedOption.prototype.setStringValue = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearStringValue = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.prototype.hasStringValue = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional string aggregate_value = 8;
     * @return {string}
     */
    proto.google.protobuf.UninterpretedOption.prototype.getAggregateValue = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.UninterpretedOption.prototype.setAggregateValue = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.google.protobuf.UninterpretedOption.prototype.clearAggregateValue = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.UninterpretedOption.prototype.hasAggregateValue = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.SourceCodeInfo = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.SourceCodeInfo.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.SourceCodeInfo, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.SourceCodeInfo.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.SourceCodeInfo.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.SourceCodeInfo.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.SourceCodeInfo} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.SourceCodeInfo.toObject = function(includeInstance, msg) {
      var obj = {
        locationList: googleProtobuf.Message.toObjectList(msg.getLocationList(),
        proto.google.protobuf.SourceCodeInfo.Location.toObject, includeInstance)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.SourceCodeInfo}
     */
    proto.google.protobuf.SourceCodeInfo.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.SourceCodeInfo;
      return proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.SourceCodeInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.SourceCodeInfo}
     */
    proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.google.protobuf.SourceCodeInfo.Location;
          reader.readMessage(value,proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader);
          msg.addLocation(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.SourceCodeInfo.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.SourceCodeInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getLocationList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter
        );
      }
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.SourceCodeInfo.Location = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.SourceCodeInfo.Location, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_ = [1,2,6];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.SourceCodeInfo.Location.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.SourceCodeInfo.Location} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.SourceCodeInfo.Location.toObject = function(includeInstance, msg) {
      var obj = {
        pathList: googleProtobuf.Message.getRepeatedField(msg, 1),
        spanList: googleProtobuf.Message.getRepeatedField(msg, 2),
        leadingComments: googleProtobuf.Message.getField(msg, 3),
        trailingComments: googleProtobuf.Message.getField(msg, 4),
        leadingDetachedCommentsList: googleProtobuf.Message.getRepeatedField(msg, 6)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.SourceCodeInfo.Location}
     */
    proto.google.protobuf.SourceCodeInfo.Location.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.SourceCodeInfo.Location;
      return proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.SourceCodeInfo.Location} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.SourceCodeInfo.Location}
     */
    proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
          msg.setPathList(value);
          break;
        case 2:
          var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
          msg.setSpanList(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setLeadingComments(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setTrailingComments(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.addLeadingDetachedComments(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.SourceCodeInfo.Location} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getPathList();
      if (f.length > 0) {
        writer.writePackedInt32(
          1,
          f
        );
      }
      f = message.getSpanList();
      if (f.length > 0) {
        writer.writePackedInt32(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getLeadingDetachedCommentsList();
      if (f.length > 0) {
        writer.writeRepeatedString(
          6,
          f
        );
      }
    };


    /**
     * repeated int32 path = 1;
     * @return {!Array<number>}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.getPathList = function() {
      return /** @type {!Array<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array<number>} value */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.setPathList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.addPath = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.google.protobuf.SourceCodeInfo.Location.prototype.clearPathList = function() {
      this.setPathList([]);
    };


    /**
     * repeated int32 span = 2;
     * @return {!Array<number>}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.getSpanList = function() {
      return /** @type {!Array<number>} */ (googleProtobuf.Message.getRepeatedField(this, 2));
    };


    /** @param {!Array<number>} value */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.setSpanList = function(value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.addSpan = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };


    proto.google.protobuf.SourceCodeInfo.Location.prototype.clearSpanList = function() {
      this.setSpanList([]);
    };


    /**
     * optional string leading_comments = 3;
     * @return {string}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingComments = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingComments = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingComments = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.hasLeadingComments = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string trailing_comments = 4;
     * @return {string}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.getTrailingComments = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.setTrailingComments = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.google.protobuf.SourceCodeInfo.Location.prototype.clearTrailingComments = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.hasTrailingComments = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * repeated string leading_detached_comments = 6;
     * @return {!Array<string>}
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingDetachedCommentsList = function() {
      return /** @type {!Array<string>} */ (googleProtobuf.Message.getRepeatedField(this, 6));
    };


    /** @param {!Array<string>} value */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingDetachedCommentsList = function(value) {
      googleProtobuf.Message.setField(this, 6, value || []);
    };


    /**
     * @param {!string} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.SourceCodeInfo.Location.prototype.addLeadingDetachedComments = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 6, value, opt_index);
    };


    proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingDetachedCommentsList = function() {
      this.setLeadingDetachedCommentsList([]);
    };


    /**
     * repeated Location location = 1;
     * @return {!Array<!proto.google.protobuf.SourceCodeInfo.Location>}
     */
    proto.google.protobuf.SourceCodeInfo.prototype.getLocationList = function() {
      return /** @type{!Array<!proto.google.protobuf.SourceCodeInfo.Location>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.SourceCodeInfo.Location, 1));
    };


    /** @param {!Array<!proto.google.protobuf.SourceCodeInfo.Location>} value */
    proto.google.protobuf.SourceCodeInfo.prototype.setLocationList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };


    /**
     * @param {!proto.google.protobuf.SourceCodeInfo.Location=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.SourceCodeInfo.Location}
     */
    proto.google.protobuf.SourceCodeInfo.prototype.addLocation = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.SourceCodeInfo.Location, opt_index);
    };


    proto.google.protobuf.SourceCodeInfo.prototype.clearLocationList = function() {
      this.setLocationList([]);
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.GeneratedCodeInfo = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.GeneratedCodeInfo.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.GeneratedCodeInfo, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.GeneratedCodeInfo.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.GeneratedCodeInfo.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.GeneratedCodeInfo.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.GeneratedCodeInfo} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.GeneratedCodeInfo.toObject = function(includeInstance, msg) {
      var obj = {
        annotationList: googleProtobuf.Message.toObjectList(msg.getAnnotationList(),
        proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject, includeInstance)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.GeneratedCodeInfo}
     */
    proto.google.protobuf.GeneratedCodeInfo.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.GeneratedCodeInfo;
      return proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.GeneratedCodeInfo} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.GeneratedCodeInfo}
     */
    proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.google.protobuf.GeneratedCodeInfo.Annotation;
          reader.readMessage(value,proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader);
          msg.addAnnotation(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.GeneratedCodeInfo.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.GeneratedCodeInfo} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAnnotationList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter
        );
      }
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_, null);
    };
    goog.inherits(proto.google.protobuf.GeneratedCodeInfo.Annotation, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject = function(includeInstance, msg) {
      var obj = {
        pathList: googleProtobuf.Message.getRepeatedField(msg, 1),
        sourceFile: googleProtobuf.Message.getField(msg, 2),
        begin: googleProtobuf.Message.getField(msg, 3),
        end: googleProtobuf.Message.getField(msg, 4)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.google.protobuf.GeneratedCodeInfo.Annotation;
      return proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
          msg.setPathList(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setSourceFile(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setBegin(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readInt32());
          msg.setEnd(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getPathList();
      if (f.length > 0) {
        writer.writePackedInt32(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeInt32(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeInt32(
          4,
          f
        );
      }
    };


    /**
     * repeated int32 path = 1;
     * @return {!Array<number>}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getPathList = function() {
      return /** @type {!Array<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array<number>} value */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setPathList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.addPath = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearPathList = function() {
      this.setPathList([]);
    };


    /**
     * optional string source_file = 2;
     * @return {string}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getSourceFile = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setSourceFile = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearSourceFile = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasSourceFile = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional int32 begin = 3;
     * @return {number}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getBegin = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setBegin = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearBegin = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasBegin = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional int32 end = 4;
     * @return {number}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getEnd = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setEnd = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearEnd = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasEnd = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * repeated Annotation annotation = 1;
     * @return {!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>}
     */
    proto.google.protobuf.GeneratedCodeInfo.prototype.getAnnotationList = function() {
      return /** @type{!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.google.protobuf.GeneratedCodeInfo.Annotation, 1));
    };


    /** @param {!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>} value */
    proto.google.protobuf.GeneratedCodeInfo.prototype.setAnnotationList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };


    /**
     * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation=} opt_value
     * @param {number=} opt_index
     * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation}
     */
    proto.google.protobuf.GeneratedCodeInfo.prototype.addAnnotation = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.GeneratedCodeInfo.Annotation, opt_index);
    };


    proto.google.protobuf.GeneratedCodeInfo.prototype.clearAnnotationList = function() {
      this.setAnnotationList([]);
    };


    goog.object.extend(exports, proto.google.protobuf);
    });

    var exchange_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!


    var goog = googleProtobuf;
    var global = Function('return this')();

    goog.exportSymbol('proto.ExchangeAddress', null, global);
    goog.exportSymbol('proto.ExchangeResponse', null, global);
    goog.exportSymbol('proto.ExchangeResponseV2', null, global);
    goog.exportSymbol('proto.SignedExchangeResponse', null, global);

    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ExchangeAddress = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ExchangeAddress, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ExchangeAddress.prototype.toObject = function(opt_includeInstance) {
      return proto.ExchangeAddress.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ExchangeAddress} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeAddress.toObject = function(includeInstance, msg) {
      var obj = {
        coinType: googleProtobuf.Message.getField(msg, 1),
        address: googleProtobuf.Message.getField(msg, 2),
        destTag: googleProtobuf.Message.getField(msg, 3),
        rsAddress: googleProtobuf.Message.getField(msg, 4)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ExchangeAddress}
     */
    proto.ExchangeAddress.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ExchangeAddress;
      return proto.ExchangeAddress.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ExchangeAddress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ExchangeAddress}
     */
    proto.ExchangeAddress.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinType(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setDestTag(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setRsAddress(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ExchangeAddress.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ExchangeAddress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ExchangeAddress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeAddress.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
    };


    /**
     * optional string coin_type = 1;
     * @return {string}
     */
    proto.ExchangeAddress.prototype.getCoinType = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.ExchangeAddress.prototype.setCoinType = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.ExchangeAddress.prototype.clearCoinType = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeAddress.prototype.hasCoinType = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string address = 2;
     * @return {string}
     */
    proto.ExchangeAddress.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.ExchangeAddress.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ExchangeAddress.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeAddress.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string dest_tag = 3;
     * @return {string}
     */
    proto.ExchangeAddress.prototype.getDestTag = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.ExchangeAddress.prototype.setDestTag = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.ExchangeAddress.prototype.clearDestTag = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeAddress.prototype.hasDestTag = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string rs_address = 4;
     * @return {string}
     */
    proto.ExchangeAddress.prototype.getRsAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /** @param {string} value */
    proto.ExchangeAddress.prototype.setRsAddress = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.ExchangeAddress.prototype.clearRsAddress = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeAddress.prototype.hasRsAddress = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ExchangeResponseV2 = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ExchangeResponseV2, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ExchangeResponseV2.prototype.toObject = function(opt_includeInstance) {
      return proto.ExchangeResponseV2.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ExchangeResponseV2} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeResponseV2.toObject = function(includeInstance, msg) {
      var f, obj = {
        depositAddress: (f = msg.getDepositAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
        depositAmount: msg.getDepositAmount_asB64(),
        expiration: googleProtobuf.Message.getField(msg, 3),
        quotedRate: msg.getQuotedRate_asB64(),
        withdrawalAddress: (f = msg.getWithdrawalAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
        withdrawalAmount: msg.getWithdrawalAmount_asB64(),
        returnAddress: (f = msg.getReturnAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
        apiKey: msg.getApiKey_asB64(),
        minerFee: msg.getMinerFee_asB64(),
        orderId: msg.getOrderId_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ExchangeResponseV2}
     */
    proto.ExchangeResponseV2.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ExchangeResponseV2;
      return proto.ExchangeResponseV2.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ExchangeResponseV2} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ExchangeResponseV2}
     */
    proto.ExchangeResponseV2.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.ExchangeAddress;
          reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
          msg.setDepositAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setDepositAmount(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readInt64());
          msg.setExpiration(value);
          break;
        case 4:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setQuotedRate(value);
          break;
        case 5:
          var value = new proto.ExchangeAddress;
          reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
          msg.setWithdrawalAddress(value);
          break;
        case 6:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setWithdrawalAmount(value);
          break;
        case 7:
          var value = new proto.ExchangeAddress;
          reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
          msg.setReturnAddress(value);
          break;
        case 8:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setApiKey(value);
          break;
        case 9:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMinerFee(value);
          break;
        case 10:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setOrderId(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ExchangeResponseV2.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ExchangeResponseV2} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeResponseV2.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getDepositAddress();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.ExchangeAddress.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeInt64(
          3,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBytes(
          4,
          f
        );
      }
      f = message.getWithdrawalAddress();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          proto.ExchangeAddress.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBytes(
          6,
          f
        );
      }
      f = message.getReturnAddress();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          proto.ExchangeAddress.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeBytes(
          8,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeBytes(
          9,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeBytes(
          10,
          f
        );
      }
    };


    /**
     * optional ExchangeAddress deposit_address = 1;
     * @return {?proto.ExchangeAddress}
     */
    proto.ExchangeResponseV2.prototype.getDepositAddress = function() {
      return /** @type{?proto.ExchangeAddress} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeAddress, 1));
    };


    /** @param {?proto.ExchangeAddress|undefined} value */
    proto.ExchangeResponseV2.prototype.setDepositAddress = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.ExchangeResponseV2.prototype.clearDepositAddress = function() {
      this.setDepositAddress(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasDepositAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes deposit_amount = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponseV2.prototype.getDepositAmount = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes deposit_amount = 2;
     * This is a type-conversion wrapper around `getDepositAmount()`
     * @return {string}
     */
    proto.ExchangeResponseV2.prototype.getDepositAmount_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getDepositAmount()));
    };


    /**
     * optional bytes deposit_amount = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getDepositAmount()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.getDepositAmount_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getDepositAmount()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponseV2.prototype.setDepositAmount = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ExchangeResponseV2.prototype.clearDepositAmount = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasDepositAmount = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional int64 expiration = 3;
     * @return {number}
     */
    proto.ExchangeResponseV2.prototype.getExpiration = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.ExchangeResponseV2.prototype.setExpiration = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.ExchangeResponseV2.prototype.clearExpiration = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasExpiration = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bytes quoted_rate = 4;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponseV2.prototype.getQuotedRate = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /**
     * optional bytes quoted_rate = 4;
     * This is a type-conversion wrapper around `getQuotedRate()`
     * @return {string}
     */
    proto.ExchangeResponseV2.prototype.getQuotedRate_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getQuotedRate()));
    };


    /**
     * optional bytes quoted_rate = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getQuotedRate()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.getQuotedRate_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getQuotedRate()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponseV2.prototype.setQuotedRate = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.ExchangeResponseV2.prototype.clearQuotedRate = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasQuotedRate = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional ExchangeAddress withdrawal_address = 5;
     * @return {?proto.ExchangeAddress}
     */
    proto.ExchangeResponseV2.prototype.getWithdrawalAddress = function() {
      return /** @type{?proto.ExchangeAddress} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeAddress, 5));
    };


    /** @param {?proto.ExchangeAddress|undefined} value */
    proto.ExchangeResponseV2.prototype.setWithdrawalAddress = function(value) {
      googleProtobuf.Message.setWrapperField(this, 5, value);
    };


    proto.ExchangeResponseV2.prototype.clearWithdrawalAddress = function() {
      this.setWithdrawalAddress(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasWithdrawalAddress = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bytes withdrawal_amount = 6;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponseV2.prototype.getWithdrawalAmount = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /**
     * optional bytes withdrawal_amount = 6;
     * This is a type-conversion wrapper around `getWithdrawalAmount()`
     * @return {string}
     */
    proto.ExchangeResponseV2.prototype.getWithdrawalAmount_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getWithdrawalAmount()));
    };


    /**
     * optional bytes withdrawal_amount = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getWithdrawalAmount()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.getWithdrawalAmount_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getWithdrawalAmount()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponseV2.prototype.setWithdrawalAmount = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.ExchangeResponseV2.prototype.clearWithdrawalAmount = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasWithdrawalAmount = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional ExchangeAddress return_address = 7;
     * @return {?proto.ExchangeAddress}
     */
    proto.ExchangeResponseV2.prototype.getReturnAddress = function() {
      return /** @type{?proto.ExchangeAddress} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeAddress, 7));
    };


    /** @param {?proto.ExchangeAddress|undefined} value */
    proto.ExchangeResponseV2.prototype.setReturnAddress = function(value) {
      googleProtobuf.Message.setWrapperField(this, 7, value);
    };


    proto.ExchangeResponseV2.prototype.clearReturnAddress = function() {
      this.setReturnAddress(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasReturnAddress = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional bytes api_key = 8;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponseV2.prototype.getApiKey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /**
     * optional bytes api_key = 8;
     * This is a type-conversion wrapper around `getApiKey()`
     * @return {string}
     */
    proto.ExchangeResponseV2.prototype.getApiKey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getApiKey()));
    };


    /**
     * optional bytes api_key = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getApiKey()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.getApiKey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getApiKey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponseV2.prototype.setApiKey = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.ExchangeResponseV2.prototype.clearApiKey = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasApiKey = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional bytes miner_fee = 9;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponseV2.prototype.getMinerFee = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, ""));
    };


    /**
     * optional bytes miner_fee = 9;
     * This is a type-conversion wrapper around `getMinerFee()`
     * @return {string}
     */
    proto.ExchangeResponseV2.prototype.getMinerFee_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMinerFee()));
    };


    /**
     * optional bytes miner_fee = 9;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMinerFee()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.getMinerFee_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMinerFee()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponseV2.prototype.setMinerFee = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.ExchangeResponseV2.prototype.clearMinerFee = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasMinerFee = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional bytes order_id = 10;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponseV2.prototype.getOrderId = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, ""));
    };


    /**
     * optional bytes order_id = 10;
     * This is a type-conversion wrapper around `getOrderId()`
     * @return {string}
     */
    proto.ExchangeResponseV2.prototype.getOrderId_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getOrderId()));
    };


    /**
     * optional bytes order_id = 10;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getOrderId()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponseV2.prototype.getOrderId_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getOrderId()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponseV2.prototype.setOrderId = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.ExchangeResponseV2.prototype.clearOrderId = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponseV2.prototype.hasOrderId = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.SignedExchangeResponse = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.SignedExchangeResponse, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.SignedExchangeResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.SignedExchangeResponse.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.SignedExchangeResponse} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignedExchangeResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        response: (f = msg.getResponse()) && proto.ExchangeResponse.toObject(includeInstance, f),
        signature: msg.getSignature_asB64(),
        responsev2: (f = msg.getResponsev2()) && proto.ExchangeResponseV2.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.SignedExchangeResponse}
     */
    proto.SignedExchangeResponse.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.SignedExchangeResponse;
      return proto.SignedExchangeResponse.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.SignedExchangeResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.SignedExchangeResponse}
     */
    proto.SignedExchangeResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.ExchangeResponse;
          reader.readMessage(value,proto.ExchangeResponse.deserializeBinaryFromReader);
          msg.setResponse(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        case 3:
          var value = new proto.ExchangeResponseV2;
          reader.readMessage(value,proto.ExchangeResponseV2.deserializeBinaryFromReader);
          msg.setResponsev2(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.SignedExchangeResponse.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.SignedExchangeResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.SignedExchangeResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignedExchangeResponse.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getResponse();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.ExchangeResponse.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = message.getResponsev2();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          proto.ExchangeResponseV2.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional ExchangeResponse response = 1;
     * @return {?proto.ExchangeResponse}
     */
    proto.SignedExchangeResponse.prototype.getResponse = function() {
      return /** @type{?proto.ExchangeResponse} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeResponse, 1));
    };


    /** @param {?proto.ExchangeResponse|undefined} value */
    proto.SignedExchangeResponse.prototype.setResponse = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.SignedExchangeResponse.prototype.clearResponse = function() {
      this.setResponse(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignedExchangeResponse.prototype.hasResponse = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes signature = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.SignedExchangeResponse.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes signature = 2;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.SignedExchangeResponse.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.SignedExchangeResponse.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.SignedExchangeResponse.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.SignedExchangeResponse.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignedExchangeResponse.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional ExchangeResponseV2 responseV2 = 3;
     * @return {?proto.ExchangeResponseV2}
     */
    proto.SignedExchangeResponse.prototype.getResponsev2 = function() {
      return /** @type{?proto.ExchangeResponseV2} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeResponseV2, 3));
    };


    /** @param {?proto.ExchangeResponseV2|undefined} value */
    proto.SignedExchangeResponse.prototype.setResponsev2 = function(value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };


    proto.SignedExchangeResponse.prototype.clearResponsev2 = function() {
      this.setResponsev2(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignedExchangeResponse.prototype.hasResponsev2 = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ExchangeResponse = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ExchangeResponse, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ExchangeResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.ExchangeResponse.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ExchangeResponse} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        depositAddress: (f = msg.getDepositAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
        depositAmount: googleProtobuf.Message.getField(msg, 2),
        expiration: googleProtobuf.Message.getField(msg, 3),
        quotedRate: googleProtobuf.Message.getField(msg, 4),
        withdrawalAddress: (f = msg.getWithdrawalAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
        withdrawalAmount: googleProtobuf.Message.getField(msg, 6),
        returnAddress: (f = msg.getReturnAddress()) && proto.ExchangeAddress.toObject(includeInstance, f),
        apiKey: msg.getApiKey_asB64(),
        minerFee: googleProtobuf.Message.getField(msg, 9),
        orderId: msg.getOrderId_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ExchangeResponse}
     */
    proto.ExchangeResponse.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ExchangeResponse;
      return proto.ExchangeResponse.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ExchangeResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ExchangeResponse}
     */
    proto.ExchangeResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.ExchangeAddress;
          reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
          msg.setDepositAddress(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setDepositAmount(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readInt64());
          msg.setExpiration(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setQuotedRate(value);
          break;
        case 5:
          var value = new proto.ExchangeAddress;
          reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
          msg.setWithdrawalAddress(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setWithdrawalAmount(value);
          break;
        case 7:
          var value = new proto.ExchangeAddress;
          reader.readMessage(value,proto.ExchangeAddress.deserializeBinaryFromReader);
          msg.setReturnAddress(value);
          break;
        case 8:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setApiKey(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setMinerFee(value);
          break;
        case 10:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setOrderId(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ExchangeResponse.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ExchangeResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ExchangeResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeResponse.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getDepositAddress();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.ExchangeAddress.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint64(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeInt64(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint64(
          4,
          f
        );
      }
      f = message.getWithdrawalAddress();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          proto.ExchangeAddress.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeUint64(
          6,
          f
        );
      }
      f = message.getReturnAddress();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          proto.ExchangeAddress.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeBytes(
          8,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint64(
          9,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeBytes(
          10,
          f
        );
      }
    };


    /**
     * optional ExchangeAddress deposit_address = 1;
     * @return {?proto.ExchangeAddress}
     */
    proto.ExchangeResponse.prototype.getDepositAddress = function() {
      return /** @type{?proto.ExchangeAddress} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeAddress, 1));
    };


    /** @param {?proto.ExchangeAddress|undefined} value */
    proto.ExchangeResponse.prototype.setDepositAddress = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.ExchangeResponse.prototype.clearDepositAddress = function() {
      this.setDepositAddress(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasDepositAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint64 deposit_amount = 2;
     * @return {number}
     */
    proto.ExchangeResponse.prototype.getDepositAmount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.ExchangeResponse.prototype.setDepositAmount = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ExchangeResponse.prototype.clearDepositAmount = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasDepositAmount = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional int64 expiration = 3;
     * @return {number}
     */
    proto.ExchangeResponse.prototype.getExpiration = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.ExchangeResponse.prototype.setExpiration = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.ExchangeResponse.prototype.clearExpiration = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasExpiration = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint64 quoted_rate = 4;
     * @return {number}
     */
    proto.ExchangeResponse.prototype.getQuotedRate = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.ExchangeResponse.prototype.setQuotedRate = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.ExchangeResponse.prototype.clearQuotedRate = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasQuotedRate = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional ExchangeAddress withdrawal_address = 5;
     * @return {?proto.ExchangeAddress}
     */
    proto.ExchangeResponse.prototype.getWithdrawalAddress = function() {
      return /** @type{?proto.ExchangeAddress} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeAddress, 5));
    };


    /** @param {?proto.ExchangeAddress|undefined} value */
    proto.ExchangeResponse.prototype.setWithdrawalAddress = function(value) {
      googleProtobuf.Message.setWrapperField(this, 5, value);
    };


    proto.ExchangeResponse.prototype.clearWithdrawalAddress = function() {
      this.setWithdrawalAddress(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasWithdrawalAddress = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional uint64 withdrawal_amount = 6;
     * @return {number}
     */
    proto.ExchangeResponse.prototype.getWithdrawalAmount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, 0));
    };


    /** @param {number} value */
    proto.ExchangeResponse.prototype.setWithdrawalAmount = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.ExchangeResponse.prototype.clearWithdrawalAmount = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasWithdrawalAmount = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional ExchangeAddress return_address = 7;
     * @return {?proto.ExchangeAddress}
     */
    proto.ExchangeResponse.prototype.getReturnAddress = function() {
      return /** @type{?proto.ExchangeAddress} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeAddress, 7));
    };


    /** @param {?proto.ExchangeAddress|undefined} value */
    proto.ExchangeResponse.prototype.setReturnAddress = function(value) {
      googleProtobuf.Message.setWrapperField(this, 7, value);
    };


    proto.ExchangeResponse.prototype.clearReturnAddress = function() {
      this.setReturnAddress(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasReturnAddress = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional bytes api_key = 8;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponse.prototype.getApiKey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /**
     * optional bytes api_key = 8;
     * This is a type-conversion wrapper around `getApiKey()`
     * @return {string}
     */
    proto.ExchangeResponse.prototype.getApiKey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getApiKey()));
    };


    /**
     * optional bytes api_key = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getApiKey()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponse.prototype.getApiKey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getApiKey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponse.prototype.setApiKey = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.ExchangeResponse.prototype.clearApiKey = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasApiKey = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint64 miner_fee = 9;
     * @return {number}
     */
    proto.ExchangeResponse.prototype.getMinerFee = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.ExchangeResponse.prototype.setMinerFee = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.ExchangeResponse.prototype.clearMinerFee = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasMinerFee = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional bytes order_id = 10;
     * @return {!(string|Uint8Array)}
     */
    proto.ExchangeResponse.prototype.getOrderId = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, ""));
    };


    /**
     * optional bytes order_id = 10;
     * This is a type-conversion wrapper around `getOrderId()`
     * @return {string}
     */
    proto.ExchangeResponse.prototype.getOrderId_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getOrderId()));
    };


    /**
     * optional bytes order_id = 10;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getOrderId()`
     * @return {!Uint8Array}
     */
    proto.ExchangeResponse.prototype.getOrderId_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getOrderId()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.ExchangeResponse.prototype.setOrderId = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.ExchangeResponse.prototype.clearOrderId = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeResponse.prototype.hasOrderId = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    goog.object.extend(exports, proto);
    });

    var types_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!


    var goog = googleProtobuf;
    var global = Function('return this')();



    goog.exportSymbol('proto.ButtonRequestType', null, global);
    goog.exportSymbol('proto.CoinType', null, global);
    goog.exportSymbol('proto.ExchangeType', null, global);
    goog.exportSymbol('proto.FailureType', null, global);
    goog.exportSymbol('proto.HDNodePathType', null, global);
    goog.exportSymbol('proto.HDNodeType', null, global);
    goog.exportSymbol('proto.IdentityType', null, global);
    goog.exportSymbol('proto.InputScriptType', null, global);
    goog.exportSymbol('proto.MultisigRedeemScriptType', null, global);
    goog.exportSymbol('proto.OutputAddressType', null, global);
    goog.exportSymbol('proto.OutputScriptType', null, global);
    goog.exportSymbol('proto.PinMatrixRequestType', null, global);
    goog.exportSymbol('proto.PolicyType', null, global);
    goog.exportSymbol('proto.RawTransactionType', null, global);
    goog.exportSymbol('proto.RequestType', null, global);
    goog.exportSymbol('proto.TransactionType', null, global);
    goog.exportSymbol('proto.TxInputType', null, global);
    goog.exportSymbol('proto.TxOutputBinType', null, global);
    goog.exportSymbol('proto.TxOutputType', null, global);
    goog.exportSymbol('proto.TxRequestDetailsType', null, global);
    goog.exportSymbol('proto.TxRequestSerializedType', null, global);
    goog.exportSymbol('proto.wireDebugIn', null, global);
    goog.exportSymbol('proto.wireDebugOut', null, global);
    goog.exportSymbol('proto.wireIn', null, global);
    goog.exportSymbol('proto.wireOut', null, global);

    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.HDNodeType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.HDNodeType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.HDNodeType.prototype.toObject = function(opt_includeInstance) {
      return proto.HDNodeType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.HDNodeType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.HDNodeType.toObject = function(includeInstance, msg) {
      var obj = {
        depth: googleProtobuf.Message.getField(msg, 1),
        fingerprint: googleProtobuf.Message.getField(msg, 2),
        childNum: googleProtobuf.Message.getField(msg, 3),
        chainCode: msg.getChainCode_asB64(),
        privateKey: msg.getPrivateKey_asB64(),
        publicKey: msg.getPublicKey_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.HDNodeType}
     */
    proto.HDNodeType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.HDNodeType;
      return proto.HDNodeType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.HDNodeType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.HDNodeType}
     */
    proto.HDNodeType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDepth(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setFingerprint(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setChildNum(value);
          break;
        case 4:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setChainCode(value);
          break;
        case 5:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPrivateKey(value);
          break;
        case 6:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPublicKey(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.HDNodeType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.HDNodeType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.HDNodeType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.HDNodeType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBytes(
          4,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBytes(
          5,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBytes(
          6,
          f
        );
      }
    };


    /**
     * required uint32 depth = 1;
     * @return {number}
     */
    proto.HDNodeType.prototype.getDepth = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.HDNodeType.prototype.setDepth = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.HDNodeType.prototype.clearDepth = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodeType.prototype.hasDepth = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required uint32 fingerprint = 2;
     * @return {number}
     */
    proto.HDNodeType.prototype.getFingerprint = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.HDNodeType.prototype.setFingerprint = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.HDNodeType.prototype.clearFingerprint = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodeType.prototype.hasFingerprint = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * required uint32 child_num = 3;
     * @return {number}
     */
    proto.HDNodeType.prototype.getChildNum = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.HDNodeType.prototype.setChildNum = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.HDNodeType.prototype.clearChildNum = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodeType.prototype.hasChildNum = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * required bytes chain_code = 4;
     * @return {!(string|Uint8Array)}
     */
    proto.HDNodeType.prototype.getChainCode = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /**
     * required bytes chain_code = 4;
     * This is a type-conversion wrapper around `getChainCode()`
     * @return {string}
     */
    proto.HDNodeType.prototype.getChainCode_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getChainCode()));
    };


    /**
     * required bytes chain_code = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChainCode()`
     * @return {!Uint8Array}
     */
    proto.HDNodeType.prototype.getChainCode_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getChainCode()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.HDNodeType.prototype.setChainCode = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.HDNodeType.prototype.clearChainCode = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodeType.prototype.hasChainCode = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional bytes private_key = 5;
     * @return {!(string|Uint8Array)}
     */
    proto.HDNodeType.prototype.getPrivateKey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, ""));
    };


    /**
     * optional bytes private_key = 5;
     * This is a type-conversion wrapper around `getPrivateKey()`
     * @return {string}
     */
    proto.HDNodeType.prototype.getPrivateKey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPrivateKey()));
    };


    /**
     * optional bytes private_key = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPrivateKey()`
     * @return {!Uint8Array}
     */
    proto.HDNodeType.prototype.getPrivateKey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPrivateKey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.HDNodeType.prototype.setPrivateKey = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.HDNodeType.prototype.clearPrivateKey = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodeType.prototype.hasPrivateKey = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bytes public_key = 6;
     * @return {!(string|Uint8Array)}
     */
    proto.HDNodeType.prototype.getPublicKey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /**
     * optional bytes public_key = 6;
     * This is a type-conversion wrapper around `getPublicKey()`
     * @return {string}
     */
    proto.HDNodeType.prototype.getPublicKey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPublicKey()));
    };


    /**
     * optional bytes public_key = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPublicKey()`
     * @return {!Uint8Array}
     */
    proto.HDNodeType.prototype.getPublicKey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPublicKey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.HDNodeType.prototype.setPublicKey = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.HDNodeType.prototype.clearPublicKey = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodeType.prototype.hasPublicKey = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.HDNodePathType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.HDNodePathType.repeatedFields_, null);
    };
    goog.inherits(proto.HDNodePathType, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.HDNodePathType.repeatedFields_ = [2];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.HDNodePathType.prototype.toObject = function(opt_includeInstance) {
      return proto.HDNodePathType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.HDNodePathType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.HDNodePathType.toObject = function(includeInstance, msg) {
      var f, obj = {
        node: (f = msg.getNode()) && proto.HDNodeType.toObject(includeInstance, f),
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.HDNodePathType}
     */
    proto.HDNodePathType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.HDNodePathType;
      return proto.HDNodePathType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.HDNodePathType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.HDNodePathType}
     */
    proto.HDNodePathType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.HDNodeType;
          reader.readMessage(value,proto.HDNodeType.deserializeBinaryFromReader);
          msg.setNode(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.HDNodePathType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.HDNodePathType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.HDNodePathType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.HDNodePathType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getNode();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          proto.HDNodeType.serializeBinaryToWriter
        );
      }
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          2,
          f
        );
      }
    };


    /**
     * required HDNodeType node = 1;
     * @return {!proto.HDNodeType}
     */
    proto.HDNodePathType.prototype.getNode = function() {
      return /** @type{!proto.HDNodeType} */ (
        googleProtobuf.Message.getWrapperField(this, proto.HDNodeType, 1, 1));
    };


    /** @param {!proto.HDNodeType} value */
    proto.HDNodePathType.prototype.setNode = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.HDNodePathType.prototype.clearNode = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.HDNodePathType.prototype.hasNode = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated uint32 address_n = 2;
     * @return {!Array.<number>}
     */
    proto.HDNodePathType.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 2));
    };


    /** @param {!Array.<number>} value */
    proto.HDNodePathType.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.HDNodePathType.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };


    proto.HDNodePathType.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.CoinType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.CoinType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.CoinType.prototype.toObject = function(opt_includeInstance) {
      return proto.CoinType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.CoinType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CoinType.toObject = function(includeInstance, msg) {
      var obj = {
        coinName: googleProtobuf.Message.getField(msg, 1),
        coinShortcut: googleProtobuf.Message.getField(msg, 2),
        addressType: googleProtobuf.Message.getFieldWithDefault(msg, 3, 0),
        maxfeeKb: googleProtobuf.Message.getField(msg, 4),
        addressTypeP2sh: googleProtobuf.Message.getFieldWithDefault(msg, 5, 5),
        signedMessageHeader: googleProtobuf.Message.getField(msg, 8),
        bip44AccountPath: googleProtobuf.Message.getField(msg, 9),
        forkid: googleProtobuf.Message.getField(msg, 12),
        decimals: googleProtobuf.Message.getField(msg, 13),
        contractAddress: msg.getContractAddress_asB64(),
        xpubMagic: googleProtobuf.Message.getFieldWithDefault(msg, 16, 76067358),
        segwit: googleProtobuf.Message.getField(msg, 18),
        forceBip143: googleProtobuf.Message.getField(msg, 19),
        curveName: googleProtobuf.Message.getField(msg, 20),
        cashaddrPrefix: googleProtobuf.Message.getField(msg, 21),
        bech32Prefix: googleProtobuf.Message.getField(msg, 22),
        decred: googleProtobuf.Message.getField(msg, 23),
        xpubMagicSegwitP2sh: googleProtobuf.Message.getField(msg, 25),
        xpubMagicSegwitNative: googleProtobuf.Message.getField(msg, 26)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.CoinType}
     */
    proto.CoinType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.CoinType;
      return proto.CoinType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.CoinType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.CoinType}
     */
    proto.CoinType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinShortcut(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAddressType(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setMaxfeeKb(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAddressTypeP2sh(value);
          break;
        case 8:
          var value = /** @type {string} */ (reader.readString());
          msg.setSignedMessageHeader(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setBip44AccountPath(value);
          break;
        case 12:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setForkid(value);
          break;
        case 13:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDecimals(value);
          break;
        case 14:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setContractAddress(value);
          break;
        case 16:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setXpubMagic(value);
          break;
        case 18:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setSegwit(value);
          break;
        case 19:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setForceBip143(value);
          break;
        case 20:
          var value = /** @type {string} */ (reader.readString());
          msg.setCurveName(value);
          break;
        case 21:
          var value = /** @type {string} */ (reader.readString());
          msg.setCashaddrPrefix(value);
          break;
        case 22:
          var value = /** @type {string} */ (reader.readString());
          msg.setBech32Prefix(value);
          break;
        case 23:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDecred(value);
          break;
        case 25:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setXpubMagicSegwitP2sh(value);
          break;
        case 26:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setXpubMagicSegwitNative(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.CoinType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.CoinType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.CoinType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CoinType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint64(
          4,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeUint32(
          5,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeString(
          8,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint32(
          9,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 12));
      if (f != null) {
        writer.writeUint32(
          12,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 13));
      if (f != null) {
        writer.writeUint32(
          13,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 14));
      if (f != null) {
        writer.writeBytes(
          14,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 16));
      if (f != null) {
        writer.writeUint32(
          16,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 18));
      if (f != null) {
        writer.writeBool(
          18,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 19));
      if (f != null) {
        writer.writeBool(
          19,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 20));
      if (f != null) {
        writer.writeString(
          20,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 21));
      if (f != null) {
        writer.writeString(
          21,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 22));
      if (f != null) {
        writer.writeString(
          22,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 23));
      if (f != null) {
        writer.writeBool(
          23,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 25));
      if (f != null) {
        writer.writeUint32(
          25,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 26));
      if (f != null) {
        writer.writeUint32(
          26,
          f
        );
      }
    };


    /**
     * optional string coin_name = 1;
     * @return {string}
     */
    proto.CoinType.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.CoinType.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.CoinType.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string coin_shortcut = 2;
     * @return {string}
     */
    proto.CoinType.prototype.getCoinShortcut = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.CoinType.prototype.setCoinShortcut = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.CoinType.prototype.clearCoinShortcut = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasCoinShortcut = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional uint32 address_type = 3;
     * @return {number}
     */
    proto.CoinType.prototype.getAddressType = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setAddressType = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.CoinType.prototype.clearAddressType = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasAddressType = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint64 maxfee_kb = 4;
     * @return {number}
     */
    proto.CoinType.prototype.getMaxfeeKb = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setMaxfeeKb = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.CoinType.prototype.clearMaxfeeKb = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasMaxfeeKb = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional uint32 address_type_p2sh = 5;
     * @return {number}
     */
    proto.CoinType.prototype.getAddressTypeP2sh = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 5));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setAddressTypeP2sh = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.CoinType.prototype.clearAddressTypeP2sh = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasAddressTypeP2sh = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional string signed_message_header = 8;
     * @return {string}
     */
    proto.CoinType.prototype.getSignedMessageHeader = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /** @param {string} value */
    proto.CoinType.prototype.setSignedMessageHeader = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.CoinType.prototype.clearSignedMessageHeader = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasSignedMessageHeader = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint32 bip44_account_path = 9;
     * @return {number}
     */
    proto.CoinType.prototype.getBip44AccountPath = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setBip44AccountPath = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.CoinType.prototype.clearBip44AccountPath = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasBip44AccountPath = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional uint32 forkid = 12;
     * @return {number}
     */
    proto.CoinType.prototype.getForkid = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 12, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setForkid = function(value) {
      googleProtobuf.Message.setField(this, 12, value);
    };


    proto.CoinType.prototype.clearForkid = function() {
      googleProtobuf.Message.setField(this, 12, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasForkid = function() {
      return googleProtobuf.Message.getField(this, 12) != null;
    };


    /**
     * optional uint32 decimals = 13;
     * @return {number}
     */
    proto.CoinType.prototype.getDecimals = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 13, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setDecimals = function(value) {
      googleProtobuf.Message.setField(this, 13, value);
    };


    proto.CoinType.prototype.clearDecimals = function() {
      googleProtobuf.Message.setField(this, 13, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasDecimals = function() {
      return googleProtobuf.Message.getField(this, 13) != null;
    };


    /**
     * optional bytes contract_address = 14;
     * @return {!(string|Uint8Array)}
     */
    proto.CoinType.prototype.getContractAddress = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 14, ""));
    };


    /**
     * optional bytes contract_address = 14;
     * This is a type-conversion wrapper around `getContractAddress()`
     * @return {string}
     */
    proto.CoinType.prototype.getContractAddress_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getContractAddress()));
    };


    /**
     * optional bytes contract_address = 14;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getContractAddress()`
     * @return {!Uint8Array}
     */
    proto.CoinType.prototype.getContractAddress_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getContractAddress()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.CoinType.prototype.setContractAddress = function(value) {
      googleProtobuf.Message.setField(this, 14, value);
    };


    proto.CoinType.prototype.clearContractAddress = function() {
      googleProtobuf.Message.setField(this, 14, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasContractAddress = function() {
      return googleProtobuf.Message.getField(this, 14) != null;
    };


    /**
     * optional uint32 xpub_magic = 16;
     * @return {number}
     */
    proto.CoinType.prototype.getXpubMagic = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 16, 76067358));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setXpubMagic = function(value) {
      googleProtobuf.Message.setField(this, 16, value);
    };


    proto.CoinType.prototype.clearXpubMagic = function() {
      googleProtobuf.Message.setField(this, 16, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasXpubMagic = function() {
      return googleProtobuf.Message.getField(this, 16) != null;
    };


    /**
     * optional bool segwit = 18;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CoinType.prototype.getSegwit = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 18, false));
    };


    /** @param {boolean} value */
    proto.CoinType.prototype.setSegwit = function(value) {
      googleProtobuf.Message.setField(this, 18, value);
    };


    proto.CoinType.prototype.clearSegwit = function() {
      googleProtobuf.Message.setField(this, 18, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasSegwit = function() {
      return googleProtobuf.Message.getField(this, 18) != null;
    };


    /**
     * optional bool force_bip143 = 19;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CoinType.prototype.getForceBip143 = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 19, false));
    };


    /** @param {boolean} value */
    proto.CoinType.prototype.setForceBip143 = function(value) {
      googleProtobuf.Message.setField(this, 19, value);
    };


    proto.CoinType.prototype.clearForceBip143 = function() {
      googleProtobuf.Message.setField(this, 19, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasForceBip143 = function() {
      return googleProtobuf.Message.getField(this, 19) != null;
    };


    /**
     * optional string curve_name = 20;
     * @return {string}
     */
    proto.CoinType.prototype.getCurveName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 20, ""));
    };


    /** @param {string} value */
    proto.CoinType.prototype.setCurveName = function(value) {
      googleProtobuf.Message.setField(this, 20, value);
    };


    proto.CoinType.prototype.clearCurveName = function() {
      googleProtobuf.Message.setField(this, 20, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasCurveName = function() {
      return googleProtobuf.Message.getField(this, 20) != null;
    };


    /**
     * optional string cashaddr_prefix = 21;
     * @return {string}
     */
    proto.CoinType.prototype.getCashaddrPrefix = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 21, ""));
    };


    /** @param {string} value */
    proto.CoinType.prototype.setCashaddrPrefix = function(value) {
      googleProtobuf.Message.setField(this, 21, value);
    };


    proto.CoinType.prototype.clearCashaddrPrefix = function() {
      googleProtobuf.Message.setField(this, 21, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasCashaddrPrefix = function() {
      return googleProtobuf.Message.getField(this, 21) != null;
    };


    /**
     * optional string bech32_prefix = 22;
     * @return {string}
     */
    proto.CoinType.prototype.getBech32Prefix = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 22, ""));
    };


    /** @param {string} value */
    proto.CoinType.prototype.setBech32Prefix = function(value) {
      googleProtobuf.Message.setField(this, 22, value);
    };


    proto.CoinType.prototype.clearBech32Prefix = function() {
      googleProtobuf.Message.setField(this, 22, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasBech32Prefix = function() {
      return googleProtobuf.Message.getField(this, 22) != null;
    };


    /**
     * optional bool decred = 23;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CoinType.prototype.getDecred = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 23, false));
    };


    /** @param {boolean} value */
    proto.CoinType.prototype.setDecred = function(value) {
      googleProtobuf.Message.setField(this, 23, value);
    };


    proto.CoinType.prototype.clearDecred = function() {
      googleProtobuf.Message.setField(this, 23, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasDecred = function() {
      return googleProtobuf.Message.getField(this, 23) != null;
    };


    /**
     * optional uint32 xpub_magic_segwit_p2sh = 25;
     * @return {number}
     */
    proto.CoinType.prototype.getXpubMagicSegwitP2sh = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 25, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setXpubMagicSegwitP2sh = function(value) {
      googleProtobuf.Message.setField(this, 25, value);
    };


    proto.CoinType.prototype.clearXpubMagicSegwitP2sh = function() {
      googleProtobuf.Message.setField(this, 25, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasXpubMagicSegwitP2sh = function() {
      return googleProtobuf.Message.getField(this, 25) != null;
    };


    /**
     * optional uint32 xpub_magic_segwit_native = 26;
     * @return {number}
     */
    proto.CoinType.prototype.getXpubMagicSegwitNative = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 26, 0));
    };


    /** @param {number} value */
    proto.CoinType.prototype.setXpubMagicSegwitNative = function(value) {
      googleProtobuf.Message.setField(this, 26, value);
    };


    proto.CoinType.prototype.clearXpubMagicSegwitNative = function() {
      googleProtobuf.Message.setField(this, 26, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinType.prototype.hasXpubMagicSegwitNative = function() {
      return googleProtobuf.Message.getField(this, 26) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.MultisigRedeemScriptType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.MultisigRedeemScriptType.repeatedFields_, null);
    };
    goog.inherits(proto.MultisigRedeemScriptType, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.MultisigRedeemScriptType.repeatedFields_ = [1,2];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.MultisigRedeemScriptType.prototype.toObject = function(opt_includeInstance) {
      return proto.MultisigRedeemScriptType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.MultisigRedeemScriptType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.MultisigRedeemScriptType.toObject = function(includeInstance, msg) {
      var obj = {
        pubkeysList: googleProtobuf.Message.toObjectList(msg.getPubkeysList(),
        proto.HDNodePathType.toObject, includeInstance),
        signaturesList: msg.getSignaturesList_asB64(),
        m: googleProtobuf.Message.getField(msg, 3)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.MultisigRedeemScriptType}
     */
    proto.MultisigRedeemScriptType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.MultisigRedeemScriptType;
      return proto.MultisigRedeemScriptType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.MultisigRedeemScriptType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.MultisigRedeemScriptType}
     */
    proto.MultisigRedeemScriptType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new proto.HDNodePathType;
          reader.readMessage(value,proto.HDNodePathType.deserializeBinaryFromReader);
          msg.addPubkeys(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.addSignatures(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setM(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.MultisigRedeemScriptType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.MultisigRedeemScriptType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.MultisigRedeemScriptType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.MultisigRedeemScriptType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getPubkeysList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          proto.HDNodePathType.serializeBinaryToWriter
        );
      }
      f = message.getSignaturesList_asU8();
      if (f.length > 0) {
        writer.writeRepeatedBytes(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
    };


    /**
     * repeated HDNodePathType pubkeys = 1;
     * @return {!Array.<!proto.HDNodePathType>}
     */
    proto.MultisigRedeemScriptType.prototype.getPubkeysList = function() {
      return /** @type{!Array.<!proto.HDNodePathType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.HDNodePathType, 1));
    };


    /** @param {!Array.<!proto.HDNodePathType>} value */
    proto.MultisigRedeemScriptType.prototype.setPubkeysList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };


    /**
     * @param {!proto.HDNodePathType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.HDNodePathType}
     */
    proto.MultisigRedeemScriptType.prototype.addPubkeys = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.HDNodePathType, opt_index);
    };


    proto.MultisigRedeemScriptType.prototype.clearPubkeysList = function() {
      this.setPubkeysList([]);
    };


    /**
     * repeated bytes signatures = 2;
     * @return {!(Array<!Uint8Array>|Array<string>)}
     */
    proto.MultisigRedeemScriptType.prototype.getSignaturesList = function() {
      return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (googleProtobuf.Message.getRepeatedField(this, 2));
    };


    /**
     * repeated bytes signatures = 2;
     * This is a type-conversion wrapper around `getSignaturesList()`
     * @return {!Array.<string>}
     */
    proto.MultisigRedeemScriptType.prototype.getSignaturesList_asB64 = function() {
      return /** @type {!Array.<string>} */ (googleProtobuf.Message.bytesListAsB64(
          this.getSignaturesList()));
    };


    /**
     * repeated bytes signatures = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignaturesList()`
     * @return {!Array.<!Uint8Array>}
     */
    proto.MultisigRedeemScriptType.prototype.getSignaturesList_asU8 = function() {
      return /** @type {!Array.<!Uint8Array>} */ (googleProtobuf.Message.bytesListAsU8(
          this.getSignaturesList()));
    };


    /** @param {!(Array<!Uint8Array>|Array<string>)} value */
    proto.MultisigRedeemScriptType.prototype.setSignaturesList = function(value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };


    /**
     * @param {!(string|Uint8Array)} value
     * @param {number=} opt_index
     */
    proto.MultisigRedeemScriptType.prototype.addSignatures = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };


    proto.MultisigRedeemScriptType.prototype.clearSignaturesList = function() {
      this.setSignaturesList([]);
    };


    /**
     * optional uint32 m = 3;
     * @return {number}
     */
    proto.MultisigRedeemScriptType.prototype.getM = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.MultisigRedeemScriptType.prototype.setM = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.MultisigRedeemScriptType.prototype.clearM = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.MultisigRedeemScriptType.prototype.hasM = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxInputType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.TxInputType.repeatedFields_, null);
    };
    goog.inherits(proto.TxInputType, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.TxInputType.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxInputType.prototype.toObject = function(opt_includeInstance) {
      return proto.TxInputType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxInputType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxInputType.toObject = function(includeInstance, msg) {
      var f, obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        prevHash: msg.getPrevHash_asB64(),
        prevIndex: googleProtobuf.Message.getField(msg, 3),
        scriptSig: msg.getScriptSig_asB64(),
        sequence: googleProtobuf.Message.getFieldWithDefault(msg, 5, -1),
        scriptType: googleProtobuf.Message.getFieldWithDefault(msg, 6, 0),
        multisig: (f = msg.getMultisig()) && proto.MultisigRedeemScriptType.toObject(includeInstance, f),
        amount: googleProtobuf.Message.getField(msg, 8),
        decredTree: googleProtobuf.Message.getField(msg, 9),
        decredScriptVersion: googleProtobuf.Message.getField(msg, 10)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxInputType}
     */
    proto.TxInputType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxInputType;
      return proto.TxInputType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxInputType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxInputType}
     */
    proto.TxInputType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPrevHash(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setPrevIndex(value);
          break;
        case 4:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setScriptSig(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setSequence(value);
          break;
        case 6:
          var value = /** @type {!proto.InputScriptType} */ (reader.readEnum());
          msg.setScriptType(value);
          break;
        case 7:
          var value = new proto.MultisigRedeemScriptType;
          reader.readMessage(value,proto.MultisigRedeemScriptType.deserializeBinaryFromReader);
          msg.setMultisig(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setAmount(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDecredTree(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDecredScriptVersion(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxInputType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxInputType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxInputType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxInputType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBytes(
          4,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeUint32(
          5,
          f
        );
      }
      f = /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeEnum(
          6,
          f
        );
      }
      f = message.getMultisig();
      if (f != null) {
        writer.writeMessage(
          7,
          f,
          proto.MultisigRedeemScriptType.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeUint64(
          8,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint32(
          9,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeUint32(
          10,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.TxInputType.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.TxInputType.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.TxInputType.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.TxInputType.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * required bytes prev_hash = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.TxInputType.prototype.getPrevHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * required bytes prev_hash = 2;
     * This is a type-conversion wrapper around `getPrevHash()`
     * @return {string}
     */
    proto.TxInputType.prototype.getPrevHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPrevHash()));
    };


    /**
     * required bytes prev_hash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPrevHash()`
     * @return {!Uint8Array}
     */
    proto.TxInputType.prototype.getPrevHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPrevHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxInputType.prototype.setPrevHash = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.TxInputType.prototype.clearPrevHash = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasPrevHash = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * required uint32 prev_index = 3;
     * @return {number}
     */
    proto.TxInputType.prototype.getPrevIndex = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.TxInputType.prototype.setPrevIndex = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.TxInputType.prototype.clearPrevIndex = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasPrevIndex = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bytes script_sig = 4;
     * @return {!(string|Uint8Array)}
     */
    proto.TxInputType.prototype.getScriptSig = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /**
     * optional bytes script_sig = 4;
     * This is a type-conversion wrapper around `getScriptSig()`
     * @return {string}
     */
    proto.TxInputType.prototype.getScriptSig_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getScriptSig()));
    };


    /**
     * optional bytes script_sig = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getScriptSig()`
     * @return {!Uint8Array}
     */
    proto.TxInputType.prototype.getScriptSig_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getScriptSig()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxInputType.prototype.setScriptSig = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.TxInputType.prototype.clearScriptSig = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasScriptSig = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional uint32 sequence = 5;
     * @return {number}
     */
    proto.TxInputType.prototype.getSequence = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, -1));
    };


    /** @param {number} value */
    proto.TxInputType.prototype.setSequence = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.TxInputType.prototype.clearSequence = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasSequence = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional InputScriptType script_type = 6;
     * @return {!proto.InputScriptType}
     */
    proto.TxInputType.prototype.getScriptType = function() {
      return /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, 0));
    };


    /** @param {!proto.InputScriptType} value */
    proto.TxInputType.prototype.setScriptType = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.TxInputType.prototype.clearScriptType = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasScriptType = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional MultisigRedeemScriptType multisig = 7;
     * @return {?proto.MultisigRedeemScriptType}
     */
    proto.TxInputType.prototype.getMultisig = function() {
      return /** @type{?proto.MultisigRedeemScriptType} */ (
        googleProtobuf.Message.getWrapperField(this, proto.MultisigRedeemScriptType, 7));
    };


    /** @param {?proto.MultisigRedeemScriptType|undefined} value */
    proto.TxInputType.prototype.setMultisig = function(value) {
      googleProtobuf.Message.setWrapperField(this, 7, value);
    };


    proto.TxInputType.prototype.clearMultisig = function() {
      this.setMultisig(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasMultisig = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional uint64 amount = 8;
     * @return {number}
     */
    proto.TxInputType.prototype.getAmount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, 0));
    };


    /** @param {number} value */
    proto.TxInputType.prototype.setAmount = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.TxInputType.prototype.clearAmount = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasAmount = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint32 decred_tree = 9;
     * @return {number}
     */
    proto.TxInputType.prototype.getDecredTree = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.TxInputType.prototype.setDecredTree = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.TxInputType.prototype.clearDecredTree = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasDecredTree = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional uint32 decred_script_version = 10;
     * @return {number}
     */
    proto.TxInputType.prototype.getDecredScriptVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, 0));
    };


    /** @param {number} value */
    proto.TxInputType.prototype.setDecredScriptVersion = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.TxInputType.prototype.clearDecredScriptVersion = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxInputType.prototype.hasDecredScriptVersion = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxOutputType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.TxOutputType.repeatedFields_, null);
    };
    goog.inherits(proto.TxOutputType, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.TxOutputType.repeatedFields_ = [2];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxOutputType.prototype.toObject = function(opt_includeInstance) {
      return proto.TxOutputType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxOutputType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxOutputType.toObject = function(includeInstance, msg) {
      var f, obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 2),
        amount: googleProtobuf.Message.getField(msg, 3),
        scriptType: googleProtobuf.Message.getField(msg, 4),
        multisig: (f = msg.getMultisig()) && proto.MultisigRedeemScriptType.toObject(includeInstance, f),
        opReturnData: msg.getOpReturnData_asB64(),
        addressType: googleProtobuf.Message.getField(msg, 7),
        exchangeType: (f = msg.getExchangeType()) && proto.ExchangeType.toObject(includeInstance, f),
        decredScriptVersion: googleProtobuf.Message.getField(msg, 9)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxOutputType}
     */
    proto.TxOutputType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxOutputType;
      return proto.TxOutputType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxOutputType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxOutputType}
     */
    proto.TxOutputType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setAmount(value);
          break;
        case 4:
          var value = /** @type {!proto.OutputScriptType} */ (reader.readEnum());
          msg.setScriptType(value);
          break;
        case 5:
          var value = new proto.MultisigRedeemScriptType;
          reader.readMessage(value,proto.MultisigRedeemScriptType.deserializeBinaryFromReader);
          msg.setMultisig(value);
          break;
        case 6:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setOpReturnData(value);
          break;
        case 7:
          var value = /** @type {!proto.OutputAddressType} */ (reader.readEnum());
          msg.setAddressType(value);
          break;
        case 8:
          var value = new proto.ExchangeType;
          reader.readMessage(value,proto.ExchangeType.deserializeBinaryFromReader);
          msg.setExchangeType(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDecredScriptVersion(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxOutputType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxOutputType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxOutputType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxOutputType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint64(
          3,
          f
        );
      }
      f = /** @type {!proto.OutputScriptType} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeEnum(
          4,
          f
        );
      }
      f = message.getMultisig();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          proto.MultisigRedeemScriptType.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBytes(
          6,
          f
        );
      }
      f = /** @type {!proto.OutputAddressType} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeEnum(
          7,
          f
        );
      }
      f = message.getExchangeType();
      if (f != null) {
        writer.writeMessage(
          8,
          f,
          proto.ExchangeType.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint32(
          9,
          f
        );
      }
    };


    /**
     * optional string address = 1;
     * @return {string}
     */
    proto.TxOutputType.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.TxOutputType.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TxOutputType.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated uint32 address_n = 2;
     * @return {!Array.<number>}
     */
    proto.TxOutputType.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 2));
    };


    /** @param {!Array.<number>} value */
    proto.TxOutputType.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 2, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.TxOutputType.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 2, value, opt_index);
    };


    proto.TxOutputType.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * required uint64 amount = 3;
     * @return {number}
     */
    proto.TxOutputType.prototype.getAmount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.TxOutputType.prototype.setAmount = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.TxOutputType.prototype.clearAmount = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasAmount = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * required OutputScriptType script_type = 4;
     * @return {!proto.OutputScriptType}
     */
    proto.TxOutputType.prototype.getScriptType = function() {
      return /** @type {!proto.OutputScriptType} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {!proto.OutputScriptType} value */
    proto.TxOutputType.prototype.setScriptType = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.TxOutputType.prototype.clearScriptType = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasScriptType = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional MultisigRedeemScriptType multisig = 5;
     * @return {?proto.MultisigRedeemScriptType}
     */
    proto.TxOutputType.prototype.getMultisig = function() {
      return /** @type{?proto.MultisigRedeemScriptType} */ (
        googleProtobuf.Message.getWrapperField(this, proto.MultisigRedeemScriptType, 5));
    };


    /** @param {?proto.MultisigRedeemScriptType|undefined} value */
    proto.TxOutputType.prototype.setMultisig = function(value) {
      googleProtobuf.Message.setWrapperField(this, 5, value);
    };


    proto.TxOutputType.prototype.clearMultisig = function() {
      this.setMultisig(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasMultisig = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bytes op_return_data = 6;
     * @return {!(string|Uint8Array)}
     */
    proto.TxOutputType.prototype.getOpReturnData = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /**
     * optional bytes op_return_data = 6;
     * This is a type-conversion wrapper around `getOpReturnData()`
     * @return {string}
     */
    proto.TxOutputType.prototype.getOpReturnData_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getOpReturnData()));
    };


    /**
     * optional bytes op_return_data = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getOpReturnData()`
     * @return {!Uint8Array}
     */
    proto.TxOutputType.prototype.getOpReturnData_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getOpReturnData()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxOutputType.prototype.setOpReturnData = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.TxOutputType.prototype.clearOpReturnData = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasOpReturnData = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional OutputAddressType address_type = 7;
     * @return {!proto.OutputAddressType}
     */
    proto.TxOutputType.prototype.getAddressType = function() {
      return /** @type {!proto.OutputAddressType} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, 0));
    };


    /** @param {!proto.OutputAddressType} value */
    proto.TxOutputType.prototype.setAddressType = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.TxOutputType.prototype.clearAddressType = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasAddressType = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional ExchangeType exchange_type = 8;
     * @return {?proto.ExchangeType}
     */
    proto.TxOutputType.prototype.getExchangeType = function() {
      return /** @type{?proto.ExchangeType} */ (
        googleProtobuf.Message.getWrapperField(this, proto.ExchangeType, 8));
    };


    /** @param {?proto.ExchangeType|undefined} value */
    proto.TxOutputType.prototype.setExchangeType = function(value) {
      googleProtobuf.Message.setWrapperField(this, 8, value);
    };


    proto.TxOutputType.prototype.clearExchangeType = function() {
      this.setExchangeType(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasExchangeType = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint32 decred_script_version = 9;
     * @return {number}
     */
    proto.TxOutputType.prototype.getDecredScriptVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.TxOutputType.prototype.setDecredScriptVersion = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.TxOutputType.prototype.clearDecredScriptVersion = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputType.prototype.hasDecredScriptVersion = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxOutputBinType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.TxOutputBinType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxOutputBinType.prototype.toObject = function(opt_includeInstance) {
      return proto.TxOutputBinType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxOutputBinType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxOutputBinType.toObject = function(includeInstance, msg) {
      var obj = {
        amount: googleProtobuf.Message.getField(msg, 1),
        scriptPubkey: msg.getScriptPubkey_asB64(),
        decredScriptVersion: googleProtobuf.Message.getField(msg, 3)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxOutputBinType}
     */
    proto.TxOutputBinType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxOutputBinType;
      return proto.TxOutputBinType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxOutputBinType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxOutputBinType}
     */
    proto.TxOutputBinType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint64());
          msg.setAmount(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setScriptPubkey(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDecredScriptVersion(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxOutputBinType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxOutputBinType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxOutputBinType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxOutputBinType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint64(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
    };


    /**
     * required uint64 amount = 1;
     * @return {number}
     */
    proto.TxOutputBinType.prototype.getAmount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.TxOutputBinType.prototype.setAmount = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TxOutputBinType.prototype.clearAmount = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputBinType.prototype.hasAmount = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required bytes script_pubkey = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.TxOutputBinType.prototype.getScriptPubkey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * required bytes script_pubkey = 2;
     * This is a type-conversion wrapper around `getScriptPubkey()`
     * @return {string}
     */
    proto.TxOutputBinType.prototype.getScriptPubkey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getScriptPubkey()));
    };


    /**
     * required bytes script_pubkey = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getScriptPubkey()`
     * @return {!Uint8Array}
     */
    proto.TxOutputBinType.prototype.getScriptPubkey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getScriptPubkey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxOutputBinType.prototype.setScriptPubkey = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.TxOutputBinType.prototype.clearScriptPubkey = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputBinType.prototype.hasScriptPubkey = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional uint32 decred_script_version = 3;
     * @return {number}
     */
    proto.TxOutputBinType.prototype.getDecredScriptVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.TxOutputBinType.prototype.setDecredScriptVersion = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.TxOutputBinType.prototype.clearDecredScriptVersion = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxOutputBinType.prototype.hasDecredScriptVersion = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TransactionType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.TransactionType.repeatedFields_, null);
    };
    goog.inherits(proto.TransactionType, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.TransactionType.repeatedFields_ = [2,3,5];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TransactionType.prototype.toObject = function(opt_includeInstance) {
      return proto.TransactionType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TransactionType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TransactionType.toObject = function(includeInstance, msg) {
      var obj = {
        version: googleProtobuf.Message.getField(msg, 1),
        inputsList: googleProtobuf.Message.toObjectList(msg.getInputsList(),
        proto.TxInputType.toObject, includeInstance),
        binOutputsList: googleProtobuf.Message.toObjectList(msg.getBinOutputsList(),
        proto.TxOutputBinType.toObject, includeInstance),
        outputsList: googleProtobuf.Message.toObjectList(msg.getOutputsList(),
        proto.TxOutputType.toObject, includeInstance),
        lockTime: googleProtobuf.Message.getField(msg, 4),
        inputsCnt: googleProtobuf.Message.getField(msg, 6),
        outputsCnt: googleProtobuf.Message.getField(msg, 7),
        extraData: msg.getExtraData_asB64(),
        extraDataLen: googleProtobuf.Message.getField(msg, 9),
        expiry: googleProtobuf.Message.getField(msg, 10),
        overwintered: googleProtobuf.Message.getField(msg, 11)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TransactionType}
     */
    proto.TransactionType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TransactionType;
      return proto.TransactionType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TransactionType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TransactionType}
     */
    proto.TransactionType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setVersion(value);
          break;
        case 2:
          var value = new proto.TxInputType;
          reader.readMessage(value,proto.TxInputType.deserializeBinaryFromReader);
          msg.addInputs(value);
          break;
        case 3:
          var value = new proto.TxOutputBinType;
          reader.readMessage(value,proto.TxOutputBinType.deserializeBinaryFromReader);
          msg.addBinOutputs(value);
          break;
        case 5:
          var value = new proto.TxOutputType;
          reader.readMessage(value,proto.TxOutputType.deserializeBinaryFromReader);
          msg.addOutputs(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setLockTime(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setInputsCnt(value);
          break;
        case 7:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setOutputsCnt(value);
          break;
        case 8:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setExtraData(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setExtraDataLen(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setExpiry(value);
          break;
        case 11:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setOverwintered(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TransactionType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TransactionType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TransactionType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TransactionType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = message.getInputsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          2,
          f,
          proto.TxInputType.serializeBinaryToWriter
        );
      }
      f = message.getBinOutputsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          3,
          f,
          proto.TxOutputBinType.serializeBinaryToWriter
        );
      }
      f = message.getOutputsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          5,
          f,
          proto.TxOutputType.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint32(
          4,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeUint32(
          6,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeUint32(
          7,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeBytes(
          8,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint32(
          9,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeUint32(
          10,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 11));
      if (f != null) {
        writer.writeBool(
          11,
          f
        );
      }
    };


    /**
     * optional uint32 version = 1;
     * @return {number}
     */
    proto.TransactionType.prototype.getVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.TransactionType.prototype.setVersion = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TransactionType.prototype.clearVersion = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasVersion = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * repeated TxInputType inputs = 2;
     * @return {!Array.<!proto.TxInputType>}
     */
    proto.TransactionType.prototype.getInputsList = function() {
      return /** @type{!Array.<!proto.TxInputType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.TxInputType, 2));
    };


    /** @param {!Array.<!proto.TxInputType>} value */
    proto.TransactionType.prototype.setInputsList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 2, value);
    };


    /**
     * @param {!proto.TxInputType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.TxInputType}
     */
    proto.TransactionType.prototype.addInputs = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.TxInputType, opt_index);
    };


    proto.TransactionType.prototype.clearInputsList = function() {
      this.setInputsList([]);
    };


    /**
     * repeated TxOutputBinType bin_outputs = 3;
     * @return {!Array.<!proto.TxOutputBinType>}
     */
    proto.TransactionType.prototype.getBinOutputsList = function() {
      return /** @type{!Array.<!proto.TxOutputBinType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.TxOutputBinType, 3));
    };


    /** @param {!Array.<!proto.TxOutputBinType>} value */
    proto.TransactionType.prototype.setBinOutputsList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 3, value);
    };


    /**
     * @param {!proto.TxOutputBinType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.TxOutputBinType}
     */
    proto.TransactionType.prototype.addBinOutputs = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.TxOutputBinType, opt_index);
    };


    proto.TransactionType.prototype.clearBinOutputsList = function() {
      this.setBinOutputsList([]);
    };


    /**
     * repeated TxOutputType outputs = 5;
     * @return {!Array.<!proto.TxOutputType>}
     */
    proto.TransactionType.prototype.getOutputsList = function() {
      return /** @type{!Array.<!proto.TxOutputType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, proto.TxOutputType, 5));
    };


    /** @param {!Array.<!proto.TxOutputType>} value */
    proto.TransactionType.prototype.setOutputsList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 5, value);
    };


    /**
     * @param {!proto.TxOutputType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.TxOutputType}
     */
    proto.TransactionType.prototype.addOutputs = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.TxOutputType, opt_index);
    };


    proto.TransactionType.prototype.clearOutputsList = function() {
      this.setOutputsList([]);
    };


    /**
     * optional uint32 lock_time = 4;
     * @return {number}
     */
    proto.TransactionType.prototype.getLockTime = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.TransactionType.prototype.setLockTime = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.TransactionType.prototype.clearLockTime = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasLockTime = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional uint32 inputs_cnt = 6;
     * @return {number}
     */
    proto.TransactionType.prototype.getInputsCnt = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, 0));
    };


    /** @param {number} value */
    proto.TransactionType.prototype.setInputsCnt = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.TransactionType.prototype.clearInputsCnt = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasInputsCnt = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional uint32 outputs_cnt = 7;
     * @return {number}
     */
    proto.TransactionType.prototype.getOutputsCnt = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, 0));
    };


    /** @param {number} value */
    proto.TransactionType.prototype.setOutputsCnt = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.TransactionType.prototype.clearOutputsCnt = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasOutputsCnt = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional bytes extra_data = 8;
     * @return {!(string|Uint8Array)}
     */
    proto.TransactionType.prototype.getExtraData = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /**
     * optional bytes extra_data = 8;
     * This is a type-conversion wrapper around `getExtraData()`
     * @return {string}
     */
    proto.TransactionType.prototype.getExtraData_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getExtraData()));
    };


    /**
     * optional bytes extra_data = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getExtraData()`
     * @return {!Uint8Array}
     */
    proto.TransactionType.prototype.getExtraData_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getExtraData()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TransactionType.prototype.setExtraData = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.TransactionType.prototype.clearExtraData = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasExtraData = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint32 extra_data_len = 9;
     * @return {number}
     */
    proto.TransactionType.prototype.getExtraDataLen = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.TransactionType.prototype.setExtraDataLen = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.TransactionType.prototype.clearExtraDataLen = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasExtraDataLen = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional uint32 expiry = 10;
     * @return {number}
     */
    proto.TransactionType.prototype.getExpiry = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, 0));
    };


    /** @param {number} value */
    proto.TransactionType.prototype.setExpiry = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.TransactionType.prototype.clearExpiry = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasExpiry = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * optional bool overwintered = 11;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.TransactionType.prototype.getOverwintered = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 11, false));
    };


    /** @param {boolean} value */
    proto.TransactionType.prototype.setOverwintered = function(value) {
      googleProtobuf.Message.setField(this, 11, value);
    };


    proto.TransactionType.prototype.clearOverwintered = function() {
      googleProtobuf.Message.setField(this, 11, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TransactionType.prototype.hasOverwintered = function() {
      return googleProtobuf.Message.getField(this, 11) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.RawTransactionType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.RawTransactionType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.RawTransactionType.prototype.toObject = function(opt_includeInstance) {
      return proto.RawTransactionType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.RawTransactionType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.RawTransactionType.toObject = function(includeInstance, msg) {
      var obj = {
        payload: msg.getPayload_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.RawTransactionType}
     */
    proto.RawTransactionType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.RawTransactionType;
      return proto.RawTransactionType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.RawTransactionType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.RawTransactionType}
     */
    proto.RawTransactionType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.RawTransactionType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.RawTransactionType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.RawTransactionType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.RawTransactionType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * required bytes payload = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.RawTransactionType.prototype.getPayload = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * required bytes payload = 1;
     * This is a type-conversion wrapper around `getPayload()`
     * @return {string}
     */
    proto.RawTransactionType.prototype.getPayload_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPayload()));
    };


    /**
     * required bytes payload = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPayload()`
     * @return {!Uint8Array}
     */
    proto.RawTransactionType.prototype.getPayload_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPayload()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.RawTransactionType.prototype.setPayload = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.RawTransactionType.prototype.clearPayload = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RawTransactionType.prototype.hasPayload = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxRequestDetailsType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.TxRequestDetailsType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxRequestDetailsType.prototype.toObject = function(opt_includeInstance) {
      return proto.TxRequestDetailsType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxRequestDetailsType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxRequestDetailsType.toObject = function(includeInstance, msg) {
      var obj = {
        requestIndex: googleProtobuf.Message.getField(msg, 1),
        txHash: msg.getTxHash_asB64(),
        extraDataLen: googleProtobuf.Message.getField(msg, 3),
        extraDataOffset: googleProtobuf.Message.getField(msg, 4)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxRequestDetailsType}
     */
    proto.TxRequestDetailsType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxRequestDetailsType;
      return proto.TxRequestDetailsType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxRequestDetailsType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxRequestDetailsType}
     */
    proto.TxRequestDetailsType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setRequestIndex(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setTxHash(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setExtraDataLen(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setExtraDataOffset(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxRequestDetailsType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxRequestDetailsType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxRequestDetailsType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxRequestDetailsType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint32(
          4,
          f
        );
      }
    };


    /**
     * optional uint32 request_index = 1;
     * @return {number}
     */
    proto.TxRequestDetailsType.prototype.getRequestIndex = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.TxRequestDetailsType.prototype.setRequestIndex = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TxRequestDetailsType.prototype.clearRequestIndex = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestDetailsType.prototype.hasRequestIndex = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes tx_hash = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.TxRequestDetailsType.prototype.getTxHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes tx_hash = 2;
     * This is a type-conversion wrapper around `getTxHash()`
     * @return {string}
     */
    proto.TxRequestDetailsType.prototype.getTxHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getTxHash()));
    };


    /**
     * optional bytes tx_hash = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTxHash()`
     * @return {!Uint8Array}
     */
    proto.TxRequestDetailsType.prototype.getTxHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getTxHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxRequestDetailsType.prototype.setTxHash = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.TxRequestDetailsType.prototype.clearTxHash = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestDetailsType.prototype.hasTxHash = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional uint32 extra_data_len = 3;
     * @return {number}
     */
    proto.TxRequestDetailsType.prototype.getExtraDataLen = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.TxRequestDetailsType.prototype.setExtraDataLen = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.TxRequestDetailsType.prototype.clearExtraDataLen = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestDetailsType.prototype.hasExtraDataLen = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint32 extra_data_offset = 4;
     * @return {number}
     */
    proto.TxRequestDetailsType.prototype.getExtraDataOffset = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.TxRequestDetailsType.prototype.setExtraDataOffset = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.TxRequestDetailsType.prototype.clearExtraDataOffset = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestDetailsType.prototype.hasExtraDataOffset = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxRequestSerializedType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.TxRequestSerializedType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxRequestSerializedType.prototype.toObject = function(opt_includeInstance) {
      return proto.TxRequestSerializedType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxRequestSerializedType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxRequestSerializedType.toObject = function(includeInstance, msg) {
      var obj = {
        signatureIndex: googleProtobuf.Message.getField(msg, 1),
        signature: msg.getSignature_asB64(),
        serializedTx: msg.getSerializedTx_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxRequestSerializedType}
     */
    proto.TxRequestSerializedType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxRequestSerializedType;
      return proto.TxRequestSerializedType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxRequestSerializedType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxRequestSerializedType}
     */
    proto.TxRequestSerializedType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setSignatureIndex(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSerializedTx(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxRequestSerializedType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxRequestSerializedType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxRequestSerializedType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxRequestSerializedType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
    };


    /**
     * optional uint32 signature_index = 1;
     * @return {number}
     */
    proto.TxRequestSerializedType.prototype.getSignatureIndex = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.TxRequestSerializedType.prototype.setSignatureIndex = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TxRequestSerializedType.prototype.clearSignatureIndex = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestSerializedType.prototype.hasSignatureIndex = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes signature = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.TxRequestSerializedType.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes signature = 2;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.TxRequestSerializedType.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.TxRequestSerializedType.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxRequestSerializedType.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.TxRequestSerializedType.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestSerializedType.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes serialized_tx = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.TxRequestSerializedType.prototype.getSerializedTx = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes serialized_tx = 3;
     * This is a type-conversion wrapper around `getSerializedTx()`
     * @return {string}
     */
    proto.TxRequestSerializedType.prototype.getSerializedTx_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSerializedTx()));
    };


    /**
     * optional bytes serialized_tx = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSerializedTx()`
     * @return {!Uint8Array}
     */
    proto.TxRequestSerializedType.prototype.getSerializedTx_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSerializedTx()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.TxRequestSerializedType.prototype.setSerializedTx = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.TxRequestSerializedType.prototype.clearSerializedTx = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequestSerializedType.prototype.hasSerializedTx = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.IdentityType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.IdentityType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.IdentityType.prototype.toObject = function(opt_includeInstance) {
      return proto.IdentityType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.IdentityType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.IdentityType.toObject = function(includeInstance, msg) {
      var obj = {
        proto: googleProtobuf.Message.getField(msg, 1),
        user: googleProtobuf.Message.getField(msg, 2),
        host: googleProtobuf.Message.getField(msg, 3),
        port: googleProtobuf.Message.getField(msg, 4),
        path: googleProtobuf.Message.getField(msg, 5),
        index: googleProtobuf.Message.getFieldWithDefault(msg, 6, 0)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.IdentityType}
     */
    proto.IdentityType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.IdentityType;
      return proto.IdentityType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.IdentityType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.IdentityType}
     */
    proto.IdentityType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setProto(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setUser(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setHost(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setPort(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setPath(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setIndex(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.IdentityType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.IdentityType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.IdentityType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.IdentityType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeString(
          5,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeUint32(
          6,
          f
        );
      }
    };


    /**
     * optional string proto = 1;
     * @return {string}
     */
    proto.IdentityType.prototype.getProto = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.IdentityType.prototype.setProto = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.IdentityType.prototype.clearProto = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.IdentityType.prototype.hasProto = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string user = 2;
     * @return {string}
     */
    proto.IdentityType.prototype.getUser = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.IdentityType.prototype.setUser = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.IdentityType.prototype.clearUser = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.IdentityType.prototype.hasUser = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string host = 3;
     * @return {string}
     */
    proto.IdentityType.prototype.getHost = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.IdentityType.prototype.setHost = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.IdentityType.prototype.clearHost = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.IdentityType.prototype.hasHost = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string port = 4;
     * @return {string}
     */
    proto.IdentityType.prototype.getPort = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /** @param {string} value */
    proto.IdentityType.prototype.setPort = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.IdentityType.prototype.clearPort = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.IdentityType.prototype.hasPort = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional string path = 5;
     * @return {string}
     */
    proto.IdentityType.prototype.getPath = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, ""));
    };


    /** @param {string} value */
    proto.IdentityType.prototype.setPath = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.IdentityType.prototype.clearPath = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.IdentityType.prototype.hasPath = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional uint32 index = 6;
     * @return {number}
     */
    proto.IdentityType.prototype.getIndex = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, 0));
    };


    /** @param {number} value */
    proto.IdentityType.prototype.setIndex = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.IdentityType.prototype.clearIndex = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.IdentityType.prototype.hasIndex = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.PolicyType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.PolicyType, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.PolicyType.prototype.toObject = function(opt_includeInstance) {
      return proto.PolicyType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.PolicyType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PolicyType.toObject = function(includeInstance, msg) {
      var obj = {
        policyName: googleProtobuf.Message.getField(msg, 1),
        enabled: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.PolicyType}
     */
    proto.PolicyType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.PolicyType;
      return proto.PolicyType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.PolicyType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.PolicyType}
     */
    proto.PolicyType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setPolicyName(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setEnabled(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.PolicyType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.PolicyType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.PolicyType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PolicyType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
    };


    /**
     * optional string policy_name = 1;
     * @return {string}
     */
    proto.PolicyType.prototype.getPolicyName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.PolicyType.prototype.setPolicyName = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.PolicyType.prototype.clearPolicyName = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PolicyType.prototype.hasPolicyName = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bool enabled = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.PolicyType.prototype.getEnabled = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.PolicyType.prototype.setEnabled = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.PolicyType.prototype.clearEnabled = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PolicyType.prototype.hasEnabled = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ExchangeType = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.ExchangeType.repeatedFields_, null);
    };
    goog.inherits(proto.ExchangeType, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.ExchangeType.repeatedFields_ = [3,4];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ExchangeType.prototype.toObject = function(opt_includeInstance) {
      return proto.ExchangeType.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ExchangeType} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeType.toObject = function(includeInstance, msg) {
      var f, obj = {
        signedExchangeResponse: (f = msg.getSignedExchangeResponse()) && exchange_pb.SignedExchangeResponse.toObject(includeInstance, f),
        withdrawalCoinName: googleProtobuf.Message.getFieldWithDefault(msg, 2, "Bitcoin"),
        withdrawalAddressNList: googleProtobuf.Message.getRepeatedField(msg, 3),
        returnAddressNList: googleProtobuf.Message.getRepeatedField(msg, 4)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ExchangeType}
     */
    proto.ExchangeType.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ExchangeType;
      return proto.ExchangeType.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ExchangeType} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ExchangeType}
     */
    proto.ExchangeType.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new exchange_pb.SignedExchangeResponse;
          reader.readMessage(value,exchange_pb.SignedExchangeResponse.deserializeBinaryFromReader);
          msg.setSignedExchangeResponse(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setWithdrawalCoinName(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addWithdrawalAddressN(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addReturnAddressN(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ExchangeType.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ExchangeType.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ExchangeType} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ExchangeType.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getSignedExchangeResponse();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          exchange_pb.SignedExchangeResponse.serializeBinaryToWriter
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = message.getWithdrawalAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          3,
          f
        );
      }
      f = message.getReturnAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          4,
          f
        );
      }
    };


    /**
     * optional SignedExchangeResponse signed_exchange_response = 1;
     * @return {?proto.SignedExchangeResponse}
     */
    proto.ExchangeType.prototype.getSignedExchangeResponse = function() {
      return /** @type{?proto.SignedExchangeResponse} */ (
        googleProtobuf.Message.getWrapperField(this, exchange_pb.SignedExchangeResponse, 1));
    };


    /** @param {?proto.SignedExchangeResponse|undefined} value */
    proto.ExchangeType.prototype.setSignedExchangeResponse = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.ExchangeType.prototype.clearSignedExchangeResponse = function() {
      this.setSignedExchangeResponse(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeType.prototype.hasSignedExchangeResponse = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string withdrawal_coin_name = 2;
     * @return {string}
     */
    proto.ExchangeType.prototype.getWithdrawalCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, "Bitcoin"));
    };


    /** @param {string} value */
    proto.ExchangeType.prototype.setWithdrawalCoinName = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ExchangeType.prototype.clearWithdrawalCoinName = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ExchangeType.prototype.hasWithdrawalCoinName = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * repeated uint32 withdrawal_address_n = 3;
     * @return {!Array.<number>}
     */
    proto.ExchangeType.prototype.getWithdrawalAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 3));
    };


    /** @param {!Array.<number>} value */
    proto.ExchangeType.prototype.setWithdrawalAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 3, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.ExchangeType.prototype.addWithdrawalAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 3, value, opt_index);
    };


    proto.ExchangeType.prototype.clearWithdrawalAddressNList = function() {
      this.setWithdrawalAddressNList([]);
    };


    /**
     * repeated uint32 return_address_n = 4;
     * @return {!Array.<number>}
     */
    proto.ExchangeType.prototype.getReturnAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 4));
    };


    /** @param {!Array.<number>} value */
    proto.ExchangeType.prototype.setReturnAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 4, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.ExchangeType.prototype.addReturnAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 4, value, opt_index);
    };


    proto.ExchangeType.prototype.clearReturnAddressNList = function() {
      this.setReturnAddressNList([]);
    };


    /**
     * @enum {number}
     */
    proto.FailureType = {
      FAILURE_UNEXPECTEDMESSAGE: 1,
      FAILURE_BUTTONEXPECTED: 2,
      FAILURE_SYNTAXERROR: 3,
      FAILURE_ACTIONCANCELLED: 4,
      FAILURE_PINEXPECTED: 5,
      FAILURE_PINCANCELLED: 6,
      FAILURE_PININVALID: 7,
      FAILURE_INVALIDSIGNATURE: 8,
      FAILURE_OTHER: 9,
      FAILURE_NOTENOUGHFUNDS: 10,
      FAILURE_NOTINITIALIZED: 11,
      FAILURE_PINMISMATCH: 12,
      FAILURE_FIRMWAREERROR: 99
    };

    /**
     * @enum {number}
     */
    proto.OutputScriptType = {
      PAYTOADDRESS: 0,
      PAYTOSCRIPTHASH: 1,
      PAYTOMULTISIG: 2,
      PAYTOOPRETURN: 3,
      PAYTOWITNESS: 4,
      PAYTOP2SHWITNESS: 5
    };

    /**
     * @enum {number}
     */
    proto.InputScriptType = {
      SPENDADDRESS: 0,
      SPENDMULTISIG: 1,
      EXTERNAL: 2,
      SPENDWITNESS: 3,
      SPENDP2SHWITNESS: 4
    };

    /**
     * @enum {number}
     */
    proto.RequestType = {
      TXINPUT: 0,
      TXOUTPUT: 1,
      TXMETA: 2,
      TXFINISHED: 3,
      TXEXTRADATA: 4
    };

    /**
     * @enum {number}
     */
    proto.OutputAddressType = {
      SPEND: 0,
      TRANSFER: 1,
      CHANGE: 2,
      EXCHANGE: 3
    };

    /**
     * @enum {number}
     */
    proto.ButtonRequestType = {
      BUTTONREQUEST_OTHER: 1,
      BUTTONREQUEST_FEEOVERTHRESHOLD: 2,
      BUTTONREQUEST_CONFIRMOUTPUT: 3,
      BUTTONREQUEST_RESETDEVICE: 4,
      BUTTONREQUEST_CONFIRMWORD: 5,
      BUTTONREQUEST_WIPEDEVICE: 6,
      BUTTONREQUEST_PROTECTCALL: 7,
      BUTTONREQUEST_SIGNTX: 8,
      BUTTONREQUEST_FIRMWARECHECK: 9,
      BUTTONREQUEST_ADDRESS: 10,
      BUTTONREQUEST_FIRMWAREERASE: 11,
      BUTTONREQUEST_CONFIRMTRANSFERTOACCOUNT: 12,
      BUTTONREQUEST_CONFIRMTRANSFERTONODEPATH: 13,
      BUTTONREQUEST_CHANGELABEL: 14,
      BUTTONREQUEST_CHANGELANGUAGE: 15,
      BUTTONREQUEST_ENABLEPASSPHRASE: 16,
      BUTTONREQUEST_DISABLEPASSPHRASE: 17,
      BUTTONREQUEST_ENCRYPTANDSIGNMESSAGE: 18,
      BUTTONREQUEST_ENCRYPTMESSAGE: 19,
      BUTTONREQUEST_IMPORTPRIVATEKEY: 20,
      BUTTONREQUEST_IMPORTRECOVERYSENTENCE: 21,
      BUTTONREQUEST_SIGNIDENTITY: 22,
      BUTTONREQUEST_PING: 23,
      BUTTONREQUEST_REMOVEPIN: 24,
      BUTTONREQUEST_CHANGEPIN: 25,
      BUTTONREQUEST_CREATEPIN: 26,
      BUTTONREQUEST_GETENTROPY: 27,
      BUTTONREQUEST_SIGNMESSAGE: 28,
      BUTTONREQUEST_APPLYPOLICIES: 29,
      BUTTONREQUEST_SIGNEXCHANGE: 30,
      BUTTONREQUEST_AUTOLOCKDELAYMS: 31,
      BUTTONREQUEST_U2FCOUNTER: 32,
      BUTTONREQUEST_CONFIRMEOSACTION: 33,
      BUTTONREQUEST_CONFIRMEOSBUDGET: 34,
      BUTTONREQUEST_CONFIRMMEMO: 35
    };

    /**
     * @enum {number}
     */
    proto.PinMatrixRequestType = {
      PINMATRIXREQUESTTYPE_CURRENT: 1,
      PINMATRIXREQUESTTYPE_NEWFIRST: 2,
      PINMATRIXREQUESTTYPE_NEWSECOND: 3
    };


    /**
     * A tuple of {field number, class constructor} for the extension
     * field named `wireIn`.
     * @type {!jspb.ExtensionFieldInfo.<boolean>}
     */
    proto.wireIn = new googleProtobuf.ExtensionFieldInfo(
        50002,
        {wireIn: 0},
        null,
         /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
             null),
        0);

    descriptor_pb.EnumValueOptions.extensionsBinary[50002] = new googleProtobuf.ExtensionFieldBinaryInfo(
        proto.wireIn,
        googleProtobuf.BinaryReader.prototype.readBool,
        googleProtobuf.BinaryWriter.prototype.writeBool,
        undefined,
        undefined,
        false);
    // This registers the extension field with the extended class, so that
    // toObject() will function correctly.
    descriptor_pb.EnumValueOptions.extensions[50002] = proto.wireIn;


    /**
     * A tuple of {field number, class constructor} for the extension
     * field named `wireOut`.
     * @type {!jspb.ExtensionFieldInfo.<boolean>}
     */
    proto.wireOut = new googleProtobuf.ExtensionFieldInfo(
        50003,
        {wireOut: 0},
        null,
         /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
             null),
        0);

    descriptor_pb.EnumValueOptions.extensionsBinary[50003] = new googleProtobuf.ExtensionFieldBinaryInfo(
        proto.wireOut,
        googleProtobuf.BinaryReader.prototype.readBool,
        googleProtobuf.BinaryWriter.prototype.writeBool,
        undefined,
        undefined,
        false);
    // This registers the extension field with the extended class, so that
    // toObject() will function correctly.
    descriptor_pb.EnumValueOptions.extensions[50003] = proto.wireOut;


    /**
     * A tuple of {field number, class constructor} for the extension
     * field named `wireDebugIn`.
     * @type {!jspb.ExtensionFieldInfo.<boolean>}
     */
    proto.wireDebugIn = new googleProtobuf.ExtensionFieldInfo(
        50004,
        {wireDebugIn: 0},
        null,
         /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
             null),
        0);

    descriptor_pb.EnumValueOptions.extensionsBinary[50004] = new googleProtobuf.ExtensionFieldBinaryInfo(
        proto.wireDebugIn,
        googleProtobuf.BinaryReader.prototype.readBool,
        googleProtobuf.BinaryWriter.prototype.writeBool,
        undefined,
        undefined,
        false);
    // This registers the extension field with the extended class, so that
    // toObject() will function correctly.
    descriptor_pb.EnumValueOptions.extensions[50004] = proto.wireDebugIn;


    /**
     * A tuple of {field number, class constructor} for the extension
     * field named `wireDebugOut`.
     * @type {!jspb.ExtensionFieldInfo.<boolean>}
     */
    proto.wireDebugOut = new googleProtobuf.ExtensionFieldInfo(
        50005,
        {wireDebugOut: 0},
        null,
         /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
             null),
        0);

    descriptor_pb.EnumValueOptions.extensionsBinary[50005] = new googleProtobuf.ExtensionFieldBinaryInfo(
        proto.wireDebugOut,
        googleProtobuf.BinaryReader.prototype.readBool,
        googleProtobuf.BinaryWriter.prototype.writeBool,
        undefined,
        undefined,
        false);
    // This registers the extension field with the extended class, so that
    // toObject() will function correctly.
    descriptor_pb.EnumValueOptions.extensions[50005] = proto.wireDebugOut;

    goog.object.extend(exports, proto);
    });

    var messages_pb = createCommonjsModule(function (module, exports) {
    /**
     * @fileoverview
     * @enhanceable
     * @suppress {messageConventions} JS Compiler reports an error if a variable or
     *     field starts with 'MSG_' and isn't a translatable message.
     * @public
     */
    // GENERATED CODE -- DO NOT EDIT!


    var goog = googleProtobuf;
    var global = Function('return this')();


    goog.exportSymbol('proto.Address', null, global);
    goog.exportSymbol('proto.ApplyPolicies', null, global);
    goog.exportSymbol('proto.ApplySettings', null, global);
    goog.exportSymbol('proto.ButtonAck', null, global);
    goog.exportSymbol('proto.ButtonRequest', null, global);
    goog.exportSymbol('proto.Cancel', null, global);
    goog.exportSymbol('proto.ChangePin', null, global);
    goog.exportSymbol('proto.CharacterAck', null, global);
    goog.exportSymbol('proto.CharacterRequest', null, global);
    goog.exportSymbol('proto.CipherKeyValue', null, global);
    goog.exportSymbol('proto.CipheredKeyValue', null, global);
    goog.exportSymbol('proto.ClearSession', null, global);
    goog.exportSymbol('proto.CoinTable', null, global);
    goog.exportSymbol('proto.DebugLinkDecision', null, global);
    goog.exportSymbol('proto.DebugLinkFillConfig', null, global);
    goog.exportSymbol('proto.DebugLinkFlashDump', null, global);
    goog.exportSymbol('proto.DebugLinkFlashDumpResponse', null, global);
    goog.exportSymbol('proto.DebugLinkGetState', null, global);
    goog.exportSymbol('proto.DebugLinkLog', null, global);
    goog.exportSymbol('proto.DebugLinkState', null, global);
    goog.exportSymbol('proto.DebugLinkStop', null, global);
    goog.exportSymbol('proto.DecryptMessage', null, global);
    goog.exportSymbol('proto.DecryptedMessage', null, global);
    goog.exportSymbol('proto.EncryptMessage', null, global);
    goog.exportSymbol('proto.EncryptedMessage', null, global);
    goog.exportSymbol('proto.Entropy', null, global);
    goog.exportSymbol('proto.EntropyAck', null, global);
    goog.exportSymbol('proto.EntropyRequest', null, global);
    goog.exportSymbol('proto.EstimateTxSize', null, global);
    goog.exportSymbol('proto.EthereumAddress', null, global);
    goog.exportSymbol('proto.EthereumGetAddress', null, global);
    goog.exportSymbol('proto.EthereumMessageSignature', null, global);
    goog.exportSymbol('proto.EthereumSignMessage', null, global);
    goog.exportSymbol('proto.EthereumSignTx', null, global);
    goog.exportSymbol('proto.EthereumTxAck', null, global);
    goog.exportSymbol('proto.EthereumTxRequest', null, global);
    goog.exportSymbol('proto.EthereumVerifyMessage', null, global);
    goog.exportSymbol('proto.Failure', null, global);
    goog.exportSymbol('proto.Features', null, global);
    goog.exportSymbol('proto.FirmwareErase', null, global);
    goog.exportSymbol('proto.FirmwareUpload', null, global);
    goog.exportSymbol('proto.FlashHash', null, global);
    goog.exportSymbol('proto.FlashHashResponse', null, global);
    goog.exportSymbol('proto.FlashWrite', null, global);
    goog.exportSymbol('proto.GetAddress', null, global);
    goog.exportSymbol('proto.GetCoinTable', null, global);
    goog.exportSymbol('proto.GetEntropy', null, global);
    goog.exportSymbol('proto.GetFeatures', null, global);
    goog.exportSymbol('proto.GetPublicKey', null, global);
    goog.exportSymbol('proto.Initialize', null, global);
    goog.exportSymbol('proto.LoadDevice', null, global);
    goog.exportSymbol('proto.MessageSignature', null, global);
    goog.exportSymbol('proto.MessageType', null, global);
    goog.exportSymbol('proto.PassphraseAck', null, global);
    goog.exportSymbol('proto.PassphraseRequest', null, global);
    goog.exportSymbol('proto.PinMatrixAck', null, global);
    goog.exportSymbol('proto.PinMatrixRequest', null, global);
    goog.exportSymbol('proto.Ping', null, global);
    goog.exportSymbol('proto.PublicKey', null, global);
    goog.exportSymbol('proto.RawTxAck', null, global);
    goog.exportSymbol('proto.RecoveryDevice', null, global);
    goog.exportSymbol('proto.ResetDevice', null, global);
    goog.exportSymbol('proto.SignIdentity', null, global);
    goog.exportSymbol('proto.SignMessage', null, global);
    goog.exportSymbol('proto.SignTx', null, global);
    goog.exportSymbol('proto.SignedIdentity', null, global);
    goog.exportSymbol('proto.SoftReset', null, global);
    goog.exportSymbol('proto.Success', null, global);
    goog.exportSymbol('proto.TxAck', null, global);
    goog.exportSymbol('proto.TxRequest', null, global);
    goog.exportSymbol('proto.TxSize', null, global);
    goog.exportSymbol('proto.VerifyMessage', null, global);
    goog.exportSymbol('proto.WipeDevice', null, global);
    goog.exportSymbol('proto.WordAck', null, global);
    goog.exportSymbol('proto.WordRequest', null, global);

    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Initialize = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Initialize, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Initialize.prototype.toObject = function(opt_includeInstance) {
      return proto.Initialize.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Initialize} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Initialize.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Initialize}
     */
    proto.Initialize.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Initialize;
      return proto.Initialize.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Initialize} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Initialize}
     */
    proto.Initialize.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Initialize.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Initialize.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Initialize} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Initialize.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.GetFeatures = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.GetFeatures, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.GetFeatures.prototype.toObject = function(opt_includeInstance) {
      return proto.GetFeatures.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.GetFeatures} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetFeatures.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.GetFeatures}
     */
    proto.GetFeatures.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.GetFeatures;
      return proto.GetFeatures.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.GetFeatures} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.GetFeatures}
     */
    proto.GetFeatures.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.GetFeatures.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.GetFeatures.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.GetFeatures} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetFeatures.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Features = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.Features.repeatedFields_, null);
    };
    goog.inherits(proto.Features, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.Features.repeatedFields_ = [11,18];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Features.prototype.toObject = function(opt_includeInstance) {
      return proto.Features.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Features} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Features.toObject = function(includeInstance, msg) {
      var obj = {
        vendor: googleProtobuf.Message.getField(msg, 1),
        majorVersion: googleProtobuf.Message.getField(msg, 2),
        minorVersion: googleProtobuf.Message.getField(msg, 3),
        patchVersion: googleProtobuf.Message.getField(msg, 4),
        bootloaderMode: googleProtobuf.Message.getField(msg, 5),
        deviceId: googleProtobuf.Message.getField(msg, 6),
        pinProtection: googleProtobuf.Message.getField(msg, 7),
        passphraseProtection: googleProtobuf.Message.getField(msg, 8),
        language: googleProtobuf.Message.getField(msg, 9),
        label: googleProtobuf.Message.getField(msg, 10),
        coinsList: googleProtobuf.Message.toObjectList(msg.getCoinsList(),
        types_pb.CoinType.toObject, includeInstance),
        initialized: googleProtobuf.Message.getField(msg, 12),
        revision: msg.getRevision_asB64(),
        bootloaderHash: msg.getBootloaderHash_asB64(),
        imported: googleProtobuf.Message.getField(msg, 15),
        pinCached: googleProtobuf.Message.getField(msg, 16),
        passphraseCached: googleProtobuf.Message.getField(msg, 17),
        policiesList: googleProtobuf.Message.toObjectList(msg.getPoliciesList(),
        types_pb.PolicyType.toObject, includeInstance),
        model: googleProtobuf.Message.getField(msg, 21),
        firmwareVariant: googleProtobuf.Message.getField(msg, 22),
        firmwareHash: msg.getFirmwareHash_asB64(),
        noBackup: googleProtobuf.Message.getField(msg, 24)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Features}
     */
    proto.Features.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Features;
      return proto.Features.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Features} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Features}
     */
    proto.Features.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setVendor(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMajorVersion(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setMinorVersion(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setPatchVersion(value);
          break;
        case 5:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setBootloaderMode(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.setDeviceId(value);
          break;
        case 7:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPinProtection(value);
          break;
        case 8:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseProtection(value);
          break;
        case 9:
          var value = /** @type {string} */ (reader.readString());
          msg.setLanguage(value);
          break;
        case 10:
          var value = /** @type {string} */ (reader.readString());
          msg.setLabel(value);
          break;
        case 11:
          var value = new types_pb.CoinType;
          reader.readMessage(value,types_pb.CoinType.deserializeBinaryFromReader);
          msg.addCoins(value);
          break;
        case 12:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setInitialized(value);
          break;
        case 13:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setRevision(value);
          break;
        case 14:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setBootloaderHash(value);
          break;
        case 15:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setImported(value);
          break;
        case 16:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPinCached(value);
          break;
        case 17:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseCached(value);
          break;
        case 18:
          var value = new types_pb.PolicyType;
          reader.readMessage(value,types_pb.PolicyType.deserializeBinaryFromReader);
          msg.addPolicies(value);
          break;
        case 21:
          var value = /** @type {string} */ (reader.readString());
          msg.setModel(value);
          break;
        case 22:
          var value = /** @type {string} */ (reader.readString());
          msg.setFirmwareVariant(value);
          break;
        case 23:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setFirmwareHash(value);
          break;
        case 24:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setNoBackup(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Features.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Features.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Features} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Features.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint32(
          4,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBool(
          5,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeString(
          6,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBool(
          7,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeBool(
          8,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeString(
          9,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeString(
          10,
          f
        );
      }
      f = message.getCoinsList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          11,
          f,
          types_pb.CoinType.serializeBinaryToWriter
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 12));
      if (f != null) {
        writer.writeBool(
          12,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 13));
      if (f != null) {
        writer.writeBytes(
          13,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 14));
      if (f != null) {
        writer.writeBytes(
          14,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 15));
      if (f != null) {
        writer.writeBool(
          15,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 16));
      if (f != null) {
        writer.writeBool(
          16,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 17));
      if (f != null) {
        writer.writeBool(
          17,
          f
        );
      }
      f = message.getPoliciesList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          18,
          f,
          types_pb.PolicyType.serializeBinaryToWriter
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 21));
      if (f != null) {
        writer.writeString(
          21,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 22));
      if (f != null) {
        writer.writeString(
          22,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 23));
      if (f != null) {
        writer.writeBytes(
          23,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 24));
      if (f != null) {
        writer.writeBool(
          24,
          f
        );
      }
    };


    /**
     * optional string vendor = 1;
     * @return {string}
     */
    proto.Features.prototype.getVendor = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.Features.prototype.setVendor = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.Features.prototype.clearVendor = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasVendor = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint32 major_version = 2;
     * @return {number}
     */
    proto.Features.prototype.getMajorVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.Features.prototype.setMajorVersion = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.Features.prototype.clearMajorVersion = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasMajorVersion = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional uint32 minor_version = 3;
     * @return {number}
     */
    proto.Features.prototype.getMinorVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.Features.prototype.setMinorVersion = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.Features.prototype.clearMinorVersion = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasMinorVersion = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint32 patch_version = 4;
     * @return {number}
     */
    proto.Features.prototype.getPatchVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.Features.prototype.setPatchVersion = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.Features.prototype.clearPatchVersion = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasPatchVersion = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional bool bootloader_mode = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getBootloaderMode = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setBootloaderMode = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.Features.prototype.clearBootloaderMode = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasBootloaderMode = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional string device_id = 6;
     * @return {string}
     */
    proto.Features.prototype.getDeviceId = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /** @param {string} value */
    proto.Features.prototype.setDeviceId = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.Features.prototype.clearDeviceId = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasDeviceId = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bool pin_protection = 7;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getPinProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setPinProtection = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.Features.prototype.clearPinProtection = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasPinProtection = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional bool passphrase_protection = 8;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getPassphraseProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setPassphraseProtection = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.Features.prototype.clearPassphraseProtection = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasPassphraseProtection = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional string language = 9;
     * @return {string}
     */
    proto.Features.prototype.getLanguage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, ""));
    };


    /** @param {string} value */
    proto.Features.prototype.setLanguage = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.Features.prototype.clearLanguage = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasLanguage = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional string label = 10;
     * @return {string}
     */
    proto.Features.prototype.getLabel = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, ""));
    };


    /** @param {string} value */
    proto.Features.prototype.setLabel = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.Features.prototype.clearLabel = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasLabel = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * repeated CoinType coins = 11;
     * @return {!Array.<!proto.CoinType>}
     */
    proto.Features.prototype.getCoinsList = function() {
      return /** @type{!Array.<!proto.CoinType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, types_pb.CoinType, 11));
    };


    /** @param {!Array.<!proto.CoinType>} value */
    proto.Features.prototype.setCoinsList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 11, value);
    };


    /**
     * @param {!proto.CoinType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.CoinType}
     */
    proto.Features.prototype.addCoins = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.CoinType, opt_index);
    };


    proto.Features.prototype.clearCoinsList = function() {
      this.setCoinsList([]);
    };


    /**
     * optional bool initialized = 12;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getInitialized = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 12, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setInitialized = function(value) {
      googleProtobuf.Message.setField(this, 12, value);
    };


    proto.Features.prototype.clearInitialized = function() {
      googleProtobuf.Message.setField(this, 12, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasInitialized = function() {
      return googleProtobuf.Message.getField(this, 12) != null;
    };


    /**
     * optional bytes revision = 13;
     * @return {!(string|Uint8Array)}
     */
    proto.Features.prototype.getRevision = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 13, ""));
    };


    /**
     * optional bytes revision = 13;
     * This is a type-conversion wrapper around `getRevision()`
     * @return {string}
     */
    proto.Features.prototype.getRevision_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getRevision()));
    };


    /**
     * optional bytes revision = 13;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getRevision()`
     * @return {!Uint8Array}
     */
    proto.Features.prototype.getRevision_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getRevision()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.Features.prototype.setRevision = function(value) {
      googleProtobuf.Message.setField(this, 13, value);
    };


    proto.Features.prototype.clearRevision = function() {
      googleProtobuf.Message.setField(this, 13, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasRevision = function() {
      return googleProtobuf.Message.getField(this, 13) != null;
    };


    /**
     * optional bytes bootloader_hash = 14;
     * @return {!(string|Uint8Array)}
     */
    proto.Features.prototype.getBootloaderHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 14, ""));
    };


    /**
     * optional bytes bootloader_hash = 14;
     * This is a type-conversion wrapper around `getBootloaderHash()`
     * @return {string}
     */
    proto.Features.prototype.getBootloaderHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getBootloaderHash()));
    };


    /**
     * optional bytes bootloader_hash = 14;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getBootloaderHash()`
     * @return {!Uint8Array}
     */
    proto.Features.prototype.getBootloaderHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getBootloaderHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.Features.prototype.setBootloaderHash = function(value) {
      googleProtobuf.Message.setField(this, 14, value);
    };


    proto.Features.prototype.clearBootloaderHash = function() {
      googleProtobuf.Message.setField(this, 14, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasBootloaderHash = function() {
      return googleProtobuf.Message.getField(this, 14) != null;
    };


    /**
     * optional bool imported = 15;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getImported = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 15, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setImported = function(value) {
      googleProtobuf.Message.setField(this, 15, value);
    };


    proto.Features.prototype.clearImported = function() {
      googleProtobuf.Message.setField(this, 15, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasImported = function() {
      return googleProtobuf.Message.getField(this, 15) != null;
    };


    /**
     * optional bool pin_cached = 16;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getPinCached = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 16, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setPinCached = function(value) {
      googleProtobuf.Message.setField(this, 16, value);
    };


    proto.Features.prototype.clearPinCached = function() {
      googleProtobuf.Message.setField(this, 16, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasPinCached = function() {
      return googleProtobuf.Message.getField(this, 16) != null;
    };


    /**
     * optional bool passphrase_cached = 17;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getPassphraseCached = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 17, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setPassphraseCached = function(value) {
      googleProtobuf.Message.setField(this, 17, value);
    };


    proto.Features.prototype.clearPassphraseCached = function() {
      googleProtobuf.Message.setField(this, 17, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasPassphraseCached = function() {
      return googleProtobuf.Message.getField(this, 17) != null;
    };


    /**
     * repeated PolicyType policies = 18;
     * @return {!Array.<!proto.PolicyType>}
     */
    proto.Features.prototype.getPoliciesList = function() {
      return /** @type{!Array.<!proto.PolicyType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, types_pb.PolicyType, 18));
    };


    /** @param {!Array.<!proto.PolicyType>} value */
    proto.Features.prototype.setPoliciesList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 18, value);
    };


    /**
     * @param {!proto.PolicyType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.PolicyType}
     */
    proto.Features.prototype.addPolicies = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.PolicyType, opt_index);
    };


    proto.Features.prototype.clearPoliciesList = function() {
      this.setPoliciesList([]);
    };


    /**
     * optional string model = 21;
     * @return {string}
     */
    proto.Features.prototype.getModel = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 21, ""));
    };


    /** @param {string} value */
    proto.Features.prototype.setModel = function(value) {
      googleProtobuf.Message.setField(this, 21, value);
    };


    proto.Features.prototype.clearModel = function() {
      googleProtobuf.Message.setField(this, 21, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasModel = function() {
      return googleProtobuf.Message.getField(this, 21) != null;
    };


    /**
     * optional string firmware_variant = 22;
     * @return {string}
     */
    proto.Features.prototype.getFirmwareVariant = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 22, ""));
    };


    /** @param {string} value */
    proto.Features.prototype.setFirmwareVariant = function(value) {
      googleProtobuf.Message.setField(this, 22, value);
    };


    proto.Features.prototype.clearFirmwareVariant = function() {
      googleProtobuf.Message.setField(this, 22, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasFirmwareVariant = function() {
      return googleProtobuf.Message.getField(this, 22) != null;
    };


    /**
     * optional bytes firmware_hash = 23;
     * @return {!(string|Uint8Array)}
     */
    proto.Features.prototype.getFirmwareHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 23, ""));
    };


    /**
     * optional bytes firmware_hash = 23;
     * This is a type-conversion wrapper around `getFirmwareHash()`
     * @return {string}
     */
    proto.Features.prototype.getFirmwareHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getFirmwareHash()));
    };


    /**
     * optional bytes firmware_hash = 23;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getFirmwareHash()`
     * @return {!Uint8Array}
     */
    proto.Features.prototype.getFirmwareHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getFirmwareHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.Features.prototype.setFirmwareHash = function(value) {
      googleProtobuf.Message.setField(this, 23, value);
    };


    proto.Features.prototype.clearFirmwareHash = function() {
      googleProtobuf.Message.setField(this, 23, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasFirmwareHash = function() {
      return googleProtobuf.Message.getField(this, 23) != null;
    };


    /**
     * optional bool no_backup = 24;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Features.prototype.getNoBackup = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 24, false));
    };


    /** @param {boolean} value */
    proto.Features.prototype.setNoBackup = function(value) {
      googleProtobuf.Message.setField(this, 24, value);
    };


    proto.Features.prototype.clearNoBackup = function() {
      googleProtobuf.Message.setField(this, 24, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Features.prototype.hasNoBackup = function() {
      return googleProtobuf.Message.getField(this, 24) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.GetCoinTable = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.GetCoinTable, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.GetCoinTable.prototype.toObject = function(opt_includeInstance) {
      return proto.GetCoinTable.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.GetCoinTable} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetCoinTable.toObject = function(includeInstance, msg) {
      var obj = {
        start: googleProtobuf.Message.getField(msg, 1),
        end: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.GetCoinTable}
     */
    proto.GetCoinTable.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.GetCoinTable;
      return proto.GetCoinTable.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.GetCoinTable} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.GetCoinTable}
     */
    proto.GetCoinTable.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setStart(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setEnd(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.GetCoinTable.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.GetCoinTable.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.GetCoinTable} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetCoinTable.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
    };


    /**
     * optional uint32 start = 1;
     * @return {number}
     */
    proto.GetCoinTable.prototype.getStart = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.GetCoinTable.prototype.setStart = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.GetCoinTable.prototype.clearStart = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetCoinTable.prototype.hasStart = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint32 end = 2;
     * @return {number}
     */
    proto.GetCoinTable.prototype.getEnd = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.GetCoinTable.prototype.setEnd = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.GetCoinTable.prototype.clearEnd = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetCoinTable.prototype.hasEnd = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.CoinTable = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.CoinTable.repeatedFields_, null);
    };
    goog.inherits(proto.CoinTable, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.CoinTable.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.CoinTable.prototype.toObject = function(opt_includeInstance) {
      return proto.CoinTable.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.CoinTable} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CoinTable.toObject = function(includeInstance, msg) {
      var obj = {
        tableList: googleProtobuf.Message.toObjectList(msg.getTableList(),
        types_pb.CoinType.toObject, includeInstance),
        numCoins: googleProtobuf.Message.getField(msg, 2),
        chunkSize: googleProtobuf.Message.getField(msg, 3)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.CoinTable}
     */
    proto.CoinTable.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.CoinTable;
      return proto.CoinTable.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.CoinTable} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.CoinTable}
     */
    proto.CoinTable.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new types_pb.CoinType;
          reader.readMessage(value,types_pb.CoinType.deserializeBinaryFromReader);
          msg.addTable(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setNumCoins(value);
          break;
        case 3:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setChunkSize(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.CoinTable.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.CoinTable.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.CoinTable} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CoinTable.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getTableList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          types_pb.CoinType.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeUint32(
          3,
          f
        );
      }
    };


    /**
     * repeated CoinType table = 1;
     * @return {!Array.<!proto.CoinType>}
     */
    proto.CoinTable.prototype.getTableList = function() {
      return /** @type{!Array.<!proto.CoinType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, types_pb.CoinType, 1));
    };


    /** @param {!Array.<!proto.CoinType>} value */
    proto.CoinTable.prototype.setTableList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };


    /**
     * @param {!proto.CoinType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.CoinType}
     */
    proto.CoinTable.prototype.addTable = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.CoinType, opt_index);
    };


    proto.CoinTable.prototype.clearTableList = function() {
      this.setTableList([]);
    };


    /**
     * optional uint32 num_coins = 2;
     * @return {number}
     */
    proto.CoinTable.prototype.getNumCoins = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.CoinTable.prototype.setNumCoins = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.CoinTable.prototype.clearNumCoins = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinTable.prototype.hasNumCoins = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional uint32 chunk_size = 3;
     * @return {number}
     */
    proto.CoinTable.prototype.getChunkSize = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, 0));
    };


    /** @param {number} value */
    proto.CoinTable.prototype.setChunkSize = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.CoinTable.prototype.clearChunkSize = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CoinTable.prototype.hasChunkSize = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ClearSession = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ClearSession, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ClearSession.prototype.toObject = function(opt_includeInstance) {
      return proto.ClearSession.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ClearSession} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ClearSession.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ClearSession}
     */
    proto.ClearSession.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ClearSession;
      return proto.ClearSession.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ClearSession} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ClearSession}
     */
    proto.ClearSession.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ClearSession.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ClearSession.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ClearSession} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ClearSession.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ApplySettings = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ApplySettings, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ApplySettings.prototype.toObject = function(opt_includeInstance) {
      return proto.ApplySettings.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ApplySettings} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ApplySettings.toObject = function(includeInstance, msg) {
      var obj = {
        language: googleProtobuf.Message.getField(msg, 1),
        label: googleProtobuf.Message.getField(msg, 2),
        usePassphrase: googleProtobuf.Message.getField(msg, 3),
        autoLockDelayMs: googleProtobuf.Message.getField(msg, 4),
        u2fCounter: googleProtobuf.Message.getField(msg, 5)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ApplySettings}
     */
    proto.ApplySettings.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ApplySettings;
      return proto.ApplySettings.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ApplySettings} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ApplySettings}
     */
    proto.ApplySettings.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setLanguage(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setLabel(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setUsePassphrase(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAutoLockDelayMs(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setU2fCounter(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ApplySettings.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ApplySettings.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ApplySettings} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ApplySettings.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint32(
          4,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeUint32(
          5,
          f
        );
      }
    };


    /**
     * optional string language = 1;
     * @return {string}
     */
    proto.ApplySettings.prototype.getLanguage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.ApplySettings.prototype.setLanguage = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.ApplySettings.prototype.clearLanguage = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ApplySettings.prototype.hasLanguage = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string label = 2;
     * @return {string}
     */
    proto.ApplySettings.prototype.getLabel = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.ApplySettings.prototype.setLabel = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ApplySettings.prototype.clearLabel = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ApplySettings.prototype.hasLabel = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool use_passphrase = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.ApplySettings.prototype.getUsePassphrase = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.ApplySettings.prototype.setUsePassphrase = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.ApplySettings.prototype.clearUsePassphrase = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ApplySettings.prototype.hasUsePassphrase = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint32 auto_lock_delay_ms = 4;
     * @return {number}
     */
    proto.ApplySettings.prototype.getAutoLockDelayMs = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {number} value */
    proto.ApplySettings.prototype.setAutoLockDelayMs = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.ApplySettings.prototype.clearAutoLockDelayMs = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ApplySettings.prototype.hasAutoLockDelayMs = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional uint32 u2f_counter = 5;
     * @return {number}
     */
    proto.ApplySettings.prototype.getU2fCounter = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 0));
    };


    /** @param {number} value */
    proto.ApplySettings.prototype.setU2fCounter = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.ApplySettings.prototype.clearU2fCounter = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ApplySettings.prototype.hasU2fCounter = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ChangePin = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ChangePin, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ChangePin.prototype.toObject = function(opt_includeInstance) {
      return proto.ChangePin.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ChangePin} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ChangePin.toObject = function(includeInstance, msg) {
      var obj = {
        remove: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ChangePin}
     */
    proto.ChangePin.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ChangePin;
      return proto.ChangePin.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ChangePin} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ChangePin}
     */
    proto.ChangePin.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setRemove(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ChangePin.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ChangePin.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ChangePin} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ChangePin.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBool(
          1,
          f
        );
      }
    };


    /**
     * optional bool remove = 1;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.ChangePin.prototype.getRemove = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, false));
    };


    /** @param {boolean} value */
    proto.ChangePin.prototype.setRemove = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.ChangePin.prototype.clearRemove = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ChangePin.prototype.hasRemove = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Ping = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Ping, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Ping.prototype.toObject = function(opt_includeInstance) {
      return proto.Ping.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Ping} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Ping.toObject = function(includeInstance, msg) {
      var obj = {
        message: googleProtobuf.Message.getField(msg, 1),
        buttonProtection: googleProtobuf.Message.getField(msg, 2),
        pinProtection: googleProtobuf.Message.getField(msg, 3),
        passphraseProtection: googleProtobuf.Message.getField(msg, 4)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Ping}
     */
    proto.Ping.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Ping;
      return proto.Ping.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Ping} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Ping}
     */
    proto.Ping.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setMessage(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setButtonProtection(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPinProtection(value);
          break;
        case 4:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseProtection(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Ping.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Ping.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Ping} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Ping.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBool(
          4,
          f
        );
      }
    };


    /**
     * optional string message = 1;
     * @return {string}
     */
    proto.Ping.prototype.getMessage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.Ping.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.Ping.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Ping.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bool button_protection = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Ping.prototype.getButtonProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.Ping.prototype.setButtonProtection = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.Ping.prototype.clearButtonProtection = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Ping.prototype.hasButtonProtection = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool pin_protection = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Ping.prototype.getPinProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.Ping.prototype.setPinProtection = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.Ping.prototype.clearPinProtection = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Ping.prototype.hasPinProtection = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bool passphrase_protection = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.Ping.prototype.getPassphraseProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, false));
    };


    /** @param {boolean} value */
    proto.Ping.prototype.setPassphraseProtection = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.Ping.prototype.clearPassphraseProtection = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Ping.prototype.hasPassphraseProtection = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Success = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Success, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Success.prototype.toObject = function(opt_includeInstance) {
      return proto.Success.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Success} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Success.toObject = function(includeInstance, msg) {
      var obj = {
        message: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Success}
     */
    proto.Success.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Success;
      return proto.Success.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Success} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Success}
     */
    proto.Success.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Success.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Success.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Success} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Success.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
    };


    /**
     * optional string message = 1;
     * @return {string}
     */
    proto.Success.prototype.getMessage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.Success.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.Success.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Success.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Failure = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Failure, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Failure.prototype.toObject = function(opt_includeInstance) {
      return proto.Failure.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Failure} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Failure.toObject = function(includeInstance, msg) {
      var obj = {
        code: googleProtobuf.Message.getField(msg, 1),
        message: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Failure}
     */
    proto.Failure.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Failure;
      return proto.Failure.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Failure} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Failure}
     */
    proto.Failure.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!proto.FailureType} */ (reader.readEnum());
          msg.setCode(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Failure.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Failure.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Failure} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Failure.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!proto.FailureType} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeEnum(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
    };


    /**
     * optional FailureType code = 1;
     * @return {!proto.FailureType}
     */
    proto.Failure.prototype.getCode = function() {
      return /** @type {!proto.FailureType} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 1));
    };


    /** @param {!proto.FailureType} value */
    proto.Failure.prototype.setCode = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.Failure.prototype.clearCode = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Failure.prototype.hasCode = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string message = 2;
     * @return {string}
     */
    proto.Failure.prototype.getMessage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.Failure.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.Failure.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Failure.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ButtonRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ButtonRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ButtonRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.ButtonRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ButtonRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ButtonRequest.toObject = function(includeInstance, msg) {
      var obj = {
        code: googleProtobuf.Message.getField(msg, 1),
        data: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ButtonRequest}
     */
    proto.ButtonRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ButtonRequest;
      return proto.ButtonRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ButtonRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ButtonRequest}
     */
    proto.ButtonRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!proto.ButtonRequestType} */ (reader.readEnum());
          msg.setCode(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setData(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ButtonRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ButtonRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ButtonRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ButtonRequest.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!proto.ButtonRequestType} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeEnum(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
    };


    /**
     * optional ButtonRequestType code = 1;
     * @return {!proto.ButtonRequestType}
     */
    proto.ButtonRequest.prototype.getCode = function() {
      return /** @type {!proto.ButtonRequestType} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 1));
    };


    /** @param {!proto.ButtonRequestType} value */
    proto.ButtonRequest.prototype.setCode = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.ButtonRequest.prototype.clearCode = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ButtonRequest.prototype.hasCode = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string data = 2;
     * @return {string}
     */
    proto.ButtonRequest.prototype.getData = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.ButtonRequest.prototype.setData = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ButtonRequest.prototype.clearData = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ButtonRequest.prototype.hasData = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ButtonAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ButtonAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ButtonAck.prototype.toObject = function(opt_includeInstance) {
      return proto.ButtonAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ButtonAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ButtonAck.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ButtonAck}
     */
    proto.ButtonAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ButtonAck;
      return proto.ButtonAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ButtonAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ButtonAck}
     */
    proto.ButtonAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ButtonAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ButtonAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ButtonAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ButtonAck.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.PinMatrixRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.PinMatrixRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.PinMatrixRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.PinMatrixRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.PinMatrixRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PinMatrixRequest.toObject = function(includeInstance, msg) {
      var obj = {
        type: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.PinMatrixRequest}
     */
    proto.PinMatrixRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.PinMatrixRequest;
      return proto.PinMatrixRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.PinMatrixRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.PinMatrixRequest}
     */
    proto.PinMatrixRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!proto.PinMatrixRequestType} */ (reader.readEnum());
          msg.setType(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.PinMatrixRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.PinMatrixRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.PinMatrixRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PinMatrixRequest.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!proto.PinMatrixRequestType} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeEnum(
          1,
          f
        );
      }
    };


    /**
     * optional PinMatrixRequestType type = 1;
     * @return {!proto.PinMatrixRequestType}
     */
    proto.PinMatrixRequest.prototype.getType = function() {
      return /** @type {!proto.PinMatrixRequestType} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 1));
    };


    /** @param {!proto.PinMatrixRequestType} value */
    proto.PinMatrixRequest.prototype.setType = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.PinMatrixRequest.prototype.clearType = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PinMatrixRequest.prototype.hasType = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.PinMatrixAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.PinMatrixAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.PinMatrixAck.prototype.toObject = function(opt_includeInstance) {
      return proto.PinMatrixAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.PinMatrixAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PinMatrixAck.toObject = function(includeInstance, msg) {
      var obj = {
        pin: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.PinMatrixAck}
     */
    proto.PinMatrixAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.PinMatrixAck;
      return proto.PinMatrixAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.PinMatrixAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.PinMatrixAck}
     */
    proto.PinMatrixAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setPin(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.PinMatrixAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.PinMatrixAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.PinMatrixAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PinMatrixAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
    };


    /**
     * required string pin = 1;
     * @return {string}
     */
    proto.PinMatrixAck.prototype.getPin = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.PinMatrixAck.prototype.setPin = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.PinMatrixAck.prototype.clearPin = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PinMatrixAck.prototype.hasPin = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Cancel = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Cancel, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Cancel.prototype.toObject = function(opt_includeInstance) {
      return proto.Cancel.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Cancel} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Cancel.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Cancel}
     */
    proto.Cancel.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Cancel;
      return proto.Cancel.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Cancel} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Cancel}
     */
    proto.Cancel.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Cancel.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Cancel.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Cancel} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Cancel.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.PassphraseRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.PassphraseRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.PassphraseRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.PassphraseRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.PassphraseRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PassphraseRequest.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.PassphraseRequest}
     */
    proto.PassphraseRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.PassphraseRequest;
      return proto.PassphraseRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.PassphraseRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.PassphraseRequest}
     */
    proto.PassphraseRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.PassphraseRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.PassphraseRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.PassphraseRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PassphraseRequest.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.PassphraseAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.PassphraseAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.PassphraseAck.prototype.toObject = function(opt_includeInstance) {
      return proto.PassphraseAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.PassphraseAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PassphraseAck.toObject = function(includeInstance, msg) {
      var obj = {
        passphrase: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.PassphraseAck}
     */
    proto.PassphraseAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.PassphraseAck;
      return proto.PassphraseAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.PassphraseAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.PassphraseAck}
     */
    proto.PassphraseAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setPassphrase(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.PassphraseAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.PassphraseAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.PassphraseAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PassphraseAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
    };


    /**
     * required string passphrase = 1;
     * @return {string}
     */
    proto.PassphraseAck.prototype.getPassphrase = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.PassphraseAck.prototype.setPassphrase = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.PassphraseAck.prototype.clearPassphrase = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PassphraseAck.prototype.hasPassphrase = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.GetEntropy = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.GetEntropy, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.GetEntropy.prototype.toObject = function(opt_includeInstance) {
      return proto.GetEntropy.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.GetEntropy} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetEntropy.toObject = function(includeInstance, msg) {
      var obj = {
        size: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.GetEntropy}
     */
    proto.GetEntropy.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.GetEntropy;
      return proto.GetEntropy.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.GetEntropy} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.GetEntropy}
     */
    proto.GetEntropy.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setSize(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.GetEntropy.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.GetEntropy.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.GetEntropy} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetEntropy.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
    };


    /**
     * required uint32 size = 1;
     * @return {number}
     */
    proto.GetEntropy.prototype.getSize = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.GetEntropy.prototype.setSize = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.GetEntropy.prototype.clearSize = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetEntropy.prototype.hasSize = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Entropy = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Entropy, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Entropy.prototype.toObject = function(opt_includeInstance) {
      return proto.Entropy.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Entropy} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Entropy.toObject = function(includeInstance, msg) {
      var obj = {
        entropy: msg.getEntropy_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Entropy}
     */
    proto.Entropy.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Entropy;
      return proto.Entropy.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Entropy} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Entropy}
     */
    proto.Entropy.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setEntropy(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Entropy.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Entropy.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Entropy} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Entropy.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * required bytes entropy = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.Entropy.prototype.getEntropy = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * required bytes entropy = 1;
     * This is a type-conversion wrapper around `getEntropy()`
     * @return {string}
     */
    proto.Entropy.prototype.getEntropy_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getEntropy()));
    };


    /**
     * required bytes entropy = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getEntropy()`
     * @return {!Uint8Array}
     */
    proto.Entropy.prototype.getEntropy_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getEntropy()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.Entropy.prototype.setEntropy = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.Entropy.prototype.clearEntropy = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Entropy.prototype.hasEntropy = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.GetPublicKey = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.GetPublicKey.repeatedFields_, null);
    };
    goog.inherits(proto.GetPublicKey, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.GetPublicKey.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.GetPublicKey.prototype.toObject = function(opt_includeInstance) {
      return proto.GetPublicKey.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.GetPublicKey} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetPublicKey.toObject = function(includeInstance, msg) {
      var obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        ecdsaCurveName: googleProtobuf.Message.getField(msg, 2),
        showDisplay: googleProtobuf.Message.getField(msg, 3),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 4, "Bitcoin"),
        scriptType: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.GetPublicKey}
     */
    proto.GetPublicKey.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.GetPublicKey;
      return proto.GetPublicKey.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.GetPublicKey} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.GetPublicKey}
     */
    proto.GetPublicKey.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setEcdsaCurveName(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setShowDisplay(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        case 5:
          var value = /** @type {!proto.InputScriptType} */ (reader.readEnum());
          msg.setScriptType(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.GetPublicKey.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.GetPublicKey.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.GetPublicKey} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetPublicKey.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
      f = /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeEnum(
          5,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.GetPublicKey.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.GetPublicKey.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.GetPublicKey.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.GetPublicKey.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional string ecdsa_curve_name = 2;
     * @return {string}
     */
    proto.GetPublicKey.prototype.getEcdsaCurveName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.GetPublicKey.prototype.setEcdsaCurveName = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.GetPublicKey.prototype.clearEcdsaCurveName = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetPublicKey.prototype.hasEcdsaCurveName = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool show_display = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.GetPublicKey.prototype.getShowDisplay = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.GetPublicKey.prototype.setShowDisplay = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.GetPublicKey.prototype.clearShowDisplay = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetPublicKey.prototype.hasShowDisplay = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string coin_name = 4;
     * @return {string}
     */
    proto.GetPublicKey.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, "Bitcoin"));
    };


    /** @param {string} value */
    proto.GetPublicKey.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.GetPublicKey.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetPublicKey.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional InputScriptType script_type = 5;
     * @return {!proto.InputScriptType}
     */
    proto.GetPublicKey.prototype.getScriptType = function() {
      return /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 0));
    };


    /** @param {!proto.InputScriptType} value */
    proto.GetPublicKey.prototype.setScriptType = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.GetPublicKey.prototype.clearScriptType = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetPublicKey.prototype.hasScriptType = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.PublicKey = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.PublicKey, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.PublicKey.prototype.toObject = function(opt_includeInstance) {
      return proto.PublicKey.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.PublicKey} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PublicKey.toObject = function(includeInstance, msg) {
      var f, obj = {
        node: (f = msg.getNode()) && types_pb.HDNodeType.toObject(includeInstance, f),
        xpub: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.PublicKey}
     */
    proto.PublicKey.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.PublicKey;
      return proto.PublicKey.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.PublicKey} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.PublicKey}
     */
    proto.PublicKey.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new types_pb.HDNodeType;
          reader.readMessage(value,types_pb.HDNodeType.deserializeBinaryFromReader);
          msg.setNode(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setXpub(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.PublicKey.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.PublicKey.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.PublicKey} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.PublicKey.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getNode();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          types_pb.HDNodeType.serializeBinaryToWriter
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
    };


    /**
     * required HDNodeType node = 1;
     * @return {!proto.HDNodeType}
     */
    proto.PublicKey.prototype.getNode = function() {
      return /** @type{!proto.HDNodeType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.HDNodeType, 1, 1));
    };


    /** @param {!proto.HDNodeType} value */
    proto.PublicKey.prototype.setNode = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.PublicKey.prototype.clearNode = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PublicKey.prototype.hasNode = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string xpub = 2;
     * @return {string}
     */
    proto.PublicKey.prototype.getXpub = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.PublicKey.prototype.setXpub = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.PublicKey.prototype.clearXpub = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.PublicKey.prototype.hasXpub = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.GetAddress = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.GetAddress.repeatedFields_, null);
    };
    goog.inherits(proto.GetAddress, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.GetAddress.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.GetAddress.prototype.toObject = function(opt_includeInstance) {
      return proto.GetAddress.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.GetAddress} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetAddress.toObject = function(includeInstance, msg) {
      var f, obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 2, "Bitcoin"),
        showDisplay: googleProtobuf.Message.getField(msg, 3),
        multisig: (f = msg.getMultisig()) && types_pb.MultisigRedeemScriptType.toObject(includeInstance, f),
        scriptType: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.GetAddress}
     */
    proto.GetAddress.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.GetAddress;
      return proto.GetAddress.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.GetAddress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.GetAddress}
     */
    proto.GetAddress.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setShowDisplay(value);
          break;
        case 4:
          var value = new types_pb.MultisigRedeemScriptType;
          reader.readMessage(value,types_pb.MultisigRedeemScriptType.deserializeBinaryFromReader);
          msg.setMultisig(value);
          break;
        case 5:
          var value = /** @type {!proto.InputScriptType} */ (reader.readEnum());
          msg.setScriptType(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.GetAddress.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.GetAddress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.GetAddress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.GetAddress.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = message.getMultisig();
      if (f != null) {
        writer.writeMessage(
          4,
          f,
          types_pb.MultisigRedeemScriptType.serializeBinaryToWriter
        );
      }
      f = /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeEnum(
          5,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.GetAddress.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.GetAddress.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.GetAddress.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.GetAddress.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional string coin_name = 2;
     * @return {string}
     */
    proto.GetAddress.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, "Bitcoin"));
    };


    /** @param {string} value */
    proto.GetAddress.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.GetAddress.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetAddress.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool show_display = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.GetAddress.prototype.getShowDisplay = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.GetAddress.prototype.setShowDisplay = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.GetAddress.prototype.clearShowDisplay = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetAddress.prototype.hasShowDisplay = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional MultisigRedeemScriptType multisig = 4;
     * @return {?proto.MultisigRedeemScriptType}
     */
    proto.GetAddress.prototype.getMultisig = function() {
      return /** @type{?proto.MultisigRedeemScriptType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.MultisigRedeemScriptType, 4));
    };


    /** @param {?proto.MultisigRedeemScriptType|undefined} value */
    proto.GetAddress.prototype.setMultisig = function(value) {
      googleProtobuf.Message.setWrapperField(this, 4, value);
    };


    proto.GetAddress.prototype.clearMultisig = function() {
      this.setMultisig(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetAddress.prototype.hasMultisig = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional InputScriptType script_type = 5;
     * @return {!proto.InputScriptType}
     */
    proto.GetAddress.prototype.getScriptType = function() {
      return /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 0));
    };


    /** @param {!proto.InputScriptType} value */
    proto.GetAddress.prototype.setScriptType = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.GetAddress.prototype.clearScriptType = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.GetAddress.prototype.hasScriptType = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumGetAddress = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.EthereumGetAddress.repeatedFields_, null);
    };
    goog.inherits(proto.EthereumGetAddress, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.EthereumGetAddress.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumGetAddress.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumGetAddress.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumGetAddress} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumGetAddress.toObject = function(includeInstance, msg) {
      var obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        showDisplay: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumGetAddress}
     */
    proto.EthereumGetAddress.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumGetAddress;
      return proto.EthereumGetAddress.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumGetAddress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumGetAddress}
     */
    proto.EthereumGetAddress.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setShowDisplay(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumGetAddress.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumGetAddress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumGetAddress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumGetAddress.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.EthereumGetAddress.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.EthereumGetAddress.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.EthereumGetAddress.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.EthereumGetAddress.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional bool show_display = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.EthereumGetAddress.prototype.getShowDisplay = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.EthereumGetAddress.prototype.setShowDisplay = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumGetAddress.prototype.clearShowDisplay = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumGetAddress.prototype.hasShowDisplay = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.Address = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.Address, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.Address.prototype.toObject = function(opt_includeInstance) {
      return proto.Address.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.Address} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Address.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.Address}
     */
    proto.Address.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.Address;
      return proto.Address.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.Address} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.Address}
     */
    proto.Address.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.Address.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.Address.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.Address} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.Address.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
    };


    /**
     * required string address = 1;
     * @return {string}
     */
    proto.Address.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.Address.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.Address.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.Address.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumAddress = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EthereumAddress, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumAddress.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumAddress.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumAddress} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumAddress.toObject = function(includeInstance, msg) {
      var obj = {
        address: msg.getAddress_asB64(),
        addressStr: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumAddress}
     */
    proto.EthereumAddress.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumAddress;
      return proto.EthereumAddress.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumAddress} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumAddress}
     */
    proto.EthereumAddress.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddressStr(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumAddress.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumAddress.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumAddress} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumAddress.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
    };


    /**
     * required bytes address = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumAddress.prototype.getAddress = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * required bytes address = 1;
     * This is a type-conversion wrapper around `getAddress()`
     * @return {string}
     */
    proto.EthereumAddress.prototype.getAddress_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getAddress()));
    };


    /**
     * required bytes address = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAddress()`
     * @return {!Uint8Array}
     */
    proto.EthereumAddress.prototype.getAddress_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getAddress()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumAddress.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EthereumAddress.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumAddress.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string address_str = 2;
     * @return {string}
     */
    proto.EthereumAddress.prototype.getAddressStr = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.EthereumAddress.prototype.setAddressStr = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumAddress.prototype.clearAddressStr = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumAddress.prototype.hasAddressStr = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.WipeDevice = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.WipeDevice, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.WipeDevice.prototype.toObject = function(opt_includeInstance) {
      return proto.WipeDevice.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.WipeDevice} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.WipeDevice.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.WipeDevice}
     */
    proto.WipeDevice.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.WipeDevice;
      return proto.WipeDevice.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.WipeDevice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.WipeDevice}
     */
    proto.WipeDevice.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.WipeDevice.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.WipeDevice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.WipeDevice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.WipeDevice.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.LoadDevice = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.LoadDevice, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.LoadDevice.prototype.toObject = function(opt_includeInstance) {
      return proto.LoadDevice.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.LoadDevice} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.LoadDevice.toObject = function(includeInstance, msg) {
      var f, obj = {
        mnemonic: googleProtobuf.Message.getField(msg, 1),
        node: (f = msg.getNode()) && types_pb.HDNodeType.toObject(includeInstance, f),
        pin: googleProtobuf.Message.getField(msg, 3),
        passphraseProtection: googleProtobuf.Message.getField(msg, 4),
        language: googleProtobuf.Message.getFieldWithDefault(msg, 5, "english"),
        label: googleProtobuf.Message.getField(msg, 6),
        skipChecksum: googleProtobuf.Message.getField(msg, 7),
        u2fCounter: googleProtobuf.Message.getField(msg, 8)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.LoadDevice}
     */
    proto.LoadDevice.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.LoadDevice;
      return proto.LoadDevice.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.LoadDevice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.LoadDevice}
     */
    proto.LoadDevice.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setMnemonic(value);
          break;
        case 2:
          var value = new types_pb.HDNodeType;
          reader.readMessage(value,types_pb.HDNodeType.deserializeBinaryFromReader);
          msg.setNode(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setPin(value);
          break;
        case 4:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseProtection(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setLanguage(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.setLabel(value);
          break;
        case 7:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setSkipChecksum(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setU2fCounter(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.LoadDevice.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.LoadDevice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.LoadDevice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.LoadDevice.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = message.getNode();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          types_pb.HDNodeType.serializeBinaryToWriter
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBool(
          4,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeString(
          5,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeString(
          6,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBool(
          7,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeUint32(
          8,
          f
        );
      }
    };


    /**
     * optional string mnemonic = 1;
     * @return {string}
     */
    proto.LoadDevice.prototype.getMnemonic = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.LoadDevice.prototype.setMnemonic = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.LoadDevice.prototype.clearMnemonic = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasMnemonic = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional HDNodeType node = 2;
     * @return {?proto.HDNodeType}
     */
    proto.LoadDevice.prototype.getNode = function() {
      return /** @type{?proto.HDNodeType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.HDNodeType, 2));
    };


    /** @param {?proto.HDNodeType|undefined} value */
    proto.LoadDevice.prototype.setNode = function(value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };


    proto.LoadDevice.prototype.clearNode = function() {
      this.setNode(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasNode = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string pin = 3;
     * @return {string}
     */
    proto.LoadDevice.prototype.getPin = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.LoadDevice.prototype.setPin = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.LoadDevice.prototype.clearPin = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasPin = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bool passphrase_protection = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.LoadDevice.prototype.getPassphraseProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, false));
    };


    /** @param {boolean} value */
    proto.LoadDevice.prototype.setPassphraseProtection = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.LoadDevice.prototype.clearPassphraseProtection = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasPassphraseProtection = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional string language = 5;
     * @return {string}
     */
    proto.LoadDevice.prototype.getLanguage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, "english"));
    };


    /** @param {string} value */
    proto.LoadDevice.prototype.setLanguage = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.LoadDevice.prototype.clearLanguage = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasLanguage = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional string label = 6;
     * @return {string}
     */
    proto.LoadDevice.prototype.getLabel = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /** @param {string} value */
    proto.LoadDevice.prototype.setLabel = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.LoadDevice.prototype.clearLabel = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasLabel = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bool skip_checksum = 7;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.LoadDevice.prototype.getSkipChecksum = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, false));
    };


    /** @param {boolean} value */
    proto.LoadDevice.prototype.setSkipChecksum = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.LoadDevice.prototype.clearSkipChecksum = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasSkipChecksum = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional uint32 u2f_counter = 8;
     * @return {number}
     */
    proto.LoadDevice.prototype.getU2fCounter = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, 0));
    };


    /** @param {number} value */
    proto.LoadDevice.prototype.setU2fCounter = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.LoadDevice.prototype.clearU2fCounter = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.LoadDevice.prototype.hasU2fCounter = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ResetDevice = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.ResetDevice, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ResetDevice.prototype.toObject = function(opt_includeInstance) {
      return proto.ResetDevice.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ResetDevice} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ResetDevice.toObject = function(includeInstance, msg) {
      var obj = {
        displayRandom: googleProtobuf.Message.getField(msg, 1),
        strength: googleProtobuf.Message.getFieldWithDefault(msg, 2, 256),
        passphraseProtection: googleProtobuf.Message.getField(msg, 3),
        pinProtection: googleProtobuf.Message.getField(msg, 4),
        language: googleProtobuf.Message.getFieldWithDefault(msg, 5, "english"),
        label: googleProtobuf.Message.getField(msg, 6),
        noBackup: googleProtobuf.Message.getField(msg, 7),
        autoLockDelayMs: googleProtobuf.Message.getField(msg, 8),
        u2fCounter: googleProtobuf.Message.getField(msg, 9)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ResetDevice}
     */
    proto.ResetDevice.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ResetDevice;
      return proto.ResetDevice.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ResetDevice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ResetDevice}
     */
    proto.ResetDevice.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDisplayRandom(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setStrength(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseProtection(value);
          break;
        case 4:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPinProtection(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setLanguage(value);
          break;
        case 6:
          var value = /** @type {string} */ (reader.readString());
          msg.setLabel(value);
          break;
        case 7:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setNoBackup(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAutoLockDelayMs(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setU2fCounter(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ResetDevice.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ResetDevice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ResetDevice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ResetDevice.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBool(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBool(
          4,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeString(
          5,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeString(
          6,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBool(
          7,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeUint32(
          8,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint32(
          9,
          f
        );
      }
    };


    /**
     * optional bool display_random = 1;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.ResetDevice.prototype.getDisplayRandom = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, false));
    };


    /** @param {boolean} value */
    proto.ResetDevice.prototype.setDisplayRandom = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.ResetDevice.prototype.clearDisplayRandom = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasDisplayRandom = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint32 strength = 2;
     * @return {number}
     */
    proto.ResetDevice.prototype.getStrength = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 256));
    };


    /** @param {number} value */
    proto.ResetDevice.prototype.setStrength = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.ResetDevice.prototype.clearStrength = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasStrength = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool passphrase_protection = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.ResetDevice.prototype.getPassphraseProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.ResetDevice.prototype.setPassphraseProtection = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.ResetDevice.prototype.clearPassphraseProtection = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasPassphraseProtection = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bool pin_protection = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.ResetDevice.prototype.getPinProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, false));
    };


    /** @param {boolean} value */
    proto.ResetDevice.prototype.setPinProtection = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.ResetDevice.prototype.clearPinProtection = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasPinProtection = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional string language = 5;
     * @return {string}
     */
    proto.ResetDevice.prototype.getLanguage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, "english"));
    };


    /** @param {string} value */
    proto.ResetDevice.prototype.setLanguage = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.ResetDevice.prototype.clearLanguage = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasLanguage = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional string label = 6;
     * @return {string}
     */
    proto.ResetDevice.prototype.getLabel = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /** @param {string} value */
    proto.ResetDevice.prototype.setLabel = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.ResetDevice.prototype.clearLabel = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasLabel = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bool no_backup = 7;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.ResetDevice.prototype.getNoBackup = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, false));
    };


    /** @param {boolean} value */
    proto.ResetDevice.prototype.setNoBackup = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.ResetDevice.prototype.clearNoBackup = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasNoBackup = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional uint32 auto_lock_delay_ms = 8;
     * @return {number}
     */
    proto.ResetDevice.prototype.getAutoLockDelayMs = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, 0));
    };


    /** @param {number} value */
    proto.ResetDevice.prototype.setAutoLockDelayMs = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.ResetDevice.prototype.clearAutoLockDelayMs = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasAutoLockDelayMs = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint32 u2f_counter = 9;
     * @return {number}
     */
    proto.ResetDevice.prototype.getU2fCounter = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.ResetDevice.prototype.setU2fCounter = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.ResetDevice.prototype.clearU2fCounter = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.ResetDevice.prototype.hasU2fCounter = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EntropyRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EntropyRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EntropyRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.EntropyRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EntropyRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EntropyRequest.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EntropyRequest}
     */
    proto.EntropyRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EntropyRequest;
      return proto.EntropyRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EntropyRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EntropyRequest}
     */
    proto.EntropyRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EntropyRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EntropyRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EntropyRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EntropyRequest.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EntropyAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EntropyAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EntropyAck.prototype.toObject = function(opt_includeInstance) {
      return proto.EntropyAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EntropyAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EntropyAck.toObject = function(includeInstance, msg) {
      var obj = {
        entropy: msg.getEntropy_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EntropyAck}
     */
    proto.EntropyAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EntropyAck;
      return proto.EntropyAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EntropyAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EntropyAck}
     */
    proto.EntropyAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setEntropy(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EntropyAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EntropyAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EntropyAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EntropyAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * optional bytes entropy = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EntropyAck.prototype.getEntropy = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes entropy = 1;
     * This is a type-conversion wrapper around `getEntropy()`
     * @return {string}
     */
    proto.EntropyAck.prototype.getEntropy_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getEntropy()));
    };


    /**
     * optional bytes entropy = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getEntropy()`
     * @return {!Uint8Array}
     */
    proto.EntropyAck.prototype.getEntropy_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getEntropy()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EntropyAck.prototype.setEntropy = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EntropyAck.prototype.clearEntropy = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EntropyAck.prototype.hasEntropy = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.RecoveryDevice = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.RecoveryDevice, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.RecoveryDevice.prototype.toObject = function(opt_includeInstance) {
      return proto.RecoveryDevice.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.RecoveryDevice} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.RecoveryDevice.toObject = function(includeInstance, msg) {
      var obj = {
        wordCount: googleProtobuf.Message.getField(msg, 1),
        passphraseProtection: googleProtobuf.Message.getField(msg, 2),
        pinProtection: googleProtobuf.Message.getField(msg, 3),
        language: googleProtobuf.Message.getFieldWithDefault(msg, 4, "english"),
        label: googleProtobuf.Message.getField(msg, 5),
        enforceWordlist: googleProtobuf.Message.getField(msg, 6),
        useCharacterCipher: googleProtobuf.Message.getField(msg, 7),
        autoLockDelayMs: googleProtobuf.Message.getField(msg, 8),
        u2fCounter: googleProtobuf.Message.getField(msg, 9),
        dryRun: googleProtobuf.Message.getField(msg, 10)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.RecoveryDevice}
     */
    proto.RecoveryDevice.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.RecoveryDevice;
      return proto.RecoveryDevice.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.RecoveryDevice} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.RecoveryDevice}
     */
    proto.RecoveryDevice.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setWordCount(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseProtection(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPinProtection(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setLanguage(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setLabel(value);
          break;
        case 6:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setEnforceWordlist(value);
          break;
        case 7:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setUseCharacterCipher(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAutoLockDelayMs(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setU2fCounter(value);
          break;
        case 10:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDryRun(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.RecoveryDevice.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.RecoveryDevice.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.RecoveryDevice} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.RecoveryDevice.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeString(
          5,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBool(
          6,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBool(
          7,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeUint32(
          8,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeUint32(
          9,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeBool(
          10,
          f
        );
      }
    };


    /**
     * optional uint32 word_count = 1;
     * @return {number}
     */
    proto.RecoveryDevice.prototype.getWordCount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.RecoveryDevice.prototype.setWordCount = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.RecoveryDevice.prototype.clearWordCount = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasWordCount = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bool passphrase_protection = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.RecoveryDevice.prototype.getPassphraseProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.RecoveryDevice.prototype.setPassphraseProtection = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.RecoveryDevice.prototype.clearPassphraseProtection = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasPassphraseProtection = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool pin_protection = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.RecoveryDevice.prototype.getPinProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.RecoveryDevice.prototype.setPinProtection = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.RecoveryDevice.prototype.clearPinProtection = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasPinProtection = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string language = 4;
     * @return {string}
     */
    proto.RecoveryDevice.prototype.getLanguage = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, "english"));
    };


    /** @param {string} value */
    proto.RecoveryDevice.prototype.setLanguage = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.RecoveryDevice.prototype.clearLanguage = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasLanguage = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional string label = 5;
     * @return {string}
     */
    proto.RecoveryDevice.prototype.getLabel = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, ""));
    };


    /** @param {string} value */
    proto.RecoveryDevice.prototype.setLabel = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.RecoveryDevice.prototype.clearLabel = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasLabel = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bool enforce_wordlist = 6;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.RecoveryDevice.prototype.getEnforceWordlist = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, false));
    };


    /** @param {boolean} value */
    proto.RecoveryDevice.prototype.setEnforceWordlist = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.RecoveryDevice.prototype.clearEnforceWordlist = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasEnforceWordlist = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bool use_character_cipher = 7;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.RecoveryDevice.prototype.getUseCharacterCipher = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, false));
    };


    /** @param {boolean} value */
    proto.RecoveryDevice.prototype.setUseCharacterCipher = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.RecoveryDevice.prototype.clearUseCharacterCipher = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasUseCharacterCipher = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional uint32 auto_lock_delay_ms = 8;
     * @return {number}
     */
    proto.RecoveryDevice.prototype.getAutoLockDelayMs = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, 0));
    };


    /** @param {number} value */
    proto.RecoveryDevice.prototype.setAutoLockDelayMs = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.RecoveryDevice.prototype.clearAutoLockDelayMs = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasAutoLockDelayMs = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional uint32 u2f_counter = 9;
     * @return {number}
     */
    proto.RecoveryDevice.prototype.getU2fCounter = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, 0));
    };


    /** @param {number} value */
    proto.RecoveryDevice.prototype.setU2fCounter = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.RecoveryDevice.prototype.clearU2fCounter = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasU2fCounter = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional bool dry_run = 10;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.RecoveryDevice.prototype.getDryRun = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, false));
    };


    /** @param {boolean} value */
    proto.RecoveryDevice.prototype.setDryRun = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.RecoveryDevice.prototype.clearDryRun = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RecoveryDevice.prototype.hasDryRun = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.WordRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.WordRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.WordRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.WordRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.WordRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.WordRequest.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.WordRequest}
     */
    proto.WordRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.WordRequest;
      return proto.WordRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.WordRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.WordRequest}
     */
    proto.WordRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.WordRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.WordRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.WordRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.WordRequest.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.WordAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.WordAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.WordAck.prototype.toObject = function(opt_includeInstance) {
      return proto.WordAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.WordAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.WordAck.toObject = function(includeInstance, msg) {
      var obj = {
        word: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.WordAck}
     */
    proto.WordAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.WordAck;
      return proto.WordAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.WordAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.WordAck}
     */
    proto.WordAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setWord(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.WordAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.WordAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.WordAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.WordAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
    };


    /**
     * required string word = 1;
     * @return {string}
     */
    proto.WordAck.prototype.getWord = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.WordAck.prototype.setWord = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.WordAck.prototype.clearWord = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.WordAck.prototype.hasWord = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.CharacterRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.CharacterRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.CharacterRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.CharacterRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.CharacterRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CharacterRequest.toObject = function(includeInstance, msg) {
      var obj = {
        wordPos: googleProtobuf.Message.getField(msg, 1),
        characterPos: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.CharacterRequest}
     */
    proto.CharacterRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.CharacterRequest;
      return proto.CharacterRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.CharacterRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.CharacterRequest}
     */
    proto.CharacterRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setWordPos(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setCharacterPos(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.CharacterRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.CharacterRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.CharacterRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CharacterRequest.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
    };


    /**
     * required uint32 word_pos = 1;
     * @return {number}
     */
    proto.CharacterRequest.prototype.getWordPos = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.CharacterRequest.prototype.setWordPos = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.CharacterRequest.prototype.clearWordPos = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CharacterRequest.prototype.hasWordPos = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required uint32 character_pos = 2;
     * @return {number}
     */
    proto.CharacterRequest.prototype.getCharacterPos = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.CharacterRequest.prototype.setCharacterPos = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.CharacterRequest.prototype.clearCharacterPos = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CharacterRequest.prototype.hasCharacterPos = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.CharacterAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.CharacterAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.CharacterAck.prototype.toObject = function(opt_includeInstance) {
      return proto.CharacterAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.CharacterAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CharacterAck.toObject = function(includeInstance, msg) {
      var obj = {
        character: googleProtobuf.Message.getField(msg, 1),
        pb_delete: googleProtobuf.Message.getField(msg, 2),
        done: googleProtobuf.Message.getField(msg, 3)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.CharacterAck}
     */
    proto.CharacterAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.CharacterAck;
      return proto.CharacterAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.CharacterAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.CharacterAck}
     */
    proto.CharacterAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setCharacter(value);
          break;
        case 2:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDelete(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDone(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.CharacterAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.CharacterAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.CharacterAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CharacterAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBool(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
    };


    /**
     * optional string character = 1;
     * @return {string}
     */
    proto.CharacterAck.prototype.getCharacter = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.CharacterAck.prototype.setCharacter = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.CharacterAck.prototype.clearCharacter = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CharacterAck.prototype.hasCharacter = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bool delete = 2;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CharacterAck.prototype.getDelete = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, false));
    };


    /** @param {boolean} value */
    proto.CharacterAck.prototype.setDelete = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.CharacterAck.prototype.clearDelete = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CharacterAck.prototype.hasDelete = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool done = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CharacterAck.prototype.getDone = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.CharacterAck.prototype.setDone = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.CharacterAck.prototype.clearDone = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CharacterAck.prototype.hasDone = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.SignMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.SignMessage.repeatedFields_, null);
    };
    goog.inherits(proto.SignMessage, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.SignMessage.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.SignMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.SignMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.SignMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignMessage.toObject = function(includeInstance, msg) {
      var obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        message: msg.getMessage_asB64(),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 3, "Bitcoin"),
        scriptType: googleProtobuf.Message.getFieldWithDefault(msg, 4, 0)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.SignMessage}
     */
    proto.SignMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.SignMessage;
      return proto.SignMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.SignMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.SignMessage}
     */
    proto.SignMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        case 4:
          var value = /** @type {!proto.InputScriptType} */ (reader.readEnum());
          msg.setScriptType(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.SignMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.SignMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.SignMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeEnum(
          4,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.SignMessage.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.SignMessage.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.SignMessage.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.SignMessage.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * required bytes message = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.SignMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * required bytes message = 2;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.SignMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * required bytes message = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.SignMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.SignMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.SignMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string coin_name = 3;
     * @return {string}
     */
    proto.SignMessage.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, "Bitcoin"));
    };


    /** @param {string} value */
    proto.SignMessage.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.SignMessage.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignMessage.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional InputScriptType script_type = 4;
     * @return {!proto.InputScriptType}
     */
    proto.SignMessage.prototype.getScriptType = function() {
      return /** @type {!proto.InputScriptType} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 0));
    };


    /** @param {!proto.InputScriptType} value */
    proto.SignMessage.prototype.setScriptType = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.SignMessage.prototype.clearScriptType = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignMessage.prototype.hasScriptType = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.VerifyMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.VerifyMessage, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.VerifyMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.VerifyMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.VerifyMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.VerifyMessage.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        signature: msg.getSignature_asB64(),
        message: msg.getMessage_asB64(),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 4, "Bitcoin")
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.VerifyMessage}
     */
    proto.VerifyMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.VerifyMessage;
      return proto.VerifyMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.VerifyMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.VerifyMessage}
     */
    proto.VerifyMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.VerifyMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.VerifyMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.VerifyMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.VerifyMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
    };


    /**
     * optional string address = 1;
     * @return {string}
     */
    proto.VerifyMessage.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.VerifyMessage.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.VerifyMessage.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.VerifyMessage.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes signature = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.VerifyMessage.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes signature = 2;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.VerifyMessage.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.VerifyMessage.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.VerifyMessage.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.VerifyMessage.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.VerifyMessage.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes message = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.VerifyMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes message = 3;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.VerifyMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * optional bytes message = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.VerifyMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.VerifyMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.VerifyMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.VerifyMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string coin_name = 4;
     * @return {string}
     */
    proto.VerifyMessage.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, "Bitcoin"));
    };


    /** @param {string} value */
    proto.VerifyMessage.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.VerifyMessage.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.VerifyMessage.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.MessageSignature = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.MessageSignature, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.MessageSignature.prototype.toObject = function(opt_includeInstance) {
      return proto.MessageSignature.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.MessageSignature} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.MessageSignature.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        signature: msg.getSignature_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.MessageSignature}
     */
    proto.MessageSignature.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.MessageSignature;
      return proto.MessageSignature.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.MessageSignature} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.MessageSignature}
     */
    proto.MessageSignature.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.MessageSignature.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.MessageSignature.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.MessageSignature} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.MessageSignature.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
    };


    /**
     * optional string address = 1;
     * @return {string}
     */
    proto.MessageSignature.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.MessageSignature.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.MessageSignature.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.MessageSignature.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes signature = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.MessageSignature.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes signature = 2;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.MessageSignature.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.MessageSignature.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.MessageSignature.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.MessageSignature.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.MessageSignature.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EncryptMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.EncryptMessage.repeatedFields_, null);
    };
    goog.inherits(proto.EncryptMessage, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.EncryptMessage.repeatedFields_ = [4];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EncryptMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.EncryptMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EncryptMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EncryptMessage.toObject = function(includeInstance, msg) {
      var obj = {
        pubkey: msg.getPubkey_asB64(),
        message: msg.getMessage_asB64(),
        displayOnly: googleProtobuf.Message.getField(msg, 3),
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 4),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 5, "Bitcoin")
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EncryptMessage}
     */
    proto.EncryptMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EncryptMessage;
      return proto.EncryptMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EncryptMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EncryptMessage}
     */
    proto.EncryptMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPubkey(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setDisplayOnly(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 5:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EncryptMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EncryptMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EncryptMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EncryptMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          4,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeString(
          5,
          f
        );
      }
    };


    /**
     * optional bytes pubkey = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EncryptMessage.prototype.getPubkey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes pubkey = 1;
     * This is a type-conversion wrapper around `getPubkey()`
     * @return {string}
     */
    proto.EncryptMessage.prototype.getPubkey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPubkey()));
    };


    /**
     * optional bytes pubkey = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPubkey()`
     * @return {!Uint8Array}
     */
    proto.EncryptMessage.prototype.getPubkey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPubkey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EncryptMessage.prototype.setPubkey = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EncryptMessage.prototype.clearPubkey = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptMessage.prototype.hasPubkey = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes message = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.EncryptMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes message = 2;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.EncryptMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * optional bytes message = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.EncryptMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EncryptMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EncryptMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool display_only = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.EncryptMessage.prototype.getDisplayOnly = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.EncryptMessage.prototype.setDisplayOnly = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.EncryptMessage.prototype.clearDisplayOnly = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptMessage.prototype.hasDisplayOnly = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * repeated uint32 address_n = 4;
     * @return {!Array.<number>}
     */
    proto.EncryptMessage.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 4));
    };


    /** @param {!Array.<number>} value */
    proto.EncryptMessage.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 4, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.EncryptMessage.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 4, value, opt_index);
    };


    proto.EncryptMessage.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional string coin_name = 5;
     * @return {string}
     */
    proto.EncryptMessage.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, "Bitcoin"));
    };


    /** @param {string} value */
    proto.EncryptMessage.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.EncryptMessage.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptMessage.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EncryptedMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EncryptedMessage, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EncryptedMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.EncryptedMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EncryptedMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EncryptedMessage.toObject = function(includeInstance, msg) {
      var obj = {
        nonce: msg.getNonce_asB64(),
        message: msg.getMessage_asB64(),
        hmac: msg.getHmac_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EncryptedMessage}
     */
    proto.EncryptedMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EncryptedMessage;
      return proto.EncryptedMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EncryptedMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EncryptedMessage}
     */
    proto.EncryptedMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setNonce(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setHmac(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EncryptedMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EncryptedMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EncryptedMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EncryptedMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
    };


    /**
     * optional bytes nonce = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EncryptedMessage.prototype.getNonce = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes nonce = 1;
     * This is a type-conversion wrapper around `getNonce()`
     * @return {string}
     */
    proto.EncryptedMessage.prototype.getNonce_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getNonce()));
    };


    /**
     * optional bytes nonce = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getNonce()`
     * @return {!Uint8Array}
     */
    proto.EncryptedMessage.prototype.getNonce_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getNonce()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EncryptedMessage.prototype.setNonce = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EncryptedMessage.prototype.clearNonce = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptedMessage.prototype.hasNonce = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes message = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.EncryptedMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes message = 2;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.EncryptedMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * optional bytes message = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.EncryptedMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EncryptedMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EncryptedMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptedMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes hmac = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.EncryptedMessage.prototype.getHmac = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes hmac = 3;
     * This is a type-conversion wrapper around `getHmac()`
     * @return {string}
     */
    proto.EncryptedMessage.prototype.getHmac_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getHmac()));
    };


    /**
     * optional bytes hmac = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHmac()`
     * @return {!Uint8Array}
     */
    proto.EncryptedMessage.prototype.getHmac_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getHmac()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EncryptedMessage.prototype.setHmac = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.EncryptedMessage.prototype.clearHmac = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EncryptedMessage.prototype.hasHmac = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DecryptMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.DecryptMessage.repeatedFields_, null);
    };
    goog.inherits(proto.DecryptMessage, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.DecryptMessage.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DecryptMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.DecryptMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DecryptMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DecryptMessage.toObject = function(includeInstance, msg) {
      var obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        nonce: msg.getNonce_asB64(),
        message: msg.getMessage_asB64(),
        hmac: msg.getHmac_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DecryptMessage}
     */
    proto.DecryptMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DecryptMessage;
      return proto.DecryptMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DecryptMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DecryptMessage}
     */
    proto.DecryptMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setNonce(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        case 4:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setHmac(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DecryptMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DecryptMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DecryptMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DecryptMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBytes(
          4,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.DecryptMessage.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.DecryptMessage.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.DecryptMessage.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.DecryptMessage.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional bytes nonce = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.DecryptMessage.prototype.getNonce = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes nonce = 2;
     * This is a type-conversion wrapper around `getNonce()`
     * @return {string}
     */
    proto.DecryptMessage.prototype.getNonce_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getNonce()));
    };


    /**
     * optional bytes nonce = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getNonce()`
     * @return {!Uint8Array}
     */
    proto.DecryptMessage.prototype.getNonce_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getNonce()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DecryptMessage.prototype.setNonce = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.DecryptMessage.prototype.clearNonce = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DecryptMessage.prototype.hasNonce = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes message = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.DecryptMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes message = 3;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.DecryptMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * optional bytes message = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.DecryptMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DecryptMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.DecryptMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DecryptMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bytes hmac = 4;
     * @return {!(string|Uint8Array)}
     */
    proto.DecryptMessage.prototype.getHmac = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /**
     * optional bytes hmac = 4;
     * This is a type-conversion wrapper around `getHmac()`
     * @return {string}
     */
    proto.DecryptMessage.prototype.getHmac_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getHmac()));
    };


    /**
     * optional bytes hmac = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHmac()`
     * @return {!Uint8Array}
     */
    proto.DecryptMessage.prototype.getHmac_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getHmac()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DecryptMessage.prototype.setHmac = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.DecryptMessage.prototype.clearHmac = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DecryptMessage.prototype.hasHmac = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DecryptedMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DecryptedMessage, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DecryptedMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.DecryptedMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DecryptedMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DecryptedMessage.toObject = function(includeInstance, msg) {
      var obj = {
        message: msg.getMessage_asB64(),
        address: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DecryptedMessage}
     */
    proto.DecryptedMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DecryptedMessage;
      return proto.DecryptedMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DecryptedMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DecryptedMessage}
     */
    proto.DecryptedMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DecryptedMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DecryptedMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DecryptedMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DecryptedMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
    };


    /**
     * optional bytes message = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.DecryptedMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes message = 1;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.DecryptedMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * optional bytes message = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.DecryptedMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DecryptedMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.DecryptedMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DecryptedMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string address = 2;
     * @return {string}
     */
    proto.DecryptedMessage.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.DecryptedMessage.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.DecryptedMessage.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DecryptedMessage.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.CipherKeyValue = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.CipherKeyValue.repeatedFields_, null);
    };
    goog.inherits(proto.CipherKeyValue, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.CipherKeyValue.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.CipherKeyValue.prototype.toObject = function(opt_includeInstance) {
      return proto.CipherKeyValue.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.CipherKeyValue} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CipherKeyValue.toObject = function(includeInstance, msg) {
      var obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        key: googleProtobuf.Message.getField(msg, 2),
        value: msg.getValue_asB64(),
        encrypt: googleProtobuf.Message.getField(msg, 4),
        askOnEncrypt: googleProtobuf.Message.getField(msg, 5),
        askOnDecrypt: googleProtobuf.Message.getField(msg, 6),
        iv: msg.getIv_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.CipherKeyValue}
     */
    proto.CipherKeyValue.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.CipherKeyValue;
      return proto.CipherKeyValue.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.CipherKeyValue} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.CipherKeyValue}
     */
    proto.CipherKeyValue.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setKey(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setValue(value);
          break;
        case 4:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setEncrypt(value);
          break;
        case 5:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setAskOnEncrypt(value);
          break;
        case 6:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setAskOnDecrypt(value);
          break;
        case 7:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setIv(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.CipherKeyValue.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.CipherKeyValue.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.CipherKeyValue} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CipherKeyValue.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBool(
          4,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBool(
          5,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBool(
          6,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBytes(
          7,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.CipherKeyValue.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.CipherKeyValue.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.CipherKeyValue.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.CipherKeyValue.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional string key = 2;
     * @return {string}
     */
    proto.CipherKeyValue.prototype.getKey = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.CipherKeyValue.prototype.setKey = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.CipherKeyValue.prototype.clearKey = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipherKeyValue.prototype.hasKey = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes value = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.CipherKeyValue.prototype.getValue = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes value = 3;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */
    proto.CipherKeyValue.prototype.getValue_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getValue()));
    };


    /**
     * optional bytes value = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */
    proto.CipherKeyValue.prototype.getValue_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getValue()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.CipherKeyValue.prototype.setValue = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.CipherKeyValue.prototype.clearValue = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipherKeyValue.prototype.hasValue = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bool encrypt = 4;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CipherKeyValue.prototype.getEncrypt = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, false));
    };


    /** @param {boolean} value */
    proto.CipherKeyValue.prototype.setEncrypt = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.CipherKeyValue.prototype.clearEncrypt = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipherKeyValue.prototype.hasEncrypt = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional bool ask_on_encrypt = 5;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CipherKeyValue.prototype.getAskOnEncrypt = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, false));
    };


    /** @param {boolean} value */
    proto.CipherKeyValue.prototype.setAskOnEncrypt = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.CipherKeyValue.prototype.clearAskOnEncrypt = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipherKeyValue.prototype.hasAskOnEncrypt = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bool ask_on_decrypt = 6;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.CipherKeyValue.prototype.getAskOnDecrypt = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, false));
    };


    /** @param {boolean} value */
    proto.CipherKeyValue.prototype.setAskOnDecrypt = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.CipherKeyValue.prototype.clearAskOnDecrypt = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipherKeyValue.prototype.hasAskOnDecrypt = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bytes iv = 7;
     * @return {!(string|Uint8Array)}
     */
    proto.CipherKeyValue.prototype.getIv = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, ""));
    };


    /**
     * optional bytes iv = 7;
     * This is a type-conversion wrapper around `getIv()`
     * @return {string}
     */
    proto.CipherKeyValue.prototype.getIv_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getIv()));
    };


    /**
     * optional bytes iv = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getIv()`
     * @return {!Uint8Array}
     */
    proto.CipherKeyValue.prototype.getIv_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getIv()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.CipherKeyValue.prototype.setIv = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.CipherKeyValue.prototype.clearIv = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipherKeyValue.prototype.hasIv = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.CipheredKeyValue = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.CipheredKeyValue, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.CipheredKeyValue.prototype.toObject = function(opt_includeInstance) {
      return proto.CipheredKeyValue.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.CipheredKeyValue} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CipheredKeyValue.toObject = function(includeInstance, msg) {
      var obj = {
        value: msg.getValue_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.CipheredKeyValue}
     */
    proto.CipheredKeyValue.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.CipheredKeyValue;
      return proto.CipheredKeyValue.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.CipheredKeyValue} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.CipheredKeyValue}
     */
    proto.CipheredKeyValue.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setValue(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.CipheredKeyValue.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.CipheredKeyValue.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.CipheredKeyValue} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.CipheredKeyValue.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * optional bytes value = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.CipheredKeyValue.prototype.getValue = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes value = 1;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */
    proto.CipheredKeyValue.prototype.getValue_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getValue()));
    };


    /**
     * optional bytes value = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */
    proto.CipheredKeyValue.prototype.getValue_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getValue()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.CipheredKeyValue.prototype.setValue = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.CipheredKeyValue.prototype.clearValue = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.CipheredKeyValue.prototype.hasValue = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EstimateTxSize = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EstimateTxSize, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EstimateTxSize.prototype.toObject = function(opt_includeInstance) {
      return proto.EstimateTxSize.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EstimateTxSize} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EstimateTxSize.toObject = function(includeInstance, msg) {
      var obj = {
        outputsCount: googleProtobuf.Message.getField(msg, 1),
        inputsCount: googleProtobuf.Message.getField(msg, 2),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 3, "Bitcoin")
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EstimateTxSize}
     */
    proto.EstimateTxSize.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EstimateTxSize;
      return proto.EstimateTxSize.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EstimateTxSize} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EstimateTxSize}
     */
    proto.EstimateTxSize.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setOutputsCount(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setInputsCount(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EstimateTxSize.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EstimateTxSize.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EstimateTxSize} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EstimateTxSize.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
    };


    /**
     * required uint32 outputs_count = 1;
     * @return {number}
     */
    proto.EstimateTxSize.prototype.getOutputsCount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.EstimateTxSize.prototype.setOutputsCount = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EstimateTxSize.prototype.clearOutputsCount = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EstimateTxSize.prototype.hasOutputsCount = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required uint32 inputs_count = 2;
     * @return {number}
     */
    proto.EstimateTxSize.prototype.getInputsCount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.EstimateTxSize.prototype.setInputsCount = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EstimateTxSize.prototype.clearInputsCount = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EstimateTxSize.prototype.hasInputsCount = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string coin_name = 3;
     * @return {string}
     */
    proto.EstimateTxSize.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, "Bitcoin"));
    };


    /** @param {string} value */
    proto.EstimateTxSize.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.EstimateTxSize.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EstimateTxSize.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxSize = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.TxSize, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxSize.prototype.toObject = function(opt_includeInstance) {
      return proto.TxSize.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxSize} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxSize.toObject = function(includeInstance, msg) {
      var obj = {
        txSize: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxSize}
     */
    proto.TxSize.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxSize;
      return proto.TxSize.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxSize} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxSize}
     */
    proto.TxSize.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setTxSize(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxSize.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxSize.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxSize} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxSize.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
    };


    /**
     * optional uint32 tx_size = 1;
     * @return {number}
     */
    proto.TxSize.prototype.getTxSize = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.TxSize.prototype.setTxSize = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TxSize.prototype.clearTxSize = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxSize.prototype.hasTxSize = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.SignTx = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.SignTx, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.SignTx.prototype.toObject = function(opt_includeInstance) {
      return proto.SignTx.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.SignTx} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignTx.toObject = function(includeInstance, msg) {
      var obj = {
        outputsCount: googleProtobuf.Message.getField(msg, 1),
        inputsCount: googleProtobuf.Message.getField(msg, 2),
        coinName: googleProtobuf.Message.getFieldWithDefault(msg, 3, "Bitcoin"),
        version: googleProtobuf.Message.getFieldWithDefault(msg, 4, 1),
        lockTime: googleProtobuf.Message.getFieldWithDefault(msg, 5, 0),
        expiry: googleProtobuf.Message.getField(msg, 6),
        overwintered: googleProtobuf.Message.getField(msg, 7),
        versionGroupId: googleProtobuf.Message.getField(msg, 8)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.SignTx}
     */
    proto.SignTx.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.SignTx;
      return proto.SignTx.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.SignTx} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.SignTx}
     */
    proto.SignTx.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setOutputsCount(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setInputsCount(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setCoinName(value);
          break;
        case 4:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setVersion(value);
          break;
        case 5:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setLockTime(value);
          break;
        case 6:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setExpiry(value);
          break;
        case 7:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setOverwintered(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setVersionGroupId(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.SignTx.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.SignTx.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.SignTx} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignTx.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeUint32(
          4,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeUint32(
          5,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeUint32(
          6,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBool(
          7,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeUint32(
          8,
          f
        );
      }
    };


    /**
     * required uint32 outputs_count = 1;
     * @return {number}
     */
    proto.SignTx.prototype.getOutputsCount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.SignTx.prototype.setOutputsCount = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.SignTx.prototype.clearOutputsCount = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasOutputsCount = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required uint32 inputs_count = 2;
     * @return {number}
     */
    proto.SignTx.prototype.getInputsCount = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.SignTx.prototype.setInputsCount = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.SignTx.prototype.clearInputsCount = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasInputsCount = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string coin_name = 3;
     * @return {string}
     */
    proto.SignTx.prototype.getCoinName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, "Bitcoin"));
    };


    /** @param {string} value */
    proto.SignTx.prototype.setCoinName = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.SignTx.prototype.clearCoinName = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasCoinName = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional uint32 version = 4;
     * @return {number}
     */
    proto.SignTx.prototype.getVersion = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, 1));
    };


    /** @param {number} value */
    proto.SignTx.prototype.setVersion = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.SignTx.prototype.clearVersion = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasVersion = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional uint32 lock_time = 5;
     * @return {number}
     */
    proto.SignTx.prototype.getLockTime = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, 0));
    };


    /** @param {number} value */
    proto.SignTx.prototype.setLockTime = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.SignTx.prototype.clearLockTime = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasLockTime = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional uint32 expiry = 6;
     * @return {number}
     */
    proto.SignTx.prototype.getExpiry = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, 0));
    };


    /** @param {number} value */
    proto.SignTx.prototype.setExpiry = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.SignTx.prototype.clearExpiry = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasExpiry = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bool overwintered = 7;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.SignTx.prototype.getOverwintered = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, false));
    };


    /** @param {boolean} value */
    proto.SignTx.prototype.setOverwintered = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.SignTx.prototype.clearOverwintered = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasOverwintered = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional uint32 version_group_id = 8;
     * @return {number}
     */
    proto.SignTx.prototype.getVersionGroupId = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, 0));
    };


    /** @param {number} value */
    proto.SignTx.prototype.setVersionGroupId = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.SignTx.prototype.clearVersionGroupId = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignTx.prototype.hasVersionGroupId = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.TxRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.TxRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        requestType: googleProtobuf.Message.getField(msg, 1),
        details: (f = msg.getDetails()) && types_pb.TxRequestDetailsType.toObject(includeInstance, f),
        serialized: (f = msg.getSerialized()) && types_pb.TxRequestSerializedType.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxRequest}
     */
    proto.TxRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxRequest;
      return proto.TxRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxRequest}
     */
    proto.TxRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!proto.RequestType} */ (reader.readEnum());
          msg.setRequestType(value);
          break;
        case 2:
          var value = new types_pb.TxRequestDetailsType;
          reader.readMessage(value,types_pb.TxRequestDetailsType.deserializeBinaryFromReader);
          msg.setDetails(value);
          break;
        case 3:
          var value = new types_pb.TxRequestSerializedType;
          reader.readMessage(value,types_pb.TxRequestSerializedType.deserializeBinaryFromReader);
          msg.setSerialized(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxRequest.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!proto.RequestType} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeEnum(
          1,
          f
        );
      }
      f = message.getDetails();
      if (f != null) {
        writer.writeMessage(
          2,
          f,
          types_pb.TxRequestDetailsType.serializeBinaryToWriter
        );
      }
      f = message.getSerialized();
      if (f != null) {
        writer.writeMessage(
          3,
          f,
          types_pb.TxRequestSerializedType.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional RequestType request_type = 1;
     * @return {!proto.RequestType}
     */
    proto.TxRequest.prototype.getRequestType = function() {
      return /** @type {!proto.RequestType} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {!proto.RequestType} value */
    proto.TxRequest.prototype.setRequestType = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.TxRequest.prototype.clearRequestType = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequest.prototype.hasRequestType = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional TxRequestDetailsType details = 2;
     * @return {?proto.TxRequestDetailsType}
     */
    proto.TxRequest.prototype.getDetails = function() {
      return /** @type{?proto.TxRequestDetailsType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.TxRequestDetailsType, 2));
    };


    /** @param {?proto.TxRequestDetailsType|undefined} value */
    proto.TxRequest.prototype.setDetails = function(value) {
      googleProtobuf.Message.setWrapperField(this, 2, value);
    };


    proto.TxRequest.prototype.clearDetails = function() {
      this.setDetails(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequest.prototype.hasDetails = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional TxRequestSerializedType serialized = 3;
     * @return {?proto.TxRequestSerializedType}
     */
    proto.TxRequest.prototype.getSerialized = function() {
      return /** @type{?proto.TxRequestSerializedType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.TxRequestSerializedType, 3));
    };


    /** @param {?proto.TxRequestSerializedType|undefined} value */
    proto.TxRequest.prototype.setSerialized = function(value) {
      googleProtobuf.Message.setWrapperField(this, 3, value);
    };


    proto.TxRequest.prototype.clearSerialized = function() {
      this.setSerialized(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxRequest.prototype.hasSerialized = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.TxAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.TxAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.TxAck.prototype.toObject = function(opt_includeInstance) {
      return proto.TxAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.TxAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxAck.toObject = function(includeInstance, msg) {
      var f, obj = {
        tx: (f = msg.getTx()) && types_pb.TransactionType.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.TxAck}
     */
    proto.TxAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.TxAck;
      return proto.TxAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.TxAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.TxAck}
     */
    proto.TxAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new types_pb.TransactionType;
          reader.readMessage(value,types_pb.TransactionType.deserializeBinaryFromReader);
          msg.setTx(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.TxAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.TxAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.TxAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.TxAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getTx();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          types_pb.TransactionType.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional TransactionType tx = 1;
     * @return {?proto.TransactionType}
     */
    proto.TxAck.prototype.getTx = function() {
      return /** @type{?proto.TransactionType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.TransactionType, 1));
    };


    /** @param {?proto.TransactionType|undefined} value */
    proto.TxAck.prototype.setTx = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.TxAck.prototype.clearTx = function() {
      this.setTx(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.TxAck.prototype.hasTx = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.RawTxAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.RawTxAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.RawTxAck.prototype.toObject = function(opt_includeInstance) {
      return proto.RawTxAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.RawTxAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.RawTxAck.toObject = function(includeInstance, msg) {
      var f, obj = {
        tx: (f = msg.getTx()) && types_pb.RawTransactionType.toObject(includeInstance, f)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.RawTxAck}
     */
    proto.RawTxAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.RawTxAck;
      return proto.RawTxAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.RawTxAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.RawTxAck}
     */
    proto.RawTxAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new types_pb.RawTransactionType;
          reader.readMessage(value,types_pb.RawTransactionType.deserializeBinaryFromReader);
          msg.setTx(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.RawTxAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.RawTxAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.RawTxAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.RawTxAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getTx();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          types_pb.RawTransactionType.serializeBinaryToWriter
        );
      }
    };


    /**
     * optional RawTransactionType tx = 1;
     * @return {?proto.RawTransactionType}
     */
    proto.RawTxAck.prototype.getTx = function() {
      return /** @type{?proto.RawTransactionType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.RawTransactionType, 1));
    };


    /** @param {?proto.RawTransactionType|undefined} value */
    proto.RawTxAck.prototype.setTx = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.RawTxAck.prototype.clearTx = function() {
      this.setTx(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.RawTxAck.prototype.hasTx = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumSignTx = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.EthereumSignTx.repeatedFields_, null);
    };
    goog.inherits(proto.EthereumSignTx, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.EthereumSignTx.repeatedFields_ = [1,9];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumSignTx.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumSignTx.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumSignTx} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumSignTx.toObject = function(includeInstance, msg) {
      var f, obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        nonce: msg.getNonce_asB64(),
        gasPrice: msg.getGasPrice_asB64(),
        gasLimit: msg.getGasLimit_asB64(),
        to: msg.getTo_asB64(),
        value: msg.getValue_asB64(),
        dataInitialChunk: msg.getDataInitialChunk_asB64(),
        dataLength: googleProtobuf.Message.getField(msg, 8),
        toAddressNList: googleProtobuf.Message.getRepeatedField(msg, 9),
        addressType: googleProtobuf.Message.getField(msg, 10),
        exchangeType: (f = msg.getExchangeType()) && types_pb.ExchangeType.toObject(includeInstance, f),
        chainId: googleProtobuf.Message.getField(msg, 12),
        tokenValue: msg.getTokenValue_asB64(),
        tokenTo: msg.getTokenTo_asB64(),
        tokenShortcut: googleProtobuf.Message.getField(msg, 102),
        txType: googleProtobuf.Message.getField(msg, 103)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumSignTx}
     */
    proto.EthereumSignTx.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumSignTx;
      return proto.EthereumSignTx.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumSignTx} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumSignTx}
     */
    proto.EthereumSignTx.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setNonce(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setGasPrice(value);
          break;
        case 4:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setGasLimit(value);
          break;
        case 5:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setTo(value);
          break;
        case 6:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setValue(value);
          break;
        case 7:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setDataInitialChunk(value);
          break;
        case 8:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDataLength(value);
          break;
        case 9:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addToAddressN(value);
          break;
        case 10:
          var value = /** @type {!proto.OutputAddressType} */ (reader.readEnum());
          msg.setAddressType(value);
          break;
        case 11:
          var value = new types_pb.ExchangeType;
          reader.readMessage(value,types_pb.ExchangeType.deserializeBinaryFromReader);
          msg.setExchangeType(value);
          break;
        case 12:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setChainId(value);
          break;
        case 100:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setTokenValue(value);
          break;
        case 101:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setTokenTo(value);
          break;
        case 102:
          var value = /** @type {string} */ (reader.readString());
          msg.setTokenShortcut(value);
          break;
        case 103:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setTxType(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumSignTx.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumSignTx} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumSignTx.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBytes(
          4,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBytes(
          5,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBytes(
          6,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeBytes(
          7,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeUint32(
          8,
          f
        );
      }
      f = message.getToAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          9,
          f
        );
      }
      f = /** @type {!proto.OutputAddressType} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeEnum(
          10,
          f
        );
      }
      f = message.getExchangeType();
      if (f != null) {
        writer.writeMessage(
          11,
          f,
          types_pb.ExchangeType.serializeBinaryToWriter
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 12));
      if (f != null) {
        writer.writeUint32(
          12,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 100));
      if (f != null) {
        writer.writeBytes(
          100,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 101));
      if (f != null) {
        writer.writeBytes(
          101,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 102));
      if (f != null) {
        writer.writeString(
          102,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 103));
      if (f != null) {
        writer.writeUint32(
          103,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.EthereumSignTx.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.EthereumSignTx.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.EthereumSignTx.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.EthereumSignTx.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * optional bytes nonce = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getNonce = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes nonce = 2;
     * This is a type-conversion wrapper around `getNonce()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getNonce_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getNonce()));
    };


    /**
     * optional bytes nonce = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getNonce()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getNonce_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getNonce()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setNonce = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumSignTx.prototype.clearNonce = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasNonce = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes gas_price = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getGasPrice = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes gas_price = 3;
     * This is a type-conversion wrapper around `getGasPrice()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getGasPrice_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getGasPrice()));
    };


    /**
     * optional bytes gas_price = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getGasPrice()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getGasPrice_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getGasPrice()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setGasPrice = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.EthereumSignTx.prototype.clearGasPrice = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasGasPrice = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bytes gas_limit = 4;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getGasLimit = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /**
     * optional bytes gas_limit = 4;
     * This is a type-conversion wrapper around `getGasLimit()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getGasLimit_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getGasLimit()));
    };


    /**
     * optional bytes gas_limit = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getGasLimit()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getGasLimit_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getGasLimit()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setGasLimit = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.EthereumSignTx.prototype.clearGasLimit = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasGasLimit = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional bytes to = 5;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getTo = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, ""));
    };


    /**
     * optional bytes to = 5;
     * This is a type-conversion wrapper around `getTo()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getTo_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getTo()));
    };


    /**
     * optional bytes to = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTo()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getTo_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getTo()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setTo = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.EthereumSignTx.prototype.clearTo = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasTo = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bytes value = 6;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getValue = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /**
     * optional bytes value = 6;
     * This is a type-conversion wrapper around `getValue()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getValue_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getValue()));
    };


    /**
     * optional bytes value = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getValue()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getValue_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getValue()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setValue = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.EthereumSignTx.prototype.clearValue = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasValue = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional bytes data_initial_chunk = 7;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getDataInitialChunk = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, ""));
    };


    /**
     * optional bytes data_initial_chunk = 7;
     * This is a type-conversion wrapper around `getDataInitialChunk()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getDataInitialChunk_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getDataInitialChunk()));
    };


    /**
     * optional bytes data_initial_chunk = 7;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getDataInitialChunk()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getDataInitialChunk_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getDataInitialChunk()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setDataInitialChunk = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.EthereumSignTx.prototype.clearDataInitialChunk = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasDataInitialChunk = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional uint32 data_length = 8;
     * @return {number}
     */
    proto.EthereumSignTx.prototype.getDataLength = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, 0));
    };


    /** @param {number} value */
    proto.EthereumSignTx.prototype.setDataLength = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.EthereumSignTx.prototype.clearDataLength = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasDataLength = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * repeated uint32 to_address_n = 9;
     * @return {!Array.<number>}
     */
    proto.EthereumSignTx.prototype.getToAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 9));
    };


    /** @param {!Array.<number>} value */
    proto.EthereumSignTx.prototype.setToAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 9, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.EthereumSignTx.prototype.addToAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 9, value, opt_index);
    };


    proto.EthereumSignTx.prototype.clearToAddressNList = function() {
      this.setToAddressNList([]);
    };


    /**
     * optional OutputAddressType address_type = 10;
     * @return {!proto.OutputAddressType}
     */
    proto.EthereumSignTx.prototype.getAddressType = function() {
      return /** @type {!proto.OutputAddressType} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, 0));
    };


    /** @param {!proto.OutputAddressType} value */
    proto.EthereumSignTx.prototype.setAddressType = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.EthereumSignTx.prototype.clearAddressType = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasAddressType = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * optional ExchangeType exchange_type = 11;
     * @return {?proto.ExchangeType}
     */
    proto.EthereumSignTx.prototype.getExchangeType = function() {
      return /** @type{?proto.ExchangeType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.ExchangeType, 11));
    };


    /** @param {?proto.ExchangeType|undefined} value */
    proto.EthereumSignTx.prototype.setExchangeType = function(value) {
      googleProtobuf.Message.setWrapperField(this, 11, value);
    };


    proto.EthereumSignTx.prototype.clearExchangeType = function() {
      this.setExchangeType(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasExchangeType = function() {
      return googleProtobuf.Message.getField(this, 11) != null;
    };


    /**
     * optional uint32 chain_id = 12;
     * @return {number}
     */
    proto.EthereumSignTx.prototype.getChainId = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 12, 0));
    };


    /** @param {number} value */
    proto.EthereumSignTx.prototype.setChainId = function(value) {
      googleProtobuf.Message.setField(this, 12, value);
    };


    proto.EthereumSignTx.prototype.clearChainId = function() {
      googleProtobuf.Message.setField(this, 12, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasChainId = function() {
      return googleProtobuf.Message.getField(this, 12) != null;
    };


    /**
     * optional bytes token_value = 100;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getTokenValue = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 100, ""));
    };


    /**
     * optional bytes token_value = 100;
     * This is a type-conversion wrapper around `getTokenValue()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getTokenValue_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getTokenValue()));
    };


    /**
     * optional bytes token_value = 100;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTokenValue()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getTokenValue_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getTokenValue()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setTokenValue = function(value) {
      googleProtobuf.Message.setField(this, 100, value);
    };


    proto.EthereumSignTx.prototype.clearTokenValue = function() {
      googleProtobuf.Message.setField(this, 100, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasTokenValue = function() {
      return googleProtobuf.Message.getField(this, 100) != null;
    };


    /**
     * optional bytes token_to = 101;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignTx.prototype.getTokenTo = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 101, ""));
    };


    /**
     * optional bytes token_to = 101;
     * This is a type-conversion wrapper around `getTokenTo()`
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getTokenTo_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getTokenTo()));
    };


    /**
     * optional bytes token_to = 101;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getTokenTo()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignTx.prototype.getTokenTo_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getTokenTo()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignTx.prototype.setTokenTo = function(value) {
      googleProtobuf.Message.setField(this, 101, value);
    };


    proto.EthereumSignTx.prototype.clearTokenTo = function() {
      googleProtobuf.Message.setField(this, 101, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasTokenTo = function() {
      return googleProtobuf.Message.getField(this, 101) != null;
    };


    /**
     * optional string token_shortcut = 102;
     * @return {string}
     */
    proto.EthereumSignTx.prototype.getTokenShortcut = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 102, ""));
    };


    /** @param {string} value */
    proto.EthereumSignTx.prototype.setTokenShortcut = function(value) {
      googleProtobuf.Message.setField(this, 102, value);
    };


    proto.EthereumSignTx.prototype.clearTokenShortcut = function() {
      googleProtobuf.Message.setField(this, 102, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasTokenShortcut = function() {
      return googleProtobuf.Message.getField(this, 102) != null;
    };


    /**
     * optional uint32 tx_type = 103;
     * @return {number}
     */
    proto.EthereumSignTx.prototype.getTxType = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 103, 0));
    };


    /** @param {number} value */
    proto.EthereumSignTx.prototype.setTxType = function(value) {
      googleProtobuf.Message.setField(this, 103, value);
    };


    proto.EthereumSignTx.prototype.clearTxType = function() {
      googleProtobuf.Message.setField(this, 103, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignTx.prototype.hasTxType = function() {
      return googleProtobuf.Message.getField(this, 103) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumTxRequest = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EthereumTxRequest, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumTxRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumTxRequest.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumTxRequest} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumTxRequest.toObject = function(includeInstance, msg) {
      var obj = {
        dataLength: googleProtobuf.Message.getField(msg, 1),
        signatureV: googleProtobuf.Message.getField(msg, 2),
        signatureR: msg.getSignatureR_asB64(),
        signatureS: msg.getSignatureS_asB64(),
        hash: msg.getHash_asB64(),
        signatureDer: msg.getSignatureDer_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumTxRequest}
     */
    proto.EthereumTxRequest.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumTxRequest;
      return proto.EthereumTxRequest.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumTxRequest} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumTxRequest}
     */
    proto.EthereumTxRequest.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setDataLength(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setSignatureV(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignatureR(value);
          break;
        case 4:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignatureS(value);
          break;
        case 5:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setHash(value);
          break;
        case 6:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignatureDer(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumTxRequest.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumTxRequest.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumTxRequest} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumTxRequest.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeBytes(
          4,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 5));
      if (f != null) {
        writer.writeBytes(
          5,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBytes(
          6,
          f
        );
      }
    };


    /**
     * optional uint32 data_length = 1;
     * @return {number}
     */
    proto.EthereumTxRequest.prototype.getDataLength = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.EthereumTxRequest.prototype.setDataLength = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EthereumTxRequest.prototype.clearDataLength = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxRequest.prototype.hasDataLength = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint32 signature_v = 2;
     * @return {number}
     */
    proto.EthereumTxRequest.prototype.getSignatureV = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.EthereumTxRequest.prototype.setSignatureV = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumTxRequest.prototype.clearSignatureV = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxRequest.prototype.hasSignatureV = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes signature_r = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumTxRequest.prototype.getSignatureR = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes signature_r = 3;
     * This is a type-conversion wrapper around `getSignatureR()`
     * @return {string}
     */
    proto.EthereumTxRequest.prototype.getSignatureR_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignatureR()));
    };


    /**
     * optional bytes signature_r = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignatureR()`
     * @return {!Uint8Array}
     */
    proto.EthereumTxRequest.prototype.getSignatureR_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignatureR()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumTxRequest.prototype.setSignatureR = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.EthereumTxRequest.prototype.clearSignatureR = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxRequest.prototype.hasSignatureR = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional bytes signature_s = 4;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumTxRequest.prototype.getSignatureS = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /**
     * optional bytes signature_s = 4;
     * This is a type-conversion wrapper around `getSignatureS()`
     * @return {string}
     */
    proto.EthereumTxRequest.prototype.getSignatureS_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignatureS()));
    };


    /**
     * optional bytes signature_s = 4;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignatureS()`
     * @return {!Uint8Array}
     */
    proto.EthereumTxRequest.prototype.getSignatureS_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignatureS()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumTxRequest.prototype.setSignatureS = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.EthereumTxRequest.prototype.clearSignatureS = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxRequest.prototype.hasSignatureS = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional bytes hash = 5;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumTxRequest.prototype.getHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 5, ""));
    };


    /**
     * optional bytes hash = 5;
     * This is a type-conversion wrapper around `getHash()`
     * @return {string}
     */
    proto.EthereumTxRequest.prototype.getHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getHash()));
    };


    /**
     * optional bytes hash = 5;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getHash()`
     * @return {!Uint8Array}
     */
    proto.EthereumTxRequest.prototype.getHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumTxRequest.prototype.setHash = function(value) {
      googleProtobuf.Message.setField(this, 5, value);
    };


    proto.EthereumTxRequest.prototype.clearHash = function() {
      googleProtobuf.Message.setField(this, 5, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxRequest.prototype.hasHash = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bytes signature_der = 6;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumTxRequest.prototype.getSignatureDer = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, ""));
    };


    /**
     * optional bytes signature_der = 6;
     * This is a type-conversion wrapper around `getSignatureDer()`
     * @return {string}
     */
    proto.EthereumTxRequest.prototype.getSignatureDer_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignatureDer()));
    };


    /**
     * optional bytes signature_der = 6;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignatureDer()`
     * @return {!Uint8Array}
     */
    proto.EthereumTxRequest.prototype.getSignatureDer_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignatureDer()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumTxRequest.prototype.setSignatureDer = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.EthereumTxRequest.prototype.clearSignatureDer = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxRequest.prototype.hasSignatureDer = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumTxAck = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EthereumTxAck, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumTxAck.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumTxAck.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumTxAck} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumTxAck.toObject = function(includeInstance, msg) {
      var obj = {
        dataChunk: msg.getDataChunk_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumTxAck}
     */
    proto.EthereumTxAck.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumTxAck;
      return proto.EthereumTxAck.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumTxAck} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumTxAck}
     */
    proto.EthereumTxAck.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setDataChunk(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumTxAck.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumTxAck.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumTxAck} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumTxAck.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * optional bytes data_chunk = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumTxAck.prototype.getDataChunk = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes data_chunk = 1;
     * This is a type-conversion wrapper around `getDataChunk()`
     * @return {string}
     */
    proto.EthereumTxAck.prototype.getDataChunk_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getDataChunk()));
    };


    /**
     * optional bytes data_chunk = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getDataChunk()`
     * @return {!Uint8Array}
     */
    proto.EthereumTxAck.prototype.getDataChunk_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getDataChunk()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumTxAck.prototype.setDataChunk = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EthereumTxAck.prototype.clearDataChunk = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumTxAck.prototype.hasDataChunk = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumSignMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.EthereumSignMessage.repeatedFields_, null);
    };
    goog.inherits(proto.EthereumSignMessage, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.EthereumSignMessage.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumSignMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumSignMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumSignMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumSignMessage.toObject = function(includeInstance, msg) {
      var obj = {
        addressNList: googleProtobuf.Message.getRepeatedField(msg, 1),
        message: msg.getMessage_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumSignMessage}
     */
    proto.EthereumSignMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumSignMessage;
      return proto.EthereumSignMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumSignMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumSignMessage}
     */
    proto.EthereumSignMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.addAddressN(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumSignMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumSignMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumSignMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumSignMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getAddressNList();
      if (f.length > 0) {
        writer.writeRepeatedUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
    };


    /**
     * repeated uint32 address_n = 1;
     * @return {!Array.<number>}
     */
    proto.EthereumSignMessage.prototype.getAddressNList = function() {
      return /** @type {!Array.<number>} */ (googleProtobuf.Message.getRepeatedField(this, 1));
    };


    /** @param {!Array.<number>} value */
    proto.EthereumSignMessage.prototype.setAddressNList = function(value) {
      googleProtobuf.Message.setField(this, 1, value || []);
    };


    /**
     * @param {!number} value
     * @param {number=} opt_index
     */
    proto.EthereumSignMessage.prototype.addAddressN = function(value, opt_index) {
      googleProtobuf.Message.addToRepeatedField(this, 1, value, opt_index);
    };


    proto.EthereumSignMessage.prototype.clearAddressNList = function() {
      this.setAddressNList([]);
    };


    /**
     * required bytes message = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumSignMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * required bytes message = 2;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.EthereumSignMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * required bytes message = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.EthereumSignMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumSignMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumSignMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumSignMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumVerifyMessage = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EthereumVerifyMessage, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumVerifyMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumVerifyMessage.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumVerifyMessage} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumVerifyMessage.toObject = function(includeInstance, msg) {
      var obj = {
        address: msg.getAddress_asB64(),
        signature: msg.getSignature_asB64(),
        message: msg.getMessage_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumVerifyMessage}
     */
    proto.EthereumVerifyMessage.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumVerifyMessage;
      return proto.EthereumVerifyMessage.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumVerifyMessage} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumVerifyMessage}
     */
    proto.EthereumVerifyMessage.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumVerifyMessage.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumVerifyMessage.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumVerifyMessage} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumVerifyMessage.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
    };


    /**
     * optional bytes address = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumVerifyMessage.prototype.getAddress = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes address = 1;
     * This is a type-conversion wrapper around `getAddress()`
     * @return {string}
     */
    proto.EthereumVerifyMessage.prototype.getAddress_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getAddress()));
    };


    /**
     * optional bytes address = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAddress()`
     * @return {!Uint8Array}
     */
    proto.EthereumVerifyMessage.prototype.getAddress_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getAddress()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumVerifyMessage.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EthereumVerifyMessage.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumVerifyMessage.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes signature = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumVerifyMessage.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes signature = 2;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.EthereumVerifyMessage.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.EthereumVerifyMessage.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumVerifyMessage.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumVerifyMessage.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumVerifyMessage.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes message = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumVerifyMessage.prototype.getMessage = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes message = 3;
     * This is a type-conversion wrapper around `getMessage()`
     * @return {string}
     */
    proto.EthereumVerifyMessage.prototype.getMessage_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getMessage()));
    };


    /**
     * optional bytes message = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getMessage()`
     * @return {!Uint8Array}
     */
    proto.EthereumVerifyMessage.prototype.getMessage_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getMessage()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumVerifyMessage.prototype.setMessage = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.EthereumVerifyMessage.prototype.clearMessage = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumVerifyMessage.prototype.hasMessage = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.EthereumMessageSignature = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.EthereumMessageSignature, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.EthereumMessageSignature.prototype.toObject = function(opt_includeInstance) {
      return proto.EthereumMessageSignature.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.EthereumMessageSignature} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumMessageSignature.toObject = function(includeInstance, msg) {
      var obj = {
        address: msg.getAddress_asB64(),
        signature: msg.getSignature_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.EthereumMessageSignature}
     */
    proto.EthereumMessageSignature.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.EthereumMessageSignature;
      return proto.EthereumMessageSignature.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.EthereumMessageSignature} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.EthereumMessageSignature}
     */
    proto.EthereumMessageSignature.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.EthereumMessageSignature.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.EthereumMessageSignature.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.EthereumMessageSignature} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.EthereumMessageSignature.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
    };


    /**
     * optional bytes address = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumMessageSignature.prototype.getAddress = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes address = 1;
     * This is a type-conversion wrapper around `getAddress()`
     * @return {string}
     */
    proto.EthereumMessageSignature.prototype.getAddress_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getAddress()));
    };


    /**
     * optional bytes address = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getAddress()`
     * @return {!Uint8Array}
     */
    proto.EthereumMessageSignature.prototype.getAddress_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getAddress()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumMessageSignature.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.EthereumMessageSignature.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumMessageSignature.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes signature = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.EthereumMessageSignature.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes signature = 2;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.EthereumMessageSignature.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.EthereumMessageSignature.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.EthereumMessageSignature.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.EthereumMessageSignature.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.EthereumMessageSignature.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.SignIdentity = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.SignIdentity, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.SignIdentity.prototype.toObject = function(opt_includeInstance) {
      return proto.SignIdentity.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.SignIdentity} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignIdentity.toObject = function(includeInstance, msg) {
      var f, obj = {
        identity: (f = msg.getIdentity()) && types_pb.IdentityType.toObject(includeInstance, f),
        challengeHidden: msg.getChallengeHidden_asB64(),
        challengeVisual: googleProtobuf.Message.getField(msg, 3),
        ecdsaCurveName: googleProtobuf.Message.getField(msg, 4)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.SignIdentity}
     */
    proto.SignIdentity.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.SignIdentity;
      return proto.SignIdentity.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.SignIdentity} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.SignIdentity}
     */
    proto.SignIdentity.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new types_pb.IdentityType;
          reader.readMessage(value,types_pb.IdentityType.deserializeBinaryFromReader);
          msg.setIdentity(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setChallengeHidden(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setChallengeVisual(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setEcdsaCurveName(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.SignIdentity.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.SignIdentity.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.SignIdentity} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignIdentity.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getIdentity();
      if (f != null) {
        writer.writeMessage(
          1,
          f,
          types_pb.IdentityType.serializeBinaryToWriter
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
    };


    /**
     * optional IdentityType identity = 1;
     * @return {?proto.IdentityType}
     */
    proto.SignIdentity.prototype.getIdentity = function() {
      return /** @type{?proto.IdentityType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.IdentityType, 1));
    };


    /** @param {?proto.IdentityType|undefined} value */
    proto.SignIdentity.prototype.setIdentity = function(value) {
      googleProtobuf.Message.setWrapperField(this, 1, value);
    };


    proto.SignIdentity.prototype.clearIdentity = function() {
      this.setIdentity(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignIdentity.prototype.hasIdentity = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes challenge_hidden = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.SignIdentity.prototype.getChallengeHidden = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes challenge_hidden = 2;
     * This is a type-conversion wrapper around `getChallengeHidden()`
     * @return {string}
     */
    proto.SignIdentity.prototype.getChallengeHidden_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getChallengeHidden()));
    };


    /**
     * optional bytes challenge_hidden = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChallengeHidden()`
     * @return {!Uint8Array}
     */
    proto.SignIdentity.prototype.getChallengeHidden_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getChallengeHidden()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.SignIdentity.prototype.setChallengeHidden = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.SignIdentity.prototype.clearChallengeHidden = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignIdentity.prototype.hasChallengeHidden = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string challenge_visual = 3;
     * @return {string}
     */
    proto.SignIdentity.prototype.getChallengeVisual = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.SignIdentity.prototype.setChallengeVisual = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.SignIdentity.prototype.clearChallengeVisual = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignIdentity.prototype.hasChallengeVisual = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string ecdsa_curve_name = 4;
     * @return {string}
     */
    proto.SignIdentity.prototype.getEcdsaCurveName = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /** @param {string} value */
    proto.SignIdentity.prototype.setEcdsaCurveName = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.SignIdentity.prototype.clearEcdsaCurveName = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignIdentity.prototype.hasEcdsaCurveName = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.SignedIdentity = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.SignedIdentity, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.SignedIdentity.prototype.toObject = function(opt_includeInstance) {
      return proto.SignedIdentity.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.SignedIdentity} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignedIdentity.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        publicKey: msg.getPublicKey_asB64(),
        signature: msg.getSignature_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.SignedIdentity}
     */
    proto.SignedIdentity.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.SignedIdentity;
      return proto.SignedIdentity.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.SignedIdentity} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.SignedIdentity}
     */
    proto.SignedIdentity.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPublicKey(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setSignature(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.SignedIdentity.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.SignedIdentity.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.SignedIdentity} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SignedIdentity.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeString(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
    };


    /**
     * optional string address = 1;
     * @return {string}
     */
    proto.SignedIdentity.prototype.getAddress = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /** @param {string} value */
    proto.SignedIdentity.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.SignedIdentity.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignedIdentity.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes public_key = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.SignedIdentity.prototype.getPublicKey = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes public_key = 2;
     * This is a type-conversion wrapper around `getPublicKey()`
     * @return {string}
     */
    proto.SignedIdentity.prototype.getPublicKey_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPublicKey()));
    };


    /**
     * optional bytes public_key = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPublicKey()`
     * @return {!Uint8Array}
     */
    proto.SignedIdentity.prototype.getPublicKey_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPublicKey()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.SignedIdentity.prototype.setPublicKey = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.SignedIdentity.prototype.clearPublicKey = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignedIdentity.prototype.hasPublicKey = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes signature = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.SignedIdentity.prototype.getSignature = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes signature = 3;
     * This is a type-conversion wrapper around `getSignature()`
     * @return {string}
     */
    proto.SignedIdentity.prototype.getSignature_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getSignature()));
    };


    /**
     * optional bytes signature = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getSignature()`
     * @return {!Uint8Array}
     */
    proto.SignedIdentity.prototype.getSignature_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getSignature()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.SignedIdentity.prototype.setSignature = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.SignedIdentity.prototype.clearSignature = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.SignedIdentity.prototype.hasSignature = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.ApplyPolicies = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, proto.ApplyPolicies.repeatedFields_, null);
    };
    goog.inherits(proto.ApplyPolicies, googleProtobuf.Message);
    /**
     * List of repeated fields within this message type.
     * @private {!Array<number>}
     * @const
     */
    proto.ApplyPolicies.repeatedFields_ = [1];



    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.ApplyPolicies.prototype.toObject = function(opt_includeInstance) {
      return proto.ApplyPolicies.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.ApplyPolicies} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ApplyPolicies.toObject = function(includeInstance, msg) {
      var obj = {
        policyList: googleProtobuf.Message.toObjectList(msg.getPolicyList(),
        types_pb.PolicyType.toObject, includeInstance)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.ApplyPolicies}
     */
    proto.ApplyPolicies.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.ApplyPolicies;
      return proto.ApplyPolicies.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.ApplyPolicies} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.ApplyPolicies}
     */
    proto.ApplyPolicies.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = new types_pb.PolicyType;
          reader.readMessage(value,types_pb.PolicyType.deserializeBinaryFromReader);
          msg.addPolicy(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.ApplyPolicies.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.ApplyPolicies.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.ApplyPolicies} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.ApplyPolicies.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = message.getPolicyList();
      if (f.length > 0) {
        writer.writeRepeatedMessage(
          1,
          f,
          types_pb.PolicyType.serializeBinaryToWriter
        );
      }
    };


    /**
     * repeated PolicyType policy = 1;
     * @return {!Array.<!proto.PolicyType>}
     */
    proto.ApplyPolicies.prototype.getPolicyList = function() {
      return /** @type{!Array.<!proto.PolicyType>} */ (
        googleProtobuf.Message.getRepeatedWrapperField(this, types_pb.PolicyType, 1));
    };


    /** @param {!Array.<!proto.PolicyType>} value */
    proto.ApplyPolicies.prototype.setPolicyList = function(value) {
      googleProtobuf.Message.setRepeatedWrapperField(this, 1, value);
    };


    /**
     * @param {!proto.PolicyType=} opt_value
     * @param {number=} opt_index
     * @return {!proto.PolicyType}
     */
    proto.ApplyPolicies.prototype.addPolicy = function(opt_value, opt_index) {
      return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PolicyType, opt_index);
    };


    proto.ApplyPolicies.prototype.clearPolicyList = function() {
      this.setPolicyList([]);
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.FlashHash = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.FlashHash, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.FlashHash.prototype.toObject = function(opt_includeInstance) {
      return proto.FlashHash.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.FlashHash} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FlashHash.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        length: googleProtobuf.Message.getField(msg, 2),
        challenge: msg.getChallenge_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.FlashHash}
     */
    proto.FlashHash.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.FlashHash;
      return proto.FlashHash.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.FlashHash} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.FlashHash}
     */
    proto.FlashHash.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setLength(value);
          break;
        case 3:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setChallenge(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.FlashHash.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.FlashHash.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.FlashHash} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FlashHash.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBytes(
          3,
          f
        );
      }
    };


    /**
     * optional uint32 address = 1;
     * @return {number}
     */
    proto.FlashHash.prototype.getAddress = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.FlashHash.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.FlashHash.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashHash.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint32 length = 2;
     * @return {number}
     */
    proto.FlashHash.prototype.getLength = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.FlashHash.prototype.setLength = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.FlashHash.prototype.clearLength = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashHash.prototype.hasLength = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bytes challenge = 3;
     * @return {!(string|Uint8Array)}
     */
    proto.FlashHash.prototype.getChallenge = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /**
     * optional bytes challenge = 3;
     * This is a type-conversion wrapper around `getChallenge()`
     * @return {string}
     */
    proto.FlashHash.prototype.getChallenge_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getChallenge()));
    };


    /**
     * optional bytes challenge = 3;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getChallenge()`
     * @return {!Uint8Array}
     */
    proto.FlashHash.prototype.getChallenge_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getChallenge()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.FlashHash.prototype.setChallenge = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.FlashHash.prototype.clearChallenge = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashHash.prototype.hasChallenge = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.FlashWrite = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.FlashWrite, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.FlashWrite.prototype.toObject = function(opt_includeInstance) {
      return proto.FlashWrite.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.FlashWrite} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FlashWrite.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        data: msg.getData_asB64(),
        erase: googleProtobuf.Message.getField(msg, 3)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.FlashWrite}
     */
    proto.FlashWrite.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.FlashWrite;
      return proto.FlashWrite.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.FlashWrite} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.FlashWrite}
     */
    proto.FlashWrite.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setData(value);
          break;
        case 3:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setErase(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.FlashWrite.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.FlashWrite.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.FlashWrite} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FlashWrite.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeBool(
          3,
          f
        );
      }
    };


    /**
     * optional uint32 address = 1;
     * @return {number}
     */
    proto.FlashWrite.prototype.getAddress = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.FlashWrite.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.FlashWrite.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashWrite.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional bytes data = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.FlashWrite.prototype.getData = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * optional bytes data = 2;
     * This is a type-conversion wrapper around `getData()`
     * @return {string}
     */
    proto.FlashWrite.prototype.getData_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getData()));
    };


    /**
     * optional bytes data = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getData()`
     * @return {!Uint8Array}
     */
    proto.FlashWrite.prototype.getData_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getData()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.FlashWrite.prototype.setData = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.FlashWrite.prototype.clearData = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashWrite.prototype.hasData = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional bool erase = 3;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.FlashWrite.prototype.getErase = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, false));
    };


    /** @param {boolean} value */
    proto.FlashWrite.prototype.setErase = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.FlashWrite.prototype.clearErase = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashWrite.prototype.hasErase = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.FlashHashResponse = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.FlashHashResponse, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.FlashHashResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.FlashHashResponse.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.FlashHashResponse} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FlashHashResponse.toObject = function(includeInstance, msg) {
      var obj = {
        data: msg.getData_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.FlashHashResponse}
     */
    proto.FlashHashResponse.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.FlashHashResponse;
      return proto.FlashHashResponse.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.FlashHashResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.FlashHashResponse}
     */
    proto.FlashHashResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setData(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.FlashHashResponse.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.FlashHashResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.FlashHashResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FlashHashResponse.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * optional bytes data = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.FlashHashResponse.prototype.getData = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes data = 1;
     * This is a type-conversion wrapper around `getData()`
     * @return {string}
     */
    proto.FlashHashResponse.prototype.getData_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getData()));
    };


    /**
     * optional bytes data = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getData()`
     * @return {!Uint8Array}
     */
    proto.FlashHashResponse.prototype.getData_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getData()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.FlashHashResponse.prototype.setData = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.FlashHashResponse.prototype.clearData = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FlashHashResponse.prototype.hasData = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkFlashDump = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkFlashDump, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkFlashDump.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkFlashDump.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkFlashDump} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkFlashDump.toObject = function(includeInstance, msg) {
      var obj = {
        address: googleProtobuf.Message.getField(msg, 1),
        length: googleProtobuf.Message.getField(msg, 2)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkFlashDump}
     */
    proto.DebugLinkFlashDump.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkFlashDump;
      return proto.DebugLinkFlashDump.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkFlashDump} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkFlashDump}
     */
    proto.DebugLinkFlashDump.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setAddress(value);
          break;
        case 2:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setLength(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkFlashDump.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkFlashDump.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkFlashDump} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkFlashDump.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeUint32(
          2,
          f
        );
      }
    };


    /**
     * optional uint32 address = 1;
     * @return {number}
     */
    proto.DebugLinkFlashDump.prototype.getAddress = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.DebugLinkFlashDump.prototype.setAddress = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.DebugLinkFlashDump.prototype.clearAddress = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkFlashDump.prototype.hasAddress = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional uint32 length = 2;
     * @return {number}
     */
    proto.DebugLinkFlashDump.prototype.getLength = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, 0));
    };


    /** @param {number} value */
    proto.DebugLinkFlashDump.prototype.setLength = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.DebugLinkFlashDump.prototype.clearLength = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkFlashDump.prototype.hasLength = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkFlashDumpResponse = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkFlashDumpResponse, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkFlashDumpResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkFlashDumpResponse.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkFlashDumpResponse} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkFlashDumpResponse.toObject = function(includeInstance, msg) {
      var obj = {
        data: msg.getData_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkFlashDumpResponse}
     */
    proto.DebugLinkFlashDumpResponse.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkFlashDumpResponse;
      return proto.DebugLinkFlashDumpResponse.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkFlashDumpResponse} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkFlashDumpResponse}
     */
    proto.DebugLinkFlashDumpResponse.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setData(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkFlashDumpResponse.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkFlashDumpResponse.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkFlashDumpResponse} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkFlashDumpResponse.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
    };


    /**
     * optional bytes data = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.DebugLinkFlashDumpResponse.prototype.getData = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes data = 1;
     * This is a type-conversion wrapper around `getData()`
     * @return {string}
     */
    proto.DebugLinkFlashDumpResponse.prototype.getData_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getData()));
    };


    /**
     * optional bytes data = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getData()`
     * @return {!Uint8Array}
     */
    proto.DebugLinkFlashDumpResponse.prototype.getData_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getData()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DebugLinkFlashDumpResponse.prototype.setData = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.DebugLinkFlashDumpResponse.prototype.clearData = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkFlashDumpResponse.prototype.hasData = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.SoftReset = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.SoftReset, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.SoftReset.prototype.toObject = function(opt_includeInstance) {
      return proto.SoftReset.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.SoftReset} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SoftReset.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.SoftReset}
     */
    proto.SoftReset.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.SoftReset;
      return proto.SoftReset.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.SoftReset} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.SoftReset}
     */
    proto.SoftReset.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.SoftReset.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.SoftReset.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.SoftReset} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.SoftReset.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.FirmwareErase = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.FirmwareErase, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.FirmwareErase.prototype.toObject = function(opt_includeInstance) {
      return proto.FirmwareErase.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.FirmwareErase} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FirmwareErase.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.FirmwareErase}
     */
    proto.FirmwareErase.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.FirmwareErase;
      return proto.FirmwareErase.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.FirmwareErase} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.FirmwareErase}
     */
    proto.FirmwareErase.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.FirmwareErase.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.FirmwareErase.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.FirmwareErase} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FirmwareErase.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.FirmwareUpload = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.FirmwareUpload, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.FirmwareUpload.prototype.toObject = function(opt_includeInstance) {
      return proto.FirmwareUpload.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.FirmwareUpload} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FirmwareUpload.toObject = function(includeInstance, msg) {
      var obj = {
        payloadHash: msg.getPayloadHash_asB64(),
        payload: msg.getPayload_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.FirmwareUpload}
     */
    proto.FirmwareUpload.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.FirmwareUpload;
      return proto.FirmwareUpload.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.FirmwareUpload} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.FirmwareUpload}
     */
    proto.FirmwareUpload.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPayloadHash(value);
          break;
        case 2:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.FirmwareUpload.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.FirmwareUpload.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.FirmwareUpload} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.FirmwareUpload.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeBytes(
          2,
          f
        );
      }
    };


    /**
     * required bytes payload_hash = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.FirmwareUpload.prototype.getPayloadHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * required bytes payload_hash = 1;
     * This is a type-conversion wrapper around `getPayloadHash()`
     * @return {string}
     */
    proto.FirmwareUpload.prototype.getPayloadHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPayloadHash()));
    };


    /**
     * required bytes payload_hash = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPayloadHash()`
     * @return {!Uint8Array}
     */
    proto.FirmwareUpload.prototype.getPayloadHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPayloadHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.FirmwareUpload.prototype.setPayloadHash = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.FirmwareUpload.prototype.clearPayloadHash = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FirmwareUpload.prototype.hasPayloadHash = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * required bytes payload = 2;
     * @return {!(string|Uint8Array)}
     */
    proto.FirmwareUpload.prototype.getPayload = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /**
     * required bytes payload = 2;
     * This is a type-conversion wrapper around `getPayload()`
     * @return {string}
     */
    proto.FirmwareUpload.prototype.getPayload_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getPayload()));
    };


    /**
     * required bytes payload = 2;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getPayload()`
     * @return {!Uint8Array}
     */
    proto.FirmwareUpload.prototype.getPayload_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getPayload()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.FirmwareUpload.prototype.setPayload = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.FirmwareUpload.prototype.clearPayload = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.FirmwareUpload.prototype.hasPayload = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkDecision = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkDecision, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkDecision.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkDecision.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkDecision} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkDecision.toObject = function(includeInstance, msg) {
      var obj = {
        yesNo: googleProtobuf.Message.getField(msg, 1)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkDecision}
     */
    proto.DebugLinkDecision.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkDecision;
      return proto.DebugLinkDecision.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkDecision} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkDecision}
     */
    proto.DebugLinkDecision.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setYesNo(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkDecision.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkDecision.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkDecision} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkDecision.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBool(
          1,
          f
        );
      }
    };


    /**
     * required bool yes_no = 1;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.DebugLinkDecision.prototype.getYesNo = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, false));
    };


    /** @param {boolean} value */
    proto.DebugLinkDecision.prototype.setYesNo = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.DebugLinkDecision.prototype.clearYesNo = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkDecision.prototype.hasYesNo = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkGetState = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkGetState, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkGetState.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkGetState.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkGetState} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkGetState.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkGetState}
     */
    proto.DebugLinkGetState.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkGetState;
      return proto.DebugLinkGetState.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkGetState} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkGetState}
     */
    proto.DebugLinkGetState.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkGetState.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkGetState.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkGetState} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkGetState.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkState = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkState, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkState.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkState.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkState} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkState.toObject = function(includeInstance, msg) {
      var f, obj = {
        layout: msg.getLayout_asB64(),
        pin: googleProtobuf.Message.getField(msg, 2),
        matrix: googleProtobuf.Message.getField(msg, 3),
        mnemonic: googleProtobuf.Message.getField(msg, 4),
        node: (f = msg.getNode()) && types_pb.HDNodeType.toObject(includeInstance, f),
        passphraseProtection: googleProtobuf.Message.getField(msg, 6),
        resetWord: googleProtobuf.Message.getField(msg, 7),
        resetEntropy: msg.getResetEntropy_asB64(),
        recoveryFakeWord: googleProtobuf.Message.getField(msg, 9),
        recoveryWordPos: googleProtobuf.Message.getField(msg, 10),
        recoveryCipher: googleProtobuf.Message.getField(msg, 11),
        recoveryAutoCompletedWord: googleProtobuf.Message.getField(msg, 12),
        firmwareHash: msg.getFirmwareHash_asB64(),
        storageHash: msg.getStorageHash_asB64()
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkState}
     */
    proto.DebugLinkState.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkState;
      return proto.DebugLinkState.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkState} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkState}
     */
    proto.DebugLinkState.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setLayout(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setPin(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setMatrix(value);
          break;
        case 4:
          var value = /** @type {string} */ (reader.readString());
          msg.setMnemonic(value);
          break;
        case 5:
          var value = new types_pb.HDNodeType;
          reader.readMessage(value,types_pb.HDNodeType.deserializeBinaryFromReader);
          msg.setNode(value);
          break;
        case 6:
          var value = /** @type {boolean} */ (reader.readBool());
          msg.setPassphraseProtection(value);
          break;
        case 7:
          var value = /** @type {string} */ (reader.readString());
          msg.setResetWord(value);
          break;
        case 8:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setResetEntropy(value);
          break;
        case 9:
          var value = /** @type {string} */ (reader.readString());
          msg.setRecoveryFakeWord(value);
          break;
        case 10:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setRecoveryWordPos(value);
          break;
        case 11:
          var value = /** @type {string} */ (reader.readString());
          msg.setRecoveryCipher(value);
          break;
        case 12:
          var value = /** @type {string} */ (reader.readString());
          msg.setRecoveryAutoCompletedWord(value);
          break;
        case 13:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setFirmwareHash(value);
          break;
        case 14:
          var value = /** @type {!Uint8Array} */ (reader.readBytes());
          msg.setStorageHash(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkState.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkState.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkState} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkState.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeBytes(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 4));
      if (f != null) {
        writer.writeString(
          4,
          f
        );
      }
      f = message.getNode();
      if (f != null) {
        writer.writeMessage(
          5,
          f,
          types_pb.HDNodeType.serializeBinaryToWriter
        );
      }
      f = /** @type {boolean} */ (googleProtobuf.Message.getField(message, 6));
      if (f != null) {
        writer.writeBool(
          6,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 7));
      if (f != null) {
        writer.writeString(
          7,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 8));
      if (f != null) {
        writer.writeBytes(
          8,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 9));
      if (f != null) {
        writer.writeString(
          9,
          f
        );
      }
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 10));
      if (f != null) {
        writer.writeUint32(
          10,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 11));
      if (f != null) {
        writer.writeString(
          11,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 12));
      if (f != null) {
        writer.writeString(
          12,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 13));
      if (f != null) {
        writer.writeBytes(
          13,
          f
        );
      }
      f = /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getField(message, 14));
      if (f != null) {
        writer.writeBytes(
          14,
          f
        );
      }
    };


    /**
     * optional bytes layout = 1;
     * @return {!(string|Uint8Array)}
     */
    proto.DebugLinkState.prototype.getLayout = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, ""));
    };


    /**
     * optional bytes layout = 1;
     * This is a type-conversion wrapper around `getLayout()`
     * @return {string}
     */
    proto.DebugLinkState.prototype.getLayout_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getLayout()));
    };


    /**
     * optional bytes layout = 1;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getLayout()`
     * @return {!Uint8Array}
     */
    proto.DebugLinkState.prototype.getLayout_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getLayout()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DebugLinkState.prototype.setLayout = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.DebugLinkState.prototype.clearLayout = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasLayout = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string pin = 2;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getPin = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setPin = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.DebugLinkState.prototype.clearPin = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasPin = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string matrix = 3;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getMatrix = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setMatrix = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.DebugLinkState.prototype.clearMatrix = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasMatrix = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };


    /**
     * optional string mnemonic = 4;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getMnemonic = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 4, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setMnemonic = function(value) {
      googleProtobuf.Message.setField(this, 4, value);
    };


    proto.DebugLinkState.prototype.clearMnemonic = function() {
      googleProtobuf.Message.setField(this, 4, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasMnemonic = function() {
      return googleProtobuf.Message.getField(this, 4) != null;
    };


    /**
     * optional HDNodeType node = 5;
     * @return {?proto.HDNodeType}
     */
    proto.DebugLinkState.prototype.getNode = function() {
      return /** @type{?proto.HDNodeType} */ (
        googleProtobuf.Message.getWrapperField(this, types_pb.HDNodeType, 5));
    };


    /** @param {?proto.HDNodeType|undefined} value */
    proto.DebugLinkState.prototype.setNode = function(value) {
      googleProtobuf.Message.setWrapperField(this, 5, value);
    };


    proto.DebugLinkState.prototype.clearNode = function() {
      this.setNode(undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasNode = function() {
      return googleProtobuf.Message.getField(this, 5) != null;
    };


    /**
     * optional bool passphrase_protection = 6;
     * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
     * You should avoid comparisons like {@code val === true/false} in those cases.
     * @return {boolean}
     */
    proto.DebugLinkState.prototype.getPassphraseProtection = function() {
      return /** @type {boolean} */ (googleProtobuf.Message.getFieldWithDefault(this, 6, false));
    };


    /** @param {boolean} value */
    proto.DebugLinkState.prototype.setPassphraseProtection = function(value) {
      googleProtobuf.Message.setField(this, 6, value);
    };


    proto.DebugLinkState.prototype.clearPassphraseProtection = function() {
      googleProtobuf.Message.setField(this, 6, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasPassphraseProtection = function() {
      return googleProtobuf.Message.getField(this, 6) != null;
    };


    /**
     * optional string reset_word = 7;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getResetWord = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 7, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setResetWord = function(value) {
      googleProtobuf.Message.setField(this, 7, value);
    };


    proto.DebugLinkState.prototype.clearResetWord = function() {
      googleProtobuf.Message.setField(this, 7, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasResetWord = function() {
      return googleProtobuf.Message.getField(this, 7) != null;
    };


    /**
     * optional bytes reset_entropy = 8;
     * @return {!(string|Uint8Array)}
     */
    proto.DebugLinkState.prototype.getResetEntropy = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 8, ""));
    };


    /**
     * optional bytes reset_entropy = 8;
     * This is a type-conversion wrapper around `getResetEntropy()`
     * @return {string}
     */
    proto.DebugLinkState.prototype.getResetEntropy_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getResetEntropy()));
    };


    /**
     * optional bytes reset_entropy = 8;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getResetEntropy()`
     * @return {!Uint8Array}
     */
    proto.DebugLinkState.prototype.getResetEntropy_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getResetEntropy()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DebugLinkState.prototype.setResetEntropy = function(value) {
      googleProtobuf.Message.setField(this, 8, value);
    };


    proto.DebugLinkState.prototype.clearResetEntropy = function() {
      googleProtobuf.Message.setField(this, 8, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasResetEntropy = function() {
      return googleProtobuf.Message.getField(this, 8) != null;
    };


    /**
     * optional string recovery_fake_word = 9;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getRecoveryFakeWord = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 9, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setRecoveryFakeWord = function(value) {
      googleProtobuf.Message.setField(this, 9, value);
    };


    proto.DebugLinkState.prototype.clearRecoveryFakeWord = function() {
      googleProtobuf.Message.setField(this, 9, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasRecoveryFakeWord = function() {
      return googleProtobuf.Message.getField(this, 9) != null;
    };


    /**
     * optional uint32 recovery_word_pos = 10;
     * @return {number}
     */
    proto.DebugLinkState.prototype.getRecoveryWordPos = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 10, 0));
    };


    /** @param {number} value */
    proto.DebugLinkState.prototype.setRecoveryWordPos = function(value) {
      googleProtobuf.Message.setField(this, 10, value);
    };


    proto.DebugLinkState.prototype.clearRecoveryWordPos = function() {
      googleProtobuf.Message.setField(this, 10, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasRecoveryWordPos = function() {
      return googleProtobuf.Message.getField(this, 10) != null;
    };


    /**
     * optional string recovery_cipher = 11;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getRecoveryCipher = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 11, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setRecoveryCipher = function(value) {
      googleProtobuf.Message.setField(this, 11, value);
    };


    proto.DebugLinkState.prototype.clearRecoveryCipher = function() {
      googleProtobuf.Message.setField(this, 11, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasRecoveryCipher = function() {
      return googleProtobuf.Message.getField(this, 11) != null;
    };


    /**
     * optional string recovery_auto_completed_word = 12;
     * @return {string}
     */
    proto.DebugLinkState.prototype.getRecoveryAutoCompletedWord = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 12, ""));
    };


    /** @param {string} value */
    proto.DebugLinkState.prototype.setRecoveryAutoCompletedWord = function(value) {
      googleProtobuf.Message.setField(this, 12, value);
    };


    proto.DebugLinkState.prototype.clearRecoveryAutoCompletedWord = function() {
      googleProtobuf.Message.setField(this, 12, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasRecoveryAutoCompletedWord = function() {
      return googleProtobuf.Message.getField(this, 12) != null;
    };


    /**
     * optional bytes firmware_hash = 13;
     * @return {!(string|Uint8Array)}
     */
    proto.DebugLinkState.prototype.getFirmwareHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 13, ""));
    };


    /**
     * optional bytes firmware_hash = 13;
     * This is a type-conversion wrapper around `getFirmwareHash()`
     * @return {string}
     */
    proto.DebugLinkState.prototype.getFirmwareHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getFirmwareHash()));
    };


    /**
     * optional bytes firmware_hash = 13;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getFirmwareHash()`
     * @return {!Uint8Array}
     */
    proto.DebugLinkState.prototype.getFirmwareHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getFirmwareHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DebugLinkState.prototype.setFirmwareHash = function(value) {
      googleProtobuf.Message.setField(this, 13, value);
    };


    proto.DebugLinkState.prototype.clearFirmwareHash = function() {
      googleProtobuf.Message.setField(this, 13, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasFirmwareHash = function() {
      return googleProtobuf.Message.getField(this, 13) != null;
    };


    /**
     * optional bytes storage_hash = 14;
     * @return {!(string|Uint8Array)}
     */
    proto.DebugLinkState.prototype.getStorageHash = function() {
      return /** @type {!(string|Uint8Array)} */ (googleProtobuf.Message.getFieldWithDefault(this, 14, ""));
    };


    /**
     * optional bytes storage_hash = 14;
     * This is a type-conversion wrapper around `getStorageHash()`
     * @return {string}
     */
    proto.DebugLinkState.prototype.getStorageHash_asB64 = function() {
      return /** @type {string} */ (googleProtobuf.Message.bytesAsB64(
          this.getStorageHash()));
    };


    /**
     * optional bytes storage_hash = 14;
     * Note that Uint8Array is not supported on all browsers.
     * @see http://caniuse.com/Uint8Array
     * This is a type-conversion wrapper around `getStorageHash()`
     * @return {!Uint8Array}
     */
    proto.DebugLinkState.prototype.getStorageHash_asU8 = function() {
      return /** @type {!Uint8Array} */ (googleProtobuf.Message.bytesAsU8(
          this.getStorageHash()));
    };


    /** @param {!(string|Uint8Array)} value */
    proto.DebugLinkState.prototype.setStorageHash = function(value) {
      googleProtobuf.Message.setField(this, 14, value);
    };


    proto.DebugLinkState.prototype.clearStorageHash = function() {
      googleProtobuf.Message.setField(this, 14, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkState.prototype.hasStorageHash = function() {
      return googleProtobuf.Message.getField(this, 14) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkStop = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkStop, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkStop.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkStop.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkStop} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkStop.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkStop}
     */
    proto.DebugLinkStop.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkStop;
      return proto.DebugLinkStop.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkStop} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkStop}
     */
    proto.DebugLinkStop.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkStop.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkStop.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkStop} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkStop.serializeBinaryToWriter = function(message, writer) {
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkLog = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkLog, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkLog.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkLog.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkLog} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkLog.toObject = function(includeInstance, msg) {
      var obj = {
        level: googleProtobuf.Message.getField(msg, 1),
        bucket: googleProtobuf.Message.getField(msg, 2),
        text: googleProtobuf.Message.getField(msg, 3)
      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkLog}
     */
    proto.DebugLinkLog.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkLog;
      return proto.DebugLinkLog.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkLog} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkLog}
     */
    proto.DebugLinkLog.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        case 1:
          var value = /** @type {number} */ (reader.readUint32());
          msg.setLevel(value);
          break;
        case 2:
          var value = /** @type {string} */ (reader.readString());
          msg.setBucket(value);
          break;
        case 3:
          var value = /** @type {string} */ (reader.readString());
          msg.setText(value);
          break;
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkLog.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkLog.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkLog} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkLog.serializeBinaryToWriter = function(message, writer) {
      var f = undefined;
      f = /** @type {number} */ (googleProtobuf.Message.getField(message, 1));
      if (f != null) {
        writer.writeUint32(
          1,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 2));
      if (f != null) {
        writer.writeString(
          2,
          f
        );
      }
      f = /** @type {string} */ (googleProtobuf.Message.getField(message, 3));
      if (f != null) {
        writer.writeString(
          3,
          f
        );
      }
    };


    /**
     * optional uint32 level = 1;
     * @return {number}
     */
    proto.DebugLinkLog.prototype.getLevel = function() {
      return /** @type {number} */ (googleProtobuf.Message.getFieldWithDefault(this, 1, 0));
    };


    /** @param {number} value */
    proto.DebugLinkLog.prototype.setLevel = function(value) {
      googleProtobuf.Message.setField(this, 1, value);
    };


    proto.DebugLinkLog.prototype.clearLevel = function() {
      googleProtobuf.Message.setField(this, 1, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkLog.prototype.hasLevel = function() {
      return googleProtobuf.Message.getField(this, 1) != null;
    };


    /**
     * optional string bucket = 2;
     * @return {string}
     */
    proto.DebugLinkLog.prototype.getBucket = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 2, ""));
    };


    /** @param {string} value */
    proto.DebugLinkLog.prototype.setBucket = function(value) {
      googleProtobuf.Message.setField(this, 2, value);
    };


    proto.DebugLinkLog.prototype.clearBucket = function() {
      googleProtobuf.Message.setField(this, 2, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkLog.prototype.hasBucket = function() {
      return googleProtobuf.Message.getField(this, 2) != null;
    };


    /**
     * optional string text = 3;
     * @return {string}
     */
    proto.DebugLinkLog.prototype.getText = function() {
      return /** @type {string} */ (googleProtobuf.Message.getFieldWithDefault(this, 3, ""));
    };


    /** @param {string} value */
    proto.DebugLinkLog.prototype.setText = function(value) {
      googleProtobuf.Message.setField(this, 3, value);
    };


    proto.DebugLinkLog.prototype.clearText = function() {
      googleProtobuf.Message.setField(this, 3, undefined);
    };


    /**
     * Returns whether this field is set.
     * @return {!boolean}
     */
    proto.DebugLinkLog.prototype.hasText = function() {
      return googleProtobuf.Message.getField(this, 3) != null;
    };



    /**
     * Generated by JsPbCodeGenerator.
     * @param {Array=} opt_data Optional initial data array, typically from a
     * server response, or constructed directly in Javascript. The array is used
     * in place and becomes part of the constructed object. It is not cloned.
     * If no data is provided, the constructed object will be empty, but still
     * valid.
     * @extends {jspb.Message}
     * @constructor
     */
    proto.DebugLinkFillConfig = function(opt_data) {
      googleProtobuf.Message.initialize(this, opt_data, 0, -1, null, null);
    };
    goog.inherits(proto.DebugLinkFillConfig, googleProtobuf.Message);


    if (googleProtobuf.Message.GENERATE_TO_OBJECT) {
    /**
     * Creates an object representation of this proto suitable for use in Soy templates.
     * Field names that are reserved in JavaScript and will be renamed to pb_name.
     * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
     * For the list of reserved names please see:
     *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
     * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
     *     for transitional soy proto support: http://goto/soy-param-migration
     * @return {!Object}
     */
    proto.DebugLinkFillConfig.prototype.toObject = function(opt_includeInstance) {
      return proto.DebugLinkFillConfig.toObject(opt_includeInstance, this);
    };


    /**
     * Static version of the {@see toObject} method.
     * @param {boolean|undefined} includeInstance Whether to include the JSPB
     *     instance for transitional soy proto support:
     *     http://goto/soy-param-migration
     * @param {!proto.DebugLinkFillConfig} msg The msg instance to transform.
     * @return {!Object}
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkFillConfig.toObject = function(includeInstance, msg) {
      var obj = {

      };

      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
    }


    /**
     * Deserializes binary data (in protobuf wire format).
     * @param {jspb.ByteSource} bytes The bytes to deserialize.
     * @return {!proto.DebugLinkFillConfig}
     */
    proto.DebugLinkFillConfig.deserializeBinary = function(bytes) {
      var reader = new googleProtobuf.BinaryReader(bytes);
      var msg = new proto.DebugLinkFillConfig;
      return proto.DebugLinkFillConfig.deserializeBinaryFromReader(msg, reader);
    };


    /**
     * Deserializes binary data (in protobuf wire format) from the
     * given reader into the given message object.
     * @param {!proto.DebugLinkFillConfig} msg The message object to deserialize into.
     * @param {!jspb.BinaryReader} reader The BinaryReader to use.
     * @return {!proto.DebugLinkFillConfig}
     */
    proto.DebugLinkFillConfig.deserializeBinaryFromReader = function(msg, reader) {
      while (reader.nextField()) {
        if (reader.isEndGroup()) {
          break;
        }
        var field = reader.getFieldNumber();
        switch (field) {
        default:
          reader.skipField();
          break;
        }
      }
      return msg;
    };


    /**
     * Serializes the message to binary data (in protobuf wire format).
     * @return {!Uint8Array}
     */
    proto.DebugLinkFillConfig.prototype.serializeBinary = function() {
      var writer = new googleProtobuf.BinaryWriter();
      proto.DebugLinkFillConfig.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    };


    /**
     * Serializes the given message to binary data (in protobuf wire
     * format), writing to the given BinaryWriter.
     * @param {!proto.DebugLinkFillConfig} message
     * @param {!jspb.BinaryWriter} writer
     * @suppress {unusedLocalVariables} f is only used for nested messages
     */
    proto.DebugLinkFillConfig.serializeBinaryToWriter = function(message, writer) {
    };


    /**
     * @enum {number}
     */
    proto.MessageType = {
      MESSAGETYPE_INITIALIZE: 0,
      MESSAGETYPE_PING: 1,
      MESSAGETYPE_SUCCESS: 2,
      MESSAGETYPE_FAILURE: 3,
      MESSAGETYPE_CHANGEPIN: 4,
      MESSAGETYPE_WIPEDEVICE: 5,
      MESSAGETYPE_FIRMWAREERASE: 6,
      MESSAGETYPE_FIRMWAREUPLOAD: 7,
      MESSAGETYPE_GETENTROPY: 9,
      MESSAGETYPE_ENTROPY: 10,
      MESSAGETYPE_GETPUBLICKEY: 11,
      MESSAGETYPE_PUBLICKEY: 12,
      MESSAGETYPE_LOADDEVICE: 13,
      MESSAGETYPE_RESETDEVICE: 14,
      MESSAGETYPE_SIGNTX: 15,
      MESSAGETYPE_FEATURES: 17,
      MESSAGETYPE_PINMATRIXREQUEST: 18,
      MESSAGETYPE_PINMATRIXACK: 19,
      MESSAGETYPE_CANCEL: 20,
      MESSAGETYPE_TXREQUEST: 21,
      MESSAGETYPE_TXACK: 22,
      MESSAGETYPE_CIPHERKEYVALUE: 23,
      MESSAGETYPE_CLEARSESSION: 24,
      MESSAGETYPE_APPLYSETTINGS: 25,
      MESSAGETYPE_BUTTONREQUEST: 26,
      MESSAGETYPE_BUTTONACK: 27,
      MESSAGETYPE_GETADDRESS: 29,
      MESSAGETYPE_ADDRESS: 30,
      MESSAGETYPE_ENTROPYREQUEST: 35,
      MESSAGETYPE_ENTROPYACK: 36,
      MESSAGETYPE_SIGNMESSAGE: 38,
      MESSAGETYPE_VERIFYMESSAGE: 39,
      MESSAGETYPE_MESSAGESIGNATURE: 40,
      MESSAGETYPE_PASSPHRASEREQUEST: 41,
      MESSAGETYPE_PASSPHRASEACK: 42,
      MESSAGETYPE_ESTIMATETXSIZE: 43,
      MESSAGETYPE_TXSIZE: 44,
      MESSAGETYPE_RECOVERYDEVICE: 45,
      MESSAGETYPE_WORDREQUEST: 46,
      MESSAGETYPE_WORDACK: 47,
      MESSAGETYPE_CIPHEREDKEYVALUE: 48,
      MESSAGETYPE_ENCRYPTMESSAGE: 49,
      MESSAGETYPE_ENCRYPTEDMESSAGE: 50,
      MESSAGETYPE_DECRYPTMESSAGE: 51,
      MESSAGETYPE_DECRYPTEDMESSAGE: 52,
      MESSAGETYPE_SIGNIDENTITY: 53,
      MESSAGETYPE_SIGNEDIDENTITY: 54,
      MESSAGETYPE_GETFEATURES: 55,
      MESSAGETYPE_ETHEREUMGETADDRESS: 56,
      MESSAGETYPE_ETHEREUMADDRESS: 57,
      MESSAGETYPE_ETHEREUMSIGNTX: 58,
      MESSAGETYPE_ETHEREUMTXREQUEST: 59,
      MESSAGETYPE_ETHEREUMTXACK: 60,
      MESSAGETYPE_CHARACTERREQUEST: 80,
      MESSAGETYPE_CHARACTERACK: 81,
      MESSAGETYPE_RAWTXACK: 82,
      MESSAGETYPE_APPLYPOLICIES: 83,
      MESSAGETYPE_FLASHHASH: 84,
      MESSAGETYPE_FLASHWRITE: 85,
      MESSAGETYPE_FLASHHASHRESPONSE: 86,
      MESSAGETYPE_DEBUGLINKFLASHDUMP: 87,
      MESSAGETYPE_DEBUGLINKFLASHDUMPRESPONSE: 88,
      MESSAGETYPE_SOFTRESET: 89,
      MESSAGETYPE_DEBUGLINKDECISION: 100,
      MESSAGETYPE_DEBUGLINKGETSTATE: 101,
      MESSAGETYPE_DEBUGLINKSTATE: 102,
      MESSAGETYPE_DEBUGLINKSTOP: 103,
      MESSAGETYPE_DEBUGLINKLOG: 104,
      MESSAGETYPE_DEBUGLINKFILLCONFIG: 105,
      MESSAGETYPE_GETCOINTABLE: 106,
      MESSAGETYPE_COINTABLE: 107,
      MESSAGETYPE_ETHEREUMSIGNMESSAGE: 108,
      MESSAGETYPE_ETHEREUMVERIFYMESSAGE: 109,
      MESSAGETYPE_ETHEREUMMESSAGESIGNATURE: 110,
      MESSAGETYPE_EOSGETPUBLICKEY: 600,
      MESSAGETYPE_EOSPUBLICKEY: 601,
      MESSAGETYPE_EOSSIGNTX: 602,
      MESSAGETYPE_EOSTXACTIONREQUEST: 603,
      MESSAGETYPE_EOSTXACTIONACK: 604,
      MESSAGETYPE_EOSSIGNEDTX: 605
    };

    goog.object.extend(exports, proto);
    });

    // Shim until this exists for jspb https://github.com/protocolbuffers/protobuf/issues/1591
    function protoFieldToSetMethod(fieldName) {
        return "set" + (fieldName.charAt(0).toUpperCase() + fieldName.slice(1));
    }
    var isArray$1 = Array.isArray || function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    var leByteArrayToLong = function (byteArray) {
        var value = 0;
        for (var i = 0; i < byteArray.length; i++) {
            value = (value * 256) + byteArray[i];
        }
        return value;
    };
    // These helper functions marshal hex into and out of UInt8Arrays which are consumed by protobuf js
    var fromHexString = function (hexString) {
        var match = hexString.match(/.{1,2}/g) || [];
        return new Uint8Array(match.map(function (byte) { return parseInt(byte, 16); }));
    };
    // export const toHexString = (bytes: number[]) => bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '')
    function toHexString(arr) {
        return Array.prototype.map.call(arr, function (x) { return ('00' + x.toString(16)).slice(-2); }).join('');
    }
    // const prevhashTx = {"txid":"6f90f3c7cbec2258b0971056ef3fe34128dbde30daa9c0639a898f9977299d54","version":1,"locktime":0,"vin":[{"txid":"ee336e79153d51f4f3e45278f1f77ab29fd5bb135dce467282e2aff22cb9c570","vout":1,"sequence":4294967295,"n":0,"scriptSig":{"hex":"483045022066c418874dbe5628296700382d727ce1734928796068c26271472df09dccf1a20221009dec59d19f9d73db381fcd35c0fff757ad73e54ef59157b0d7c57e6739a092f00121033fef08c603943dc7d25f4ce65771762143b1cd8678343d660a1a76b9d1d3ced7","asm":"3045022066c418874dbe5628296700382d727ce1734928796068c26271472df09dccf1a20221009dec59d19f9d73db381fcd35c0fff757ad73e54ef59157b0d7c57e6739a092f0[ALL] 033fef08c603943dc7d25f4ce65771762143b1cd8678343d660a1a76b9d1d3ced7"},"addr":"mnsfHtywp6AVUzgqu9P4tay6iQYY3WhCpz","valueSat":550865100,"value":5.508651,"doubleSpentTxID":null},{"txid":"2fe4d8af2b44faccc10dd5a6578c923491d2d21269a1dfe8c83f492a30fb8f9f","vout":1,"sequence":4294967295,"n":1,"scriptSig":{"hex":"47304402206fbb8e14be706b8557a2280d2a2a75c0a65c4f7936d90d510f0971c93f41f74402201b79c8c4e4ac4c944913611633c230193558296e70a36269b7fc3a80efa27d120121030cb5be79bdc36a4ff4443dbac43068cc43d638ea06ff2fa1b8dab389e39aefc7","asm":"304402206fbb8e14be706b8557a2280d2a2a75c0a65c4f7936d90d510f0971c93f41f74402201b79c8c4e4ac4c944913611633c230193558296e70a36269b7fc3a80efa27d12[ALL] 030cb5be79bdc36a4ff4443dbac43068cc43d638ea06ff2fa1b8dab389e39aefc7"},"addr":"mrDBnbEumaEiHm8pc9pj1rfUCsR4H7N5xh","valueSat":852985889,"value":8.52985889,"doubleSpentTxID":null}],"vout":[{"value":"4.03850989","n":0,"scriptPubKey":{"hex":"76a914f5a05c2664b40d3116b1c5086c9ba38ed15b742e88ac","asm":"OP_DUP OP_HASH160 f5a05c2664b40d3116b1c5086c9ba38ed15b742e OP_EQUALVERIFY OP_CHECKSIG","addresses":["n3uhx4JymCrWKX3e9i59YdJivMghF1bKZ4"],"type":"pubkeyhash"},"spentTxId":"5170fe1f25a05e1c9e125c27cd09e11f7c79c41409bc5b68f0e6f056af2d56b0","spentIndex":0,"spentHeight":203911},{"value":"10.00000000","n":1,"scriptPubKey":{"hex":"76a91424a56db43cf6f2b02e838ea493f95d8d6047423188ac","asm":"OP_DUP OP_HASH160 24a56db43cf6f2b02e838ea493f95d8d60474231 OP_EQUALVERIFY OP_CHECKSIG","addresses":["mirio8q3gtv7fhdnmb3TpZ4EuafdzSs7zL"],"type":"pubkeyhash"},"spentTxId":null,"spentIndex":null,"spentHeight":null}],"blockhash":"000000006656e1d72a211b7f469dd85209ba85c54127957a95591712a63d3848","blockheight":180573,"confirmations":1234520,"time":1391901762,"blocktime":1391901762,"valueOut":14.03850989,"size":373,"valueIn":14.03850989,"fees":0}
    // export function getPrevHashTx(prevhash){
    //   return prevhashTx
    // }
    // Copying this from ethers.js until their elliptic dep stops being circular
    function arrayify(value) {
        if (value == null) {
            throw new Error('cannot convert null value to array');
        }
        if (typeof (value) === 'string') {
            var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
            if (!match) {
                throw new Error('invalid hexidecimal string');
            }
            if (match[1] !== '0x') {
                throw new Error('hex string must have 0x prefix');
            }
            value = value.substring(2);
            if (value.length % 2) {
                value = '0' + value;
            }
            var result = [];
            for (var i = 0; i < value.length; i += 2) {
                result.push(parseInt(value.substr(i, 2), 16));
            }
            return new Uint8Array(result);
        }
    }
    var HARDENED = 0x80000000;
    function bip32ToAddressNList(address) {
        if (/^m\//i.test(address)) {
            address = address.slice(2);
        }
        var path = address.split('/');
        if (path.length === 1 && path[0] === '')
            return [];
        var ret = new Array(path.length);
        for (var i = 0; i < path.length; i++) {
            var tmp = /(\d+)([hH\']?)/.exec(path[i]);
            if (tmp === null) {
                throw new Error('Invalid input');
            }
            ret[i] = parseInt(tmp[1], 10);
            if (ret[i] >= HARDENED) {
                throw new Error('Invalid child index');
            }
            if (tmp[2] === 'h' || tmp[2] === 'H' || tmp[2] === '\'') {
                ret[i] += HARDENED;
            }
            else if (tmp[2].length !== 0) {
                throw new Error('Invalid modifier');
            }
        }
        return ret;
    }
    function bip32Like(address) {
        return address.slice(0, 2) === 'm/';
    }

    var long_1 = createCommonjsModule(function (module) {
    /*
     Copyright 2013 Daniel Wirtz <dcode@dcode.io>
     Copyright 2009 The Closure Library Authors. All Rights Reserved.

     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS-IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

    /**
     * @license long.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
     * Released under the Apache License, Version 2.0
     * see: https://github.com/dcodeIO/long.js for details
     */
    (function(global, factory) {

        /* AMD */ if (typeof commonjsRequire === 'function' && 'object' === "object" && module && module["exports"])
            module["exports"] = factory();
        /* Global */ else
            (global["dcodeIO"] = global["dcodeIO"] || {})["Long"] = factory();

    })(commonjsGlobal, function() {

        /**
         * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
         *  See the from* functions below for more convenient ways of constructing Longs.
         * @exports Long
         * @class A Long class for representing a 64 bit two's-complement integer value.
         * @param {number} low The low (signed) 32 bits of the long
         * @param {number} high The high (signed) 32 bits of the long
         * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
         * @constructor
         */
        function Long(low, high, unsigned) {

            /**
             * The low 32 bits as a signed value.
             * @type {number}
             */
            this.low = low | 0;

            /**
             * The high 32 bits as a signed value.
             * @type {number}
             */
            this.high = high | 0;

            /**
             * Whether unsigned or not.
             * @type {boolean}
             */
            this.unsigned = !!unsigned;
        }

        // The internal representation of a long is the two given signed, 32-bit values.
        // We use 32-bit pieces because these are the size of integers on which
        // Javascript performs bit-operations.  For operations like addition and
        // multiplication, we split each number into 16 bit pieces, which can easily be
        // multiplied within Javascript's floating-point representation without overflow
        // or change in sign.
        //
        // In the algorithms below, we frequently reduce the negative case to the
        // positive case by negating the input(s) and then post-processing the result.
        // Note that we must ALWAYS check specially whether those values are MIN_VALUE
        // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
        // a positive number, it overflows back into a negative).  Not handling this
        // case would often result in infinite recursion.
        //
        // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
        // methods on which they depend.

        /**
         * An indicator used to reliably determine if an object is a Long or not.
         * @type {boolean}
         * @const
         * @private
         */
        Long.prototype.__isLong__;

        Object.defineProperty(Long.prototype, "__isLong__", {
            value: true,
            enumerable: false,
            configurable: false
        });

        /**
         * @function
         * @param {*} obj Object
         * @returns {boolean}
         * @inner
         */
        function isLong(obj) {
            return (obj && obj["__isLong__"]) === true;
        }

        /**
         * Tests if the specified object is a Long.
         * @function
         * @param {*} obj Object
         * @returns {boolean}
         */
        Long.isLong = isLong;

        /**
         * A cache of the Long representations of small integer values.
         * @type {!Object}
         * @inner
         */
        var INT_CACHE = {};

        /**
         * A cache of the Long representations of small unsigned integer values.
         * @type {!Object}
         * @inner
         */
        var UINT_CACHE = {};

        /**
         * @param {number} value
         * @param {boolean=} unsigned
         * @returns {!Long}
         * @inner
         */
        function fromInt(value, unsigned) {
            var obj, cachedObj, cache;
            if (unsigned) {
                value >>>= 0;
                if (cache = (0 <= value && value < 256)) {
                    cachedObj = UINT_CACHE[value];
                    if (cachedObj)
                        return cachedObj;
                }
                obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
                if (cache)
                    UINT_CACHE[value] = obj;
                return obj;
            } else {
                value |= 0;
                if (cache = (-128 <= value && value < 128)) {
                    cachedObj = INT_CACHE[value];
                    if (cachedObj)
                        return cachedObj;
                }
                obj = fromBits(value, value < 0 ? -1 : 0, false);
                if (cache)
                    INT_CACHE[value] = obj;
                return obj;
            }
        }

        /**
         * Returns a Long representing the given 32 bit integer value.
         * @function
         * @param {number} value The 32 bit integer in question
         * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
         * @returns {!Long} The corresponding Long value
         */
        Long.fromInt = fromInt;

        /**
         * @param {number} value
         * @param {boolean=} unsigned
         * @returns {!Long}
         * @inner
         */
        function fromNumber(value, unsigned) {
            if (isNaN(value) || !isFinite(value))
                return unsigned ? UZERO : ZERO;
            if (unsigned) {
                if (value < 0)
                    return UZERO;
                if (value >= TWO_PWR_64_DBL)
                    return MAX_UNSIGNED_VALUE;
            } else {
                if (value <= -TWO_PWR_63_DBL)
                    return MIN_VALUE;
                if (value + 1 >= TWO_PWR_63_DBL)
                    return MAX_VALUE;
            }
            if (value < 0)
                return fromNumber(-value, unsigned).neg();
            return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
        }

        /**
         * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
         * @function
         * @param {number} value The number in question
         * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
         * @returns {!Long} The corresponding Long value
         */
        Long.fromNumber = fromNumber;

        /**
         * @param {number} lowBits
         * @param {number} highBits
         * @param {boolean=} unsigned
         * @returns {!Long}
         * @inner
         */
        function fromBits(lowBits, highBits, unsigned) {
            return new Long(lowBits, highBits, unsigned);
        }

        /**
         * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
         *  assumed to use 32 bits.
         * @function
         * @param {number} lowBits The low 32 bits
         * @param {number} highBits The high 32 bits
         * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
         * @returns {!Long} The corresponding Long value
         */
        Long.fromBits = fromBits;

        /**
         * @function
         * @param {number} base
         * @param {number} exponent
         * @returns {number}
         * @inner
         */
        var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)

        /**
         * @param {string} str
         * @param {(boolean|number)=} unsigned
         * @param {number=} radix
         * @returns {!Long}
         * @inner
         */
        function fromString(str, unsigned, radix) {
            if (str.length === 0)
                throw Error('empty string');
            if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
                return ZERO;
            if (typeof unsigned === 'number') {
                // For goog.math.long compatibility
                radix = unsigned,
                unsigned = false;
            } else {
                unsigned = !! unsigned;
            }
            radix = radix || 10;
            if (radix < 2 || 36 < radix)
                throw RangeError('radix');

            var p;
            if ((p = str.indexOf('-')) > 0)
                throw Error('interior hyphen');
            else if (p === 0) {
                return fromString(str.substring(1), unsigned, radix).neg();
            }

            // Do several (8) digits each time through the loop, so as to
            // minimize the calls to the very expensive emulated div.
            var radixToPower = fromNumber(pow_dbl(radix, 8));

            var result = ZERO;
            for (var i = 0; i < str.length; i += 8) {
                var size = Math.min(8, str.length - i),
                    value = parseInt(str.substring(i, i + size), radix);
                if (size < 8) {
                    var power = fromNumber(pow_dbl(radix, size));
                    result = result.mul(power).add(fromNumber(value));
                } else {
                    result = result.mul(radixToPower);
                    result = result.add(fromNumber(value));
                }
            }
            result.unsigned = unsigned;
            return result;
        }

        /**
         * Returns a Long representation of the given string, written using the specified radix.
         * @function
         * @param {string} str The textual representation of the Long
         * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to `false` for signed
         * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
         * @returns {!Long} The corresponding Long value
         */
        Long.fromString = fromString;

        /**
         * @function
         * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
         * @returns {!Long}
         * @inner
         */
        function fromValue(val) {
            if (val /* is compatible */ instanceof Long)
                return val;
            if (typeof val === 'number')
                return fromNumber(val);
            if (typeof val === 'string')
                return fromString(val);
            // Throws for non-objects, converts non-instanceof Long:
            return fromBits(val.low, val.high, val.unsigned);
        }

        /**
         * Converts the specified value to a Long.
         * @function
         * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
         * @returns {!Long}
         */
        Long.fromValue = fromValue;

        // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
        // no runtime penalty for these.

        /**
         * @type {number}
         * @const
         * @inner
         */
        var TWO_PWR_16_DBL = 1 << 16;

        /**
         * @type {number}
         * @const
         * @inner
         */
        var TWO_PWR_24_DBL = 1 << 24;

        /**
         * @type {number}
         * @const
         * @inner
         */
        var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;

        /**
         * @type {number}
         * @const
         * @inner
         */
        var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;

        /**
         * @type {number}
         * @const
         * @inner
         */
        var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;

        /**
         * @type {!Long}
         * @const
         * @inner
         */
        var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);

        /**
         * @type {!Long}
         * @inner
         */
        var ZERO = fromInt(0);

        /**
         * Signed zero.
         * @type {!Long}
         */
        Long.ZERO = ZERO;

        /**
         * @type {!Long}
         * @inner
         */
        var UZERO = fromInt(0, true);

        /**
         * Unsigned zero.
         * @type {!Long}
         */
        Long.UZERO = UZERO;

        /**
         * @type {!Long}
         * @inner
         */
        var ONE = fromInt(1);

        /**
         * Signed one.
         * @type {!Long}
         */
        Long.ONE = ONE;

        /**
         * @type {!Long}
         * @inner
         */
        var UONE = fromInt(1, true);

        /**
         * Unsigned one.
         * @type {!Long}
         */
        Long.UONE = UONE;

        /**
         * @type {!Long}
         * @inner
         */
        var NEG_ONE = fromInt(-1);

        /**
         * Signed negative one.
         * @type {!Long}
         */
        Long.NEG_ONE = NEG_ONE;

        /**
         * @type {!Long}
         * @inner
         */
        var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);

        /**
         * Maximum signed value.
         * @type {!Long}
         */
        Long.MAX_VALUE = MAX_VALUE;

        /**
         * @type {!Long}
         * @inner
         */
        var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);

        /**
         * Maximum unsigned value.
         * @type {!Long}
         */
        Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;

        /**
         * @type {!Long}
         * @inner
         */
        var MIN_VALUE = fromBits(0, 0x80000000|0, false);

        /**
         * Minimum signed value.
         * @type {!Long}
         */
        Long.MIN_VALUE = MIN_VALUE;

        /**
         * @alias Long.prototype
         * @inner
         */
        var LongPrototype = Long.prototype;

        /**
         * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
         * @returns {number}
         */
        LongPrototype.toInt = function toInt() {
            return this.unsigned ? this.low >>> 0 : this.low;
        };

        /**
         * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
         * @returns {number}
         */
        LongPrototype.toNumber = function toNumber() {
            if (this.unsigned)
                return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
            return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
        };

        /**
         * Converts the Long to a string written in the specified radix.
         * @param {number=} radix Radix (2-36), defaults to 10
         * @returns {string}
         * @override
         * @throws {RangeError} If `radix` is out of range
         */
        LongPrototype.toString = function toString(radix) {
            radix = radix || 10;
            if (radix < 2 || 36 < radix)
                throw RangeError('radix');
            if (this.isZero())
                return '0';
            if (this.isNegative()) { // Unsigned Longs are never negative
                if (this.eq(MIN_VALUE)) {
                    // We need to change the Long value before it can be negated, so we remove
                    // the bottom-most digit in this base and then recurse to do the rest.
                    var radixLong = fromNumber(radix),
                        div = this.div(radixLong),
                        rem1 = div.mul(radixLong).sub(this);
                    return div.toString(radix) + rem1.toInt().toString(radix);
                } else
                    return '-' + this.neg().toString(radix);
            }

            // Do several (6) digits each time through the loop, so as to
            // minimize the calls to the very expensive emulated div.
            var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
                rem = this;
            var result = '';
            while (true) {
                var remDiv = rem.div(radixToPower),
                    intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
                    digits = intval.toString(radix);
                rem = remDiv;
                if (rem.isZero())
                    return digits + result;
                else {
                    while (digits.length < 6)
                        digits = '0' + digits;
                    result = '' + digits + result;
                }
            }
        };

        /**
         * Gets the high 32 bits as a signed integer.
         * @returns {number} Signed high bits
         */
        LongPrototype.getHighBits = function getHighBits() {
            return this.high;
        };

        /**
         * Gets the high 32 bits as an unsigned integer.
         * @returns {number} Unsigned high bits
         */
        LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
            return this.high >>> 0;
        };

        /**
         * Gets the low 32 bits as a signed integer.
         * @returns {number} Signed low bits
         */
        LongPrototype.getLowBits = function getLowBits() {
            return this.low;
        };

        /**
         * Gets the low 32 bits as an unsigned integer.
         * @returns {number} Unsigned low bits
         */
        LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
            return this.low >>> 0;
        };

        /**
         * Gets the number of bits needed to represent the absolute value of this Long.
         * @returns {number}
         */
        LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
            if (this.isNegative()) // Unsigned Longs are never negative
                return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
            var val = this.high != 0 ? this.high : this.low;
            for (var bit = 31; bit > 0; bit--)
                if ((val & (1 << bit)) != 0)
                    break;
            return this.high != 0 ? bit + 33 : bit + 1;
        };

        /**
         * Tests if this Long's value equals zero.
         * @returns {boolean}
         */
        LongPrototype.isZero = function isZero() {
            return this.high === 0 && this.low === 0;
        };

        /**
         * Tests if this Long's value is negative.
         * @returns {boolean}
         */
        LongPrototype.isNegative = function isNegative() {
            return !this.unsigned && this.high < 0;
        };

        /**
         * Tests if this Long's value is positive.
         * @returns {boolean}
         */
        LongPrototype.isPositive = function isPositive() {
            return this.unsigned || this.high >= 0;
        };

        /**
         * Tests if this Long's value is odd.
         * @returns {boolean}
         */
        LongPrototype.isOdd = function isOdd() {
            return (this.low & 1) === 1;
        };

        /**
         * Tests if this Long's value is even.
         * @returns {boolean}
         */
        LongPrototype.isEven = function isEven() {
            return (this.low & 1) === 0;
        };

        /**
         * Tests if this Long's value equals the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.equals = function equals(other) {
            if (!isLong(other))
                other = fromValue(other);
            if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
                return false;
            return this.high === other.high && this.low === other.low;
        };

        /**
         * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.eq = LongPrototype.equals;

        /**
         * Tests if this Long's value differs from the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.notEquals = function notEquals(other) {
            return !this.eq(/* validates */ other);
        };

        /**
         * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.neq = LongPrototype.notEquals;

        /**
         * Tests if this Long's value is less than the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.lessThan = function lessThan(other) {
            return this.comp(/* validates */ other) < 0;
        };

        /**
         * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.lt = LongPrototype.lessThan;

        /**
         * Tests if this Long's value is less than or equal the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
            return this.comp(/* validates */ other) <= 0;
        };

        /**
         * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.lte = LongPrototype.lessThanOrEqual;

        /**
         * Tests if this Long's value is greater than the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.greaterThan = function greaterThan(other) {
            return this.comp(/* validates */ other) > 0;
        };

        /**
         * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.gt = LongPrototype.greaterThan;

        /**
         * Tests if this Long's value is greater than or equal the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
            return this.comp(/* validates */ other) >= 0;
        };

        /**
         * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {boolean}
         */
        LongPrototype.gte = LongPrototype.greaterThanOrEqual;

        /**
         * Compares this Long's value with the specified's.
         * @param {!Long|number|string} other Other value
         * @returns {number} 0 if they are the same, 1 if the this is greater and -1
         *  if the given one is greater
         */
        LongPrototype.compare = function compare(other) {
            if (!isLong(other))
                other = fromValue(other);
            if (this.eq(other))
                return 0;
            var thisNeg = this.isNegative(),
                otherNeg = other.isNegative();
            if (thisNeg && !otherNeg)
                return -1;
            if (!thisNeg && otherNeg)
                return 1;
            // At this point the sign bits are the same
            if (!this.unsigned)
                return this.sub(other).isNegative() ? -1 : 1;
            // Both are positive if at least one is unsigned
            return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
        };

        /**
         * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
         * @function
         * @param {!Long|number|string} other Other value
         * @returns {number} 0 if they are the same, 1 if the this is greater and -1
         *  if the given one is greater
         */
        LongPrototype.comp = LongPrototype.compare;

        /**
         * Negates this Long's value.
         * @returns {!Long} Negated Long
         */
        LongPrototype.negate = function negate() {
            if (!this.unsigned && this.eq(MIN_VALUE))
                return MIN_VALUE;
            return this.not().add(ONE);
        };

        /**
         * Negates this Long's value. This is an alias of {@link Long#negate}.
         * @function
         * @returns {!Long} Negated Long
         */
        LongPrototype.neg = LongPrototype.negate;

        /**
         * Returns the sum of this and the specified Long.
         * @param {!Long|number|string} addend Addend
         * @returns {!Long} Sum
         */
        LongPrototype.add = function add(addend) {
            if (!isLong(addend))
                addend = fromValue(addend);

            // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

            var a48 = this.high >>> 16;
            var a32 = this.high & 0xFFFF;
            var a16 = this.low >>> 16;
            var a00 = this.low & 0xFFFF;

            var b48 = addend.high >>> 16;
            var b32 = addend.high & 0xFFFF;
            var b16 = addend.low >>> 16;
            var b00 = addend.low & 0xFFFF;

            var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
            c00 += a00 + b00;
            c16 += c00 >>> 16;
            c00 &= 0xFFFF;
            c16 += a16 + b16;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c32 += a32 + b32;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c48 += a48 + b48;
            c48 &= 0xFFFF;
            return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
        };

        /**
         * Returns the difference of this and the specified Long.
         * @param {!Long|number|string} subtrahend Subtrahend
         * @returns {!Long} Difference
         */
        LongPrototype.subtract = function subtract(subtrahend) {
            if (!isLong(subtrahend))
                subtrahend = fromValue(subtrahend);
            return this.add(subtrahend.neg());
        };

        /**
         * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
         * @function
         * @param {!Long|number|string} subtrahend Subtrahend
         * @returns {!Long} Difference
         */
        LongPrototype.sub = LongPrototype.subtract;

        /**
         * Returns the product of this and the specified Long.
         * @param {!Long|number|string} multiplier Multiplier
         * @returns {!Long} Product
         */
        LongPrototype.multiply = function multiply(multiplier) {
            if (this.isZero())
                return ZERO;
            if (!isLong(multiplier))
                multiplier = fromValue(multiplier);
            if (multiplier.isZero())
                return ZERO;
            if (this.eq(MIN_VALUE))
                return multiplier.isOdd() ? MIN_VALUE : ZERO;
            if (multiplier.eq(MIN_VALUE))
                return this.isOdd() ? MIN_VALUE : ZERO;

            if (this.isNegative()) {
                if (multiplier.isNegative())
                    return this.neg().mul(multiplier.neg());
                else
                    return this.neg().mul(multiplier).neg();
            } else if (multiplier.isNegative())
                return this.mul(multiplier.neg()).neg();

            // If both longs are small, use float multiplication
            if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
                return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);

            // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
            // We can skip products that would overflow.

            var a48 = this.high >>> 16;
            var a32 = this.high & 0xFFFF;
            var a16 = this.low >>> 16;
            var a00 = this.low & 0xFFFF;

            var b48 = multiplier.high >>> 16;
            var b32 = multiplier.high & 0xFFFF;
            var b16 = multiplier.low >>> 16;
            var b00 = multiplier.low & 0xFFFF;

            var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
            c00 += a00 * b00;
            c16 += c00 >>> 16;
            c00 &= 0xFFFF;
            c16 += a16 * b00;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c16 += a00 * b16;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c32 += a32 * b00;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c32 += a16 * b16;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c32 += a00 * b32;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
            c48 &= 0xFFFF;
            return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
        };

        /**
         * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
         * @function
         * @param {!Long|number|string} multiplier Multiplier
         * @returns {!Long} Product
         */
        LongPrototype.mul = LongPrototype.multiply;

        /**
         * Returns this Long divided by the specified. The result is signed if this Long is signed or
         *  unsigned if this Long is unsigned.
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Quotient
         */
        LongPrototype.divide = function divide(divisor) {
            if (!isLong(divisor))
                divisor = fromValue(divisor);
            if (divisor.isZero())
                throw Error('division by zero');
            if (this.isZero())
                return this.unsigned ? UZERO : ZERO;
            var approx, rem, res;
            if (!this.unsigned) {
                // This section is only relevant for signed longs and is derived from the
                // closure library as a whole.
                if (this.eq(MIN_VALUE)) {
                    if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
                        return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
                    else if (divisor.eq(MIN_VALUE))
                        return ONE;
                    else {
                        // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                        var halfThis = this.shr(1);
                        approx = halfThis.div(divisor).shl(1);
                        if (approx.eq(ZERO)) {
                            return divisor.isNegative() ? ONE : NEG_ONE;
                        } else {
                            rem = this.sub(divisor.mul(approx));
                            res = approx.add(rem.div(divisor));
                            return res;
                        }
                    }
                } else if (divisor.eq(MIN_VALUE))
                    return this.unsigned ? UZERO : ZERO;
                if (this.isNegative()) {
                    if (divisor.isNegative())
                        return this.neg().div(divisor.neg());
                    return this.neg().div(divisor).neg();
                } else if (divisor.isNegative())
                    return this.div(divisor.neg()).neg();
                res = ZERO;
            } else {
                // The algorithm below has not been made for unsigned longs. It's therefore
                // required to take special care of the MSB prior to running it.
                if (!divisor.unsigned)
                    divisor = divisor.toUnsigned();
                if (divisor.gt(this))
                    return UZERO;
                if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
                    return UONE;
                res = UZERO;
            }

            // Repeat the following until the remainder is less than other:  find a
            // floating-point that approximates remainder / other *from below*, add this
            // into the result, and subtract it from the remainder.  It is critical that
            // the approximate value is less than or equal to the real value so that the
            // remainder never becomes negative.
            rem = this;
            while (rem.gte(divisor)) {
                // Approximate the result of division. This may be a little greater or
                // smaller than the actual value.
                approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));

                // We will tweak the approximate result by changing it in the 48-th digit or
                // the smallest non-fractional digit, whichever is larger.
                var log2 = Math.ceil(Math.log(approx) / Math.LN2),
                    delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),

                // Decrease the approximation until it is smaller than the remainder.  Note
                // that if it is too large, the product overflows and is negative.
                    approxRes = fromNumber(approx),
                    approxRem = approxRes.mul(divisor);
                while (approxRem.isNegative() || approxRem.gt(rem)) {
                    approx -= delta;
                    approxRes = fromNumber(approx, this.unsigned);
                    approxRem = approxRes.mul(divisor);
                }

                // We know the answer can't be zero... and actually, zero would cause
                // infinite recursion since we would make no progress.
                if (approxRes.isZero())
                    approxRes = ONE;

                res = res.add(approxRes);
                rem = rem.sub(approxRem);
            }
            return res;
        };

        /**
         * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
         * @function
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Quotient
         */
        LongPrototype.div = LongPrototype.divide;

        /**
         * Returns this Long modulo the specified.
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Remainder
         */
        LongPrototype.modulo = function modulo(divisor) {
            if (!isLong(divisor))
                divisor = fromValue(divisor);
            return this.sub(this.div(divisor).mul(divisor));
        };

        /**
         * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
         * @function
         * @param {!Long|number|string} divisor Divisor
         * @returns {!Long} Remainder
         */
        LongPrototype.mod = LongPrototype.modulo;

        /**
         * Returns the bitwise NOT of this Long.
         * @returns {!Long}
         */
        LongPrototype.not = function not() {
            return fromBits(~this.low, ~this.high, this.unsigned);
        };

        /**
         * Returns the bitwise AND of this Long and the specified.
         * @param {!Long|number|string} other Other Long
         * @returns {!Long}
         */
        LongPrototype.and = function and(other) {
            if (!isLong(other))
                other = fromValue(other);
            return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
        };

        /**
         * Returns the bitwise OR of this Long and the specified.
         * @param {!Long|number|string} other Other Long
         * @returns {!Long}
         */
        LongPrototype.or = function or(other) {
            if (!isLong(other))
                other = fromValue(other);
            return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
        };

        /**
         * Returns the bitwise XOR of this Long and the given one.
         * @param {!Long|number|string} other Other Long
         * @returns {!Long}
         */
        LongPrototype.xor = function xor(other) {
            if (!isLong(other))
                other = fromValue(other);
            return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
        };

        /**
         * Returns this Long with bits shifted to the left by the given amount.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        LongPrototype.shiftLeft = function shiftLeft(numBits) {
            if (isLong(numBits))
                numBits = numBits.toInt();
            if ((numBits &= 63) === 0)
                return this;
            else if (numBits < 32)
                return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
            else
                return fromBits(0, this.low << (numBits - 32), this.unsigned);
        };

        /**
         * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
         * @function
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        LongPrototype.shl = LongPrototype.shiftLeft;

        /**
         * Returns this Long with bits arithmetically shifted to the right by the given amount.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        LongPrototype.shiftRight = function shiftRight(numBits) {
            if (isLong(numBits))
                numBits = numBits.toInt();
            if ((numBits &= 63) === 0)
                return this;
            else if (numBits < 32)
                return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
            else
                return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
        };

        /**
         * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
         * @function
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        LongPrototype.shr = LongPrototype.shiftRight;

        /**
         * Returns this Long with bits logically shifted to the right by the given amount.
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
            if (isLong(numBits))
                numBits = numBits.toInt();
            numBits &= 63;
            if (numBits === 0)
                return this;
            else {
                var high = this.high;
                if (numBits < 32) {
                    var low = this.low;
                    return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
                } else if (numBits === 32)
                    return fromBits(high, 0, this.unsigned);
                else
                    return fromBits(high >>> (numBits - 32), 0, this.unsigned);
            }
        };

        /**
         * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
         * @function
         * @param {number|!Long} numBits Number of bits
         * @returns {!Long} Shifted Long
         */
        LongPrototype.shru = LongPrototype.shiftRightUnsigned;

        /**
         * Converts this Long to signed.
         * @returns {!Long} Signed long
         */
        LongPrototype.toSigned = function toSigned() {
            if (!this.unsigned)
                return this;
            return fromBits(this.low, this.high, false);
        };

        /**
         * Converts this Long to unsigned.
         * @returns {!Long} Unsigned long
         */
        LongPrototype.toUnsigned = function toUnsigned() {
            if (this.unsigned)
                return this;
            return fromBits(this.low, this.high, true);
        };

        /**
         * Converts this Long to its byte representation.
         * @param {boolean=} le Whether little or big endian, defaults to big endian
         * @returns {!Array.<number>} Byte representation
         */
        LongPrototype.toBytes = function(le) {
            return le ? this.toBytesLE() : this.toBytesBE();
        };

        /**
         * Converts this Long to its little endian byte representation.
         * @returns {!Array.<number>} Little endian byte representation
         */
        LongPrototype.toBytesLE = function() {
            var hi = this.high,
                lo = this.low;
            return [
                 lo         & 0xff,
                (lo >>>  8) & 0xff,
                (lo >>> 16) & 0xff,
                (lo >>> 24) & 0xff,
                 hi         & 0xff,
                (hi >>>  8) & 0xff,
                (hi >>> 16) & 0xff,
                (hi >>> 24) & 0xff
            ];
        };

        /**
         * Converts this Long to its big endian byte representation.
         * @returns {!Array.<number>} Big endian byte representation
         */
        LongPrototype.toBytesBE = function() {
            var hi = this.high,
                lo = this.low;
            return [
                (hi >>> 24) & 0xff,
                (hi >>> 16) & 0xff,
                (hi >>>  8) & 0xff,
                 hi         & 0xff,
                (lo >>> 24) & 0xff,
                (lo >>> 16) & 0xff,
                (lo >>>  8) & 0xff,
                 lo         & 0xff
            ];
        };

        return Long;
    });
    });

    var bytebuffer = createCommonjsModule(function (module) {
    /*
     Copyright 2013-2014 Daniel Wirtz <dcode@dcode.io>

     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

    /**
     * @license bytebuffer.js (c) 2015 Daniel Wirtz <dcode@dcode.io>
     * Backing buffer: ArrayBuffer, Accessor: Uint8Array
     * Released under the Apache License, Version 2.0
     * see: https://github.com/dcodeIO/bytebuffer.js for details
     */
    (function(global, factory) {

        /* AMD */ if (typeof commonjsRequire === 'function' && 'object' === "object" && module && module["exports"])
            module['exports'] = (function() {
                var Long; try { Long = long_1; } catch (e) {}
                return factory(Long);
            })();
        /* Global */ else
            (global["dcodeIO"] = global["dcodeIO"] || {})["ByteBuffer"] = factory(global["dcodeIO"]["Long"]);

    })(commonjsGlobal, function(Long) {

        /**
         * Constructs a new ByteBuffer.
         * @class The swiss army knife for binary data in JavaScript.
         * @exports ByteBuffer
         * @constructor
         * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @expose
         */
        var ByteBuffer = function(capacity, littleEndian, noAssert) {
            if (typeof capacity === 'undefined')
                capacity = ByteBuffer.DEFAULT_CAPACITY;
            if (typeof littleEndian === 'undefined')
                littleEndian = ByteBuffer.DEFAULT_ENDIAN;
            if (typeof noAssert === 'undefined')
                noAssert = ByteBuffer.DEFAULT_NOASSERT;
            if (!noAssert) {
                capacity = capacity | 0;
                if (capacity < 0)
                    throw RangeError("Illegal capacity");
                littleEndian = !!littleEndian;
                noAssert = !!noAssert;
            }

            /**
             * Backing ArrayBuffer.
             * @type {!ArrayBuffer}
             * @expose
             */
            this.buffer = capacity === 0 ? EMPTY_BUFFER : new ArrayBuffer(capacity);

            /**
             * Uint8Array utilized to manipulate the backing buffer. Becomes `null` if the backing buffer has a capacity of `0`.
             * @type {?Uint8Array}
             * @expose
             */
            this.view = capacity === 0 ? null : new Uint8Array(this.buffer);

            /**
             * Absolute read/write offset.
             * @type {number}
             * @expose
             * @see ByteBuffer#flip
             * @see ByteBuffer#clear
             */
            this.offset = 0;

            /**
             * Marked offset.
             * @type {number}
             * @expose
             * @see ByteBuffer#mark
             * @see ByteBuffer#reset
             */
            this.markedOffset = -1;

            /**
             * Absolute limit of the contained data. Set to the backing buffer's capacity upon allocation.
             * @type {number}
             * @expose
             * @see ByteBuffer#flip
             * @see ByteBuffer#clear
             */
            this.limit = capacity;

            /**
             * Whether to use little endian byte order, defaults to `false` for big endian.
             * @type {boolean}
             * @expose
             */
            this.littleEndian = littleEndian;

            /**
             * Whether to skip assertions of offsets and values, defaults to `false`.
             * @type {boolean}
             * @expose
             */
            this.noAssert = noAssert;
        };

        /**
         * ByteBuffer version.
         * @type {string}
         * @const
         * @expose
         */
        ByteBuffer.VERSION = "5.0.1";

        /**
         * Little endian constant that can be used instead of its boolean value. Evaluates to `true`.
         * @type {boolean}
         * @const
         * @expose
         */
        ByteBuffer.LITTLE_ENDIAN = true;

        /**
         * Big endian constant that can be used instead of its boolean value. Evaluates to `false`.
         * @type {boolean}
         * @const
         * @expose
         */
        ByteBuffer.BIG_ENDIAN = false;

        /**
         * Default initial capacity of `16`.
         * @type {number}
         * @expose
         */
        ByteBuffer.DEFAULT_CAPACITY = 16;

        /**
         * Default endianess of `false` for big endian.
         * @type {boolean}
         * @expose
         */
        ByteBuffer.DEFAULT_ENDIAN = ByteBuffer.BIG_ENDIAN;

        /**
         * Default no assertions flag of `false`.
         * @type {boolean}
         * @expose
         */
        ByteBuffer.DEFAULT_NOASSERT = false;

        /**
         * A `Long` class for representing a 64-bit two's-complement integer value. May be `null` if Long.js has not been loaded
         *  and int64 support is not available.
         * @type {?Long}
         * @const
         * @see https://github.com/dcodeIO/long.js
         * @expose
         */
        ByteBuffer.Long = Long || null;

        /**
         * @alias ByteBuffer.prototype
         * @inner
         */
        var ByteBufferPrototype = ByteBuffer.prototype;

        /**
         * An indicator used to reliably determine if an object is a ByteBuffer or not.
         * @type {boolean}
         * @const
         * @expose
         * @private
         */
        ByteBufferPrototype.__isByteBuffer__;

        Object.defineProperty(ByteBufferPrototype, "__isByteBuffer__", {
            value: true,
            enumerable: false,
            configurable: false
        });

        // helpers

        /**
         * @type {!ArrayBuffer}
         * @inner
         */
        var EMPTY_BUFFER = new ArrayBuffer(0);

        /**
         * String.fromCharCode reference for compile-time renaming.
         * @type {function(...number):string}
         * @inner
         */
        var stringFromCharCode = String.fromCharCode;

        /**
         * Creates a source function for a string.
         * @param {string} s String to read from
         * @returns {function():number|null} Source function returning the next char code respectively `null` if there are
         *  no more characters left.
         * @throws {TypeError} If the argument is invalid
         * @inner
         */
        function stringSource(s) {
            var i=0; return function() {
                return i < s.length ? s.charCodeAt(i++) : null;
            };
        }

        /**
         * Creates a destination function for a string.
         * @returns {function(number=):undefined|string} Destination function successively called with the next char code.
         *  Returns the final string when called without arguments.
         * @inner
         */
        function stringDestination() {
            var cs = [], ps = []; return function() {
                if (arguments.length === 0)
                    return ps.join('')+stringFromCharCode.apply(String, cs);
                if (cs.length + arguments.length > 1024)
                    ps.push(stringFromCharCode.apply(String, cs)),
                        cs.length = 0;
                Array.prototype.push.apply(cs, arguments);
            };
        }

        /**
         * Gets the accessor type.
         * @returns {Function} `Buffer` under node.js, `Uint8Array` respectively `DataView` in the browser (classes)
         * @expose
         */
        ByteBuffer.accessor = function() {
            return Uint8Array;
        };
        /**
         * Allocates a new ByteBuffer backed by a buffer of the specified capacity.
         * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer}
         * @expose
         */
        ByteBuffer.allocate = function(capacity, littleEndian, noAssert) {
            return new ByteBuffer(capacity, littleEndian, noAssert);
        };

        /**
         * Concatenates multiple ByteBuffers into one.
         * @param {!Array.<!ByteBuffer|!ArrayBuffer|!Uint8Array|string>} buffers Buffers to concatenate
         * @param {(string|boolean)=} encoding String encoding if `buffers` contains a string ("base64", "hex", "binary",
         *  defaults to "utf8")
         * @param {boolean=} littleEndian Whether to use little or big endian byte order for the resulting ByteBuffer. Defaults
         *  to {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values for the resulting ByteBuffer. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} Concatenated ByteBuffer
         * @expose
         */
        ByteBuffer.concat = function(buffers, encoding, littleEndian, noAssert) {
            if (typeof encoding === 'boolean' || typeof encoding !== 'string') {
                noAssert = littleEndian;
                littleEndian = encoding;
                encoding = undefined;
            }
            var capacity = 0;
            for (var i=0, k=buffers.length, length; i<k; ++i) {
                if (!ByteBuffer.isByteBuffer(buffers[i]))
                    buffers[i] = ByteBuffer.wrap(buffers[i], encoding);
                length = buffers[i].limit - buffers[i].offset;
                if (length > 0) capacity += length;
            }
            if (capacity === 0)
                return new ByteBuffer(0, littleEndian, noAssert);
            var bb = new ByteBuffer(capacity, littleEndian, noAssert),
                bi;
            i=0; while (i<k) {
                bi = buffers[i++];
                length = bi.limit - bi.offset;
                if (length <= 0) continue;
                bb.view.set(bi.view.subarray(bi.offset, bi.limit), bb.offset);
                bb.offset += length;
            }
            bb.limit = bb.offset;
            bb.offset = 0;
            return bb;
        };

        /**
         * Tests if the specified type is a ByteBuffer.
         * @param {*} bb ByteBuffer to test
         * @returns {boolean} `true` if it is a ByteBuffer, otherwise `false`
         * @expose
         */
        ByteBuffer.isByteBuffer = function(bb) {
            return (bb && bb["__isByteBuffer__"]) === true;
        };
        /**
         * Gets the backing buffer type.
         * @returns {Function} `Buffer` under node.js, `ArrayBuffer` in the browser (classes)
         * @expose
         */
        ByteBuffer.type = function() {
            return ArrayBuffer;
        };
        /**
         * Wraps a buffer or a string. Sets the allocated ByteBuffer's {@link ByteBuffer#offset} to `0` and its
         *  {@link ByteBuffer#limit} to the length of the wrapped data.
         * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string|!Array.<number>} buffer Anything that can be wrapped
         * @param {(string|boolean)=} encoding String encoding if `buffer` is a string ("base64", "hex", "binary", defaults to
         *  "utf8")
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} A ByteBuffer wrapping `buffer`
         * @expose
         */
        ByteBuffer.wrap = function(buffer, encoding, littleEndian, noAssert) {
            if (typeof encoding !== 'string') {
                noAssert = littleEndian;
                littleEndian = encoding;
                encoding = undefined;
            }
            if (typeof buffer === 'string') {
                if (typeof encoding === 'undefined')
                    encoding = "utf8";
                switch (encoding) {
                    case "base64":
                        return ByteBuffer.fromBase64(buffer, littleEndian);
                    case "hex":
                        return ByteBuffer.fromHex(buffer, littleEndian);
                    case "binary":
                        return ByteBuffer.fromBinary(buffer, littleEndian);
                    case "utf8":
                        return ByteBuffer.fromUTF8(buffer, littleEndian);
                    case "debug":
                        return ByteBuffer.fromDebug(buffer, littleEndian);
                    default:
                        throw Error("Unsupported encoding: "+encoding);
                }
            }
            if (buffer === null || typeof buffer !== 'object')
                throw TypeError("Illegal buffer");
            var bb;
            if (ByteBuffer.isByteBuffer(buffer)) {
                bb = ByteBufferPrototype.clone.call(buffer);
                bb.markedOffset = -1;
                return bb;
            }
            if (buffer instanceof Uint8Array) { // Extract ArrayBuffer from Uint8Array
                bb = new ByteBuffer(0, littleEndian, noAssert);
                if (buffer.length > 0) { // Avoid references to more than one EMPTY_BUFFER
                    bb.buffer = buffer.buffer;
                    bb.offset = buffer.byteOffset;
                    bb.limit = buffer.byteOffset + buffer.byteLength;
                    bb.view = new Uint8Array(buffer.buffer);
                }
            } else if (buffer instanceof ArrayBuffer) { // Reuse ArrayBuffer
                bb = new ByteBuffer(0, littleEndian, noAssert);
                if (buffer.byteLength > 0) {
                    bb.buffer = buffer;
                    bb.offset = 0;
                    bb.limit = buffer.byteLength;
                    bb.view = buffer.byteLength > 0 ? new Uint8Array(buffer) : null;
                }
            } else if (Object.prototype.toString.call(buffer) === "[object Array]") { // Create from octets
                bb = new ByteBuffer(buffer.length, littleEndian, noAssert);
                bb.limit = buffer.length;
                for (var i=0; i<buffer.length; ++i)
                    bb.view[i] = buffer[i];
            } else
                throw TypeError("Illegal buffer"); // Otherwise fail
            return bb;
        };

        /**
         * Writes the array as a bitset.
         * @param {Array<boolean>} value Array of booleans to write
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
         * @returns {!ByteBuffer}
         * @expose
         */
        ByteBufferPrototype.writeBitSet = function(value, offset) {
          var relative = typeof offset === 'undefined';
          if (relative) offset = this.offset;
          if (!this.noAssert) {
            if (!(value instanceof Array))
              throw TypeError("Illegal BitSet: Not an array");
            if (typeof offset !== 'number' || offset % 1 !== 0)
                throw TypeError("Illegal offset: "+offset+" (not an integer)");
            offset >>>= 0;
            if (offset < 0 || offset + 0 > this.buffer.byteLength)
                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
          }

          var start = offset,
              bits = value.length,
              bytes = (bits >> 3),
              bit = 0,
              k;

          offset += this.writeVarint32(bits,offset);

          while(bytes--) {
            k = (!!value[bit++] & 1) |
                ((!!value[bit++] & 1) << 1) |
                ((!!value[bit++] & 1) << 2) |
                ((!!value[bit++] & 1) << 3) |
                ((!!value[bit++] & 1) << 4) |
                ((!!value[bit++] & 1) << 5) |
                ((!!value[bit++] & 1) << 6) |
                ((!!value[bit++] & 1) << 7);
            this.writeByte(k,offset++);
          }

          if(bit < bits) {
            var m = 0; k = 0;
            while(bit < bits) k = k | ((!!value[bit++] & 1) << (m++));
            this.writeByte(k,offset++);
          }

          if (relative) {
            this.offset = offset;
            return this;
          }
          return offset - start;
        };

        /**
         * Reads a BitSet as an array of booleans.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
         * @returns {Array<boolean>
         * @expose
         */
        ByteBufferPrototype.readBitSet = function(offset) {
          var relative = typeof offset === 'undefined';
          if (relative) offset = this.offset;

          var ret = this.readVarint32(offset),
              bits = ret.value,
              bytes = (bits >> 3),
              bit = 0,
              value = [],
              k;

          offset += ret.length;

          while(bytes--) {
            k = this.readByte(offset++);
            value[bit++] = !!(k & 0x01);
            value[bit++] = !!(k & 0x02);
            value[bit++] = !!(k & 0x04);
            value[bit++] = !!(k & 0x08);
            value[bit++] = !!(k & 0x10);
            value[bit++] = !!(k & 0x20);
            value[bit++] = !!(k & 0x40);
            value[bit++] = !!(k & 0x80);
          }

          if(bit < bits) {
            var m = 0;
            k = this.readByte(offset++);
            while(bit < bits) value[bit++] = !!((k >> (m++)) & 1);
          }

          if (relative) {
            this.offset = offset;
          }
          return value;
        };
        /**
         * Reads the specified number of bytes.
         * @param {number} length Number of bytes to read
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
         * @returns {!ByteBuffer}
         * @expose
         */
        ByteBufferPrototype.readBytes = function(length, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + length > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+length+") <= "+this.buffer.byteLength);
            }
            var slice = this.slice(offset, offset + length);
            if (relative) this.offset += length;
            return slice;
        };


        // types/ints/int8

        /**
         * Writes an 8bit signed integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeInt8 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 1;
            var capacity0 = this.buffer.byteLength;
            if (offset > capacity0)
                this.resize((capacity0 *= 2) > offset ? capacity0 : offset);
            offset -= 1;
            this.view[offset] = value;
            if (relative) this.offset += 1;
            return this;
        };

        /**
         * Writes an 8bit signed integer. This is an alias of {@link ByteBuffer#writeInt8}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeByte = ByteBufferPrototype.writeInt8;

        /**
         * Reads an 8bit signed integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readInt8 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var value = this.view[offset];
            if ((value & 0x80) === 0x80) value = -(0xFF - value + 1); // Cast to signed
            if (relative) this.offset += 1;
            return value;
        };

        /**
         * Reads an 8bit signed integer. This is an alias of {@link ByteBuffer#readInt8}.
         * @function
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readByte = ByteBufferPrototype.readInt8;

        /**
         * Writes an 8bit unsigned integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeUint8 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value >>>= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 1;
            var capacity1 = this.buffer.byteLength;
            if (offset > capacity1)
                this.resize((capacity1 *= 2) > offset ? capacity1 : offset);
            offset -= 1;
            this.view[offset] = value;
            if (relative) this.offset += 1;
            return this;
        };

        /**
         * Writes an 8bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint8}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeUInt8 = ByteBufferPrototype.writeUint8;

        /**
         * Reads an 8bit unsigned integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readUint8 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var value = this.view[offset];
            if (relative) this.offset += 1;
            return value;
        };

        /**
         * Reads an 8bit unsigned integer. This is an alias of {@link ByteBuffer#readUint8}.
         * @function
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readUInt8 = ByteBufferPrototype.readUint8;

        // types/ints/int16

        /**
         * Writes a 16bit signed integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeInt16 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 2;
            var capacity2 = this.buffer.byteLength;
            if (offset > capacity2)
                this.resize((capacity2 *= 2) > offset ? capacity2 : offset);
            offset -= 2;
            if (this.littleEndian) {
                this.view[offset+1] = (value & 0xFF00) >>> 8;
                this.view[offset  ] =  value & 0x00FF;
            } else {
                this.view[offset]   = (value & 0xFF00) >>> 8;
                this.view[offset+1] =  value & 0x00FF;
            }
            if (relative) this.offset += 2;
            return this;
        };

        /**
         * Writes a 16bit signed integer. This is an alias of {@link ByteBuffer#writeInt16}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeShort = ByteBufferPrototype.writeInt16;

        /**
         * Reads a 16bit signed integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readInt16 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 2 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+2+") <= "+this.buffer.byteLength);
            }
            var value = 0;
            if (this.littleEndian) {
                value  = this.view[offset  ];
                value |= this.view[offset+1] << 8;
            } else {
                value  = this.view[offset  ] << 8;
                value |= this.view[offset+1];
            }
            if ((value & 0x8000) === 0x8000) value = -(0xFFFF - value + 1); // Cast to signed
            if (relative) this.offset += 2;
            return value;
        };

        /**
         * Reads a 16bit signed integer. This is an alias of {@link ByteBuffer#readInt16}.
         * @function
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readShort = ByteBufferPrototype.readInt16;

        /**
         * Writes a 16bit unsigned integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeUint16 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value >>>= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 2;
            var capacity3 = this.buffer.byteLength;
            if (offset > capacity3)
                this.resize((capacity3 *= 2) > offset ? capacity3 : offset);
            offset -= 2;
            if (this.littleEndian) {
                this.view[offset+1] = (value & 0xFF00) >>> 8;
                this.view[offset  ] =  value & 0x00FF;
            } else {
                this.view[offset]   = (value & 0xFF00) >>> 8;
                this.view[offset+1] =  value & 0x00FF;
            }
            if (relative) this.offset += 2;
            return this;
        };

        /**
         * Writes a 16bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint16}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @throws {TypeError} If `offset` or `value` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.writeUInt16 = ByteBufferPrototype.writeUint16;

        /**
         * Reads a 16bit unsigned integer.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readUint16 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 2 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+2+") <= "+this.buffer.byteLength);
            }
            var value = 0;
            if (this.littleEndian) {
                value  = this.view[offset  ];
                value |= this.view[offset+1] << 8;
            } else {
                value  = this.view[offset  ] << 8;
                value |= this.view[offset+1];
            }
            if (relative) this.offset += 2;
            return value;
        };

        /**
         * Reads a 16bit unsigned integer. This is an alias of {@link ByteBuffer#readUint16}.
         * @function
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
         * @returns {number} Value read
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @expose
         */
        ByteBufferPrototype.readUInt16 = ByteBufferPrototype.readUint16;

        // types/ints/int32

        /**
         * Writes a 32bit signed integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeInt32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 4;
            var capacity4 = this.buffer.byteLength;
            if (offset > capacity4)
                this.resize((capacity4 *= 2) > offset ? capacity4 : offset);
            offset -= 4;
            if (this.littleEndian) {
                this.view[offset+3] = (value >>> 24) & 0xFF;
                this.view[offset+2] = (value >>> 16) & 0xFF;
                this.view[offset+1] = (value >>>  8) & 0xFF;
                this.view[offset  ] =  value         & 0xFF;
            } else {
                this.view[offset  ] = (value >>> 24) & 0xFF;
                this.view[offset+1] = (value >>> 16) & 0xFF;
                this.view[offset+2] = (value >>>  8) & 0xFF;
                this.view[offset+3] =  value         & 0xFF;
            }
            if (relative) this.offset += 4;
            return this;
        };

        /**
         * Writes a 32bit signed integer. This is an alias of {@link ByteBuffer#writeInt32}.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeInt = ByteBufferPrototype.writeInt32;

        /**
         * Reads a 32bit signed integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readInt32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var value = 0;
            if (this.littleEndian) {
                value  = this.view[offset+2] << 16;
                value |= this.view[offset+1] <<  8;
                value |= this.view[offset  ];
                value += this.view[offset+3] << 24 >>> 0;
            } else {
                value  = this.view[offset+1] << 16;
                value |= this.view[offset+2] <<  8;
                value |= this.view[offset+3];
                value += this.view[offset  ] << 24 >>> 0;
            }
            value |= 0; // Cast to signed
            if (relative) this.offset += 4;
            return value;
        };

        /**
         * Reads a 32bit signed integer. This is an alias of {@link ByteBuffer#readInt32}.
         * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readInt = ByteBufferPrototype.readInt32;

        /**
         * Writes a 32bit unsigned integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeUint32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value >>>= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 4;
            var capacity5 = this.buffer.byteLength;
            if (offset > capacity5)
                this.resize((capacity5 *= 2) > offset ? capacity5 : offset);
            offset -= 4;
            if (this.littleEndian) {
                this.view[offset+3] = (value >>> 24) & 0xFF;
                this.view[offset+2] = (value >>> 16) & 0xFF;
                this.view[offset+1] = (value >>>  8) & 0xFF;
                this.view[offset  ] =  value         & 0xFF;
            } else {
                this.view[offset  ] = (value >>> 24) & 0xFF;
                this.view[offset+1] = (value >>> 16) & 0xFF;
                this.view[offset+2] = (value >>>  8) & 0xFF;
                this.view[offset+3] =  value         & 0xFF;
            }
            if (relative) this.offset += 4;
            return this;
        };

        /**
         * Writes a 32bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint32}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @expose
         */
        ByteBufferPrototype.writeUInt32 = ByteBufferPrototype.writeUint32;

        /**
         * Reads a 32bit unsigned integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readUint32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var value = 0;
            if (this.littleEndian) {
                value  = this.view[offset+2] << 16;
                value |= this.view[offset+1] <<  8;
                value |= this.view[offset  ];
                value += this.view[offset+3] << 24 >>> 0;
            } else {
                value  = this.view[offset+1] << 16;
                value |= this.view[offset+2] <<  8;
                value |= this.view[offset+3];
                value += this.view[offset  ] << 24 >>> 0;
            }
            if (relative) this.offset += 4;
            return value;
        };

        /**
         * Reads a 32bit unsigned integer. This is an alias of {@link ByteBuffer#readUint32}.
         * @function
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number} Value read
         * @expose
         */
        ByteBufferPrototype.readUInt32 = ByteBufferPrototype.readUint32;

        // types/ints/int64

        if (Long) {

            /**
             * Writes a 64bit signed integer.
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeInt64 = function(value, offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof value === 'number')
                        value = Long.fromNumber(value);
                    else if (typeof value === 'string')
                        value = Long.fromString(value);
                    else if (!(value && value instanceof Long))
                        throw TypeError("Illegal value: "+value+" (not an integer or Long)");
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 0 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
                }
                if (typeof value === 'number')
                    value = Long.fromNumber(value);
                else if (typeof value === 'string')
                    value = Long.fromString(value);
                offset += 8;
                var capacity6 = this.buffer.byteLength;
                if (offset > capacity6)
                    this.resize((capacity6 *= 2) > offset ? capacity6 : offset);
                offset -= 8;
                var lo = value.low,
                    hi = value.high;
                if (this.littleEndian) {
                    this.view[offset+3] = (lo >>> 24) & 0xFF;
                    this.view[offset+2] = (lo >>> 16) & 0xFF;
                    this.view[offset+1] = (lo >>>  8) & 0xFF;
                    this.view[offset  ] =  lo         & 0xFF;
                    offset += 4;
                    this.view[offset+3] = (hi >>> 24) & 0xFF;
                    this.view[offset+2] = (hi >>> 16) & 0xFF;
                    this.view[offset+1] = (hi >>>  8) & 0xFF;
                    this.view[offset  ] =  hi         & 0xFF;
                } else {
                    this.view[offset  ] = (hi >>> 24) & 0xFF;
                    this.view[offset+1] = (hi >>> 16) & 0xFF;
                    this.view[offset+2] = (hi >>>  8) & 0xFF;
                    this.view[offset+3] =  hi         & 0xFF;
                    offset += 4;
                    this.view[offset  ] = (lo >>> 24) & 0xFF;
                    this.view[offset+1] = (lo >>> 16) & 0xFF;
                    this.view[offset+2] = (lo >>>  8) & 0xFF;
                    this.view[offset+3] =  lo         & 0xFF;
                }
                if (relative) this.offset += 8;
                return this;
            };

            /**
             * Writes a 64bit signed integer. This is an alias of {@link ByteBuffer#writeInt64}.
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeLong = ByteBufferPrototype.writeInt64;

            /**
             * Reads a 64bit signed integer.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readInt64 = function(offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 8 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
                }
                var lo = 0,
                    hi = 0;
                if (this.littleEndian) {
                    lo  = this.view[offset+2] << 16;
                    lo |= this.view[offset+1] <<  8;
                    lo |= this.view[offset  ];
                    lo += this.view[offset+3] << 24 >>> 0;
                    offset += 4;
                    hi  = this.view[offset+2] << 16;
                    hi |= this.view[offset+1] <<  8;
                    hi |= this.view[offset  ];
                    hi += this.view[offset+3] << 24 >>> 0;
                } else {
                    hi  = this.view[offset+1] << 16;
                    hi |= this.view[offset+2] <<  8;
                    hi |= this.view[offset+3];
                    hi += this.view[offset  ] << 24 >>> 0;
                    offset += 4;
                    lo  = this.view[offset+1] << 16;
                    lo |= this.view[offset+2] <<  8;
                    lo |= this.view[offset+3];
                    lo += this.view[offset  ] << 24 >>> 0;
                }
                var value = new Long(lo, hi, false);
                if (relative) this.offset += 8;
                return value;
            };

            /**
             * Reads a 64bit signed integer. This is an alias of {@link ByteBuffer#readInt64}.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readLong = ByteBufferPrototype.readInt64;

            /**
             * Writes a 64bit unsigned integer.
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeUint64 = function(value, offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof value === 'number')
                        value = Long.fromNumber(value);
                    else if (typeof value === 'string')
                        value = Long.fromString(value);
                    else if (!(value && value instanceof Long))
                        throw TypeError("Illegal value: "+value+" (not an integer or Long)");
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 0 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
                }
                if (typeof value === 'number')
                    value = Long.fromNumber(value);
                else if (typeof value === 'string')
                    value = Long.fromString(value);
                offset += 8;
                var capacity7 = this.buffer.byteLength;
                if (offset > capacity7)
                    this.resize((capacity7 *= 2) > offset ? capacity7 : offset);
                offset -= 8;
                var lo = value.low,
                    hi = value.high;
                if (this.littleEndian) {
                    this.view[offset+3] = (lo >>> 24) & 0xFF;
                    this.view[offset+2] = (lo >>> 16) & 0xFF;
                    this.view[offset+1] = (lo >>>  8) & 0xFF;
                    this.view[offset  ] =  lo         & 0xFF;
                    offset += 4;
                    this.view[offset+3] = (hi >>> 24) & 0xFF;
                    this.view[offset+2] = (hi >>> 16) & 0xFF;
                    this.view[offset+1] = (hi >>>  8) & 0xFF;
                    this.view[offset  ] =  hi         & 0xFF;
                } else {
                    this.view[offset  ] = (hi >>> 24) & 0xFF;
                    this.view[offset+1] = (hi >>> 16) & 0xFF;
                    this.view[offset+2] = (hi >>>  8) & 0xFF;
                    this.view[offset+3] =  hi         & 0xFF;
                    offset += 4;
                    this.view[offset  ] = (lo >>> 24) & 0xFF;
                    this.view[offset+1] = (lo >>> 16) & 0xFF;
                    this.view[offset+2] = (lo >>>  8) & 0xFF;
                    this.view[offset+3] =  lo         & 0xFF;
                }
                if (relative) this.offset += 8;
                return this;
            };

            /**
             * Writes a 64bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint64}.
             * @function
             * @param {number|!Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!ByteBuffer} this
             * @expose
             */
            ByteBufferPrototype.writeUInt64 = ByteBufferPrototype.writeUint64;

            /**
             * Reads a 64bit unsigned integer.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readUint64 = function(offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 8 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
                }
                var lo = 0,
                    hi = 0;
                if (this.littleEndian) {
                    lo  = this.view[offset+2] << 16;
                    lo |= this.view[offset+1] <<  8;
                    lo |= this.view[offset  ];
                    lo += this.view[offset+3] << 24 >>> 0;
                    offset += 4;
                    hi  = this.view[offset+2] << 16;
                    hi |= this.view[offset+1] <<  8;
                    hi |= this.view[offset  ];
                    hi += this.view[offset+3] << 24 >>> 0;
                } else {
                    hi  = this.view[offset+1] << 16;
                    hi |= this.view[offset+2] <<  8;
                    hi |= this.view[offset+3];
                    hi += this.view[offset  ] << 24 >>> 0;
                    offset += 4;
                    lo  = this.view[offset+1] << 16;
                    lo |= this.view[offset+2] <<  8;
                    lo |= this.view[offset+3];
                    lo += this.view[offset  ] << 24 >>> 0;
                }
                var value = new Long(lo, hi, true);
                if (relative) this.offset += 8;
                return value;
            };

            /**
             * Reads a 64bit unsigned integer. This is an alias of {@link ByteBuffer#readUint64}.
             * @function
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
             * @returns {!Long}
             * @expose
             */
            ByteBufferPrototype.readUInt64 = ByteBufferPrototype.readUint64;

        } // Long


        // types/floats/float32

        /*
         ieee754 - https://github.com/feross/ieee754

         The MIT License (MIT)

         Copyright (c) Feross Aboukhadijeh

         Permission is hereby granted, free of charge, to any person obtaining a copy
         of this software and associated documentation files (the "Software"), to deal
         in the Software without restriction, including without limitation the rights
         to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         copies of the Software, and to permit persons to whom the Software is
         furnished to do so, subject to the following conditions:

         The above copyright notice and this permission notice shall be included in
         all copies or substantial portions of the Software.

         THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         THE SOFTWARE.
        */

        /**
         * Reads an IEEE754 float from a byte array.
         * @param {!Array} buffer
         * @param {number} offset
         * @param {boolean} isLE
         * @param {number} mLen
         * @param {number} nBytes
         * @returns {number}
         * @inner
         */
        function ieee754_read(buffer, offset, isLE, mLen, nBytes) {
            var e, m,
                eLen = nBytes * 8 - mLen - 1,
                eMax = (1 << eLen) - 1,
                eBias = eMax >> 1,
                nBits = -7,
                i = isLE ? (nBytes - 1) : 0,
                d = isLE ? -1 : 1,
                s = buffer[offset + i];

            i += d;

            e = s & ((1 << (-nBits)) - 1);
            s >>= (-nBits);
            nBits += eLen;
            for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

            m = e & ((1 << (-nBits)) - 1);
            e >>= (-nBits);
            nBits += mLen;
            for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

            if (e === 0) {
                e = 1 - eBias;
            } else if (e === eMax) {
                return m ? NaN : ((s ? -1 : 1) * Infinity);
            } else {
                m = m + Math.pow(2, mLen);
                e = e - eBias;
            }
            return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
        }

        /**
         * Writes an IEEE754 float to a byte array.
         * @param {!Array} buffer
         * @param {number} value
         * @param {number} offset
         * @param {boolean} isLE
         * @param {number} mLen
         * @param {number} nBytes
         * @inner
         */
        function ieee754_write(buffer, value, offset, isLE, mLen, nBytes) {
            var e, m, c,
                eLen = nBytes * 8 - mLen - 1,
                eMax = (1 << eLen) - 1,
                eBias = eMax >> 1,
                rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0),
                i = isLE ? 0 : (nBytes - 1),
                d = isLE ? 1 : -1,
                s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

            value = Math.abs(value);

            if (isNaN(value) || value === Infinity) {
                m = isNaN(value) ? 1 : 0;
                e = eMax;
            } else {
                e = Math.floor(Math.log(value) / Math.LN2);
                if (value * (c = Math.pow(2, -e)) < 1) {
                    e--;
                    c *= 2;
                }
                if (e + eBias >= 1) {
                    value += rt / c;
                } else {
                    value += rt * Math.pow(2, 1 - eBias);
                }
                if (value * c >= 2) {
                    e++;
                    c /= 2;
                }

                if (e + eBias >= eMax) {
                    m = 0;
                    e = eMax;
                } else if (e + eBias >= 1) {
                    m = (value * c - 1) * Math.pow(2, mLen);
                    e = e + eBias;
                } else {
                    m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                    e = 0;
                }
            }

            for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

            e = (e << mLen) | m;
            eLen += mLen;
            for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

            buffer[offset + i - d] |= s * 128;
        }

        /**
         * Writes a 32bit float.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeFloat32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number')
                    throw TypeError("Illegal value: "+value+" (not a number)");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 4;
            var capacity8 = this.buffer.byteLength;
            if (offset > capacity8)
                this.resize((capacity8 *= 2) > offset ? capacity8 : offset);
            offset -= 4;
            ieee754_write(this.view, value, offset, this.littleEndian, 23, 4);
            if (relative) this.offset += 4;
            return this;
        };

        /**
         * Writes a 32bit float. This is an alias of {@link ByteBuffer#writeFloat32}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeFloat = ByteBufferPrototype.writeFloat32;

        /**
         * Reads a 32bit float.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readFloat32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var value = ieee754_read(this.view, offset, this.littleEndian, 23, 4);
            if (relative) this.offset += 4;
            return value;
        };

        /**
         * Reads a 32bit float. This is an alias of {@link ByteBuffer#readFloat32}.
         * @function
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readFloat = ByteBufferPrototype.readFloat32;

        // types/floats/float64

        /**
         * Writes a 64bit float.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeFloat64 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number')
                    throw TypeError("Illegal value: "+value+" (not a number)");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            offset += 8;
            var capacity9 = this.buffer.byteLength;
            if (offset > capacity9)
                this.resize((capacity9 *= 2) > offset ? capacity9 : offset);
            offset -= 8;
            ieee754_write(this.view, value, offset, this.littleEndian, 52, 8);
            if (relative) this.offset += 8;
            return this;
        };

        /**
         * Writes a 64bit float. This is an alias of {@link ByteBuffer#writeFloat64}.
         * @function
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeDouble = ByteBufferPrototype.writeFloat64;

        /**
         * Reads a 64bit float.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readFloat64 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 8 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
            }
            var value = ieee754_read(this.view, offset, this.littleEndian, 52, 8);
            if (relative) this.offset += 8;
            return value;
        };

        /**
         * Reads a 64bit float. This is an alias of {@link ByteBuffer#readFloat64}.
         * @function
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
         * @returns {number}
         * @expose
         */
        ByteBufferPrototype.readDouble = ByteBufferPrototype.readFloat64;


        // types/varints/varint32

        /**
         * Maximum number of bytes required to store a 32bit base 128 variable-length integer.
         * @type {number}
         * @const
         * @expose
         */
        ByteBuffer.MAX_VARINT32_BYTES = 5;

        /**
         * Calculates the actual number of bytes required to store a 32bit base 128 variable-length integer.
         * @param {number} value Value to encode
         * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT32_BYTES}
         * @expose
         */
        ByteBuffer.calculateVarint32 = function(value) {
            // ref: src/google/protobuf/io/coded_stream.cc
            value = value >>> 0;
                 if (value < 1 << 7 ) return 1;
            else if (value < 1 << 14) return 2;
            else if (value < 1 << 21) return 3;
            else if (value < 1 << 28) return 4;
            else                      return 5;
        };

        /**
         * Zigzag encodes a signed 32bit integer so that it can be effectively used with varint encoding.
         * @param {number} n Signed 32bit integer
         * @returns {number} Unsigned zigzag encoded 32bit integer
         * @expose
         */
        ByteBuffer.zigZagEncode32 = function(n) {
            return (((n |= 0) << 1) ^ (n >> 31)) >>> 0; // ref: src/google/protobuf/wire_format_lite.h
        };

        /**
         * Decodes a zigzag encoded signed 32bit integer.
         * @param {number} n Unsigned zigzag encoded 32bit integer
         * @returns {number} Signed 32bit integer
         * @expose
         */
        ByteBuffer.zigZagDecode32 = function(n) {
            return ((n >>> 1) ^ -(n & 1)) | 0; // // ref: src/google/protobuf/wire_format_lite.h
        };

        /**
         * Writes a 32bit base 128 variable-length integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
         * @expose
         */
        ByteBufferPrototype.writeVarint32 = function(value, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var size = ByteBuffer.calculateVarint32(value),
                b;
            offset += size;
            var capacity10 = this.buffer.byteLength;
            if (offset > capacity10)
                this.resize((capacity10 *= 2) > offset ? capacity10 : offset);
            offset -= size;
            value >>>= 0;
            while (value >= 0x80) {
                b = (value & 0x7f) | 0x80;
                this.view[offset++] = b;
                value >>>= 7;
            }
            this.view[offset++] = value;
            if (relative) {
                this.offset = offset;
                return this;
            }
            return size;
        };

        /**
         * Writes a zig-zag encoded (signed) 32bit base 128 variable-length integer.
         * @param {number} value Value to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
         * @expose
         */
        ByteBufferPrototype.writeVarint32ZigZag = function(value, offset) {
            return this.writeVarint32(ByteBuffer.zigZagEncode32(value), offset);
        };

        /**
         * Reads a 32bit base 128 variable-length integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
         *  and the actual number of bytes read.
         * @throws {Error} If it's not a valid varint. Has a property `truncated = true` if there is not enough data available
         *  to fully decode the varint.
         * @expose
         */
        ByteBufferPrototype.readVarint32 = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var c = 0,
                value = 0 >>> 0,
                b;
            do {
                if (!this.noAssert && offset > this.limit) {
                    var err = Error("Truncated");
                    err['truncated'] = true;
                    throw err;
                }
                b = this.view[offset++];
                if (c < 5)
                    value |= (b & 0x7f) << (7*c);
                ++c;
            } while ((b & 0x80) !== 0);
            value |= 0;
            if (relative) {
                this.offset = offset;
                return value;
            }
            return {
                "value": value,
                "length": c
            };
        };

        /**
         * Reads a zig-zag encoded (signed) 32bit base 128 variable-length integer.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
         *  and the actual number of bytes read.
         * @throws {Error} If it's not a valid varint
         * @expose
         */
        ByteBufferPrototype.readVarint32ZigZag = function(offset) {
            var val = this.readVarint32(offset);
            if (typeof val === 'object')
                val["value"] = ByteBuffer.zigZagDecode32(val["value"]);
            else
                val = ByteBuffer.zigZagDecode32(val);
            return val;
        };

        // types/varints/varint64

        if (Long) {

            /**
             * Maximum number of bytes required to store a 64bit base 128 variable-length integer.
             * @type {number}
             * @const
             * @expose
             */
            ByteBuffer.MAX_VARINT64_BYTES = 10;

            /**
             * Calculates the actual number of bytes required to store a 64bit base 128 variable-length integer.
             * @param {number|!Long} value Value to encode
             * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT64_BYTES}
             * @expose
             */
            ByteBuffer.calculateVarint64 = function(value) {
                if (typeof value === 'number')
                    value = Long.fromNumber(value);
                else if (typeof value === 'string')
                    value = Long.fromString(value);
                // ref: src/google/protobuf/io/coded_stream.cc
                var part0 = value.toInt() >>> 0,
                    part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
                    part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
                if (part2 == 0) {
                    if (part1 == 0) {
                        if (part0 < 1 << 14)
                            return part0 < 1 << 7 ? 1 : 2;
                        else
                            return part0 < 1 << 21 ? 3 : 4;
                    } else {
                        if (part1 < 1 << 14)
                            return part1 < 1 << 7 ? 5 : 6;
                        else
                            return part1 < 1 << 21 ? 7 : 8;
                    }
                } else
                    return part2 < 1 << 7 ? 9 : 10;
            };

            /**
             * Zigzag encodes a signed 64bit integer so that it can be effectively used with varint encoding.
             * @param {number|!Long} value Signed long
             * @returns {!Long} Unsigned zigzag encoded long
             * @expose
             */
            ByteBuffer.zigZagEncode64 = function(value) {
                if (typeof value === 'number')
                    value = Long.fromNumber(value, false);
                else if (typeof value === 'string')
                    value = Long.fromString(value, false);
                else if (value.unsigned !== false) value = value.toSigned();
                // ref: src/google/protobuf/wire_format_lite.h
                return value.shiftLeft(1).xor(value.shiftRight(63)).toUnsigned();
            };

            /**
             * Decodes a zigzag encoded signed 64bit integer.
             * @param {!Long|number} value Unsigned zigzag encoded long or JavaScript number
             * @returns {!Long} Signed long
             * @expose
             */
            ByteBuffer.zigZagDecode64 = function(value) {
                if (typeof value === 'number')
                    value = Long.fromNumber(value, false);
                else if (typeof value === 'string')
                    value = Long.fromString(value, false);
                else if (value.unsigned !== false) value = value.toSigned();
                // ref: src/google/protobuf/wire_format_lite.h
                return value.shiftRightUnsigned(1).xor(value.and(Long.ONE).toSigned().negate()).toSigned();
            };

            /**
             * Writes a 64bit base 128 variable-length integer.
             * @param {number|Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  written if omitted.
             * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
             * @expose
             */
            ByteBufferPrototype.writeVarint64 = function(value, offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof value === 'number')
                        value = Long.fromNumber(value);
                    else if (typeof value === 'string')
                        value = Long.fromString(value);
                    else if (!(value && value instanceof Long))
                        throw TypeError("Illegal value: "+value+" (not an integer or Long)");
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 0 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
                }
                if (typeof value === 'number')
                    value = Long.fromNumber(value, false);
                else if (typeof value === 'string')
                    value = Long.fromString(value, false);
                else if (value.unsigned !== false) value = value.toSigned();
                var size = ByteBuffer.calculateVarint64(value),
                    part0 = value.toInt() >>> 0,
                    part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
                    part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
                offset += size;
                var capacity11 = this.buffer.byteLength;
                if (offset > capacity11)
                    this.resize((capacity11 *= 2) > offset ? capacity11 : offset);
                offset -= size;
                switch (size) {
                    case 10: this.view[offset+9] = (part2 >>>  7) & 0x01;
                    case 9 : this.view[offset+8] = size !== 9 ? (part2       ) | 0x80 : (part2       ) & 0x7F;
                    case 8 : this.view[offset+7] = size !== 8 ? (part1 >>> 21) | 0x80 : (part1 >>> 21) & 0x7F;
                    case 7 : this.view[offset+6] = size !== 7 ? (part1 >>> 14) | 0x80 : (part1 >>> 14) & 0x7F;
                    case 6 : this.view[offset+5] = size !== 6 ? (part1 >>>  7) | 0x80 : (part1 >>>  7) & 0x7F;
                    case 5 : this.view[offset+4] = size !== 5 ? (part1       ) | 0x80 : (part1       ) & 0x7F;
                    case 4 : this.view[offset+3] = size !== 4 ? (part0 >>> 21) | 0x80 : (part0 >>> 21) & 0x7F;
                    case 3 : this.view[offset+2] = size !== 3 ? (part0 >>> 14) | 0x80 : (part0 >>> 14) & 0x7F;
                    case 2 : this.view[offset+1] = size !== 2 ? (part0 >>>  7) | 0x80 : (part0 >>>  7) & 0x7F;
                    case 1 : this.view[offset  ] = size !== 1 ? (part0       ) | 0x80 : (part0       ) & 0x7F;
                }
                if (relative) {
                    this.offset += size;
                    return this;
                } else {
                    return size;
                }
            };

            /**
             * Writes a zig-zag encoded 64bit base 128 variable-length integer.
             * @param {number|Long} value Value to write
             * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  written if omitted.
             * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
             * @expose
             */
            ByteBufferPrototype.writeVarint64ZigZag = function(value, offset) {
                return this.writeVarint64(ByteBuffer.zigZagEncode64(value), offset);
            };

            /**
             * Reads a 64bit base 128 variable-length integer. Requires Long.js.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  read if omitted.
             * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
             *  the actual number of bytes read.
             * @throws {Error} If it's not a valid varint
             * @expose
             */
            ByteBufferPrototype.readVarint64 = function(offset) {
                var relative = typeof offset === 'undefined';
                if (relative) offset = this.offset;
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + 1 > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
                }
                // ref: src/google/protobuf/io/coded_stream.cc
                var start = offset,
                    part0 = 0,
                    part1 = 0,
                    part2 = 0,
                    b  = 0;
                b = this.view[offset++]; part0  = (b & 0x7F)      ; if ( b & 0x80                                                   ) {
                b = this.view[offset++]; part0 |= (b & 0x7F) <<  7; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part0 |= (b & 0x7F) << 14; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part0 |= (b & 0x7F) << 21; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part1  = (b & 0x7F)      ; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part1 |= (b & 0x7F) <<  7; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part1 |= (b & 0x7F) << 14; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part1 |= (b & 0x7F) << 21; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part2  = (b & 0x7F)      ; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                b = this.view[offset++]; part2 |= (b & 0x7F) <<  7; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
                throw Error("Buffer overrun"); }}}}}}}}}}
                var value = Long.fromBits(part0 | (part1 << 28), (part1 >>> 4) | (part2) << 24, false);
                if (relative) {
                    this.offset = offset;
                    return value;
                } else {
                    return {
                        'value': value,
                        'length': offset-start
                    };
                }
            };

            /**
             * Reads a zig-zag encoded 64bit base 128 variable-length integer. Requires Long.js.
             * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
             *  read if omitted.
             * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
             *  the actual number of bytes read.
             * @throws {Error} If it's not a valid varint
             * @expose
             */
            ByteBufferPrototype.readVarint64ZigZag = function(offset) {
                var val = this.readVarint64(offset);
                if (val && val['value'] instanceof Long)
                    val["value"] = ByteBuffer.zigZagDecode64(val["value"]);
                else
                    val = ByteBuffer.zigZagDecode64(val);
                return val;
            };

        } // Long


        // types/strings/cstring

        /**
         * Writes a NULL-terminated UTF8 encoded string. For this to work the specified string must not contain any NULL
         *  characters itself.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  contained in `str` + 1 if omitted.
         * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written
         * @expose
         */
        ByteBufferPrototype.writeCString = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            var i,
                k = str.length;
            if (!this.noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                for (i=0; i<k; ++i) {
                    if (str.charCodeAt(i) === 0)
                        throw RangeError("Illegal str: Contains NULL-characters");
                }
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            // UTF8 strings do not contain zero bytes in between except for the zero character, so:
            k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
            offset += k+1;
            var capacity12 = this.buffer.byteLength;
            if (offset > capacity12)
                this.resize((capacity12 *= 2) > offset ? capacity12 : offset);
            offset -= k+1;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view[offset++] = b;
            }.bind(this));
            this.view[offset++] = 0;
            if (relative) {
                this.offset = offset;
                return this;
            }
            return k;
        };

        /**
         * Reads a NULL-terminated UTF8 encoded string. For this to work the string read must not contain any NULL characters
         *  itself.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         */
        ByteBufferPrototype.readCString = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var start = offset;
            // UTF8 strings do not contain zero bytes in between except for the zero character itself, so:
            var sd, b = -1;
            utfx.decodeUTF8toUTF16(function() {
                if (b === 0) return null;
                if (offset >= this.limit)
                    throw RangeError("Illegal range: Truncated data, "+offset+" < "+this.limit);
                b = this.view[offset++];
                return b === 0 ? null : b;
            }.bind(this), sd = stringDestination(), true);
            if (relative) {
                this.offset = offset;
                return sd();
            } else {
                return {
                    "string": sd(),
                    "length": offset - start
                };
            }
        };

        // types/strings/istring

        /**
         * Writes a length as uint32 prefixed UTF8 encoded string.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
         * @expose
         * @see ByteBuffer#writeVarint32
         */
        ByteBufferPrototype.writeIString = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var start = offset,
                k;
            k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
            offset += 4+k;
            var capacity13 = this.buffer.byteLength;
            if (offset > capacity13)
                this.resize((capacity13 *= 2) > offset ? capacity13 : offset);
            offset -= 4+k;
            if (this.littleEndian) {
                this.view[offset+3] = (k >>> 24) & 0xFF;
                this.view[offset+2] = (k >>> 16) & 0xFF;
                this.view[offset+1] = (k >>>  8) & 0xFF;
                this.view[offset  ] =  k         & 0xFF;
            } else {
                this.view[offset  ] = (k >>> 24) & 0xFF;
                this.view[offset+1] = (k >>> 16) & 0xFF;
                this.view[offset+2] = (k >>>  8) & 0xFF;
                this.view[offset+3] =  k         & 0xFF;
            }
            offset += 4;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view[offset++] = b;
            }.bind(this));
            if (offset !== start + 4 + k)
                throw RangeError("Illegal range: Truncated data, "+offset+" == "+(offset+4+k));
            if (relative) {
                this.offset = offset;
                return this;
            }
            return offset - start;
        };

        /**
         * Reads a length as uint32 prefixed UTF8 encoded string.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         * @see ByteBuffer#readVarint32
         */
        ByteBufferPrototype.readIString = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 4 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
            }
            var start = offset;
            var len = this.readUint32(offset);
            var str = this.readUTF8String(len, ByteBuffer.METRICS_BYTES, offset += 4);
            offset += str['length'];
            if (relative) {
                this.offset = offset;
                return str['string'];
            } else {
                return {
                    'string': str['string'],
                    'length': offset - start
                };
            }
        };

        // types/strings/utf8string

        /**
         * Metrics representing number of UTF8 characters. Evaluates to `c`.
         * @type {string}
         * @const
         * @expose
         */
        ByteBuffer.METRICS_CHARS = 'c';

        /**
         * Metrics representing number of bytes. Evaluates to `b`.
         * @type {string}
         * @const
         * @expose
         */
        ByteBuffer.METRICS_BYTES = 'b';

        /**
         * Writes an UTF8 encoded string.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
         * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
         * @expose
         */
        ByteBufferPrototype.writeUTF8String = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var k;
            var start = offset;
            k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
            offset += k;
            var capacity14 = this.buffer.byteLength;
            if (offset > capacity14)
                this.resize((capacity14 *= 2) > offset ? capacity14 : offset);
            offset -= k;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view[offset++] = b;
            }.bind(this));
            if (relative) {
                this.offset = offset;
                return this;
            }
            return offset - start;
        };

        /**
         * Writes an UTF8 encoded string. This is an alias of {@link ByteBuffer#writeUTF8String}.
         * @function
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
         * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
         * @expose
         */
        ByteBufferPrototype.writeString = ByteBufferPrototype.writeUTF8String;

        /**
         * Calculates the number of UTF8 characters of a string. JavaScript itself uses UTF-16, so that a string's
         *  `length` property does not reflect its actual UTF8 size if it contains code points larger than 0xFFFF.
         * @param {string} str String to calculate
         * @returns {number} Number of UTF8 characters
         * @expose
         */
        ByteBuffer.calculateUTF8Chars = function(str) {
            return utfx.calculateUTF16asUTF8(stringSource(str))[0];
        };

        /**
         * Calculates the number of UTF8 bytes of a string.
         * @param {string} str String to calculate
         * @returns {number} Number of UTF8 bytes
         * @expose
         */
        ByteBuffer.calculateUTF8Bytes = function(str) {
            return utfx.calculateUTF16asUTF8(stringSource(str))[1];
        };

        /**
         * Calculates the number of UTF8 bytes of a string. This is an alias of {@link ByteBuffer.calculateUTF8Bytes}.
         * @function
         * @param {string} str String to calculate
         * @returns {number} Number of UTF8 bytes
         * @expose
         */
        ByteBuffer.calculateString = ByteBuffer.calculateUTF8Bytes;

        /**
         * Reads an UTF8 encoded string.
         * @param {number} length Number of characters or bytes to read.
         * @param {string=} metrics Metrics specifying what `length` is meant to count. Defaults to
         *  {@link ByteBuffer.METRICS_CHARS}.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         */
        ByteBufferPrototype.readUTF8String = function(length, metrics, offset) {
            if (typeof metrics === 'number') {
                offset = metrics;
                metrics = undefined;
            }
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (typeof metrics === 'undefined') metrics = ByteBuffer.METRICS_CHARS;
            if (!this.noAssert) {
                if (typeof length !== 'number' || length % 1 !== 0)
                    throw TypeError("Illegal length: "+length+" (not an integer)");
                length |= 0;
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var i = 0,
                start = offset,
                sd;
            if (metrics === ByteBuffer.METRICS_CHARS) { // The same for node and the browser
                sd = stringDestination();
                utfx.decodeUTF8(function() {
                    return i < length && offset < this.limit ? this.view[offset++] : null;
                }.bind(this), function(cp) {
                    ++i; utfx.UTF8toUTF16(cp, sd);
                });
                if (i !== length)
                    throw RangeError("Illegal range: Truncated data, "+i+" == "+length);
                if (relative) {
                    this.offset = offset;
                    return sd();
                } else {
                    return {
                        "string": sd(),
                        "length": offset - start
                    };
                }
            } else if (metrics === ByteBuffer.METRICS_BYTES) {
                if (!this.noAssert) {
                    if (typeof offset !== 'number' || offset % 1 !== 0)
                        throw TypeError("Illegal offset: "+offset+" (not an integer)");
                    offset >>>= 0;
                    if (offset < 0 || offset + length > this.buffer.byteLength)
                        throw RangeError("Illegal offset: 0 <= "+offset+" (+"+length+") <= "+this.buffer.byteLength);
                }
                var k = offset + length;
                utfx.decodeUTF8toUTF16(function() {
                    return offset < k ? this.view[offset++] : null;
                }.bind(this), sd = stringDestination(), this.noAssert);
                if (offset !== k)
                    throw RangeError("Illegal range: Truncated data, "+offset+" == "+k);
                if (relative) {
                    this.offset = offset;
                    return sd();
                } else {
                    return {
                        'string': sd(),
                        'length': offset - start
                    };
                }
            } else
                throw TypeError("Unsupported metrics: "+metrics);
        };

        /**
         * Reads an UTF8 encoded string. This is an alias of {@link ByteBuffer#readUTF8String}.
         * @function
         * @param {number} length Number of characters or bytes to read
         * @param {number=} metrics Metrics specifying what `n` is meant to count. Defaults to
         *  {@link ByteBuffer.METRICS_CHARS}.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         */
        ByteBufferPrototype.readString = ByteBufferPrototype.readUTF8String;

        // types/strings/vstring

        /**
         * Writes a length as varint32 prefixed UTF8 encoded string.
         * @param {string} str String to write
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
         * @expose
         * @see ByteBuffer#writeVarint32
         */
        ByteBufferPrototype.writeVString = function(str, offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            var start = offset,
                k, l;
            k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
            l = ByteBuffer.calculateVarint32(k);
            offset += l+k;
            var capacity15 = this.buffer.byteLength;
            if (offset > capacity15)
                this.resize((capacity15 *= 2) > offset ? capacity15 : offset);
            offset -= l+k;
            offset += this.writeVarint32(k, offset);
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                this.view[offset++] = b;
            }.bind(this));
            if (offset !== start+k+l)
                throw RangeError("Illegal range: Truncated data, "+offset+" == "+(offset+k+l));
            if (relative) {
                this.offset = offset;
                return this;
            }
            return offset - start;
        };

        /**
         * Reads a length as varint32 prefixed UTF8 encoded string.
         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
         *  read and the actual number of bytes read.
         * @expose
         * @see ByteBuffer#readVarint32
         */
        ByteBufferPrototype.readVString = function(offset) {
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 1 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
            }
            var start = offset;
            var len = this.readVarint32(offset);
            var str = this.readUTF8String(len['value'], ByteBuffer.METRICS_BYTES, offset += len['length']);
            offset += str['length'];
            if (relative) {
                this.offset = offset;
                return str['string'];
            } else {
                return {
                    'string': str['string'],
                    'length': offset - start
                };
            }
        };


        /**
         * Appends some data to this ByteBuffer. This will overwrite any contents behind the specified offset up to the appended
         *  data's length.
         * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to append. If `source` is a ByteBuffer, its offsets
         *  will be modified according to the performed read operation.
         * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
         * @param {number=} offset Offset to append at. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @example A relative `<01 02>03.append(<04 05>)` will result in `<01 02 04 05>, 04 05|`
         * @example An absolute `<01 02>03.append(04 05>, 1)` will result in `<01 04>05, 04 05|`
         */
        ByteBufferPrototype.append = function(source, encoding, offset) {
            if (typeof encoding === 'number' || typeof encoding !== 'string') {
                offset = encoding;
                encoding = undefined;
            }
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            if (!(source instanceof ByteBuffer))
                source = ByteBuffer.wrap(source, encoding);
            var length = source.limit - source.offset;
            if (length <= 0) return this; // Nothing to append
            offset += length;
            var capacity16 = this.buffer.byteLength;
            if (offset > capacity16)
                this.resize((capacity16 *= 2) > offset ? capacity16 : offset);
            offset -= length;
            this.view.set(source.view.subarray(source.offset, source.limit), offset);
            source.offset += length;
            if (relative) this.offset += length;
            return this;
        };

        /**
         * Appends this ByteBuffer's contents to another ByteBuffer. This will overwrite any contents at and after the
            specified offset up to the length of this ByteBuffer's data.
         * @param {!ByteBuffer} target Target ByteBuffer
         * @param {number=} offset Offset to append to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  read if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @see ByteBuffer#append
         */
        ByteBufferPrototype.appendTo = function(target, offset) {
            target.append(this, offset);
            return this;
        };

        /**
         * Writes a payload of bytes. This is an alias of {@link ByteBuffer#append}.
         * @function
         * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to write. If `source` is a ByteBuffer, its offsets
         *  will be modified according to the performed read operation.
         * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.writeBytes = ByteBufferPrototype.append;
        /**
         * Enables or disables assertions of argument types and offsets. Assertions are enabled by default but you can opt to
         *  disable them if your code already makes sure that everything is valid.
         * @param {boolean} assert `true` to enable assertions, otherwise `false`
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.assert = function(assert) {
            this.noAssert = !assert;
            return this;
        };

        /**
         * Gets the capacity of this ByteBuffer's backing buffer.
         * @returns {number} Capacity of the backing buffer
         * @expose
         */
        ByteBufferPrototype.capacity = function() {
            return this.buffer.byteLength;
        };
        /**
         * Clears this ByteBuffer's offsets by setting {@link ByteBuffer#offset} to `0` and {@link ByteBuffer#limit} to the
         *  backing buffer's capacity. Discards {@link ByteBuffer#markedOffset}.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.clear = function() {
            this.offset = 0;
            this.limit = this.buffer.byteLength;
            this.markedOffset = -1;
            return this;
        };

        /**
         * Creates a cloned instance of this ByteBuffer, preset with this ByteBuffer's values for {@link ByteBuffer#offset},
         *  {@link ByteBuffer#markedOffset} and {@link ByteBuffer#limit}.
         * @param {boolean=} copy Whether to copy the backing buffer or to return another view on the same, defaults to `false`
         * @returns {!ByteBuffer} Cloned instance
         * @expose
         */
        ByteBufferPrototype.clone = function(copy) {
            var bb = new ByteBuffer(0, this.littleEndian, this.noAssert);
            if (copy) {
                bb.buffer = new ArrayBuffer(this.buffer.byteLength);
                bb.view = new Uint8Array(bb.buffer);
            } else {
                bb.buffer = this.buffer;
                bb.view = this.view;
            }
            bb.offset = this.offset;
            bb.markedOffset = this.markedOffset;
            bb.limit = this.limit;
            return bb;
        };

        /**
         * Compacts this ByteBuffer to be backed by a {@link ByteBuffer#buffer} of its contents' length. Contents are the bytes
         *  between {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. Will set `offset = 0` and `limit = capacity` and
         *  adapt {@link ByteBuffer#markedOffset} to the same relative position if set.
         * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.compact = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === 0 && end === this.buffer.byteLength)
                return this; // Already compacted
            var len = end - begin;
            if (len === 0) {
                this.buffer = EMPTY_BUFFER;
                this.view = null;
                if (this.markedOffset >= 0) this.markedOffset -= begin;
                this.offset = 0;
                this.limit = 0;
                return this;
            }
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            view.set(this.view.subarray(begin, end));
            this.buffer = buffer;
            this.view = view;
            if (this.markedOffset >= 0) this.markedOffset -= begin;
            this.offset = 0;
            this.limit = len;
            return this;
        };

        /**
         * Creates a copy of this ByteBuffer's contents. Contents are the bytes between {@link ByteBuffer#offset} and
         *  {@link ByteBuffer#limit}.
         * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
         * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
         * @returns {!ByteBuffer} Copy
         * @expose
         */
        ByteBufferPrototype.copy = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === end)
                return new ByteBuffer(0, this.littleEndian, this.noAssert);
            var capacity = end - begin,
                bb = new ByteBuffer(capacity, this.littleEndian, this.noAssert);
            bb.offset = 0;
            bb.limit = capacity;
            if (bb.markedOffset >= 0) bb.markedOffset -= begin;
            this.copyTo(bb, 0, begin, end);
            return bb;
        };

        /**
         * Copies this ByteBuffer's contents to another ByteBuffer. Contents are the bytes between {@link ByteBuffer#offset} and
         *  {@link ByteBuffer#limit}.
         * @param {!ByteBuffer} target Target ByteBuffer
         * @param {number=} targetOffset Offset to copy to. Will use and increase the target's {@link ByteBuffer#offset}
         *  by the number of bytes copied if omitted.
         * @param {number=} sourceOffset Offset to start copying from. Will use and increase {@link ByteBuffer#offset} by the
         *  number of bytes copied if omitted.
         * @param {number=} sourceLimit Offset to end copying from, defaults to {@link ByteBuffer#limit}
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.copyTo = function(target, targetOffset, sourceOffset, sourceLimit) {
            var relative,
                targetRelative;
            if (!this.noAssert) {
                if (!ByteBuffer.isByteBuffer(target))
                    throw TypeError("Illegal target: Not a ByteBuffer");
            }
            targetOffset = (targetRelative = typeof targetOffset === 'undefined') ? target.offset : targetOffset | 0;
            sourceOffset = (relative = typeof sourceOffset === 'undefined') ? this.offset : sourceOffset | 0;
            sourceLimit = typeof sourceLimit === 'undefined' ? this.limit : sourceLimit | 0;

            if (targetOffset < 0 || targetOffset > target.buffer.byteLength)
                throw RangeError("Illegal target range: 0 <= "+targetOffset+" <= "+target.buffer.byteLength);
            if (sourceOffset < 0 || sourceLimit > this.buffer.byteLength)
                throw RangeError("Illegal source range: 0 <= "+sourceOffset+" <= "+this.buffer.byteLength);

            var len = sourceLimit - sourceOffset;
            if (len === 0)
                return target; // Nothing to copy

            target.ensureCapacity(targetOffset + len);

            target.view.set(this.view.subarray(sourceOffset, sourceLimit), targetOffset);

            if (relative) this.offset += len;
            if (targetRelative) target.offset += len;

            return this;
        };

        /**
         * Makes sure that this ByteBuffer is backed by a {@link ByteBuffer#buffer} of at least the specified capacity. If the
         *  current capacity is exceeded, it will be doubled. If double the current capacity is less than the required capacity,
         *  the required capacity will be used instead.
         * @param {number} capacity Required capacity
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.ensureCapacity = function(capacity) {
            var current = this.buffer.byteLength;
            if (current < capacity)
                return this.resize((current *= 2) > capacity ? current : capacity);
            return this;
        };

        /**
         * Overwrites this ByteBuffer's contents with the specified value. Contents are the bytes between
         *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
         * @param {number|string} value Byte value to fill with. If given as a string, the first character is used.
         * @param {number=} begin Begin offset. Will use and increase {@link ByteBuffer#offset} by the number of bytes
         *  written if omitted. defaults to {@link ByteBuffer#offset}.
         * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
         * @returns {!ByteBuffer} this
         * @expose
         * @example `someByteBuffer.clear().fill(0)` fills the entire backing buffer with zeroes
         */
        ByteBufferPrototype.fill = function(value, begin, end) {
            var relative = typeof begin === 'undefined';
            if (relative) begin = this.offset;
            if (typeof value === 'string' && value.length > 0)
                value = value.charCodeAt(0);
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof value !== 'number' || value % 1 !== 0)
                    throw TypeError("Illegal value: "+value+" (not an integer)");
                value |= 0;
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin >= end)
                return this; // Nothing to fill
            while (begin < end) this.view[begin++] = value;
            if (relative) this.offset = begin;
            return this;
        };

        /**
         * Makes this ByteBuffer ready for a new sequence of write or relative read operations. Sets `limit = offset` and
         *  `offset = 0`. Make sure always to flip a ByteBuffer when all relative read or write operations are complete.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.flip = function() {
            this.limit = this.offset;
            this.offset = 0;
            return this;
        };
        /**
         * Marks an offset on this ByteBuffer to be used later.
         * @param {number=} offset Offset to mark. Defaults to {@link ByteBuffer#offset}.
         * @returns {!ByteBuffer} this
         * @throws {TypeError} If `offset` is not a valid number
         * @throws {RangeError} If `offset` is out of bounds
         * @see ByteBuffer#reset
         * @expose
         */
        ByteBufferPrototype.mark = function(offset) {
            offset = typeof offset === 'undefined' ? this.offset : offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            this.markedOffset = offset;
            return this;
        };
        /**
         * Sets the byte order.
         * @param {boolean} littleEndian `true` for little endian byte order, `false` for big endian
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.order = function(littleEndian) {
            if (!this.noAssert) {
                if (typeof littleEndian !== 'boolean')
                    throw TypeError("Illegal littleEndian: Not a boolean");
            }
            this.littleEndian = !!littleEndian;
            return this;
        };

        /**
         * Switches (to) little endian byte order.
         * @param {boolean=} littleEndian Defaults to `true`, otherwise uses big endian
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.LE = function(littleEndian) {
            this.littleEndian = typeof littleEndian !== 'undefined' ? !!littleEndian : true;
            return this;
        };

        /**
         * Switches (to) big endian byte order.
         * @param {boolean=} bigEndian Defaults to `true`, otherwise uses little endian
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.BE = function(bigEndian) {
            this.littleEndian = typeof bigEndian !== 'undefined' ? !bigEndian : false;
            return this;
        };
        /**
         * Prepends some data to this ByteBuffer. This will overwrite any contents before the specified offset up to the
         *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
         *  will be resized and its contents moved accordingly.
         * @param {!ByteBuffer|string|!ArrayBuffer} source Data to prepend. If `source` is a ByteBuffer, its offset will be
         *  modified according to the performed read operation.
         * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
         * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
         *  prepended if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @example A relative `00<01 02 03>.prepend(<04 05>)` results in `<04 05 01 02 03>, 04 05|`
         * @example An absolute `00<01 02 03>.prepend(<04 05>, 2)` results in `04<05 02 03>, 04 05|`
         */
        ByteBufferPrototype.prepend = function(source, encoding, offset) {
            if (typeof encoding === 'number' || typeof encoding !== 'string') {
                offset = encoding;
                encoding = undefined;
            }
            var relative = typeof offset === 'undefined';
            if (relative) offset = this.offset;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
                offset >>>= 0;
                if (offset < 0 || offset + 0 > this.buffer.byteLength)
                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
            }
            if (!(source instanceof ByteBuffer))
                source = ByteBuffer.wrap(source, encoding);
            var len = source.limit - source.offset;
            if (len <= 0) return this; // Nothing to prepend
            var diff = len - offset;
            if (diff > 0) { // Not enough space before offset, so resize + move
                var buffer = new ArrayBuffer(this.buffer.byteLength + diff);
                var view = new Uint8Array(buffer);
                view.set(this.view.subarray(offset, this.buffer.byteLength), len);
                this.buffer = buffer;
                this.view = view;
                this.offset += diff;
                if (this.markedOffset >= 0) this.markedOffset += diff;
                this.limit += diff;
                offset += diff;
            } else {
                var arrayView = new Uint8Array(this.buffer);
            }
            this.view.set(source.view.subarray(source.offset, source.limit), offset - len);

            source.offset = source.limit;
            if (relative)
                this.offset -= len;
            return this;
        };

        /**
         * Prepends this ByteBuffer to another ByteBuffer. This will overwrite any contents before the specified offset up to the
         *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
         *  will be resized and its contents moved accordingly.
         * @param {!ByteBuffer} target Target ByteBuffer
         * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
         *  prepended if omitted.
         * @returns {!ByteBuffer} this
         * @expose
         * @see ByteBuffer#prepend
         */
        ByteBufferPrototype.prependTo = function(target, offset) {
            target.prepend(this, offset);
            return this;
        };
        /**
         * Prints debug information about this ByteBuffer's contents.
         * @param {function(string)=} out Output function to call, defaults to console.log
         * @expose
         */
        ByteBufferPrototype.printDebug = function(out) {
            if (typeof out !== 'function') out = console.log.bind(console);
            out(
                this.toString()+"\n"+
                "-------------------------------------------------------------------\n"+
                this.toDebug(/* columns */ true)
            );
        };

        /**
         * Gets the number of remaining readable bytes. Contents are the bytes between {@link ByteBuffer#offset} and
         *  {@link ByteBuffer#limit}, so this returns `limit - offset`.
         * @returns {number} Remaining readable bytes. May be negative if `offset > limit`.
         * @expose
         */
        ByteBufferPrototype.remaining = function() {
            return this.limit - this.offset;
        };
        /**
         * Resets this ByteBuffer's {@link ByteBuffer#offset}. If an offset has been marked through {@link ByteBuffer#mark}
         *  before, `offset` will be set to {@link ByteBuffer#markedOffset}, which will then be discarded. If no offset has been
         *  marked, sets `offset = 0`.
         * @returns {!ByteBuffer} this
         * @see ByteBuffer#mark
         * @expose
         */
        ByteBufferPrototype.reset = function() {
            if (this.markedOffset >= 0) {
                this.offset = this.markedOffset;
                this.markedOffset = -1;
            } else {
                this.offset = 0;
            }
            return this;
        };
        /**
         * Resizes this ByteBuffer to be backed by a buffer of at least the given capacity. Will do nothing if already that
         *  large or larger.
         * @param {number} capacity Capacity required
         * @returns {!ByteBuffer} this
         * @throws {TypeError} If `capacity` is not a number
         * @throws {RangeError} If `capacity < 0`
         * @expose
         */
        ByteBufferPrototype.resize = function(capacity) {
            if (!this.noAssert) {
                if (typeof capacity !== 'number' || capacity % 1 !== 0)
                    throw TypeError("Illegal capacity: "+capacity+" (not an integer)");
                capacity |= 0;
                if (capacity < 0)
                    throw RangeError("Illegal capacity: 0 <= "+capacity);
            }
            if (this.buffer.byteLength < capacity) {
                var buffer = new ArrayBuffer(capacity);
                var view = new Uint8Array(buffer);
                view.set(this.view);
                this.buffer = buffer;
                this.view = view;
            }
            return this;
        };
        /**
         * Reverses this ByteBuffer's contents.
         * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.reverse = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            if (begin === end)
                return this; // Nothing to reverse
            Array.prototype.reverse.call(this.view.subarray(begin, end));
            return this;
        };
        /**
         * Skips the next `length` bytes. This will just advance
         * @param {number} length Number of bytes to skip. May also be negative to move the offset back.
         * @returns {!ByteBuffer} this
         * @expose
         */
        ByteBufferPrototype.skip = function(length) {
            if (!this.noAssert) {
                if (typeof length !== 'number' || length % 1 !== 0)
                    throw TypeError("Illegal length: "+length+" (not an integer)");
                length |= 0;
            }
            var offset = this.offset + length;
            if (!this.noAssert) {
                if (offset < 0 || offset > this.buffer.byteLength)
                    throw RangeError("Illegal length: 0 <= "+this.offset+" + "+length+" <= "+this.buffer.byteLength);
            }
            this.offset = offset;
            return this;
        };

        /**
         * Slices this ByteBuffer by creating a cloned instance with `offset = begin` and `limit = end`.
         * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
         * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
         * @returns {!ByteBuffer} Clone of this ByteBuffer with slicing applied, backed by the same {@link ByteBuffer#buffer}
         * @expose
         */
        ByteBufferPrototype.slice = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var bb = this.clone();
            bb.offset = begin;
            bb.limit = end;
            return bb;
        };
        /**
         * Returns a copy of the backing buffer that contains this ByteBuffer's contents. Contents are the bytes between
         *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
         * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory if
         *  possible. Defaults to `false`
         * @returns {!ArrayBuffer} Contents as an ArrayBuffer
         * @expose
         */
        ByteBufferPrototype.toBuffer = function(forceCopy) {
            var offset = this.offset,
                limit = this.limit;
            if (!this.noAssert) {
                if (typeof offset !== 'number' || offset % 1 !== 0)
                    throw TypeError("Illegal offset: Not an integer");
                offset >>>= 0;
                if (typeof limit !== 'number' || limit % 1 !== 0)
                    throw TypeError("Illegal limit: Not an integer");
                limit >>>= 0;
                if (offset < 0 || offset > limit || limit > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+offset+" <= "+limit+" <= "+this.buffer.byteLength);
            }
            // NOTE: It's not possible to have another ArrayBuffer reference the same memory as the backing buffer. This is
            // possible with Uint8Array#subarray only, but we have to return an ArrayBuffer by contract. So:
            if (!forceCopy && offset === 0 && limit === this.buffer.byteLength)
                return this.buffer;
            if (offset === limit)
                return EMPTY_BUFFER;
            var buffer = new ArrayBuffer(limit - offset);
            new Uint8Array(buffer).set(new Uint8Array(this.buffer).subarray(offset, limit), 0);
            return buffer;
        };

        /**
         * Returns a raw buffer compacted to contain this ByteBuffer's contents. Contents are the bytes between
         *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. This is an alias of {@link ByteBuffer#toBuffer}.
         * @function
         * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory.
         *  Defaults to `false`
         * @returns {!ArrayBuffer} Contents as an ArrayBuffer
         * @expose
         */
        ByteBufferPrototype.toArrayBuffer = ByteBufferPrototype.toBuffer;

        /**
         * Converts the ByteBuffer's contents to a string.
         * @param {string=} encoding Output encoding. Returns an informative string representation if omitted but also allows
         *  direct conversion to "utf8", "hex", "base64" and "binary" encoding. "debug" returns a hex representation with
         *  highlighted offsets.
         * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
         * @returns {string} String representation
         * @throws {Error} If `encoding` is invalid
         * @expose
         */
        ByteBufferPrototype.toString = function(encoding, begin, end) {
            if (typeof encoding === 'undefined')
                return "ByteBufferAB(offset="+this.offset+",markedOffset="+this.markedOffset+",limit="+this.limit+",capacity="+this.capacity()+")";
            if (typeof encoding === 'number')
                encoding = "utf8",
                begin = encoding,
                end = begin;
            switch (encoding) {
                case "utf8":
                    return this.toUTF8(begin, end);
                case "base64":
                    return this.toBase64(begin, end);
                case "hex":
                    return this.toHex(begin, end);
                case "binary":
                    return this.toBinary(begin, end);
                case "debug":
                    return this.toDebug();
                case "columns":
                    return this.toColumns();
                default:
                    throw Error("Unsupported encoding: "+encoding);
            }
        };

        // lxiv-embeddable

        /**
         * lxiv-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
         * Released under the Apache License, Version 2.0
         * see: https://github.com/dcodeIO/lxiv for details
         */
        var lxiv = function() {

            /**
             * lxiv namespace.
             * @type {!Object.<string,*>}
             * @exports lxiv
             */
            var lxiv = {};

            /**
             * Character codes for output.
             * @type {!Array.<number>}
             * @inner
             */
            var aout = [
                65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
                81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102,
                103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
                119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47
            ];

            /**
             * Character codes for input.
             * @type {!Array.<number>}
             * @inner
             */
            var ain = [];
            for (var i=0, k=aout.length; i<k; ++i)
                ain[aout[i]] = i;

            /**
             * Encodes bytes to base64 char codes.
             * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if
             *  there are no more bytes left.
             * @param {!function(number)} dst Characters destination as a function successively called with each encoded char
             *  code.
             */
            lxiv.encode = function(src, dst) {
                var b, t;
                while ((b = src()) !== null) {
                    dst(aout[(b>>2)&0x3f]);
                    t = (b&0x3)<<4;
                    if ((b = src()) !== null) {
                        t |= (b>>4)&0xf;
                        dst(aout[(t|((b>>4)&0xf))&0x3f]);
                        t = (b&0xf)<<2;
                        if ((b = src()) !== null)
                            dst(aout[(t|((b>>6)&0x3))&0x3f]),
                            dst(aout[b&0x3f]);
                        else
                            dst(aout[t&0x3f]),
                            dst(61);
                    } else
                        dst(aout[t&0x3f]),
                        dst(61),
                        dst(61);
                }
            };

            /**
             * Decodes base64 char codes to bytes.
             * @param {!function():number|null} src Characters source as a function returning the next char code respectively
             *  `null` if there are no more characters left.
             * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
             * @throws {Error} If a character code is invalid
             */
            lxiv.decode = function(src, dst) {
                var c, t1, t2;
                function fail(c) {
                    throw Error("Illegal character code: "+c);
                }
                while ((c = src()) !== null) {
                    t1 = ain[c];
                    if (typeof t1 === 'undefined') fail(c);
                    if ((c = src()) !== null) {
                        t2 = ain[c];
                        if (typeof t2 === 'undefined') fail(c);
                        dst((t1<<2)>>>0|(t2&0x30)>>4);
                        if ((c = src()) !== null) {
                            t1 = ain[c];
                            if (typeof t1 === 'undefined')
                                if (c === 61) break; else fail(c);
                            dst(((t2&0xf)<<4)>>>0|(t1&0x3c)>>2);
                            if ((c = src()) !== null) {
                                t2 = ain[c];
                                if (typeof t2 === 'undefined')
                                    if (c === 61) break; else fail(c);
                                dst(((t1&0x3)<<6)>>>0|t2);
                            }
                        }
                    }
                }
            };

            /**
             * Tests if a string is valid base64.
             * @param {string} str String to test
             * @returns {boolean} `true` if valid, otherwise `false`
             */
            lxiv.test = function(str) {
                return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(str);
            };

            return lxiv;
        }();

        // encodings/base64

        /**
         * Encodes this ByteBuffer's contents to a base64 encoded string.
         * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}.
         * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}.
         * @returns {string} Base64 encoded string
         * @throws {RangeError} If `begin` or `end` is out of bounds
         * @expose
         */
        ByteBufferPrototype.toBase64 = function(begin, end) {
            if (typeof begin === 'undefined')
                begin = this.offset;
            if (typeof end === 'undefined')
                end = this.limit;
            begin = begin | 0; end = end | 0;
            if (begin < 0 || end > this.capacity || begin > end)
                throw RangeError("begin, end");
            var sd; lxiv.encode(function() {
                return begin < end ? this.view[begin++] : null;
            }.bind(this), sd = stringDestination());
            return sd();
        };

        /**
         * Decodes a base64 encoded string to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromBase64 = function(str, littleEndian) {
            if (typeof str !== 'string')
                throw TypeError("str");
            var bb = new ByteBuffer(str.length/4*3, littleEndian),
                i = 0;
            lxiv.decode(stringSource(str), function(b) {
                bb.view[i++] = b;
            });
            bb.limit = i;
            return bb;
        };

        /**
         * Encodes a binary string to base64 like `window.btoa` does.
         * @param {string} str Binary string
         * @returns {string} Base64 encoded string
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.btoa
         * @expose
         */
        ByteBuffer.btoa = function(str) {
            return ByteBuffer.fromBinary(str).toBase64();
        };

        /**
         * Decodes a base64 encoded string to binary like `window.atob` does.
         * @param {string} b64 Base64 encoded string
         * @returns {string} Binary string
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.atob
         * @expose
         */
        ByteBuffer.atob = function(b64) {
            return ByteBuffer.fromBase64(b64).toBinary();
        };

        // encodings/binary

        /**
         * Encodes this ByteBuffer to a binary encoded string, that is using only characters 0x00-0xFF as bytes.
         * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
         * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
         * @returns {string} Binary encoded string
         * @throws {RangeError} If `offset > limit`
         * @expose
         */
        ByteBufferPrototype.toBinary = function(begin, end) {
            if (typeof begin === 'undefined')
                begin = this.offset;
            if (typeof end === 'undefined')
                end = this.limit;
            begin |= 0; end |= 0;
            if (begin < 0 || end > this.capacity() || begin > end)
                throw RangeError("begin, end");
            if (begin === end)
                return "";
            var chars = [],
                parts = [];
            while (begin < end) {
                chars.push(this.view[begin++]);
                if (chars.length >= 1024)
                    parts.push(String.fromCharCode.apply(String, chars)),
                    chars = [];
            }
            return parts.join('') + String.fromCharCode.apply(String, chars);
        };

        /**
         * Decodes a binary encoded string, that is using only characters 0x00-0xFF as bytes, to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromBinary = function(str, littleEndian) {
            if (typeof str !== 'string')
                throw TypeError("str");
            var i = 0,
                k = str.length,
                charCode,
                bb = new ByteBuffer(k, littleEndian);
            while (i<k) {
                charCode = str.charCodeAt(i);
                if (charCode > 0xff)
                    throw RangeError("illegal char code: "+charCode);
                bb.view[i++] = charCode;
            }
            bb.limit = k;
            return bb;
        };

        // encodings/debug

        /**
         * Encodes this ByteBuffer to a hex encoded string with marked offsets. Offset symbols are:
         * * `<` : offset,
         * * `'` : markedOffset,
         * * `>` : limit,
         * * `|` : offset and limit,
         * * `[` : offset and markedOffset,
         * * `]` : markedOffset and limit,
         * * `!` : offset, markedOffset and limit
         * @param {boolean=} columns If `true` returns two columns hex + ascii, defaults to `false`
         * @returns {string|!Array.<string>} Debug string or array of lines if `asArray = true`
         * @expose
         * @example `>00'01 02<03` contains four bytes with `limit=0, markedOffset=1, offset=3`
         * @example `00[01 02 03>` contains four bytes with `offset=markedOffset=1, limit=4`
         * @example `00|01 02 03` contains four bytes with `offset=limit=1, markedOffset=-1`
         * @example `|` contains zero bytes with `offset=limit=0, markedOffset=-1`
         */
        ByteBufferPrototype.toDebug = function(columns) {
            var i = -1,
                k = this.buffer.byteLength,
                b,
                hex = "",
                asc = "",
                out = "";
            while (i<k) {
                if (i !== -1) {
                    b = this.view[i];
                    if (b < 0x10) hex += "0"+b.toString(16).toUpperCase();
                    else hex += b.toString(16).toUpperCase();
                    if (columns)
                        asc += b > 32 && b < 127 ? String.fromCharCode(b) : '.';
                }
                ++i;
                if (columns) {
                    if (i > 0 && i % 16 === 0 && i !== k) {
                        while (hex.length < 3*16+3) hex += " ";
                        out += hex+asc+"\n";
                        hex = asc = "";
                    }
                }
                if (i === this.offset && i === this.limit)
                    hex += i === this.markedOffset ? "!" : "|";
                else if (i === this.offset)
                    hex += i === this.markedOffset ? "[" : "<";
                else if (i === this.limit)
                    hex += i === this.markedOffset ? "]" : ">";
                else
                    hex += i === this.markedOffset ? "'" : (columns || (i !== 0 && i !== k) ? " " : "");
            }
            if (columns && hex !== " ") {
                while (hex.length < 3*16+3)
                    hex += " ";
                out += hex + asc + "\n";
            }
            return columns ? out : hex;
        };

        /**
         * Decodes a hex encoded string with marked offsets to a ByteBuffer.
         * @param {string} str Debug string to decode (not be generated with `columns = true`)
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         * @see ByteBuffer#toDebug
         */
        ByteBuffer.fromDebug = function(str, littleEndian, noAssert) {
            var k = str.length,
                bb = new ByteBuffer(((k+1)/3)|0, littleEndian, noAssert);
            var i = 0, j = 0, ch, b,
                rs = false, // Require symbol next
                ho = false, hm = false, hl = false, // Already has offset (ho), markedOffset (hm), limit (hl)?
                fail = false;
            while (i<k) {
                switch (ch = str.charAt(i++)) {
                    case '!':
                        if (!noAssert) {
                            if (ho || hm || hl) {
                                fail = true;
                                break;
                            }
                            ho = hm = hl = true;
                        }
                        bb.offset = bb.markedOffset = bb.limit = j;
                        rs = false;
                        break;
                    case '|':
                        if (!noAssert) {
                            if (ho || hl) {
                                fail = true;
                                break;
                            }
                            ho = hl = true;
                        }
                        bb.offset = bb.limit = j;
                        rs = false;
                        break;
                    case '[':
                        if (!noAssert) {
                            if (ho || hm) {
                                fail = true;
                                break;
                            }
                            ho = hm = true;
                        }
                        bb.offset = bb.markedOffset = j;
                        rs = false;
                        break;
                    case '<':
                        if (!noAssert) {
                            if (ho) {
                                fail = true;
                                break;
                            }
                            ho = true;
                        }
                        bb.offset = j;
                        rs = false;
                        break;
                    case ']':
                        if (!noAssert) {
                            if (hl || hm) {
                                fail = true;
                                break;
                            }
                            hl = hm = true;
                        }
                        bb.limit = bb.markedOffset = j;
                        rs = false;
                        break;
                    case '>':
                        if (!noAssert) {
                            if (hl) {
                                fail = true;
                                break;
                            }
                            hl = true;
                        }
                        bb.limit = j;
                        rs = false;
                        break;
                    case "'":
                        if (!noAssert) {
                            if (hm) {
                                fail = true;
                                break;
                            }
                            hm = true;
                        }
                        bb.markedOffset = j;
                        rs = false;
                        break;
                    case ' ':
                        rs = false;
                        break;
                    default:
                        if (!noAssert) {
                            if (rs) {
                                fail = true;
                                break;
                            }
                        }
                        b = parseInt(ch+str.charAt(i++), 16);
                        if (!noAssert) {
                            if (isNaN(b) || b < 0 || b > 255)
                                throw TypeError("Illegal str: Not a debug encoded string");
                        }
                        bb.view[j++] = b;
                        rs = true;
                }
                if (fail)
                    throw TypeError("Illegal str: Invalid symbol at "+i);
            }
            if (!noAssert) {
                if (!ho || !hl)
                    throw TypeError("Illegal str: Missing offset or limit");
                if (j<bb.buffer.byteLength)
                    throw TypeError("Illegal str: Not a debug encoded string (is it hex?) "+j+" < "+k);
            }
            return bb;
        };

        // encodings/hex

        /**
         * Encodes this ByteBuffer's contents to a hex encoded string.
         * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
         * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
         * @returns {string} Hex encoded string
         * @expose
         */
        ByteBufferPrototype.toHex = function(begin, end) {
            begin = typeof begin === 'undefined' ? this.offset : begin;
            end = typeof end === 'undefined' ? this.limit : end;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var out = new Array(end - begin),
                b;
            while (begin < end) {
                b = this.view[begin++];
                if (b < 0x10)
                    out.push("0", b.toString(16));
                else out.push(b.toString(16));
            }
            return out.join('');
        };

        /**
         * Decodes a hex encoded string to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromHex = function(str, littleEndian, noAssert) {
            if (!noAssert) {
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
                if (str.length % 2 !== 0)
                    throw TypeError("Illegal str: Length not a multiple of 2");
            }
            var k = str.length,
                bb = new ByteBuffer((k / 2) | 0, littleEndian),
                b;
            for (var i=0, j=0; i<k; i+=2) {
                b = parseInt(str.substring(i, i+2), 16);
                if (!noAssert)
                    if (!isFinite(b) || b < 0 || b > 255)
                        throw TypeError("Illegal str: Contains non-hex characters");
                bb.view[j++] = b;
            }
            bb.limit = j;
            return bb;
        };

        // utfx-embeddable

        /**
         * utfx-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
         * Released under the Apache License, Version 2.0
         * see: https://github.com/dcodeIO/utfx for details
         */
        var utfx = function() {

            /**
             * utfx namespace.
             * @inner
             * @type {!Object.<string,*>}
             */
            var utfx = {};

            /**
             * Maximum valid code point.
             * @type {number}
             * @const
             */
            utfx.MAX_CODEPOINT = 0x10FFFF;

            /**
             * Encodes UTF8 code points to UTF8 bytes.
             * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
             *  respectively `null` if there are no more code points left or a single numeric code point.
             * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
             */
            utfx.encodeUTF8 = function(src, dst) {
                var cp = null;
                if (typeof src === 'number')
                    cp = src,
                    src = function() { return null; };
                while (cp !== null || (cp = src()) !== null) {
                    if (cp < 0x80)
                        dst(cp&0x7F);
                    else if (cp < 0x800)
                        dst(((cp>>6)&0x1F)|0xC0),
                        dst((cp&0x3F)|0x80);
                    else if (cp < 0x10000)
                        dst(((cp>>12)&0x0F)|0xE0),
                        dst(((cp>>6)&0x3F)|0x80),
                        dst((cp&0x3F)|0x80);
                    else
                        dst(((cp>>18)&0x07)|0xF0),
                        dst(((cp>>12)&0x3F)|0x80),
                        dst(((cp>>6)&0x3F)|0x80),
                        dst((cp&0x3F)|0x80);
                    cp = null;
                }
            };

            /**
             * Decodes UTF8 bytes to UTF8 code points.
             * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
             *  are no more bytes left.
             * @param {!function(number)} dst Code points destination as a function successively called with each decoded code point.
             * @throws {RangeError} If a starting byte is invalid in UTF8
             * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the
             *  remaining bytes.
             */
            utfx.decodeUTF8 = function(src, dst) {
                var a, b, c, d, fail = function(b) {
                    b = b.slice(0, b.indexOf(null));
                    var err = Error(b.toString());
                    err.name = "TruncatedError";
                    err['bytes'] = b;
                    throw err;
                };
                while ((a = src()) !== null) {
                    if ((a&0x80) === 0)
                        dst(a);
                    else if ((a&0xE0) === 0xC0)
                        ((b = src()) === null) && fail([a, b]),
                        dst(((a&0x1F)<<6) | (b&0x3F));
                    else if ((a&0xF0) === 0xE0)
                        ((b=src()) === null || (c=src()) === null) && fail([a, b, c]),
                        dst(((a&0x0F)<<12) | ((b&0x3F)<<6) | (c&0x3F));
                    else if ((a&0xF8) === 0xF0)
                        ((b=src()) === null || (c=src()) === null || (d=src()) === null) && fail([a, b, c ,d]),
                        dst(((a&0x07)<<18) | ((b&0x3F)<<12) | ((c&0x3F)<<6) | (d&0x3F));
                    else throw RangeError("Illegal starting byte: "+a);
                }
            };

            /**
             * Converts UTF16 characters to UTF8 code points.
             * @param {!function():number|null} src Characters source as a function returning the next char code respectively
             *  `null` if there are no more characters left.
             * @param {!function(number)} dst Code points destination as a function successively called with each converted code
             *  point.
             */
            utfx.UTF16toUTF8 = function(src, dst) {
                var c1, c2 = null;
                while (true) {
                    if ((c1 = c2 !== null ? c2 : src()) === null)
                        break;
                    if (c1 >= 0xD800 && c1 <= 0xDFFF) {
                        if ((c2 = src()) !== null) {
                            if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
                                dst((c1-0xD800)*0x400+c2-0xDC00+0x10000);
                                c2 = null; continue;
                            }
                        }
                    }
                    dst(c1);
                }
                if (c2 !== null) dst(c2);
            };

            /**
             * Converts UTF8 code points to UTF16 characters.
             * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
             *  respectively `null` if there are no more code points left or a single numeric code point.
             * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
             * @throws {RangeError} If a code point is out of range
             */
            utfx.UTF8toUTF16 = function(src, dst) {
                var cp = null;
                if (typeof src === 'number')
                    cp = src, src = function() { return null; };
                while (cp !== null || (cp = src()) !== null) {
                    if (cp <= 0xFFFF)
                        dst(cp);
                    else
                        cp -= 0x10000,
                        dst((cp>>10)+0xD800),
                        dst((cp%0x400)+0xDC00);
                    cp = null;
                }
            };

            /**
             * Converts and encodes UTF16 characters to UTF8 bytes.
             * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
             *  if there are no more characters left.
             * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
             */
            utfx.encodeUTF16toUTF8 = function(src, dst) {
                utfx.UTF16toUTF8(src, function(cp) {
                    utfx.encodeUTF8(cp, dst);
                });
            };

            /**
             * Decodes and converts UTF8 bytes to UTF16 characters.
             * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
             *  are no more bytes left.
             * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
             * @throws {RangeError} If a starting byte is invalid in UTF8
             * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the remaining bytes.
             */
            utfx.decodeUTF8toUTF16 = function(src, dst) {
                utfx.decodeUTF8(src, function(cp) {
                    utfx.UTF8toUTF16(cp, dst);
                });
            };

            /**
             * Calculates the byte length of an UTF8 code point.
             * @param {number} cp UTF8 code point
             * @returns {number} Byte length
             */
            utfx.calculateCodePoint = function(cp) {
                return (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
            };

            /**
             * Calculates the number of UTF8 bytes required to store UTF8 code points.
             * @param {(!function():number|null)} src Code points source as a function returning the next code point respectively
             *  `null` if there are no more code points left.
             * @returns {number} The number of UTF8 bytes required
             */
            utfx.calculateUTF8 = function(src) {
                var cp, l=0;
                while ((cp = src()) !== null)
                    l += (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
                return l;
            };

            /**
             * Calculates the number of UTF8 code points respectively UTF8 bytes required to store UTF16 char codes.
             * @param {(!function():number|null)} src Characters source as a function returning the next char code respectively
             *  `null` if there are no more characters left.
             * @returns {!Array.<number>} The number of UTF8 code points at index 0 and the number of UTF8 bytes required at index 1.
             */
            utfx.calculateUTF16asUTF8 = function(src) {
                var n=0, l=0;
                utfx.UTF16toUTF8(src, function(cp) {
                    ++n; l += (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
                });
                return [n,l];
            };

            return utfx;
        }();

        // encodings/utf8

        /**
         * Encodes this ByteBuffer's contents between {@link ByteBuffer#offset} and {@link ByteBuffer#limit} to an UTF8 encoded
         *  string.
         * @returns {string} Hex encoded string
         * @throws {RangeError} If `offset > limit`
         * @expose
         */
        ByteBufferPrototype.toUTF8 = function(begin, end) {
            if (typeof begin === 'undefined') begin = this.offset;
            if (typeof end === 'undefined') end = this.limit;
            if (!this.noAssert) {
                if (typeof begin !== 'number' || begin % 1 !== 0)
                    throw TypeError("Illegal begin: Not an integer");
                begin >>>= 0;
                if (typeof end !== 'number' || end % 1 !== 0)
                    throw TypeError("Illegal end: Not an integer");
                end >>>= 0;
                if (begin < 0 || begin > end || end > this.buffer.byteLength)
                    throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
            }
            var sd; try {
                utfx.decodeUTF8toUTF16(function() {
                    return begin < end ? this.view[begin++] : null;
                }.bind(this), sd = stringDestination());
            } catch (e) {
                if (begin !== end)
                    throw RangeError("Illegal range: Truncated data, "+begin+" != "+end);
            }
            return sd();
        };

        /**
         * Decodes an UTF8 encoded string to a ByteBuffer.
         * @param {string} str String to decode
         * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
         *  {@link ByteBuffer.DEFAULT_ENDIAN}.
         * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
         *  {@link ByteBuffer.DEFAULT_NOASSERT}.
         * @returns {!ByteBuffer} ByteBuffer
         * @expose
         */
        ByteBuffer.fromUTF8 = function(str, littleEndian, noAssert) {
            if (!noAssert)
                if (typeof str !== 'string')
                    throw TypeError("Illegal str: Not a string");
            var bb = new ByteBuffer(utfx.calculateUTF16asUTF8(stringSource(str), true)[1], littleEndian, noAssert),
                i = 0;
            utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
                bb.view[i++] = b;
            });
            bb.limit = i;
            return bb;
        };

        return ByteBuffer;
    });
    });

    // shim for using process in browser
    // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout () {
        throw new Error('clearTimeout has not been defined');
    }
    var cachedSetTimeout = defaultSetTimout;
    var cachedClearTimeout = defaultClearTimeout;
    if (typeof global$1.setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
    }
    if (typeof global$1.clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
    }

    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch(e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch(e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }


    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }



    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }

    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;

        var len = queue.length;
        while(len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }
    function nextTick(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    }
    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function () {
        this.fun.apply(null, this.array);
    };
    var title = 'browser';
    var platform = 'browser';
    var browser = true;
    var env = {};
    var argv = [];
    var version = ''; // empty string to avoid regexp issues
    var versions = {};
    var release = {};
    var config = {};

    function noop() {}

    var on = noop;
    var addListener = noop;
    var once = noop;
    var off = noop;
    var removeListener = noop;
    var removeAllListeners = noop;
    var emit = noop;

    function binding(name) {
        throw new Error('process.binding is not supported');
    }

    function cwd () { return '/' }
    function chdir (dir) {
        throw new Error('process.chdir is not supported');
    }function umask() { return 0; }

    // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
    var performance = global$1.performance || {};
    var performanceNow =
      performance.now        ||
      performance.mozNow     ||
      performance.msNow      ||
      performance.oNow       ||
      performance.webkitNow  ||
      function(){ return (new Date()).getTime() };

    // generate timestamp or delta
    // see http://nodejs.org/api/process.html#process_process_hrtime
    function hrtime(previousTimestamp){
      var clocktime = performanceNow.call(performance)*1e-3;
      var seconds = Math.floor(clocktime);
      var nanoseconds = Math.floor((clocktime%1)*1e9);
      if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds<0) {
          seconds--;
          nanoseconds += 1e9;
        }
      }
      return [seconds,nanoseconds]
    }

    var startTime = new Date();
    function uptime() {
      var currentTime = new Date();
      var dif = currentTime - startTime;
      return dif / 1000;
    }

    var process = {
      nextTick: nextTick,
      title: title,
      browser: browser,
      env: env,
      argv: argv,
      version: version,
      versions: versions,
      on: on,
      addListener: addListener,
      once: once,
      off: off,
      removeListener: removeListener,
      removeAllListeners: removeAllListeners,
      emit: emit,
      binding: binding,
      cwd: cwd,
      chdir: chdir,
      umask: umask,
      hrtime: hrtime,
      platform: platform,
      release: release,
      config: config,
      uptime: uptime
    };

    var eventemitter2 = createCommonjsModule(function (module, exports) {
    !function(undefined) {

      var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
      };
      var defaultMaxListeners = 10;

      function init() {
        this._events = {};
        if (this._conf) {
          configure.call(this, this._conf);
        }
      }

      function configure(conf) {
        if (conf) {
          this._conf = conf;

          conf.delimiter && (this.delimiter = conf.delimiter);
          this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;

          conf.wildcard && (this.wildcard = conf.wildcard);
          conf.newListener && (this._newListener = conf.newListener);
          conf.removeListener && (this._removeListener = conf.removeListener);
          conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);

          if (this.wildcard) {
            this.listenerTree = {};
          }
        } else {
          this._maxListeners = defaultMaxListeners;
        }
      }

      function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = '(node) warning: possible EventEmitter memory ' +
            'leak detected. ' + count + ' listeners added. ' +
            'Use emitter.setMaxListeners() to increase limit.';

        if(this.verboseMemoryLeak){
          errorMsg += ' Event name: ' + eventName + '.';
        }

        if(typeof process !== 'undefined' && process.emitWarning){
          var e = new Error(errorMsg);
          e.name = 'MaxListenersExceededWarning';
          e.emitter = this;
          e.count = count;
          process.emitWarning(e);
        } else {
          console.error(errorMsg);

          if (console.trace){
            console.trace();
          }
        }
      }

      function EventEmitter(conf) {
        this._events = {};
        this._newListener = false;
        this._removeListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
      }
      EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property

      //
      // Attention, function return type now is array, always !
      // It has zero elements if no any matches found and one or more
      // elements (leafs) if there are matches
      //
      function searchListenerTree(handlers, type, tree, i) {
        if (!tree) {
          return [];
        }
        var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
            typeLength = type.length, currentType = type[i], nextType = type[i+1];
        if (i === typeLength && tree._listeners) {
          //
          // If at the end of the event(s) list and the tree has listeners
          // invoke those listeners.
          //
          if (typeof tree._listeners === 'function') {
            handlers && handlers.push(tree._listeners);
            return [tree];
          } else {
            for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
              handlers && handlers.push(tree._listeners[leaf]);
            }
            return [tree];
          }
        }

        if ((currentType === '*' || currentType === '**') || tree[currentType]) {
          //
          // If the event emitted is '*' at this part
          // or there is a concrete match at this patch
          //
          if (currentType === '*') {
            for (branch in tree) {
              if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
              }
            }
            return listeners;
          } else if(currentType === '**') {
            endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
            if(endReached && tree._listeners) {
              // The next element has a _listeners, add it to the handlers.
              listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
            }

            for (branch in tree) {
              if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                if(branch === '*' || branch === '**') {
                  if(tree[branch]._listeners && !endReached) {
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                  }
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                } else if(branch === nextType) {
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
                } else {
                  // No match on this one, shift into the tree but not in the type array.
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
              }
            }
            return listeners;
          }

          listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
        }

        xTree = tree['*'];
        if (xTree) {
          //
          // If the listener tree will allow any match for this part,
          // then recursively explore all branches of the tree
          //
          searchListenerTree(handlers, type, xTree, i+1);
        }

        xxTree = tree['**'];
        if(xxTree) {
          if(i < typeLength) {
            if(xxTree._listeners) {
              // If we have a listener on a '**', it will catch all, so add its handler.
              searchListenerTree(handlers, type, xxTree, typeLength);
            }

            // Build arrays of matching next branches and others.
            for(branch in xxTree) {
              if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                if(branch === nextType) {
                  // We know the next element will match, so jump twice.
                  searchListenerTree(handlers, type, xxTree[branch], i+2);
                } else if(branch === currentType) {
                  // Current node matches, move into the tree.
                  searchListenerTree(handlers, type, xxTree[branch], i+1);
                } else {
                  isolatedBranch = {};
                  isolatedBranch[branch] = xxTree[branch];
                  searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
                }
              }
            }
          } else if(xxTree._listeners) {
            // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
          } else if(xxTree['*'] && xxTree['*']._listeners) {
            searchListenerTree(handlers, type, xxTree['*'], typeLength);
          }
        }

        return listeners;
      }

      function growListenerTree(type, listener) {

        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();

        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i+1 < len; i++) {
          if(type[i] === '**' && type[i+1] === '**') {
            return;
          }
        }

        var tree = this.listenerTree;
        var name = type.shift();

        while (name !== undefined) {

          if (!tree[name]) {
            tree[name] = {};
          }

          tree = tree[name];

          if (type.length === 0) {

            if (!tree._listeners) {
              tree._listeners = listener;
            }
            else {
              if (typeof tree._listeners === 'function') {
                tree._listeners = [tree._listeners];
              }

              tree._listeners.push(listener);

              if (
                !tree._listeners.warned &&
                this._maxListeners > 0 &&
                tree._listeners.length > this._maxListeners
              ) {
                tree._listeners.warned = true;
                logPossibleMemoryLeak.call(this, tree._listeners.length, name);
              }
            }
            return true;
          }
          name = type.shift();
        }
        return true;
      }

      // By default EventEmitters will print a warning if more than
      // 10 listeners are added to it. This is a useful default which
      // helps finding memory leaks.
      //
      // Obviously not all Emitters should be limited to 10. This function allows
      // that to be increased. Set to zero for unlimited.

      EventEmitter.prototype.delimiter = '.';

      EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
          this._maxListeners = n;
          if (!this._conf) this._conf = {};
          this._conf.maxListeners = n;
        }
      };

      EventEmitter.prototype.event = '';


      EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
      };

      EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
      };

      EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
      };

      EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
      };

      EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
      };

      EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;

        if (typeof fn !== 'function') {
          throw new Error('many only accepts instances of Function');
        }

        function listener() {
          if (--ttl === 0) {
            self.off(event, listener);
          }
          return fn.apply(this, arguments);
        }

        listener._origin = fn;

        this._on(event, listener, prepend);

        return self;
      };

      EventEmitter.prototype.emit = function() {

        this._events || init.call(this);

        var type = arguments[0];

        if (type === 'newListener' && !this._newListener) {
          if (!this._events.newListener) {
            return false;
          }
        }

        var al = arguments.length;
        var args,l,i,j;
        var handler;

        if (this._all && this._all.length) {
          handler = this._all.slice();
          if (al > 3) {
            args = new Array(al);
            for (j = 0; j < al; j++) args[j] = arguments[j];
          }

          for (i = 0, l = handler.length; i < l; i++) {
            this.event = type;
            switch (al) {
            case 1:
              handler[i].call(this, type);
              break;
            case 2:
              handler[i].call(this, type, arguments[1]);
              break;
            case 3:
              handler[i].call(this, type, arguments[1], arguments[2]);
              break;
            default:
              handler[i].apply(this, args);
            }
          }
        }

        if (this.wildcard) {
          handler = [];
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
          handler = this._events[type];
          if (typeof handler === 'function') {
            this.event = type;
            switch (al) {
            case 1:
              handler.call(this);
              break;
            case 2:
              handler.call(this, arguments[1]);
              break;
            case 3:
              handler.call(this, arguments[1], arguments[2]);
              break;
            default:
              args = new Array(al - 1);
              for (j = 1; j < al; j++) args[j - 1] = arguments[j];
              handler.apply(this, args);
            }
            return true;
          } else if (handler) {
            // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
          }
        }

        if (handler && handler.length) {
          if (al > 3) {
            args = new Array(al - 1);
            for (j = 1; j < al; j++) args[j - 1] = arguments[j];
          }
          for (i = 0, l = handler.length; i < l; i++) {
            this.event = type;
            switch (al) {
            case 1:
              handler[i].call(this);
              break;
            case 2:
              handler[i].call(this, arguments[1]);
              break;
            case 3:
              handler[i].call(this, arguments[1], arguments[2]);
              break;
            default:
              handler[i].apply(this, args);
            }
          }
          return true;
        } else if (!this._all && type === 'error') {
          if (arguments[1] instanceof Error) {
            throw arguments[1]; // Unhandled 'error' event
          } else {
            throw new Error("Uncaught, unspecified 'error' event.");
          }
          return false;
        }

        return !!this._all;
      };

      EventEmitter.prototype.emitAsync = function() {

        this._events || init.call(this);

        var type = arguments[0];

        if (type === 'newListener' && !this._newListener) {
            if (!this._events.newListener) { return Promise.resolve([false]); }
        }

        var promises= [];

        var al = arguments.length;
        var args,l,i,j;
        var handler;

        if (this._all) {
          if (al > 3) {
            args = new Array(al);
            for (j = 1; j < al; j++) args[j] = arguments[j];
          }
          for (i = 0, l = this._all.length; i < l; i++) {
            this.event = type;
            switch (al) {
            case 1:
              promises.push(this._all[i].call(this, type));
              break;
            case 2:
              promises.push(this._all[i].call(this, type, arguments[1]));
              break;
            case 3:
              promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
              break;
            default:
              promises.push(this._all[i].apply(this, args));
            }
          }
        }

        if (this.wildcard) {
          handler = [];
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
          handler = this._events[type];
        }

        if (typeof handler === 'function') {
          this.event = type;
          switch (al) {
          case 1:
            promises.push(handler.call(this));
            break;
          case 2:
            promises.push(handler.call(this, arguments[1]));
            break;
          case 3:
            promises.push(handler.call(this, arguments[1], arguments[2]));
            break;
          default:
            args = new Array(al - 1);
            for (j = 1; j < al; j++) args[j - 1] = arguments[j];
            promises.push(handler.apply(this, args));
          }
        } else if (handler && handler.length) {
          handler = handler.slice();
          if (al > 3) {
            args = new Array(al - 1);
            for (j = 1; j < al; j++) args[j - 1] = arguments[j];
          }
          for (i = 0, l = handler.length; i < l; i++) {
            this.event = type;
            switch (al) {
            case 1:
              promises.push(handler[i].call(this));
              break;
            case 2:
              promises.push(handler[i].call(this, arguments[1]));
              break;
            case 3:
              promises.push(handler[i].call(this, arguments[1], arguments[2]));
              break;
            default:
              promises.push(handler[i].apply(this, args));
            }
          }
        } else if (!this._all && type === 'error') {
          if (arguments[1] instanceof Error) {
            return Promise.reject(arguments[1]); // Unhandled 'error' event
          } else {
            return Promise.reject("Uncaught, unspecified 'error' event.");
          }
        }

        return Promise.all(promises);
      };

      EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
      };

      EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
      };

      EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
      };

      EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
      };

      EventEmitter.prototype.addListener = EventEmitter.prototype.on;

      EventEmitter.prototype._onAny = function(fn, prepend){
        if (typeof fn !== 'function') {
          throw new Error('onAny only accepts instances of Function');
        }

        if (!this._all) {
          this._all = [];
        }

        // Add the function to the event listener collection.
        if(prepend){
          this._all.unshift(fn);
        }else{
          this._all.push(fn);
        }

        return this;
      };

      EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
          this._onAny(type, listener);
          return this;
        }

        if (typeof listener !== 'function') {
          throw new Error('on only accepts instances of Function');
        }
        this._events || init.call(this);

        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        if (this._newListener)
           this.emit('newListener', type, listener);

        if (this.wildcard) {
          growListenerTree.call(this, type, listener);
          return this;
        }

        if (!this._events[type]) {
          // Optimize the case of one listener. Don't need the extra array object.
          this._events[type] = listener;
        }
        else {
          if (typeof this._events[type] === 'function') {
            // Change to array.
            this._events[type] = [this._events[type]];
          }

          // If we've already got an array, just add
          if(prepend){
            this._events[type].unshift(listener);
          }else{
            this._events[type].push(listener);
          }

          // Check for listener leak
          if (
            !this._events[type].warned &&
            this._maxListeners > 0 &&
            this._events[type].length > this._maxListeners
          ) {
            this._events[type].warned = true;
            logPossibleMemoryLeak.call(this, this._events[type].length, type);
          }
        }

        return this;
      };

      EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') {
          throw new Error('removeListener only takes instances of Function');
        }

        var handlers,leafs=[];

        if(this.wildcard) {
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        }
        else {
          // does not use listeners(), so no side effect of creating _events[type]
          if (!this._events[type]) return this;
          handlers = this._events[type];
          leafs.push({_listeners:handlers});
        }

        for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
          var leaf = leafs[iLeaf];
          handlers = leaf._listeners;
          if (isArray(handlers)) {

            var position = -1;

            for (var i = 0, length = handlers.length; i < length; i++) {
              if (handlers[i] === listener ||
                (handlers[i].listener && handlers[i].listener === listener) ||
                (handlers[i]._origin && handlers[i]._origin === listener)) {
                position = i;
                break;
              }
            }

            if (position < 0) {
              continue;
            }

            if(this.wildcard) {
              leaf._listeners.splice(position, 1);
            }
            else {
              this._events[type].splice(position, 1);
            }

            if (handlers.length === 0) {
              if(this.wildcard) {
                delete leaf._listeners;
              }
              else {
                delete this._events[type];
              }
            }
            if (this._removeListener)
              this.emit("removeListener", type, listener);

            return this;
          }
          else if (handlers === listener ||
            (handlers.listener && handlers.listener === listener) ||
            (handlers._origin && handlers._origin === listener)) {
            if(this.wildcard) {
              delete leaf._listeners;
            }
            else {
              delete this._events[type];
            }
            if (this._removeListener)
              this.emit("removeListener", type, listener);
          }
        }

        function recursivelyGarbageCollect(root) {
          if (root === undefined) {
            return;
          }
          var keys = Object.keys(root);
          for (var i in keys) {
            var key = keys[i];
            var obj = root[key];
            if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
              continue;
            if (Object.keys(obj).length > 0) {
              recursivelyGarbageCollect(root[key]);
            }
            if (Object.keys(obj).length === 0) {
              delete root[key];
            }
          }
        }
        recursivelyGarbageCollect(this.listenerTree);

        return this;
      };

      EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
          fns = this._all;
          for(i = 0, l = fns.length; i < l; i++) {
            if(fn === fns[i]) {
              fns.splice(i, 1);
              if (this._removeListener)
                this.emit("removeListenerAny", fn);
              return this;
            }
          }
        } else {
          fns = this._all;
          if (this._removeListener) {
            for(i = 0, l = fns.length; i < l; i++)
              this.emit("removeListenerAny", fns[i]);
          }
          this._all = [];
        }
        return this;
      };

      EventEmitter.prototype.removeListener = EventEmitter.prototype.off;

      EventEmitter.prototype.removeAllListeners = function(type) {
        if (type === undefined) {
          !this._events || init.call(this);
          return this;
        }

        if (this.wildcard) {
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);

          for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
            var leaf = leafs[iLeaf];
            leaf._listeners = null;
          }
        }
        else if (this._events) {
          this._events[type] = null;
        }
        return this;
      };

      EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
          var handlers = [];
          var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
          searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
          return handlers;
        }

        this._events || init.call(this);

        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) {
          this._events[type] = [this._events[type]];
        }
        return this._events[type];
      };

      EventEmitter.prototype.eventNames = function(){
        return Object.keys(this._events);
      };

      EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
      };

      EventEmitter.prototype.listenersAny = function() {

        if(this._all) {
          return this._all;
        }
        else {
          return [];
        }

      };

      if (typeof undefined === 'function' && undefined.amd) {
         // AMD. Register as an anonymous module.
        undefined(function() {
          return EventEmitter;
        });
      } else {
        // CommonJS
        module.exports = EventEmitter;
      }
    }();
    });

    // Port of lower_bound from http://en.cppreference.com/w/cpp/algorithm/lower_bound
    // Used to compute insertion index to keep queue sorted after insertion
    function lowerBound(array, value, comp) {
    	let first = 0;
    	let count = array.length;

    	while (count > 0) {
    		const step = (count / 2) | 0;
    		let it = first + step;

    		if (comp(array[it], value) <= 0) {
    			first = ++it;
    			count -= step + 1;
    		} else {
    			count = step;
    		}
    	}

    	return first;
    }

    class PriorityQueue {
    	constructor() {
    		this._queue = [];
    	}

    	enqueue(run, options) {
    		options = Object.assign({
    			priority: 0
    		}, options);

    		const element = {priority: options.priority, run};

    		if (this.size && this._queue[this.size - 1].priority >= options.priority) {
    			this._queue.push(element);
    			return;
    		}

    		const index = lowerBound(this._queue, element, (a, b) => b.priority - a.priority);
    		this._queue.splice(index, 0, element);
    	}

    	dequeue() {
    		return this._queue.shift().run;
    	}

    	get size() {
    		return this._queue.length;
    	}
    }

    class PQueue {
    	constructor(options) {
    		options = Object.assign({
    			carryoverConcurrencyCount: false,
    			intervalCap: Infinity,
    			interval: 0,
    			concurrency: Infinity,
    			autoStart: true,
    			queueClass: PriorityQueue
    		}, options);

    		if (!(typeof options.concurrency === 'number' && options.concurrency >= 1)) {
    			throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${options.concurrency}\` (${typeof options.concurrency})`);
    		}

    		if (!(typeof options.intervalCap === 'number' && options.intervalCap >= 1)) {
    			throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${options.intervalCap}\` (${typeof options.intervalCap})`);
    		}

    		if (!(typeof options.interval === 'number' && Number.isFinite(options.interval) && options.interval >= 0)) {
    			throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${options.interval}\` (${typeof options.interval})`);
    		}

    		this._carryoverConcurrencyCount = options.carryoverConcurrencyCount;
    		this._isIntervalIgnored = options.intervalCap === Infinity || options.interval === 0;
    		this._intervalCount = 0;
    		this._intervalCap = options.intervalCap;
    		this._interval = options.interval;
    		this._intervalId = null;
    		this._intervalEnd = 0;
    		this._timeoutId = null;

    		this.queue = new options.queueClass(); // eslint-disable-line new-cap
    		this._queueClass = options.queueClass;
    		this._pendingCount = 0;
    		this._concurrency = options.concurrency;
    		this._isPaused = options.autoStart === false;
    		this._resolveEmpty = () => {};
    		this._resolveIdle = () => {};
    	}

    	get _doesIntervalAllowAnother() {
    		return this._isIntervalIgnored || this._intervalCount < this._intervalCap;
    	}

    	get _doesConcurrentAllowAnother() {
    		return this._pendingCount < this._concurrency;
    	}

    	_next() {
    		this._pendingCount--;
    		this._tryToStartAnother();
    	}

    	_resolvePromises() {
    		this._resolveEmpty();
    		this._resolveEmpty = () => {};

    		if (this._pendingCount === 0) {
    			this._resolveIdle();
    			this._resolveIdle = () => {};
    		}
    	}

    	_onResumeInterval() {
    		this._onInterval();
    		this._initializeIntervalIfNeeded();
    		this._timeoutId = null;
    	}

    	_intervalPaused() {
    		const now = Date.now();

    		if (this._intervalId === null) {
    			const delay = this._intervalEnd - now;
    			if (delay < 0) {
    				// Act as the interval was done
    				// We don't need to resume it here,
    				// because it'll be resumed on line 160
    				this._intervalCount = (this._carryoverConcurrencyCount) ? this._pendingCount : 0;
    			} else {
    				// Act as the interval is pending
    				if (this._timeoutId === null) {
    					this._timeoutId = setTimeout(() => this._onResumeInterval(), delay);
    				}

    				return true;
    			}
    		}

    		return false;
    	}

    	_tryToStartAnother() {
    		if (this.queue.size === 0) {
    			// We can clear the interval ("pause")
    			// because we can redo it later ("resume")
    			clearInterval(this._intervalId);
    			this._intervalId = null;

    			this._resolvePromises();

    			return false;
    		}

    		if (!this._isPaused) {
    			const canInitializeInterval = !this._intervalPaused();
    			if (this._doesIntervalAllowAnother && this._doesConcurrentAllowAnother) {
    				this.queue.dequeue()();
    				if (canInitializeInterval) {
    					this._initializeIntervalIfNeeded();
    				}

    				return true;
    			}
    		}

    		return false;
    	}

    	_initializeIntervalIfNeeded() {
    		if (this._isIntervalIgnored || this._intervalId !== null) {
    			return;
    		}

    		this._intervalId = setInterval(() => this._onInterval(), this._interval);
    		this._intervalEnd = Date.now() + this._interval;
    	}

    	_onInterval() {
    		if (this._intervalCount === 0 && this._pendingCount === 0) {
    			clearInterval(this._intervalId);
    			this._intervalId = null;
    		}

    		this._intervalCount = (this._carryoverConcurrencyCount) ? this._pendingCount : 0;
    		while (this._tryToStartAnother()) {} // eslint-disable-line no-empty
    	}

    	add(fn, options) {
    		return new Promise((resolve, reject) => {
    			const run = () => {
    				this._pendingCount++;
    				this._intervalCount++;

    				try {
    					Promise.resolve(fn()).then(
    						val => {
    							resolve(val);
    							this._next();
    						},
    						err => {
    							reject(err);
    							this._next();
    						}
    					);
    				} catch (err) {
    					reject(err);
    					this._next();
    				}
    			};

    			this.queue.enqueue(run, options);
    			this._tryToStartAnother();
    		});
    	}

    	addAll(fns, options) {
    		return Promise.all(fns.map(fn => this.add(fn, options)));
    	}

    	start() {
    		if (!this._isPaused) {
    			return;
    		}

    		this._isPaused = false;
    		while (this._tryToStartAnother()) {} // eslint-disable-line no-empty
    	}

    	pause() {
    		this._isPaused = true;
    	}

    	clear() {
    		this.queue = new this._queueClass(); // eslint-disable-line new-cap
    	}

    	onEmpty() {
    		// Instantly resolve if the queue is empty
    		if (this.queue.size === 0) {
    			return Promise.resolve();
    		}

    		return new Promise(resolve => {
    			const existingResolve = this._resolveEmpty;
    			this._resolveEmpty = () => {
    				existingResolve();
    				resolve();
    			};
    		});
    	}

    	onIdle() {
    		// Instantly resolve if none pending and if nothing else is queued
    		if (this._pendingCount === 0 && this.queue.size === 0) {
    			return Promise.resolve();
    		}

    		return new Promise(resolve => {
    			const existingResolve = this._resolveIdle;
    			this._resolveIdle = () => {
    				existingResolve();
    				resolve();
    			};
    		});
    	}

    	get size() {
    		return this.queue.size;
    	}

    	get pending() {
    		return this._pendingCount;
    	}

    	get isPaused() {
    		return this._isPaused;
    	}
    }

    var pQueue = PQueue;

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isFunction(x) {
        return typeof x === 'function';
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var _enable_super_gross_mode_that_will_cause_bad_things = false;
    var config$1 = {
        Promise: undefined,
        set useDeprecatedSynchronousErrorHandling(value) {
            if (value) {
                var error = /*@__PURE__*/ new Error();
                /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
            }
            else if (_enable_super_gross_mode_that_will_cause_bad_things) {
                /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
            }
            _enable_super_gross_mode_that_will_cause_bad_things = value;
        },
        get useDeprecatedSynchronousErrorHandling() {
            return _enable_super_gross_mode_that_will_cause_bad_things;
        },
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function hostReportError(err) {
        setTimeout(function () { throw err; });
    }

    /** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
    var empty = {
        closed: true,
        next: function (value) { },
        error: function (err) {
            if (config$1.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        },
        complete: function () { }
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var isArray$2 = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isObject(x) {
        return x != null && typeof x === 'object';
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var errorObject = { e: {} };

    /** PURE_IMPORTS_START _errorObject PURE_IMPORTS_END */
    var tryCatchTarget;
    function tryCatcher() {
        try {
            return tryCatchTarget.apply(this, arguments);
        }
        catch (e) {
            errorObject.e = e;
            return errorObject;
        }
    }
    function tryCatch(fn) {
        tryCatchTarget = fn;
        return tryCatcher;
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    var UnsubscriptionError = UnsubscriptionErrorImpl;

    /** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_tryCatch,_util_errorObject,_util_UnsubscriptionError PURE_IMPORTS_END */
    var Subscription = /*@__PURE__*/ (function () {
        function Subscription(unsubscribe) {
            this.closed = false;
            this._parent = null;
            this._parents = null;
            this._subscriptions = null;
            if (unsubscribe) {
                this._unsubscribe = unsubscribe;
            }
        }
        Subscription.prototype.unsubscribe = function () {
            var hasErrors = false;
            var errors;
            if (this.closed) {
                return;
            }
            var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
            this.closed = true;
            this._parent = null;
            this._parents = null;
            this._subscriptions = null;
            var index = -1;
            var len = _parents ? _parents.length : 0;
            while (_parent) {
                _parent.remove(this);
                _parent = ++index < len && _parents[index] || null;
            }
            if (isFunction(_unsubscribe)) {
                var trial = tryCatch(_unsubscribe).call(this);
                if (trial === errorObject) {
                    hasErrors = true;
                    errors = errors || (errorObject.e instanceof UnsubscriptionError ?
                        flattenUnsubscriptionErrors(errorObject.e.errors) : [errorObject.e]);
                }
            }
            if (isArray$2(_subscriptions)) {
                index = -1;
                len = _subscriptions.length;
                while (++index < len) {
                    var sub = _subscriptions[index];
                    if (isObject(sub)) {
                        var trial = tryCatch(sub.unsubscribe).call(sub);
                        if (trial === errorObject) {
                            hasErrors = true;
                            errors = errors || [];
                            var err = errorObject.e;
                            if (err instanceof UnsubscriptionError) {
                                errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
            }
            if (hasErrors) {
                throw new UnsubscriptionError(errors);
            }
        };
        Subscription.prototype.add = function (teardown) {
            if (!teardown || (teardown === Subscription.EMPTY)) {
                return Subscription.EMPTY;
            }
            if (teardown === this) {
                return this;
            }
            var subscription = teardown;
            switch (typeof teardown) {
                case 'function':
                    subscription = new Subscription(teardown);
                case 'object':
                    if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                        return subscription;
                    }
                    else if (this.closed) {
                        subscription.unsubscribe();
                        return subscription;
                    }
                    else if (typeof subscription._addParent !== 'function') {
                        var tmp = subscription;
                        subscription = new Subscription();
                        subscription._subscriptions = [tmp];
                    }
                    break;
                default:
                    throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
            var subscriptions = this._subscriptions || (this._subscriptions = []);
            subscriptions.push(subscription);
            subscription._addParent(this);
            return subscription;
        };
        Subscription.prototype.remove = function (subscription) {
            var subscriptions = this._subscriptions;
            if (subscriptions) {
                var subscriptionIndex = subscriptions.indexOf(subscription);
                if (subscriptionIndex !== -1) {
                    subscriptions.splice(subscriptionIndex, 1);
                }
            }
        };
        Subscription.prototype._addParent = function (parent) {
            var _a = this, _parent = _a._parent, _parents = _a._parents;
            if (!_parent || _parent === parent) {
                this._parent = parent;
            }
            else if (!_parents) {
                this._parents = [parent];
            }
            else if (_parents.indexOf(parent) === -1) {
                _parents.push(parent);
            }
        };
        Subscription.EMPTY = (function (empty) {
            empty.closed = true;
            return empty;
        }(new Subscription()));
        return Subscription;
    }());
    function flattenUnsubscriptionErrors(errors) {
        return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var rxSubscriber = typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();

    /** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
    var Subscriber = /*@__PURE__*/ (function (_super) {
        __extends(Subscriber, _super);
        function Subscriber(destinationOrNext, error, complete) {
            var _this = _super.call(this) || this;
            _this.syncErrorValue = null;
            _this.syncErrorThrown = false;
            _this.syncErrorThrowable = false;
            _this.isStopped = false;
            _this._parentSubscription = null;
            switch (arguments.length) {
                case 0:
                    _this.destination = empty;
                    break;
                case 1:
                    if (!destinationOrNext) {
                        _this.destination = empty;
                        break;
                    }
                    if (typeof destinationOrNext === 'object') {
                        if (destinationOrNext instanceof Subscriber) {
                            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                            _this.destination = destinationOrNext;
                            destinationOrNext.add(_this);
                        }
                        else {
                            _this.syncErrorThrowable = true;
                            _this.destination = new SafeSubscriber(_this, destinationOrNext);
                        }
                        break;
                    }
                default:
                    _this.syncErrorThrowable = true;
                    _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                    break;
            }
            return _this;
        }
        Subscriber.prototype[rxSubscriber] = function () { return this; };
        Subscriber.create = function (next, error, complete) {
            var subscriber = new Subscriber(next, error, complete);
            subscriber.syncErrorThrowable = false;
            return subscriber;
        };
        Subscriber.prototype.next = function (value) {
            if (!this.isStopped) {
                this._next(value);
            }
        };
        Subscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                this.isStopped = true;
                this._error(err);
            }
        };
        Subscriber.prototype.complete = function () {
            if (!this.isStopped) {
                this.isStopped = true;
                this._complete();
            }
        };
        Subscriber.prototype.unsubscribe = function () {
            if (this.closed) {
                return;
            }
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
        };
        Subscriber.prototype._next = function (value) {
            this.destination.next(value);
        };
        Subscriber.prototype._error = function (err) {
            this.destination.error(err);
            this.unsubscribe();
        };
        Subscriber.prototype._complete = function () {
            this.destination.complete();
            this.unsubscribe();
        };
        Subscriber.prototype._unsubscribeAndRecycle = function () {
            var _a = this, _parent = _a._parent, _parents = _a._parents;
            this._parent = null;
            this._parents = null;
            this.unsubscribe();
            this.closed = false;
            this.isStopped = false;
            this._parent = _parent;
            this._parents = _parents;
            this._parentSubscription = null;
            return this;
        };
        return Subscriber;
    }(Subscription));
    var SafeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SafeSubscriber, _super);
        function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
            var _this = _super.call(this) || this;
            _this._parentSubscriber = _parentSubscriber;
            var next;
            var context = _this;
            if (isFunction(observerOrNext)) {
                next = observerOrNext;
            }
            else if (observerOrNext) {
                next = observerOrNext.next;
                error = observerOrNext.error;
                complete = observerOrNext.complete;
                if (observerOrNext !== empty) {
                    context = Object.create(observerOrNext);
                    if (isFunction(context.unsubscribe)) {
                        _this.add(context.unsubscribe.bind(context));
                    }
                    context.unsubscribe = _this.unsubscribe.bind(_this);
                }
            }
            _this._context = context;
            _this._next = next;
            _this._error = error;
            _this._complete = complete;
            return _this;
        }
        SafeSubscriber.prototype.next = function (value) {
            if (!this.isStopped && this._next) {
                var _parentSubscriber = this._parentSubscriber;
                if (!config$1.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._next, value);
                }
                else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var _parentSubscriber = this._parentSubscriber;
                var useDeprecatedSynchronousErrorHandling = config$1.useDeprecatedSynchronousErrorHandling;
                if (this._error) {
                    if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                        this.__tryOrUnsub(this._error, err);
                        this.unsubscribe();
                    }
                    else {
                        this.__tryOrSetError(_parentSubscriber, this._error, err);
                        this.unsubscribe();
                    }
                }
                else if (!_parentSubscriber.syncErrorThrowable) {
                    this.unsubscribe();
                    if (useDeprecatedSynchronousErrorHandling) {
                        throw err;
                    }
                    hostReportError(err);
                }
                else {
                    if (useDeprecatedSynchronousErrorHandling) {
                        _parentSubscriber.syncErrorValue = err;
                        _parentSubscriber.syncErrorThrown = true;
                    }
                    else {
                        hostReportError(err);
                    }
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.complete = function () {
            var _this = this;
            if (!this.isStopped) {
                var _parentSubscriber = this._parentSubscriber;
                if (this._complete) {
                    var wrappedComplete = function () { return _this._complete.call(_this._context); };
                    if (!config$1.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                        this.__tryOrUnsub(wrappedComplete);
                        this.unsubscribe();
                    }
                    else {
                        this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                        this.unsubscribe();
                    }
                }
                else {
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
            try {
                fn.call(this._context, value);
            }
            catch (err) {
                this.unsubscribe();
                if (config$1.useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                else {
                    hostReportError(err);
                }
            }
        };
        SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
            if (!config$1.useDeprecatedSynchronousErrorHandling) {
                throw new Error('bad call');
            }
            try {
                fn.call(this._context, value);
            }
            catch (err) {
                if (config$1.useDeprecatedSynchronousErrorHandling) {
                    parent.syncErrorValue = err;
                    parent.syncErrorThrown = true;
                    return true;
                }
                else {
                    hostReportError(err);
                    return true;
                }
            }
            return false;
        };
        SafeSubscriber.prototype._unsubscribe = function () {
            var _parentSubscriber = this._parentSubscriber;
            this._context = null;
            this._parentSubscriber = null;
            _parentSubscriber.unsubscribe();
        };
        return SafeSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
    function canReportError(observer) {
        while (observer) {
            var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
            if (closed_1 || isStopped) {
                return false;
            }
            else if (destination && destination instanceof Subscriber) {
                observer = destination;
            }
            else {
                observer = null;
            }
        }
        return true;
    }

    /** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
    function toSubscriber(nextOrObserver, error, complete) {
        if (nextOrObserver) {
            if (nextOrObserver instanceof Subscriber) {
                return nextOrObserver;
            }
            if (nextOrObserver[rxSubscriber]) {
                return nextOrObserver[rxSubscriber]();
            }
        }
        if (!nextOrObserver && !error && !complete) {
            return new Subscriber(empty);
        }
        return new Subscriber(nextOrObserver, error, complete);
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function noop$1() { }

    /** PURE_IMPORTS_START _noop PURE_IMPORTS_END */
    function pipeFromArray(fns) {
        if (!fns) {
            return noop$1;
        }
        if (fns.length === 1) {
            return fns[0];
        }
        return function piped(input) {
            return fns.reduce(function (prev, fn) { return fn(prev); }, input);
        };
    }

    /** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_internal_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
    var Observable = /*@__PURE__*/ (function () {
        function Observable(subscribe) {
            this._isScalar = false;
            if (subscribe) {
                this._subscribe = subscribe;
            }
        }
        Observable.prototype.lift = function (operator) {
            var observable$$1 = new Observable();
            observable$$1.source = this;
            observable$$1.operator = operator;
            return observable$$1;
        };
        Observable.prototype.subscribe = function (observerOrNext, error, complete) {
            var operator = this.operator;
            var sink = toSubscriber(observerOrNext, error, complete);
            if (operator) {
                operator.call(sink, this.source);
            }
            else {
                sink.add(this.source || (config$1.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                    this._subscribe(sink) :
                    this._trySubscribe(sink));
            }
            if (config$1.useDeprecatedSynchronousErrorHandling) {
                if (sink.syncErrorThrowable) {
                    sink.syncErrorThrowable = false;
                    if (sink.syncErrorThrown) {
                        throw sink.syncErrorValue;
                    }
                }
            }
            return sink;
        };
        Observable.prototype._trySubscribe = function (sink) {
            try {
                return this._subscribe(sink);
            }
            catch (err) {
                if (config$1.useDeprecatedSynchronousErrorHandling) {
                    sink.syncErrorThrown = true;
                    sink.syncErrorValue = err;
                }
                if (canReportError(sink)) {
                    sink.error(err);
                }
                else {
                    console.warn(err);
                }
            }
        };
        Observable.prototype.forEach = function (next, promiseCtor) {
            var _this = this;
            promiseCtor = getPromiseCtor(promiseCtor);
            return new promiseCtor(function (resolve, reject) {
                var subscription;
                subscription = _this.subscribe(function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        if (subscription) {
                            subscription.unsubscribe();
                        }
                    }
                }, reject, resolve);
            });
        };
        Observable.prototype._subscribe = function (subscriber) {
            var source = this.source;
            return source && source.subscribe(subscriber);
        };
        Observable.prototype[observable] = function () {
            return this;
        };
        Observable.prototype.pipe = function () {
            var operations = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                operations[_i] = arguments[_i];
            }
            if (operations.length === 0) {
                return this;
            }
            return pipeFromArray(operations)(this);
        };
        Observable.prototype.toPromise = function (promiseCtor) {
            var _this = this;
            promiseCtor = getPromiseCtor(promiseCtor);
            return new promiseCtor(function (resolve, reject) {
                var value;
                _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
            });
        };
        Observable.create = function (subscribe) {
            return new Observable(subscribe);
        };
        return Observable;
    }());
    function getPromiseCtor(promiseCtor) {
        if (!promiseCtor) {
            promiseCtor = Promise;
        }
        if (!promiseCtor) {
            throw new Error('no Promise impl found');
        }
        return promiseCtor;
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

    /** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
    var SubjectSubscription = /*@__PURE__*/ (function (_super) {
        __extends(SubjectSubscription, _super);
        function SubjectSubscription(subject, subscriber) {
            var _this = _super.call(this) || this;
            _this.subject = subject;
            _this.subscriber = subscriber;
            _this.closed = false;
            return _this;
        }
        SubjectSubscription.prototype.unsubscribe = function () {
            if (this.closed) {
                return;
            }
            this.closed = true;
            var subject = this.subject;
            var observers = subject.observers;
            this.subject = null;
            if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
                return;
            }
            var subscriberIndex = observers.indexOf(this.subscriber);
            if (subscriberIndex !== -1) {
                observers.splice(subscriberIndex, 1);
            }
        };
        return SubjectSubscription;
    }(Subscription));

    /** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */
    var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SubjectSubscriber, _super);
        function SubjectSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            return _this;
        }
        return SubjectSubscriber;
    }(Subscriber));
    var Subject = /*@__PURE__*/ (function (_super) {
        __extends(Subject, _super);
        function Subject() {
            var _this = _super.call(this) || this;
            _this.observers = [];
            _this.closed = false;
            _this.isStopped = false;
            _this.hasError = false;
            _this.thrownError = null;
            return _this;
        }
        Subject.prototype[rxSubscriber] = function () {
            return new SubjectSubscriber(this);
        };
        Subject.prototype.lift = function (operator) {
            var subject = new AnonymousSubject(this, this);
            subject.operator = operator;
            return subject;
        };
        Subject.prototype.next = function (value) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            if (!this.isStopped) {
                var observers = this.observers;
                var len = observers.length;
                var copy = observers.slice();
                for (var i = 0; i < len; i++) {
                    copy[i].next(value);
                }
            }
        };
        Subject.prototype.error = function (err) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            this.hasError = true;
            this.thrownError = err;
            this.isStopped = true;
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].error(err);
            }
            this.observers.length = 0;
        };
        Subject.prototype.complete = function () {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            this.isStopped = true;
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].complete();
            }
            this.observers.length = 0;
        };
        Subject.prototype.unsubscribe = function () {
            this.isStopped = true;
            this.closed = true;
            this.observers = null;
        };
        Subject.prototype._trySubscribe = function (subscriber) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else {
                return _super.prototype._trySubscribe.call(this, subscriber);
            }
        };
        Subject.prototype._subscribe = function (subscriber) {
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else if (this.hasError) {
                subscriber.error(this.thrownError);
                return Subscription.EMPTY;
            }
            else if (this.isStopped) {
                subscriber.complete();
                return Subscription.EMPTY;
            }
            else {
                this.observers.push(subscriber);
                return new SubjectSubscription(this, subscriber);
            }
        };
        Subject.prototype.asObservable = function () {
            var observable = new Observable();
            observable.source = this;
            return observable;
        };
        Subject.create = function (destination, source) {
            return new AnonymousSubject(destination, source);
        };
        return Subject;
    }(Observable));
    var AnonymousSubject = /*@__PURE__*/ (function (_super) {
        __extends(AnonymousSubject, _super);
        function AnonymousSubject(destination, source) {
            var _this = _super.call(this) || this;
            _this.destination = destination;
            _this.source = source;
            return _this;
        }
        AnonymousSubject.prototype.next = function (value) {
            var destination = this.destination;
            if (destination && destination.next) {
                destination.next(value);
            }
        };
        AnonymousSubject.prototype.error = function (err) {
            var destination = this.destination;
            if (destination && destination.error) {
                this.destination.error(err);
            }
        };
        AnonymousSubject.prototype.complete = function () {
            var destination = this.destination;
            if (destination && destination.complete) {
                this.destination.complete();
            }
        };
        AnonymousSubject.prototype._subscribe = function (subscriber) {
            var source = this.source;
            if (source) {
                return this.source.subscribe(subscriber);
            }
            else {
                return Subscription.EMPTY;
            }
        };
        return AnonymousSubject;
    }(Subject));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function refCount() {
        return function refCountOperatorFunction(source) {
            return source.lift(new RefCountOperator(source));
        };
    }
    var RefCountOperator = /*@__PURE__*/ (function () {
        function RefCountOperator(connectable) {
            this.connectable = connectable;
        }
        RefCountOperator.prototype.call = function (subscriber, source) {
            var connectable = this.connectable;
            connectable._refCount++;
            var refCounter = new RefCountSubscriber(subscriber, connectable);
            var subscription = source.subscribe(refCounter);
            if (!refCounter.closed) {
                refCounter.connection = connectable.connect();
            }
            return subscription;
        };
        return RefCountOperator;
    }());
    var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RefCountSubscriber, _super);
        function RefCountSubscriber(destination, connectable) {
            var _this = _super.call(this, destination) || this;
            _this.connectable = connectable;
            return _this;
        }
        RefCountSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (!connectable) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var refCount = connectable._refCount;
            if (refCount <= 0) {
                this.connection = null;
                return;
            }
            connectable._refCount = refCount - 1;
            if (refCount > 1) {
                this.connection = null;
                return;
            }
            var connection = this.connection;
            var sharedConnection = connectable._connection;
            this.connection = null;
            if (sharedConnection && (!connection || sharedConnection === connection)) {
                sharedConnection.unsubscribe();
            }
        };
        return RefCountSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */
    var ConnectableObservable = /*@__PURE__*/ (function (_super) {
        __extends(ConnectableObservable, _super);
        function ConnectableObservable(source, subjectFactory) {
            var _this = _super.call(this) || this;
            _this.source = source;
            _this.subjectFactory = subjectFactory;
            _this._refCount = 0;
            _this._isComplete = false;
            return _this;
        }
        ConnectableObservable.prototype._subscribe = function (subscriber) {
            return this.getSubject().subscribe(subscriber);
        };
        ConnectableObservable.prototype.getSubject = function () {
            var subject = this._subject;
            if (!subject || subject.isStopped) {
                this._subject = this.subjectFactory();
            }
            return this._subject;
        };
        ConnectableObservable.prototype.connect = function () {
            var connection = this._connection;
            if (!connection) {
                this._isComplete = false;
                connection = this._connection = new Subscription();
                connection.add(this.source
                    .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
                if (connection.closed) {
                    this._connection = null;
                    connection = Subscription.EMPTY;
                }
                else {
                    this._connection = connection;
                }
            }
            return connection;
        };
        ConnectableObservable.prototype.refCount = function () {
            return refCount()(this);
        };
        return ConnectableObservable;
    }(Observable));
    var connectableProto = ConnectableObservable.prototype;
    var connectableObservableDescriptor = {
        operator: { value: null },
        _refCount: { value: 0, writable: true },
        _subject: { value: null, writable: true },
        _connection: { value: null, writable: true },
        _subscribe: { value: connectableProto._subscribe },
        _isComplete: { value: connectableProto._isComplete, writable: true },
        getSubject: { value: connectableProto.getSubject },
        connect: { value: connectableProto.connect },
        refCount: { value: connectableProto.refCount }
    };
    var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ConnectableSubscriber, _super);
        function ConnectableSubscriber(destination, connectable) {
            var _this = _super.call(this, destination) || this;
            _this.connectable = connectable;
            return _this;
        }
        ConnectableSubscriber.prototype._error = function (err) {
            this._unsubscribe();
            _super.prototype._error.call(this, err);
        };
        ConnectableSubscriber.prototype._complete = function () {
            this.connectable._isComplete = true;
            this._unsubscribe();
            _super.prototype._complete.call(this);
        };
        ConnectableSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (connectable) {
                this.connectable = null;
                var connection = connectable._connection;
                connectable._refCount = 0;
                connectable._subject = null;
                connectable._connection = null;
                if (connection) {
                    connection.unsubscribe();
                }
            }
        };
        return ConnectableSubscriber;
    }(SubjectSubscriber));
    var RefCountSubscriber$1 = /*@__PURE__*/ (function (_super) {
        __extends(RefCountSubscriber, _super);
        function RefCountSubscriber(destination, connectable) {
            var _this = _super.call(this, destination) || this;
            _this.connectable = connectable;
            return _this;
        }
        RefCountSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (!connectable) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var refCount$$1 = connectable._refCount;
            if (refCount$$1 <= 0) {
                this.connection = null;
                return;
            }
            connectable._refCount = refCount$$1 - 1;
            if (refCount$$1 > 1) {
                this.connection = null;
                return;
            }
            var connection = this.connection;
            var sharedConnection = connectable._connection;
            this.connection = null;
            if (sharedConnection && (!connection || sharedConnection === connection)) {
                sharedConnection.unsubscribe();
            }
        };
        return RefCountSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */
    var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(GroupBySubscriber, _super);
        function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
            var _this = _super.call(this, destination) || this;
            _this.keySelector = keySelector;
            _this.elementSelector = elementSelector;
            _this.durationSelector = durationSelector;
            _this.subjectSelector = subjectSelector;
            _this.groups = null;
            _this.attemptedToUnsubscribe = false;
            _this.count = 0;
            return _this;
        }
        GroupBySubscriber.prototype._next = function (value) {
            var key;
            try {
                key = this.keySelector(value);
            }
            catch (err) {
                this.error(err);
                return;
            }
            this._group(value, key);
        };
        GroupBySubscriber.prototype._group = function (value, key) {
            var groups = this.groups;
            if (!groups) {
                groups = this.groups = new Map();
            }
            var group = groups.get(key);
            var element;
            if (this.elementSelector) {
                try {
                    element = this.elementSelector(value);
                }
                catch (err) {
                    this.error(err);
                }
            }
            else {
                element = value;
            }
            if (!group) {
                group = (this.subjectSelector ? this.subjectSelector() : new Subject());
                groups.set(key, group);
                var groupedObservable = new GroupedObservable(key, group, this);
                this.destination.next(groupedObservable);
                if (this.durationSelector) {
                    var duration = void 0;
                    try {
                        duration = this.durationSelector(new GroupedObservable(key, group));
                    }
                    catch (err) {
                        this.error(err);
                        return;
                    }
                    this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
                }
            }
            if (!group.closed) {
                group.next(element);
            }
        };
        GroupBySubscriber.prototype._error = function (err) {
            var groups = this.groups;
            if (groups) {
                groups.forEach(function (group, key) {
                    group.error(err);
                });
                groups.clear();
            }
            this.destination.error(err);
        };
        GroupBySubscriber.prototype._complete = function () {
            var groups = this.groups;
            if (groups) {
                groups.forEach(function (group, key) {
                    group.complete();
                });
                groups.clear();
            }
            this.destination.complete();
        };
        GroupBySubscriber.prototype.removeGroup = function (key) {
            this.groups.delete(key);
        };
        GroupBySubscriber.prototype.unsubscribe = function () {
            if (!this.closed) {
                this.attemptedToUnsubscribe = true;
                if (this.count === 0) {
                    _super.prototype.unsubscribe.call(this);
                }
            }
        };
        return GroupBySubscriber;
    }(Subscriber));
    var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(GroupDurationSubscriber, _super);
        function GroupDurationSubscriber(key, group, parent) {
            var _this = _super.call(this, group) || this;
            _this.key = key;
            _this.group = group;
            _this.parent = parent;
            return _this;
        }
        GroupDurationSubscriber.prototype._next = function (value) {
            this.complete();
        };
        GroupDurationSubscriber.prototype._unsubscribe = function () {
            var _a = this, parent = _a.parent, key = _a.key;
            this.key = this.parent = null;
            if (parent) {
                parent.removeGroup(key);
            }
        };
        return GroupDurationSubscriber;
    }(Subscriber));
    var GroupedObservable = /*@__PURE__*/ (function (_super) {
        __extends(GroupedObservable, _super);
        function GroupedObservable(key, groupSubject, refCountSubscription) {
            var _this = _super.call(this) || this;
            _this.key = key;
            _this.groupSubject = groupSubject;
            _this.refCountSubscription = refCountSubscription;
            return _this;
        }
        GroupedObservable.prototype._subscribe = function (subscriber) {
            var subscription = new Subscription();
            var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
            if (refCountSubscription && !refCountSubscription.closed) {
                subscription.add(new InnerRefCountSubscription(refCountSubscription));
            }
            subscription.add(groupSubject.subscribe(subscriber));
            return subscription;
        };
        return GroupedObservable;
    }(Observable));
    var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
        __extends(InnerRefCountSubscription, _super);
        function InnerRefCountSubscription(parent) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            parent.count++;
            return _this;
        }
        InnerRefCountSubscription.prototype.unsubscribe = function () {
            var parent = this.parent;
            if (!parent.closed && !this.closed) {
                _super.prototype.unsubscribe.call(this);
                parent.count -= 1;
                if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                    parent.unsubscribe();
                }
            }
        };
        return InnerRefCountSubscription;
    }(Subscription));

    /** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */
    var BehaviorSubject = /*@__PURE__*/ (function (_super) {
        __extends(BehaviorSubject, _super);
        function BehaviorSubject(_value) {
            var _this = _super.call(this) || this;
            _this._value = _value;
            return _this;
        }
        Object.defineProperty(BehaviorSubject.prototype, "value", {
            get: function () {
                return this.getValue();
            },
            enumerable: true,
            configurable: true
        });
        BehaviorSubject.prototype._subscribe = function (subscriber) {
            var subscription = _super.prototype._subscribe.call(this, subscriber);
            if (subscription && !subscription.closed) {
                subscriber.next(this._value);
            }
            return subscription;
        };
        BehaviorSubject.prototype.getValue = function () {
            if (this.hasError) {
                throw this.thrownError;
            }
            else if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else {
                return this._value;
            }
        };
        BehaviorSubject.prototype.next = function (value) {
            _super.prototype.next.call(this, this._value = value);
        };
        return BehaviorSubject;
    }(Subject));

    /** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
    var Action = /*@__PURE__*/ (function (_super) {
        __extends(Action, _super);
        function Action(scheduler, work) {
            return _super.call(this) || this;
        }
        Action.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return this;
        };
        return Action;
    }(Subscription));

    /** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
    var AsyncAction = /*@__PURE__*/ (function (_super) {
        __extends(AsyncAction, _super);
        function AsyncAction(scheduler, work) {
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            _this.pending = false;
            return _this;
        }
        AsyncAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (this.closed) {
                return this;
            }
            this.state = state;
            var id = this.id;
            var scheduler = this.scheduler;
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, delay);
            }
            this.pending = true;
            this.delay = delay;
            this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
            return this;
        };
        AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return setInterval(scheduler.flush.bind(scheduler, this), delay);
        };
        AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay !== null && this.delay === delay && this.pending === false) {
                return id;
            }
            clearInterval(id);
        };
        AsyncAction.prototype.execute = function (state, delay) {
            if (this.closed) {
                return new Error('executing a cancelled action');
            }
            this.pending = false;
            var error = this._execute(state, delay);
            if (error) {
                return error;
            }
            else if (this.pending === false && this.id != null) {
                this.id = this.recycleAsyncId(this.scheduler, this.id, null);
            }
        };
        AsyncAction.prototype._execute = function (state, delay) {
            var errored = false;
            var errorValue = undefined;
            try {
                this.work(state);
            }
            catch (e) {
                errored = true;
                errorValue = !!e && e || new Error(e);
            }
            if (errored) {
                this.unsubscribe();
                return errorValue;
            }
        };
        AsyncAction.prototype._unsubscribe = function () {
            var id = this.id;
            var scheduler = this.scheduler;
            var actions = scheduler.actions;
            var index = actions.indexOf(this);
            this.work = null;
            this.state = null;
            this.pending = false;
            this.scheduler = null;
            if (index !== -1) {
                actions.splice(index, 1);
            }
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
        };
        return AsyncAction;
    }(Action));

    /** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
    var QueueAction = /*@__PURE__*/ (function (_super) {
        __extends(QueueAction, _super);
        function QueueAction(scheduler, work) {
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            return _this;
        }
        QueueAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay > 0) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.delay = delay;
            this.state = state;
            this.scheduler.flush(this);
            return this;
        };
        QueueAction.prototype.execute = function (state, delay) {
            return (delay > 0 || this.closed) ?
                _super.prototype.execute.call(this, state, delay) :
                this._execute(state, delay);
        };
        QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            return scheduler.flush(this);
        };
        return QueueAction;
    }(AsyncAction));

    var Scheduler = /*@__PURE__*/ (function () {
        function Scheduler(SchedulerAction, now) {
            if (now === void 0) {
                now = Scheduler.now;
            }
            this.SchedulerAction = SchedulerAction;
            this.now = now;
        }
        Scheduler.prototype.schedule = function (work, delay, state) {
            if (delay === void 0) {
                delay = 0;
            }
            return new this.SchedulerAction(this, work).schedule(state, delay);
        };
        Scheduler.now = function () { return Date.now(); };
        return Scheduler;
    }());

    /** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
    var AsyncScheduler = /*@__PURE__*/ (function (_super) {
        __extends(AsyncScheduler, _super);
        function AsyncScheduler(SchedulerAction, now) {
            if (now === void 0) {
                now = Scheduler.now;
            }
            var _this = _super.call(this, SchedulerAction, function () {
                if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                    return AsyncScheduler.delegate.now();
                }
                else {
                    return now();
                }
            }) || this;
            _this.actions = [];
            _this.active = false;
            _this.scheduled = undefined;
            return _this;
        }
        AsyncScheduler.prototype.schedule = function (work, delay, state) {
            if (delay === void 0) {
                delay = 0;
            }
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
                return AsyncScheduler.delegate.schedule(work, delay, state);
            }
            else {
                return _super.prototype.schedule.call(this, work, delay, state);
            }
        };
        AsyncScheduler.prototype.flush = function (action) {
            var actions = this.actions;
            if (this.active) {
                actions.push(action);
                return;
            }
            var error;
            this.active = true;
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (action = actions.shift());
            this.active = false;
            if (error) {
                while (action = actions.shift()) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AsyncScheduler;
    }(Scheduler));

    /** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
    var QueueScheduler = /*@__PURE__*/ (function (_super) {
        __extends(QueueScheduler, _super);
        function QueueScheduler() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return QueueScheduler;
    }(AsyncScheduler));

    /** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */
    var queue$1 = /*@__PURE__*/ new QueueScheduler(QueueAction);

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
    var EMPTY = /*@__PURE__*/ new Observable(function (subscriber) { return subscriber.complete(); });
    function empty$1(scheduler) {
        return scheduler ? emptyScheduled(scheduler) : EMPTY;
    }
    function emptyScheduled(scheduler) {
        return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isScheduler(value) {
        return value && typeof value.schedule === 'function';
    }

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var subscribeToArray = function (array) {
        return function (subscriber) {
            for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            if (!subscriber.closed) {
                subscriber.complete();
            }
        };
    };

    /** PURE_IMPORTS_START _Observable,_Subscription,_util_subscribeToArray PURE_IMPORTS_END */
    function fromArray(input, scheduler) {
        if (!scheduler) {
            return new Observable(subscribeToArray(input));
        }
        else {
            return new Observable(function (subscriber) {
                var sub = new Subscription();
                var i = 0;
                sub.add(scheduler.schedule(function () {
                    if (i === input.length) {
                        subscriber.complete();
                        return;
                    }
                    subscriber.next(input[i++]);
                    if (!subscriber.closed) {
                        sub.add(this.schedule());
                    }
                }));
                return sub;
            });
        }
    }

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
    function scalar(value) {
        var result = new Observable(function (subscriber) {
            subscriber.next(value);
            subscriber.complete();
        });
        result._isScalar = true;
        result.value = value;
        return result;
    }

    /** PURE_IMPORTS_START _util_isScheduler,_fromArray,_empty,_scalar PURE_IMPORTS_END */
    function of() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var scheduler = args[args.length - 1];
        if (isScheduler(scheduler)) {
            args.pop();
        }
        else {
            scheduler = undefined;
        }
        switch (args.length) {
            case 0:
                return empty$1(scheduler);
            case 1:
                return scheduler ? fromArray(args, scheduler) : scalar(args[0]);
            default:
                return fromArray(args, scheduler);
        }
    }

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
    function throwError(error, scheduler) {
        if (!scheduler) {
            return new Observable(function (subscriber) { return subscriber.error(error); });
        }
        else {
            return new Observable(function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
        }
    }
    function dispatch(_a) {
        var error = _a.error, subscriber = _a.subscriber;
        subscriber.error(error);
    }

    /** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */
    var Notification = /*@__PURE__*/ (function () {
        function Notification(kind, value, error) {
            this.kind = kind;
            this.value = value;
            this.error = error;
            this.hasValue = kind === 'N';
        }
        Notification.prototype.observe = function (observer) {
            switch (this.kind) {
                case 'N':
                    return observer.next && observer.next(this.value);
                case 'E':
                    return observer.error && observer.error(this.error);
                case 'C':
                    return observer.complete && observer.complete();
            }
        };
        Notification.prototype.do = function (next, error, complete) {
            var kind = this.kind;
            switch (kind) {
                case 'N':
                    return next && next(this.value);
                case 'E':
                    return error && error(this.error);
                case 'C':
                    return complete && complete();
            }
        };
        Notification.prototype.accept = function (nextOrObserver, error, complete) {
            if (nextOrObserver && typeof nextOrObserver.next === 'function') {
                return this.observe(nextOrObserver);
            }
            else {
                return this.do(nextOrObserver, error, complete);
            }
        };
        Notification.prototype.toObservable = function () {
            var kind = this.kind;
            switch (kind) {
                case 'N':
                    return of(this.value);
                case 'E':
                    return throwError(this.error);
                case 'C':
                    return empty$1();
            }
            throw new Error('unexpected notification kind value');
        };
        Notification.createNext = function (value) {
            if (typeof value !== 'undefined') {
                return new Notification('N', value);
            }
            return Notification.undefinedValueNotification;
        };
        Notification.createError = function (err) {
            return new Notification('E', undefined, err);
        };
        Notification.createComplete = function () {
            return Notification.completeNotification;
        };
        Notification.completeNotification = new Notification('C');
        Notification.undefinedValueNotification = new Notification('N', undefined);
        return Notification;
    }());

    /** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
    var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ObserveOnSubscriber, _super);
        function ObserveOnSubscriber(destination, scheduler, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            var _this = _super.call(this, destination) || this;
            _this.scheduler = scheduler;
            _this.delay = delay;
            return _this;
        }
        ObserveOnSubscriber.dispatch = function (arg) {
            var notification = arg.notification, destination = arg.destination;
            notification.observe(destination);
            this.unsubscribe();
        };
        ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
            var destination = this.destination;
            destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
        };
        ObserveOnSubscriber.prototype._next = function (value) {
            this.scheduleMessage(Notification.createNext(value));
        };
        ObserveOnSubscriber.prototype._error = function (err) {
            this.scheduleMessage(Notification.createError(err));
            this.unsubscribe();
        };
        ObserveOnSubscriber.prototype._complete = function () {
            this.scheduleMessage(Notification.createComplete());
            this.unsubscribe();
        };
        return ObserveOnSubscriber;
    }(Subscriber));
    var ObserveOnMessage = /*@__PURE__*/ (function () {
        function ObserveOnMessage(notification, destination) {
            this.notification = notification;
            this.destination = destination;
        }
        return ObserveOnMessage;
    }());

    /** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */
    var ReplaySubject = /*@__PURE__*/ (function (_super) {
        __extends(ReplaySubject, _super);
        function ReplaySubject(bufferSize, windowTime, scheduler) {
            if (bufferSize === void 0) {
                bufferSize = Number.POSITIVE_INFINITY;
            }
            if (windowTime === void 0) {
                windowTime = Number.POSITIVE_INFINITY;
            }
            var _this = _super.call(this) || this;
            _this.scheduler = scheduler;
            _this._events = [];
            _this._infiniteTimeWindow = false;
            _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
            _this._windowTime = windowTime < 1 ? 1 : windowTime;
            if (windowTime === Number.POSITIVE_INFINITY) {
                _this._infiniteTimeWindow = true;
                _this.next = _this.nextInfiniteTimeWindow;
            }
            else {
                _this.next = _this.nextTimeWindow;
            }
            return _this;
        }
        ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) {
                _events.shift();
            }
            _super.prototype.next.call(this, value);
        };
        ReplaySubject.prototype.nextTimeWindow = function (value) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
            _super.prototype.next.call(this, value);
        };
        ReplaySubject.prototype._subscribe = function (subscriber) {
            var _infiniteTimeWindow = this._infiniteTimeWindow;
            var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
            var scheduler = this.scheduler;
            var len = _events.length;
            var subscription;
            if (this.closed) {
                throw new ObjectUnsubscribedError();
            }
            else if (this.isStopped || this.hasError) {
                subscription = Subscription.EMPTY;
            }
            else {
                this.observers.push(subscriber);
                subscription = new SubjectSubscription(this, subscriber);
            }
            if (scheduler) {
                subscriber.add(subscriber = new ObserveOnSubscriber(subscriber, scheduler));
            }
            if (_infiniteTimeWindow) {
                for (var i = 0; i < len && !subscriber.closed; i++) {
                    subscriber.next(_events[i]);
                }
            }
            else {
                for (var i = 0; i < len && !subscriber.closed; i++) {
                    subscriber.next(_events[i].value);
                }
            }
            if (this.hasError) {
                subscriber.error(this.thrownError);
            }
            else if (this.isStopped) {
                subscriber.complete();
            }
            return subscription;
        };
        ReplaySubject.prototype._getNow = function () {
            return (this.scheduler || queue$1).now();
        };
        ReplaySubject.prototype._trimBufferThenGetEvents = function () {
            var now = this._getNow();
            var _bufferSize = this._bufferSize;
            var _windowTime = this._windowTime;
            var _events = this._events;
            var eventsCount = _events.length;
            var spliceCount = 0;
            while (spliceCount < eventsCount) {
                if ((now - _events[spliceCount].time) < _windowTime) {
                    break;
                }
                spliceCount++;
            }
            if (eventsCount > _bufferSize) {
                spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
            }
            if (spliceCount > 0) {
                _events.splice(0, spliceCount);
            }
            return _events;
        };
        return ReplaySubject;
    }(Subject));
    var ReplayEvent = /*@__PURE__*/ (function () {
        function ReplayEvent(time, value) {
            this.time = time;
            this.value = value;
        }
        return ReplayEvent;
    }());

    /** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */
    var AsyncSubject = /*@__PURE__*/ (function (_super) {
        __extends(AsyncSubject, _super);
        function AsyncSubject() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.value = null;
            _this.hasNext = false;
            _this.hasCompleted = false;
            return _this;
        }
        AsyncSubject.prototype._subscribe = function (subscriber) {
            if (this.hasError) {
                subscriber.error(this.thrownError);
                return Subscription.EMPTY;
            }
            else if (this.hasCompleted && this.hasNext) {
                subscriber.next(this.value);
                subscriber.complete();
                return Subscription.EMPTY;
            }
            return _super.prototype._subscribe.call(this, subscriber);
        };
        AsyncSubject.prototype.next = function (value) {
            if (!this.hasCompleted) {
                this.value = value;
                this.hasNext = true;
            }
        };
        AsyncSubject.prototype.error = function (error) {
            if (!this.hasCompleted) {
                _super.prototype.error.call(this, error);
            }
        };
        AsyncSubject.prototype.complete = function () {
            this.hasCompleted = true;
            if (this.hasNext) {
                _super.prototype.next.call(this, this.value);
            }
            _super.prototype.complete.call(this);
        };
        return AsyncSubject;
    }(Subject));

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var nextHandle = 1;
    var tasksByHandle = {};
    function runIfPresent(handle) {
        var cb = tasksByHandle[handle];
        if (cb) {
            cb();
        }
    }
    var Immediate = {
        setImmediate: function (cb) {
            var handle = nextHandle++;
            tasksByHandle[handle] = cb;
            Promise.resolve().then(function () { return runIfPresent(handle); });
            return handle;
        },
        clearImmediate: function (handle) {
            delete tasksByHandle[handle];
        },
    };

    /** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */
    var AsapAction = /*@__PURE__*/ (function (_super) {
        __extends(AsapAction, _super);
        function AsapAction(scheduler, work) {
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            return _this;
        }
        AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay !== null && delay > 0) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            scheduler.actions.push(this);
            return scheduler.scheduled || (scheduler.scheduled = Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
        };
        AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
            }
            if (scheduler.actions.length === 0) {
                Immediate.clearImmediate(id);
                scheduler.scheduled = undefined;
            }
            return undefined;
        };
        return AsapAction;
    }(AsyncAction));

    /** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
    var AsapScheduler = /*@__PURE__*/ (function (_super) {
        __extends(AsapScheduler, _super);
        function AsapScheduler() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AsapScheduler.prototype.flush = function (action) {
            this.active = true;
            this.scheduled = undefined;
            var actions = this.actions;
            var error;
            var index = -1;
            var count = actions.length;
            action = action || actions.shift();
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (++index < count && (action = actions.shift()));
            this.active = false;
            if (error) {
                while (++index < count && (action = actions.shift())) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AsapScheduler;
    }(AsyncScheduler));

    /** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */
    var asap = /*@__PURE__*/ new AsapScheduler(AsapAction);

    /** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
    var async = /*@__PURE__*/ new AsyncScheduler(AsyncAction);

    /** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
    var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
        __extends(AnimationFrameAction, _super);
        function AnimationFrameAction(scheduler, work) {
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            return _this;
        }
        AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay !== null && delay > 0) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            scheduler.actions.push(this);
            return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
        };
        AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
                return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
            }
            if (scheduler.actions.length === 0) {
                cancelAnimationFrame(id);
                scheduler.scheduled = undefined;
            }
            return undefined;
        };
        return AnimationFrameAction;
    }(AsyncAction));

    /** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
    var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
        __extends(AnimationFrameScheduler, _super);
        function AnimationFrameScheduler() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AnimationFrameScheduler.prototype.flush = function (action) {
            this.active = true;
            this.scheduled = undefined;
            var actions = this.actions;
            var error;
            var index = -1;
            var count = actions.length;
            action = action || actions.shift();
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (++index < count && (action = actions.shift()));
            this.active = false;
            if (error) {
                while (++index < count && (action = actions.shift())) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AnimationFrameScheduler;
    }(AsyncScheduler));

    /** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */
    var animationFrame = /*@__PURE__*/ new AnimationFrameScheduler(AnimationFrameAction);

    /** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
    var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
        __extends(VirtualTimeScheduler, _super);
        function VirtualTimeScheduler(SchedulerAction, maxFrames) {
            if (SchedulerAction === void 0) {
                SchedulerAction = VirtualAction;
            }
            if (maxFrames === void 0) {
                maxFrames = Number.POSITIVE_INFINITY;
            }
            var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
            _this.maxFrames = maxFrames;
            _this.frame = 0;
            _this.index = -1;
            return _this;
        }
        VirtualTimeScheduler.prototype.flush = function () {
            var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
            var error, action;
            while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            }
            if (error) {
                while (action = actions.shift()) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        VirtualTimeScheduler.frameTimeFactor = 10;
        return VirtualTimeScheduler;
    }(AsyncScheduler));
    var VirtualAction = /*@__PURE__*/ (function (_super) {
        __extends(VirtualAction, _super);
        function VirtualAction(scheduler, work, index) {
            if (index === void 0) {
                index = scheduler.index += 1;
            }
            var _this = _super.call(this, scheduler, work) || this;
            _this.scheduler = scheduler;
            _this.work = work;
            _this.index = index;
            _this.active = true;
            _this.index = scheduler.index = index;
            return _this;
        }
        VirtualAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (!this.id) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        };
        VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            this.delay = scheduler.frame + delay;
            var actions = scheduler.actions;
            actions.push(this);
            actions.sort(VirtualAction.sortActions);
            return true;
        };
        VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return undefined;
        };
        VirtualAction.prototype._execute = function (state, delay) {
            if (this.active === true) {
                return _super.prototype._execute.call(this, state, delay);
            }
        };
        VirtualAction.sortActions = function (a, b) {
            if (a.delay === b.delay) {
                if (a.index === b.index) {
                    return 0;
                }
                else if (a.index > b.index) {
                    return 1;
                }
                else {
                    return -1;
                }
            }
            else if (a.delay > b.delay) {
                return 1;
            }
            else {
                return -1;
            }
        };
        return VirtualAction;
    }(AsyncAction));

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    var EmptyError = EmptyErrorImpl;

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    function map(project, thisArg) {
        return function mapOperation(source) {
            if (typeof project !== 'function') {
                throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
            }
            return source.lift(new MapOperator(project, thisArg));
        };
    }
    var MapOperator = /*@__PURE__*/ (function () {
        function MapOperator(project, thisArg) {
            this.project = project;
            this.thisArg = thisArg;
        }
        MapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
        };
        return MapOperator;
    }());
    var MapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MapSubscriber, _super);
        function MapSubscriber(destination, project, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.count = 0;
            _this.thisArg = thisArg || _this;
            return _this;
        }
        MapSubscriber.prototype._next = function (value) {
            var result;
            try {
                result = this.project.call(this.thisArg, value, this.count++);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return MapSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var OuterSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(OuterSubscriber, _super);
        function OuterSubscriber() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(innerValue);
        };
        OuterSubscriber.prototype.notifyError = function (error, innerSub) {
            this.destination.error(error);
        };
        OuterSubscriber.prototype.notifyComplete = function (innerSub) {
            this.destination.complete();
        };
        return OuterSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var InnerSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(InnerSubscriber, _super);
        function InnerSubscriber(parent, outerValue, outerIndex) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            _this.outerValue = outerValue;
            _this.outerIndex = outerIndex;
            _this.index = 0;
            return _this;
        }
        InnerSubscriber.prototype._next = function (value) {
            this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
        };
        InnerSubscriber.prototype._error = function (error) {
            this.parent.notifyError(error, this);
            this.unsubscribe();
        };
        InnerSubscriber.prototype._complete = function () {
            this.parent.notifyComplete(this);
            this.unsubscribe();
        };
        return InnerSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
    var subscribeToPromise = function (promise) {
        return function (subscriber) {
            promise.then(function (value) {
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function (err) { return subscriber.error(err); })
                .then(null, hostReportError);
            return subscriber;
        };
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function getSymbolIterator() {
        if (typeof Symbol !== 'function' || !Symbol.iterator) {
            return '@@iterator';
        }
        return Symbol.iterator;
    }
    var iterator = /*@__PURE__*/ getSymbolIterator();

    /** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
    var subscribeToIterable = function (iterable) {
        return function (subscriber) {
            var iterator$$1 = iterable[iterator]();
            do {
                var item = iterator$$1.next();
                if (item.done) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(item.value);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
            if (typeof iterator$$1.return === 'function') {
                subscriber.add(function () {
                    if (iterator$$1.return) {
                        iterator$$1.return();
                    }
                });
            }
            return subscriber;
        };
    };

    /** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
    var subscribeToObservable = function (obj) {
        return function (subscriber) {
            var obs = obj[observable]();
            if (typeof obs.subscribe !== 'function') {
                throw new TypeError('Provided object does not correctly implement Symbol.observable');
            }
            else {
                return obs.subscribe(subscriber);
            }
        };
    };

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */
    function isPromise(value) {
        return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
    }

    /** PURE_IMPORTS_START _Observable,_subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
    var subscribeTo = function (result) {
        if (result instanceof Observable) {
            return function (subscriber) {
                if (result._isScalar) {
                    subscriber.next(result.value);
                    subscriber.complete();
                    return undefined;
                }
                else {
                    return result.subscribe(subscriber);
                }
            };
        }
        else if (result && typeof result[observable] === 'function') {
            return subscribeToObservable(result);
        }
        else if (isArrayLike(result)) {
            return subscribeToArray(result);
        }
        else if (isPromise(result)) {
            return subscribeToPromise(result);
        }
        else if (result && typeof result[iterator] === 'function') {
            return subscribeToIterable(result);
        }
        else {
            var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
            var msg = "You provided " + value + " where a stream was expected."
                + ' You can provide an Observable, Promise, Array, or Iterable.';
            throw new TypeError(msg);
        }
    };

    /** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo PURE_IMPORTS_END */
    function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, destination) {
        if (destination === void 0) {
            destination = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
        }
        if (destination.closed) {
            return;
        }
        return subscribeTo(result)(destination);
    }

    /** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */
    var NONE = {};
    var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(CombineLatestSubscriber, _super);
        function CombineLatestSubscriber(destination, resultSelector) {
            var _this = _super.call(this, destination) || this;
            _this.resultSelector = resultSelector;
            _this.active = 0;
            _this.values = [];
            _this.observables = [];
            return _this;
        }
        CombineLatestSubscriber.prototype._next = function (observable) {
            this.values.push(NONE);
            this.observables.push(observable);
        };
        CombineLatestSubscriber.prototype._complete = function () {
            var observables = this.observables;
            var len = observables.length;
            if (len === 0) {
                this.destination.complete();
            }
            else {
                this.active = len;
                this.toRespond = len;
                for (var i = 0; i < len; i++) {
                    var observable = observables[i];
                    this.add(subscribeToResult(this, observable, observable, i));
                }
            }
        };
        CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
            if ((this.active -= 1) === 0) {
                this.destination.complete();
            }
        };
        CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var values = this.values;
            var oldVal = values[outerIndex];
            var toRespond = !this.toRespond
                ? 0
                : oldVal === NONE ? --this.toRespond : this.toRespond;
            values[outerIndex] = innerValue;
            if (toRespond === 0) {
                if (this.resultSelector) {
                    this._tryResultSelector(values);
                }
                else {
                    this.destination.next(values.slice());
                }
            }
        };
        CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
            var result;
            try {
                result = this.resultSelector.apply(this, values);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return CombineLatestSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_Subscription,_util_subscribeToPromise PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator,_util_subscribeToIterable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable,_util_subscribeToObservable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_util_isPromise,_util_isArrayLike,_util_isInteropObservable,_util_isIterable,_fromArray,_fromPromise,_fromIterable,_fromObservable,_util_subscribeTo PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber,_map,_observable_from PURE_IMPORTS_END */
    var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MergeMapSubscriber, _super);
        function MergeMapSubscriber(destination, project, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.concurrent = concurrent;
            _this.hasCompleted = false;
            _this.buffer = [];
            _this.active = 0;
            _this.index = 0;
            return _this;
        }
        MergeMapSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
                this._tryNext(value);
            }
            else {
                this.buffer.push(value);
            }
        };
        MergeMapSubscriber.prototype._tryNext = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.active++;
            this._innerSub(result, value, index);
        };
        MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
            var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
            var destination = this.destination;
            destination.add(innerSubscriber);
            subscribeToResult(this, ish, value, index, innerSubscriber);
        };
        MergeMapSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
                this.destination.complete();
            }
            this.unsubscribe();
        };
        MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(innerValue);
        };
        MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            this.remove(innerSub);
            this.active--;
            if (buffer.length > 0) {
                this._next(buffer.shift());
            }
            else if (this.active === 0 && this.hasCompleted) {
                this.destination.complete();
            }
        };
        return MergeMapSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _util_isScheduler,_of,_from,_operators_concatAll PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Observable,_util_isArray,_empty,_util_subscribeToResult,_OuterSubscriber,_operators_map PURE_IMPORTS_END */
    var ForkJoinSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ForkJoinSubscriber, _super);
        function ForkJoinSubscriber(destination, sources) {
            var _this = _super.call(this, destination) || this;
            _this.sources = sources;
            _this.completed = 0;
            _this.haveValues = 0;
            var len = sources.length;
            _this.values = new Array(len);
            for (var i = 0; i < len; i++) {
                var source = sources[i];
                var innerSubscription = subscribeToResult(_this, source, null, i);
                if (innerSubscription) {
                    _this.add(innerSubscription);
                }
            }
            return _this;
        }
        ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.values[outerIndex] = innerValue;
            if (!innerSub._hasValue) {
                innerSub._hasValue = true;
                this.haveValues++;
            }
        };
        ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
            var _a = this, destination = _a.destination, haveValues = _a.haveValues, values = _a.values;
            var len = values.length;
            if (!innerSub._hasValue) {
                destination.complete();
                return;
            }
            this.completed++;
            if (this.completed !== len) {
                return;
            }
            if (haveValues === len) {
                destination.next(values);
            }
            destination.complete();
        };
        return ForkJoinSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
    function fromEvent(target, eventName, options, resultSelector) {
        if (isFunction(options)) {
            resultSelector = options;
            options = undefined;
        }
        if (resultSelector) {
            return fromEvent(target, eventName, options).pipe(map(function (args) { return isArray$2(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
        }
        return new Observable(function (subscriber) {
            function handler(e) {
                if (arguments.length > 1) {
                    subscriber.next(Array.prototype.slice.call(arguments));
                }
                else {
                    subscriber.next(e);
                }
            }
            setupSubscription(target, eventName, handler, subscriber, options);
        });
    }
    function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else if (sourceObj && sourceObj.length) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(unsubscribe);
    }
    function isNodeStyleEventEmitter(sourceObj) {
        return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
    }
    function isJQueryStyleEventEmitter(sourceObj) {
        return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
    }
    function isEventTarget(sourceObj) {
        return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
    }

    /** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
    function isNumeric(val) {
        return !isArray$2(val) && (val - parseFloat(val) + 1) >= 0;
    }

    /** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */
    var NEVER = /*@__PURE__*/ new Observable(noop$1);

    /** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var RaceSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RaceSubscriber, _super);
        function RaceSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.hasFirst = false;
            _this.observables = [];
            _this.subscriptions = [];
            return _this;
        }
        RaceSubscriber.prototype._next = function (observable) {
            this.observables.push(observable);
        };
        RaceSubscriber.prototype._complete = function () {
            var observables = this.observables;
            var len = observables.length;
            if (len === 0) {
                this.destination.complete();
            }
            else {
                for (var i = 0; i < len && !this.hasFirst; i++) {
                    var observable = observables[i];
                    var subscription = subscribeToResult(this, observable, observable, i);
                    if (this.subscriptions) {
                        this.subscriptions.push(subscription);
                    }
                    this.add(subscription);
                }
                this.observables = null;
            }
        };
        RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            if (!this.hasFirst) {
                this.hasFirst = true;
                for (var i = 0; i < this.subscriptions.length; i++) {
                    if (i !== outerIndex) {
                        var subscription = this.subscriptions[i];
                        subscription.unsubscribe();
                        this.remove(subscription);
                    }
                }
                this.subscriptions = null;
            }
            this.destination.next(innerValue);
        };
        return RaceSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_OuterSubscriber,_util_subscribeToResult,_.._internal_symbol_iterator PURE_IMPORTS_END */
    var ZipSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ZipSubscriber, _super);
        function ZipSubscriber(destination, resultSelector, values) {
            if (values === void 0) {
                values = Object.create(null);
            }
            var _this = _super.call(this, destination) || this;
            _this.iterators = [];
            _this.active = 0;
            _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : null;
            _this.values = values;
            return _this;
        }
        ZipSubscriber.prototype._next = function (value) {
            var iterators = this.iterators;
            if (isArray$2(value)) {
                iterators.push(new StaticArrayIterator(value));
            }
            else if (typeof value[iterator] === 'function') {
                iterators.push(new StaticIterator(value[iterator]()));
            }
            else {
                iterators.push(new ZipBufferIterator(this.destination, this, value));
            }
        };
        ZipSubscriber.prototype._complete = function () {
            var iterators = this.iterators;
            var len = iterators.length;
            this.unsubscribe();
            if (len === 0) {
                this.destination.complete();
                return;
            }
            this.active = len;
            for (var i = 0; i < len; i++) {
                var iterator$$1 = iterators[i];
                if (iterator$$1.stillUnsubscribed) {
                    var destination = this.destination;
                    destination.add(iterator$$1.subscribe(iterator$$1, i));
                }
                else {
                    this.active--;
                }
            }
        };
        ZipSubscriber.prototype.notifyInactive = function () {
            this.active--;
            if (this.active === 0) {
                this.destination.complete();
            }
        };
        ZipSubscriber.prototype.checkIterators = function () {
            var iterators = this.iterators;
            var len = iterators.length;
            var destination = this.destination;
            for (var i = 0; i < len; i++) {
                var iterator$$1 = iterators[i];
                if (typeof iterator$$1.hasValue === 'function' && !iterator$$1.hasValue()) {
                    return;
                }
            }
            var shouldComplete = false;
            var args = [];
            for (var i = 0; i < len; i++) {
                var iterator$$1 = iterators[i];
                var result = iterator$$1.next();
                if (iterator$$1.hasCompleted()) {
                    shouldComplete = true;
                }
                if (result.done) {
                    destination.complete();
                    return;
                }
                args.push(result.value);
            }
            if (this.resultSelector) {
                this._tryresultSelector(args);
            }
            else {
                destination.next(args);
            }
            if (shouldComplete) {
                destination.complete();
            }
        };
        ZipSubscriber.prototype._tryresultSelector = function (args) {
            var result;
            try {
                result = this.resultSelector.apply(this, args);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return ZipSubscriber;
    }(Subscriber));
    var StaticIterator = /*@__PURE__*/ (function () {
        function StaticIterator(iterator$$1) {
            this.iterator = iterator$$1;
            this.nextResult = iterator$$1.next();
        }
        StaticIterator.prototype.hasValue = function () {
            return true;
        };
        StaticIterator.prototype.next = function () {
            var result = this.nextResult;
            this.nextResult = this.iterator.next();
            return result;
        };
        StaticIterator.prototype.hasCompleted = function () {
            var nextResult = this.nextResult;
            return nextResult && nextResult.done;
        };
        return StaticIterator;
    }());
    var StaticArrayIterator = /*@__PURE__*/ (function () {
        function StaticArrayIterator(array) {
            this.array = array;
            this.index = 0;
            this.length = 0;
            this.length = array.length;
        }
        StaticArrayIterator.prototype[iterator] = function () {
            return this;
        };
        StaticArrayIterator.prototype.next = function (value) {
            var i = this.index++;
            var array = this.array;
            return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
        };
        StaticArrayIterator.prototype.hasValue = function () {
            return this.array.length > this.index;
        };
        StaticArrayIterator.prototype.hasCompleted = function () {
            return this.array.length === this.index;
        };
        return StaticArrayIterator;
    }());
    var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
        __extends(ZipBufferIterator, _super);
        function ZipBufferIterator(destination, parent, observable) {
            var _this = _super.call(this, destination) || this;
            _this.parent = parent;
            _this.observable = observable;
            _this.stillUnsubscribed = true;
            _this.buffer = [];
            _this.isComplete = false;
            return _this;
        }
        ZipBufferIterator.prototype[iterator] = function () {
            return this;
        };
        ZipBufferIterator.prototype.next = function () {
            var buffer = this.buffer;
            if (buffer.length === 0 && this.isComplete) {
                return { value: null, done: true };
            }
            else {
                return { value: buffer.shift(), done: false };
            }
        };
        ZipBufferIterator.prototype.hasValue = function () {
            return this.buffer.length > 0;
        };
        ZipBufferIterator.prototype.hasCompleted = function () {
            return this.buffer.length === 0 && this.isComplete;
        };
        ZipBufferIterator.prototype.notifyComplete = function () {
            if (this.buffer.length > 0) {
                this.isComplete = true;
                this.parent.notifyInactive();
            }
            else {
                this.destination.complete();
            }
        };
        ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.buffer.push(innerValue);
            this.parent.checkIterators();
        };
        ZipBufferIterator.prototype.subscribe = function (value, index) {
            return subscribeToResult(this, this.observable, this, index);
        };
        return ZipBufferIterator;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var AuditSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(AuditSubscriber, _super);
        function AuditSubscriber(destination, durationSelector) {
            var _this = _super.call(this, destination) || this;
            _this.durationSelector = durationSelector;
            _this.hasValue = false;
            return _this;
        }
        AuditSubscriber.prototype._next = function (value) {
            this.value = value;
            this.hasValue = true;
            if (!this.throttled) {
                var duration = tryCatch(this.durationSelector)(value);
                if (duration === errorObject) {
                    this.destination.error(errorObject.e);
                }
                else {
                    var innerSubscription = subscribeToResult(this, duration);
                    if (!innerSubscription || innerSubscription.closed) {
                        this.clearThrottle();
                    }
                    else {
                        this.add(this.throttled = innerSubscription);
                    }
                }
            }
        };
        AuditSubscriber.prototype.clearThrottle = function () {
            var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
            if (throttled) {
                this.remove(throttled);
                this.throttled = null;
                throttled.unsubscribe();
            }
            if (hasValue) {
                this.value = null;
                this.hasValue = false;
                this.destination.next(value);
            }
        };
        AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
            this.clearThrottle();
        };
        AuditSubscriber.prototype.notifyComplete = function () {
            this.clearThrottle();
        };
        return AuditSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var BufferSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(BufferSubscriber, _super);
        function BufferSubscriber(destination, closingNotifier) {
            var _this = _super.call(this, destination) || this;
            _this.buffer = [];
            _this.add(subscribeToResult(_this, closingNotifier));
            return _this;
        }
        BufferSubscriber.prototype._next = function (value) {
            this.buffer.push(value);
        };
        BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var buffer = this.buffer;
            this.buffer = [];
            this.destination.next(buffer);
        };
        return BufferSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(BufferCountSubscriber, _super);
        function BufferCountSubscriber(destination, bufferSize) {
            var _this = _super.call(this, destination) || this;
            _this.bufferSize = bufferSize;
            _this.buffer = [];
            return _this;
        }
        BufferCountSubscriber.prototype._next = function (value) {
            var buffer = this.buffer;
            buffer.push(value);
            if (buffer.length == this.bufferSize) {
                this.destination.next(buffer);
                this.buffer = [];
            }
        };
        BufferCountSubscriber.prototype._complete = function () {
            var buffer = this.buffer;
            if (buffer.length > 0) {
                this.destination.next(buffer);
            }
            _super.prototype._complete.call(this);
        };
        return BufferCountSubscriber;
    }(Subscriber));
    var BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(BufferSkipCountSubscriber, _super);
        function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
            var _this = _super.call(this, destination) || this;
            _this.bufferSize = bufferSize;
            _this.startBufferEvery = startBufferEvery;
            _this.buffers = [];
            _this.count = 0;
            return _this;
        }
        BufferSkipCountSubscriber.prototype._next = function (value) {
            var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
            this.count++;
            if (count % startBufferEvery === 0) {
                buffers.push([]);
            }
            for (var i = buffers.length; i--;) {
                var buffer = buffers[i];
                buffer.push(value);
                if (buffer.length === bufferSize) {
                    buffers.splice(i, 1);
                    this.destination.next(buffer);
                }
            }
        };
        BufferSkipCountSubscriber.prototype._complete = function () {
            var _a = this, buffers = _a.buffers, destination = _a.destination;
            while (buffers.length > 0) {
                var buffer = buffers.shift();
                if (buffer.length > 0) {
                    destination.next(buffer);
                }
            }
            _super.prototype._complete.call(this);
        };
        return BufferSkipCountSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */
    var Context = /*@__PURE__*/ (function () {
        function Context() {
            this.buffer = [];
        }
        return Context;
    }());
    var BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(BufferTimeSubscriber, _super);
        function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.bufferTimeSpan = bufferTimeSpan;
            _this.bufferCreationInterval = bufferCreationInterval;
            _this.maxBufferSize = maxBufferSize;
            _this.scheduler = scheduler;
            _this.contexts = [];
            var context = _this.openContext();
            _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
            if (_this.timespanOnly) {
                var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
                _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
            }
            else {
                var closeState = { subscriber: _this, context: context };
                var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
                _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
                _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
            }
            return _this;
        }
        BufferTimeSubscriber.prototype._next = function (value) {
            var contexts = this.contexts;
            var len = contexts.length;
            var filledBufferContext;
            for (var i = 0; i < len; i++) {
                var context_1 = contexts[i];
                var buffer = context_1.buffer;
                buffer.push(value);
                if (buffer.length == this.maxBufferSize) {
                    filledBufferContext = context_1;
                }
            }
            if (filledBufferContext) {
                this.onBufferFull(filledBufferContext);
            }
        };
        BufferTimeSubscriber.prototype._error = function (err) {
            this.contexts.length = 0;
            _super.prototype._error.call(this, err);
        };
        BufferTimeSubscriber.prototype._complete = function () {
            var _a = this, contexts = _a.contexts, destination = _a.destination;
            while (contexts.length > 0) {
                var context_2 = contexts.shift();
                destination.next(context_2.buffer);
            }
            _super.prototype._complete.call(this);
        };
        BufferTimeSubscriber.prototype._unsubscribe = function () {
            this.contexts = null;
        };
        BufferTimeSubscriber.prototype.onBufferFull = function (context) {
            this.closeContext(context);
            var closeAction = context.closeAction;
            closeAction.unsubscribe();
            this.remove(closeAction);
            if (!this.closed && this.timespanOnly) {
                context = this.openContext();
                var bufferTimeSpan = this.bufferTimeSpan;
                var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
                this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
            }
        };
        BufferTimeSubscriber.prototype.openContext = function () {
            var context = new Context();
            this.contexts.push(context);
            return context;
        };
        BufferTimeSubscriber.prototype.closeContext = function (context) {
            this.destination.next(context.buffer);
            var contexts = this.contexts;
            var spliceIndex = contexts ? contexts.indexOf(context) : -1;
            if (spliceIndex >= 0) {
                contexts.splice(contexts.indexOf(context), 1);
            }
        };
        return BufferTimeSubscriber;
    }(Subscriber));
    function dispatchBufferTimeSpanOnly(state) {
        var subscriber = state.subscriber;
        var prevContext = state.context;
        if (prevContext) {
            subscriber.closeContext(prevContext);
        }
        if (!subscriber.closed) {
            state.context = subscriber.openContext();
            state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
        }
    }
    function dispatchBufferCreation(state) {
        var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
        var context = subscriber.openContext();
        var action = this;
        if (!subscriber.closed) {
            subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
            action.schedule(state, bufferCreationInterval);
        }
    }
    function dispatchBufferClose(arg) {
        var subscriber = arg.subscriber, context = arg.context;
        subscriber.closeContext(context);
    }

    /** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */
    var BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(BufferToggleSubscriber, _super);
        function BufferToggleSubscriber(destination, openings, closingSelector) {
            var _this = _super.call(this, destination) || this;
            _this.openings = openings;
            _this.closingSelector = closingSelector;
            _this.contexts = [];
            _this.add(subscribeToResult(_this, openings));
            return _this;
        }
        BufferToggleSubscriber.prototype._next = function (value) {
            var contexts = this.contexts;
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].buffer.push(value);
            }
        };
        BufferToggleSubscriber.prototype._error = function (err) {
            var contexts = this.contexts;
            while (contexts.length > 0) {
                var context_1 = contexts.shift();
                context_1.subscription.unsubscribe();
                context_1.buffer = null;
                context_1.subscription = null;
            }
            this.contexts = null;
            _super.prototype._error.call(this, err);
        };
        BufferToggleSubscriber.prototype._complete = function () {
            var contexts = this.contexts;
            while (contexts.length > 0) {
                var context_2 = contexts.shift();
                this.destination.next(context_2.buffer);
                context_2.subscription.unsubscribe();
                context_2.buffer = null;
                context_2.subscription = null;
            }
            this.contexts = null;
            _super.prototype._complete.call(this);
        };
        BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
        };
        BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
            this.closeBuffer(innerSub.context);
        };
        BufferToggleSubscriber.prototype.openBuffer = function (value) {
            try {
                var closingSelector = this.closingSelector;
                var closingNotifier = closingSelector.call(this, value);
                if (closingNotifier) {
                    this.trySubscribe(closingNotifier);
                }
            }
            catch (err) {
                this._error(err);
            }
        };
        BufferToggleSubscriber.prototype.closeBuffer = function (context) {
            var contexts = this.contexts;
            if (contexts && context) {
                var buffer = context.buffer, subscription = context.subscription;
                this.destination.next(buffer);
                contexts.splice(contexts.indexOf(context), 1);
                this.remove(subscription);
                subscription.unsubscribe();
            }
        };
        BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
            var contexts = this.contexts;
            var buffer = [];
            var subscription = new Subscription();
            var context = { buffer: buffer, subscription: subscription };
            contexts.push(context);
            var innerSubscription = subscribeToResult(this, closingNotifier, context);
            if (!innerSubscription || innerSubscription.closed) {
                this.closeBuffer(context);
            }
            else {
                innerSubscription.context = context;
                this.add(innerSubscription);
                subscription.add(innerSubscription);
            }
        };
        return BufferToggleSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscription,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(BufferWhenSubscriber, _super);
        function BufferWhenSubscriber(destination, closingSelector) {
            var _this = _super.call(this, destination) || this;
            _this.closingSelector = closingSelector;
            _this.subscribing = false;
            _this.openBuffer();
            return _this;
        }
        BufferWhenSubscriber.prototype._next = function (value) {
            this.buffer.push(value);
        };
        BufferWhenSubscriber.prototype._complete = function () {
            var buffer = this.buffer;
            if (buffer) {
                this.destination.next(buffer);
            }
            _super.prototype._complete.call(this);
        };
        BufferWhenSubscriber.prototype._unsubscribe = function () {
            this.buffer = null;
            this.subscribing = false;
        };
        BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.openBuffer();
        };
        BufferWhenSubscriber.prototype.notifyComplete = function () {
            if (this.subscribing) {
                this.complete();
            }
            else {
                this.openBuffer();
            }
        };
        BufferWhenSubscriber.prototype.openBuffer = function () {
            var closingSubscription = this.closingSubscription;
            if (closingSubscription) {
                this.remove(closingSubscription);
                closingSubscription.unsubscribe();
            }
            var buffer = this.buffer;
            if (this.buffer) {
                this.destination.next(buffer);
            }
            this.buffer = [];
            var closingNotifier = tryCatch(this.closingSelector)();
            if (closingNotifier === errorObject) {
                this.error(errorObject.e);
            }
            else {
                closingSubscription = new Subscription();
                this.closingSubscription = closingSubscription;
                this.add(closingSubscription);
                this.subscribing = true;
                closingSubscription.add(subscribeToResult(this, closingNotifier));
                this.subscribing = false;
            }
        };
        return BufferWhenSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var CatchSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(CatchSubscriber, _super);
        function CatchSubscriber(destination, selector, caught) {
            var _this = _super.call(this, destination) || this;
            _this.selector = selector;
            _this.caught = caught;
            return _this;
        }
        CatchSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var result = void 0;
                try {
                    result = this.selector(err, this.caught);
                }
                catch (err2) {
                    _super.prototype.error.call(this, err2);
                    return;
                }
                this._unsubscribeAndRecycle();
                var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
                this.add(innerSubscriber);
                subscribeToResult(this, result, undefined, undefined, innerSubscriber);
            }
        };
        return CatchSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var CountSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(CountSubscriber, _super);
        function CountSubscriber(destination, predicate, source) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.source = source;
            _this.count = 0;
            _this.index = 0;
            return _this;
        }
        CountSubscriber.prototype._next = function (value) {
            if (this.predicate) {
                this._tryPredicate(value);
            }
            else {
                this.count++;
            }
        };
        CountSubscriber.prototype._tryPredicate = function (value) {
            var result;
            try {
                result = this.predicate(value, this.index++, this.source);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                this.count++;
            }
        };
        CountSubscriber.prototype._complete = function () {
            this.destination.next(this.count);
            this.destination.complete();
        };
        return CountSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var DebounceSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DebounceSubscriber, _super);
        function DebounceSubscriber(destination, durationSelector) {
            var _this = _super.call(this, destination) || this;
            _this.durationSelector = durationSelector;
            _this.hasValue = false;
            _this.durationSubscription = null;
            return _this;
        }
        DebounceSubscriber.prototype._next = function (value) {
            try {
                var result = this.durationSelector.call(this, value);
                if (result) {
                    this._tryNext(value, result);
                }
            }
            catch (err) {
                this.destination.error(err);
            }
        };
        DebounceSubscriber.prototype._complete = function () {
            this.emitValue();
            this.destination.complete();
        };
        DebounceSubscriber.prototype._tryNext = function (value, duration) {
            var subscription = this.durationSubscription;
            this.value = value;
            this.hasValue = true;
            if (subscription) {
                subscription.unsubscribe();
                this.remove(subscription);
            }
            subscription = subscribeToResult(this, duration);
            if (subscription && !subscription.closed) {
                this.add(this.durationSubscription = subscription);
            }
        };
        DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.emitValue();
        };
        DebounceSubscriber.prototype.notifyComplete = function () {
            this.emitValue();
        };
        DebounceSubscriber.prototype.emitValue = function () {
            if (this.hasValue) {
                var value = this.value;
                var subscription = this.durationSubscription;
                if (subscription) {
                    this.durationSubscription = null;
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
                this.value = null;
                this.hasValue = false;
                _super.prototype._next.call(this, value);
            }
        };
        return DebounceSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */
    var DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DebounceTimeSubscriber, _super);
        function DebounceTimeSubscriber(destination, dueTime, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.dueTime = dueTime;
            _this.scheduler = scheduler;
            _this.debouncedSubscription = null;
            _this.lastValue = null;
            _this.hasValue = false;
            return _this;
        }
        DebounceTimeSubscriber.prototype._next = function (value) {
            this.clearDebounce();
            this.lastValue = value;
            this.hasValue = true;
            this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext$2, this.dueTime, this));
        };
        DebounceTimeSubscriber.prototype._complete = function () {
            this.debouncedNext();
            this.destination.complete();
        };
        DebounceTimeSubscriber.prototype.debouncedNext = function () {
            this.clearDebounce();
            if (this.hasValue) {
                var lastValue = this.lastValue;
                this.lastValue = null;
                this.hasValue = false;
                this.destination.next(lastValue);
            }
        };
        DebounceTimeSubscriber.prototype.clearDebounce = function () {
            var debouncedSubscription = this.debouncedSubscription;
            if (debouncedSubscription !== null) {
                this.remove(debouncedSubscription);
                debouncedSubscription.unsubscribe();
                this.debouncedSubscription = null;
            }
        };
        return DebounceTimeSubscriber;
    }(Subscriber));
    function dispatchNext$2(subscriber) {
        subscriber.debouncedNext();
    }

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DefaultIfEmptySubscriber, _super);
        function DefaultIfEmptySubscriber(destination, defaultValue) {
            var _this = _super.call(this, destination) || this;
            _this.defaultValue = defaultValue;
            _this.isEmpty = true;
            return _this;
        }
        DefaultIfEmptySubscriber.prototype._next = function (value) {
            this.isEmpty = false;
            this.destination.next(value);
        };
        DefaultIfEmptySubscriber.prototype._complete = function () {
            if (this.isEmpty) {
                this.destination.next(this.defaultValue);
            }
            this.destination.complete();
        };
        return DefaultIfEmptySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */
    var DelaySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DelaySubscriber, _super);
        function DelaySubscriber(destination, delay, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.delay = delay;
            _this.scheduler = scheduler;
            _this.queue = [];
            _this.active = false;
            _this.errored = false;
            return _this;
        }
        DelaySubscriber.dispatch = function (state) {
            var source = state.source;
            var queue = source.queue;
            var scheduler = state.scheduler;
            var destination = state.destination;
            while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
                queue.shift().notification.observe(destination);
            }
            if (queue.length > 0) {
                var delay_1 = Math.max(0, queue[0].time - scheduler.now());
                this.schedule(state, delay_1);
            }
            else {
                this.unsubscribe();
                source.active = false;
            }
        };
        DelaySubscriber.prototype._schedule = function (scheduler) {
            this.active = true;
            var destination = this.destination;
            destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
                source: this, destination: this.destination, scheduler: scheduler
            }));
        };
        DelaySubscriber.prototype.scheduleNotification = function (notification) {
            if (this.errored === true) {
                return;
            }
            var scheduler = this.scheduler;
            var message = new DelayMessage(scheduler.now() + this.delay, notification);
            this.queue.push(message);
            if (this.active === false) {
                this._schedule(scheduler);
            }
        };
        DelaySubscriber.prototype._next = function (value) {
            this.scheduleNotification(Notification.createNext(value));
        };
        DelaySubscriber.prototype._error = function (err) {
            this.errored = true;
            this.queue = [];
            this.destination.error(err);
            this.unsubscribe();
        };
        DelaySubscriber.prototype._complete = function () {
            this.scheduleNotification(Notification.createComplete());
            this.unsubscribe();
        };
        return DelaySubscriber;
    }(Subscriber));
    var DelayMessage = /*@__PURE__*/ (function () {
        function DelayMessage(time, notification) {
            this.time = time;
            this.notification = notification;
        }
        return DelayMessage;
    }());

    /** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DelayWhenSubscriber, _super);
        function DelayWhenSubscriber(destination, delayDurationSelector) {
            var _this = _super.call(this, destination) || this;
            _this.delayDurationSelector = delayDurationSelector;
            _this.completed = false;
            _this.delayNotifierSubscriptions = [];
            _this.index = 0;
            return _this;
        }
        DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(outerValue);
            this.removeSubscription(innerSub);
            this.tryComplete();
        };
        DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
            var value = this.removeSubscription(innerSub);
            if (value) {
                this.destination.next(value);
            }
            this.tryComplete();
        };
        DelayWhenSubscriber.prototype._next = function (value) {
            var index = this.index++;
            try {
                var delayNotifier = this.delayDurationSelector(value, index);
                if (delayNotifier) {
                    this.tryDelay(delayNotifier, value);
                }
            }
            catch (err) {
                this.destination.error(err);
            }
        };
        DelayWhenSubscriber.prototype._complete = function () {
            this.completed = true;
            this.tryComplete();
            this.unsubscribe();
        };
        DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
            subscription.unsubscribe();
            var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
            if (subscriptionIdx !== -1) {
                this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            }
            return subscription.outerValue;
        };
        DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
            var notifierSubscription = subscribeToResult(this, delayNotifier, value);
            if (notifierSubscription && !notifierSubscription.closed) {
                var destination = this.destination;
                destination.add(notifierSubscription);
                this.delayNotifierSubscriptions.push(notifierSubscription);
            }
        };
        DelayWhenSubscriber.prototype.tryComplete = function () {
            if (this.completed && this.delayNotifierSubscriptions.length === 0) {
                this.destination.complete();
            }
        };
        return DelayWhenSubscriber;
    }(OuterSubscriber));
    var SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
        __extends(SubscriptionDelayObservable, _super);
        function SubscriptionDelayObservable(source, subscriptionDelay) {
            var _this = _super.call(this) || this;
            _this.source = source;
            _this.subscriptionDelay = subscriptionDelay;
            return _this;
        }
        SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
            this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
        };
        return SubscriptionDelayObservable;
    }(Observable));
    var SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SubscriptionDelaySubscriber, _super);
        function SubscriptionDelaySubscriber(parent, source) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            _this.source = source;
            _this.sourceSubscribed = false;
            return _this;
        }
        SubscriptionDelaySubscriber.prototype._next = function (unused) {
            this.subscribeToSource();
        };
        SubscriptionDelaySubscriber.prototype._error = function (err) {
            this.unsubscribe();
            this.parent.error(err);
        };
        SubscriptionDelaySubscriber.prototype._complete = function () {
            this.unsubscribe();
            this.subscribeToSource();
        };
        SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
            if (!this.sourceSubscribed) {
                this.sourceSubscribed = true;
                this.unsubscribe();
                this.source.subscribe(this.parent);
            }
        };
        return SubscriptionDelaySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DeMaterializeSubscriber, _super);
        function DeMaterializeSubscriber(destination) {
            return _super.call(this, destination) || this;
        }
        DeMaterializeSubscriber.prototype._next = function (value) {
            value.observe(this.destination);
        };
        return DeMaterializeSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var DistinctSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DistinctSubscriber, _super);
        function DistinctSubscriber(destination, keySelector, flushes) {
            var _this = _super.call(this, destination) || this;
            _this.keySelector = keySelector;
            _this.values = new Set();
            if (flushes) {
                _this.add(subscribeToResult(_this, flushes));
            }
            return _this;
        }
        DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.values.clear();
        };
        DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        DistinctSubscriber.prototype._next = function (value) {
            if (this.keySelector) {
                this._useKeySelector(value);
            }
            else {
                this._finalizeNext(value, value);
            }
        };
        DistinctSubscriber.prototype._useKeySelector = function (value) {
            var key;
            var destination = this.destination;
            try {
                key = this.keySelector(value);
            }
            catch (err) {
                destination.error(err);
                return;
            }
            this._finalizeNext(key, value);
        };
        DistinctSubscriber.prototype._finalizeNext = function (key, value) {
            var values = this.values;
            if (!values.has(key)) {
                values.add(key);
                this.destination.next(value);
            }
        };
        return DistinctSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_tryCatch,_util_errorObject PURE_IMPORTS_END */
    var DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(DistinctUntilChangedSubscriber, _super);
        function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
            var _this = _super.call(this, destination) || this;
            _this.keySelector = keySelector;
            _this.hasKey = false;
            if (typeof compare === 'function') {
                _this.compare = compare;
            }
            return _this;
        }
        DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
            return x === y;
        };
        DistinctUntilChangedSubscriber.prototype._next = function (value) {
            var keySelector = this.keySelector;
            var key = value;
            if (keySelector) {
                key = tryCatch(this.keySelector)(value);
                if (key === errorObject) {
                    return this.destination.error(errorObject.e);
                }
            }
            var result = false;
            if (this.hasKey) {
                result = tryCatch(this.compare)(this.key, key);
                if (result === errorObject) {
                    return this.destination.error(errorObject.e);
                }
            }
            else {
                this.hasKey = true;
            }
            if (Boolean(result) === false) {
                this.key = key;
                this.destination.next(value);
            }
        };
        return DistinctUntilChangedSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var FilterSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(FilterSubscriber, _super);
        function FilterSubscriber(destination, predicate, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.thisArg = thisArg;
            _this.count = 0;
            return _this;
        }
        FilterSubscriber.prototype._next = function (value) {
            var result;
            try {
                result = this.predicate.call(this.thisArg, value, this.count++);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                this.destination.next(value);
            }
        };
        return FilterSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */
    var TapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TapSubscriber, _super);
        function TapSubscriber(destination, observerOrNext, error, complete) {
            var _this = _super.call(this, destination) || this;
            _this._tapNext = noop$1;
            _this._tapError = noop$1;
            _this._tapComplete = noop$1;
            _this._tapError = error || noop$1;
            _this._tapComplete = complete || noop$1;
            if (isFunction(observerOrNext)) {
                _this._context = _this;
                _this._tapNext = observerOrNext;
            }
            else if (observerOrNext) {
                _this._context = observerOrNext;
                _this._tapNext = observerOrNext.next || noop$1;
                _this._tapError = observerOrNext.error || noop$1;
                _this._tapComplete = observerOrNext.complete || noop$1;
            }
            return _this;
        }
        TapSubscriber.prototype._next = function (value) {
            try {
                this._tapNext.call(this._context, value);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(value);
        };
        TapSubscriber.prototype._error = function (err) {
            try {
                this._tapError.call(this._context, err);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.error(err);
        };
        TapSubscriber.prototype._complete = function () {
            try {
                this._tapComplete.call(this._context);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            return this.destination.complete();
        };
        return TapSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _tap,_util_EmptyError PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */
    function take(count) {
        return function (source) {
            if (count === 0) {
                return empty$1();
            }
            else {
                return source.lift(new TakeOperator(count));
            }
        };
    }
    var TakeOperator = /*@__PURE__*/ (function () {
        function TakeOperator(total) {
            this.total = total;
            if (this.total < 0) {
                throw new ArgumentOutOfRangeError;
            }
        }
        TakeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeSubscriber(subscriber, this.total));
        };
        return TakeOperator;
    }());
    var TakeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeSubscriber, _super);
        function TakeSubscriber(destination, total) {
            var _this = _super.call(this, destination) || this;
            _this.total = total;
            _this.count = 0;
            return _this;
        }
        TakeSubscriber.prototype._next = function (value) {
            var total = this.total;
            var count = ++this.count;
            if (count <= total) {
                this.destination.next(value);
                if (count === total) {
                    this.destination.complete();
                    this.unsubscribe();
                }
            }
        };
        return TakeSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _observable_fromArray,_observable_scalar,_observable_empty,_observable_concat,_util_isScheduler PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var EverySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(EverySubscriber, _super);
        function EverySubscriber(destination, predicate, thisArg, source) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.thisArg = thisArg;
            _this.source = source;
            _this.index = 0;
            _this.thisArg = thisArg || _this;
            return _this;
        }
        EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
            this.destination.next(everyValueMatch);
            this.destination.complete();
        };
        EverySubscriber.prototype._next = function (value) {
            var result = false;
            try {
                result = this.predicate.call(this.thisArg, value, this.index++, this.source);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            if (!result) {
                this.notifyComplete(false);
            }
        };
        EverySubscriber.prototype._complete = function () {
            this.notifyComplete(true);
        };
        return EverySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SwitchFirstSubscriber, _super);
        function SwitchFirstSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.hasCompleted = false;
            _this.hasSubscription = false;
            return _this;
        }
        SwitchFirstSubscriber.prototype._next = function (value) {
            if (!this.hasSubscription) {
                this.hasSubscription = true;
                this.add(subscribeToResult(this, value));
            }
        };
        SwitchFirstSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (!this.hasSubscription) {
                this.destination.complete();
            }
        };
        SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
            this.remove(innerSub);
            this.hasSubscription = false;
            if (this.hasCompleted) {
                this.destination.complete();
            }
        };
        return SwitchFirstSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */
    var ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ExhaustMapSubscriber, _super);
        function ExhaustMapSubscriber(destination, project) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.hasSubscription = false;
            _this.hasCompleted = false;
            _this.index = 0;
            return _this;
        }
        ExhaustMapSubscriber.prototype._next = function (value) {
            if (!this.hasSubscription) {
                this.tryNext(value);
            }
        };
        ExhaustMapSubscriber.prototype.tryNext = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.hasSubscription = true;
            this._innerSub(result, value, index);
        };
        ExhaustMapSubscriber.prototype._innerSub = function (result, value, index) {
            var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
            var destination = this.destination;
            destination.add(innerSubscriber);
            subscribeToResult(this, result, value, index, innerSubscriber);
        };
        ExhaustMapSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (!this.hasSubscription) {
                this.destination.complete();
            }
            this.unsubscribe();
        };
        ExhaustMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(innerValue);
        };
        ExhaustMapSubscriber.prototype.notifyError = function (err) {
            this.destination.error(err);
        };
        ExhaustMapSubscriber.prototype.notifyComplete = function (innerSub) {
            var destination = this.destination;
            destination.remove(innerSub);
            this.hasSubscription = false;
            if (this.hasCompleted) {
                this.destination.complete();
            }
        };
        return ExhaustMapSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var ExpandSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ExpandSubscriber, _super);
        function ExpandSubscriber(destination, project, concurrent, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.concurrent = concurrent;
            _this.scheduler = scheduler;
            _this.index = 0;
            _this.active = 0;
            _this.hasCompleted = false;
            if (concurrent < Number.POSITIVE_INFINITY) {
                _this.buffer = [];
            }
            return _this;
        }
        ExpandSubscriber.dispatch = function (arg) {
            var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
            subscriber.subscribeToProjection(result, value, index);
        };
        ExpandSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            if (destination.closed) {
                this._complete();
                return;
            }
            var index = this.index++;
            if (this.active < this.concurrent) {
                destination.next(value);
                var result = tryCatch(this.project)(value, index);
                if (result === errorObject) {
                    destination.error(errorObject.e);
                }
                else if (!this.scheduler) {
                    this.subscribeToProjection(result, value, index);
                }
                else {
                    var state = { subscriber: this, result: result, value: value, index: index };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            }
            else {
                this.buffer.push(value);
            }
        };
        ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
            this.active++;
            var destination = this.destination;
            destination.add(subscribeToResult(this, result, value, index));
        };
        ExpandSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.hasCompleted && this.active === 0) {
                this.destination.complete();
            }
            this.unsubscribe();
        };
        ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this._next(innerValue);
        };
        ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            var destination = this.destination;
            destination.remove(innerSub);
            this.active--;
            if (buffer && buffer.length > 0) {
                this._next(buffer.shift());
            }
            if (this.hasCompleted && this.active === 0) {
                this.destination.complete();
            }
        };
        return ExpandSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */
    var FinallySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(FinallySubscriber, _super);
        function FinallySubscriber(destination, callback) {
            var _this = _super.call(this, destination) || this;
            _this.add(new Subscription(callback));
            return _this;
        }
        return FinallySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var FindValueSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(FindValueSubscriber, _super);
        function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.source = source;
            _this.yieldIndex = yieldIndex;
            _this.thisArg = thisArg;
            _this.index = 0;
            return _this;
        }
        FindValueSubscriber.prototype.notifyComplete = function (value) {
            var destination = this.destination;
            destination.next(value);
            destination.complete();
            this.unsubscribe();
        };
        FindValueSubscriber.prototype._next = function (value) {
            var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
            var index = this.index++;
            try {
                var result = predicate.call(thisArg || this, value, index, this.source);
                if (result) {
                    this.notifyComplete(this.yieldIndex ? index : value);
                }
            }
            catch (err) {
                this.destination.error(err);
            }
        };
        FindValueSubscriber.prototype._complete = function () {
            this.notifyComplete(this.yieldIndex ? -1 : undefined);
        };
        return FindValueSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(IgnoreElementsSubscriber, _super);
        function IgnoreElementsSubscriber() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        IgnoreElementsSubscriber.prototype._next = function (unused) {
        };
        return IgnoreElementsSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(IsEmptySubscriber, _super);
        function IsEmptySubscriber(destination) {
            return _super.call(this, destination) || this;
        }
        IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
            var destination = this.destination;
            destination.next(isEmpty);
            destination.complete();
        };
        IsEmptySubscriber.prototype._next = function (value) {
            this.notifyComplete(false);
        };
        IsEmptySubscriber.prototype._complete = function () {
            this.notifyComplete(true);
        };
        return IsEmptySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */
    var TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeLastSubscriber, _super);
        function TakeLastSubscriber(destination, total) {
            var _this = _super.call(this, destination) || this;
            _this.total = total;
            _this.ring = new Array();
            _this.count = 0;
            return _this;
        }
        TakeLastSubscriber.prototype._next = function (value) {
            var ring = this.ring;
            var total = this.total;
            var count = this.count++;
            if (ring.length < total) {
                ring.push(value);
            }
            else {
                var index = count % total;
                ring[index] = value;
            }
        };
        TakeLastSubscriber.prototype._complete = function () {
            var destination = this.destination;
            var count = this.count;
            if (count > 0) {
                var total = this.count >= this.total ? this.total : this.count;
                var ring = this.ring;
                for (var i = 0; i < total; i++) {
                    var idx = (count++) % total;
                    destination.next(ring[idx]);
                }
            }
            destination.complete();
        };
        return TakeLastSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var MapToSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MapToSubscriber, _super);
        function MapToSubscriber(destination, value) {
            var _this = _super.call(this, destination) || this;
            _this.value = value;
            return _this;
        }
        MapToSubscriber.prototype._next = function (x) {
            this.destination.next(this.value);
        };
        return MapToSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
    var MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MaterializeSubscriber, _super);
        function MaterializeSubscriber(destination) {
            return _super.call(this, destination) || this;
        }
        MaterializeSubscriber.prototype._next = function (value) {
            this.destination.next(Notification.createNext(value));
        };
        MaterializeSubscriber.prototype._error = function (err) {
            var destination = this.destination;
            destination.next(Notification.createError(err));
            destination.complete();
        };
        MaterializeSubscriber.prototype._complete = function () {
            var destination = this.destination;
            destination.next(Notification.createComplete());
            destination.complete();
        };
        return MaterializeSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var ScanSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ScanSubscriber, _super);
        function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
            var _this = _super.call(this, destination) || this;
            _this.accumulator = accumulator;
            _this._seed = _seed;
            _this.hasSeed = hasSeed;
            _this.index = 0;
            return _this;
        }
        Object.defineProperty(ScanSubscriber.prototype, "seed", {
            get: function () {
                return this._seed;
            },
            set: function (value) {
                this.hasSeed = true;
                this._seed = value;
            },
            enumerable: true,
            configurable: true
        });
        ScanSubscriber.prototype._next = function (value) {
            if (!this.hasSeed) {
                this.seed = value;
                this.destination.next(value);
            }
            else {
                return this._tryNext(value);
            }
        };
        ScanSubscriber.prototype._tryNext = function (value) {
            var index = this.index++;
            var result;
            try {
                result = this.accumulator(this.seed, value, index);
            }
            catch (err) {
                this.destination.error(err);
            }
            this.seed = result;
            this.destination.next(result);
        };
        return ScanSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_util_subscribeToResult,_OuterSubscriber,_InnerSubscriber PURE_IMPORTS_END */
    var MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(MergeScanSubscriber, _super);
        function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
            var _this = _super.call(this, destination) || this;
            _this.accumulator = accumulator;
            _this.acc = acc;
            _this.concurrent = concurrent;
            _this.hasValue = false;
            _this.hasCompleted = false;
            _this.buffer = [];
            _this.active = 0;
            _this.index = 0;
            return _this;
        }
        MergeScanSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
                var index = this.index++;
                var ish = tryCatch(this.accumulator)(this.acc, value);
                var destination = this.destination;
                if (ish === errorObject) {
                    destination.error(errorObject.e);
                }
                else {
                    this.active++;
                    this._innerSub(ish, value, index);
                }
            }
            else {
                this.buffer.push(value);
            }
        };
        MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
            var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
            var destination = this.destination;
            destination.add(innerSubscriber);
            subscribeToResult(this, ish, value, index, innerSubscriber);
        };
        MergeScanSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
                if (this.hasValue === false) {
                    this.destination.next(this.acc);
                }
                this.destination.complete();
            }
            this.unsubscribe();
        };
        MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var destination = this.destination;
            this.acc = innerValue;
            this.hasValue = true;
            destination.next(innerValue);
        };
        MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            var destination = this.destination;
            destination.remove(innerSub);
            this.active--;
            if (buffer.length > 0) {
                this._next(buffer.shift());
            }
            else if (this.active === 0 && this.hasCompleted) {
                if (this.hasValue === false) {
                    this.destination.next(this.acc);
                }
                this.destination.complete();
            }
        };
        return MergeScanSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(OnErrorResumeNextSubscriber, _super);
        function OnErrorResumeNextSubscriber(destination, nextSources) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            _this.nextSources = nextSources;
            return _this;
        }
        OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
            this.subscribeToNextSource();
        };
        OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
            this.subscribeToNextSource();
        };
        OnErrorResumeNextSubscriber.prototype._error = function (err) {
            this.subscribeToNextSource();
            this.unsubscribe();
        };
        OnErrorResumeNextSubscriber.prototype._complete = function () {
            this.subscribeToNextSource();
            this.unsubscribe();
        };
        OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
            var next = this.nextSources.shift();
            if (next) {
                var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
                var destination = this.destination;
                destination.add(innerSubscriber);
                subscribeToResult(this, next, undefined, undefined, innerSubscriber);
            }
            else {
                this.destination.complete();
            }
        };
        return OnErrorResumeNextSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(PairwiseSubscriber, _super);
        function PairwiseSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.hasPrev = false;
            return _this;
        }
        PairwiseSubscriber.prototype._next = function (value) {
            if (this.hasPrev) {
                this.destination.next([this.prev, value]);
            }
            else {
                this.hasPrev = true;
            }
            this.prev = value;
        };
        return PairwiseSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _map PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */
    var RepeatSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RepeatSubscriber, _super);
        function RepeatSubscriber(destination, count, source) {
            var _this = _super.call(this, destination) || this;
            _this.count = count;
            _this.source = source;
            return _this;
        }
        RepeatSubscriber.prototype.complete = function () {
            if (!this.isStopped) {
                var _a = this, source = _a.source, count = _a.count;
                if (count === 0) {
                    return _super.prototype.complete.call(this);
                }
                else if (count > -1) {
                    this.count = count - 1;
                }
                source.subscribe(this._unsubscribeAndRecycle());
            }
        };
        return RepeatSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RepeatWhenSubscriber, _super);
        function RepeatWhenSubscriber(destination, notifier, source) {
            var _this = _super.call(this, destination) || this;
            _this.notifier = notifier;
            _this.source = source;
            _this.sourceIsBeingSubscribedTo = true;
            return _this;
        }
        RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.sourceIsBeingSubscribedTo = true;
            this.source.subscribe(this);
        };
        RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
            if (this.sourceIsBeingSubscribedTo === false) {
                return _super.prototype.complete.call(this);
            }
        };
        RepeatWhenSubscriber.prototype.complete = function () {
            this.sourceIsBeingSubscribedTo = false;
            if (!this.isStopped) {
                if (!this.retries) {
                    this.subscribeToRetries();
                }
                if (!this.retriesSubscription || this.retriesSubscription.closed) {
                    return _super.prototype.complete.call(this);
                }
                this._unsubscribeAndRecycle();
                this.notifications.next();
            }
        };
        RepeatWhenSubscriber.prototype._unsubscribe = function () {
            var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
            if (notifications) {
                notifications.unsubscribe();
                this.notifications = null;
            }
            if (retriesSubscription) {
                retriesSubscription.unsubscribe();
                this.retriesSubscription = null;
            }
            this.retries = null;
        };
        RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
            var _unsubscribe = this._unsubscribe;
            this._unsubscribe = null;
            _super.prototype._unsubscribeAndRecycle.call(this);
            this._unsubscribe = _unsubscribe;
            return this;
        };
        RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
            this.notifications = new Subject();
            var retries = tryCatch(this.notifier)(this.notifications);
            if (retries === errorObject) {
                return _super.prototype.complete.call(this);
            }
            this.retries = retries;
            this.retriesSubscription = subscribeToResult(this, retries);
        };
        return RepeatWhenSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var RetrySubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RetrySubscriber, _super);
        function RetrySubscriber(destination, count, source) {
            var _this = _super.call(this, destination) || this;
            _this.count = count;
            _this.source = source;
            return _this;
        }
        RetrySubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var _a = this, source = _a.source, count = _a.count;
                if (count === 0) {
                    return _super.prototype.error.call(this, err);
                }
                else if (count > -1) {
                    this.count = count - 1;
                }
                source.subscribe(this._unsubscribeAndRecycle());
            }
        };
        return RetrySubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(RetryWhenSubscriber, _super);
        function RetryWhenSubscriber(destination, notifier, source) {
            var _this = _super.call(this, destination) || this;
            _this.notifier = notifier;
            _this.source = source;
            return _this;
        }
        RetryWhenSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var errors = this.errors;
                var retries = this.retries;
                var retriesSubscription = this.retriesSubscription;
                if (!retries) {
                    errors = new Subject();
                    retries = tryCatch(this.notifier)(errors);
                    if (retries === errorObject) {
                        return _super.prototype.error.call(this, errorObject.e);
                    }
                    retriesSubscription = subscribeToResult(this, retries);
                }
                else {
                    this.errors = null;
                    this.retriesSubscription = null;
                }
                this._unsubscribeAndRecycle();
                this.errors = errors;
                this.retries = retries;
                this.retriesSubscription = retriesSubscription;
                errors.next(err);
            }
        };
        RetryWhenSubscriber.prototype._unsubscribe = function () {
            var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
            if (errors) {
                errors.unsubscribe();
                this.errors = null;
            }
            if (retriesSubscription) {
                retriesSubscription.unsubscribe();
                this.retriesSubscription = null;
            }
            this.retries = null;
        };
        RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var _unsubscribe = this._unsubscribe;
            this._unsubscribe = null;
            this._unsubscribeAndRecycle();
            this._unsubscribe = _unsubscribe;
            this.source.subscribe(this);
        };
        return RetryWhenSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var SampleSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SampleSubscriber, _super);
        function SampleSubscriber() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.hasValue = false;
            return _this;
        }
        SampleSubscriber.prototype._next = function (value) {
            this.value = value;
            this.hasValue = true;
        };
        SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.emitValue();
        };
        SampleSubscriber.prototype.notifyComplete = function () {
            this.emitValue();
        };
        SampleSubscriber.prototype.emitValue = function () {
            if (this.hasValue) {
                this.hasValue = false;
                this.destination.next(this.value);
            }
        };
        return SampleSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */
    var SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SampleTimeSubscriber, _super);
        function SampleTimeSubscriber(destination, period, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.period = period;
            _this.scheduler = scheduler;
            _this.hasValue = false;
            _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
            return _this;
        }
        SampleTimeSubscriber.prototype._next = function (value) {
            this.lastValue = value;
            this.hasValue = true;
        };
        SampleTimeSubscriber.prototype.notifyNext = function () {
            if (this.hasValue) {
                this.hasValue = false;
                this.destination.next(this.lastValue);
            }
        };
        return SampleTimeSubscriber;
    }(Subscriber));
    function dispatchNotification(state) {
        var subscriber = state.subscriber, period = state.period;
        subscriber.notifyNext();
        this.schedule(state, period);
    }

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_tryCatch,_util_errorObject PURE_IMPORTS_END */
    var SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SequenceEqualSubscriber, _super);
        function SequenceEqualSubscriber(destination, compareTo, comparor) {
            var _this = _super.call(this, destination) || this;
            _this.compareTo = compareTo;
            _this.comparor = comparor;
            _this._a = [];
            _this._b = [];
            _this._oneComplete = false;
            _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
            return _this;
        }
        SequenceEqualSubscriber.prototype._next = function (value) {
            if (this._oneComplete && this._b.length === 0) {
                this.emit(false);
            }
            else {
                this._a.push(value);
                this.checkValues();
            }
        };
        SequenceEqualSubscriber.prototype._complete = function () {
            if (this._oneComplete) {
                this.emit(this._a.length === 0 && this._b.length === 0);
            }
            else {
                this._oneComplete = true;
            }
            this.unsubscribe();
        };
        SequenceEqualSubscriber.prototype.checkValues = function () {
            var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
            while (_a.length > 0 && _b.length > 0) {
                var a = _a.shift();
                var b = _b.shift();
                var areEqual = false;
                if (comparor) {
                    areEqual = tryCatch(comparor)(a, b);
                    if (areEqual === errorObject) {
                        this.destination.error(errorObject.e);
                    }
                }
                else {
                    areEqual = a === b;
                }
                if (!areEqual) {
                    this.emit(false);
                }
            }
        };
        SequenceEqualSubscriber.prototype.emit = function (value) {
            var destination = this.destination;
            destination.next(value);
            destination.complete();
        };
        SequenceEqualSubscriber.prototype.nextB = function (value) {
            if (this._oneComplete && this._a.length === 0) {
                this.emit(false);
            }
            else {
                this._b.push(value);
                this.checkValues();
            }
        };
        SequenceEqualSubscriber.prototype.completeB = function () {
            if (this._oneComplete) {
                this.emit(this._a.length === 0 && this._b.length === 0);
            }
            else {
                this._oneComplete = true;
            }
        };
        return SequenceEqualSubscriber;
    }(Subscriber));
    var SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SequenceEqualCompareToSubscriber, _super);
        function SequenceEqualCompareToSubscriber(destination, parent) {
            var _this = _super.call(this, destination) || this;
            _this.parent = parent;
            return _this;
        }
        SequenceEqualCompareToSubscriber.prototype._next = function (value) {
            this.parent.nextB(value);
        };
        SequenceEqualCompareToSubscriber.prototype._error = function (err) {
            this.parent.error(err);
            this.unsubscribe();
        };
        SequenceEqualCompareToSubscriber.prototype._complete = function () {
            this.parent.completeB();
            this.unsubscribe();
        };
        return SequenceEqualCompareToSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */
    var SingleSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SingleSubscriber, _super);
        function SingleSubscriber(destination, predicate, source) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.source = source;
            _this.seenValue = false;
            _this.index = 0;
            return _this;
        }
        SingleSubscriber.prototype.applySingleValue = function (value) {
            if (this.seenValue) {
                this.destination.error('Sequence contains more than one element');
            }
            else {
                this.seenValue = true;
                this.singleValue = value;
            }
        };
        SingleSubscriber.prototype._next = function (value) {
            var index = this.index++;
            if (this.predicate) {
                this.tryNext(value, index);
            }
            else {
                this.applySingleValue(value);
            }
        };
        SingleSubscriber.prototype.tryNext = function (value, index) {
            try {
                if (this.predicate(value, index, this.source)) {
                    this.applySingleValue(value);
                }
            }
            catch (err) {
                this.destination.error(err);
            }
        };
        SingleSubscriber.prototype._complete = function () {
            var destination = this.destination;
            if (this.index > 0) {
                destination.next(this.seenValue ? this.singleValue : undefined);
                destination.complete();
            }
            else {
                destination.error(new EmptyError);
            }
        };
        return SingleSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var SkipSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SkipSubscriber, _super);
        function SkipSubscriber(destination, total) {
            var _this = _super.call(this, destination) || this;
            _this.total = total;
            _this.count = 0;
            return _this;
        }
        SkipSubscriber.prototype._next = function (x) {
            if (++this.count > this.total) {
                this.destination.next(x);
            }
        };
        return SkipSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */
    var SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SkipLastSubscriber, _super);
        function SkipLastSubscriber(destination, _skipCount) {
            var _this = _super.call(this, destination) || this;
            _this._skipCount = _skipCount;
            _this._count = 0;
            _this._ring = new Array(_skipCount);
            return _this;
        }
        SkipLastSubscriber.prototype._next = function (value) {
            var skipCount = this._skipCount;
            var count = this._count++;
            if (count < skipCount) {
                this._ring[count] = value;
            }
            else {
                var currentIndex = count % skipCount;
                var ring = this._ring;
                var oldValue = ring[currentIndex];
                ring[currentIndex] = value;
                this.destination.next(oldValue);
            }
        };
        return SkipLastSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SkipUntilSubscriber, _super);
        function SkipUntilSubscriber(destination, notifier) {
            var _this = _super.call(this, destination) || this;
            _this.hasValue = false;
            var innerSubscriber = new InnerSubscriber(_this, undefined, undefined);
            _this.add(innerSubscriber);
            _this.innerSubscription = innerSubscriber;
            subscribeToResult(_this, notifier, undefined, undefined, innerSubscriber);
            return _this;
        }
        SkipUntilSubscriber.prototype._next = function (value) {
            if (this.hasValue) {
                _super.prototype._next.call(this, value);
            }
        };
        SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.hasValue = true;
            if (this.innerSubscription) {
                this.innerSubscription.unsubscribe();
            }
        };
        SkipUntilSubscriber.prototype.notifyComplete = function () {
        };
        return SkipUntilSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SkipWhileSubscriber, _super);
        function SkipWhileSubscriber(destination, predicate) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.skipping = true;
            _this.index = 0;
            return _this;
        }
        SkipWhileSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            if (this.skipping) {
                this.tryCallPredicate(value);
            }
            if (!this.skipping) {
                destination.next(value);
            }
        };
        SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
            try {
                var result = this.predicate(value, this.index++);
                this.skipping = Boolean(result);
            }
            catch (err) {
                this.destination.error(err);
            }
        };
        return SkipWhileSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START _observable_fromArray,_observable_scalar,_observable_empty,_observable_concat,_util_isScheduler PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */
    var SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
        __extends(SubscribeOnObservable, _super);
        function SubscribeOnObservable(source, delayTime, scheduler) {
            if (delayTime === void 0) {
                delayTime = 0;
            }
            if (scheduler === void 0) {
                scheduler = asap;
            }
            var _this = _super.call(this) || this;
            _this.source = source;
            _this.delayTime = delayTime;
            _this.scheduler = scheduler;
            if (!isNumeric(delayTime) || delayTime < 0) {
                _this.delayTime = 0;
            }
            if (!scheduler || typeof scheduler.schedule !== 'function') {
                _this.scheduler = asap;
            }
            return _this;
        }
        SubscribeOnObservable.create = function (source, delay, scheduler) {
            if (delay === void 0) {
                delay = 0;
            }
            if (scheduler === void 0) {
                scheduler = asap;
            }
            return new SubscribeOnObservable(source, delay, scheduler);
        };
        SubscribeOnObservable.dispatch = function (arg) {
            var source = arg.source, subscriber = arg.subscriber;
            return this.add(source.subscribe(subscriber));
        };
        SubscribeOnObservable.prototype._subscribe = function (subscriber) {
            var delay = this.delayTime;
            var source = this.source;
            var scheduler = this.scheduler;
            return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
                source: source, subscriber: subscriber
            });
        };
        return SubscribeOnObservable;
    }(Observable));

    /** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_InnerSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */
    var SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(SwitchMapSubscriber, _super);
        function SwitchMapSubscriber(destination, project) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.index = 0;
            return _this;
        }
        SwitchMapSubscriber.prototype._next = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            }
            catch (error) {
                this.destination.error(error);
                return;
            }
            this._innerSub(result, value, index);
        };
        SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
            var innerSubscription = this.innerSubscription;
            if (innerSubscription) {
                innerSubscription.unsubscribe();
            }
            var innerSubscriber = new InnerSubscriber(this, undefined, undefined);
            var destination = this.destination;
            destination.add(innerSubscriber);
            this.innerSubscription = subscribeToResult(this, result, value, index, innerSubscriber);
        };
        SwitchMapSubscriber.prototype._complete = function () {
            var innerSubscription = this.innerSubscription;
            if (!innerSubscription || innerSubscription.closed) {
                _super.prototype._complete.call(this);
            }
            this.unsubscribe();
        };
        SwitchMapSubscriber.prototype._unsubscribe = function () {
            this.innerSubscription = null;
        };
        SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
            var destination = this.destination;
            destination.remove(innerSub);
            this.innerSubscription = null;
            if (this.isStopped) {
                _super.prototype._complete.call(this);
            }
        };
        SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(innerValue);
        };
        return SwitchMapSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeUntilSubscriber, _super);
        function TakeUntilSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.seenValue = false;
            return _this;
        }
        TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.seenValue = true;
            this.complete();
        };
        TakeUntilSubscriber.prototype.notifyComplete = function () {
        };
        return TakeUntilSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
    var TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TakeWhileSubscriber, _super);
        function TakeWhileSubscriber(destination, predicate) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.index = 0;
            return _this;
        }
        TakeWhileSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            var result;
            try {
                result = this.predicate(value, this.index++);
            }
            catch (err) {
                destination.error(err);
                return;
            }
            this.nextOrComplete(value, result);
        };
        TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
            var destination = this.destination;
            if (Boolean(predicateResult)) {
                destination.next(value);
            }
            else {
                destination.complete();
            }
        };
        return TakeWhileSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ThrottleSubscriber, _super);
        function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            _this.durationSelector = durationSelector;
            _this._leading = _leading;
            _this._trailing = _trailing;
            _this._hasValue = false;
            return _this;
        }
        ThrottleSubscriber.prototype._next = function (value) {
            this._hasValue = true;
            this._sendValue = value;
            if (!this._throttled) {
                if (this._leading) {
                    this.send();
                }
                else {
                    this.throttle(value);
                }
            }
        };
        ThrottleSubscriber.prototype.send = function () {
            var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
            if (_hasValue) {
                this.destination.next(_sendValue);
                this.throttle(_sendValue);
            }
            this._hasValue = false;
            this._sendValue = null;
        };
        ThrottleSubscriber.prototype.throttle = function (value) {
            var duration = this.tryDurationSelector(value);
            if (duration) {
                this.add(this._throttled = subscribeToResult(this, duration));
            }
        };
        ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
            try {
                return this.durationSelector(value);
            }
            catch (err) {
                this.destination.error(err);
                return null;
            }
        };
        ThrottleSubscriber.prototype.throttlingDone = function () {
            var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
            if (_throttled) {
                _throttled.unsubscribe();
            }
            this._throttled = null;
            if (_trailing) {
                this.send();
            }
        };
        ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.throttlingDone();
        };
        ThrottleSubscriber.prototype.notifyComplete = function () {
            this.throttlingDone();
        };
        return ThrottleSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */
    var ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(ThrottleTimeSubscriber, _super);
        function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
            var _this = _super.call(this, destination) || this;
            _this.duration = duration;
            _this.scheduler = scheduler;
            _this.leading = leading;
            _this.trailing = trailing;
            _this._hasTrailingValue = false;
            _this._trailingValue = null;
            return _this;
        }
        ThrottleTimeSubscriber.prototype._next = function (value) {
            if (this.throttled) {
                if (this.trailing) {
                    this._trailingValue = value;
                    this._hasTrailingValue = true;
                }
            }
            else {
                this.add(this.throttled = this.scheduler.schedule(dispatchNext$3, this.duration, { subscriber: this }));
                if (this.leading) {
                    this.destination.next(value);
                }
            }
        };
        ThrottleTimeSubscriber.prototype._complete = function () {
            if (this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this.destination.complete();
            }
            else {
                this.destination.complete();
            }
        };
        ThrottleTimeSubscriber.prototype.clearThrottle = function () {
            var throttled = this.throttled;
            if (throttled) {
                if (this.trailing && this._hasTrailingValue) {
                    this.destination.next(this._trailingValue);
                    this._trailingValue = null;
                    this._hasTrailingValue = false;
                }
                throttled.unsubscribe();
                this.remove(throttled);
                this.throttled = null;
            }
        };
        return ThrottleTimeSubscriber;
    }(Subscriber));
    function dispatchNext$3(arg) {
        var subscriber = arg.subscriber;
        subscriber.clearThrottle();
    }

    /** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(TimeoutWithSubscriber, _super);
        function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.absoluteTimeout = absoluteTimeout;
            _this.waitFor = waitFor;
            _this.withObservable = withObservable;
            _this.scheduler = scheduler;
            _this.action = null;
            _this.scheduleTimeout();
            return _this;
        }
        TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
            var withObservable = subscriber.withObservable;
            subscriber._unsubscribeAndRecycle();
            subscriber.add(subscribeToResult(subscriber, withObservable));
        };
        TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
            var action = this.action;
            if (action) {
                this.action = action.schedule(this, this.waitFor);
            }
            else {
                this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
            }
        };
        TimeoutWithSubscriber.prototype._next = function (value) {
            if (!this.absoluteTimeout) {
                this.scheduleTimeout();
            }
            _super.prototype._next.call(this, value);
        };
        TimeoutWithSubscriber.prototype._unsubscribe = function () {
            this.action = null;
            this.scheduler = null;
            this.withObservable = null;
        };
        return TimeoutWithSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

    /** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var WindowSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(WindowSubscriber, _super);
        function WindowSubscriber(destination) {
            var _this = _super.call(this, destination) || this;
            _this.window = new Subject();
            destination.next(_this.window);
            return _this;
        }
        WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.openWindow();
        };
        WindowSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        WindowSubscriber.prototype.notifyComplete = function (innerSub) {
            this._complete();
        };
        WindowSubscriber.prototype._next = function (value) {
            this.window.next(value);
        };
        WindowSubscriber.prototype._error = function (err) {
            this.window.error(err);
            this.destination.error(err);
        };
        WindowSubscriber.prototype._complete = function () {
            this.window.complete();
            this.destination.complete();
        };
        WindowSubscriber.prototype._unsubscribe = function () {
            this.window = null;
        };
        WindowSubscriber.prototype.openWindow = function () {
            var prevWindow = this.window;
            if (prevWindow) {
                prevWindow.complete();
            }
            var destination = this.destination;
            var newWindow = this.window = new Subject();
            destination.next(newWindow);
        };
        return WindowSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */
    var WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(WindowCountSubscriber, _super);
        function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            _this.windowSize = windowSize;
            _this.startWindowEvery = startWindowEvery;
            _this.windows = [new Subject()];
            _this.count = 0;
            destination.next(_this.windows[0]);
            return _this;
        }
        WindowCountSubscriber.prototype._next = function (value) {
            var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
            var destination = this.destination;
            var windowSize = this.windowSize;
            var windows = this.windows;
            var len = windows.length;
            for (var i = 0; i < len && !this.closed; i++) {
                windows[i].next(value);
            }
            var c = this.count - windowSize + 1;
            if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
                windows.shift().complete();
            }
            if (++this.count % startWindowEvery === 0 && !this.closed) {
                var window_1 = new Subject();
                windows.push(window_1);
                destination.next(window_1);
            }
        };
        WindowCountSubscriber.prototype._error = function (err) {
            var windows = this.windows;
            if (windows) {
                while (windows.length > 0 && !this.closed) {
                    windows.shift().error(err);
                }
            }
            this.destination.error(err);
        };
        WindowCountSubscriber.prototype._complete = function () {
            var windows = this.windows;
            if (windows) {
                while (windows.length > 0 && !this.closed) {
                    windows.shift().complete();
                }
            }
            this.destination.complete();
        };
        WindowCountSubscriber.prototype._unsubscribe = function () {
            this.count = 0;
            this.windows = null;
        };
        return WindowCountSubscriber;
    }(Subscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */
    var CountedSubject = /*@__PURE__*/ (function (_super) {
        __extends(CountedSubject, _super);
        function CountedSubject() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._numberOfNextedValues = 0;
            return _this;
        }
        CountedSubject.prototype.next = function (value) {
            this._numberOfNextedValues++;
            _super.prototype.next.call(this, value);
        };
        Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
            get: function () {
                return this._numberOfNextedValues;
            },
            enumerable: true,
            configurable: true
        });
        return CountedSubject;
    }(Subject));
    var WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(WindowTimeSubscriber, _super);
        function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            _this.windowTimeSpan = windowTimeSpan;
            _this.windowCreationInterval = windowCreationInterval;
            _this.maxWindowSize = maxWindowSize;
            _this.scheduler = scheduler;
            _this.windows = [];
            var window = _this.openWindow();
            if (windowCreationInterval !== null && windowCreationInterval >= 0) {
                var closeState = { subscriber: _this, window: window, context: null };
                var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
                _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
                _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
            }
            else {
                var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
                _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
            }
            return _this;
        }
        WindowTimeSubscriber.prototype._next = function (value) {
            var windows = this.windows;
            var len = windows.length;
            for (var i = 0; i < len; i++) {
                var window_1 = windows[i];
                if (!window_1.closed) {
                    window_1.next(value);
                    if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                        this.closeWindow(window_1);
                    }
                }
            }
        };
        WindowTimeSubscriber.prototype._error = function (err) {
            var windows = this.windows;
            while (windows.length > 0) {
                windows.shift().error(err);
            }
            this.destination.error(err);
        };
        WindowTimeSubscriber.prototype._complete = function () {
            var windows = this.windows;
            while (windows.length > 0) {
                var window_2 = windows.shift();
                if (!window_2.closed) {
                    window_2.complete();
                }
            }
            this.destination.complete();
        };
        WindowTimeSubscriber.prototype.openWindow = function () {
            var window = new CountedSubject();
            this.windows.push(window);
            var destination = this.destination;
            destination.next(window);
            return window;
        };
        WindowTimeSubscriber.prototype.closeWindow = function (window) {
            window.complete();
            var windows = this.windows;
            windows.splice(windows.indexOf(window), 1);
        };
        return WindowTimeSubscriber;
    }(Subscriber));
    function dispatchWindowTimeSpanOnly(state) {
        var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
        if (window) {
            subscriber.closeWindow(window);
        }
        state.window = subscriber.openWindow();
        this.schedule(state, windowTimeSpan);
    }
    function dispatchWindowCreation(state) {
        var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
        var window = subscriber.openWindow();
        var action = this;
        var context = { action: action, subscription: null };
        var timeSpanState = { subscriber: subscriber, window: window, context: context };
        context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
        action.add(context.subscription);
        action.schedule(state, windowCreationInterval);
    }
    function dispatchWindowClose(state) {
        var subscriber = state.subscriber, window = state.window, context = state.context;
        if (context && context.action && context.subscription) {
            context.action.remove(context.subscription);
        }
        subscriber.closeWindow(window);
    }

    /** PURE_IMPORTS_START tslib,_Subject,_Subscription,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(WindowToggleSubscriber, _super);
        function WindowToggleSubscriber(destination, openings, closingSelector) {
            var _this = _super.call(this, destination) || this;
            _this.openings = openings;
            _this.closingSelector = closingSelector;
            _this.contexts = [];
            _this.add(_this.openSubscription = subscribeToResult(_this, openings, openings));
            return _this;
        }
        WindowToggleSubscriber.prototype._next = function (value) {
            var contexts = this.contexts;
            if (contexts) {
                var len = contexts.length;
                for (var i = 0; i < len; i++) {
                    contexts[i].window.next(value);
                }
            }
        };
        WindowToggleSubscriber.prototype._error = function (err) {
            var contexts = this.contexts;
            this.contexts = null;
            if (contexts) {
                var len = contexts.length;
                var index = -1;
                while (++index < len) {
                    var context_1 = contexts[index];
                    context_1.window.error(err);
                    context_1.subscription.unsubscribe();
                }
            }
            _super.prototype._error.call(this, err);
        };
        WindowToggleSubscriber.prototype._complete = function () {
            var contexts = this.contexts;
            this.contexts = null;
            if (contexts) {
                var len = contexts.length;
                var index = -1;
                while (++index < len) {
                    var context_2 = contexts[index];
                    context_2.window.complete();
                    context_2.subscription.unsubscribe();
                }
            }
            _super.prototype._complete.call(this);
        };
        WindowToggleSubscriber.prototype._unsubscribe = function () {
            var contexts = this.contexts;
            this.contexts = null;
            if (contexts) {
                var len = contexts.length;
                var index = -1;
                while (++index < len) {
                    var context_3 = contexts[index];
                    context_3.window.unsubscribe();
                    context_3.subscription.unsubscribe();
                }
            }
        };
        WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            if (outerValue === this.openings) {
                var closingSelector = this.closingSelector;
                var closingNotifier = tryCatch(closingSelector)(innerValue);
                if (closingNotifier === errorObject) {
                    return this.error(errorObject.e);
                }
                else {
                    var window_1 = new Subject();
                    var subscription = new Subscription();
                    var context_4 = { window: window_1, subscription: subscription };
                    this.contexts.push(context_4);
                    var innerSubscription = subscribeToResult(this, closingNotifier, context_4);
                    if (innerSubscription.closed) {
                        this.closeWindow(this.contexts.length - 1);
                    }
                    else {
                        innerSubscription.context = context_4;
                        subscription.add(innerSubscription);
                    }
                    this.destination.next(window_1);
                }
            }
            else {
                this.closeWindow(this.contexts.indexOf(outerValue));
            }
        };
        WindowToggleSubscriber.prototype.notifyError = function (err) {
            this.error(err);
        };
        WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
            if (inner !== this.openSubscription) {
                this.closeWindow(this.contexts.indexOf(inner.context));
            }
        };
        WindowToggleSubscriber.prototype.closeWindow = function (index) {
            if (index === -1) {
                return;
            }
            var contexts = this.contexts;
            var context = contexts[index];
            var window = context.window, subscription = context.subscription;
            contexts.splice(index, 1);
            window.complete();
            subscription.unsubscribe();
        };
        return WindowToggleSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var WindowSubscriber$1 = /*@__PURE__*/ (function (_super) {
        __extends(WindowSubscriber, _super);
        function WindowSubscriber(destination, closingSelector) {
            var _this = _super.call(this, destination) || this;
            _this.destination = destination;
            _this.closingSelector = closingSelector;
            _this.openWindow();
            return _this;
        }
        WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.openWindow(innerSub);
        };
        WindowSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        WindowSubscriber.prototype.notifyComplete = function (innerSub) {
            this.openWindow(innerSub);
        };
        WindowSubscriber.prototype._next = function (value) {
            this.window.next(value);
        };
        WindowSubscriber.prototype._error = function (err) {
            this.window.error(err);
            this.destination.error(err);
            this.unsubscribeClosingNotification();
        };
        WindowSubscriber.prototype._complete = function () {
            this.window.complete();
            this.destination.complete();
            this.unsubscribeClosingNotification();
        };
        WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
            if (this.closingNotification) {
                this.closingNotification.unsubscribe();
            }
        };
        WindowSubscriber.prototype.openWindow = function (innerSub) {
            if (innerSub === void 0) {
                innerSub = null;
            }
            if (innerSub) {
                this.remove(innerSub);
                innerSub.unsubscribe();
            }
            var prevWindow = this.window;
            if (prevWindow) {
                prevWindow.complete();
            }
            var window = this.window = new Subject();
            this.destination.next(window);
            var closingNotifier = tryCatch(this.closingSelector)();
            if (closingNotifier === errorObject) {
                var err = errorObject.e;
                this.destination.error(err);
                this.window.error(err);
            }
            else {
                this.add(this.closingNotification = subscribeToResult(this, closingNotifier));
            }
        };
        return WindowSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
    var WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
        __extends(WithLatestFromSubscriber, _super);
        function WithLatestFromSubscriber(destination, observables, project) {
            var _this = _super.call(this, destination) || this;
            _this.observables = observables;
            _this.project = project;
            _this.toRespond = [];
            var len = observables.length;
            _this.values = new Array(len);
            for (var i = 0; i < len; i++) {
                _this.toRespond.push(i);
            }
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                _this.add(subscribeToResult(_this, observable, observable, i));
            }
            return _this;
        }
        WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.values[outerIndex] = innerValue;
            var toRespond = this.toRespond;
            if (toRespond.length > 0) {
                var found = toRespond.indexOf(outerIndex);
                if (found !== -1) {
                    toRespond.splice(found, 1);
                }
            }
        };
        WithLatestFromSubscriber.prototype.notifyComplete = function () {
        };
        WithLatestFromSubscriber.prototype._next = function (value) {
            if (this.toRespond.length === 0) {
                var args = [value].concat(this.values);
                if (this.project) {
                    this._tryProject(args);
                }
                else {
                    this.destination.next(args);
                }
            }
        };
        WithLatestFromSubscriber.prototype._tryProject = function (args) {
            var result;
            try {
                result = this.project.apply(this, args);
            }
            catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return WithLatestFromSubscriber;
    }(OuterSubscriber));

    /** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

    /** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

    /** PURE_IMPORTS_START  PURE_IMPORTS_END */

    var options = {
    	java_package: "com.keepkey.deviceprotocol",
    	java_outer_classname: "KeepKeyMessage"
    };
    var nested = {
    	wire_in: {
    		type: "bool",
    		id: 50002,
    		extend: "google.protobuf.EnumValueOptions"
    	},
    	wire_out: {
    		type: "bool",
    		id: 50003,
    		extend: "google.protobuf.EnumValueOptions"
    	},
    	wire_debug_in: {
    		type: "bool",
    		id: 50004,
    		extend: "google.protobuf.EnumValueOptions"
    	},
    	wire_debug_out: {
    		type: "bool",
    		id: 50005,
    		extend: "google.protobuf.EnumValueOptions"
    	},
    	FailureType: {
    		values: {
    			Failure_UnexpectedMessage: 1,
    			Failure_ButtonExpected: 2,
    			Failure_SyntaxError: 3,
    			Failure_ActionCancelled: 4,
    			Failure_PinExpected: 5,
    			Failure_PinCancelled: 6,
    			Failure_PinInvalid: 7,
    			Failure_InvalidSignature: 8,
    			Failure_Other: 9,
    			Failure_NotEnoughFunds: 10,
    			Failure_NotInitialized: 11,
    			Failure_PinMismatch: 12,
    			Failure_FirmwareError: 99
    		}
    	},
    	OutputScriptType: {
    		values: {
    			PAYTOADDRESS: 0,
    			PAYTOSCRIPTHASH: 1,
    			PAYTOMULTISIG: 2,
    			PAYTOOPRETURN: 3,
    			PAYTOWITNESS: 4,
    			PAYTOP2SHWITNESS: 5
    		}
    	},
    	InputScriptType: {
    		values: {
    			SPENDADDRESS: 0,
    			SPENDMULTISIG: 1,
    			EXTERNAL: 2,
    			SPENDWITNESS: 3,
    			SPENDP2SHWITNESS: 4
    		}
    	},
    	RequestType: {
    		values: {
    			TXINPUT: 0,
    			TXOUTPUT: 1,
    			TXMETA: 2,
    			TXFINISHED: 3,
    			TXEXTRADATA: 4
    		}
    	},
    	OutputAddressType: {
    		values: {
    			SPEND: 0,
    			TRANSFER: 1,
    			CHANGE: 2,
    			EXCHANGE: 3
    		}
    	},
    	ButtonRequestType: {
    		values: {
    			ButtonRequest_Other: 1,
    			ButtonRequest_FeeOverThreshold: 2,
    			ButtonRequest_ConfirmOutput: 3,
    			ButtonRequest_ResetDevice: 4,
    			ButtonRequest_ConfirmWord: 5,
    			ButtonRequest_WipeDevice: 6,
    			ButtonRequest_ProtectCall: 7,
    			ButtonRequest_SignTx: 8,
    			ButtonRequest_FirmwareCheck: 9,
    			ButtonRequest_Address: 10,
    			ButtonRequest_FirmwareErase: 11,
    			ButtonRequest_ConfirmTransferToAccount: 12,
    			ButtonRequest_ConfirmTransferToNodePath: 13,
    			ButtonRequest_ChangeLabel: 14,
    			ButtonRequest_ChangeLanguage: 15,
    			ButtonRequest_EnablePassphrase: 16,
    			ButtonRequest_DisablePassphrase: 17,
    			ButtonRequest_EncryptAndSignMessage: 18,
    			ButtonRequest_EncryptMessage: 19,
    			ButtonRequest_ImportPrivateKey: 20,
    			ButtonRequest_ImportRecoverySentence: 21,
    			ButtonRequest_SignIdentity: 22,
    			ButtonRequest_Ping: 23,
    			ButtonRequest_RemovePin: 24,
    			ButtonRequest_ChangePin: 25,
    			ButtonRequest_CreatePin: 26,
    			ButtonRequest_GetEntropy: 27,
    			ButtonRequest_SignMessage: 28,
    			ButtonRequest_ApplyPolicies: 29,
    			ButtonRequest_SignExchange: 30,
    			ButtonRequest_AutoLockDelayMs: 31,
    			ButtonRequest_U2FCounter: 32
    		}
    	},
    	PinMatrixRequestType: {
    		values: {
    			PinMatrixRequestType_Current: 1,
    			PinMatrixRequestType_NewFirst: 2,
    			PinMatrixRequestType_NewSecond: 3
    		}
    	},
    	HDNodeType: {
    		fields: {
    			depth: {
    				rule: "required",
    				type: "uint32",
    				id: 1
    			},
    			fingerprint: {
    				rule: "required",
    				type: "uint32",
    				id: 2
    			},
    			child_num: {
    				rule: "required",
    				type: "uint32",
    				id: 3
    			},
    			chain_code: {
    				rule: "required",
    				type: "bytes",
    				id: 4
    			},
    			private_key: {
    				type: "bytes",
    				id: 5
    			},
    			public_key: {
    				type: "bytes",
    				id: 6
    			}
    		}
    	},
    	HDNodePathType: {
    		fields: {
    			node: {
    				rule: "required",
    				type: "HDNodeType",
    				id: 1
    			},
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 2,
    				options: {
    					packed: false
    				}
    			}
    		}
    	},
    	CoinType: {
    		fields: {
    			coin_name: {
    				type: "string",
    				id: 1
    			},
    			coin_shortcut: {
    				type: "string",
    				id: 2
    			},
    			address_type: {
    				type: "uint32",
    				id: 3,
    				options: {
    					"default": 0
    				}
    			},
    			maxfee_kb: {
    				type: "uint64",
    				id: 4
    			},
    			address_type_p2sh: {
    				type: "uint32",
    				id: 5,
    				options: {
    					"default": 5
    				}
    			},
    			address_type_p2wpkh: {
    				type: "uint32",
    				id: 6,
    				options: {
    					"default": 6
    				}
    			},
    			address_type_p2wsh: {
    				type: "uint32",
    				id: 7,
    				options: {
    					"default": 10
    				}
    			},
    			signed_message_header: {
    				type: "string",
    				id: 8
    			},
    			bip44_account_path: {
    				type: "uint32",
    				id: 9
    			},
    			forkid: {
    				type: "uint32",
    				id: 12
    			},
    			decimals: {
    				type: "uint32",
    				id: 13
    			},
    			contract_address: {
    				type: "bytes",
    				id: 14
    			},
    			gas_limit: {
    				type: "bytes",
    				id: 15
    			},
    			xpub_magic: {
    				type: "uint32",
    				id: 16,
    				options: {
    					"default": 76067358
    				}
    			},
    			xprv_magic: {
    				type: "uint32",
    				id: 17,
    				options: {
    					"default": 76066276
    				}
    			},
    			segwit: {
    				type: "bool",
    				id: 18
    			},
    			force_bip143: {
    				type: "bool",
    				id: 19
    			},
    			curve_name: {
    				type: "string",
    				id: 20
    			},
    			cashaddr_prefix: {
    				type: "string",
    				id: 21
    			},
    			bech32_prefix: {
    				type: "string",
    				id: 22
    			},
    			decred: {
    				type: "bool",
    				id: 23
    			},
    			version_group_id: {
    				type: "uint32",
    				id: 24
    			},
    			xpub_magic_segwit_p2sh: {
    				type: "uint32",
    				id: 25
    			},
    			xpub_magic_segwit_native: {
    				type: "uint32",
    				id: 26
    			}
    		}
    	},
    	MultisigRedeemScriptType: {
    		fields: {
    			pubkeys: {
    				rule: "repeated",
    				type: "HDNodePathType",
    				id: 1
    			},
    			signatures: {
    				rule: "repeated",
    				type: "bytes",
    				id: 2
    			},
    			m: {
    				type: "uint32",
    				id: 3
    			}
    		}
    	},
    	TxInputType: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			prev_hash: {
    				rule: "required",
    				type: "bytes",
    				id: 2
    			},
    			prev_index: {
    				rule: "required",
    				type: "uint32",
    				id: 3
    			},
    			script_sig: {
    				type: "bytes",
    				id: 4
    			},
    			sequence: {
    				type: "uint32",
    				id: 5,
    				options: {
    					"default": 4294967295
    				}
    			},
    			script_type: {
    				type: "InputScriptType",
    				id: 6,
    				options: {
    					"default": "SPENDADDRESS"
    				}
    			},
    			multisig: {
    				type: "MultisigRedeemScriptType",
    				id: 7
    			},
    			amount: {
    				type: "uint64",
    				id: 8
    			},
    			decred_tree: {
    				type: "uint32",
    				id: 9
    			},
    			decred_script_version: {
    				type: "uint32",
    				id: 10
    			}
    		}
    	},
    	TxOutputType: {
    		fields: {
    			address: {
    				type: "string",
    				id: 1
    			},
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 2,
    				options: {
    					packed: false
    				}
    			},
    			amount: {
    				rule: "required",
    				type: "uint64",
    				id: 3
    			},
    			script_type: {
    				rule: "required",
    				type: "OutputScriptType",
    				id: 4
    			},
    			multisig: {
    				type: "MultisigRedeemScriptType",
    				id: 5
    			},
    			op_return_data: {
    				type: "bytes",
    				id: 6
    			},
    			address_type: {
    				type: "OutputAddressType",
    				id: 7
    			},
    			exchange_type: {
    				type: "ExchangeType",
    				id: 8
    			},
    			decred_script_version: {
    				type: "uint32",
    				id: 9
    			}
    		}
    	},
    	TxOutputBinType: {
    		fields: {
    			amount: {
    				rule: "required",
    				type: "uint64",
    				id: 1
    			},
    			script_pubkey: {
    				rule: "required",
    				type: "bytes",
    				id: 2
    			},
    			decred_script_version: {
    				type: "uint32",
    				id: 3
    			}
    		}
    	},
    	TransactionType: {
    		fields: {
    			version: {
    				type: "uint32",
    				id: 1
    			},
    			inputs: {
    				rule: "repeated",
    				type: "TxInputType",
    				id: 2
    			},
    			bin_outputs: {
    				rule: "repeated",
    				type: "TxOutputBinType",
    				id: 3
    			},
    			outputs: {
    				rule: "repeated",
    				type: "TxOutputType",
    				id: 5
    			},
    			lock_time: {
    				type: "uint32",
    				id: 4
    			},
    			inputs_cnt: {
    				type: "uint32",
    				id: 6
    			},
    			outputs_cnt: {
    				type: "uint32",
    				id: 7
    			},
    			extra_data: {
    				type: "bytes",
    				id: 8
    			},
    			extra_data_len: {
    				type: "uint32",
    				id: 9
    			},
    			expiry: {
    				type: "uint32",
    				id: 10
    			},
    			overwintered: {
    				type: "bool",
    				id: 11
    			}
    		}
    	},
    	RawTransactionType: {
    		fields: {
    			payload: {
    				rule: "required",
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	TxRequestDetailsType: {
    		fields: {
    			request_index: {
    				type: "uint32",
    				id: 1
    			},
    			tx_hash: {
    				type: "bytes",
    				id: 2
    			},
    			extra_data_len: {
    				type: "uint32",
    				id: 3
    			},
    			extra_data_offset: {
    				type: "uint32",
    				id: 4
    			}
    		}
    	},
    	TxRequestSerializedType: {
    		fields: {
    			signature_index: {
    				type: "uint32",
    				id: 1
    			},
    			signature: {
    				type: "bytes",
    				id: 2
    			},
    			serialized_tx: {
    				type: "bytes",
    				id: 3
    			}
    		}
    	},
    	IdentityType: {
    		fields: {
    			proto: {
    				type: "string",
    				id: 1
    			},
    			user: {
    				type: "string",
    				id: 2
    			},
    			host: {
    				type: "string",
    				id: 3
    			},
    			port: {
    				type: "string",
    				id: 4
    			},
    			path: {
    				type: "string",
    				id: 5
    			},
    			index: {
    				type: "uint32",
    				id: 6,
    				options: {
    					"default": 0
    				}
    			}
    		}
    	},
    	PolicyType: {
    		fields: {
    			policy_name: {
    				type: "string",
    				id: 1
    			},
    			enabled: {
    				type: "bool",
    				id: 2
    			}
    		}
    	},
    	ExchangeType: {
    		fields: {
    			signed_exchange_response: {
    				type: "SignedExchangeResponse",
    				id: 1
    			},
    			withdrawal_coin_name: {
    				type: "string",
    				id: 2,
    				options: {
    					"default": "Bitcoin"
    				}
    			},
    			withdrawal_address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 3,
    				options: {
    					packed: false
    				}
    			},
    			return_address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 4,
    				options: {
    					packed: false
    				}
    			}
    		}
    	},
    	google: {
    		nested: {
    			protobuf: {
    				options: {
    					java_package: "com.google.protobuf",
    					java_outer_classname: "DescriptorProtos",
    					optimize_for: "SPEED"
    				},
    				nested: {
    					FileDescriptorSet: {
    						fields: {
    							file: {
    								rule: "repeated",
    								type: "FileDescriptorProto",
    								id: 1
    							}
    						}
    					},
    					FileDescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							"package": {
    								type: "string",
    								id: 2
    							},
    							dependency: {
    								rule: "repeated",
    								type: "string",
    								id: 3
    							},
    							public_dependency: {
    								rule: "repeated",
    								type: "int32",
    								id: 10,
    								options: {
    									packed: false
    								}
    							},
    							weak_dependency: {
    								rule: "repeated",
    								type: "int32",
    								id: 11,
    								options: {
    									packed: false
    								}
    							},
    							message_type: {
    								rule: "repeated",
    								type: "DescriptorProto",
    								id: 4
    							},
    							enum_type: {
    								rule: "repeated",
    								type: "EnumDescriptorProto",
    								id: 5
    							},
    							service: {
    								rule: "repeated",
    								type: "ServiceDescriptorProto",
    								id: 6
    							},
    							extension: {
    								rule: "repeated",
    								type: "FieldDescriptorProto",
    								id: 7
    							},
    							options: {
    								type: "FileOptions",
    								id: 8
    							},
    							source_code_info: {
    								type: "SourceCodeInfo",
    								id: 9
    							}
    						}
    					},
    					DescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							field: {
    								rule: "repeated",
    								type: "FieldDescriptorProto",
    								id: 2
    							},
    							extension: {
    								rule: "repeated",
    								type: "FieldDescriptorProto",
    								id: 6
    							},
    							nested_type: {
    								rule: "repeated",
    								type: "DescriptorProto",
    								id: 3
    							},
    							enum_type: {
    								rule: "repeated",
    								type: "EnumDescriptorProto",
    								id: 4
    							},
    							extension_range: {
    								rule: "repeated",
    								type: "ExtensionRange",
    								id: 5
    							},
    							options: {
    								type: "MessageOptions",
    								id: 7
    							}
    						},
    						nested: {
    							ExtensionRange: {
    								fields: {
    									start: {
    										type: "int32",
    										id: 1
    									},
    									end: {
    										type: "int32",
    										id: 2
    									}
    								}
    							}
    						}
    					},
    					FieldDescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							number: {
    								type: "int32",
    								id: 3
    							},
    							label: {
    								type: "Label",
    								id: 4
    							},
    							type: {
    								type: "Type",
    								id: 5
    							},
    							type_name: {
    								type: "string",
    								id: 6
    							},
    							extendee: {
    								type: "string",
    								id: 2
    							},
    							default_value: {
    								type: "string",
    								id: 7
    							},
    							options: {
    								type: "FieldOptions",
    								id: 8
    							}
    						},
    						nested: {
    							Type: {
    								values: {
    									TYPE_DOUBLE: 1,
    									TYPE_FLOAT: 2,
    									TYPE_INT64: 3,
    									TYPE_UINT64: 4,
    									TYPE_INT32: 5,
    									TYPE_FIXED64: 6,
    									TYPE_FIXED32: 7,
    									TYPE_BOOL: 8,
    									TYPE_STRING: 9,
    									TYPE_GROUP: 10,
    									TYPE_MESSAGE: 11,
    									TYPE_BYTES: 12,
    									TYPE_UINT32: 13,
    									TYPE_ENUM: 14,
    									TYPE_SFIXED32: 15,
    									TYPE_SFIXED64: 16,
    									TYPE_SINT32: 17,
    									TYPE_SINT64: 18
    								}
    							},
    							Label: {
    								values: {
    									LABEL_OPTIONAL: 1,
    									LABEL_REQUIRED: 2,
    									LABEL_REPEATED: 3
    								}
    							}
    						}
    					},
    					EnumDescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							value: {
    								rule: "repeated",
    								type: "EnumValueDescriptorProto",
    								id: 2
    							},
    							options: {
    								type: "EnumOptions",
    								id: 3
    							}
    						}
    					},
    					EnumValueDescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							number: {
    								type: "int32",
    								id: 2
    							},
    							options: {
    								type: "EnumValueOptions",
    								id: 3
    							}
    						}
    					},
    					ServiceDescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							method: {
    								rule: "repeated",
    								type: "MethodDescriptorProto",
    								id: 2
    							},
    							options: {
    								type: "ServiceOptions",
    								id: 3
    							}
    						}
    					},
    					MethodDescriptorProto: {
    						fields: {
    							name: {
    								type: "string",
    								id: 1
    							},
    							input_type: {
    								type: "string",
    								id: 2
    							},
    							output_type: {
    								type: "string",
    								id: 3
    							},
    							options: {
    								type: "MethodOptions",
    								id: 4
    							}
    						}
    					},
    					FileOptions: {
    						fields: {
    							java_package: {
    								type: "string",
    								id: 1
    							},
    							java_outer_classname: {
    								type: "string",
    								id: 8
    							},
    							java_multiple_files: {
    								type: "bool",
    								id: 10,
    								options: {
    									"default": false
    								}
    							},
    							java_generate_equals_and_hash: {
    								type: "bool",
    								id: 20,
    								options: {
    									"default": false
    								}
    							},
    							optimize_for: {
    								type: "OptimizeMode",
    								id: 9,
    								options: {
    									"default": "SPEED"
    								}
    							},
    							go_package: {
    								type: "string",
    								id: 11
    							},
    							cc_generic_services: {
    								type: "bool",
    								id: 16,
    								options: {
    									"default": false
    								}
    							},
    							java_generic_services: {
    								type: "bool",
    								id: 17,
    								options: {
    									"default": false
    								}
    							},
    							py_generic_services: {
    								type: "bool",
    								id: 18,
    								options: {
    									"default": false
    								}
    							},
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						],
    						nested: {
    							OptimizeMode: {
    								values: {
    									SPEED: 1,
    									CODE_SIZE: 2,
    									LITE_RUNTIME: 3
    								}
    							}
    						}
    					},
    					MessageOptions: {
    						fields: {
    							message_set_wire_format: {
    								type: "bool",
    								id: 1,
    								options: {
    									"default": false
    								}
    							},
    							no_standard_descriptor_accessor: {
    								type: "bool",
    								id: 2,
    								options: {
    									"default": false
    								}
    							},
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						]
    					},
    					FieldOptions: {
    						fields: {
    							ctype: {
    								type: "CType",
    								id: 1,
    								options: {
    									"default": "STRING"
    								}
    							},
    							packed: {
    								type: "bool",
    								id: 2
    							},
    							lazy: {
    								type: "bool",
    								id: 5,
    								options: {
    									"default": false
    								}
    							},
    							deprecated: {
    								type: "bool",
    								id: 3,
    								options: {
    									"default": false
    								}
    							},
    							experimental_map_key: {
    								type: "string",
    								id: 9
    							},
    							weak: {
    								type: "bool",
    								id: 10,
    								options: {
    									"default": false
    								}
    							},
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						],
    						nested: {
    							CType: {
    								values: {
    									STRING: 0,
    									CORD: 1,
    									STRING_PIECE: 2
    								}
    							}
    						}
    					},
    					EnumOptions: {
    						fields: {
    							allow_alias: {
    								type: "bool",
    								id: 2,
    								options: {
    									"default": true
    								}
    							},
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						]
    					},
    					EnumValueOptions: {
    						fields: {
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						]
    					},
    					ServiceOptions: {
    						fields: {
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						]
    					},
    					MethodOptions: {
    						fields: {
    							uninterpreted_option: {
    								rule: "repeated",
    								type: "UninterpretedOption",
    								id: 999
    							}
    						},
    						extensions: [
    							[
    								1000,
    								536870911
    							]
    						]
    					},
    					UninterpretedOption: {
    						fields: {
    							name: {
    								rule: "repeated",
    								type: "NamePart",
    								id: 2
    							},
    							identifier_value: {
    								type: "string",
    								id: 3
    							},
    							positive_int_value: {
    								type: "uint64",
    								id: 4
    							},
    							negative_int_value: {
    								type: "int64",
    								id: 5
    							},
    							double_value: {
    								type: "double",
    								id: 6
    							},
    							string_value: {
    								type: "bytes",
    								id: 7
    							},
    							aggregate_value: {
    								type: "string",
    								id: 8
    							}
    						},
    						nested: {
    							NamePart: {
    								fields: {
    									name_part: {
    										rule: "required",
    										type: "string",
    										id: 1
    									},
    									is_extension: {
    										rule: "required",
    										type: "bool",
    										id: 2
    									}
    								}
    							}
    						}
    					},
    					SourceCodeInfo: {
    						fields: {
    							location: {
    								rule: "repeated",
    								type: "Location",
    								id: 1
    							}
    						},
    						nested: {
    							Location: {
    								fields: {
    									path: {
    										rule: "repeated",
    										type: "int32",
    										id: 1
    									},
    									span: {
    										rule: "repeated",
    										type: "int32",
    										id: 2
    									},
    									leading_comments: {
    										type: "string",
    										id: 3
    									},
    									trailing_comments: {
    										type: "string",
    										id: 4
    									}
    								}
    							}
    						}
    					}
    				}
    			}
    		}
    	},
    	ExchangeAddress: {
    		fields: {
    			coin_type: {
    				type: "string",
    				id: 1
    			},
    			address: {
    				type: "string",
    				id: 2
    			},
    			dest_tag: {
    				type: "string",
    				id: 3
    			},
    			rs_address: {
    				type: "string",
    				id: 4
    			}
    		}
    	},
    	ExchangeResponseV2: {
    		fields: {
    			deposit_address: {
    				type: "ExchangeAddress",
    				id: 1
    			},
    			deposit_amount: {
    				type: "bytes",
    				id: 2
    			},
    			expiration: {
    				type: "int64",
    				id: 3
    			},
    			quoted_rate: {
    				type: "bytes",
    				id: 4
    			},
    			withdrawal_address: {
    				type: "ExchangeAddress",
    				id: 5
    			},
    			withdrawal_amount: {
    				type: "bytes",
    				id: 6
    			},
    			return_address: {
    				type: "ExchangeAddress",
    				id: 7
    			},
    			api_key: {
    				type: "bytes",
    				id: 8
    			},
    			miner_fee: {
    				type: "bytes",
    				id: 9
    			},
    			order_id: {
    				type: "bytes",
    				id: 10
    			}
    		}
    	},
    	SignedExchangeResponse: {
    		fields: {
    			response: {
    				type: "ExchangeResponse",
    				id: 1
    			},
    			signature: {
    				type: "bytes",
    				id: 2
    			},
    			responseV2: {
    				type: "ExchangeResponseV2",
    				id: 3
    			}
    		}
    	},
    	ExchangeResponse: {
    		fields: {
    			deposit_address: {
    				type: "ExchangeAddress",
    				id: 1
    			},
    			deposit_amount: {
    				type: "uint64",
    				id: 2
    			},
    			expiration: {
    				type: "int64",
    				id: 3
    			},
    			quoted_rate: {
    				type: "uint64",
    				id: 4
    			},
    			withdrawal_address: {
    				type: "ExchangeAddress",
    				id: 5
    			},
    			withdrawal_amount: {
    				type: "uint64",
    				id: 6
    			},
    			return_address: {
    				type: "ExchangeAddress",
    				id: 7
    			},
    			api_key: {
    				type: "bytes",
    				id: 8
    			},
    			miner_fee: {
    				type: "uint64",
    				id: 9
    			},
    			order_id: {
    				type: "bytes",
    				id: 10
    			}
    		}
    	},
    	MessageType: {
    		values: {
    			MessageType_Initialize: 0,
    			MessageType_Ping: 1,
    			MessageType_Success: 2,
    			MessageType_Failure: 3,
    			MessageType_ChangePin: 4,
    			MessageType_WipeDevice: 5,
    			MessageType_FirmwareErase: 6,
    			MessageType_FirmwareUpload: 7,
    			MessageType_GetEntropy: 9,
    			MessageType_Entropy: 10,
    			MessageType_GetPublicKey: 11,
    			MessageType_PublicKey: 12,
    			MessageType_LoadDevice: 13,
    			MessageType_ResetDevice: 14,
    			MessageType_SignTx: 15,
    			MessageType_SimpleSignTx: 16,
    			MessageType_Features: 17,
    			MessageType_PinMatrixRequest: 18,
    			MessageType_PinMatrixAck: 19,
    			MessageType_Cancel: 20,
    			MessageType_TxRequest: 21,
    			MessageType_TxAck: 22,
    			MessageType_CipherKeyValue: 23,
    			MessageType_ClearSession: 24,
    			MessageType_ApplySettings: 25,
    			MessageType_ButtonRequest: 26,
    			MessageType_ButtonAck: 27,
    			MessageType_GetAddress: 29,
    			MessageType_Address: 30,
    			MessageType_EntropyRequest: 35,
    			MessageType_EntropyAck: 36,
    			MessageType_SignMessage: 38,
    			MessageType_VerifyMessage: 39,
    			MessageType_MessageSignature: 40,
    			MessageType_PassphraseRequest: 41,
    			MessageType_PassphraseAck: 42,
    			MessageType_EstimateTxSize: 43,
    			MessageType_TxSize: 44,
    			MessageType_RecoveryDevice: 45,
    			MessageType_WordRequest: 46,
    			MessageType_WordAck: 47,
    			MessageType_CipheredKeyValue: 48,
    			MessageType_EncryptMessage: 49,
    			MessageType_EncryptedMessage: 50,
    			MessageType_DecryptMessage: 51,
    			MessageType_DecryptedMessage: 52,
    			MessageType_SignIdentity: 53,
    			MessageType_SignedIdentity: 54,
    			MessageType_GetFeatures: 55,
    			MessageType_EthereumGetAddress: 56,
    			MessageType_EthereumAddress: 57,
    			MessageType_EthereumSignTx: 58,
    			MessageType_EthereumTxRequest: 59,
    			MessageType_EthereumTxAck: 60,
    			MessageType_CharacterRequest: 80,
    			MessageType_CharacterAck: 81,
    			MessageType_RawTxAck: 82,
    			MessageType_ApplyPolicies: 83,
    			MessageType_FlashHash: 84,
    			MessageType_FlashWrite: 85,
    			MessageType_FlashHashResponse: 86,
    			MessageType_DebugLinkFlashDump: 87,
    			MessageType_DebugLinkFlashDumpResponse: 88,
    			MessageType_SoftReset: 89,
    			MessageType_DebugLinkDecision: 100,
    			MessageType_DebugLinkGetState: 101,
    			MessageType_DebugLinkState: 102,
    			MessageType_DebugLinkStop: 103,
    			MessageType_DebugLinkLog: 104,
    			MessageType_DebugLinkFillConfig: 105,
    			MessageType_GetCoinTable: 106,
    			MessageType_CoinTable: 107,
    			MessageType_EthereumSignMessage: 108,
    			MessageType_EthereumVerifyMessage: 109,
    			MessageType_EthereumMessageSignature: 110
    		}
    	},
    	Initialize: {
    		fields: {
    		}
    	},
    	GetFeatures: {
    		fields: {
    		}
    	},
    	Features: {
    		fields: {
    			vendor: {
    				type: "string",
    				id: 1
    			},
    			major_version: {
    				type: "uint32",
    				id: 2
    			},
    			minor_version: {
    				type: "uint32",
    				id: 3
    			},
    			patch_version: {
    				type: "uint32",
    				id: 4
    			},
    			bootloader_mode: {
    				type: "bool",
    				id: 5
    			},
    			device_id: {
    				type: "string",
    				id: 6
    			},
    			pin_protection: {
    				type: "bool",
    				id: 7
    			},
    			passphrase_protection: {
    				type: "bool",
    				id: 8
    			},
    			language: {
    				type: "string",
    				id: 9
    			},
    			label: {
    				type: "string",
    				id: 10
    			},
    			coins: {
    				rule: "repeated",
    				type: "CoinType",
    				id: 11
    			},
    			initialized: {
    				type: "bool",
    				id: 12
    			},
    			revision: {
    				type: "bytes",
    				id: 13
    			},
    			bootloader_hash: {
    				type: "bytes",
    				id: 14
    			},
    			imported: {
    				type: "bool",
    				id: 15
    			},
    			pin_cached: {
    				type: "bool",
    				id: 16
    			},
    			passphrase_cached: {
    				type: "bool",
    				id: 17
    			},
    			policies: {
    				rule: "repeated",
    				type: "PolicyType",
    				id: 18
    			},
    			model: {
    				type: "string",
    				id: 21
    			},
    			firmware_variant: {
    				type: "string",
    				id: 22
    			},
    			firmware_hash: {
    				type: "bytes",
    				id: 23
    			},
    			no_backup: {
    				type: "bool",
    				id: 24
    			}
    		}
    	},
    	GetCoinTable: {
    		fields: {
    			start: {
    				type: "uint32",
    				id: 1
    			},
    			end: {
    				type: "uint32",
    				id: 2
    			}
    		}
    	},
    	CoinTable: {
    		fields: {
    			table: {
    				rule: "repeated",
    				type: "CoinType",
    				id: 1
    			},
    			num_coins: {
    				type: "uint32",
    				id: 2
    			},
    			chunk_size: {
    				type: "uint32",
    				id: 3
    			}
    		}
    	},
    	ClearSession: {
    		fields: {
    		}
    	},
    	ApplySettings: {
    		fields: {
    			language: {
    				type: "string",
    				id: 1
    			},
    			label: {
    				type: "string",
    				id: 2
    			},
    			use_passphrase: {
    				type: "bool",
    				id: 3
    			},
    			auto_lock_delay_ms: {
    				type: "uint32",
    				id: 4
    			},
    			u2f_counter: {
    				type: "uint32",
    				id: 5
    			}
    		}
    	},
    	ChangePin: {
    		fields: {
    			remove: {
    				type: "bool",
    				id: 1
    			}
    		}
    	},
    	Ping: {
    		fields: {
    			message: {
    				type: "string",
    				id: 1
    			},
    			button_protection: {
    				type: "bool",
    				id: 2
    			},
    			pin_protection: {
    				type: "bool",
    				id: 3
    			},
    			passphrase_protection: {
    				type: "bool",
    				id: 4
    			}
    		}
    	},
    	Success: {
    		fields: {
    			message: {
    				type: "string",
    				id: 1
    			}
    		}
    	},
    	Failure: {
    		fields: {
    			code: {
    				type: "FailureType",
    				id: 1
    			},
    			message: {
    				type: "string",
    				id: 2
    			}
    		}
    	},
    	ButtonRequest: {
    		fields: {
    			code: {
    				type: "ButtonRequestType",
    				id: 1
    			},
    			data: {
    				type: "string",
    				id: 2
    			}
    		}
    	},
    	ButtonAck: {
    		fields: {
    		}
    	},
    	PinMatrixRequest: {
    		fields: {
    			type: {
    				type: "PinMatrixRequestType",
    				id: 1
    			}
    		}
    	},
    	PinMatrixAck: {
    		fields: {
    			pin: {
    				rule: "required",
    				type: "string",
    				id: 1
    			}
    		}
    	},
    	Cancel: {
    		fields: {
    		}
    	},
    	PassphraseRequest: {
    		fields: {
    		}
    	},
    	PassphraseAck: {
    		fields: {
    			passphrase: {
    				rule: "required",
    				type: "string",
    				id: 1
    			}
    		}
    	},
    	GetEntropy: {
    		fields: {
    			size: {
    				rule: "required",
    				type: "uint32",
    				id: 1
    			}
    		}
    	},
    	Entropy: {
    		fields: {
    			entropy: {
    				rule: "required",
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	GetPublicKey: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			ecdsa_curve_name: {
    				type: "string",
    				id: 2
    			},
    			show_display: {
    				type: "bool",
    				id: 3
    			},
    			coin_name: {
    				type: "string",
    				id: 4,
    				options: {
    					"default": "Bitcoin"
    				}
    			},
    			script_type: {
    				type: "InputScriptType",
    				id: 5,
    				options: {
    					"default": "SPENDADDRESS"
    				}
    			}
    		}
    	},
    	PublicKey: {
    		fields: {
    			node: {
    				rule: "required",
    				type: "HDNodeType",
    				id: 1
    			},
    			xpub: {
    				type: "string",
    				id: 2
    			}
    		}
    	},
    	GetAddress: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			coin_name: {
    				type: "string",
    				id: 2,
    				options: {
    					"default": "Bitcoin"
    				}
    			},
    			show_display: {
    				type: "bool",
    				id: 3
    			},
    			multisig: {
    				type: "MultisigRedeemScriptType",
    				id: 4
    			},
    			script_type: {
    				type: "InputScriptType",
    				id: 5,
    				options: {
    					"default": "SPENDADDRESS"
    				}
    			}
    		}
    	},
    	EthereumGetAddress: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			show_display: {
    				type: "bool",
    				id: 2
    			}
    		}
    	},
    	Address: {
    		fields: {
    			address: {
    				rule: "required",
    				type: "string",
    				id: 1
    			}
    		}
    	},
    	EthereumAddress: {
    		fields: {
    			address: {
    				rule: "required",
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	WipeDevice: {
    		fields: {
    		}
    	},
    	LoadDevice: {
    		fields: {
    			mnemonic: {
    				type: "string",
    				id: 1
    			},
    			node: {
    				type: "HDNodeType",
    				id: 2
    			},
    			pin: {
    				type: "string",
    				id: 3
    			},
    			passphrase_protection: {
    				type: "bool",
    				id: 4
    			},
    			language: {
    				type: "string",
    				id: 5,
    				options: {
    					"default": "english"
    				}
    			},
    			label: {
    				type: "string",
    				id: 6
    			},
    			skip_checksum: {
    				type: "bool",
    				id: 7
    			},
    			u2f_counter: {
    				type: "uint32",
    				id: 8
    			}
    		}
    	},
    	ResetDevice: {
    		fields: {
    			display_random: {
    				type: "bool",
    				id: 1
    			},
    			strength: {
    				type: "uint32",
    				id: 2,
    				options: {
    					"default": 256
    				}
    			},
    			passphrase_protection: {
    				type: "bool",
    				id: 3
    			},
    			pin_protection: {
    				type: "bool",
    				id: 4
    			},
    			language: {
    				type: "string",
    				id: 5,
    				options: {
    					"default": "english"
    				}
    			},
    			label: {
    				type: "string",
    				id: 6
    			},
    			no_backup: {
    				type: "bool",
    				id: 7
    			},
    			auto_lock_delay_ms: {
    				type: "uint32",
    				id: 8
    			}
    		}
    	},
    	EntropyRequest: {
    		fields: {
    		}
    	},
    	EntropyAck: {
    		fields: {
    			entropy: {
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	RecoveryDevice: {
    		fields: {
    			word_count: {
    				type: "uint32",
    				id: 1
    			},
    			passphrase_protection: {
    				type: "bool",
    				id: 2
    			},
    			pin_protection: {
    				type: "bool",
    				id: 3
    			},
    			language: {
    				type: "string",
    				id: 4,
    				options: {
    					"default": "english"
    				}
    			},
    			label: {
    				type: "string",
    				id: 5
    			},
    			enforce_wordlist: {
    				type: "bool",
    				id: 6
    			},
    			use_character_cipher: {
    				type: "bool",
    				id: 7
    			},
    			auto_lock_delay_ms: {
    				type: "uint32",
    				id: 8
    			}
    		}
    	},
    	WordRequest: {
    		fields: {
    		}
    	},
    	WordAck: {
    		fields: {
    			word: {
    				rule: "required",
    				type: "string",
    				id: 1
    			}
    		}
    	},
    	CharacterRequest: {
    		fields: {
    			word_pos: {
    				rule: "required",
    				type: "uint32",
    				id: 1
    			},
    			character_pos: {
    				rule: "required",
    				type: "uint32",
    				id: 2
    			}
    		}
    	},
    	CharacterAck: {
    		fields: {
    			character: {
    				type: "string",
    				id: 1
    			},
    			"delete": {
    				type: "bool",
    				id: 2
    			},
    			done: {
    				type: "bool",
    				id: 3
    			}
    		}
    	},
    	SignMessage: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			message: {
    				rule: "required",
    				type: "bytes",
    				id: 2
    			},
    			coin_name: {
    				type: "string",
    				id: 3,
    				options: {
    					"default": "Bitcoin"
    				}
    			},
    			script_type: {
    				type: "InputScriptType",
    				id: 4,
    				options: {
    					"default": "SPENDADDRESS"
    				}
    			}
    		}
    	},
    	VerifyMessage: {
    		fields: {
    			address: {
    				type: "string",
    				id: 1
    			},
    			signature: {
    				type: "bytes",
    				id: 2
    			},
    			message: {
    				type: "bytes",
    				id: 3
    			},
    			coin_name: {
    				type: "string",
    				id: 4,
    				options: {
    					"default": "Bitcoin"
    				}
    			}
    		}
    	},
    	MessageSignature: {
    		fields: {
    			address: {
    				type: "string",
    				id: 1
    			},
    			signature: {
    				type: "bytes",
    				id: 2
    			}
    		}
    	},
    	EncryptMessage: {
    		fields: {
    			pubkey: {
    				type: "bytes",
    				id: 1
    			},
    			message: {
    				type: "bytes",
    				id: 2
    			},
    			display_only: {
    				type: "bool",
    				id: 3
    			},
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 4,
    				options: {
    					packed: false
    				}
    			},
    			coin_name: {
    				type: "string",
    				id: 5,
    				options: {
    					"default": "Bitcoin"
    				}
    			}
    		}
    	},
    	EncryptedMessage: {
    		fields: {
    			nonce: {
    				type: "bytes",
    				id: 1
    			},
    			message: {
    				type: "bytes",
    				id: 2
    			},
    			hmac: {
    				type: "bytes",
    				id: 3
    			}
    		}
    	},
    	DecryptMessage: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			nonce: {
    				type: "bytes",
    				id: 2
    			},
    			message: {
    				type: "bytes",
    				id: 3
    			},
    			hmac: {
    				type: "bytes",
    				id: 4
    			}
    		}
    	},
    	DecryptedMessage: {
    		fields: {
    			message: {
    				type: "bytes",
    				id: 1
    			},
    			address: {
    				type: "string",
    				id: 2
    			}
    		}
    	},
    	CipherKeyValue: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			key: {
    				type: "string",
    				id: 2
    			},
    			value: {
    				type: "bytes",
    				id: 3
    			},
    			encrypt: {
    				type: "bool",
    				id: 4
    			},
    			ask_on_encrypt: {
    				type: "bool",
    				id: 5
    			},
    			ask_on_decrypt: {
    				type: "bool",
    				id: 6
    			},
    			iv: {
    				type: "bytes",
    				id: 7
    			}
    		}
    	},
    	CipheredKeyValue: {
    		fields: {
    			value: {
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	EstimateTxSize: {
    		fields: {
    			outputs_count: {
    				rule: "required",
    				type: "uint32",
    				id: 1
    			},
    			inputs_count: {
    				rule: "required",
    				type: "uint32",
    				id: 2
    			},
    			coin_name: {
    				type: "string",
    				id: 3,
    				options: {
    					"default": "Bitcoin"
    				}
    			}
    		}
    	},
    	TxSize: {
    		fields: {
    			tx_size: {
    				type: "uint32",
    				id: 1
    			}
    		}
    	},
    	SignTx: {
    		fields: {
    			outputs_count: {
    				rule: "required",
    				type: "uint32",
    				id: 1
    			},
    			inputs_count: {
    				rule: "required",
    				type: "uint32",
    				id: 2
    			},
    			coin_name: {
    				type: "string",
    				id: 3,
    				options: {
    					"default": "Bitcoin"
    				}
    			},
    			version: {
    				type: "uint32",
    				id: 4,
    				options: {
    					"default": 1
    				}
    			},
    			lock_time: {
    				type: "uint32",
    				id: 5,
    				options: {
    					"default": 0
    				}
    			},
    			expiry: {
    				type: "uint32",
    				id: 6
    			},
    			overwintered: {
    				type: "bool",
    				id: 7
    			},
    			version_group_id: {
    				type: "uint32",
    				id: 8
    			}
    		}
    	},
    	SimpleSignTx: {
    		fields: {
    			inputs: {
    				rule: "repeated",
    				type: "TxInputType",
    				id: 1
    			},
    			outputs: {
    				rule: "repeated",
    				type: "TxOutputType",
    				id: 2
    			},
    			transactions: {
    				rule: "repeated",
    				type: "TransactionType",
    				id: 3
    			},
    			coin_name: {
    				type: "string",
    				id: 4,
    				options: {
    					"default": "Bitcoin"
    				}
    			},
    			version: {
    				type: "uint32",
    				id: 5,
    				options: {
    					"default": 1
    				}
    			},
    			lock_time: {
    				type: "uint32",
    				id: 6,
    				options: {
    					"default": 0
    				}
    			},
    			expiry: {
    				type: "uint32",
    				id: 7
    			},
    			overwintered: {
    				type: "bool",
    				id: 8
    			}
    		}
    	},
    	TxRequest: {
    		fields: {
    			request_type: {
    				type: "RequestType",
    				id: 1
    			},
    			details: {
    				type: "TxRequestDetailsType",
    				id: 2
    			},
    			serialized: {
    				type: "TxRequestSerializedType",
    				id: 3
    			}
    		}
    	},
    	TxAck: {
    		fields: {
    			tx: {
    				type: "TransactionType",
    				id: 1
    			}
    		}
    	},
    	RawTxAck: {
    		fields: {
    			tx: {
    				type: "RawTransactionType",
    				id: 1
    			}
    		}
    	},
    	EthereumSignTx: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			nonce: {
    				type: "bytes",
    				id: 2
    			},
    			gas_price: {
    				type: "bytes",
    				id: 3
    			},
    			gas_limit: {
    				type: "bytes",
    				id: 4
    			},
    			to: {
    				type: "bytes",
    				id: 5
    			},
    			value: {
    				type: "bytes",
    				id: 6
    			},
    			data_initial_chunk: {
    				type: "bytes",
    				id: 7
    			},
    			data_length: {
    				type: "uint32",
    				id: 8
    			},
    			to_address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 9,
    				options: {
    					packed: false
    				}
    			},
    			address_type: {
    				type: "OutputAddressType",
    				id: 10
    			},
    			exchange_type: {
    				type: "ExchangeType",
    				id: 11
    			},
    			chain_id: {
    				type: "uint32",
    				id: 12
    			},
    			token_value: {
    				type: "bytes",
    				id: 100
    			},
    			token_to: {
    				type: "bytes",
    				id: 101
    			},
    			token_shortcut: {
    				type: "string",
    				id: 102
    			},
    			tx_type: {
    				type: "uint32",
    				id: 103
    			}
    		}
    	},
    	EthereumTxRequest: {
    		fields: {
    			data_length: {
    				type: "uint32",
    				id: 1
    			},
    			signature_v: {
    				type: "uint32",
    				id: 2
    			},
    			signature_r: {
    				type: "bytes",
    				id: 3
    			},
    			signature_s: {
    				type: "bytes",
    				id: 4
    			},
    			hash: {
    				type: "bytes",
    				id: 5
    			},
    			signature_der: {
    				type: "bytes",
    				id: 6
    			}
    		}
    	},
    	EthereumTxAck: {
    		fields: {
    			data_chunk: {
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	EthereumSignMessage: {
    		fields: {
    			address_n: {
    				rule: "repeated",
    				type: "uint32",
    				id: 1,
    				options: {
    					packed: false
    				}
    			},
    			message: {
    				rule: "required",
    				type: "bytes",
    				id: 2
    			}
    		}
    	},
    	EthereumVerifyMessage: {
    		fields: {
    			address: {
    				type: "bytes",
    				id: 1
    			},
    			signature: {
    				type: "bytes",
    				id: 2
    			},
    			message: {
    				type: "bytes",
    				id: 3
    			}
    		}
    	},
    	EthereumMessageSignature: {
    		fields: {
    			address: {
    				type: "bytes",
    				id: 1
    			},
    			signature: {
    				type: "bytes",
    				id: 2
    			}
    		}
    	},
    	SignIdentity: {
    		fields: {
    			identity: {
    				type: "IdentityType",
    				id: 1
    			},
    			challenge_hidden: {
    				type: "bytes",
    				id: 2
    			},
    			challenge_visual: {
    				type: "string",
    				id: 3
    			},
    			ecdsa_curve_name: {
    				type: "string",
    				id: 4
    			}
    		}
    	},
    	SignedIdentity: {
    		fields: {
    			address: {
    				type: "string",
    				id: 1
    			},
    			public_key: {
    				type: "bytes",
    				id: 2
    			},
    			signature: {
    				type: "bytes",
    				id: 3
    			}
    		}
    	},
    	ApplyPolicies: {
    		fields: {
    			policy: {
    				rule: "repeated",
    				type: "PolicyType",
    				id: 1
    			}
    		}
    	},
    	FlashHash: {
    		fields: {
    			address: {
    				type: "uint32",
    				id: 1
    			},
    			length: {
    				type: "uint32",
    				id: 2
    			},
    			challenge: {
    				type: "bytes",
    				id: 3
    			}
    		}
    	},
    	FlashWrite: {
    		fields: {
    			address: {
    				type: "uint32",
    				id: 1
    			},
    			data: {
    				type: "bytes",
    				id: 2
    			},
    			erase: {
    				type: "bool",
    				id: 3
    			}
    		}
    	},
    	FlashHashResponse: {
    		fields: {
    			data: {
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	DebugLinkFlashDump: {
    		fields: {
    			address: {
    				type: "uint32",
    				id: 1
    			},
    			length: {
    				type: "uint32",
    				id: 2
    			}
    		}
    	},
    	DebugLinkFlashDumpResponse: {
    		fields: {
    			data: {
    				type: "bytes",
    				id: 1
    			}
    		}
    	},
    	SoftReset: {
    		fields: {
    		}
    	},
    	FirmwareErase: {
    		fields: {
    		}
    	},
    	FirmwareUpload: {
    		fields: {
    			payload_hash: {
    				rule: "required",
    				type: "bytes",
    				id: 1
    			},
    			payload: {
    				rule: "required",
    				type: "bytes",
    				id: 2
    			}
    		}
    	},
    	DebugLinkDecision: {
    		fields: {
    			yes_no: {
    				rule: "required",
    				type: "bool",
    				id: 1
    			}
    		}
    	},
    	DebugLinkGetState: {
    		fields: {
    		}
    	},
    	DebugLinkState: {
    		fields: {
    			layout: {
    				type: "bytes",
    				id: 1
    			},
    			pin: {
    				type: "string",
    				id: 2
    			},
    			matrix: {
    				type: "string",
    				id: 3
    			},
    			mnemonic: {
    				type: "string",
    				id: 4
    			},
    			node: {
    				type: "HDNodeType",
    				id: 5
    			},
    			passphrase_protection: {
    				type: "bool",
    				id: 6
    			},
    			reset_word: {
    				type: "string",
    				id: 7
    			},
    			reset_entropy: {
    				type: "bytes",
    				id: 8
    			},
    			recovery_fake_word: {
    				type: "string",
    				id: 9
    			},
    			recovery_word_pos: {
    				type: "uint32",
    				id: 10
    			},
    			recovery_cipher: {
    				type: "string",
    				id: 11
    			},
    			recovery_auto_completed_word: {
    				type: "string",
    				id: 12
    			},
    			firmware_hash: {
    				type: "bytes",
    				id: 13
    			},
    			storage_hash: {
    				type: "bytes",
    				id: 14
    			}
    		}
    	},
    	DebugLinkStop: {
    		fields: {
    		}
    	},
    	DebugLinkLog: {
    		fields: {
    			level: {
    				type: "uint32",
    				id: 1
    			},
    			bucket: {
    				type: "string",
    				id: 2
    			},
    			text: {
    				type: "string",
    				id: 3
    			}
    		}
    	},
    	DebugLinkFillConfig: {
    		fields: {
    		}
    	}
    };
    var proto$1 = {
    	options: options,
    	nested: nested
    };

    var values = proto$1.nested.MessageType.values;
    var messageTypeRegistry = Object.entries(values).reduce(function (registry, entry) {
        registry[entry[1]] = messages_pb[entry[0].split('_')[1]];
        return registry;
    }, {});

    var values$1 = proto$1.nested.MessageType.values;
    // Map of message type enums to human readable message name
    var messageNameRegistry = Object.entries(values$1).reduce(function (registry, entry) {
        registry[entry[1]] = entry[0].split('_')[1];
        return registry;
    }, {});

    function makeEvent(e) {
        return __assign({ message_type: messageNameRegistry[e.message_enum], date: Date.now() }, e);
    }

    var NO_THROW_CODES = [
        types_pb.FailureType.FAILURE_ACTIONCANCELLED,
        types_pb.FailureType.FAILURE_PINCANCELLED
    ];
    var Device = /** @class */ (function () {
        function Device() {
        }
        // exchange sends a request to the device and streams back the results
        // the MessageType enum numer will be returned in addition to the google-protobuf message
        // based on trezorExchange()
        // in https://github.com/go-ethereum/accounts/usbwallet/trezor.go
        // and https://github.com/solipsis/go-keepkey/blob/master/pkg/keepkey/transport.go#L277
        Device.prototype.exchange = function (msgTypeEnum, msg) {
            return __awaiter(this, void 0, void 0, function () {
                var msgBuffer, responseBuffer, _a, responseTypeEnum, responseMsg, errorResponse, ack, interruptedResponse, interruptedResponse, interruptedResponse;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            msgBuffer = this.toMessageBuffer(msgTypeEnum, msg);
                            return [4 /*yield*/, this.sendRaw(msgBuffer)];
                        case 1:
                            responseBuffer = _b.sent();
                            this.events.emit(String(msgTypeEnum), makeEvent({
                                message_enum: msgTypeEnum,
                                message: msg.toObject(),
                                from_device: false,
                                interface: this.interface
                            }));
                            _a = this.fromMessageBuffer(responseBuffer), responseTypeEnum = _a[0], responseMsg = _a[1];
                            this.events.emit(String(responseTypeEnum), makeEvent({
                                message_enum: responseTypeEnum,
                                message: responseMsg.toObject(),
                                from_device: true,
                                interface: this.interface
                            }));
                            // If error, throw with response message
                            if (responseTypeEnum === messages_pb.MessageType.MESSAGETYPE_FAILURE) {
                                errorResponse = responseMsg;
                                if (!NO_THROW_CODES.includes(errorResponse.getCode()))
                                    throw new Error(errorResponse.getMessage()); // We don't want to throw if cancel actions are user initiated
                            }
                            if (responseTypeEnum === messages_pb.MessageType.MESSAGETYPE_BUTTONREQUEST) {
                                return [2 /*return*/, this.exchange(messages_pb.MessageType.MESSAGETYPE_BUTTONACK, new messages_pb.ButtonAck())];
                            }
                            if (responseTypeEnum === messages_pb.MessageType.MESSAGETYPE_ENTROPYREQUEST) {
                                ack = new messages_pb.EntropyAck();
                                ack.setEntropy(this.getEntropy(32));
                                return [2 /*return*/, this.exchange(messages_pb.MessageType.MESSAGETYPE_ENTROPYACK, ack)];
                            }
                            if (!(responseTypeEnum === messages_pb.MessageType.MESSAGETYPE_PINMATRIXREQUEST)) return [3 /*break*/, 3];
                            return [4 /*yield*/, fromEvent(this.events, 'PINMATRIXACK_INTERRUPT_RESULT').pipe(take(1)).toPromise()];
                        case 2:
                            interruptedResponse = _b.sent();
                            return [2 /*return*/, interruptedResponse];
                        case 3:
                            if (!(responseTypeEnum === messages_pb.MessageType.MESSAGETYPE_PASSPHRASEREQUEST)) return [3 /*break*/, 5];
                            return [4 /*yield*/, fromEvent(this.events, 'PASSPHRASEACK_INTERRUPT_RESULT').pipe(take(1)).toPromise()];
                        case 4:
                            interruptedResponse = _b.sent();
                            return [2 /*return*/, interruptedResponse];
                        case 5:
                            if (!(responseTypeEnum === messages_pb.MessageType.MESSAGETYPE_CHARACTERREQUEST)) return [3 /*break*/, 7];
                            return [4 /*yield*/, fromEvent(this.events, 'CHARACTERACK_INTERRUPT_RESULT').pipe(take(1)).toPromise()];
                        case 6:
                            interruptedResponse = _b.sent();
                            return [2 /*return*/, interruptedResponse];
                        case 7: return [2 /*return*/, [responseTypeEnum, responseMsg]];
                    }
                });
            });
        };
        Device.prototype.toMessageBuffer = function (msgTypeEnum, msg) {
            var messageBuffer = msg.serializeBinary();
            var headerBuffer = new ArrayBuffer(8);
            var headerView = new DataView(headerBuffer);
            headerView.setUint8(0, 0x23);
            headerView.setUint8(1, 0x23);
            headerView.setUint16(2, msgTypeEnum);
            headerView.setUint32(4, messageBuffer.byteLength);
            return bytebuffer.concat([headerView.buffer, messageBuffer]);
        };
        Device.prototype.fromMessageBuffer = function (buff) {
            var dataView = buff.view;
            var typeID = leByteArrayToLong(dataView.slice(3, 5));
            var MessageType = messageTypeRegistry[typeID];
            if (!MessageType) {
                var msg_1 = new messages_pb.Failure();
                msg_1.setCode(types_pb.FailureType.FAILURE_UNEXPECTEDMESSAGE);
                msg_1.setMessage('Unknown message type received');
                return [messages_pb.MessageType.MESSAGETYPE_FAILURE, msg_1];
            }
            var msg = new MessageType();
            var reader = new googleProtobuf.BinaryReader(dataView.slice(9), 0, buff.limit - (9 + 2));
            return [typeID, MessageType.deserializeBinaryFromReader(msg, reader)];
        };
        Device.failureMessageFactory = function (e) {
            var msg = new messages_pb.Failure();
            msg.setCode(types_pb.FailureType.FAILURE_UNEXPECTEDMESSAGE);
            if (typeof e === 'string') {
                msg.setMessage(e);
            }
            else {
                msg.setMessage(String(e));
            }
            return bytebuffer.wrap(msg.serializeBinary());
        };
        return Device;
    }());

    var SEGMENT_SIZE = 63;
    var WebUSBDevice = /** @class */ (function (_super) {
        __extends(WebUSBDevice, _super);
        function WebUSBDevice(config) {
            var _this = _super.call(this) || this;
            _this.interface = 'StandardWebUSB';
            _this.usbDevice = config.usbDevice;
            _this.events = config.events || new eventemitter2.EventEmitter2();
            _this.queue = new pQueue({ concurrency: 1 });
            return _this;
        }
        WebUSBDevice.requestPair = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, window.navigator.usb.requestDevice({ filters: [{ vendorId: 0x2b24 }] })];
                });
            });
        };
        Object.defineProperty(WebUSBDevice.prototype, "isInitialized", {
            get: function () {
                return this.usbDevice.opened;
            },
            enumerable: true,
            configurable: true
        });
        WebUSBDevice.prototype.initialize = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.usbDevice.open()];
                        case 1:
                            _a.sent();
                            if (!(this.usbDevice.configuration === null)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.usbDevice.selectConfiguration(1)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [4 /*yield*/, this.usbDevice.claimInterface(0)];
                        case 4:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        WebUSBDevice.prototype.cancelPending = function () {
            return __awaiter(this, void 0, void 0, function () {
                var cancelMsg, buffer, e_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('pending', this.queue.pending);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            // If there are no pending commands, we should wait for a read back from the cancel command
                            // Otherwise the pending promise will read the error
                            if (this.queue.pending === 0) {
                                this.queue.add(function () { return _this.read(); }, { priority: 1000 })
                                    .then(function () { return console.log('cancenPending read done'); })
                                    .catch(function (e) { return console.log('cancenPending read failed', e); });
                            }
                            cancelMsg = new messages_pb.Cancel();
                            buffer = this.toMessageBuffer(messages_pb.MessageType.MESSAGETYPE_CANCEL, cancelMsg);
                            return [4 /*yield*/, this.write(buffer)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            console.error('Cancel Pending Error', e_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        WebUSBDevice.prototype.disconnect = function () {
            return __awaiter(this, void 0, void 0, function () {
                var e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            // If the device is disconnected, this will fail and throw, which is fine.
                            return [4 /*yield*/, this.usbDevice.close()];
                        case 1:
                            // If the device is disconnected, this will fail and throw, which is fine.
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            e_2 = _a.sent();
                            console.log('Disconnect Error (Ignored):', e_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        WebUSBDevice.prototype.getEntropy = function (length) {
            if (length === void 0) { length = 64; }
            return window.crypto.getRandomValues(new Uint8Array(length));
        };
        // This must return a tuple of [returnedBuffer, entireBufferThatWasSent], concatenating if
        // buffers were sent in chunks
        WebUSBDevice.prototype.sendRaw = function (buffer) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    // Temporarily removing queue to debug overflow error potentially caused by concurrent sends
                    return [2 /*return*/, this.queue.add(function () { return __awaiter(_this, void 0, void 0, function () {
                            var e_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, this.write(buffer)];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, this.read()];
                                    case 2: return [2 /*return*/, _a.sent()];
                                    case 3:
                                        e_3 = _a.sent();
                                        return [2 /*return*/, Device.failureMessageFactory(e_3)];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        WebUSBDevice.prototype.write = function (buff) {
            return __awaiter(this, void 0, void 0, function () {
                var i, segment, padding, fragments, fragmentBuffer;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // break frame into segments
                            this.events.emit('write', buff);
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < buff.limit)) return [3 /*break*/, 4];
                            segment = buff.toArrayBuffer().slice(i, i + SEGMENT_SIZE);
                            padding = new Array(SEGMENT_SIZE - segment.byteLength + 1).join('\0');
                            fragments = [];
                            fragments.push([63]);
                            fragments.push(segment);
                            fragments.push(padding);
                            fragmentBuffer = bytebuffer.concat(fragments);
                            return [4 /*yield*/, this.writeChunk(fragmentBuffer)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i += SEGMENT_SIZE;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        WebUSBDevice.prototype.read = function () {
            return __awaiter(this, void 0, void 0, function () {
                var first, valid, msgLength, buffer, k, offset, next, k, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.events.emit('reading');
                            return [4 /*yield*/, this.readChunk()
                                // Check that buffer starts with: "?##" [ 0x3f, 0x23, 0x23 ]
                                // "?" = USB marker, "##" = KeepKey magic bytes
                                // Message ID is bytes 4-5. Message length starts at byte 6.
                            ];
                        case 1:
                            first = _a.sent();
                            valid = (first.getUint32(0) & 0xffffff00) === 0x3f232300;
                            msgLength = first.getUint32(5);
                            if (!(valid && msgLength >= 0 && msgLength < 131072)) return [3 /*break*/, 5];
                            buffer = new Uint8Array(9 + 2 + msgLength);
                            for (k = 0; k < first.byteLength; k++) {
                                buffer[k] = first.getUint8(k);
                            }
                            offset = first.byteLength;
                            _a.label = 2;
                        case 2:
                            if (!(offset < buffer.length)) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.readChunk()
                                // Drop USB "?" packet identifier in the first byte
                            ];
                        case 3:
                            next = _a.sent();
                            // Drop USB "?" packet identifier in the first byte
                            for (k = 1; (k < next.byteLength && offset < buffer.length); k++) {
                                buffer[offset] = next.getUint8(k);
                                offset++;
                            }
                            return [3 /*break*/, 2];
                        case 4:
                            res = bytebuffer.wrap(buffer);
                            this.events.emit('read', res);
                            return [2 /*return*/, res];
                        case 5:
                            console.error('Invalid message', { msgLength: msgLength, valid: valid, first: first });
                            throw new Error('Invalid message');
                    }
                });
            });
        };
        WebUSBDevice.prototype.writeChunk = function (buffer) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.usbDevice.transferOut(1, buffer.toArrayBuffer())];
                });
            });
        };
        WebUSBDevice.prototype.readChunk = function () {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.usbDevice.transferIn(1, SEGMENT_SIZE + 1)];
                        case 1:
                            result = _a.sent();
                            if (!(result.status === 'stall')) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.usbDevice.clearHalt('out', 1)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/, Promise.resolve(result.data)];
                    }
                });
            });
        };
        return WebUSBDevice;
    }(Device));

    var initialKeepKeyArgs = {
        autoButton: false,
        device: null
    };
    var KeepKey = /** @class */ (function () {
        function KeepKey(config) {
            this.autoButton = false;
            var mergedConfig = __assign({}, initialKeepKeyArgs, config);
            this.autoButton = mergedConfig.autoButton;
            this.device = mergedConfig.device;
        }
        KeepKey.withWebUSB = function (webUSBDeviceConfig) {
            return new KeepKey({ autoButton: false, device: new WebUSBDevice(webUSBDeviceConfig) });
        };
        KeepKey.prototype.acknowledgeWithCharacter = function (character) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.acknowledgeWithCharacterProto(character, false, false)];
                });
            });
        };
        KeepKey.prototype.acknowledgeWithCharacterDelete = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.acknowledgeWithCharacterProto('', true, false)];
                });
            });
        };
        KeepKey.prototype.acknowledgeWithCharacterDone = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.acknowledgeWithCharacterProto('', false, true)];
                });
            });
        };
        KeepKey.prototype.acknowledgeWithCharacterProto = function (character, _delete, _done) {
            return __awaiter(this, void 0, void 0, function () {
                var characterAck, _a, typeEnum, response, responseObj;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            characterAck = new messages_pb.CharacterAck();
                            if (character !== '') {
                                characterAck.setCharacter(character);
                            }
                            else if (_delete) {
                                characterAck.setDelete(_delete);
                            }
                            else if (_done) {
                                characterAck.setDone(_done);
                            }
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_CHARACTERACK, characterAck)];
                        case 1:
                            _a = _b.sent(), typeEnum = _a[0], response = _a[1];
                            responseObj = response.toObject();
                            // Emit event to notify clients that a character has been exchanged
                            this.device.events.emit('CHARACTERACK_INTERRUPT_RESULT', typeEnum, response);
                            return [2 /*return*/, [typeEnum, responseObj]];
                    }
                });
            });
        };
        // Send passphrase to the device, this will typically be called in response to a MESSAGETYPE_PASSPHRASEREQUEST event
        KeepKey.prototype.acknowledgeWithPassphrase = function (passphrase) {
            return __awaiter(this, void 0, void 0, function () {
                var passphraseAck, _a, typeEnum, response, responseObj;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            passphraseAck = new messages_pb.PassphraseAck();
                            passphraseAck.setPassphrase(passphrase);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_PASSPHRASEACK, passphraseAck)];
                        case 1:
                            _a = _b.sent(), typeEnum = _a[0], response = _a[1];
                            responseObj = response.toObject();
                            // Emit event to notify clients that passphrase has been exchanged
                            this.device.events.emit('PASSPHRASEACK_INTERRUPT_RESULT', typeEnum, response);
                            return [2 /*return*/, [typeEnum, responseObj]];
                    }
                });
            });
        };
        // Send pin to the device, this will typically be called in response to a MESSAGETYPE_PINMATRIXREQUEST event
        KeepKey.prototype.acknowledgeWithPin = function (pin) {
            return __awaiter(this, void 0, void 0, function () {
                var matrixAck, _a, typeEnum, response, responseObj;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            matrixAck = new messages_pb.PinMatrixAck();
                            matrixAck.setPin(pin);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_PINMATRIXACK, matrixAck)];
                        case 1:
                            _a = _b.sent(), typeEnum = _a[0], response = _a[1];
                            responseObj = response.toObject();
                            // Emit event to notify clients that pin has been exchanged
                            this.device.events.emit('PINMATRIXACK_INTERRUPT_RESULT', typeEnum, response);
                            return [2 /*return*/, [typeEnum, responseObj]];
                    }
                });
            });
        };
        // ApplyPolicy enables or disables a named policy such as "ShapeShift" on the device
        KeepKey.prototype.applyPolicy = function (p) {
            return __awaiter(this, void 0, void 0, function () {
                var policy, applyPolicies;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            policy = new types_pb.PolicyType();
                            policy.setPolicyName(p.policyName);
                            policy.setEnabled(p.enabled);
                            applyPolicies = new messages_pb.ApplyPolicies();
                            applyPolicies.setPolicyList([policy]);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_APPLYPOLICIES, applyPolicies)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // ApplySettings changes the label, language, and enabling/disabling the passphrase
        // The default language is english
        KeepKey.prototype.applySettings = function (s) {
            return __awaiter(this, void 0, void 0, function () {
                var applySettings;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            applySettings = new messages_pb.ApplySettings();
                            if (s.label) {
                                applySettings.setLabel(s.label);
                            }
                            if (s.language) {
                                applySettings.setLanguage(s.language);
                            }
                            if (s.usePassphrase !== undefined) {
                                applySettings.setUsePassphrase(s.usePassphrase);
                            }
                            if (s.autoLockDelayMs) {
                                applySettings.setAutoLockDelayMs(s.autoLockDelayMs);
                            }
                            if (s.u2fCounter) {
                                applySettings.setU2fCounter(s.u2fCounter);
                            }
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_APPLYSETTINGS, applySettings)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // Cancel aborts the last device action that required user interaction
        // It can follow a button request, passphrase request, or pin request
        KeepKey.prototype.cancel = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.device.cancelPending()];
                        case 1:
                            _a.sent();
                            this.device.events.emit('CANCEL_ACTION');
                            return [2 /*return*/];
                    }
                });
            });
        };
        // ChangePin requests setting/changing the pin
        KeepKey.prototype.changePin = function () {
            return __awaiter(this, void 0, void 0, function () {
                var changePin;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            changePin = new messages_pb.ChangePin();
                            // User may be propmpted for button press up to 2 times
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_CHANGEPIN, changePin)];
                        case 1:
                            // User may be propmpted for button press up to 2 times
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // CipherKeyValue encrypts or decrypts a value with a given key, nodepath, and initializationVector
        // This method encrypts if encrypt is true and decrypts if false, the confirm paramater determines wether
        // the user is prompted on the device. See EncryptKeyValue() and DecryptKeyValue() for convenience methods
        // NOTE: If the length of the value in bytes is not divisible by 16 it will be zero padded
        KeepKey.prototype.cipherKeyValue = function (v) {
            return __awaiter(this, void 0, void 0, function () {
                var cipherKeyValue, _a, _, response, value;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            cipherKeyValue = new messages_pb.CipherKeyValue();
                            cipherKeyValue.setAddressNList(v.addressNList);
                            cipherKeyValue.setKey(v.key);
                            cipherKeyValue.setValue(v.value);
                            cipherKeyValue.setEncrypt(v.encrypt);
                            cipherKeyValue.setAskOnEncrypt(v.askOnEncrypt || false);
                            cipherKeyValue.setAskOnDecrypt(v.askOnDecrypt || false);
                            cipherKeyValue.setIv(v.iv || '');
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_CIPHERKEYVALUE, cipherKeyValue)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            value = response.toObject().value;
                            return [2 /*return*/, value];
                    }
                });
            });
        };
        // ClearSession clears cached session values such as the pin and passphrase
        KeepKey.prototype.clearSession = function () {
            return __awaiter(this, void 0, void 0, function () {
                var clearSession;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            clearSession = new messages_pb.ClearSession();
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_CLEARSESSION, clearSession)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // DecryptKeyValue is a convenience method around decrypting with CipherKeyValue().
        // For more granular control of the process use CipherKeyValue()
        KeepKey.prototype.decryptKeyValue = function (v) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.cipherKeyValue(v)];
                });
            });
        };
        // EthereumGetAddress returns the ethereum address associated with the given node path
        // Optionally you can display  the address on the screen
        KeepKey.prototype.ethereumGetAddress = function (a) {
            return __awaiter(this, void 0, void 0, function () {
                var getAddr, _a, _, response, ethAddress;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            getAddr = new messages_pb.EthereumGetAddress();
                            getAddr.setAddressNList(a.addressNList);
                            getAddr.setShowDisplay(a.showDisplay !== false);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_ETHEREUMGETADDRESS, getAddr)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            ethAddress = response;
                            if (ethAddress.hasAddressStr()) {
                                return [2 /*return*/, ethAddress.getAddressStr()];
                            }
                            else if (ethAddress.hasAddress()) {
                                return [2 /*return*/, '0x' + toHexString(ethAddress.getAddress_asU8())];
                            }
                            throw new Error('unable to obtain eth address from device');
                    }
                });
            });
        };
        // Sign an ethereum transaction using a given node path
        // The user may be prompted for a pin and/or passphrase if they are enabled
        KeepKey.prototype.ethereumSignTx = function (tx, addressType, exchangeType, data, chainId) {
            return __awaiter(this, void 0, void 0, function () {
                var est, dataChunk, dataRemaining, response, nextResponse, dataLength;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            est = new messages_pb.EthereumSignTx();
                            if (addressType === types_pb.OutputAddressType.TRANSFER) {
                                throw Error('Not implemented yet.');
                            }
                            else if (addressType === types_pb.OutputAddressType.EXCHANGE) {
                                est.setAddressNList(tx.addressNList);
                                est.setNonce(typeof tx.nonce === 'string' ? arrayify(tx.nonce) : tx.nonce);
                                est.setGasPrice(typeof tx.gasPrice === 'string' ? arrayify(tx.gasPrice) : tx.gasPrice);
                                est.setGasLimit(typeof tx.gasLimit === 'string' ? arrayify(tx.gasLimit) : tx.gasLimit);
                                est.setValue(typeof tx.value === 'string' ? arrayify(tx.value) : tx.value);
                                est.setAddressType(types_pb.OutputAddressType.EXCHANGE);
                                est.setExchangeType(exchangeType);
                            }
                            else {
                                est.setAddressNList(tx.addressNList);
                                est.setNonce(typeof tx.nonce === 'string' ? arrayify(tx.nonce) : tx.nonce);
                                est.setGasPrice(typeof tx.gasPrice === 'string' ? arrayify(tx.gasPrice) : tx.gasPrice);
                                est.setGasLimit(typeof tx.gasLimit === 'string' ? arrayify(tx.gasLimit) : tx.gasLimit);
                                est.setValue(typeof tx.value === 'string' ? arrayify(tx.value) : tx.value);
                                est.setAddressType(types_pb.OutputAddressType.SPEND);
                            }
                            if (tx.to) {
                                if (typeof tx.to === 'string')
                                    est.setTo(arrayify(tx.to));
                                else
                                    est.setTo(tx.to);
                            }
                            dataChunk = null;
                            dataRemaining = typeof data === 'string' ? arrayify(data) : data;
                            if (dataRemaining) {
                                est.setDataLength(dataRemaining.length);
                                dataChunk = dataRemaining.slice(0, 1024);
                                dataRemaining = dataRemaining.slice(dataChunk.length);
                                est.setDataInitialChunk(dataChunk);
                            }
                            if (chainId != null) {
                                est.setChainId(chainId);
                            }
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_ETHEREUMSIGNTX, est)];
                        case 1:
                            nextResponse = _a.sent();
                            response = nextResponse[1];
                            _a.label = 2;
                        case 2:
                            if (!response.hasDataLength()) return [3 /*break*/, 4];
                            dataLength = response.getDataLength();
                            dataChunk = dataRemaining.slice(0, dataLength);
                            dataRemaining = dataRemaining.slice(dataLength, dataRemaining.length);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_ETHEREUMSIGNTX, est)];
                        case 3:
                            nextResponse = _a.sent();
                            response = nextResponse[1];
                            return [3 /*break*/, 2];
                        case 4: return [2 /*return*/, {
                                r: '0x' + toHexString(response.getSignatureR_asU8()),
                                s: '0x' + toHexString(response.getSignatureS_asU8()),
                                v: '0x' + response.getSignatureV().toString(16)
                            }];
                    }
                });
            });
        };
        KeepKey.prototype.ethereumSignMessage = function (m) {
            return __awaiter(this, void 0, void 0, function () {
                var msg, _a, _, response, sig;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            msg = new messages_pb.EthereumSignMessage();
                            msg.setAddressNList(m.addressNList || bip32ToAddressNList("m/44'/60'/0'/0/0"));
                            msg.setMessage(m.message);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_ETHEREUMSIGNMESSAGE, msg)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            sig = response.toObject();
                            return [2 /*return*/, {
                                    address: sig.address,
                                    signature: sig.signature
                                }];
                    }
                });
            });
        };
        KeepKey.prototype.ethereumVerifyMessage = function (m) {
            return __awaiter(this, void 0, void 0, function () {
                var msg, _a, _, response;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            msg = new messages_pb.EthereumVerifyMessage();
                            msg.setAddress(m.address);
                            msg.setSignature(m.signature);
                            msg.setMessage(m.message);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_ETHEREUMVERIFYMESSAGE, msg)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            return [2 /*return*/, typeof response === typeof messages_pb.Success];
                    }
                });
            });
        };
        // FirmwareErase askes the device to erase its firmware
        KeepKey.prototype.firmwareErase = function () {
            return __awaiter(this, void 0, void 0, function () {
                var firmwareErase;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            firmwareErase = new messages_pb.FirmwareErase();
                            // send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_FIRMWAREERASE, firmwareErase)];
                        case 1:
                            // send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // Initialize assigns a hid connection to this KeepKey and send initialize message to device
        KeepKey.prototype.initialize = function () {
            return __awaiter(this, void 0, void 0, function () {
                var initialize, _a, _, response, features;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.device.initialize()
                            // send initialize
                        ];
                        case 1:
                            _b.sent();
                            initialize = new messages_pb.Initialize();
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_INITIALIZE, initialize)];
                        case 2:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            features = response.toObject();
                            this.features = features;
                            return [2 /*return*/, features];
                    }
                });
            });
        };
        // GetAddress returns an address string given a node path and a coin type.
        // Optionally you can display the address on the device screen
        // If passphrase is enabled this may request the passphrase.
        KeepKey.prototype.getAddress = function (g) {
            return __awaiter(this, void 0, void 0, function () {
                var address, _a, _, response, msg;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            address = new messages_pb.GetAddress();
                            address.setAddressNList(g.addressNList);
                            address.setCoinName(g.coinName);
                            address.setShowDisplay(g.showDisplay !== false);
                            address.setScriptType(g.scriptType || types_pb.InputScriptType.SPENDADDRESS);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_GETADDRESS, address)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            msg = response.toObject();
                            return [2 /*return*/, msg.address];
                    }
                });
            });
        };
        // GetFeatures returns the features and other device information such as the version, label, and supported coins
        KeepKey.prototype.getFeatures = function () {
            return __awaiter(this, void 0, void 0, function () {
                var features, _a, _, response;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            features = new messages_pb.GetFeatures();
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_GETFEATURES, features)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            return [2 /*return*/, response.toObject()];
                    }
                });
            });
        };
        // GetEntropy requests sample data from the hardware RNG
        KeepKey.prototype.getEntropy = function (size) {
            return __awaiter(this, void 0, void 0, function () {
                var getEntropy, _a, _, response, entropy;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            getEntropy = new messages_pb.GetEntropy();
                            getEntropy.setSize(size);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_GETENTROPY, getEntropy)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            entropy = response.toObject().entropy;
                            return [2 /*return*/, entropy];
                    }
                });
            });
        };
        // GetPublicKey asks the device for a public key corresponding to a nodePath and curve name.
        // Returns the hdnode, the XPUB as a string and a possidble error
        // This may prompt the user for a passphrase
        KeepKey.prototype.getPublicKey = function (g) {
            return __awaiter(this, void 0, void 0, function () {
                var getPublicKey, _a, _, response, publicKey;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            getPublicKey = new messages_pb.GetPublicKey();
                            getPublicKey.setAddressNList(g.addressNList);
                            getPublicKey.setEcdsaCurveName(g.ecdsaCurveName || 'secp256k1');
                            getPublicKey.setShowDisplay(g.showDisplay || false);
                            getPublicKey.setScriptType(g.scriptType || types_pb.InputScriptType.SPENDADDRESS);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_GETPUBLICKEY, getPublicKey)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            publicKey = response.toObject();
                            return [2 /*return*/, [publicKey.node, publicKey.xpub]];
                    }
                });
            });
        };
        // GetNumCoins returns the number of coins supported by the device regardless of if the hanve funds.
        KeepKey.prototype.getNumCoins = function () {
            return __awaiter(this, void 0, void 0, function () {
                var getCoinTable, _a, _, response;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            getCoinTable = new messages_pb.GetCoinTable();
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_GETCOINTABLE, getCoinTable)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            return [2 /*return*/, response.getNumCoins()];
                    }
                });
            });
        };
        KeepKey.prototype.getAllCoinsAsMap = function () {
            return __awaiter(this, void 0, void 0, function () {
                var numCoins, coinTable, i, pagedTable;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getNumCoins()];
                        case 1:
                            numCoins = _a.sent();
                            coinTable = {};
                            i = 0;
                            _a.label = 2;
                        case 2:
                            if (!(i < numCoins)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.getCoinTable(i, i + Math.min(numCoins - i, 10))];
                        case 3:
                            pagedTable = _a.sent();
                            pagedTable.filter(function (coin) { return !coin.coinShortcut.startsWith(' '); }).forEach(function (coinType) {
                                var symbol = coinType.coinShortcut;
                                coinTable[symbol] = {
                                    coinShortcut: symbol,
                                    bip44AccountPath: coinType.bip44AccountPath,
                                    curveName: coinType.curveName,
                                    coinName: coinType.coinName
                                };
                            });
                            _a.label = 4;
                        case 4:
                            i += 10;
                            return [3 /*break*/, 2];
                        case 5: return [2 /*return*/, coinTable];
                    }
                });
            });
        };
        // GetCoinTable returns an array of Types.CoinTypes, with start and end arguments for paging.
        // You cannot request more than 10 at a time.
        KeepKey.prototype.getCoinTable = function (start, end) {
            if (start === void 0) { start = 0; }
            if (end === void 0) { end = start + 10; }
            return __awaiter(this, void 0, void 0, function () {
                var getCoinTable, _a, _, response, coinTable;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            getCoinTable = new messages_pb.GetCoinTable();
                            getCoinTable.setStart(start);
                            getCoinTable.setEnd(end);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_GETCOINTABLE, getCoinTable)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            coinTable = response.toObject();
                            return [2 /*return*/, coinTable.tableList];
                    }
                });
            });
        };
        // getCoinShortcutXPubPairs returns an array of [coinShortcut, xPub] pairs
        KeepKey.prototype.getCoinShortcutXPubPairs = function (coinTable) {
            return __awaiter(this, void 0, void 0, function () {
                var publicKeys, pairs;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Promise.all(coinTable.map(function (coinType) { return _this.getPublicKey({
                                addressNList: [2147483648 + 44, coinType.bip44AccountPath, 2147483648]
                            }); }))];
                        case 1:
                            publicKeys = _a.sent();
                            pairs = [];
                            publicKeys.forEach(function (_a, i) {
                                var xPub = _a[1];
                                pairs.push([coinTable[i].coinShortcut, xPub]);
                            });
                            return [2 /*return*/, pairs];
                    }
                });
            });
        };
        // LoadDevice loads a provided seed onto the device and applies the provided settings
        // including setting a pin/device label, enabling/disabling the passphrase, and whether to
        // check the checksum of the provided mnemonic
        KeepKey.prototype.loadDevice = function (l) {
            return __awaiter(this, void 0, void 0, function () {
                var loadDevice;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            loadDevice = new messages_pb.LoadDevice();
                            loadDevice.setMnemonic(l.mnemonic);
                            loadDevice.setPassphraseProtection(l.passphraseProtection || false);
                            loadDevice.setSkipChecksum(l.skipChecksum || true);
                            if (l.pin)
                                loadDevice.setPin(l.pin);
                            if (l.label)
                                loadDevice.setLabel(l.label);
                            // send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_LOADDEVICE, loadDevice)];
                        case 1:
                            // send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        KeepKey.prototype.recoveryDevice = function (r) {
            return __awaiter(this, void 0, void 0, function () {
                var msg, epoch;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (r.wordCount !== 12 && r.wordCount !== 18 && r.wordCount !== 24) {
                                throw new Error('Invalid word count. Use 12/18/24');
                            }
                            msg = new messages_pb.RecoveryDevice();
                            msg.setWordCount(r.wordCount);
                            msg.setPassphraseProtection(r.passphraseProtection);
                            msg.setPinProtection(r.pinProtection);
                            msg.setLabel(r.label);
                            msg.setLanguage(r.language || 'english');
                            msg.setEnforceWordlist(true);
                            msg.setUseCharacterCipher(true);
                            if (r.autoLockDelayMs) {
                                msg.setAutoLockDelayMs(r.autoLockDelayMs);
                            }
                            epoch = Math.floor(+new Date() / 1000);
                            msg.setU2fCounter(r.u2fCounter || epoch);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_RECOVERYDEVICE, msg)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // Ping the device. If a message is provided it will be shown on the device screen and returned
        // in the success message. Optionally require a button press, pin, or passphrase to continue
        KeepKey.prototype.ping = function (p) {
            return __awaiter(this, void 0, void 0, function () {
                var ping, _a, _, response, message;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            ping = new messages_pb.Ping();
                            ping.setMessage(p.message);
                            ping.setButtonProtection(p.buttonProtection || false);
                            ping.setPinProtection(p.pinProtection || false);
                            ping.setPassphraseProtection(p.passphraseProtection || false);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_PING, ping)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            message = response.toObject().message;
                            return [2 /*return*/, message];
                    }
                });
            });
        };
        KeepKey.prototype.prepareSignTx = function (coinName, inputs, outputs, exchangeOutputs) {
            return __awaiter(this, void 0, void 0, function () {
                var txmap, unsignedTx;
                return __generator(this, function (_a) {
                    txmap = {} // Create a map of transactions by txid needed for the KeepKey signing flow.
                    ;
                    unsignedTx = new types_pb.TransactionType();
                    unsignedTx.setVersion(2);
                    unsignedTx.setInputsCnt(inputs.length);
                    unsignedTx.setOutputsCnt(outputs.length);
                    unsignedTx.setLockTime(0); // TODO: remove?
                    inputs.forEach(function (input, i) {
                        var utxo = new types_pb.TxInputType();
                        utxo.setPrevHash(fromHexString(input.txid));
                        utxo.setPrevIndex(input.vout);
                        // utxo.setSequence(4294967295)  // TODO: check this
                        // utxo.setScriptType(Types.InputScriptType.SPENDADDRESS)  // TODO: handle multisig & segwit
                        utxo.setAddressNList(input.address_n); // bip-32 path to the master key.  TODO: check this
                        utxo.setAmount(input.amount); // Only required by KeepKey for segwit inputs
                        unsignedTx.addInputs(utxo, i);
                    });
                    outputs.forEach(function (output, k) {
                        var newOutput = new types_pb.TxOutputType();
                        newOutput.setAmount(output.amount);
                        newOutput.setScriptType(types_pb.OutputScriptType.PAYTOADDRESS); // TODO: Support all script types. NOTE: Older firmware may require PAYTOSCRIPTHASH.
                        if (exchangeOutputs && exchangeOutputs[k]) {
                            var exchangeOutput = exchangeOutputs[k];
                            // convert the base64 encoded signedExchangeResponse message into the correct object
                            var signedExchange = exchange_pb.SignedExchangeResponse.deserializeBinary(exchangeOutput.signed_exchange_response);
                            // decode the deposit amount from a little-endian Uint8Array into an unsigned uint64
                            var depAmt = signedExchange.getResponsev2().getDepositAmount_asU8();
                            var val = 0;
                            for (var jj = depAmt.length - 1; jj >= 0; jj--) {
                                val += depAmt[jj] * Math.pow(2, (8 * (depAmt.length - jj - 1)));
                                // TODO validate is uint64
                            }
                            var outExchangeType = new types_pb.ExchangeType();
                            outExchangeType.setSignedExchangeResponse(signedExchange);
                            outExchangeType.setWithdrawalCoinName(exchangeOutput.withdrawal_coin_name);
                            outExchangeType.setWithdrawalAddressNList(exchangeOutput.withdrawal_address_n);
                            outExchangeType.setReturnAddressNList(exchangeOutput.return_address_n);
                            newOutput.setAmount(val);
                            newOutput.setAddress(signedExchange.toObject().responsev2.depositAddress.address);
                            newOutput.setScriptType(types_pb.OutputScriptType.PAYTOADDRESS);
                            newOutput.setAddressType(3);
                            newOutput.setExchangeType(outExchangeType);
                        }
                        else if (output.isChange) {
                            newOutput.setAddressNList(output.address_n);
                            newOutput.setAddressType(types_pb.OutputAddressType.CHANGE);
                        }
                        else {
                            newOutput.setAddress(output.address);
                            newOutput.setAddressType(types_pb.OutputAddressType.SPEND);
                        }
                        unsignedTx.addOutputs(newOutput, k);
                    });
                    txmap['unsigned'] = unsignedTx;
                    inputs.forEach(function (inputTx) {
                        var tx = new types_pb.TransactionType();
                        tx.setVersion(inputTx.tx.version);
                        tx.setLockTime(inputTx.tx.locktime); // TODO: remove?
                        tx.setInputsCnt(inputTx.tx.vin.length);
                        tx.setOutputsCnt(inputTx.tx.vout.length);
                        inputTx.tx.vin.forEach(function (vin, i) {
                            var txInput = new types_pb.TxInputType();
                            txInput.setPrevHash(fromHexString(vin.txid));
                            txInput.setPrevIndex(vin.vout);
                            txInput.setSequence(vin.sequence);
                            txInput.setScriptSig(fromHexString(vin.scriptSig.hex));
                            txInput.setScriptType(types_pb.InputScriptType.SPENDADDRESS);
                            txInput.setAmount(vin.valueSat);
                            tx.addInputs(txInput, i);
                        });
                        inputTx.tx.vout.forEach(function (vout, i) {
                            var txOutput = new types_pb.TxOutputBinType();
                            txOutput.setAmount(Number((vout.value * (Math.pow(10, 8))).toFixed(0)));
                            txOutput.setScriptPubkey(fromHexString(vout.scriptPubKey.hex));
                            tx.addBinOutputs(txOutput, i);
                        });
                        txmap[inputTx.txid] = tx;
                    });
                    return [2 /*return*/, txmap];
                });
            });
        };
        // RemovePin disables pin protection for the device. If a pin is currently enabled
        // it will prompt the user to enter the current pin
        KeepKey.prototype.removePin = function () {
            return __awaiter(this, void 0, void 0, function () {
                var changePin;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            changePin = new messages_pb.ChangePin();
                            changePin.setRemove(true);
                            // send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_CHANGEPIN, changePin)];
                        case 1:
                            // send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // ResetDevice generates a new seed using device RNG for entropy and applies the provided settings
        // The device must be uninitialized  before calling this method. This can be achieved by calling WipeDevice()
        // The device entropy strength must be 128, 192, or 256
        KeepKey.prototype.resetDevice = function (r) {
            return __awaiter(this, void 0, void 0, function () {
                var resetDevice, epoch;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            resetDevice = new messages_pb.ResetDevice();
                            resetDevice.setStrength(r.strength || 128);
                            resetDevice.setDisplayRandom(r.displayRandom || false);
                            resetDevice.setPassphraseProtection(r.passphraseProtection || false);
                            resetDevice.setPinProtection(r.pinProtection || false);
                            resetDevice.setLabel(r.label);
                            if (r.autoLockDelayMs) {
                                resetDevice.setAutoLockDelayMs(r.autoLockDelayMs);
                            }
                            epoch = Math.floor(+new Date() / 1000);
                            resetDevice.setU2fCounter(r.u2fCounter || epoch);
                            // resetDevice.setWordsPerGape(wordsPerScreen) // Re-enable when patch gets in
                            // Send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_RESETDEVICE, resetDevice)];
                        case 1:
                            // resetDevice.setWordsPerGape(wordsPerScreen) // Re-enable when patch gets in
                            // Send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        KeepKey.prototype.send = function (events) {
            return __awaiter(this, void 0, void 0, function () {
                var _loop_1, this_1, _i, events_1, event_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _loop_1 = function (event_1) {
                                var MessageType, msg;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            MessageType = messageTypeRegistry[event_1.message_enum];
                                            msg = new MessageType();
                                            Object.entries(event_1.message).forEach(function (_a) {
                                                var key = _a[0], value = _a[1];
                                                var setterMethod = protoFieldToSetMethod(key);
                                                if (msg[setterMethod]) {
                                                    // Assume setter methods are always of the format: strength -> setStrength
                                                    // until this exists https://github.com/protocolbuffers/protobuf/issues/1591
                                                    msg[setterMethod](value);
                                                }
                                            });
                                            return [4 /*yield*/, this_1.device.exchange(event_1.message_enum, msg)];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, events_1 = events;
                            _a.label = 1;
                        case 1:
                            if (!(_i < events_1.length)) return [3 /*break*/, 4];
                            event_1 = events_1[_i];
                            return [5 /*yield**/, _loop_1(event_1)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        // Sign UTXO Transaction
        KeepKey.prototype.signTransaction = function (coinName, inputs, outputs, exchangeOutputs, version, lockTime) {
            if (exchangeOutputs === void 0) { exchangeOutputs = []; }
            return __awaiter(this, void 0, void 0, function () {
                var _a, txmap, tx, responseType, response, signatures, serializedTx, errorResponse, txRequest, currentTx, msg, txAck, nextResponse, nextResponse, nextResponse, offset, length_1, nextResponse;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.prepareSignTx(coinName, inputs, outputs, exchangeOutputs)
                            // Prepare and send initial message
                        ];
                        case 1:
                            txmap = _b.sent();
                            tx = new messages_pb.SignTx();
                            tx.setInputsCount(inputs.length);
                            tx.setOutputsCount(outputs.length);
                            tx.setCoinName(coinName);
                            if (version != null)
                                tx.setVersion(version);
                            if (lockTime != null)
                                tx.setLockTime(lockTime);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_SIGNTX, tx)
                                // Prepare structure for signatures
                            ];
                        case 2:
                            _a = _b.sent(), responseType = _a[0], response = _a[1];
                            signatures = new Array(inputs.length).fill(null);
                            serializedTx = '';
                            _b.label = 3;
                        case 3:
                            if (responseType === messages_pb.MessageType.MESSAGETYPE_FAILURE) {
                                errorResponse = response;
                                throw new Error("Signing failed: " + errorResponse.getMessage());
                            }
                            if (responseType !== messages_pb.MessageType.MESSAGETYPE_TXREQUEST) {
                                throw new Error("Unexpected message type: " + responseType);
                            }
                            txRequest = response;
                            // If there's some part of signed transaction, add it
                            if (txRequest.hasSerialized() && txRequest.getSerialized().hasSerializedTx()) {
                                serializedTx += toHexString(txRequest.getSerialized().getSerializedTx_asU8());
                            }
                            if (txRequest.hasSerialized() && txRequest.getSerialized().hasSignatureIndex()) {
                                if (signatures[txRequest.getSerialized().getSignatureIndex()] !== null) {
                                    throw new Error("Signature for index " + txRequest.getSerialized().getSignatureIndex() + " already filled");
                                }
                                signatures[txRequest.getSerialized().getSignatureIndex()] = txRequest.getSerialized().getSignature_asB64();
                            }
                            if (txRequest.getRequestType() === types_pb.RequestType.TXFINISHED) {
                                // Device didn't ask for more information, finish workflow
                                return [3 /*break*/, 12];
                            }
                            currentTx = null;
                            msg = null;
                            txAck = null;
                            // Device asked for one more information, let's process it.
                            if (txRequest.hasDetails() && !txRequest.getDetails().hasTxHash()) {
                                currentTx = txmap['unsigned'];
                            }
                            else {
                                currentTx = txmap[toHexString(txRequest.getDetails().getTxHash_asU8())];
                            }
                            if (!(txRequest.getRequestType() === types_pb.RequestType.TXMETA)) return [3 /*break*/, 5];
                            msg = new types_pb.TransactionType();
                            msg.setVersion(currentTx.getVersion());
                            msg.setLockTime(currentTx.getLockTime());
                            msg.setInputsCnt(currentTx.getInputsCnt());
                            if (txRequest.getDetails().hasTxHash()) {
                                msg.setOutputsCnt(currentTx.getBinOutputsList().length);
                            }
                            else {
                                msg.setOutputsCnt(currentTx.getOutputsList().length);
                            }
                            if (currentTx.hasExtraData()) {
                                msg.setExtraDataLen(currentTx.getExtraData_asU8().length);
                            }
                            else {
                                msg.setExtraDataLen(0);
                            }
                            txAck = new messages_pb.TxAck();
                            txAck.setTx(msg);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_TXACK, txAck)];
                        case 4:
                            nextResponse = _b.sent();
                            responseType = nextResponse[0];
                            response = nextResponse[1];
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(txRequest.getRequestType() === types_pb.RequestType.TXINPUT)) return [3 /*break*/, 7];
                            msg = new types_pb.TransactionType();
                            msg.setInputsList([currentTx.getInputsList()[txRequest.getDetails().getRequestIndex()]]);
                            txAck = new messages_pb.TxAck();
                            txAck.setTx(msg);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_TXACK, txAck)];
                        case 6:
                            nextResponse = _b.sent();
                            responseType = nextResponse[0];
                            response = nextResponse[1];
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(txRequest.getRequestType() === types_pb.RequestType.TXOUTPUT)) return [3 /*break*/, 9];
                            msg = new types_pb.TransactionType();
                            if (txRequest.getDetails().hasTxHash()) {
                                msg.setBinOutputsList([currentTx.getBinOutputsList()[txRequest.getDetails().getRequestIndex()]]);
                            }
                            else {
                                msg.setOutputsList([currentTx.getOutputsList()[txRequest.getDetails().getRequestIndex()]]);
                                msg.setOutputsCnt(1);
                            }
                            txAck = new messages_pb.TxAck();
                            txAck.setTx(msg);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_TXACK, txAck)];
                        case 8:
                            nextResponse = _b.sent();
                            responseType = nextResponse[0];
                            response = nextResponse[1];
                            return [3 /*break*/, 11];
                        case 9:
                            if (!(txRequest.getRequestType() === types_pb.RequestType.TXEXTRADATA)) return [3 /*break*/, 11];
                            offset = txRequest.getDetails().getExtraDataOffset();
                            length_1 = txRequest.getDetails().getExtraDataLen();
                            msg = new types_pb.TransactionType();
                            msg.setExtraData(currentTx.getExtraData_asU8().slice(offset, offset + length_1));
                            txAck = new messages_pb.TxAck();
                            txAck.setTx(msg);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_TXACK, txAck)];
                        case 10:
                            nextResponse = _b.sent();
                            responseType = nextResponse[0];
                            response = nextResponse[1];
                            _b.label = 11;
                        case 11: return [3 /*break*/, 3];
                        case 12:
                            if (signatures.includes(null)) {
                                throw new Error('Some signatures are missing!');
                            }
                            return [2 /*return*/, [signatures, serializedTx]];
                    }
                });
            });
        };
        // SignMessage signs a message using the given nodepath and Coin
        KeepKey.prototype.signMessage = function (s) {
            return __awaiter(this, void 0, void 0, function () {
                var sign, _a, _, response, messageSignature;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            sign = new messages_pb.SignMessage();
                            sign.setAddressNList(s.addressNList);
                            sign.setMessage(s.message);
                            sign.setCoinName(s.coinName);
                            sign.setScriptType(s.scriptType || types_pb.InputScriptType.SPENDADDRESS);
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_SIGNMESSAGE, sign)];
                        case 1:
                            _a = _b.sent(), _ = _a[0], response = _a[1];
                            messageSignature = response.toObject();
                            return [2 /*return*/, [messageSignature.signature, messageSignature.address]];
                    }
                });
            });
        };
        // SoftReset power cycles the device. The device only responds to
        // this message while in manufacturer mode
        KeepKey.prototype.softReset = function () {
            return __awaiter(this, void 0, void 0, function () {
                var softReset;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            softReset = new messages_pb.SoftReset();
                            // send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_SOFTRESET, softReset)];
                        case 1:
                            // send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // VerifyMessage verifies a signed message
        KeepKey.prototype.verifyMessage = function (addr, coinName, msg, sig) {
            return __awaiter(this, void 0, void 0, function () {
                var verify;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            verify = new messages_pb.VerifyMessage();
                            verify.setAddress(addr);
                            verify.setSignature(sig);
                            verify.setMessage(msg);
                            verify.setCoinName(coinName);
                            // send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_VERIFYMESSAGE, verify)];
                        case 1:
                            // send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // WipeDevice wipes all sensitive data and settings
        KeepKey.prototype.wipeDevice = function () {
            return __awaiter(this, void 0, void 0, function () {
                var wipeDevice;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            wipeDevice = new messages_pb.WipeDevice();
                            // send
                            return [4 /*yield*/, this.device.exchange(messages_pb.MessageType.MESSAGETYPE_WIPEDEVICE, wipeDevice)];
                        case 1:
                            // send
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        return KeepKey;
    }());

    var defaultUSBDeviceCallback = function () { }; // tslint:disable-line:no-empty
    var KeepKeyManager = /** @class */ (function () {
        function KeepKeyManager(config) {
            if (config === void 0) { config = {}; }
            this.deviceEvents = new eventemitter2.EventEmitter2({ wildcard: true });
            this.keepkeys = {};
            this.onConnectCallback = defaultUSBDeviceCallback;
            this.onDisconnectCallback = defaultUSBDeviceCallback;
            this.onConnectCallback = config.onConnectCallback || defaultUSBDeviceCallback;
            this.onDisconnectCallback = config.onDisconnectCallback || defaultUSBDeviceCallback;
            // If we have access to WebUSB, register callbacks
            if (window.navigator.usb) {
                window.navigator.usb.onconnect = this.handleConnectKeepKey.bind(this);
                window.navigator.usb.ondisconnect = this.handleDisconnectKeepKey.bind(this);
            }
        }
        Object.defineProperty(KeepKeyManager.prototype, "initializedCount", {
            get: function () {
                return Object.keys(this.keepkeys).length;
            },
            enumerable: true,
            configurable: true
        });
        KeepKeyManager.prototype.initializeWebUSBDevices = function (webusbConfig, devices) {
            return __awaiter(this, void 0, void 0, function () {
                var devicesToInitialize, _a, _i, devicesToInitialize_1, usbDevice, k, features;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!window.navigator.usb)
                                throw new Error('WebUSB not supported in your browser!');
                            _a = devices;
                            if (_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, window.navigator.usb.getDevices()];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            devicesToInitialize = _a;
                            _i = 0, devicesToInitialize_1 = devicesToInitialize;
                            _b.label = 3;
                        case 3:
                            if (!(_i < devicesToInitialize_1.length)) return [3 /*break*/, 8];
                            usbDevice = devicesToInitialize_1[_i];
                            if (!this.keepkeys[usbDevice.serialNumber]) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.get(usbDevice.serialNumber).initialize()];
                        case 4:
                            _b.sent();
                            return [3 /*break*/, 7];
                        case 5:
                            k = KeepKey.withWebUSB(__assign({ usbDevice: usbDevice }, webusbConfig));
                            return [4 /*yield*/, k.initialize()];
                        case 6:
                            features = _b.sent();
                            if (features)
                                this.add(k, usbDevice.serialNumber);
                            _b.label = 7;
                        case 7:
                            _i++;
                            return [3 /*break*/, 3];
                        case 8: return [2 /*return*/, this.initializedCount];
                    }
                });
            });
        };
        KeepKeyManager.prototype.add = function (keepkey, deviceID) {
            var id = deviceID || keepkey.features.deviceId;
            if (!(this.keepkeys[id])) {
                this.keepkeys[id] = keepkey;
                this.decorateEvents(deviceID, keepkey.device.events);
                return true;
            }
            return false;
        };
        KeepKeyManager.prototype.exec = function (method) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, Promise.all(Object.values(this.keepkeys)
                            .map(function (k) { return k[method].apply(k, args); })).then(function (values) { return values.reduce(function (final, response, i) {
                            final[Object.keys(_this.keepkeys)[i]] = response;
                            return final;
                        }, {}); })];
                });
            });
        };
        KeepKeyManager.prototype.get = function (deviceID) {
            if (this.keepkeys[deviceID])
                return this.keepkeys[deviceID];
            if (this.initializedCount)
                return Object.values(this.keepkeys)[0];
            return null;
        };
        KeepKeyManager.prototype.remove = function (deviceID) {
            return __awaiter(this, void 0, void 0, function () {
                var keepkey, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.keepkeys[deviceID])
                                return [2 /*return*/];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            keepkey = this.get(deviceID);
                            return [4 /*yield*/, keepkey.clearSession()];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, keepkey.device.disconnect()];
                        case 3:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            e_1 = _a.sent();
                            console.error(e_1);
                            return [3 /*break*/, 5];
                        case 5:
                            delete this.keepkeys[deviceID];
                            return [2 /*return*/];
                    }
                });
            });
        };
        KeepKeyManager.prototype.removeAll = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Promise.all(Object.keys(this.keepkeys).map(this.remove))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        KeepKeyManager.prototype.disconnectAll = function () {
            Object.values(this.keepkeys).forEach(function (k) {
                if (k.device.queue)
                    k.device.queue.clear();
                k.device.disconnect().catch(console.log);
            });
        };
        KeepKeyManager.prototype.decorateEvents = function (deviceID, events) {
            var _this = this;
            events.onAny(function (e) {
                var values = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    values[_i - 1] = arguments[_i];
                }
                return _this.deviceEvents.emit([e, deviceID], [deviceID].concat(values));
            });
        };
        KeepKeyManager.prototype.handleConnectKeepKey = function (e) {
            var _this = this;
            var deviceID = e.device.serialNumber;
            this.initializeWebUSBDevices(null, [e.device])
                .then(function () { return _this.onConnectCallback(deviceID); })
                .catch(console.error);
        };
        KeepKeyManager.prototype.handleDisconnectKeepKey = function (e) {
            var _this = this;
            var deviceID = e.device.serialNumber;
            this.remove(deviceID)
                .then(function () { return _this.onDisconnectCallback(deviceID); })
                .catch(function (e) {
                console.error(e);
                _this.onDisconnectCallback(deviceID);
            });
        };
        return KeepKeyManager;
    }());

    function ethTxAsProto(tx, nodePath) {
        var est = new messages_pb.EthereumSignTx();
        est.setAddressNList(nodePath);
        // For proper rlp encoding when the value of the  parameter is zero,
        // the device expects an empty byte array instead of
        // a byte array with a value of zero
        if (tx.value) {
            est.setValue(emptyOrVal(tx.value));
        }
        if (tx.gasLimit) {
            est.setValue(emptyOrVal(tx.gasLimit));
        }
        if (tx.gasPrice) {
            est.setValue(emptyOrVal(tx.gasPrice));
        }
        return est;
    }
    function emptyOrVal(val) {
        if (!val)
            return new Uint8Array();
        else
            return arrayify(val);
    }
    function newTokenTransaction(tx, tShortCut, tRecipient, tValue) {
        return {
            ethereumTx: tx,
            tokenShortcut: tShortCut,
            tokenTo: tRecipient,
            tokenValue: tValue
        };
    }

    exports.KeepKeyManager = KeepKeyManager;
    exports.KeepKey = KeepKey;
    exports.WebUSBDevice = WebUSBDevice;
    exports.Messages = messages_pb;
    exports.Types = types_pb;
    exports.Exchange = exchange_pb;
    exports.messageTypeRegistry = messageTypeRegistry;
    exports.ethTxAsProto = ethTxAsProto;
    exports.newTokenTransaction = newTokenTransaction;
    exports.protoFieldToSetMethod = protoFieldToSetMethod;
    exports.isArray = isArray$1;
    exports.leByteArrayToLong = leByteArrayToLong;
    exports.fromHexString = fromHexString;
    exports.toHexString = toHexString;
    exports.arrayify = arrayify;
    exports.bip32ToAddressNList = bip32ToAddressNList;
    exports.bip32Like = bip32Like;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=keepkey.browser.js.map
